/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		30: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"async","1":"async36","2":"async34","3":"async32","4":"async30","5":"async28","6":"async26","7":"async24","8":"async22","9":"async20","10":"async18","11":"async16","12":"async13","13":"async8","14":"async6","15":"async4","16":"async0","17":"home","18":"living","19":"profile","20":"allhostlist","21":"ranking","22":"withdraw","23":"play","24":"history","25":"gamecenter","26":"activity","27":"showpage","28":"recharge","29":"async15"}[chunkId]||chunkId) + "." + {"0":"ebfd1","1":"339a7","2":"34330","3":"62d75","4":"7610b","5":"e081b","6":"dfd7f","7":"1818c","8":"d2996","9":"4b4f7","10":"a44ba","11":"99130","12":"d23f0","13":"0b749","14":"17e69","15":"010ba","16":"3c013","17":"f2c29","18":"a2369","19":"458fa","20":"17edf","21":"5b725","22":"c0239","23":"a1984","24":"a7c34","25":"bc69b","26":"4ce61","27":"ce9d4","28":"1e224","29":"1dd23"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "//h.cdn.pengpengla.com/up/uplive-pc/4.7.8/assets/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 294);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(302);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var _underscore = __webpack_require__(264);

var _underscore2 = _interopRequireDefault(_underscore);

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _enus = __webpack_require__(107);

var _enus2 = _interopRequireDefault(_enus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _lang = {

    template: function template(tplStr, data, insertEM) {

        var lang = UP.Global.siteLanguage;
        var langType = lang.replace('-', '').toLowerCase();
        var langPack = window.LangPack || _enus2.default;

        var tpl = (langPack[tplStr] || tplStr) + '';

        try {
            if (tpl) {
                if (tpl.indexOf('@@@@') > 0) {
                    var strArr = [];

                    strArr.push('<ul>');
                    tpl.split('@@@@').forEach(function (item, index) {
                        item && strArr.push('<li>' + item + '</li>');
                    });
                    strArr.push('</ul>');
                    tpl = strArr.join('');
                }
                if (insertEM) {
                    tpl = tpl.replace(/<%=([\s\S]+?)%>/g, function ($0, $1) {
                        return '<em class="' + $1 + '">' + $0 + '</em>';
                    });
                }

                var compiled = _underscore2.default.template(tpl);
                return compiled(data);
            } else {
                return _underscore2.default.template(tplStr)(data);
            }
        } catch (e) {
            console.log(e.message);
        }
    }
}; /**
    * 前端多语言解决方案
    */


module.exports = _lang;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule invariant
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * 本地缓存组件
 * 本地存储的技术方案：
   1、localStorage
        只考虑localStorage的存储方式，不考虑cookie方式。原因：
        （1）cookie 存储上限只有 4KB，且会加重网络负担，cookie 会被发送到作用域之内的所有http请求，包括js请求，css请求，图片请求，很多异步的请求
        （2）localStorage 存储上线是5MB   
   2、组件规范
        （1）数据存储格式
            旧的游戏：prefix/env/ppuid/gameType/key
            新的游戏：prefix/env/openId/gameType/key
        （2）prefix
            key前缀。默认是ppcache
            如果同一款游戏，后期做推广，gameType或者用户openId(即appid)与自家版相同，推荐prefix改为package name
        （3）key
            存储数据的字段名
            推荐使用驼峰格式（首字母小写其他词首大写），如myFieldName
        （4）expires：-1
            有效期配置
            单位：毫秒
            -1  ：永久保存
            > 0 ：有设置有效期

 * 使用说明
    @method
        检测localstorage是否可用
            isEnable() // ==> true/false
        如果使用规范存储的字段格式，使用方法
            setCache(key, value, expires)
            getCache(key)
            removeCache(key)
        原生的自定义，存储的字段名，不遵循（prefix/env/XXX/gameType/key）格式；try()catch(e){}
            setItem(key, value, expires) // 设置；当存储到达上限之后，该方法不可用
            getItem(key)       // 获取
            removeItem(key)    // 清除
            getAll()           // 获取所有
            clear()            // 清除所有

 * @author 陈立英
 * @example 
 *      var cache = new Cache({
            prefix: 'knowme',
            gameType: 'knowme',
            uid: '123456'
        });

 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    var Base = __webpack_require__(56);
    var Url = __webpack_require__(5);
    var win = window;

    var Cache = Base.extend({
        defaults: {
            prefix: 'ppcache', // 数据存储 key 的前缀，默认是ppcache。
            gameType: '', // 游戏类型，例如knowme
            uid: '', // 用户信息，新游戏是openId, 旧游戏是ppuid
            data: {}, // 存储缓存数据 data: {data: value, expires: 0}
            expires: -1 // 有效期，默认则为永久，单位毫秒
        },
        // 浏览器是否支持localStorage
        enable: false,

        /**
         * 初始化入口
         */
        initialize: function initialize() {
            var self = this;
            self.Parent.apply(self, arguments);

            self.isEnable();
        },
        /**
         * 设置本地缓存
         * @name set
         * @param key {String} 存储key
         * @param value {string| JSON Object} 存储内容。value会序列化
         * @param expires {Number} 单位毫秒 内容有效期设置，不设置则为永久缓存
         * @example     
         *      cache.set(key, value, expires);
         */
        setCache: function setCache(key, value, expires) {
            var name = this.getLocalKey(key);
            this.setItem(name, value, expires);
        },
        /**
         * 获取本地缓存
         * @name get
         * @param {string| JSON Object} 数据字段名。
         * @example
         *      cache.get(key);
         */
        getCache: function getCache(key) {
            var name = this.getLocalKey(key);
            return this.getItem(name);
        },
        /**
         * 移除本地缓存的数据'key'
         * @name remove
         */
        removeCache: function removeCache(key) {
            var name = this.getLocalKey(key);
            this.removeItem(name);
        },
        /**
         * 获取本地缓存的key
         */
        getLocalKey: function getLocalKey(key) {
            var prefix = this.get('prefix'),
                ret = [];
            var gameType = this.get('gameType') || '';
            var uid = this.get('uid') || '';
            var env = Url.query('env');

            if (!env || env == 'null') {
                env = 'pro';
            }

            if (prefix !== '') {
                ret.push(prefix);
            }

            if (env !== '') {
                ret.push(env);
            }

            if (uid !== '') {
                ret.push(uid);
            }

            if (gameType !== '') {
                ret.push(gameType);
            }

            if (key !== '') {
                ret.push(key);
            }

            return ret.join('/');
        },
        /**
         * 序列化工具方法
         * @name serialize
         */
        serialize: function serialize(value) {
            return JSON.stringify(value);
        },
        /**
         * 反序列化工具方法
         * @name deserialize
         */
        deserialize: function deserialize(value) {
            if (typeof value != 'string') {
                return undefined;
            }
            try {
                return JSON.parse(value);
            } catch (e) {
                return value || undefined;
            }
        },
        /**
         * 判断key是否失效
         * @return {Boolean}  true 无效； false未失效
         */
        isExpire: function isExpire(time) {
            if (time > 0) {
                return new Date().getTime() > Number(time);
            } else {
                return false;
            }
        },
        /**
         * 设置混存数据
         */
        setItem: function setItem(key, value, expires) {
            var expires = expires || this.get('expires');
            var curStamp = +new Date();
            var newValue;
            try {
                // 存储设置的本地数据
                if (expires > 0) {
                    newValue = {
                        data: value,
                        expires: curStamp + expires
                    };
                } else {
                    newValue = value;
                }
                newValue = this.serialize(newValue);
                localStorage.setItem(key, newValue);
            } catch (e) {
                // this.clear();
            }
        },
        /**
         * 获取缓存数据
         */
        getItem: function getItem(key) {
            var ret = null;

            try {
                var ret = localStorage.getItem(key);
                var opt = this.deserialize(ret);
                var isExpire = this.isExpire(opt.expires);
                // 已经失效
                if (isExpire) {
                    ret = null;
                    this.removeItem(key);
                } else {
                    return opt.expires > 0 ? opt.data : opt;
                }
            } catch (e) {}
        },
        /**
         * 清除全部数据
         */
        clear: function clear() {
            try {
                localStorage.clear();
            } catch (e) {}
        },
        /**
         * 移除数据key
         */
        removeItem: function removeItem(key) {
            try {
                localStorage.removeItem(key);
            } catch (e) {}
        },
        /**
         * 获得所有的本地缓存信息
         */
        getAll: function getAll() {
            var ret = {};
            try {
                for (var i = 0; i < localStorage.length; ++i) {
                    var key = localStorage.key(i);
                    ret[key] = this.getItem(key);
                }
            } catch (e) {}
            return ret;
        },
        /**
         * 浏览器是否支持localStorage。当存储达到上限值后。lcoalStorage.setItem()方法不可用
         * @return { Boolean } 如果浏览器支持 则返回 true, 否则返回 false.
         *  @example
         *      cache.isEnable() => true
         */
        isEnable: function isEnable() {
            var name = '__localStorageTest__';
            try {
                if ('localStorage' in win && win['localStorage'] && localStorage.setItem && localStorage.getItem) {

                    localStorage.setItem(name, name);

                    if (localStorage.getItem(name) == name) {
                        this.enable = true;
                    }
                    localStorage.removeItem(name);
                }
            } catch (e) {}

            return this.enable;
        }
    });

    module.exports = Cache;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 4 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * pbajax模块(用于pb接口交互)
 * @author zhenn
 * @time 2016-11-16
 */
var proxyUrl = {
    pro: 'https://sg-proxy.upliveapp.com/index/index',
    dev: 'http://awsbj-proxy.xingyunzhi.cn/index/index',
    stage: 'https://sg-stage-proxy.upliveapp.com/index'
};

var PbAajx = function () {
    function PbAajx() {
        _classCallCheck(this, PbAajx);

        this.canceled = 0;
    }

    // canceled: 0, // 是否被取消

    _createClass(PbAajx, [{
        key: 'do',
        value: function _do(cfg, data) {
            var success = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

            var _this = this;

            var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
            var fail = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};

            var prefix = proxyUrl[this.env()];

            if (!cfg.header) {
                cfg.header = {};
            }

            var UserAgent = UP.Global.getDefaultUA();

            if (cfg.header.UserAgent && cfg.header.UserAgent.indexOf('feature/9999') > -1) {
                UserAgent += ' feature/9999';
            }

            cfg.header.UserAgent = UserAgent;

            var _url = prefix + '?' + $.param(cfg);
            var timer = void 0,
                xhr = void 0;

            timer = setTimeout(function () {
                timeout();
            }, 20 * 1000);

            try {
                xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
                xhr.open("POST", _url, true);
                xhr.responseType = "arraybuffer";

                try {
                    xhr.send(data.toArrayBuffer());
                } catch (e) {
                    xhr.send();
                }
            } catch (e) {
                alert('please upgrade your brower, such as chrome!');
            }

            xhr.onreadystatechange = function (data) {

                if (xhr.readyState == 4) {
                    if (xhr.status == 200) {
                        clearTimeout(timer);
                        if (!_this.canceled) {
                            success(xhr.response);
                        }
                    } else {
                        if (typeof fail == 'function') {
                            fail();
                        }
                    }
                }
            };
        }
    }, {
        key: 'query',
        value: function query(name, scope) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
                scope = scope || 'search',
                r = location[scope].substr(1).match(reg);
            if (r != null) {
                return unescape(r[2]);
            }
            return null;
        }
    }, {
        key: 'env',
        value: function env() {
            return this.query('env') || 'pro';
        }
    }, {
        key: 'serializeURI',
        value: function serializeURI(obj) {
            var result = [];
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                obj = {};
            }
            for (var i in obj) {
                result.push(i + '=' + encodeURIComponent(obj[i]));
            }

            return result.join('&');
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.canceled = 1;
        }
    }]);

    return PbAajx;
}();

exports.default = PbAajx;

/***/ }),
/* 5 */
/***/ (function(module, exports) {



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var url = {
    scope: 'search',
    paramReg: /^(?:([A-Za-z]+):(\/{0,3}))?([0-9.\-A-Za-z]+\.[0-9A-Za-z]+)?(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/,

    names: ['url', 'scheme', 'slash', 'host', 'port', 'path', 'query', 'hash'],

    query: function query(name, scope) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
            scope = scope || this.scope,
            r = location[scope].substr(1).match(reg);
        if (r != null) {
            return decodeURIComponent(r[2]);
        }
        return null;
    },

    addParam: function addParam(url, data) {
        if (typeof data === 'undefined') {
            return;
        }

        var hashReg = /#.*$/gi,
            hashMatch = url.match(hashReg),
            hash = '';

        if (hashMatch) {
            hash = hashMatch[0];
        }

        // 去除hash值的url
        var preUrl = url.replace(hash, '');

        var searchReg = /\?(.*?)$/gi;
        var result = searchReg.exec(preUrl);
        var query, newUrl;
        if (result) {
            query = result[1].split('#')[0];
        }

        var id = !query ? '' : '&';

        return preUrl + (query && query.length > 0 ? '' : '?') + (id + $.param(data)) + hash;
    },

    delQuery: function delQuery(url, key) {
        var path = '',
            param = '',
            hash = '';
        if (url.indexOf('?') == -1) {
            path = url;
        } else {
            path = url.substr(0, url.indexOf('?'));
            param = url.substr(url.indexOf('?') + 1);
            if (param.indexOf('#') != -1) {
                hash = param.substr(param.indexOf('#') + 1);
                param = param.substr(0, param.indexOf('#'));
            }
        }
        var params = param.split('&');
        for (var i = params.length - 1; i >= 0; i--) {
            if (params[i].indexOf(key + '=') > -1) {
                params.splice(i, 1);
                break;
            }
        }

        return path + (params.join('&') ? '?' + params.join('&') : '') + (hash ? '#' + hash : '');
    },
    /**
     * 将URL query的字符串解析成对象
     */
    parseQuery: function parseQuery(query) {
        var ret = {},
            qs,
            q,
            _qs;
        if ((typeof query === 'undefined' ? 'undefined' : _typeof(query)) == 'object') {
            for (var p in query) {
                if (query.hasOwnProperty(p) && query[p] !== null) {
                    ret[p] = query[p];
                }
            }
        } else {
            qs = query.split('&');
            for (var i = 0; i < qs.length; i++) {
                if ((q = qs[i]) && (_qs = q.split('=')) && _qs[0]) {
                    ret[_qs[0]] = _qs[1] ? decodeURIComponent(_qs[1]) : '';
                }
            }
        }

        return ret;
    },
    /**
     * 将URL解析为对象
     * @name parse
     * @return {
     *      url: '',
     *      hash: '',
     *      query: '',
     *      host: ''
     *      ...
     * }
     */
    parse: function parse(url) {
        var results = this.paramReg.exec(url),
            names = this.names,
            ret = {},
            key;

        for (var i = 0, len = names.length; i < len; i += 1) {
            key = names[i];
            ret[key] = (key == 'path' ? '/' : '') + (results[i] || '');
        }

        return ret;
    },
    /**
     * 将对象解析为URL字符串
     */
    stringify: function stringify(data) {
        var ret = '';
        var names = this.names;
        for (var i = 1; i < names.length; i++) {
            var key = names[i],
                value = data[key];
            if (typeof value != 'undefined') {
                ret += function (key, value) {
                    if (key == 'scheme') {
                        return value + ':';
                    }
                    if (key == 'port') {
                        return value ? ':' + value : '';
                    }
                    if (key == 'host') {
                        return value;
                    }

                    if (key == 'query') {
                        return value ? '?' + value : '';
                    }
                    if (key == 'hash') {
                        return value ? '#' + value : '';
                    }

                    return value;
                }(key, value);
            }
        }
        return ret;
    }
};

module.exports = url;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(158);


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule warning
 */



var emptyFunction = __webpack_require__(21);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  warning = function (condition, format) {
    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    }
  };
}

module.exports = warning;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Object.assign
 */

// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign



function assign(target, sources) {
  if (target == null) {
    throw new TypeError('Object.assign target cannot be null or undefined');
  }

  var to = Object(target);
  var hasOwnProperty = Object.prototype.hasOwnProperty;

  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
    var nextSource = arguments[nextIndex];
    if (nextSource == null) {
      continue;
    }

    var from = Object(nextSource);

    // We don't currently support accessors nor proxies. Therefore this
    // copy cannot throw. If we ever supported this then we must handle
    // exceptions and side-effects. We don't support symbols so they won't
    // be transferred.

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
  }

  return to;
}

module.exports = assign;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Result",
        "fields": [{
            "rule": "optional",
            "type": "Code",
            "name": "code",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "msg",
            "id": 2
        }, {
            "rule": "optional",
            "type": "google.protobuf.Any",
            "name": "data",
            "id": 3
        }]
    }, {
        "name": "google",
        "fields": [],
        "messages": [{
            "name": "protobuf",
            "fields": [],
            "options": {
                "csharp_namespace": "Google.Protobuf.WellKnownTypes",
                "go_package": "github.com/golang/protobuf/ptypes/any",
                "java_package": "com.google.protobuf",
                "java_outer_classname": "AnyProto",
                "java_multiple_files": true,
                "java_generate_equals_and_hash": true,
                "objc_class_prefix": "GPB"
            },
            "messages": [{
                "name": "Any",
                "fields": [{
                    "rule": "optional",
                    "type": "string",
                    "name": "type_url",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "bytes",
                    "name": "value",
                    "id": 2
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "Code",
        "values": [{
            "name": "DEFAULT",
            "id": 0
        }, {
            "name": "SC_SUCCESS",
            "id": 1
        }, {
            "name": "SC_THIRD_PARTY_ALREADY_BIND",
            "id": 256
        }, {
            "name": "SC_THIRD_CHECK_USER_NOT_REGISTER",
            "id": 257
        }, {
            "name": "SC_NEED_BIND_PHONE",
            "id": 258
        }, {
            "name": "SC_PARAMETER_INVALID",
            "id": 4096
        }, {
            "name": "SC_ADMIN_NO_PERMISSION",
            "id": 4352
        }, {
            "name": "SC_ACCOUTN_USER_TOKEN_NOTMATCH",
            "id": 8192
        }, {
            "name": "SC_ACCOUNT_IS_VISTOR",
            "id": 8194
        }, {
            "name": "SC_LOGINED_IN_OTHER_DEVICE",
            "id": 8193
        }, {
            "name": "SC_SMS_VERIFY_CODE_NOMOBILE",
            "id": 4097
        }, {
            "name": "SC_SMS_VERIFY_CODE_FAIL",
            "id": 4098
        }, {
            "name": "SC_SMS_VERIFY_CODE_NOTMATCH",
            "id": 4099
        }, {
            "name": "SC_ACCOUNT_MOBILE_PHONE_REPETITION",
            "id": 4100
        }, {
            "name": "SC_ACCOUNT_MOBILE_PHONE_ALLREADY_BIND",
            "id": 4101
        }, {
            "name": "SC_ACCOUTN_USER_NAME_FORBIDDEN",
            "id": 4102
        }, {
            "name": "SC_ACCOUTN_THIRD_CHECK_FAIL",
            "id": 4103
        }, {
            "name": "SC_ACCOUNT_USER_NAME_OVER_LONG",
            "id": 4104
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_OVER_LONG",
            "id": 4105
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_EMAIL_WHITE",
            "id": 4106
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_NOT_STANDARD",
            "id": 4112
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_EXIST",
            "id": 4113
        }, {
            "name": "SC_ACCOUNT_LIVE_UPDATE_FAIL",
            "id": 4114
        }, {
            "name": "SC_ACCOUNT_PASSWORD_ERROR",
            "id": 4115
        }, {
            "name": "SC_ACCOUNT_USER_NOT_EXIST",
            "id": 4116
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_TOO_SHORT",
            "id": 4117
        }, {
            "name": "SC_ACCOUNT_SIGNATURE_OVER_LONG",
            "id": 4118
        }, {
            "name": "SC_ACCOUTN_USER_FORBIDDEN",
            "id": 4119
        }, {
            "name": "SC_ACCOUNT_RANDOM_NOTEXIST",
            "id": 4120
        }, {
            "name": "SC_ACCOUNT_RANDOM_NOTSCAN",
            "id": 4121
        }, {
            "name": "SC_ACCOUNT_RANDOM_SCANNED",
            "id": 4128
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_NOLY_MODIFY_ONCE",
            "id": 4129
        }, {
            "name": "SC_ACCOUNT_USER_OR_PASSWORD_ERROR",
            "id": 4130
        }, {
            "name": "SC_EMAIL_SEND_OVER_LIMIT",
            "id": 4131
        }, {
            "name": "SC_EMAIL_VERIFY_INVALID",
            "id": 4132
        }, {
            "name": "SC_EMAIL_NOT_VERIFY",
            "id": 4133
        }, {
            "name": "SC_NEED_REGISTER",
            "id": 4134
        }, {
            "name": "SC_ACCOUNT_HAVE_NO_BIND_MOBILE",
            "id": 4135
        }, {
            "name": "SC_ACCOUNT_DID_FORBIDDEN",
            "id": 4136
        }, {
            "name": "SC_SMS_SEND_CODE_BEYOND_LIMIT",
            "id": 4137
        }, {
            "name": "SC_SENSITIVE_CONTENT",
            "id": 4609
        }, {
            "name": "SC_ACCOUNT_USER_USERNAME_IS_HIDDEN",
            "id": 4610
        }, {
            "name": "SC_MALL_GIFT_NOT_EXIST",
            "id": 12289
        }, {
            "name": "SC_MALL_TRANSACTION_REPEATED",
            "id": 12290
        }, {
            "name": "SC_MALL_MONEY_NOT_ENOUGH",
            "id": 12291
        }, {
            "name": "SC_MALL_TRANSACTION_NOT_EXIST",
            "id": 12292
        }, {
            "name": "SC_MALL_PRODUCT_NOT_AVAILABLE",
            "id": 12293
        }, {
            "name": "SC_MALL_ORDER_NOT_EXIST",
            "id": 12294
        }, {
            "name": "SC_MALL_UNIFIED_ORDER_FAIL",
            "id": 12295
        }, {
            "name": "SC_MALL_PAY_FAIL",
            "id": 12296
        }, {
            "name": "SC_MALL_PAY_QUERY_FAIL",
            "id": 12297
        }, {
            "name": "SC_MALL_IAP_VALIDATE_FAIL",
            "id": 12298
        }, {
            "name": "SC_MALL_ORDER_EXIST_NOT_FINISHED",
            "id": 12299
        }, {
            "name": "SC_MALL_NOT_BIND_WECHAT",
            "id": 12300
        }, {
            "name": "SC_MALL_EXCEED_WITHDRAW_TIMES",
            "id": 12301
        }, {
            "name": "SC_MALL_EXCEED_WITHDRAW_QUOTA",
            "id": 12302
        }, {
            "name": "SC_MALL_WITHDRAW_FAIL",
            "id": 12303
        }, {
            "name": "SC_MALL_WITHDRAW_LESS_THAN_MIN",
            "id": 12304
        }, {
            "name": "SC_MALL_WITHDRAW_GREATER_THAN_MAX",
            "id": 12305
        }, {
            "name": "SC_MALL_WITHDRAW_FREQ_LIMIT",
            "id": 12306
        }, {
            "name": "SC_MALL_WITHDRAW_SENDNUM_LIMIT",
            "id": 12307
        }, {
            "name": "SC_MALL_NOT_BIND_PAYPAL",
            "id": 12308
        }, {
            "name": "SC_MALL_IAB_VALIDATE_FAIL",
            "id": 12309
        }, {
            "name": "SC_MALL_BUY_GUARD_DIAMOND_LOW",
            "id": 12310
        }, {
            "name": "SC_MALL_TRANSLATE_NOT_SUPPORT",
            "id": 12311
        }, {
            "name": "SC_MALL_TRANSLATE_CLOSED",
            "id": 12312
        }, {
            "name": "SC_MALL_GIFT_SEND_VIP_LIMIT",
            "id": 12313
        }, {
            "name": "SC_MALL_GIFT_NOT_ALLOW",
            "id": 12320
        }, {
            "name": "SC_MALL_GIFT_NEED_RECHARGE",
            "id": 12321
        }, {
            "name": "SC_MALL_ACC_BILL_NOT_ENOUGH",
            "id": 12322
        }, {
            "name": "SC_MALL_USER_FROZEN",
            "id": 12323
        }, {
            "name": "SC_MALL_RECHARGE_REPEAT",
            "id": 12324
        }, {
            "name": "SC_MALL_RECHARGE_REWARD_REPEAT",
            "id": 12325
        }, {
            "name": "SC_MALL_RECHARGE_REWARD_INVALID",
            "id": 12326
        }, {
            "name": "SC_MALL_SHAREREDPACKET_TOTALAMOUNT_INVALID",
            "id": 12327
        }, {
            "name": "SC_MALL_SHAREREDPACKET_SPLITNUM_INVALID",
            "id": 12328
        }, {
            "name": "SC_MALL_SHAREREDPACKET_SPLITAMOUNT_INVALID",
            "id": 12329
        }, {
            "name": "SC_MALL_GOODS_NOT_EXIST",
            "id": 12336
        }, {
            "name": "SC_MALL_BROADCAST_NOT_OPEN",
            "id": 12337
        }, {
            "name": "SC_MALL_FIXEDCONTENT_NOT_EXIST",
            "id": 12338
        }, {
            "name": "SC_MALL_GIFT_GUARD_TOO_LOW",
            "id": 12339
        }, {
            "name": "SC_MALL_FIGHT_OVER",
            "id": 12340
        }, {
            "name": "SC_MALL_BIGBALL_OVER",
            "id": 12341
        }, {
            "name": "SC_MALL_PROP_LEFT_AMOUNT_NOT_ENOUGH",
            "id": 12342
        }, {
            "name": "SC_MALL_PROP_SAME_EXIST",
            "id": 12343
        }, {
            "name": "SC_MALL_PLAY_NOT_OPEN",
            "id": 12344
        }, {
            "name": "SC_MALL_MOUNT_CANNOTREPURCHASE",
            "id": 12345
        }, {
            "name": "SC_RANKING_VIP_INVISIBLE_LIMIT",
            "id": 14593
        }, {
            "name": "SC_RANKING_VIP_INVISIBLE_OFF",
            "id": 14594
        }, {
            "name": "SC_CONTACT_ALREADY_FRIEND",
            "id": 16385
        }, {
            "name": "SC_LIVE_ROOM_NOT_EXIST",
            "id": 20481
        }, {
            "name": "SC_LIVE_ROOM_DISABLED",
            "id": 20482
        }, {
            "name": "SC_LIVE_ROOM_NO_PERMISSION",
            "id": 20483
        }, {
            "name": "SC_LIVE_ROOM_USER_GRADE_NOT_ENOUGH",
            "id": 20484
        }, {
            "name": "SC_LIVE_ROOM_SPECIAL_NOT_CREATE",
            "id": 20485
        }, {
            "name": "SC_LIVE_ROOM_ADMIN_SHUTUP_FAIL",
            "id": 20486
        }, {
            "name": "SC_LIVE_ROOM_ADMIN_LIFTED_FAIL",
            "id": 20487
        }, {
            "name": "SC_LIVE_ROOM_ADMIN_SHUTUP_UIDS_ERROR",
            "id": 20488
        }, {
            "name": "SC_LIVE_ROOM_NO_TEL_AUTH",
            "id": 20489
        }, {
            "name": "SC_LIVE_ROOM_FORCED_OUT",
            "id": 20490
        }, {
            "name": "SC_LIVE_ROOM_POLICY_DISABLED",
            "id": 20491
        }, {
            "name": "SC_LIVE_ROOM_RID_UID_NOTMATCH",
            "id": 20492
        }, {
            "name": "SC_LIVE_ROOM_NO_REALNAME_AUTH",
            "id": 20496
        }, {
            "name": "SC_LIVE_ROOM_NOT_IN_MULTILIVE",
            "id": 20497
        }, {
            "name": "SC_LIVE_ROOM_PAY_FAILED",
            "id": 20498
        }, {
            "name": "SC_LIVE_ROOM_CANNOT_MULTILIVE",
            "id": 20499
        }, {
            "name": "SC_LIVE_ROOM_MULTILIVE_MEMBERS_LIMIT",
            "id": 20500
        }, {
            "name": "SC_LIVE_ROOM_MULTILIVE_CREATE_MEETINGROOM_FAILED",
            "id": 20501
        }, {
            "name": "SC_LIVE_ROOM_MULTILIVE_FINISH",
            "id": 20502
        }, {
            "name": "SC_LIVE_ROOM_IS_LIVING",
            "id": 20503
        }, {
            "name": "SC_LIVE_ROOM_PRIVATELIVE_NOT_ALLOW",
            "id": 20504
        }, {
            "name": "SC_LIVE_ROOM_CHARGE_NOT_ALLOW",
            "id": 20505
        }, {
            "name": "SC_LIVE_ROOM_CHARGE_BELOW_MIN",
            "id": 20506
        }, {
            "name": "SC_LIVE_ROOM_AUDIENCE_LIMIT_ALLOW",
            "id": 20507
        }, {
            "name": "SC_LIVE_ROOM_LIVE_NEED_CHARGE",
            "id": 20508
        }, {
            "name": "SC_LIVE_ROOM_NUMBER_REACHED_TOPLIMIT",
            "id": 20512
        }, {
            "name": "SC_LIVE_ROOM_VOICE_NOT_ALLOW",
            "id": 20513
        }, {
            "name": "SC_LIVE_ROOM_USER_NOT_ONLINE",
            "id": 20514
        }, {
            "name": "SC_LIVE_ROOM_APPLY_MULTILIVE_NOT_ALLOW",
            "id": 20515
        }, {
            "name": "SC_LIVE_ROOM_NO_MEMBER",
            "id": 20516
        }, {
            "name": "SC_LIVE_ROOM_NO_INVITE",
            "id": 20517
        }, {
            "name": "SC_LIVE_ROOM_MULTILIVE_FREEJOINTIME_EMPTY",
            "id": 20518
        }, {
            "name": "SC_LIVE_ROOM_MF_VIP_LIMIT",
            "id": 20519
        }, {
            "name": "SC_LIVE_ROOM_MF_COUNTRY_LIMIT",
            "id": 20520
        }, {
            "name": "SC_LIVE_ROOM_INVITE_LIMIT_DAILY",
            "id": 20521
        }, {
            "name": "SC_ACTIVITY_SEND_DIAMOND_TIME_END",
            "id": 24577
        }, {
            "name": "SC_ACTIVITY_SEND_DIAMOND_OVER_LIMIT",
            "id": 24578
        }, {
            "name": "SC_ACTIVITY_SEND_DIAMOND_ALREADY",
            "id": 24579
        }, {
            "name": "SC_ACTIVITY_NO_RECHARGE",
            "id": 24580
        }, {
            "name": "SC_ACTIVITY_NOT_CONDITIONS",
            "id": 24581
        }, {
            "name": "SC_SYSTEM_ERROR",
            "id": 16777215
        }, {
            "name": "SC_ZMXY_AUTH_BIND_SUCCESS",
            "id": 28673
        }, {
            "name": "SC_ZMXY_AUTH_HAS_BEEN_USEED",
            "id": 28674
        }, {
            "name": "SC_ZMXY_AUTH_HAS_BIND",
            "id": 28675
        }, {
            "name": "SC_ZMXY_AUTH_ERROR",
            "id": 28676
        }, {
            "name": "SC_REDPACKET_OVERDUE_ERROR",
            "id": 32769
        }, {
            "name": "SC_REDPACKET_DISTRIBUTED_ERROR",
            "id": 32770
        }, {
            "name": "SC_REDPACKET_REPEAT_ERROR",
            "id": 32771
        }, {
            "name": "SC_REDPACKET_DELAYTIME_ERROR",
            "id": 32772
        }, {
            "name": "SC_PERMISSIONUSE_NOT_ALLOW",
            "id": 36865
        }, {
            "name": "SC_PERMISSIONUSE_LOW_PERMISSION",
            "id": 36866
        }, {
            "name": "SC_PERMISSIONUSE_OVER_ROOMMAX",
            "id": 36867
        }, {
            "name": "SC_PERMISSIONUSE_OVER_DAYMAX",
            "id": 36868
        }, {
            "name": "SC_PERMISSIONUSE_OVER_ADD_LIMIT",
            "id": 36869
        }, {
            "name": "SC_PERMISSIONUSE_ERROR",
            "id": 36870
        }, {
            "name": "SC_PERMISSIONUSE_REPEAT_ERROR",
            "id": 36871
        }, {
            "name": "SC_ACTIVITY_EXCHANGE_REPEATED",
            "id": 65537
        }, {
            "name": "SC_ACTIVITY_POINT_NOT_ENOUGH",
            "id": 65538
        }, {
            "name": "SC_PACK_TRANSACTION_REPEATED",
            "id": 69633
        }, {
            "name": "SC_PACK_GIFT_NOT_AVAILABLE",
            "id": 69634
        }, {
            "name": "SC_PACK_GIFT_EXPIRE",
            "id": 69635
        }, {
            "name": "SC_PACK_TRANSACTION_NOT_EXIST",
            "id": 69636
        }, {
            "name": "SC_PACK_FULL",
            "id": 69637
        }, {
            "name": "SC_DYNAMIC_COMMENT_FREQUENCY_LIMITED",
            "id": 73729
        }, {
            "name": "SC_DYNAMIC_COMMENT_WORDS_OVER_LONG",
            "id": 73730
        }, {
            "name": "SC_DYNAMIC_NOT_EXIST_OR_DELETED",
            "id": 73731
        }, {
            "name": "SC_DYNAMIC_HAS_NO_RIGHT",
            "id": 73732
        }, {
            "name": "SC_DYNAMIC_IN_CALCULATION",
            "id": 73733
        }, {
            "name": "SC_DYNAMIC_EMPTY_NEED_GET_RECOMMEND_ANCHOR",
            "id": 73734
        }, {
            "name": "SC_DYNAMIC_LIMIT_FREQUENTLY_REPEAT_COMMENT",
            "id": 73735
        }, {
            "name": "SC_DYNAMIC_NOT_VIDEO_COMMENT",
            "id": 73736
        }, {
            "name": "SC_CHECKIN_ALREADY",
            "id": 77825
        }, {
            "name": "SC_FAN_GROUP_TITLE_CHANGE_POINT_NOT_ENOUGH",
            "id": 94465
        }, {
            "name": "SC_FAN_GROUP_NOT_EXIST",
            "id": 94466
        }, {
            "name": "SC_FAN_GROUP_NOT_FAN",
            "id": 94467
        }, {
            "name": "SC_FAN_GROUP_SELF_JOIN_ERROR",
            "id": 94468
        }, {
            "name": "SC_FAN_TASK_NOT_EXIST",
            "id": 94469
        }, {
            "name": "SC_FAN_TASK_TYPE_NOT_EXIST",
            "id": 94470
        }, {
            "name": "SC_FAN_TASK_MAXIMUM_TIME_REACHED",
            "id": 94471
        }, {
            "name": "SC_FAN_PERMISSION_NO",
            "id": 94472
        }, {
            "name": "SC_ACTIVITY_REWARD_ALREADY",
            "id": 81921
        }, {
            "name": "SC_ACTIVITY_REWARD_CANNOT",
            "id": 81922
        }, {
            "name": "SC_RANKING_GAME_NOTAUTHORITY",
            "id": 86017
        }, {
            "name": "IM_SYSTEM_ERROR",
            "id": 90113
        }, {
            "name": "IM_CREATE_PERMISSION_DENIED",
            "id": 90114
        }, {
            "name": "IM_BEYOND_GROUP_NUM_LIMIT",
            "id": 90115
        }, {
            "name": "IM_BEYOND_GROUP_USER_NUM_LIMIT",
            "id": 90116
        }, {
            "name": "IM_PERMISSION_DENIED",
            "id": 90117
        }, {
            "name": "IM_GROUP_INVALID",
            "id": 90118
        }, {
            "name": "IM_INVITE_INVALID",
            "id": 90119
        }, {
            "name": "SC_FOLLOW_YOU_ARE_IN_OTHERS_BLACKLIST",
            "id": 98305
        }, {
            "name": "SC_FOLLOW_ALREADY_REACH_MAX_FOLLOW",
            "id": 98306
        }, {
            "name": "SC_GIFTITEM_SAMENAME",
            "id": 98307
        }, {
            "name": "GIFTO_ACCOUNT_LOGING",
            "id": 1052673
        }, {
            "name": "GIFTO_ACCOUNT_ALREADY_ACTIVATE",
            "id": 1052674
        }, {
            "name": "GIFTO_ACCOUNT_WAIT_ACTIVATE",
            "id": 1052675
        }, {
            "name": "GIFTO_ACCOUNT_EXPIRE_ACTIVATE",
            "id": 1052676
        }, {
            "name": "GIFTO_ACCOUNT_NOT_BIND",
            "id": 1052677
        }, {
            "name": "GIFTO_EMAIL_VERIFY_INVALID",
            "id": 1052678
        }, {
            "name": "GIFTO_ACCOUNT_USER_OR_PASSWORD_ERROR",
            "id": 1052679
        }, {
            "name": "GIFTO_EMAIL_SEND_OVER_LIMIT",
            "id": 1052680
        }, {
            "name": "GIFTO_EMAIL_NOT_VERIFY",
            "id": 1052681
        }, {
            "name": "GIFTO_NOT_CURRENT_USER_BIND",
            "id": 1052682
        }, {
            "name": "GIFTO_ACCOUNT_PASSWORD_ERROR",
            "id": 1052683
        }, {
            "name": "GIFTO_KYC_NOT_SCUCCESS",
            "id": 1052684
        }, {
            "name": "GIFTO_ACCOUNT_NO_AUTHORITY",
            "id": 1052685
        }, {
            "name": "GIFTO_EMAIL_ALREADY_REGISTER",
            "id": 1052686
        }, {
            "name": "WALLET_JSON_NOT_VALID",
            "id": 1056769
        }, {
            "name": "WALLET_REQUEST_MISSING",
            "id": 1056770
        }, {
            "name": "WALLET_CURRENCY_NOT_SUPPORTED",
            "id": 1056771
        }, {
            "name": "WALLET_EXCEED_MAX_LENGRH",
            "id": 1056772
        }, {
            "name": "WALLET_INVALID_TOKEN",
            "id": 1056773
        }, {
            "name": "WALLET_METHOD_NOT_ALLOWED",
            "id": 1056774
        }, {
            "name": "WALLET_HAD_REPEAT_VALID",
            "id": 1056775
        }, {
            "name": "WALLET_MINIMUM_COIN_REQUIRED",
            "id": 1056776
        }, {
            "name": "WALLET_BALANCE_NOT_ENOUGH",
            "id": 1056777
        }, {
            "name": "WALLET_TRANSFER_FEE_TYPE_NOT_SUPPORTED",
            "id": 1056778
        }, {
            "name": "WALLET_TRANSFER_TYPE_NOT_SUPPORTED",
            "id": 1056779
        }, {
            "name": "WALLET_PASSPHRASE_NOT_CORRECT",
            "id": 1056780
        }, {
            "name": "WALLET_SENDER_IDENTITY_NOT_FOUNT",
            "id": 1056781
        }, {
            "name": "WALLET_RECEIVER_IDENTITY_NOT_FOUNT",
            "id": 1056782
        }, {
            "name": "WALLET_FOR_DEPOSITING",
            "id": 1056783
        }, {
            "name": "WALLET_OPEN_UCOINS_NOT_ENOUGH",
            "id": 1060865
        }, {
            "name": "WALLET_OPEN_TRANSACTION_REPEATED",
            "id": 1060866
        }, {
            "name": "WALLET_OPEN_TRANSACTION_NOT_EXIST",
            "id": 1060867
        }, {
            "name": "WALLET_OPEN_FAIL",
            "id": 1060868
        }, {
            "name": "WALLET_OPEN_TRANSACTION_NOT_END",
            "id": 1060869
        }, {
            "name": "WALLET_OPEN_TRANSACTION_DAY_LIMIT",
            "id": 1060870
        }, {
            "name": "WALLET_OPEN_TRANSACTION_MONTH_LIMIT",
            "id": 1060871
        }, {
            "name": "WALLET_OPEN_TRANSACTION_YEAR_LIMIT",
            "id": 1060872
        }, {
            "name": "WALLET_OPEN_TRANSACTION_FREQUENTLY",
            "id": 1060873
        }, {
            "name": "WALLET_OPEN_TRANSACTION_ONCHAIN_SHUT",
            "id": 1060874
        }, {
            "name": "WALLET_OPEN_PAYPASS_NOT_SETTING",
            "id": 1060875
        }, {
            "name": "WALLET_OPEN_USER_TRANSACTION_SHUT",
            "id": 1060876
        }, {
            "name": "WALLET_OPEN_USER_DEPOT_LOCKED",
            "id": 1060877
        }, {
            "name": "WALLET_OPEN_FIAT_PRODUCT_NOT_AVAILABLE",
            "id": 1060878
        }, {
            "name": "WALLET_OPEN_FIAT_PRODUCT_REFRESHED",
            "id": 1060879
        }, {
            "name": "WALLET_OPEN_UNIFIED_ORDER_FAIL",
            "id": 1060880
        }, {
            "name": "WALLET_OPEN_ORDER_NOT_EXIST",
            "id": 1060881
        }, {
            "name": "WALLET_OPEN_PAY_QUERY_FAIL",
            "id": 1060882
        }, {
            "name": "WALLET_OPEN_PAY_FAIL",
            "id": 1060883
        }, {
            "name": "WALLET_OPEN_FIAT_RECHARGE_DAY_LIMIT",
            "id": 1060884
        }, {
            "name": "WALLET_OPEN_UCOINS_EXCHANGE_REGION_CLOSE",
            "id": 1060885
        }, {
            "name": "WALLET_OPEN_UCOINS_HAS_EXCHANGE",
            "id": 1060886
        }, {
            "name": "WALLET_OPEN_UCOINS_MORE_MAX",
            "id": 1060887
        }, {
            "name": "WALLET_OPEN_UCOINS_LESS_MIN",
            "id": 1060888
        }, {
            "name": "WALLET_OPEN_USABLE_BALANCE_NOT_ENOUGH",
            "id": 1060889
        }, {
            "name": "GIFTO_MALL_REQUEST_SUCCESS",
            "id": 1064960
        }, {
            "name": "GIFTO_MALL_DUPLICATED_TRANSACTION",
            "id": 1064961
        }, {
            "name": "GIFTO_MALL_GTO_BALANCE_NOT_ENOUGH",
            "id": 1064962
        }, {
            "name": "GIFTO_MALL_PRARAMETER_INVALID",
            "id": 1064963
        }, {
            "name": "GIFTO_MALL_GIFT_NOT_EXIST",
            "id": 1064964
        }, {
            "name": "GIFTO_MALL_UNKNOWN_EXCEPTION",
            "id": 1064965
        }, {
            "name": "GIFTO_MALL_GIFT_SEND_VIP_LIMIT",
            "id": 1064966
        }, {
            "name": "GIFTO_MALL_GIFTO_RECEIVE_NOT_AUTHORITY",
            "id": 1064967
        }, {
            "name": "GREETING_CARDS_REQUEST_SUCCESS",
            "id": 1069056
        }, {
            "name": "GREETING_CARDS_NOT_GIFT",
            "id": 1069057
        }, {
            "name": "GREETING_CARDS_REQUEST_ERROR",
            "id": 1069058
        }, {
            "name": "GREETING_CARDS_GIFT_ID_ERROR",
            "id": 1069059
        }, {
            "name": "GREETING_CARDS_GIFT_ID_NULL",
            "id": 1069060
        }, {
            "name": "GREETING_CARDS_STATUS_NO_PASS",
            "id": 1069061
        }, {
            "name": "GREETING_CARDS_IP_COUNT_FULL",
            "id": 1069062
        }, {
            "name": "PK_USER_NOT_IN_PK",
            "id": 1073152
        }, {
            "name": "PK_USER_INCONVENIENT",
            "id": 1073153
        }, {
            "name": "PK_USER_OFFLINE",
            "id": 1073154
        }, {
            "name": "PK_SEND_MSG_FAIL",
            "id": 1073155
        }, {
            "name": "PK_USER_ALREADY_IN_INVITE",
            "id": 1073156
        }, {
            "name": "PK_USER_ALREADY_IN_MATCH_WAITING",
            "id": 1073157
        }, {
            "name": "PK_INVALID_USER",
            "id": 1073158
        }, {
            "name": "PK_INVITE_UUID_EXPIRED",
            "id": 1073159
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(373)();
}


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {

    module.exports = function (win) {
        var doc = win.document,
            body = doc.body,
            E_float,
            E_floatMsg,
            E_floatContent,
            E_floatOk,
            E_floatCancel,
            initDom = false,
            flashTimeoutId,
            showTimeoutId,
            hideTimeoutId,
            E_mask;

        E_mask = doc.createElement('div');
        E_mask.className = 'c-float-mask hide';

        E_float = doc.createElement('div');
        E_float.className = 'c-float-popWrap msgMode hide';
        E_float.innerHTML = ['<style type="text/css">', '.c-float-modePop{text-align:center}.c-float-modePop .warnMsg{color:#fff}.c-float-modePop button{padding:6px 9px 6px 9px;color:#157afb;background:-webkit-gradient(linear,left top,left bottom,color-stop(0,#404040),color-stop(100%,#2e2e2e));border:none}.c-float-shade{width:100%;display:block;position:absolute;z-index:99;background-color:#000;opacity:.5;top:0;left:0}.c-float-mask{position:fixed;top:0;left:0;bottom:0;right:0;height:100%;width:100%;z-index:9998;background:rgba(0,0,0,.7);opacity:0;-webkit-transition:opacity .3s linear 0s}.c-float-shade.hide{display:none}.c-float-mask.hide{display:none}.c-float-popWrap{width:90%; border-radius:8px;-webkit-border-radius:8px;z-index:9999;position:fixed;overflow:hidden;left:50%;top:50%; margin-left: -45%; -webkit-transition:opacity .3s linear 0s}.c-float-popWrap .c-float-modePop{background-color:rgba(0,0,0,.7);-webkit-border-radius:8px;border-radius:8px;overflow:hidden;padding:10px;}.c-float-popWrap .c-float-modePop .warnMsg{padding:0;font-size:15px;line-height:18px;color:#fff;font-weight:400}.c-float-popWrap .c-float-modePop .content{line-height:1.5}.c-float-popWrap.hide{display:none;-webkit-box-shadow:none}.c-float-popWrap.show{display:block}.c-float-popWrap.msgMode .c-float-modePop .content,.c-float-popWrap.msgMode .c-float-modePop .doBtn{display:none}.c-float-popWrap.alertMode .c-float-modePop .content{display:none}.c-float-popWrap.alertMode .c-float-modePop .doBtn .cancel{display:none}.c-float-popWrap.alertMode,.c-float-popWrap.confirmMode{width:90%;}.c-float-popWrap.alertMode .c-float-modePop,.c-float-popWrap.confirmMode .c-float-modePop{background:#fff;padding:0;color:#202325}.c-float-popWrap.alertMode .c-float-modePop .content,.c-float-popWrap.confirmMode .c-float-modePop .content{padding:10px;border-bottom:1px solid #d6d9dc}.c-float-popWrap.alertMode .c-float-modePop .warnMsg,.c-float-popWrap.confirmMode .c-float-modePop .warnMsg{padding:10px;display:-webkit-box;-webkit-box-align:center;-webkit-box-pack:center;text-align:center;font-weight:700}.c-float-popWrap.alertMode .c-float-modePop .doBtn,.c-float-popWrap.alertMode .c-float-modePop .warnMsg,.c-float-popWrap.confirmMode .c-float-modePop .doBtn,.c-float-popWrap.confirmMode .c-float-modePop .warnMsg{border-bottom:1px solid #d6d9dc;color:#202325}.c-float-popWrap.alertMode .c-float-modePop .doBtn,.c-float-popWrap.confirmMode .c-float-modePop .doBtn{border-bottom:none;display:-webkit-box;-webkit-box-align:center}.c-float-popWrap.alertMode .c-float-modePop .content,.c-float-popWrap.confirmMode .c-float-modePop .content{display:block;color:#202325;padding:10px;line-height:24px;font-size:15px;text-align:left;font-weight:700}.c-float-modePop button{-webkit-box-flex:1;color:#157afb;background:#fff;height:40px;font-size:18px;display:block}.c-float-modePop button.cancel{border-right:1px solid #b2b2b2}.c-float-modePop button.ok{font-weight:700}', '</style>', '<div class="c-float-modePop">', '<div class="warnMsg"></div>', '<div class="content"></div>', '<div class="doBtn">', '<button class="cancel">取消</button>', '<button class="ok">确定</button>', '</div>', '</div>'].join('');

        E_floatMsg = E_float.querySelector('.warnMsg');
        E_floatContent = E_float.querySelector('.content');
        E_floatOk = E_float.querySelector('.doBtn .ok');
        E_floatCancel = E_float.querySelector('.doBtn .cancel');

        E_floatMsg.addEventListener('click', function () {
            // alert(E_float.className);
        }, false);

        function _extend(a, b) {
            for (var k in b) {
                a[k] = b[k];
            }
            return a;
        }

        function successHandler(e) {
            this.callback && this.callback(e, true);
        }

        function failureHandler(e) {
            this.callback && this.callback(e, false);
        }

        function ModePop(options) {
            this._options = _extend({
                mode: 'msg',
                text: '网页提示',
                useTap: false
            }, options || {});

            this._init();
        }

        _extend(ModePop.prototype, {
            _init: function _init() {
                var that = this,
                    opt = that._options,
                    mode = opt.mode,
                    text = opt.text,
                    okText = opt.okText,
                    cancelText = opt.cancelText,
                    content = opt.content,
                    callback = opt.callback,
                    background = opt.background,
                    clickEvent = opt.useTap ? 'touchend' : 'click';

                // set mode
                var classTxt = E_float.className;
                classTxt = classTxt.replace(/(msg|alert|confirm)Mode/i, mode + 'Mode');
                E_float.className = classTxt;

                // set background
                background && (E_float.style.background = background);

                // set text & content
                if (text) {
                    E_floatMsg.innerHTML = text;
                    E_floatMsg.style.display = 'block';
                } else {
                    E_floatMsg.style.display = 'none';
                }

                if (content) {
                    E_floatContent.innerHTML = content;
                    E_floatContent.style.display = 'block';
                } else {
                    E_floatContent.style.display = 'none';
                }

                E_floatOk.innerHTML = okText || '确定';
                E_floatCancel.innerHTML = cancelText || '取消';

                if (mode == 'alert' || mode == 'confirm') {
                    this.hasMask = true;
                } else {
                    this.hasMask = false;
                }

                // click event
                E_floatOk.removeEventListener('touchend', successHandler);
                E_floatOk.removeEventListener('click', successHandler);
                E_floatCancel.removeEventListener('touchend', successHandler);
                E_floatCancel.removeEventListener('click', successHandler);
                E_floatOk.addEventListener(clickEvent, successHandler, false);
                E_floatCancel.addEventListener(clickEvent, failureHandler, false);
                E_floatOk.callback = E_floatCancel.callback = function () {
                    callback.apply(that, arguments);
                };

                if (!initDom) {
                    initDom = true;
                    doc.body.appendChild(E_mask);
                    doc.body.appendChild(E_float);
                    win.addEventListener('resize', function () {
                        setTimeout(function () {
                            that._pos();
                        }, 500);
                    }, false);
                }
            },

            _pos: function _pos() {
                var rect = E_float.getBoundingClientRect(),
                    eW = rect.width,
                    eH = rect.height;

                E_float.style.marginLeft = -eW / 2 + 'px';
                E_float.style.marginTop = -eH / 2 + 'px';
            },

            isShow: function isShow() {
                return E_float.className.indexOf('show') > -1;
            },

            isHide: function isHide() {
                return E_float.className.indexOf('hide') > -1;
            },

            _cbShow: function _cbShow(pos) {
                var that = this,
                    opt = that._options,
                    onShow = opt.onShow;

                E_float.style.opacity = '1';
                that.hasMask && (E_mask.style.opacity = '1');
                that.hasMask && (E_mask.className = E_mask.className.replace(/hide/g, '').trim());

                if (!that.isShow()) {
                    E_float.className += ' show';
                    that.hasMask && (E_mask.className += ' show');
                }

                pos && that._pos();

                onShow && onShow.call(that);
            },

            show: function show() {
                var that = this;

                if (flashTimeoutId) {
                    clearTimeout(flashTimeoutId);
                    flashTimeoutId = null;
                    this._cbHide();
                }

                if (showTimeoutId) {
                    clearTimeout(showTimeoutId);
                    showTimeoutId = null;
                }

                if (hideTimeoutId) {
                    clearTimeout(hideTimeoutId);
                    hideTimeoutId = null;
                }

                if (!that.isShow()) {
                    E_float.className = E_float.className.replace(/hide/g, '').trim();
                    that.hasMask && (E_mask.className = E_mask.className.replace(/hide/g, '').trim());

                    that._pos();

                    setTimeout(function () {
                        E_float.style.opacity = '1';
                        that.hasMask && (E_mask.style.opacity = '1');
                    }, 1);

                    showTimeoutId = setTimeout(function () {
                        that._cbShow();
                    }, 300);
                } else {
                    that._cbShow(true);
                }
            },

            _cbHide: function _cbHide() {
                var that = this,
                    opt = that._options,
                    onHide = opt.onHide;

                E_float.style.opacity = '0';
                E_mask.style.opacity = '0';

                if (!that.isHide()) {
                    E_float.className = E_float.className.replace(/hide|show/g, '').trim();
                    E_float.className += ' hide';
                    E_mask.className = E_mask.className.replace(/hide|show/g, '').trim();
                    E_mask.className += ' hide';
                }
                onHide && onHide.call(that);
            },
            // ruoli 添加timeout参数，防止点击弹出框，立即再弹出一个框，出现闪动
            hide: function hide(timeout) {
                var that = this;

                if (showTimeoutId) {
                    clearTimeout(showTimeoutId);
                    showTimeoutId = null;
                }

                if (hideTimeoutId) {
                    clearTimeout(hideTimeoutId);
                    hideTimeoutId = null;
                }

                if (!that.isHide()) {
                    E_float.className = E_float.className.replace(/show/g, '').trim();
                    E_mask.className = E_mask.className.replace(/show/g, '').trim();

                    setTimeout(function () {
                        E_float.style.opacity = '0';
                        E_mask.style.opacity = '0';
                    }, 1);

                    hideTimeoutId = setTimeout(function () {
                        that._cbHide();
                    }, timeout || 300);
                } else {
                    that._cbHide();
                }
            },

            flash: function flash(timeout) {
                var that = this,
                    opt = that._options;

                that.show();

                //opt.onShow = function() {
                flashTimeoutId = setTimeout(function () {
                    if (flashTimeoutId) {
                        that.hide();
                    }
                }, timeout);
                //};
            }
        });

        var notification = new function () {

            this.simple = function (text, bg, timeout) {
                if (arguments.length == 2) {
                    if (typeof arguments[1] == 'number') {
                        timeout = arguments[1];
                        bg = undefined;
                    }
                }

                var pop = new ModePop({
                    mode: 'msg',
                    text: text,
                    background: bg
                });

                pop.flash(timeout || 2000);
                return pop;
            };

            this.msg = function (text, options) {
                return new ModePop(_extend({
                    mode: 'msg',
                    text: text
                }, options || {}));
            };

            this.alert = function (text, content, callback, options) {

                if (typeof content === 'function') {
                    options = callback;
                    callback = content;
                    content = null;
                }

                return new ModePop(_extend({
                    mode: 'alert',
                    text: text,
                    content: content,
                    callback: callback
                }, options || {}));
            };

            this.confirm = function (text, content, callback, options) {
                return new ModePop(_extend({
                    mode: 'confirm',
                    text: text,
                    content: content,
                    callback: callback
                }, options || {}));
            };

            this.pop = function (options) {
                return new ModePop(options);
            };
        }();

        return notification;
    }(window);
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var modalFactory = __webpack_require__(265);
var insertKeyframesRule = __webpack_require__(266);
var appendVendorPrefix = __webpack_require__(156);

var animation = {
    show: {
        animationDuration: '0.4s',
        animationTimingFunction: 'cubic-bezier(0.6,0,0.4,1)'
    },
    hide: {
        animationDuration: '0.4s',
        animationTimingFunction: 'ease-out'
    },
    showContentAnimation: insertKeyframesRule({
        '0%': {
            opacity: 0,
            transform: 'scale3d(0, 0, 1)'
        },
        '100%': {
            opacity: 1,
            transform: 'scale3d(1, 1, 1)'
        }
    }),

    hideContentAnimation: insertKeyframesRule({
        '0%': {
            opacity: 1
        },
        '100%': {
            opacity: 0,
            transform: 'scale3d(0.5, 0.5, 1)'
        }
    }),

    showBackdropAnimation: insertKeyframesRule({
        '0%': {
            opacity: 0
        },
        '100%': {
            opacity: 0.9
        },
    }),

    hideBackdropAnimation: insertKeyframesRule({
        '0%': {
            opacity: 0.9
        },
        '100%': {
            opacity: 0
        }
    })
};

var showAnimation = animation.show;
var hideAnimation = animation.hide;
var showContentAnimation = animation.showContentAnimation;
var hideContentAnimation = animation.hideContentAnimation;
var showBackdropAnimation = animation.showBackdropAnimation;
var hideBackdropAnimation = animation.hideBackdropAnimation;

module.exports = modalFactory({
    getRef: function(willHidden) {
        return 'content';
    },
    getModalStyle: function(willHidden) {
        return appendVendorPrefix({
            zIndex: 1050,
            position: "fixed",
            width: "500px",
            transform: "translate3d(-50%, -50%, 0)",
            top: "50%",
            left: "50%"
        })
    },
    getBackdropStyle: function(willHidden) {
        return appendVendorPrefix({
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: 1040,
            backgroundColor: "#373A47",
            animationFillMode: 'forwards',
            animationDuration: '0.4s',
            animationName: willHidden ? hideBackdropAnimation : showBackdropAnimation,
            animationTimingFunction: (willHidden ? hideAnimation : showAnimation).animationTimingFunction
        });
    },
    getContentStyle: function(willHidden) {
        return appendVendorPrefix({
            margin: 0,
            backgroundColor: "white",
            animationDuration: (willHidden ? hideAnimation : showAnimation).animationDuration,
            animationFillMode: 'forwards',
            animationName: willHidden ? hideContentAnimation : showContentAnimation,
            animationTimingFunction: (willHidden ? hideAnimation : showAnimation).animationTimingFunction
        })
    }
});


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var style = {
    backdropStyle: {
        background: 'transparent',
        position: 'fixed',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        overflow: 'hidden',
        zIndex: '99999',
        display: '-webkit-box',
        WebkitBoxOrient: 'horizontal',
        WebkitBoxPack: 'center',
        WebkitBoxAlign: 'center'
    },
    contentStyle: {
        position: 'absolute',
        width: '100px',
        height: '90px',
        color: '#fff',
        textAlign: 'center',
        fontSize: '11px',
        borderRadius: '6px',
        background: '#000',
        opacity: '0.9',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitBoxAlign: 'center'
    },
    loadingIconStyle: {
        display: 'block',
        width: '40px',
        height: '40px',
        margin: '18px auto 8px',
        background: 'url(data:image/gif;base64,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) no-repeat center center',
        backgroundSize: '30px 30px'
    }
};

var Layer = function (_Component) {
    _inherits(Layer, _Component);

    function Layer(props) {
        _classCallCheck(this, Layer);

        return _possibleConstructorReturn(this, (Layer.__proto__ || Object.getPrototypeOf(Layer)).call(this, props));
    }

    _createClass(Layer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var wrap = this.refs.wrap;
            var item = this.refs.content;

            var bodyRect = document.body.getBoundingClientRect();
            var spanRect = item.getBoundingClientRect();
            var zIndex = item.style.zIndex;

            item.style.position = "fixed";
            item.style.left = "50%";
            item.style.top = "50%";
            item.style.marginLeft = -spanRect.width / 2 + "px";
            item.style.marginTop = -spanRect.height / 2 + "px";

            setTimeout(function () {
                item.style.zIndex = zIndex;
            }, 0);
        }
    }, {
        key: 'render',
        value: function render() {
            var backdropStyle = style.backdropStyle;
            var contentStyle = style.contentStyle;
            var loadingIconStyle = style.loadingIconStyle;

            if (this.props.loadingIconStyle) {
                for (var _style in this.props.loadingIconStyle) {
                    loadingIconStyle[_style] = this.props.loadingIconStyle[_style];
                }
            }

            if (this.props.backdropStyle) {
                for (var _style2 in this.props.backdropStyle) {
                    backdropStyle[_style2] = this.props.backdropStyle[_style2];
                }
            }

            if (this.props.contentStyle) {
                for (var _style3 in this.props.contentStyle) {
                    contentStyle[_style3] = this.props.contentStyle[_style3];
                }
            }
            console.log(this.props.content);
            return _react2.default.createElement(
                'div',
                { className: 'loading-wrap', style: backdropStyle, ref: 'wrap' },
                _react2.default.createElement(
                    'div',
                    { className: 'loading-content', style: contentStyle, ref: 'content' },
                    _react2.default.createElement('i', { className: 'loading-icon', style: loadingIconStyle }),
                    _react2.default.createElement(
                        'div',
                        { className: 'loading-txt' },
                        this.props.content
                    )
                )
            );
        }
    }]);

    return Layer;
}(_react.Component);

Layer.defaultProps = {
    content: 'Loading',
    contentStyle: {},
    backdropStyle: {},
    loadingIconStyle: {}

};


module.exports = {
    show: function show(cfg) {
        cfg = cfg || {};

        if (this.layer) {
            this.destroy();
        }

        cfg.content = typeof cfg.content !== 'undefined' ? cfg.content : 'Loading';

        var mountNode = this.createMountNode();

        this.layer = _reactDom2.default.render(_react2.default.createElement(Layer, cfg), mountNode);
    },

    hide: function hide() {
        if (this.layer) {
            this.destroy();
        }
    },

    // 创建组件插入的DOM节点
    createMountNode: function createMountNode() {
        this.mountNode = document.createElement("div");
        $(document.body).append(this.mountNode);
        return this.mountNode;
    },

    destroy: function destroy() {
        _reactDom2.default.unmountComponentAtNode(this.mountNode);
        $(this.mountNode).remove();
        delete this.layer;
    }
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ExecutionEnvironment
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactMount
 */



var DOMProperty = __webpack_require__(47);
var ReactBrowserEventEmitter = __webpack_require__(79);
var ReactCurrentOwner = __webpack_require__(25);
var ReactDOMFeatureFlags = __webpack_require__(168);
var ReactElement = __webpack_require__(18);
var ReactEmptyComponentRegistry = __webpack_require__(169);
var ReactInstanceHandles = __webpack_require__(48);
var ReactInstanceMap = __webpack_require__(61);
var ReactMarkupChecksum = __webpack_require__(171);
var ReactPerf = __webpack_require__(19);
var ReactReconciler = __webpack_require__(39);
var ReactUpdateQueue = __webpack_require__(113);
var ReactUpdates = __webpack_require__(20);

var assign = __webpack_require__(8);
var emptyObject = __webpack_require__(62);
var containsNode = __webpack_require__(172);
var instantiateReactComponent = __webpack_require__(115);
var invariant = __webpack_require__(2);
var setInnerHTML = __webpack_require__(77);
var shouldUpdateReactComponent = __webpack_require__(117);
var validateDOMNesting = __webpack_require__(118);
var warning = __webpack_require__(7);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var nodeCache = {};

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var ownerDocumentContextKey = '__ReactMount_ownerDocument$' + Math.random().toString(36).slice(2);

/** Mapping from reactRootID to React component instance. */
var instancesByReactRootID = {};

/** Mapping from reactRootID to `container` nodes. */
var containersByReactRootID = {};

if (false) {
  /** __DEV__-only mapping from reactRootID to root elements. */
  var rootElementsByReactRootID = {};
}

// Used to store breadth-first search state in findComponentRoot.
var findComponentRootReusableArray = [];

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

/**
 * @param {DOMElement} container DOM element that may contain a React component.
 * @return {?string} A "reactRoot" ID, if a React component is rendered.
 */
function getReactRootID(container) {
  var rootElement = getReactRootElementInContainer(container);
  return rootElement && ReactMount.getID(rootElement);
}

/**
 * Accessing node[ATTR_NAME] or calling getAttribute(ATTR_NAME) on a form
 * element can return its control whose name or ID equals ATTR_NAME. All
 * DOM nodes support `getAttributeNode` but this can also get called on
 * other objects so just return '' if we're given something other than a
 * DOM node (such as window).
 *
 * @param {?DOMElement|DOMWindow|DOMDocument|DOMTextNode} node DOM node.
 * @return {string} ID of the supplied `domNode`.
 */
function getID(node) {
  var id = internalGetID(node);
  if (id) {
    if (nodeCache.hasOwnProperty(id)) {
      var cached = nodeCache[id];
      if (cached !== node) {
        !!isValid(cached, id) ?  false ? invariant(false, 'ReactMount: Two valid but unequal nodes with the same `%s`: %s', ATTR_NAME, id) : invariant(false) : undefined;

        nodeCache[id] = node;
      }
    } else {
      nodeCache[id] = node;
    }
  }

  return id;
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node && node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Sets the React-specific ID of the given node.
 *
 * @param {DOMElement} node The DOM node whose ID will be set.
 * @param {string} id The value of the ID attribute.
 */
function setID(node, id) {
  var oldID = internalGetID(node);
  if (oldID !== id) {
    delete nodeCache[oldID];
  }
  node.setAttribute(ATTR_NAME, id);
  nodeCache[id] = node;
}

/**
 * Finds the node with the supplied React-generated DOM ID.
 *
 * @param {string} id A React-generated DOM ID.
 * @return {DOMElement} DOM node with the suppled `id`.
 * @internal
 */
function getNode(id) {
  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
    nodeCache[id] = ReactMount.findReactNodeByID(id);
  }
  return nodeCache[id];
}

/**
 * Finds the node with the supplied public React instance.
 *
 * @param {*} instance A public React instance.
 * @return {?DOMElement} DOM node with the suppled `id`.
 * @internal
 */
function getNodeFromInstance(instance) {
  var id = ReactInstanceMap.get(instance)._rootNodeID;
  if (ReactEmptyComponentRegistry.isNullComponentID(id)) {
    return null;
  }
  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
    nodeCache[id] = ReactMount.findReactNodeByID(id);
  }
  return nodeCache[id];
}

/**
 * A node is "valid" if it is contained by a currently mounted container.
 *
 * This means that the node does not have to be contained by a document in
 * order to be considered valid.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @param {string} id The expected ID of the node.
 * @return {boolean} Whether the node is contained by a mounted container.
 */
function isValid(node, id) {
  if (node) {
    !(internalGetID(node) === id) ?  false ? invariant(false, 'ReactMount: Unexpected modification of `%s`', ATTR_NAME) : invariant(false) : undefined;

    var container = ReactMount.findReactContainerForID(id);
    if (container && containsNode(container, node)) {
      return true;
    }
  }

  return false;
}

/**
 * Causes the cache to forget about one React-specific ID.
 *
 * @param {string} id The ID to forget.
 */
function purgeID(id) {
  delete nodeCache[id];
}

var deepestNodeSoFar = null;
function findDeepestCachedAncestorImpl(ancestorID) {
  var ancestor = nodeCache[ancestorID];
  if (ancestor && isValid(ancestor, ancestorID)) {
    deepestNodeSoFar = ancestor;
  } else {
    // This node isn't populated in the cache, so presumably none of its
    // descendants are. Break out of the loop.
    return false;
  }
}

/**
 * Return the deepest cached node whose ID is a prefix of `targetID`.
 */
function findDeepestCachedAncestor(targetID) {
  deepestNodeSoFar = null;
  ReactInstanceHandles.traverseAncestors(targetID, findDeepestCachedAncestorImpl);

  var foundNode = deepestNodeSoFar;
  deepestNodeSoFar = null;
  return foundNode;
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {string} rootID DOM ID of the root node.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(componentInstance, rootID, container, transaction, shouldReuseMarkup, context) {
  if (ReactDOMFeatureFlags.useCreateElement) {
    context = assign({}, context);
    if (container.nodeType === DOC_NODE_TYPE) {
      context[ownerDocumentContextKey] = container;
    } else {
      context[ownerDocumentContextKey] = container.ownerDocument;
    }
  }
  if (false) {
    if (context === emptyObject) {
      context = {};
    }
    var tag = container.nodeName.toLowerCase();
    context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(null, tag, null);
  }
  var markup = ReactReconciler.mountComponent(componentInstance, rootID, transaction, context);
  componentInstance._renderedComponent._topLevelWrapper = componentInstance;
  ReactMount._mountImageIntoNode(markup, container, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {string} rootID DOM ID of the root node.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, rootID, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* forceHTML */shouldReuseMarkup);
  transaction.perform(mountComponentIntoNode, null, componentInstance, rootID, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container) {
  ReactReconciler.unmountComponent(instance);

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(node) {
  var reactRootID = getReactRootID(node);
  return reactRootID ? reactRootID !== ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID) : false;
}

/**
 * Returns the first (deepest) ancestor of a node which is rendered by this copy
 * of React.
 */
function findFirstReactDOMImpl(node) {
  // This node might be from another React instance, so we make sure not to
  // examine the node cache here
  for (; node && node.parentNode !== node; node = node.parentNode) {
    if (node.nodeType !== 1) {
      // Not a DOMElement, therefore not a React component
      continue;
    }
    var nodeID = internalGetID(node);
    if (!nodeID) {
      continue;
    }
    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);

    // If containersByReactRootID contains the container we find by crawling up
    // the tree, we know that this instance of React rendered the node.
    // nb. isValid's strategy (with containsNode) does not work because render
    // trees may be nested and we don't want a false positive in that case.
    var current = node;
    var lastID;
    do {
      lastID = internalGetID(current);
      current = current.parentNode;
      if (current == null) {
        // The passed-in node has been detached from the container it was
        // originally rendered into.
        return null;
      }
    } while (lastID !== reactRootID);

    if (current === containersByReactRootID[reactRootID]) {
      return node;
    }
  }
  return null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var TopLevelWrapper = function () {};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  // this.props is actually a ReactElement
  return this.props;
};

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {

  TopLevelWrapper: TopLevelWrapper,

  /** Exposed for debugging purposes **/
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    if (false) {
      // Record the root element in case it later gets transplanted.
      rootElementsByReactRootID[getReactRootID(container)] = getReactRootElementInContainer(container);
    }

    return prevComponent;
  },

  /**
   * Register a component into the instance map and starts scroll value
   * monitoring
   * @param {ReactComponent} nextComponent component instance to render
   * @param {DOMElement} container container to render into
   * @return {string} reactRoot ID prefix
   */
  _registerComponent: function (nextComponent, container) {
    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : invariant(false) : undefined;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();

    var reactRootID = ReactMount.registerContainer(container);
    instancesByReactRootID[reactRootID] = nextComponent;
    return reactRootID;
  },

  /**
   * Render a new component into the DOM.
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;

    var componentInstance = instantiateReactComponent(nextElement, null);
    var reactRootID = ReactMount._registerComponent(componentInstance, container);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, reactRootID, container, shouldReuseMarkup, context);

    if (false) {
      // Record the root element in case it later gets transplanted.
      rootElementsByReactRootID[reactRootID] = getReactRootElementInContainer(container);
    }

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && parentComponent._reactInternalInstance != null) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : invariant(false) : undefined;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing an element string, make sure to instantiate ' + 'it by passing it to React.createElement.' : typeof nextElement === 'function' ? ' Instead of passing a component class, make sure to instantiate ' + 'it by passing it to React.createElement.' :
    // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : invariant(false) : undefined;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : undefined;

    var nextWrappedElement = new ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);

    var prevComponent = instancesByReactRootID[getReactRootID(container)];

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : undefined;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : undefined;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, parentComponent != null ? parentComponent._reactInternalInstance._processChildContext(parentComponent._reactInternalInstance._context) : emptyObject)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Registers a container node into which React components will be rendered.
   * This also creates the "reactRoot" ID that will be assigned to the element
   * rendered within.
   *
   * @param {DOMElement} container DOM element to register as a container.
   * @return {string} The "reactRoot" ID of elements rendered within.
   */
  registerContainer: function (container) {
    var reactRootID = getReactRootID(container);
    if (reactRootID) {
      // If one exists, make sure it is a valid "reactRoot" ID.
      reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID);
    }
    if (!reactRootID) {
      // No valid "reactRoot" ID found, create one.
      reactRootID = ReactInstanceHandles.createReactRootID();
    }
    containersByReactRootID[reactRootID] = container;
    return reactRootID;
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;

    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : invariant(false) : undefined;

    var reactRootID = getReactRootID(container);
    var component = instancesByReactRootID[reactRootID];
    if (!component) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var containerID = internalGetID(container);
      var isContainerReactRoot = containerID && containerID === ReactInstanceHandles.getReactRootIDFromNodeID(containerID);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : undefined;
      }

      return false;
    }
    ReactUpdates.batchedUpdates(unmountComponentFromNode, component, container);
    delete instancesByReactRootID[reactRootID];
    delete containersByReactRootID[reactRootID];
    if (false) {
      delete rootElementsByReactRootID[reactRootID];
    }
    return true;
  },

  /**
   * Finds the container DOM element that contains React component to which the
   * supplied DOM `id` belongs.
   *
   * @param {string} id The ID of an element rendered by a React component.
   * @return {?DOMElement} DOM element that contains the `id`.
   */
  findReactContainerForID: function (id) {
    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(id);
    var container = containersByReactRootID[reactRootID];

    if (false) {
      var rootElement = rootElementsByReactRootID[reactRootID];
      if (rootElement && rootElement.parentNode !== container) {
        process.env.NODE_ENV !== 'production' ? warning(
        // Call internalGetID here because getID calls isValid which calls
        // findReactContainerForID (this function).
        internalGetID(rootElement) === reactRootID, 'ReactMount: Root element ID differed from reactRootID.') : undefined;
        var containerChild = container.firstChild;
        if (containerChild && reactRootID === internalGetID(containerChild)) {
          // If the container has a new child with the same ID as the old
          // root element, then rootElementsByReactRootID[reactRootID] is
          // just stale and needs to be updated. The case that deserves a
          // warning is when the container is empty.
          rootElementsByReactRootID[reactRootID] = containerChild;
        } else {
          process.env.NODE_ENV !== 'production' ? warning(false, 'ReactMount: Root element has been removed from its original ' + 'container. New container: %s', rootElement.parentNode) : undefined;
        }
      }
    }

    return container;
  },

  /**
   * Finds an element rendered by React with the supplied ID.
   *
   * @param {string} id ID of a DOM node in the React component.
   * @return {DOMElement} Root DOM node of the React component.
   */
  findReactNodeByID: function (id) {
    var reactRoot = ReactMount.findReactContainerForID(id);
    return ReactMount.findComponentRoot(reactRoot, id);
  },

  /**
   * Traverses up the ancestors of the supplied node to find a node that is a
   * DOM representation of a React component rendered by this copy of React.
   *
   * @param {*} node
   * @return {?DOMEventTarget}
   * @internal
   */
  getFirstReactDOM: function (node) {
    return findFirstReactDOMImpl(node);
  },

  /**
   * Finds a node with the supplied `targetID` inside of the supplied
   * `ancestorNode`.  Exploits the ID naming scheme to perform the search
   * quickly.
   *
   * @param {DOMEventTarget} ancestorNode Search from this root.
   * @pararm {string} targetID ID of the DOM representation of the component.
   * @return {DOMEventTarget} DOM node with the supplied `targetID`.
   * @internal
   */
  findComponentRoot: function (ancestorNode, targetID) {
    var firstChildren = findComponentRootReusableArray;
    var childIndex = 0;

    var deepestAncestor = findDeepestCachedAncestor(targetID) || ancestorNode;

    if (false) {
      // This will throw on the next line; give an early warning
      process.env.NODE_ENV !== 'production' ? warning(deepestAncestor != null, 'React can\'t find the root component node for data-reactid value ' + '`%s`. If you\'re seeing this message, it probably means that ' + 'you\'ve loaded two copies of React on the page. At this time, only ' + 'a single copy of React can be loaded at a time.', targetID) : undefined;
    }

    firstChildren[0] = deepestAncestor.firstChild;
    firstChildren.length = 1;

    while (childIndex < firstChildren.length) {
      var child = firstChildren[childIndex++];
      var targetChild;

      while (child) {
        var childID = ReactMount.getID(child);
        if (childID) {
          // Even if we find the node we're looking for, we finish looping
          // through its siblings to ensure they're cached so that we don't have
          // to revisit this node again. Otherwise, we make n^2 calls to getID
          // when visiting the many children of a single node in order.

          if (targetID === childID) {
            targetChild = child;
          } else if (ReactInstanceHandles.isAncestorIDOf(childID, targetID)) {
            // If we find a child whose ID is an ancestor of the given ID,
            // then we can be sure that we only want to search the subtree
            // rooted at this child, so we can throw out the rest of the
            // search state.
            firstChildren.length = childIndex = 0;
            firstChildren.push(child.firstChild);
          }
        } else {
          // If this child had no ID, then there's a chance that it was
          // injected automatically by the browser, as when a `<table>`
          // element sprouts an extra `<tbody>` child as a side effect of
          // `.innerHTML` parsing. Optimistically continue down this
          // branch, but not before examining the other siblings.
          firstChildren.push(child.firstChild);
        }

        child = child.nextSibling;
      }

      if (targetChild) {
        // Emptying firstChildren/findComponentRootReusableArray is
        // not necessary for correctness, but it helps the GC reclaim
        // any nodes that were left at the end of the search.
        firstChildren.length = 0;

        return targetChild;
      }
    }

    firstChildren.length = 0;

     true ?  false ? invariant(false, 'findComponentRoot(..., %s): Unable to find element. This probably ' + 'means the DOM was unexpectedly mutated (e.g., by the browser), ' + 'usually due to forgetting a <tbody> when using tables, nesting tags ' + 'like <form>, <p>, or <a>, or using non-SVG elements in an <svg> ' + 'parent. ' + 'Try inspecting the child nodes of the element with React ID `%s`.', targetID, ReactMount.getID(ancestorNode)) : invariant(false) : undefined;
  },

  _mountImageIntoNode: function (markup, container, shouldReuseMarkup, transaction) {
    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : invariant(false) : undefined;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using ' + 'server rendering but the checksum was invalid. This usually ' + 'means you rendered a different component type or props on ' + 'the client from the one on the server, or your render() ' + 'methods are impure. React cannot handle this case due to ' + 'cross-browser quirks by rendering at the document root. You ' + 'should look for environment dependent code in your components ' + 'and ensure the props are the same client and server side:\n%s', difference) : invariant(false) : undefined;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : undefined;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but ' + 'you didn\'t use server rendering. We can\'t do this ' + 'without using server rendering due to cross-browser quirks. ' + 'See ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      container.appendChild(markup);
    } else {
      setInnerHTML(container, markup);
    }
  },

  ownerDocumentContextKey: ownerDocumentContextKey,

  /**
   * React ID utilities.
   */

  getReactRootID: getReactRootID,

  getID: getID,

  setID: setID,

  getNode: getNode,

  getNodeFromInstance: getNodeFromInstance,

  isValid: isValid,

  purgeID: purgeID
};

ReactPerf.measureMethods(ReactMount, 'ReactMount', {
  _renderNewRootComponent: '_renderNewRootComponent',
  _mountImageIntoNode: '_mountImageIntoNode'
});

module.exports = ReactMount;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6dcb91b75d8e8ac33ed6d971faab30eb.png";

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactElement
 */



var ReactCurrentOwner = __webpack_require__(25);

var assign = __webpack_require__(8);
var canDefineProperty = __webpack_require__(80);

// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

/**
 * Base constructor for all React elements. This is only used to make this
 * work with a dynamic instanceof check. Nothing should live on this prototype.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    Object.freeze(element.props);
    Object.freeze(element);
  }

  return element;
};

ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    ref = config.ref === undefined ? null : config.ref;
    key = config.key === undefined ? null : '' + config.key;
    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (typeof props[propName] === 'undefined') {
        props[propName] = defaultProps[propName];
      }
    }
  }

  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

ReactElement.cloneAndReplaceProps = function (oldElement, newProps) {
  var newElement = ReactElement(oldElement.type, oldElement.key, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, newProps);

  if (false) {
    // If the key on the original is valid, then the clone is valid
    newElement._store.validated = oldElement._store.validated;
  }

  return newElement;
};

ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (config.ref !== undefined) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (config.key !== undefined) {
      key = '' + config.key;
    }
    // Remaining properties override existing props
    for (propName in config) {
      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPerf
 * @typechecks static-only
 */



/**
 * ReactPerf is a general AOP system designed to measure performance. This
 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
 */
var ReactPerf = {
  /**
   * Boolean to enable/disable measurement. Set to false by default to prevent
   * accidental logging and perf loss.
   */
  enableMeasure: false,

  /**
   * Holds onto the measure function in use. By default, don't measure
   * anything, but we'll override this if we inject a measure function.
   */
  storedMeasure: _noMeasure,

  /**
   * @param {object} object
   * @param {string} objectName
   * @param {object<string>} methodNames
   */
  measureMethods: function (object, objectName, methodNames) {
    if (false) {
      for (var key in methodNames) {
        if (!methodNames.hasOwnProperty(key)) {
          continue;
        }
        object[key] = ReactPerf.measure(objectName, methodNames[key], object[key]);
      }
    }
  },

  /**
   * Use this to wrap methods you want to measure. Zero overhead in production.
   *
   * @param {string} objName
   * @param {string} fnName
   * @param {function} func
   * @return {function}
   */
  measure: function (objName, fnName, func) {
    if (false) {
      var measuredFunc = null;
      var wrapper = function () {
        if (ReactPerf.enableMeasure) {
          if (!measuredFunc) {
            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
          }
          return measuredFunc.apply(this, arguments);
        }
        return func.apply(this, arguments);
      };
      wrapper.displayName = objName + '_' + fnName;
      return wrapper;
    }
    return func;
  },

  injection: {
    /**
     * @param {function} measure
     */
    injectMeasure: function (measure) {
      ReactPerf.storedMeasure = measure;
    }
  }
};

/**
 * Simply passes through the measured function, without measuring it.
 *
 * @param {string} objName
 * @param {string} fnName
 * @param {function} func
 * @return {function}
 */
function _noMeasure(objName, fnName, func) {
  return func;
}

module.exports = ReactPerf;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactUpdates
 */



var CallbackQueue = __webpack_require__(114);
var PooledClass = __webpack_require__(31);
var ReactPerf = __webpack_require__(19);
var ReactReconciler = __webpack_require__(39);
var Transaction = __webpack_require__(81);

var assign = __webpack_require__(8);
var invariant = __webpack_require__(2);

var dirtyComponents = [];
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching ' + 'strategy') : invariant(false) : undefined;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled( /* forceHTML */false);
}

assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to ' + 'match dirty-components array length (%s).', len, dirtyComponents.length) : invariant(false) : undefined;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction);

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};
flushBatchedUpdates = ReactPerf.measure('ReactUpdates', 'flushBatchedUpdates', flushBatchedUpdates);

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setProps, setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' + 'updates are not being batched.') : invariant(false) : undefined;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : invariant(false) : undefined;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : invariant(false) : undefined;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : invariant(false) : undefined;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : invariant(false) : undefined;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule emptyFunction
 */



function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
function emptyFunction() {}

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var _grade = __webpack_require__(267);

var _grade2 = _interopRequireDefault(_grade);

var _gender = __webpack_require__(458);

var _gender2 = _interopRequireDefault(_gender);

var _Image = __webpack_require__(257);

var _Image2 = _interopRequireDefault(_Image);

var _vip = __webpack_require__(461);

var _vip2 = _interopRequireDefault(_vip);

var _officialAuth = __webpack_require__(463);

var _officialAuth2 = _interopRequireDefault(_officialAuth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
	Grade: _grade2.default,
	Gender: _gender2.default,
	ImageView: _Image2.default,
	VIP: _vip2.default,
	OfficialAuth: _officialAuth2.default
};

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(369);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(195);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_1__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(383);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexLink", function() { return __WEBPACK_IMPORTED_MODULE_2__IndexLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(384);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__withRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(386);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRedirect", function() { return __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(387);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRoute", function() { return __WEBPACK_IMPORTED_MODULE_5__IndexRoute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(196);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(388);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(34);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createRoutes", function() { return __WEBPACK_IMPORTED_MODULE_8__RouteUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RouterContext", function() { return __WEBPACK_IMPORTED_MODULE_9__RouterContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "locationShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(389);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "match", function() { return __WEBPACK_IMPORTED_MODULE_11__match__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(199);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useRouterHistory", function() { return __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(50);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatPattern", function() { return __WEBPACK_IMPORTED_MODULE_13__PatternUtils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(393);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyRouterMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(394);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "browserHistory", function() { return __WEBPACK_IMPORTED_MODULE_15__browserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(396);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hashHistory", function() { return __WEBPACK_IMPORTED_MODULE_16__hashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMemoryHistory", function() { return __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__["a"]; });
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(370);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactCurrentOwner
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {

  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null

};

module.exports = ReactCurrentOwner;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventConstants
 */



var keyMirror = __webpack_require__(76);

var PropagationPhases = keyMirror({ bubbled: null, captured: null });

/**
 * Types of raw signals from the browser caught at the top level.
 */
var topLevelTypes = keyMirror({
  topAbort: null,
  topBlur: null,
  topCanPlay: null,
  topCanPlayThrough: null,
  topChange: null,
  topClick: null,
  topCompositionEnd: null,
  topCompositionStart: null,
  topCompositionUpdate: null,
  topContextMenu: null,
  topCopy: null,
  topCut: null,
  topDoubleClick: null,
  topDrag: null,
  topDragEnd: null,
  topDragEnter: null,
  topDragExit: null,
  topDragLeave: null,
  topDragOver: null,
  topDragStart: null,
  topDrop: null,
  topDurationChange: null,
  topEmptied: null,
  topEncrypted: null,
  topEnded: null,
  topError: null,
  topFocus: null,
  topInput: null,
  topKeyDown: null,
  topKeyPress: null,
  topKeyUp: null,
  topLoad: null,
  topLoadedData: null,
  topLoadedMetadata: null,
  topLoadStart: null,
  topMouseDown: null,
  topMouseMove: null,
  topMouseOut: null,
  topMouseOver: null,
  topMouseUp: null,
  topPaste: null,
  topPause: null,
  topPlay: null,
  topPlaying: null,
  topProgress: null,
  topRateChange: null,
  topReset: null,
  topScroll: null,
  topSeeked: null,
  topSeeking: null,
  topSelectionChange: null,
  topStalled: null,
  topSubmit: null,
  topSuspend: null,
  topTextInput: null,
  topTimeUpdate: null,
  topTouchCancel: null,
  topTouchEnd: null,
  topTouchMove: null,
  topTouchStart: null,
  topVolumeChange: null,
  topWaiting: null,
  topWheel: null
});

var EventConstants = {
  topLevelTypes: topLevelTypes,
  PropagationPhases: PropagationPhases
};

module.exports = EventConstants;

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(482);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Tooltip__["a" /* default */]);

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(146);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(513);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(517);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(146);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule PooledClass
 */



var invariant = __webpack_require__(2);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4, a5);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4, a5);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : invariant(false) : undefined;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances (optional).
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler,
  fiveArgumentPooler: fiveArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyOf
 */

/**
 * Allows extraction of a minified key. Let's the build system minify keys
 * without losing the ability to dynamically use key strings as values
 * themselves. Pass in an object with a single key/val pair and it will return
 * you the string key of that single record. Suppose you want to grab the
 * value for a key 'className' inside of an object. Key/val minification may
 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
 * reuse those resolutions.
 */


var keyOf = function (oneKeyObj) {
  var key;
  for (key in oneKeyObj) {
    if (!oneKeyObj.hasOwnProperty(key)) {
      continue;
    }
    return key;
  }
  return null;
};

module.exports = keyOf;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["b"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 37 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(72)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactReconciler
 */



var ReactRef = __webpack_require__(311);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {string} rootID DOM ID of the root node.
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, rootID, transaction, context) {
    var markup = internalInstance.mountComponent(rootID, transaction, context);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    return markup;
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance) {
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent();
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction) {
    internalInstance.performUpdateIfNecessary(transaction);
  }

};

module.exports = ReactReconciler;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticEvent
 * @typechecks static-only
 */



var PooledClass = __webpack_require__(31);

var assign = __webpack_require__(8);
var emptyFunction = __webpack_require__(21);
var warning = __webpack_require__(7);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 */
function SyntheticEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  this.dispatchConfig = dispatchConfig;
  this.dispatchMarker = dispatchMarker;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
}

assign(SyntheticEvent.prototype, {

  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `preventDefault` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
    }
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
    } else {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `stopPropagation` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
    }
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
    } else {
      event.cancelBubble = true;
    }
    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      this[propName] = null;
    }
    this.dispatchConfig = null;
    this.dispatchMarker = null;
    this.nativeEvent = null;
  }

});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var prototype = Object.create(Super.prototype);
  assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(15);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(35);

var _Actions = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(71);
var IE8_DOM_DEFINE = __webpack_require__(211);
var toPrimitive = __webpack_require__(138);
var dP = Object.defineProperty;

exports.f = __webpack_require__(38) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NumberUtil = {
    /**
     * 补0
     * @param  {Number} num    [要处理的数字]
     * @param  {Number} digits [要处理的位数]
     * @example
     *      prefixedNum(1,1); // 01
     *      prefixedNum(1,2); // 001
     */
    prefixed: function prefixed(num, digits) {
        var zeroStr = [];
        num = typeof num == 'undefined' ? '' : num;
        for (var i = 0; i < digits; ++i) {
            zeroStr.push(0);
        }

        return zeroStr.join('').substr(0, digits - num.toString().length) + num;
    },
    /**
     * 分隔数字
     * @param  {String|Number} str       [要处理的数字]
     * @param  {String} separator [分隔符号]
     * @example
     *      getSeparatedNum('900020'); // 900,020
     */
    separate: function separate(str, separator) {
        str = (typeof str == 'undefined' ? '' : str) + '';
        separator = separator || ',';

        return str.replace(/(\d+)(\.\d+)?/g, function (num, a, b) {
            return (a.length > 3 ? a.indexOf(separator) < 0 || a.indexOf(separator) > 3 ? a.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") : a : a) + (b || '');
        });
    },

    formatDiffTime: function formatDiffTime(timeDifference, formatPattern) {
        var self = this;
        var oriFormatPattern = formatPattern,
            timeSlices;
        formatPattern = formatPattern || 'd天h小时m分s秒';
        timeSlices = [{
            pattern: /d+/g,
            rate: 24 * 60 * 60 * 1000
        }, {
            pattern: /h+/g,
            rate: 60 * 60 * 1000
        }, {
            pattern: /m+/g,
            rate: 60 * 1000
        }, {
            pattern: /s+/g,
            rate: 1000
        }, {
            pattern: /f+/g,
            rate: 1
        }];

        for (var i = 0; i < timeSlices.length; ++i) {
            timeSlices[i].value = timeDifference;
            for (var j = 0; j < i; ++j) {
                if (formatPattern.match(timeSlices[j].pattern)) {
                    timeSlices[i].value -= timeSlices[j].value * timeSlices[j].rate;
                }
            }
            timeSlices[i].value = Math.floor(timeSlices[i].value / timeSlices[i].rate);
        }

        for (var i = 0; i < timeSlices.length; ++i) {
            formatPattern = formatPattern.replace(timeSlices[i].pattern, function (matchStr) {
                var subLen = Math.min(matchStr.length, i == 0 ? Infinity : i == 4 ? 3 : 2);
                return self.prefixed(timeSlices[i].value, subLen);
            });
        }

        formatPattern = oriFormatPattern ? formatPattern : formatPattern.replace(/(\d+)(?:天|小时|分|秒|毫秒)/g, function (matchStr, num) {
            return Number(num) ? matchStr : '';
        });

        return formatPattern;
    },

    getDiffTime: function getDiffTime(time) {
        // var now = new Date().getTime();
        // var t;
        // if (typeof time == 'number') {
        //     t = new Date(parseInt(time));
        // } else if (typeof time == 'string') {
        //     t = Number(time) ? arguments.callee(parseInt(time)) : new Date(time.replace(/-/g, '/'));
        // }
        // var val = Math.floor((now - t) / 1000);
        var val = time / 1000;
        var result = '';

        var timeMap = {
            'y': {
                rate: 60 * 60 * 24 * 365
            },
            'M': {
                rate: 60 * 60 * 24 * 30
            },
            'd': {
                rate: 60 * 60 * 24
            },
            'h': {
                rate: 60 * 60
            },
            'm': {
                rate: 60
            }
        };

        for (var i in timeMap) {
            timeMap[i].value = Math.floor(val / timeMap[i].rate);
        }

        if (timeMap['y'].value > 0) {
            result = _lang2.default.template('<%=num%>年前', { num: timeMap['y'].value });
        } else if (timeMap['M'].value > 0) {
            result = _lang2.default.template('<%=num%>月前', { num: timeMap['M'].value });
        } else if (timeMap['d'].value > 0) {
            result = _lang2.default.template('<%=num%>天前', { num: timeMap['d'].value });
        } else if (timeMap['h'].value > 0) {
            result = _lang2.default.template('<%=num%>小时前', { num: timeMap['h'].value });
        } else if (timeMap['m'].value > 0) {
            result = _lang2.default.template('<%=num%>分钟前', { num: timeMap['m'].value });
        } else {
            result = _lang2.default.template('刚刚');
        }
        return result;
    },

    uuid: function uuid(len, radix) {
        var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
        var uuid = [],
            i;
        radix = radix || chars.length;

        if (len) {
            // Compact form
            for (i = 0; i < len; i++) {
                uuid[i] = chars[0 | Math.random() * radix];
            }
        } else {
            // rfc4122, version 4 form
            var r;

            // rfc4122 requires these characters
            uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
            uuid[14] = '4';

            // Fill in random data.  At i==19 set the high bits of clock sequence as
            // per rfc4122, sec. 4.1.5
            for (i = 0; i < 36; i++) {
                if (!uuid[i]) {
                    r = 0 | Math.random() * 16;
                    uuid[i] = chars[i == 19 ? r & 0x3 | 0x8 : r];
                }
            }
        }

        return uuid.join('');
    }
};

exports.default = NumberUtil;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingTip = function (_Component) {
    _inherits(LoadingTip, _Component);

    function LoadingTip() {
        _classCallCheck(this, LoadingTip);

        return _possibleConstructorReturn(this, (LoadingTip.__proto__ || Object.getPrototypeOf(LoadingTip)).apply(this, arguments));
    }

    _createClass(LoadingTip, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'mini-loading' },
                _react2.default.createElement(
                    'div',
                    { className: 'loading-tip' },
                    _lang2.default.template('正在加载'),
                    _react2.default.createElement(
                        'em',
                        null,
                        '.'
                    ),
                    _react2.default.createElement(
                        'em',
                        null,
                        '.'
                    ),
                    _react2.default.createElement(
                        'em',
                        null,
                        '.'
                    )
                )
            );
        }
    }]);

    return LoadingTip;
}(_react.Component);

exports.default = LoadingTip;

/***/ }),
/* 46 */
/***/ (function(module, exports) {



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * pbajax模块(用于pb接口交互)
 * @author zhenn
 * @time 2016-11-16
 */
var proxyUrl = {
    pro: 'https://sg-proxy.upliveapp.com/index/index',
    dev: 'http://awsbj-proxy.pengpengla.com/index/index',
    stage: 'https://sg-stage-proxy.upliveapp.com/index/index'
};

// let pbajax = {

//     canceled: 0, // 是否被取消

//     do(cfg, data, success = () => {}, timeout = () => {}, fail = () => {}) {
//         let prefix = proxyUrl[pbajax.env()];
//         let _url = prefix + '?' + $.param(cfg);
//         let timer, xhr;
//         this.canceled = 0;
//         timer = setTimeout(function() {
//             timeout();
//         }, 5000);

//         try {
//             xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
//             xhr.open("POST", _url, true);
//             xhr.responseType = "arraybuffer";

//             try {
//                 xhr.send(data.toArrayBuffer());
//             } catch (e) {
//                 xhr.send();
//             }
//         } catch (e) {
//             alert('please upgrade your brower, such as chrome!');
//         }

//         xhr.onreadystatechange = (data)=>{

//             if (xhr.readyState == 4) {
//                 if (xhr.status == 200) {
//                     clearTimeout(timer);
//                     if (!this.canceled) {
//                         success(xhr.response);
//                     }

//                 } else {
//                     if (typeof fail == 'function') {
//                         fail();
//                     }
//                 }
//             }
//         }


//     },
//     query(name, scope) {
//         var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
//             scope = scope || 'search',
//             r = location[scope].substr(1).match(reg);
//         if (r != null) {
//             return unescape(r[2]);
//         }
//         return null;
//     },

//     env() {
//         return this.query('env') || 'pro';
//     },

//     serializeURI(obj) {
//         var result = [];
//         if (typeof obj != 'object') {
//             obj = {};
//         }
//         for (var i in obj) {
//             result.push(i + '=' + encodeURIComponent(obj[i]));
//         }

//         return result.join('&')
//     },

//     cancel() {
//         this.canceled = 1;
//     }
// };

// export default pbajax;


var PbAajx = function () {
    function PbAajx() {
        _classCallCheck(this, PbAajx);

        this.canceled = 0;
    }

    // canceled: 0, // 是否被取消

    _createClass(PbAajx, [{
        key: 'do',
        value: function _do(cfg, data) {
            var success = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

            var _this = this;

            var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
            var fail = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};

            var prefix = proxyUrl[this.env()] || 'pro';
            var _url = prefix + '?' + $.param(cfg);
            var timer = void 0,
                xhr = void 0;
            timer = setTimeout(function () {
                timeout();
            }, 10000);

            try {
                xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
                xhr.open("POST", _url, true);
                xhr.responseType = "arraybuffer";

                try {
                    xhr.send(data.toArrayBuffer());
                } catch (e) {
                    xhr.send();
                }
            } catch (e) {
                alert('please upgrade your brower, such as chrome!');
            }

            xhr.onreadystatechange = function (data) {

                if (xhr.readyState == 4) {
                    if (xhr.status == 200) {
                        clearTimeout(timer);
                        if (!_this.canceled) {
                            success(xhr.response);
                        }
                    } else {
                        if (typeof fail == 'function') {
                            fail();
                        }
                    }
                }
            };
        }
    }, {
        key: 'query',
        value: function query(name, scope) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
                scope = scope || 'search',
                r = location[scope].substr(1).match(reg);
            if (r != null) {
                return unescape(r[2]);
            }
            return null;
        }
    }, {
        key: 'env',
        value: function env() {
            return this.query('env') || 'pro';
        }
    }, {
        key: 'serializeURI',
        value: function serializeURI(obj) {
            var result = [];
            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) != 'object') {
                obj = {};
            }
            for (var i in obj) {
                result.push(i + '=' + encodeURIComponent(obj[i]));
            }

            return result.join('&');
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.canceled = 1;
        }
    }]);

    return PbAajx;
}();

exports.default = PbAajx;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DOMProperty
 * @typechecks static-only
 */



var invariant = __webpack_require__(2);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_ATTRIBUTE: 0x1,
  MUST_USE_PROPERTY: 0x2,
  HAS_SIDE_EFFECTS: 0x4,
  HAS_BOOLEAN_VALUE: 0x8,
  HAS_NUMERIC_VALUE: 0x10,
  HAS_POSITIVE_NUMERIC_VALUE: 0x20 | 0x10,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x40,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' + '\'%s\' which has already been injected. You may be accidentally ' + 'injecting the same DOM property config twice, or you may be ' + 'injecting two configs that have conflicting property names.', propName) : invariant(false) : undefined;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseAttribute: checkMask(propConfig, Injection.MUST_USE_ATTRIBUTE),
        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasSideEffects: checkMask(propConfig, Injection.HAS_SIDE_EFFECTS),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };

      !(!propertyInfo.mustUseAttribute || !propertyInfo.mustUseProperty) ?  false ? invariant(false, 'DOMProperty: Cannot require using both attribute and property: %s', propName) : invariant(false) : undefined;
      !(propertyInfo.mustUseProperty || !propertyInfo.hasSideEffects) ?  false ? invariant(false, 'DOMProperty: Properties that have side effects must use property: %s', propName) : invariant(false) : undefined;
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or ' + 'numeric value, but not a combination: %s', propName) : invariant(false) : undefined;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};
var defaultValueCache = {};

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {

  ID_ATTRIBUTE_NAME: 'data-reactid',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseAttribute:
   *   Whether the property must be accessed and mutated using `*Attribute()`.
   *   (This includes anything that fails `<propName> in <element>`.)
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasSideEffects:
   *   Whether or not setting a value causes side effects such as triggering
   *   resources to be loaded or text selection changes. If true, we read from
   *   the DOM before updating to ensure that the value is only set if it has
   *   changed.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   * @type {Object}
   */
  getPossibleStandardName:  false ? {} : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  /**
   * Returns the default property value for a DOM property (i.e., not an
   * attribute). Most default values are '' or false, but not all. Worse yet,
   * some (in particular, `type`) vary depending on the type of element.
   *
   * TODO: Is it better to grab all the possible properties when creating an
   * element to avoid having to create the same element twice?
   */
  getDefaultValueForProperty: function (nodeName, prop) {
    var nodeDefaults = defaultValueCache[nodeName];
    var testElement;
    if (!nodeDefaults) {
      defaultValueCache[nodeName] = nodeDefaults = {};
    }
    if (!(prop in nodeDefaults)) {
      testElement = document.createElement(nodeName);
      nodeDefaults[prop] = testElement[prop];
    }
    return nodeDefaults[prop];
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInstanceHandles
 * @typechecks static-only
 */



var ReactRootIndex = __webpack_require__(170);

var invariant = __webpack_require__(2);

var SEPARATOR = '.';
var SEPARATOR_LENGTH = SEPARATOR.length;

/**
 * Maximum depth of traversals before we consider the possibility of a bad ID.
 */
var MAX_TREE_DEPTH = 10000;

/**
 * Creates a DOM ID prefix to use when mounting React components.
 *
 * @param {number} index A unique integer
 * @return {string} React root ID.
 * @internal
 */
function getReactRootIDString(index) {
  return SEPARATOR + index.toString(36);
}

/**
 * Checks if a character in the supplied ID is a separator or the end.
 *
 * @param {string} id A React DOM ID.
 * @param {number} index Index of the character to check.
 * @return {boolean} True if the character is a separator or end of the ID.
 * @private
 */
function isBoundary(id, index) {
  return id.charAt(index) === SEPARATOR || index === id.length;
}

/**
 * Checks if the supplied string is a valid React DOM ID.
 *
 * @param {string} id A React DOM ID, maybe.
 * @return {boolean} True if the string is a valid React DOM ID.
 * @private
 */
function isValidID(id) {
  return id === '' || id.charAt(0) === SEPARATOR && id.charAt(id.length - 1) !== SEPARATOR;
}

/**
 * Checks if the first ID is an ancestor of or equal to the second ID.
 *
 * @param {string} ancestorID
 * @param {string} descendantID
 * @return {boolean} True if `ancestorID` is an ancestor of `descendantID`.
 * @internal
 */
function isAncestorIDOf(ancestorID, descendantID) {
  return descendantID.indexOf(ancestorID) === 0 && isBoundary(descendantID, ancestorID.length);
}

/**
 * Gets the parent ID of the supplied React DOM ID, `id`.
 *
 * @param {string} id ID of a component.
 * @return {string} ID of the parent, or an empty string.
 * @private
 */
function getParentID(id) {
  return id ? id.substr(0, id.lastIndexOf(SEPARATOR)) : '';
}

/**
 * Gets the next DOM ID on the tree path from the supplied `ancestorID` to the
 * supplied `destinationID`. If they are equal, the ID is returned.
 *
 * @param {string} ancestorID ID of an ancestor node of `destinationID`.
 * @param {string} destinationID ID of the destination node.
 * @return {string} Next ID on the path from `ancestorID` to `destinationID`.
 * @private
 */
function getNextDescendantID(ancestorID, destinationID) {
  !(isValidID(ancestorID) && isValidID(destinationID)) ?  false ? invariant(false, 'getNextDescendantID(%s, %s): Received an invalid React DOM ID.', ancestorID, destinationID) : invariant(false) : undefined;
  !isAncestorIDOf(ancestorID, destinationID) ?  false ? invariant(false, 'getNextDescendantID(...): React has made an invalid assumption about ' + 'the DOM hierarchy. Expected `%s` to be an ancestor of `%s`.', ancestorID, destinationID) : invariant(false) : undefined;
  if (ancestorID === destinationID) {
    return ancestorID;
  }
  // Skip over the ancestor and the immediate separator. Traverse until we hit
  // another separator or we reach the end of `destinationID`.
  var start = ancestorID.length + SEPARATOR_LENGTH;
  var i;
  for (i = start; i < destinationID.length; i++) {
    if (isBoundary(destinationID, i)) {
      break;
    }
  }
  return destinationID.substr(0, i);
}

/**
 * Gets the nearest common ancestor ID of two IDs.
 *
 * Using this ID scheme, the nearest common ancestor ID is the longest common
 * prefix of the two IDs that immediately preceded a "marker" in both strings.
 *
 * @param {string} oneID
 * @param {string} twoID
 * @return {string} Nearest common ancestor ID, or the empty string if none.
 * @private
 */
function getFirstCommonAncestorID(oneID, twoID) {
  var minLength = Math.min(oneID.length, twoID.length);
  if (minLength === 0) {
    return '';
  }
  var lastCommonMarkerIndex = 0;
  // Use `<=` to traverse until the "EOL" of the shorter string.
  for (var i = 0; i <= minLength; i++) {
    if (isBoundary(oneID, i) && isBoundary(twoID, i)) {
      lastCommonMarkerIndex = i;
    } else if (oneID.charAt(i) !== twoID.charAt(i)) {
      break;
    }
  }
  var longestCommonID = oneID.substr(0, lastCommonMarkerIndex);
  !isValidID(longestCommonID) ?  false ? invariant(false, 'getFirstCommonAncestorID(%s, %s): Expected a valid React DOM ID: %s', oneID, twoID, longestCommonID) : invariant(false) : undefined;
  return longestCommonID;
}

/**
 * Traverses the parent path between two IDs (either up or down). The IDs must
 * not be the same, and there must exist a parent path between them. If the
 * callback returns `false`, traversal is stopped.
 *
 * @param {?string} start ID at which to start traversal.
 * @param {?string} stop ID at which to end traversal.
 * @param {function} cb Callback to invoke each ID with.
 * @param {*} arg Argument to invoke the callback with.
 * @param {?boolean} skipFirst Whether or not to skip the first node.
 * @param {?boolean} skipLast Whether or not to skip the last node.
 * @private
 */
function traverseParentPath(start, stop, cb, arg, skipFirst, skipLast) {
  start = start || '';
  stop = stop || '';
  !(start !== stop) ?  false ? invariant(false, 'traverseParentPath(...): Cannot traverse from and to the same ID, `%s`.', start) : invariant(false) : undefined;
  var traverseUp = isAncestorIDOf(stop, start);
  !(traverseUp || isAncestorIDOf(start, stop)) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Cannot traverse from two IDs that do ' + 'not have a parent path.', start, stop) : invariant(false) : undefined;
  // Traverse from `start` to `stop` one depth at a time.
  var depth = 0;
  var traverse = traverseUp ? getParentID : getNextDescendantID;
  for (var id = start;; /* until break */id = traverse(id, stop)) {
    var ret;
    if ((!skipFirst || id !== start) && (!skipLast || id !== stop)) {
      ret = cb(id, traverseUp, arg);
    }
    if (ret === false || id === stop) {
      // Only break //after// visiting `stop`.
      break;
    }
    !(depth++ < MAX_TREE_DEPTH) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Detected an infinite loop while ' + 'traversing the React DOM ID tree. This may be due to malformed IDs: %s', start, stop, id) : invariant(false) : undefined;
  }
}

/**
 * Manages the IDs assigned to DOM representations of React components. This
 * uses a specific scheme in order to traverse the DOM efficiently (e.g. in
 * order to simulate events).
 *
 * @internal
 */
var ReactInstanceHandles = {

  /**
   * Constructs a React root ID
   * @return {string} A React root ID.
   */
  createReactRootID: function () {
    return getReactRootIDString(ReactRootIndex.createReactRootIndex());
  },

  /**
   * Constructs a React ID by joining a root ID with a name.
   *
   * @param {string} rootID Root ID of a parent component.
   * @param {string} name A component's name (as flattened children).
   * @return {string} A React ID.
   * @internal
   */
  createReactID: function (rootID, name) {
    return rootID + name;
  },

  /**
   * Gets the DOM ID of the React component that is the root of the tree that
   * contains the React component with the supplied DOM ID.
   *
   * @param {string} id DOM ID of a React component.
   * @return {?string} DOM ID of the React component that is the root.
   * @internal
   */
  getReactRootIDFromNodeID: function (id) {
    if (id && id.charAt(0) === SEPARATOR && id.length > 1) {
      var index = id.indexOf(SEPARATOR, 1);
      return index > -1 ? id.substr(0, index) : id;
    }
    return null;
  },

  /**
   * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
   * should would receive a `mouseEnter` or `mouseLeave` event.
   *
   * NOTE: Does not invoke the callback on the nearest common ancestor because
   * nothing "entered" or "left" that element.
   *
   * @param {string} leaveID ID being left.
   * @param {string} enterID ID being entered.
   * @param {function} cb Callback to invoke on each entered/left ID.
   * @param {*} upArg Argument to invoke the callback with on left IDs.
   * @param {*} downArg Argument to invoke the callback with on entered IDs.
   * @internal
   */
  traverseEnterLeave: function (leaveID, enterID, cb, upArg, downArg) {
    var ancestorID = getFirstCommonAncestorID(leaveID, enterID);
    if (ancestorID !== leaveID) {
      traverseParentPath(leaveID, ancestorID, cb, upArg, false, true);
    }
    if (ancestorID !== enterID) {
      traverseParentPath(ancestorID, enterID, cb, downArg, true, false);
    }
  },

  /**
   * Simulates the traversal of a two-phase, capture/bubble event dispatch.
   *
   * NOTE: This traversal happens on IDs without touching the DOM.
   *
   * @param {string} targetID ID of the target node.
   * @param {function} cb Callback to invoke.
   * @param {*} arg Argument to invoke the callback with.
   * @internal
   */
  traverseTwoPhase: function (targetID, cb, arg) {
    if (targetID) {
      traverseParentPath('', targetID, cb, arg, true, false);
      traverseParentPath(targetID, '', cb, arg, false, true);
    }
  },

  /**
   * Same as `traverseTwoPhase` but skips the `targetID`.
   */
  traverseTwoPhaseSkipTarget: function (targetID, cb, arg) {
    if (targetID) {
      traverseParentPath('', targetID, cb, arg, true, true);
      traverseParentPath(targetID, '', cb, arg, true, true);
    }
  },

  /**
   * Traverse a node ID, calling the supplied `cb` for each ancestor ID. For
   * example, passing `.0.$row-0.1` would result in `cb` getting called
   * with `.0`, `.0.$row-0`, and `.0.$row-0.1`.
   *
   * NOTE: This traversal happens on IDs without touching the DOM.
   *
   * @param {string} targetID ID of the target node.
   * @param {function} cb Callback to invoke.
   * @param {*} arg Argument to invoke the callback with.
   * @internal
   */
  traverseAncestors: function (targetID, cb, arg) {
    traverseParentPath('', targetID, cb, arg, true, false);
  },

  getFirstCommonAncestorID: getFirstCommonAncestorID,

  /**
   * Exposed for unit testing.
   * @private
   */
  _getNextDescendantID: getNextDescendantID,

  isAncestorIDOf: isAncestorIDOf,

  SEPARATOR: SEPARATOR

};

module.exports = ReactInstanceHandles;

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["c"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(36);
var core = __webpack_require__(37);
var ctx = __webpack_require__(210);
var hide = __webpack_require__(52);
var has = __webpack_require__(43);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(42);
var createDesc = __webpack_require__(91);
module.exports = __webpack_require__(38) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(214);
var defined = __webpack_require__(139);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(142)('wks');
var uid = __webpack_require__(94);
var Symbol = __webpack_require__(36).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    /**
     * @file 组件基类
     * @authors 子虔
     * @date    2014-05-12 17:39:36
     * @example <caption>扩展一个子类</caption>
     *      Base.extend({
     *          defaults: {}, // 设置类的默认参数
     *          constructor: function Widget(){
     *              // 子类的构造函数
     *          },
     *      });
     *
     */
    var Events = __webpack_require__(102),
        extend = __webpack_require__(104),
        attributes = __webpack_require__(106),
        isEqual = __webpack_require__(59),
        parseParam = __webpack_require__(58);

    /**
     * 组件Base类
     * @param {object} [Opts={}] - 入参
     */
    function Base(Opts) {
        // 默认配置
        this.defaults = this.defaults || {};

        // 用户配置
        this.config = Opts || {};

        // 最终配置
        this.attributes = $.extend({}, this.attributes || {}, this.defaults) || {};

        if (_typeof(this.config) == 'object') {
            this.attributes = $.extend(this.attributes, this.config) || {};
        }

        this.initialize.apply(this, arguments);
    }

    // 扩展
    $.extend(Base.prototype, Events, {
        /**
         * @constructs
         */
        constructor: Base,

        initialize: function initialize() {},

        /**
         * 频道
         * @deprecated - 当要被废弃
         */
        channel: Events.channel,

        /**
         * 获取配置
         * @param  {string} name - 名称
         * @return {*}
         */
        get: function get(name) {
            return this.attributes[name];
        },

        /**
         * 设置配置
         * @param {*} name  -属性名
         * @param {*} [value] [属性值]
         * @param {boolean} [silent=false] [变化时是否派发事件，默认派发]
         */
        set: function set(name, value, silent) {
            var lastValue;
            if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) == 'object') {
                silent = value;
                for (var key in name) {
                    if (name.hasOwnProperty(key)) {
                        this.set(key, name[key], silent);
                    }
                }
            } else {
                lastValue = this.attributes[name];
                this.attributes[name] = value;
                if (!silent && !isEqual(lastValue, value)) {
                    this.emit('change:' + name, value, lastValue);
                    this.emit('change');
                }
            }
        },

        /**
         * 重置配置
         * @param  {string[]} [whiteList=[]] - white list,不需要重置的list
         * @param  {boolean} [silent=false] - 是否不不派发事件
         */
        reset: function reset(whiteList, silent) {
            whiteList = whiteList || [];

            if (arguments.length > 1) {
                silent = !!whiteList;
            }

            this.defaults = this.defaults || {};

            for (var key in this.attributes) {
                if (this.attributes.hasOwnProperty(key) && whiteList.indexOf(key) == -1) {
                    this.set(key, this.defaults[key], silent);
                }
            }
        },
        /**
         * 销毁，默认移除事件
         */
        destroy: function destroy() {
            this.off();
        }
    });

    // 生成子类
    Base.extend = extend;

    // 修改原型
    Base.use = function (protoProps) {
        var that = this,
            protoProps = [].concat(protoProps);

        protoProps.forEach(function (proto) {
            for (var name in proto) {
                if (proto.hasOwnProperty(name)) {
                    that.prototype[name] = proto[name];
                }
            }
        });
        return this;
    };

    // 组件过滤参数
    Base.parseParam = function (protoProps) {
        var newBase;

        newBase = this.extend({
            /**
             * 过滤实例时的参数
             * @description 剔除非defaults定义的属性
             */
            initialize: function initialize() {
                this.attributes = parseParam(this.defaults || {}, this.attributes);
                this.Parent(initialize, arguments);
            }
        });

        return protoProps ? newBase.extend(protoProps) : newBase;
    };

    module.exports = Base.extend(attributes);
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 57 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * 三方授权配置
 */

// 授权回调域名

var cbHost = 'https://web.upliveapps.com';

// 碰碰在sns平台中信息
// key值为sourceid
var upInfoInSNS = {
    'wechat': {
        appId: 'wxbe95819b0e7499a9',
        appSecret: 'b34144895076ee00a3c2dd5c9bb2f3cb'
    },
    'fb': {
        appId: '1698316857098420'
    },
    'weibo': {
        appid: '3739970591'
    },
    google: {
        clientId: '810710132118-nhlomv7vpqsm6v2a0c9lsgkhbpd4c2qo.apps.googleusercontent.com'
    }
};

exports.cbHost = cbHost;
exports.upInfoInSNS = upInfoInSNS;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    /**
     * @file 合并参数
     * @author 子虔
     * @date    2014-08-15 17:43:36
     * @param  {Object}  to - 源
     * @param  {Object}  from - 要处理的对象
     */

    module.exports = function parseParam(to, from) {
        var key,
            obj = {};

        from = from || {};

        for (key in to) {
            if (to.hasOwnProperty(key)) {
                obj[key] = to[key];
                if (from[key] != null) {
                    if (from.hasOwnProperty(key)) {
                        if ($.isPlainObject(obj[key]) && $.isPlainObject(from[key])) {
                            obj[key] = parseParam(obj[key], from[key]);
                        } else {
                            obj[key] = from[key];
                        }
                    }
                }
            }
        }

        return obj;
    };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    /**
     * @file isEqual(来自underscore)
     * @author 子虔
     * @date    2015-02-15 15:37:47
     */
    module.exports = eq;

    // Internal recursive comparison function for `isEqual`.
    function eq(a, b, aStack, bStack) {
        // Identical objects are equal. `0 === -0`, but they aren't identical.
        // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
        if (a === b) return a !== 0 || 1 / a === 1 / b;
        // A strict comparison is necessary because `null == undefined`.
        if (a == null || b == null) return a === b;

        // Compare `[[Class]]` names.
        var className = Object.prototype.toString.call(a);
        if (className !== Object.prototype.toString.call(b)) return false;

        switch (className) {
            // Strings, numbers, regular expressions, dates, and booleans are compared by value.
            case '[object RegExp]':
            // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
            case '[object String]':
                // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
                // equivalent to `new String("5")`.
                return '' + a === '' + b;
            case '[object Number]':
                // `NaN`s are equivalent, but non-reflexive.
                // Object(NaN) is equivalent to NaN
                if (+a !== +a) return +b !== +b;
                // An `egal` comparison is performed for other numeric values.
                return +a === 0 ? 1 / +a === 1 / b : +a === +b;
            case '[object Date]':
            case '[object Boolean]':
                // Coerce dates and booleans to numeric primitive values. Dates are compared by their
                // millisecond representations. Note that invalid dates with millisecond representations
                // of `NaN` are not equivalent.
                return +a === +b;
        }

        var areArrays = className === '[object Array]';

        if (!areArrays) {
            if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) != 'object' || (typeof b === 'undefined' ? 'undefined' : _typeof(b)) != 'object') return false;

            // Objects with different constructors are not equivalent, but `Object`s or `Array`s
            // from different frames are.
            var aCtor = a.constructor,
                bCtor = b.constructor;
            if (aCtor !== bCtor && !(typeof aCtor == 'function' && aCtor instanceof aCtor && typeof bCtor == 'function' && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) {
                return false;
            }
        }
        // Assume equality for cyclic structures. The algorithm for detecting cyclic
        // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

        // Initializing stack of traversed objects.
        // It's done here since we only need them for objects and arrays comparison.
        aStack = aStack || [];
        bStack = bStack || [];
        var length = aStack.length;
        while (length--) {
            // Linear search. Performance is inversely proportional to the number of
            // unique nested structures.
            if (aStack[length] === a) return bStack[length] === b;
        }

        // Add the first object to the stack of traversed objects.
        aStack.push(a);
        bStack.push(b);

        // Recursively compare objects and arrays.
        if (areArrays) {
            // Compare array lengths to determine if a deep comparison is necessary.
            length = a.length;
            if (length !== b.length) return false;
            // Deep compare the contents, ignoring non-numeric properties.

            while (length--) {
                if (!eq(a[length], b[length], aStack, bStack)) return false;
            }
        } else {
            // Deep compare objects.
            var keys = Object.keys(a),
                key;
            length = keys.length;
            // Ensure that both objects contain the same number of properties before comparing deep equality.
            if (Object.keys(b).length !== length) return false;

            while (length--) {
                // Deep compare each member
                key = keys[length];
                if (!(b.hasOwnProperty(key) && eq(a[key], b[key], aStack, bStack))) return false;
            }
        }
        // Remove the first object from the stack of traversed objects.
        aStack.pop();
        bStack.pop();
        return true;
    }
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventPluginHub
 */



var EventPluginRegistry = __webpack_require__(163);
var EventPluginUtils = __webpack_require__(308);
var ReactErrorUtils = __webpack_require__(164);

var accumulateInto = __webpack_require__(165);
var forEachAccumulated = __webpack_require__(166);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(7);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

/**
 * - `InstanceHandle`: [required] Module that performs logical traversals of DOM
 *   hierarchy given ids of the logical DOM elements involved.
 */
var InstanceHandle = null;

function validateInstanceHandle() {
  var valid = InstanceHandle && InstanceHandle.traverseTwoPhase && InstanceHandle.traverseEnterLeave;
   false ? warning(valid, 'InstanceHandle not injected before use!') : undefined;
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {

  /**
   * Methods for injecting dependencies.
   */
  injection: {

    /**
     * @param {object} InjectedMount
     * @public
     */
    injectMount: EventPluginUtils.injection.injectMount,

    /**
     * @param {object} InjectedInstanceHandle
     * @public
     */
    injectInstanceHandle: function (InjectedInstanceHandle) {
      InstanceHandle = InjectedInstanceHandle;
      if (false) {
        validateInstanceHandle();
      }
    },

    getInstanceHandle: function () {
      if (false) {
        validateInstanceHandle();
      }
      return InstanceHandle;
    },

    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName

  },

  eventNameDispatchConfigs: EventPluginRegistry.eventNameDispatchConfigs,

  registrationNameModules: EventPluginRegistry.registrationNameModules,

  /**
   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
   *
   * @param {string} id ID of the DOM element.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {?function} listener The callback to store.
   */
  putListener: function (id, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : invariant(false) : undefined;

    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[id] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(id, registrationName, listener);
    }
  },

  /**
   * @param {string} id ID of the DOM element.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (id, registrationName) {
    var bankForRegistrationName = listenerBank[registrationName];
    return bankForRegistrationName && bankForRegistrationName[id];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {string} id ID of the DOM element.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (id, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(id, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      delete bankForRegistrationName[id];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {string} id ID of the DOM element.
   */
  deleteAllListeners: function (id) {
    for (var registrationName in listenerBank) {
      if (!listenerBank[registrationName][id]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(id, registrationName);
      }

      delete listenerBank[registrationName][id];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {DOMEventTarget} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native browser event.
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing ' + 'an event queue. Support for this has not yet been implemented.') : invariant(false) : undefined;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }

};

module.exports = EventPluginHub;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInstanceMap
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
var ReactInstanceMap = {

  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }

};

module.exports = ReactInstanceMap;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule emptyObject
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventPropagators
 */



var EventConstants = __webpack_require__(26);
var EventPluginHub = __webpack_require__(60);

var warning = __webpack_require__(7);

var accumulateInto = __webpack_require__(165);
var forEachAccumulated = __webpack_require__(166);

var PropagationPhases = EventConstants.PropagationPhases;
var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(id, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(id, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(domID, upwards, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(domID, 'Dispatching id must not be null') : undefined;
  }
  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
  var listener = listenerAtPhase(domID, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchIDs = accumulateInto(event._dispatchIDs, domID);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginHub.injection.getInstanceHandle().traverseTwoPhase(event.dispatchMarker, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginHub.injection.getInstanceHandle().traverseTwoPhaseSkipTarget(event.dispatchMarker, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(id, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(id, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchIDs = accumulateInto(event._dispatchIDs, id);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event.dispatchMarker, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, fromID, toID) {
  EventPluginHub.injection.getInstanceHandle().traverseEnterLeave(fromID, toID, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticUIEvent
 * @typechecks static-only
 */



var SyntheticEvent = __webpack_require__(40);

var getEventTarget = __webpack_require__(119);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target != null && target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  listen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var component = __WEBPACK_IMPORTED_MODULE_0_prop_types__["elementType"];
var components = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([component, __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);
var route = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["element"]]);
var routes = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([route, Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(route)]);

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

  /*
  * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
  * Digest Algorithm, as defined in RFC 1321.
  * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
  * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
  * Distributed under the BSD License
  * See http://pajhome.org.uk/crypt/md5 for more info.
  */

  /*
   * Configurable variables. You may need to tweak these to be compatible with
   * the server-side, but the defaults work in most cases.
   */
  var hexcase = 0; /* hex output format. 0 - lowercase; 1 - uppercase        */
  var b64pad = ""; /* base-64 pad character. "=" for strict RFC compliance   */
  var chrsz = 8; /* bits per input character. 8 - ASCII; 16 - Unicode      */

  /*
   * These are the functions you'll usually want to call
   * They take string arguments and return either hex or base-64 encoded strings
   */
  function hex_md5(s) {
    return binl2hex(core_md5(str2binl(s), s.length * chrsz));
  }
  function b64_md5(s) {
    return binl2b64(core_md5(str2binl(s), s.length * chrsz));
  }
  function str_md5(s) {
    return binl2str(core_md5(str2binl(s), s.length * chrsz));
  }
  function hex_hmac_md5(key, data) {
    return binl2hex(core_hmac_md5(key, data));
  }
  function b64_hmac_md5(key, data) {
    return binl2b64(core_hmac_md5(key, data));
  }
  function str_hmac_md5(key, data) {
    return binl2str(core_hmac_md5(key, data));
  }

  /*
   * Perform a simple self-test to see if the VM is working
   */
  function md5_vm_test() {
    return hex_md5("abc") == "900150983cd24fb0d6963f7d28e17f72";
  }

  /*
   * Calculate the MD5 of an array of little-endian words, and a bit length
   */
  function core_md5(x, len) {
    /* append padding */
    x[len >> 5] |= 0x80 << len % 32;
    x[(len + 64 >>> 9 << 4) + 14] = len;

    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;

    for (var i = 0; i < x.length; i += 16) {
      var olda = a;
      var oldb = b;
      var oldc = c;
      var oldd = d;

      a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
      d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
      c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
      b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
      a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
      d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
      c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
      b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
      a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
      d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
      c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
      b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
      a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
      d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
      c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
      b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);

      a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
      d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
      c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
      b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
      a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
      d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
      c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
      b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
      a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
      d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
      c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
      b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
      a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
      d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
      c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
      b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

      a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
      d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
      c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
      b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
      a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
      d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
      c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
      b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
      a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
      d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
      c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
      b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
      a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
      d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
      c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
      b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);

      a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
      d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
      c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
      b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
      a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
      d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
      c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
      b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
      a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
      d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
      c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
      b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
      a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
      d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
      c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
      b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);

      a = safe_add(a, olda);
      b = safe_add(b, oldb);
      c = safe_add(c, oldc);
      d = safe_add(d, oldd);
    }
    return Array(a, b, c, d);
  }

  /*
   * These functions implement the four basic operations the algorithm uses.
   */
  function md5_cmn(q, a, b, x, s, t) {
    return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
  }
  function md5_ff(a, b, c, d, x, s, t) {
    return md5_cmn(b & c | ~b & d, a, b, x, s, t);
  }
  function md5_gg(a, b, c, d, x, s, t) {
    return md5_cmn(b & d | c & ~d, a, b, x, s, t);
  }
  function md5_hh(a, b, c, d, x, s, t) {
    return md5_cmn(b ^ c ^ d, a, b, x, s, t);
  }
  function md5_ii(a, b, c, d, x, s, t) {
    return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
  }

  /*
   * Calculate the HMAC-MD5, of a key and some data
   */
  function core_hmac_md5(key, data) {
    var bkey = str2binl(key);
    if (bkey.length > 16) bkey = core_md5(bkey, key.length * chrsz);

    var ipad = Array(16),
        opad = Array(16);
    for (var i = 0; i < 16; i++) {
      ipad[i] = bkey[i] ^ 0x36363636;
      opad[i] = bkey[i] ^ 0x5C5C5C5C;
    }

    var hash = core_md5(ipad.concat(str2binl(data)), 512 + data.length * chrsz);
    return core_md5(opad.concat(hash), 512 + 128);
  }

  /*
   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
   * to work around bugs in some JS interpreters.
   */
  function safe_add(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xFFFF;
  }

  /*
   * Bitwise rotate a 32-bit number to the left.
   */
  function bit_rol(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
  }

  /*
   * Convert a string to an array of little-endian words
   * If chrsz is ASCII, characters >255 have their hi-byte silently ignored.
   */
  function str2binl(str) {
    var bin = Array();
    var mask = (1 << chrsz) - 1;
    for (var i = 0; i < str.length * chrsz; i += chrsz) {
      bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << i % 32;
    }return bin;
  }

  /*
   * Convert an array of little-endian words to a string
   */
  function binl2str(bin) {
    var str = "";
    var mask = (1 << chrsz) - 1;
    for (var i = 0; i < bin.length * 32; i += chrsz) {
      str += String.fromCharCode(bin[i >> 5] >>> i % 32 & mask);
    }return str;
  }

  /*
   * Convert an array of little-endian words to a hex string.
   */
  function binl2hex(binarray) {
    var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
    var str = "";
    for (var i = 0; i < binarray.length * 4; i++) {
      str += hex_tab.charAt(binarray[i >> 2] >> i % 4 * 8 + 4 & 0xF) + hex_tab.charAt(binarray[i >> 2] >> i % 4 * 8 & 0xF);
    }
    return str;
  }

  /*
   * Convert an array of little-endian words to a base-64 string
   */
  function binl2b64(binarray) {
    var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var str = "";
    for (var i = 0; i < binarray.length * 4; i += 3) {
      var triplet = (binarray[i >> 2] >> 8 * (i % 4) & 0xFF) << 16 | (binarray[i + 1 >> 2] >> 8 * ((i + 1) % 4) & 0xFF) << 8 | binarray[i + 2 >> 2] >> 8 * ((i + 2) % 4) & 0xFF;
      for (var j = 0; j < 4; j++) {
        if (i * 8 + j * 6 > binarray.length * 32) str += b64pad;else str += tab.charAt(triplet >> 6 * (3 - j) & 0x3F);
      }
    }
    return str;
  }

  module.exports = {
    hex_md5: hex_md5,
    b64_md5: b64_md5,
    str_md5: str_md5,
    hex_hmac_md5: hex_hmac_md5,
    b64_hmac_md5: b64_hmac_md5,
    str_hmac_md5: str_hmac_md5
  };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Result",
        "fields": [{
            "rule": "optional",
            "type": "Code",
            "name": "code",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "msg",
            "id": 2
        }, {
            "rule": "optional",
            "type": "google.protobuf.Any",
            "name": "data",
            "id": 3
        }]
    }, {
        "name": "google",
        "fields": [],
        "messages": [{
            "name": "protobuf",
            "fields": [],
            "options": {
                "csharp_namespace": "Google.Protobuf.WellKnownTypes",
                "go_package": "github.com/golang/protobuf/ptypes/any",
                "java_package": "com.google.protobuf",
                "java_outer_classname": "AnyProto",
                "java_multiple_files": true,
                "java_generate_equals_and_hash": true,
                "objc_class_prefix": "GPB"
            },
            "messages": [{
                "name": "Any",
                "fields": [{
                    "rule": "optional",
                    "type": "string",
                    "name": "type_url",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "bytes",
                    "name": "value",
                    "id": 2
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "Code",
        "values": [{
            "name": "DEFAULT",
            "id": 0
        }, {
            "name": "SC_SUCCESS",
            "id": 1
        }, {
            "name": "SC_THIRD_PARTY_ALREADY_BIND",
            "id": 256
        }, {
            "name": "SC_THIRD_CHECK_USER_NOT_REGISTER",
            "id": 257
        }, {
            "name": "SC_NEED_BIND_PHONE",
            "id": 258
        }, {
            "name": "SC_PARAMETER_INVALID",
            "id": 4096
        }, {
            "name": "SC_ADMIN_NO_PERMISSION",
            "id": 4352
        }, {
            "name": "SC_ACCOUTN_USER_TOKEN_NOTMATCH",
            "id": 8192
        }, {
            "name": "SC_LOGINED_IN_OTHER_DEVICE",
            "id": 8193
        }, {
            "name": "SC_SMS_VERIFY_CODE_NOMOBILE",
            "id": 4097
        }, {
            "name": "SC_SMS_VERIFY_CODE_FAIL",
            "id": 4098
        }, {
            "name": "SC_SMS_VERIFY_CODE_NOTMATCH",
            "id": 4099
        }, {
            "name": "SC_ACCOUNT_MOBILE_PHONE_REPETITION",
            "id": 4100
        }, {
            "name": "SC_ACCOUNT_MOBILE_PHONE_ALLREADY_BIND",
            "id": 4101
        }, {
            "name": "SC_ACCOUTN_USER_NAME_FORBIDDEN",
            "id": 4102
        }, {
            "name": "SC_ACCOUTN_THIRD_CHECK_FAIL",
            "id": 4103
        }, {
            "name": "SC_ACCOUNT_USER_NAME_OVER_LONG",
            "id": 4104
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_OVER_LONG",
            "id": 4105
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_NOT_STANDARD",
            "id": 4112
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_EXIST",
            "id": 4113
        }, {
            "name": "SC_ACCOUNT_LIVE_UPDATE_FAIL",
            "id": 4114
        }, {
            "name": "SC_ACCOUNT_PASSWORD_ERROR",
            "id": 4115
        }, {
            "name": "SC_ACCOUNT_USER_NOT_EXIST",
            "id": 4116
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_TOO_SHORT",
            "id": 4117
        }, {
            "name": "SC_ACCOUNT_SIGNATURE_OVER_LONG",
            "id": 4118
        }, {
            "name": "SC_ACCOUTN_USER_FORBIDDEN",
            "id": 4119
        }, {
            "name": "SC_ACCOUNT_RANDOM_NOTEXIST",
            "id": 4120
        }, {
            "name": "SC_ACCOUNT_RANDOM_NOTSCAN",
            "id": 4121
        }, {
            "name": "SC_ACCOUNT_RANDOM_SCANNED",
            "id": 4128
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_NOLY_MODIFY_ONCE",
            "id": 4129
        }, {
            "name": "SC_ACCOUNT_USER_OR_PASSWORD_ERROR",
            "id": 4130
        }, {
            "name": "SC_EMAIL_SEND_OVER_LIMIT",
            "id": 4131
        }, {
            "name": "SC_EMAIL_VERIFY_INVALID",
            "id": 4132
        }, {
            "name": "SC_EMAIL_NOT_VERIFY",
            "id": 4133
        }, {
            "name": "SC_NEED_REGISTER",
            "id": 4134
        }, {
            "name": "SC_ACCOUNT_HAVE_NO_BIND_MOBILE",
            "id": 4135
        }, {
            "name": "SC_ACCOUNT_DID_FORBIDDEN",
            "id": 4136
        }, {
            "name": "SC_SMS_SEND_CODE_BEYOND_LIMIT",
            "id": 4137
        }, {
            "name": "SC_SENSITIVE_CONTENT",
            "id": 4609
        }, {
            "name": "SC_MALL_GIFT_NOT_EXIST",
            "id": 12289
        }, {
            "name": "SC_MALL_TRANSACTION_REPEATED",
            "id": 12290
        }, {
            "name": "SC_MALL_MONEY_NOT_ENOUGH",
            "id": 12291
        }, {
            "name": "SC_MALL_TRANSACTION_NOT_EXIST",
            "id": 12292
        }, {
            "name": "SC_MALL_PRODUCT_NOT_AVAILABLE",
            "id": 12293
        }, {
            "name": "SC_MALL_ORDER_NOT_EXIST",
            "id": 12294
        }, {
            "name": "SC_MALL_UNIFIED_ORDER_FAIL",
            "id": 12295
        }, {
            "name": "SC_MALL_PAY_FAIL",
            "id": 12296
        }, {
            "name": "SC_MALL_PAY_QUERY_FAIL",
            "id": 12297
        }, {
            "name": "SC_MALL_IAP_VALIDATE_FAIL",
            "id": 12298
        }, {
            "name": "SC_MALL_ORDER_EXIST_NOT_FINISHED",
            "id": 12299
        }, {
            "name": "SC_MALL_NOT_BIND_WECHAT",
            "id": 12300
        }, {
            "name": "SC_MALL_EXCEED_WITHDRAW_TIMES",
            "id": 12301
        }, {
            "name": "SC_MALL_EXCEED_WITHDRAW_QUOTA",
            "id": 12302
        }, {
            "name": "SC_MALL_WITHDRAW_FAIL",
            "id": 12303
        }, {
            "name": "SC_MALL_WITHDRAW_LESS_THAN_MIN",
            "id": 12304
        }, {
            "name": "SC_MALL_WITHDRAW_GREATER_THAN_MAX",
            "id": 12305
        }, {
            "name": "SC_MALL_WITHDRAW_FREQ_LIMIT",
            "id": 12306
        }, {
            "name": "SC_MALL_WITHDRAW_SENDNUM_LIMIT",
            "id": 12307
        }, {
            "name": "SC_MALL_NOT_BIND_PAYPAL",
            "id": 12308
        }, {
            "name": "SC_MALL_IAB_VALIDATE_FAIL",
            "id": 12309
        }, {
            "name": "SC_MALL_BUY_GUARD_DIAMOND_LOW",
            "id": 12310
        }, {
            "name": "SC_MALL_TRANSLATE_NOT_SUPPORT",
            "id": 12311
        }, {
            "name": "SC_MALL_TRANSLATE_CLOSED",
            "id": 12312
        }, {
            "name": "SC_MALL_GIFT_SEND_VIP_LIMIT",
            "id": 12313
        }, {
            "name": "SC_MALL_GIFT_NOT_ALLOW",
            "id": 12320
        }, {
            "name": "SC_MALL_GIFT_NEED_RECHARGE",
            "id": 12321
        }, {
            "name": "SC_MALL_ACC_BILL_NOT_ENOUGH",
            "id": 12322
        }, {
            "name": "SC_MALL_USER_FROZEN",
            "id": 12323
        }, {
            "name": "SC_MALL_RECHARGE_REPEAT",
            "id": 12324
        }, {
            "name": "SC_MALL_RECHARGE_REWARD_REPEAT",
            "id": 12325
        }, {
            "name": "SC_MALL_RECHARGE_REWARD_INVALID",
            "id": 12326
        }, {
            "name": "SC_MALL_SHAREREDPACKET_TOTALAMOUNT_INVALID",
            "id": 12327
        }, {
            "name": "SC_MALL_SHAREREDPACKET_SPLITNUM_INVALID",
            "id": 12328
        }, {
            "name": "SC_MALL_SHAREREDPACKET_SPLITAMOUNT_INVALID",
            "id": 12329
        }, {
            "name": "SC_MALL_GOODS_NOT_EXIST",
            "id": 12336
        }, {
            "name": "SC_MALL_BROADCAST_NOT_OPEN",
            "id": 12337
        }, {
            "name": "SC_MALL_FIXEDCONTENT_NOT_EXIST",
            "id": 12338
        }, {
            "name": "SC_RANKING_VIP_INVISIBLE_LIMIT",
            "id": 14593
        }, {
            "name": "SC_RANKING_VIP_INVISIBLE_OFF",
            "id": 14594
        }, {
            "name": "SC_CONTACT_ALREADY_FRIEND",
            "id": 16385
        }, {
            "name": "SC_LIVE_ROOM_NOT_EXIST",
            "id": 20481
        }, {
            "name": "SC_LIVE_ROOM_DISABLED",
            "id": 20482
        }, {
            "name": "SC_LIVE_ROOM_NO_PERMISSION",
            "id": 20483
        }, {
            "name": "SC_LIVE_ROOM_USER_GRADE_NOT_ENOUGH",
            "id": 20484
        }, {
            "name": "SC_LIVE_ROOM_SPECIAL_NOT_CREATE",
            "id": 20485
        }, {
            "name": "SC_LIVE_ROOM_ADMIN_SHUTUP_FAIL",
            "id": 20486
        }, {
            "name": "SC_LIVE_ROOM_ADMIN_LIFTED_FAIL",
            "id": 20487
        }, {
            "name": "SC_LIVE_ROOM_ADMIN_SHUTUP_UIDS_ERROR",
            "id": 20488
        }, {
            "name": "SC_LIVE_ROOM_NO_TEL_AUTH",
            "id": 20489
        }, {
            "name": "SC_LIVE_ROOM_FORCED_OUT",
            "id": 20490
        }, {
            "name": "SC_LIVE_ROOM_POLICY_DISABLED",
            "id": 20491
        }, {
            "name": "SC_LIVE_ROOM_RID_UID_NOTMATCH",
            "id": 20492
        }, {
            "name": "SC_LIVE_ROOM_NO_REALNAME_AUTH",
            "id": 20496
        }, {
            "name": "SC_LIVE_ROOM_NOT_IN_MULTILIVE",
            "id": 20497
        }, {
            "name": "SC_LIVE_ROOM_PAY_FAILED",
            "id": 20498
        }, {
            "name": "SC_LIVE_ROOM_CANNOT_MULTILIVE",
            "id": 20499
        }, {
            "name": "SC_LIVE_ROOM_MULTILIVE_MEMBERS_LIMIT",
            "id": 20500
        }, {
            "name": "SC_LIVE_ROOM_MULTILIVE_CREATE_MEETINGROOM_FAILED",
            "id": 20501
        }, {
            "name": "SC_LIVE_ROOM_MULTILIVE_FINISH",
            "id": 20502
        }, {
            "name": "SC_LIVE_ROOM_IS_LIVING",
            "id": 20503
        }, {
            "name": "SC_LIVE_ROOM_PRIVATELIVE_NOT_ALLOW",
            "id": 20504
        }, {
            "name": "SC_LIVE_ROOM_CHARGE_NOT_ALLOW",
            "id": 20505
        }, {
            "name": "SC_LIVE_ROOM_CHARGE_BELOW_MIN",
            "id": 20506
        }, {
            "name": "SC_LIVE_ROOM_AUDIENCE_LIMIT_ALLOW",
            "id": 20507
        }, {
            "name": "SC_LIVE_ROOM_LIVE_NEED_CHARGE",
            "id": 20508
        }, {
            "name": "SC_LIVE_ROOM_NUMBER_REACHED_TOPLIMIT",
            "id": 20512
        }, {
            "name": "SC_LIVE_ROOM_VOICE_NOT_ALLOW",
            "id": 20513
        }, {
            "name": "SC_LIVE_ROOM_USER_NOT_ONLINE",
            "id": 20514
        }, {
            "name": "SC_LIVE_ROOM_APPLY_MULTILIVE_NOT_ALLOW",
            "id": 20515
        }, {
            "name": "SC_ACTIVITY_SEND_DIAMOND_TIME_END",
            "id": 24577
        }, {
            "name": "SC_ACTIVITY_SEND_DIAMOND_OVER_LIMIT",
            "id": 24578
        }, {
            "name": "SC_ACTIVITY_SEND_DIAMOND_ALREADY",
            "id": 24579
        }, {
            "name": "SC_ACTIVITY_NO_RECHARGE",
            "id": 24580
        }, {
            "name": "SC_ACTIVITY_NOT_CONDITIONS",
            "id": 24581
        }, {
            "name": "SC_SYSTEM_ERROR",
            "id": 16777215
        }, {
            "name": "SC_ZMXY_AUTH_BIND_SUCCESS",
            "id": 28673
        }, {
            "name": "SC_ZMXY_AUTH_HAS_BEEN_USEED",
            "id": 28674
        }, {
            "name": "SC_ZMXY_AUTH_HAS_BIND",
            "id": 28675
        }, {
            "name": "SC_ZMXY_AUTH_ERROR",
            "id": 28676
        }, {
            "name": "SC_REDPACKET_OVERDUE_ERROR",
            "id": 32769
        }, {
            "name": "SC_REDPACKET_DISTRIBUTED_ERROR",
            "id": 32770
        }, {
            "name": "SC_REDPACKET_REPEAT_ERROR",
            "id": 32771
        }, {
            "name": "SC_PERMISSIONUSE_NOT_ALLOW",
            "id": 36865
        }, {
            "name": "SC_PERMISSIONUSE_LOW_PERMISSION",
            "id": 36866
        }, {
            "name": "SC_PERMISSIONUSE_OVER_ROOMMAX",
            "id": 36867
        }, {
            "name": "SC_PERMISSIONUSE_OVER_DAYMAX",
            "id": 36868
        }, {
            "name": "SC_PERMISSIONUSE_OVER_ADD_LIMIT",
            "id": 36869
        }, {
            "name": "SC_PERMISSIONUSE_ERROR",
            "id": 36870
        }, {
            "name": "SC_PERMISSIONUSE_REPEAT_ERROR",
            "id": 36871
        }, {
            "name": "SC_ACTIVITY_EXCHANGE_REPEATED",
            "id": 65537
        }, {
            "name": "SC_ACTIVITY_POINT_NOT_ENOUGH",
            "id": 65538
        }, {
            "name": "SC_PACK_TRANSACTION_REPEATED",
            "id": 69633
        }, {
            "name": "SC_PACK_GIFT_NOT_AVAILABLE",
            "id": 69634
        }, {
            "name": "SC_PACK_GIFT_EXPIRE",
            "id": 69635
        }, {
            "name": "SC_PACK_TRANSACTION_NOT_EXIST",
            "id": 69636
        }, {
            "name": "SC_PACK_FULL",
            "id": 69637
        }, {
            "name": "SC_DYNAMIC_COMMENT_FREQUENCY_LIMITED",
            "id": 73729
        }, {
            "name": "SC_DYNAMIC_COMMENT_WORDS_OVER_LONG",
            "id": 73730
        }, {
            "name": "SC_DYNAMIC_NOT_EXIST_OR_DELETED",
            "id": 73731
        }, {
            "name": "SC_DYNAMIC_HAS_NO_RIGHT",
            "id": 73732
        }, {
            "name": "SC_DYNAMIC_IN_CALCULATION",
            "id": 73733
        }, {
            "name": "SC_DYNAMIC_EMPTY_NEED_GET_RECOMMEND_ANCHOR",
            "id": 73734
        }, {
            "name": "SC_DYNAMIC_LIMIT_FREQUENTLY_REPEAT_COMMENT",
            "id": 73735
        }, {
            "name": "SC_DYNAMIC_NOT_VIDEO_COMMENT",
            "id": 73736
        }, {
            "name": "SC_CHECKIN_ALREADY",
            "id": 77825
        }, {
            "name": "SC_FAN_GROUP_TITLE_CHANGE_POINT_NOT_ENOUGH",
            "id": 94465
        }, {
            "name": "SC_FAN_GROUP_NOT_EXIST",
            "id": 94466
        }, {
            "name": "SC_FAN_GROUP_NOT_FAN",
            "id": 94467
        }, {
            "name": "SC_FAN_GROUP_SELF_JOIN_ERROR",
            "id": 94468
        }, {
            "name": "SC_FAN_TASK_NOT_EXIST",
            "id": 94469
        }, {
            "name": "SC_FAN_TASK_TYPE_NOT_EXIST",
            "id": 94470
        }, {
            "name": "SC_FAN_TASK_MAXIMUM_TIME_REACHED",
            "id": 94471
        }, {
            "name": "SC_FAN_PERMISSION_NO",
            "id": 94472
        }, {
            "name": "SC_ACTIVITY_REWARD_ALREADY",
            "id": 81921
        }, {
            "name": "SC_ACTIVITY_REWARD_CANNOT",
            "id": 81922
        }, {
            "name": "SC_RANKING_GAME_NOTAUTHORITY",
            "id": 86017
        }, {
            "name": "IM_SYSTEM_ERROR",
            "id": 90113
        }, {
            "name": "IM_CREATE_PERMISSION_DENIED",
            "id": 90114
        }, {
            "name": "IM_BEYOND_GROUP_NUM_LIMIT",
            "id": 90115
        }, {
            "name": "IM_BEYOND_GROUP_USER_NUM_LIMIT",
            "id": 90116
        }, {
            "name": "IM_PERMISSION_DENIED",
            "id": 90117
        }, {
            "name": "IM_GROUP_INVALID",
            "id": 90118
        }, {
            "name": "IM_INVITE_INVALID",
            "id": 90119
        }, {
            "name": "SC_FOLLOW_YOU_ARE_IN_OTHERS_BLACKLIST",
            "id": 98305
        }, {
            "name": "SC_FOLLOW_ALREADY_REACH_MAX_FOLLOW",
            "id": 98306
        }, {
            "name": "SC_GIFTITEM_SAMENAME",
            "id": 98307
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(483);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(53);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

var _ScaleModal = __webpack_require__(12);

var _ScaleModal2 = _interopRequireDefault(_ScaleModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 登出弹出层
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var noop = function noop() {};

var style = {
    modalStyle: {
        width: '380px'
    },
    contentStyle: {
        width: '380px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        backgroundColor: "rgba(23,19,31, 0.7)"
    }
};

var OverlayPop = function (_Component) {
    _inherits(OverlayPop, _Component);

    function OverlayPop(props) {
        _classCallCheck(this, OverlayPop);

        var _this = _possibleConstructorReturn(this, (OverlayPop.__proto__ || Object.getPrototypeOf(OverlayPop)).call(this, props));

        _this.status = 'cancel';
        return _this;
    }

    _createClass(OverlayPop, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.showModal();
        }
    }, {
        key: 'onConfirm',
        value: function onConfirm() {
            this.hideModal();
            this.status = 'confirm';
        }
    }, {
        key: 'onCancel',
        value: function onCancel() {
            this.hideModal();
            this.status = 'cancel';
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            if (this.status == 'confirm') {
                this.props.onConfirm();
            } else {
                this.props.onCancel();
            }
            this.props.onHide();
        }
    }, {
        key: 'showModal',
        value: function showModal() {
            this.refs.modal.show();
        }
    }, {
        key: 'hideModal',
        value: function hideModal() {
            this.refs.modal.hide();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var modalStyle = style.modalStyle;
            var backdropStyle = style.backdropStyle;
            var contentStyle = style.contentStyle;

            if (this.props.modalStyle) {
                for (var _style in this.props.modalStyle) {
                    modalStyle[_style] = this.props.modalStyle[_style];
                }
            }

            if (this.props.backdropStyle) {
                for (var _style2 in this.props.backdropStyle) {
                    backdropStyle[_style2] = this.props.backdropStyle[_style2];
                }
            }

            if (this.props.contentStyle) {
                for (var _style3 in this.props.contentStyle) {
                    contentStyle[_style3] = this.props.contentStyle[_style3];
                }
            }

            return _react2.default.createElement(
                _ScaleModal2.default,
                {
                    ref: 'modal',
                    closeOnClick: this.props.closeOnClick,
                    modalStyle: modalStyle,
                    backdropStyle: backdropStyle,
                    contentStyle: contentStyle,
                    onHide: this.onHide.bind(this)
                },
                _react2.default.createElement(
                    'div',
                    { className: 'overlay-pop' },
                    _react2.default.createElement(
                        'div',
                        { className: 'overlay-pop-hd' },
                        this.props.title || _index2.default.template('提示')
                    ),
                    _react2.default.createElement('div', { className: 'overlay-pop-bd', dangerouslySetInnerHTML: { __html: this.props.content } }),
                    _react2.default.createElement(
                        'div',
                        { className: 'overlay-pop-ft' },
                        this.props.type == 'confirm' ? _react2.default.createElement(
                            'button',
                            { className: 'btn cancel', onClick: function onClick() {
                                    return _this2.onCancel();
                                } },
                            this.props.cancelText || _index2.default.template('取消')
                        ) : null,
                        _react2.default.createElement(
                            'button',
                            { className: 'btn confirm', onClick: function onClick() {
                                    return _this2.onConfirm();
                                } },
                            this.props.confirmText || _index2.default.template('确认')
                        )
                    )
                )
            );
        }
    }]);

    return OverlayPop;
}(_react.Component);

OverlayPop.defaultProps = {
    onHide: noop,
    onConfirm: noop,
    onCancel: noop,
    title: '',
    content: '',
    type: 'confirm',
    cancelText: '',
    confirmText: '',
    confirm: '',
    closeOnClick: true
};


module.exports = {
    create: function create(cfg) {
        cfg = cfg || {};

        if (this.layer) {
            this.destroy();
        }
        var mountNode = this.createMountNode();

        this.layer = _reactDom2.default.render(_react2.default.createElement(OverlayPop, _extends({}, cfg, { onHide: this.onHide.bind(this) })), mountNode);
    },
    onHide: function onHide() {
        this.destroy();
    },
    // 创建组件插入的DOM节点
    createMountNode: function createMountNode() {
        this.mountNode = document.createElement("div");
        $(document.body).append(this.mountNode);
        return this.mountNode;
    },
    destroy: function destroy() {
        _reactDom2.default.unmountComponentAtNode(this.mountNode);
        $(this.mountNode).remove();
        delete this.layer;
    }
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Event center
 */
(function (global, factory) {

    // amd mode
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof require === 'function' && (typeof module === 'undefined' ? 'undefined' : _typeof(module)) === "object" && module && module["exports"]) {
        // commonjs mode
        module.exports = factory();
    } else {
        // global mode
        global.events = factory();
    }
})(window, function () {

    var Callbacks = function Callbacks(options) {
        options = $.extend({}, options);

        var memory,
            // Last fire value (for non-forgettable lists)
        _fired,
            // Flag to know if list was already fired
        firing,
            // Flag to know if list is currently firing
        firingStart,
            // First callback to fire (used internally by add and fireWith)
        firingLength,
            // End of the loop when firing
        firingIndex,
            // Index of currently firing callback (modified by remove if needed)
        list = [],
            // Actual callback list
        stack = !options.once && [],
            // Stack of fire calls for repeatable lists
        fire = function fire(data) {
            memory = options.memory && data;
            _fired = true;
            firingIndex = firingStart || 0;
            firingStart = 0;
            firingLength = list.length;
            firing = true;
            for (; list && firingIndex < firingLength; ++firingIndex) {
                if (list[firingIndex].apply(data[0], data[1]) === false && options.stopOnFalse) {
                    memory = false;
                    break;
                }
            }
            firing = false;
            if (list) {
                if (stack) stack.length && fire(stack.shift());else if (memory) list.length = 0;else Callbacks.disable();
            }
        },
            Callbacks = {
            list: list,
            add: function add() {
                if (list) {
                    var start = list.length,
                        add = function add(args) {
                        args = Array.prototype.slice.call(args);
                        args.forEach(function (arg, _) {
                            if (typeof arg === "function") {
                                if (!options.unique || !Callbacks.has(arg)) list.push(arg);
                            } else if (arg && arg.length && typeof arg !== 'string') add(arg);
                        });
                    };
                    add(arguments);
                    if (firing) firingLength = list.length;else if (memory) {
                        firingStart = start;
                        fire(memory);
                    }
                }
                return this;
            },
            remove: function remove() {
                var args = Array.prototype.slice.call(arguments);
                if (list) {
                    args.forEach(function (arg, _) {
                        var index;
                        while ((index = list.indexOf(arg, index)) > -1) {
                            list.splice(index, 1);
                            // Handle firing indexes
                            if (firing) {
                                if (index <= firingLength) --firingLength;
                                if (index <= firingIndex) --firingIndex;
                            }
                        }
                    });
                }
                return this;
            },
            has: function has(fn) {
                return !!(list && (fn ? list.indexOf(fn) > -1 : list.length));
            },
            empty: function empty() {
                firingLength = list.length = 0;
                return this;
            },
            disable: function disable() {
                list = stack = memory = undefined;
                return this;
            },
            disabled: function disabled() {
                return !list;
            },
            lock: function lock() {
                stack = undefined;
                if (!memory) Callbacks.disable();
                return this;
            },
            locked: function locked() {
                return !stack;
            },
            fireWith: function fireWith(context, args) {
                if (list && (!_fired || stack)) {
                    args = args || [];
                    args = [context, args.slice ? args.slice() : args];
                    if (firing) stack.push(args);else fire(args);
                }
                return this;
            },
            fire: function fire() {
                return Callbacks.fireWith(this, arguments);
            },
            fired: function fired() {
                return !!_fired;
            }
        };

        return Callbacks;
    };
    var channelObj = {};

    // 统一事件机制
    var Events = {
        Event: Callbacks,
        /**
         * 添加事件监听
         * @param  {string}   name - 事件名称
         * @param  {function} callback - 事件回调
         */
        on: function on(name, callback) {
            var obj,
                that = this;

            this.events = this.events || {};

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.on(item, callback);
                    }
                });
            }

            if (!this.global && name.indexOf('/') != -1) {
                // 频道监听
                if (name.split('/')[0] == 'channel') {
                    return that.channel.on(name.replace(/^channel\//gi, ''), callback);
                }

                obj = getObjectByNames(name, this);
                this.events[name] = this.events[name] || [];
                this.events[name].push(callback);
                return obj ? obj.on(getEventName(name), callback) : this;
            } else {
                obj = this.events[name] || (this.events[name] = this.Event());
            }

            // 如果设置为一起派发，则再次监听时，直接执行
            if (this._alwayEmitSource && this._alwayEmitSource[name]) {
                return callback.apply(name, this._alwayEmitSource[name]);
            }
            obj.add(callback);

            return this;
        },
        /**
         * 移除事件监听
         * @param  {string}   name     事件名称
         * @param  {function} [callback] - 事件回调，为空时，移除所有回调
         */
        off: function off(name, callback) {
            var obj,
                funs,
                that = this;

            this.events = this.events || {};

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.off(item, callback);
                    }
                });
            }

            if (!this.global && name && name.indexOf('/') != -1) {
                if (name.split('/')[0] == 'channel') {
                    return that.channel.off(name.replace(/^channel\//gi, ''), callback);
                }

                if (this.events[name]) {
                    obj = getObjectByNames(name, this);
                    if (callback) {
                        return obj ? obj.off(getEventName(name), callback) : this;
                    } else {
                        funs = this.events[name];
                        for (var i = 0; obj && funs && i < funs.length; i++) {
                            obj.off(getEventName(name), funs[i]);
                        }
                        this.events[name] = null;
                    }
                }

                return this;
            }

            if (name && callback && (obj = this.events[name])) {
                obj.remove(callback);
            } else if (name && (obj = this.events[name])) {
                obj.empty();
            } else {

                for (name in this.events) {
                    if (this.events.hasOwnProperty(name) && this.events[name]) {
                        if (!this.global && name.indexOf('/') != -1) {
                            if (name.split('/')[0] == 'channel') {
                                return this.channel.off(name.replace(/^channel\//gi, ''));
                            }
                            this.off(name);
                        } else {
                            this.events[name].empty();
                        }
                    }
                }
            }

            return this;
        },
        ///**
        // * 只监听一次事件
        // * @param name
        // * @param callback
        // */
        //once: function (name, callback) {
        //    var _callback;
        //
        //    this.on(name, _callback = function () {
        //        callback.apply(this, arguments);
        //        this.off(name, _callback);
        //    });
        //},
        /**
         * 默认派发事件
         * @return {object}
         */
        trigger: function trigger() {
            var name = arguments[0],
                obj,
                param,
                that = this;

            this.events = this.events || {};
            param = Array.prototype.slice.call(arguments, 1);

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.trigger.apply(this, [item].concat(param));
                    }
                });
            }

            if (!this.global && name && name.indexOf('/') != -1) {
                if (name.split('/')[0] == 'channel') {
                    return that.channel.trigger.apply(that.channel, [name.replace(/^channel\//gi, '')].concat(param));
                }
                obj = getObjectByNames(name, this);
                name = getEventName(name);
                return obj ? obj.trigger.apply(obj, [name].concat(param)) : this;
            }

            if (name && (obj = this.events[name])) {
                obj.fire.apply(this, [].concat(param));
            }

            return {
                event: obj,
                always: function always() {
                    that._alwayEmitSource = that._alwayEmitSource || {};
                    that._alwayEmitSource[name] = [].concat(param);
                }
            };
        },
        /**
         * 派发事件
         * @example
         *        this.emit('ready',args0,args1...);
         */
        emit: function emit() {
            return this.trigger.apply(this, arguments);
        }
    };

    /**
     * 获取context下的name属性
     * @private
     */
    function getObjectByNames(name, context) {
        var that, names, len;

        context = context || {};
        that = context;
        names = name.split('/');
        len = names.length;

        for (var i = 0; len > 1 && i < len - 1; i++) {
            if (that && that[names[i]]) {
                that = that[names[i]];
            } else {
                that = null;
            }
        }

        return that;
    }

    /**
     * 获取事件名称
     * @param  {String} name [description]
     * @return {String}
     */
    function getEventName(name) {
        var names = name.split('/');
        return names[names.length - 1];
    }

    // global single Event
    Events.channel = $.channel || ($.channel = $.extend(channelObj, Events));
    Events.channel.global = Events.channel;

    return Events;
});

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _index = __webpack_require__(402);

var _index2 = _interopRequireDefault(_index);

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // 敏感词处理


var cache = new _cCache2.default({
    prefix: 'pcuplive/sensitivewords'
});
var pbajax = new _pbajax2.default();

var sensitive = {
    getDataFromServer: function getDataFromServer() {
        var _this = this;

        var _lang = UP.Global.siteLanguage;
        var localLast = cache.getCache('lastTime/' + _lang);
        var localExtLast = cache.getCache('extLastTime/' + _lang);

        var data = new _index2.default.SensitiveWords.Get.Request({
            lastTime: localLast ? parseInt(localLast) : 0,
            extLastTime: localExtLast ? parseInt(localExtLast) : 0
        });

        pbajax.do({
            service: 'service',
            api: '/sensitive/words/get',
            header: {
                lang: _lang
            }
        }, data, function (res) {
            var dataWrap = _public2.default.Result.decode(res);
            var data = void 0;

            if (dataWrap.code == 1) {
                data = _index2.default.SensitiveWords.Get.Response.decode(dataWrap.data.value);
                // console.log('sensitive:', data);
                // 存储敏感词主库的最后更新时间
                cache.setCache('lastTime/' + _lang, longToString(data.updateTime));
                cache.setCache('extLastTime/' + _lang, longToString(data.extUpdateTime));
                _this.localSensitiveUpdate(data);
            }
        });
    },
    localSensitiveUpdate: function localSensitiveUpdate(data) {
        var _lang = UP.Global.siteLanguage;
        var list = data.words;
        var locals = cache.getCache('words/' + _lang);

        if (!locals) {
            // list = this.getWordsByLang(_lang, list);
            list = this.getValidPureWordList(list);
            cache.setCache('words/' + _lang, list);
            return;
        }

        var newLocal = this.update(locals, list);

        cache.setCache('words/' + _lang, newLocal);
    },


    // 不区分status（是否被删除 0 无效的 1 有效）
    getWordsByLang: function getWordsByLang(lang, list) {
        var arr = [];
        list.forEach(function (item, inx) {
            if (item.lang == lang) {
                arr.push(item);
            }
        });

        return arr;
    },


    // 获得有效的敏感词纯数组
    getValidPureWordList: function getValidPureWordList(list) {
        var arr = [];
        list.forEach(function (item, inx) {
            if (item.status) {
                arr.push(item.content);
            }
        });

        return arr;
    },
    update: function update(localList, news) {
        var _this2 = this;

        news.forEach(function (item, inx) {
            if (item.status) {
                localList.push(item.content);
            } else {
                localList = _this2.delSomeByValue(localList, item.content);
            }
        });

        return [].concat(_toConsumableArray(localList));
    },
    delSomeByValue: function delSomeByValue(arr, item) {
        for (var i = arr.length; i--;) {
            var val = arr[i];
            if (val == item) {
                arr.splice(i, 1);
            }
        }

        return [].concat(_toConsumableArray(arr));
    },
    getLocalWords: function getLocalWords() {
        var _lang = UP.Global.siteLanguage;

        return cache.getCache('words/' + _lang);
    },
    filter: function filter(content) {
        if (!content) {
            return content;
        }
        var localList = this.getLocalWords();

        if (localList && localList.length > 0) {
            localList = localList.map(function (item, inx) {
                item = item.replace(/[\ |\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?]/g, function (s, i) {
                    return '\\' + s;
                });
                return '(' + item + ')';
            });

            var reg = new RegExp(localList.join('|'), 'gi');

            return content.replace(reg, '***');
        } else {
            return content;
        }
    },
    check: function check(content) {
        var localList = this.getLocalWords();

        if (localList && localList.length > 0) {
            localList = localList.map(function (item, inx) {
                item = item.replace(/[\ |\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?]/g, function (s, i) {
                    return '\\' + s;
                });
                return '(' + item + ')';
            });

            var reg = new RegExp(localList.join('|'), 'gi');

            return content.match(reg) ? false : true;
        } else {
            return true;
        }
    }
};

exports.default = sensitive;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyMirror
 * @typechecks static-only
 */



var invariant = __webpack_require__(2);

/**
 * Constructs an enumeration with keys equal to their value.
 *
 * For example:
 *
 *   var COLORS = keyMirror({blue: null, red: null});
 *   var myColor = COLORS.blue;
 *   var isColorValid = !!COLORS[myColor];
 *
 * The last line could not be performed if the values of the generated enum were
 * not equal to their keys.
 *
 *   Input:  {key1: val1, key2: val2}
 *   Output: {key1: key1, key2: key2}
 *
 * @param {object} obj
 * @return {object}
 */
var keyMirror = function (obj) {
  var ret = {};
  var key;
  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : undefined;
  for (key in obj) {
    if (!obj.hasOwnProperty(key)) {
      continue;
    }
    ret[key] = key;
  }
  return ret;
};

module.exports = keyMirror;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule setInnerHTML
 */

/* globals MSApp */



var ExecutionEnvironment = __webpack_require__(14);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = function (node, html) {
  node.innerHTML = html;
};

// Win8 apps: Allow all html to be inserted
if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
  setInnerHTML = function (node, html) {
    MSApp.execUnsafeLocalFunction(function () {
      node.innerHTML = html;
    });
  };
}

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xFEFF) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
}

module.exports = setInnerHTML;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule escapeTextContentForBrowser
 */



var ESCAPE_LOOKUP = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  '\'': '&#x27;'
};

var ESCAPE_REGEX = /[&><"']/g;

function escaper(match) {
  return ESCAPE_LOOKUP[match];
}

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  return ('' + text).replace(ESCAPE_REGEX, escaper);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactBrowserEventEmitter
 * @typechecks static-only
 */



var EventConstants = __webpack_require__(26);
var EventPluginHub = __webpack_require__(60);
var EventPluginRegistry = __webpack_require__(163);
var ReactEventEmitterMixin = __webpack_require__(309);
var ReactPerf = __webpack_require__(19);
var ViewportMetrics = __webpack_require__(167);

var assign = __webpack_require__(8);
var isEventSupported = __webpack_require__(112);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   ReactBrowserEventEmitter.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = assign({}, ReactEventEmitterMixin, {

  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    var topLevelTypes = EventConstants.topLevelTypes;
    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === topLevelTypes.topWheel) {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === topLevelTypes.topScroll) {

          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {

          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening[topLevelTypes.topBlur] = true;
          isListening[topLevelTypes.topFocus] = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (!isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  },

  eventNameDispatchConfigs: EventPluginHub.eventNameDispatchConfigs,

  registrationNameModules: EventPluginHub.registrationNameModules,

  putListener: EventPluginHub.putListener,

  getListener: EventPluginHub.getListener,

  deleteListener: EventPluginHub.deleteListener,

  deleteAllListeners: EventPluginHub.deleteAllListeners

});

ReactPerf.measureMethods(ReactBrowserEventEmitter, 'ReactBrowserEventEmitter', {
  putListener: 'putListener',
  deleteListener: 'deleteListener'
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule canDefineProperty
 */



var canDefineProperty = false;
if (false) {
  try {
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Transaction
 */



var invariant = __webpack_require__(2);

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var Mixin = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there ' + 'is already an outstanding transaction.') : invariant(false) : undefined;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : invariant(false) : undefined;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

var Transaction = {

  Mixin: Mixin,

  /**
   * Token to look for to determine if an error occurred.
   */
  OBSERVED_ERROR: {}

};

module.exports = Transaction;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPropTypeLocations
 */



var keyMirror = __webpack_require__(76);

var ReactPropTypeLocations = keyMirror({
  prop: null,
  context: null,
  childContext: null
});

module.exports = ReactPropTypeLocations;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPropTypeLocationNames
 */



var ReactPropTypeLocationNames = {};

if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
}

module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticMouseEvent
 * @typechecks static-only
 */



var SyntheticUIEvent = __webpack_require__(64);
var ViewportMetrics = __webpack_require__(167);

var getEventModifierState = __webpack_require__(120);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _login = __webpack_require__(407);

var _login2 = _interopRequireDefault(_login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pbajax = new _pbajax2.default();

var UserLogin = function () {
    function UserLogin() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, UserLogin);

        this.promise = this.login(data);
    }

    _createClass(UserLogin, [{
        key: 'login',
        value: function login(data) {
            var self = this;
            var defer = $.Deferred();
            var _loginPb$User$Login = _login2.default.User.Login,
                Request = _loginPb$User$Login.Request,
                Response = _loginPb$User$Login.Response;


            var businessData = new Request(data);

            var requestData = {
                https: 'true',
                service: 'safe', // java service name
                api: '/user/login' // java api
            };

            pbajax.do(requestData, businessData, function (res) {
                var dataWrap = _public2.default.Result.decode(res);
                var data = void 0;

                if (dataWrap.code == 1) {
                    // 未绑定过
                    data = Response.decode(dataWrap.data.value);

                    var userInfo = Object.assign({}, data.profile, self.parseData(data.profile));

                    defer.resolve(userInfo);
                } else {
                    defer.reject(dataWrap);
                }
            }, function () {
                defer.reject();
            }, function () {
                defer.reject();
            });

            return defer.promise();
        }
        /*
         * 解析数据
         */

    }, {
        key: 'parseData',
        value: function parseData(data) {
            var balance = data.balance || {};
            return {
                uid: this.longToString(data.uid), // 用户UID
                balance: {
                    diamond: this.longToInt(balance.diamond),
                    bill: this.longToInt(balance.bill),
                    inBill: this.longToInt(balance.inBill),
                    outDiamond: this.longToInt(balance.outDiamond)
                },
                exp: this.longToInt(data.exp), // 用户经验值
                currentExp: this.longToInt(data.currentExp), //当前级的经验值
                nextExp: this.longToInt(data.nextExp), // 距离下一级还需要多少经验值
                chatroomid: this.longToString(data.chatroomid),
                officialAuth: data.officialAuth || 0 // 大V认证标识 1是 0否
            };
        }
    }, {
        key: 'longToString',
        value: function longToString(value) {
            return window.longToString(value);
        }
    }, {
        key: 'longToInt',
        value: function longToInt(value) {
            value = this.longToString(value);

            return parseInt(value, 10) || 0;
        }
    }]);

    return UserLogin;
}();

exports.default = UserLogin;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _countries = __webpack_require__(408);

var _countries2 = _interopRequireDefault(_countries);

var _countryCode = __webpack_require__(409);

var _countryCode2 = _interopRequireDefault(_countryCode);

var _lang2 = __webpack_require__(1);

var _lang3 = _interopRequireDefault(_lang2);

var _number = __webpack_require__(44);

var _number2 = _interopRequireDefault(_number);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 国家选择列表
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var CountryView = function (_Component) {
    _inherits(CountryView, _Component);

    function CountryView(props) {
        _classCallCheck(this, CountryView);

        // 系统语言
        var _this = _possibleConstructorReturn(this, (CountryView.__proto__ || Object.getPrototypeOf(CountryView)).call(this, props));

        _this.onChange = function (e) {
            var el = $(e.currentTarget);
            var val = el.val();

            _this.timer && clearTimeout(_this.timer);
            _this.timer = setTimeout(function () {
                var countries = _this.filter(val);
                _this.setState({
                    countries: countries
                });
            }, 300);
        };

        var _lang = UP.Global.systemLanguage;
        // let countryCode = _lang.split('-')[1].toUpperCase();

        // let whiteList = ['CN', 'JP', 'VN']; // 默认国家码白名单

        // if (whiteList.indexOf(countryCode) == -1) {
        // 	countryCode = '';
        // }
        var user = UP.Global.getUser() || {};
        var countryCode = user.countryCode || '';

        _this.state = Object.assign({
            countries: _countries2.default,
            visible: props.visible
        }, _this.getInputValueByCode(countryCode));
        return _this;
    }

    _createClass(CountryView, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.props.selectOption(this.state);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                visible: nextProps.visible
            });
        }
    }, {
        key: 'getInputValueByCode',
        value: function getInputValueByCode(code) {
            var name = '';
            var num = '';

            if (_countryCode2.default[code]) {
                $.each(_countries2.default, function (key, value) {
                    if (key == code) {
                        name = _lang3.default.template(key);
                        return false;
                    }
                });

                num = _number2.default.prefixed(_countryCode2.default[code], 4);
            }

            return {
                code: code,
                areaCode: num,
                inputValuePlusCode: name ? '+' + _countryCode2.default[code] : '',
                inputValue: name
            };
        }
    }, {
        key: 'filter',
        value: function filter(val) {
            var list = this.state.countries;
            var result = {};

            $.each(_countries2.default, function (key, value) {
                var name = _lang3.default.template(key);
                var num = _countryCode2.default[key];

                if (val.match(/^[0-9]+$/)) {
                    if (num && num.indexOf(val) > -1) {
                        result[key] = value;
                    }
                } else {
                    if (name.indexOf(val) > -1) {
                        result[key] = value;
                    }
                }
            });

            return result;
        }
    }, {
        key: 'onClickOption',
        value: function onClickOption(code) {
            var state = Object.assign({}, this.getInputValueByCode(code));

            this.props.selectOption(state);
            this.setState(state);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var $options = [];

            $.map(this.state.countries, function (value, key) {
                if (_countryCode2.default[key]) {

                    var cls = _this2.state.code == key ? 'selected' : '';

                    var node = _react2.default.createElement(
                        'li',
                        { className: cls, key: key, 'data-code': key, onClick: function onClick() {
                                return _this2.onClickOption(key);
                            } },
                        _react2.default.createElement(
                            'label',
                            null,
                            _lang3.default.template(key)
                        ),
                        _react2.default.createElement(
                            'em',
                            null,
                            '(+',
                            _countryCode2.default[key],
                            ')'
                        )
                    );

                    $options[$options.length] = node;
                }
            });

            return _react2.default.createElement(
                'div',
                { className: 'country-list-wrap', style: { display: this.state.visible ? 'block' : 'none' } },
                _react2.default.createElement(
                    'div',
                    { className: 'search-bar' },
                    _react2.default.createElement(
                        'div',
                        { className: 'input-wrapper' },
                        _react2.default.createElement('input', { className: 'input', onKeyUp: this.onChange, placeholder: _lang3.default.template('搜索') })
                    )
                ),
                _react2.default.createElement(
                    'ul',
                    { className: 'country-list' },
                    $options
                )
            );
        }
    }]);

    return CountryView;
}(_react.Component);

CountryView.defaultProps = {
    visible: false,
    selectOption: function selectOption() {}
};
exports.default = CountryView;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 检测第三方账号是否已经绑定过
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _check = __webpack_require__(410);

var _check2 = _interopRequireDefault(_check);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pbajax = new _pbajax2.default();

var ThirdCheck = function () {
    function ThirdCheck() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, ThirdCheck);

        this.promise = this.check(data);
    }

    _createClass(ThirdCheck, [{
        key: 'check',
        value: function check(data) {
            var defer = $.Deferred();
            var _checkPb$ThirdParty$C = _check2.default.ThirdParty.Check,
                Request = _checkPb$ThirdParty$C.Request,
                Response = _checkPb$ThirdParty$C.Response;


            var businessData = new Request(data);

            var requestData = {
                service: 'service',
                api: '/third/party/check'
            };

            pbajax.do(requestData, businessData, function (res) {
                var dataWrap = _public2.default.Result.decode(res);
                var data = void 0;

                if (dataWrap.code == '256') {
                    // 已绑定过
                    defer.resolve(true);
                } else if (dataWrap.code == 1) {
                    // 未绑定过
                    defer.resolve(false);
                } else {
                    defer.reject();
                }
            }, function () {
                defer.reject();
            }, function () {
                defer.reject();
            });
            return defer.promise();
        }
    }]);

    return ThirdCheck;
}();

exports.default = ThirdCheck;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _register = __webpack_require__(205);

var _register2 = _interopRequireDefault(_register);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pbajax = new _pbajax2.default();

var ThirdRegister = function () {
    function ThirdRegister() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, ThirdRegister);

        this.promise = this.register(data);
    }

    _createClass(ThirdRegister, [{
        key: 'register',
        value: function register(data) {
            var self = this;
            var defer = $.Deferred();
            var _registerPb$ThirdChec = _register2.default.ThirdCheck.Register,
                Request = _registerPb$ThirdChec.Request,
                Response = _registerPb$ThirdChec.Response;
            // let ua = window.navigator.userAgent + ' feature/9999 channel/' + UP.Global.channel + (window.smDeviceId ? ' smd/' + window.smDeviceId : '');

            var businessData = new Request(data);

            var requestData = {
                service: 'service',
                api: '/third/check/register',
                header: {
                    'Accept-Language': UP.Global.siteLanguage
                    // 'UserAgent': ua
                }
            };

            pbajax.do(requestData, businessData, function (res) {
                var dataWrap = _public2.default.Result.decode(res);
                var data = void 0;

                if (dataWrap.code == 1) {
                    data = Response.decode(dataWrap.data.value);
                    if (data.profile) {
                        var userInfo = Object.assign({}, data.profile, self.parseData(data.profile));
                        defer.resolve(userInfo);
                    } else {
                        defer.resolve(data);
                    }
                } else {

                    defer.reject(dataWrap);
                }
            }, function () {
                defer.reject();
            }, function () {
                defer.reject();
            });
            return defer.promise();
        }
        /*
         * 解析数据
         */

    }, {
        key: 'parseData',
        value: function parseData(data) {
            var balance = data.balance || {};

            return {
                uid: this.longToString(data.uid), // 用户UID
                balance: {
                    diamond: this.longToInt(balance.diamond),
                    bill: this.longToInt(balance.bill),
                    inBill: this.longToInt(balance.inBill),
                    outDiamond: this.longToInt(balance.outDiamond)
                },
                exp: this.longToInt(data.exp), // 用户经验值
                currentExp: this.longToInt(data.currentExp), //当前级的经验值
                nextExp: this.longToInt(data.nextExp), // 距离下一级还需要多少经验值
                chatroomid: this.longToString(data.chatroomid),
                officialAuth: data.officialAuth || 0 // 大V认证标识 1是 0否
            };
        }
    }, {
        key: 'longToString',
        value: function longToString(value) {
            return window.longToString(value);
        }
    }, {
        key: 'longToInt',
        value: function longToInt(value) {
            value = this.longToString(value);

            return parseInt(value, 10) || 0;
        }
    }]);

    return ThirdRegister;
}();

exports.default = ThirdRegister;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

(function (r) {
  r.fn.qrcode = function (h) {
    var s;function u(a) {
      this.mode = s;this.data = a;
    }function o(a, c) {
      this.typeNumber = a;this.errorCorrectLevel = c;this.modules = null;this.moduleCount = 0;this.dataCache = null;this.dataList = [];
    }function q(a, c) {
      if (void 0 == a.length) throw Error(a.length + "/" + c);for (var d = 0; d < a.length && 0 == a[d];) {
        d++;
      }this.num = Array(a.length - d + c);for (var b = 0; b < a.length - d; b++) {
        this.num[b] = a[b + d];
      }
    }function p(a, c) {
      this.totalCount = a;this.dataCount = c;
    }function t() {
      this.buffer = [];this.length = 0;
    }u.prototype = { getLength: function getLength() {
        return this.data.length;
      },
      write: function write(a) {
        for (var c = 0; c < this.data.length; c++) {
          a.put(this.data.charCodeAt(c), 8);
        }
      } };o.prototype = { addData: function addData(a) {
        this.dataList.push(new u(a));this.dataCache = null;
      }, isDark: function isDark(a, c) {
        if (0 > a || this.moduleCount <= a || 0 > c || this.moduleCount <= c) throw Error(a + "," + c);return this.modules[a][c];
      }, getModuleCount: function getModuleCount() {
        return this.moduleCount;
      }, make: function make() {
        if (1 > this.typeNumber) {
          for (var a = 1, a = 1; 40 > a; a++) {
            for (var c = p.getRSBlocks(a, this.errorCorrectLevel), d = new t(), b = 0, e = 0; e < c.length; e++) {
              b += c[e].dataCount;
            }for (e = 0; e < this.dataList.length; e++) {
              c = this.dataList[e], d.put(c.mode, 4), d.put(c.getLength(), j.getLengthInBits(c.mode, a)), c.write(d);
            }if (d.getLengthInBits() <= 8 * b) break;
          }this.typeNumber = a;
        }this.makeImpl(!1, this.getBestMaskPattern());
      }, makeImpl: function makeImpl(a, c) {
        this.moduleCount = 4 * this.typeNumber + 17;this.modules = Array(this.moduleCount);for (var d = 0; d < this.moduleCount; d++) {
          this.modules[d] = Array(this.moduleCount);for (var b = 0; b < this.moduleCount; b++) {
            this.modules[d][b] = null;
          }
        }this.setupPositionProbePattern(0, 0);this.setupPositionProbePattern(this.moduleCount - 7, 0);this.setupPositionProbePattern(0, this.moduleCount - 7);this.setupPositionAdjustPattern();this.setupTimingPattern();this.setupTypeInfo(a, c);7 <= this.typeNumber && this.setupTypeNumber(a);null == this.dataCache && (this.dataCache = o.createData(this.typeNumber, this.errorCorrectLevel, this.dataList));this.mapData(this.dataCache, c);
      }, setupPositionProbePattern: function setupPositionProbePattern(a, c) {
        for (var d = -1; 7 >= d; d++) {
          if (!(-1 >= a + d || this.moduleCount <= a + d)) for (var b = -1; 7 >= b; b++) {
            -1 >= c + b || this.moduleCount <= c + b || (this.modules[a + d][c + b] = 0 <= d && 6 >= d && (0 == b || 6 == b) || 0 <= b && 6 >= b && (0 == d || 6 == d) || 2 <= d && 4 >= d && 2 <= b && 4 >= b ? !0 : !1);
          }
        }
      }, getBestMaskPattern: function getBestMaskPattern() {
        for (var a = 0, c = 0, d = 0; 8 > d; d++) {
          this.makeImpl(!0, d);var b = j.getLostPoint(this);if (0 == d || a > b) a = b, c = d;
        }return c;
      }, createMovieClip: function createMovieClip(a, c, d) {
        a = a.createEmptyMovieClip(c, d);this.make();for (c = 0; c < this.modules.length; c++) {
          for (var d = 1 * c, b = 0; b < this.modules[c].length; b++) {
            var e = 1 * b;this.modules[c][b] && (a.beginFill(0, 100), a.moveTo(e, d), a.lineTo(e + 1, d), a.lineTo(e + 1, d + 1), a.lineTo(e, d + 1), a.endFill());
          }
        }return a;
      },
      setupTimingPattern: function setupTimingPattern() {
        for (var a = 8; a < this.moduleCount - 8; a++) {
          null == this.modules[a][6] && (this.modules[a][6] = 0 == a % 2);
        }for (a = 8; a < this.moduleCount - 8; a++) {
          null == this.modules[6][a] && (this.modules[6][a] = 0 == a % 2);
        }
      }, setupPositionAdjustPattern: function setupPositionAdjustPattern() {
        for (var a = j.getPatternPosition(this.typeNumber), c = 0; c < a.length; c++) {
          for (var d = 0; d < a.length; d++) {
            var b = a[c],
                e = a[d];if (null == this.modules[b][e]) for (var f = -2; 2 >= f; f++) {
              for (var i = -2; 2 >= i; i++) {
                this.modules[b + f][e + i] = -2 == f || 2 == f || -2 == i || 2 == i || 0 == f && 0 == i ? !0 : !1;
              }
            }
          }
        }
      }, setupTypeNumber: function setupTypeNumber(a) {
        for (var c = j.getBCHTypeNumber(this.typeNumber), d = 0; 18 > d; d++) {
          var b = !a && 1 == (c >> d & 1);this.modules[Math.floor(d / 3)][d % 3 + this.moduleCount - 8 - 3] = b;
        }for (d = 0; 18 > d; d++) {
          b = !a && 1 == (c >> d & 1), this.modules[d % 3 + this.moduleCount - 8 - 3][Math.floor(d / 3)] = b;
        }
      }, setupTypeInfo: function setupTypeInfo(a, c) {
        for (var d = j.getBCHTypeInfo(this.errorCorrectLevel << 3 | c), b = 0; 15 > b; b++) {
          var e = !a && 1 == (d >> b & 1);6 > b ? this.modules[b][8] = e : 8 > b ? this.modules[b + 1][8] = e : this.modules[this.moduleCount - 15 + b][8] = e;
        }for (b = 0; 15 > b; b++) {
          e = !a && 1 == (d >> b & 1), 8 > b ? this.modules[8][this.moduleCount - b - 1] = e : 9 > b ? this.modules[8][15 - b - 1 + 1] = e : this.modules[8][15 - b - 1] = e;
        }this.modules[this.moduleCount - 8][8] = !a;
      }, mapData: function mapData(a, c) {
        for (var d = -1, b = this.moduleCount - 1, e = 7, f = 0, i = this.moduleCount - 1; 0 < i; i -= 2) {
          for (6 == i && i--;;) {
            for (var g = 0; 2 > g; g++) {
              if (null == this.modules[b][i - g]) {
                var n = !1;f < a.length && (n = 1 == (a[f] >>> e & 1));j.getMask(c, b, i - g) && (n = !n);this.modules[b][i - g] = n;e--;-1 == e && (f++, e = 7);
              }
            }b += d;if (0 > b || this.moduleCount <= b) {
              b -= d;d = -d;break;
            }
          }
        }
      } };o.PAD0 = 236;o.PAD1 = 17;o.createData = function (a, c, d) {
      for (var c = p.getRSBlocks(a, c), b = new t(), e = 0; e < d.length; e++) {
        var f = d[e];b.put(f.mode, 4);b.put(f.getLength(), j.getLengthInBits(f.mode, a));f.write(b);
      }for (e = a = 0; e < c.length; e++) {
        a += c[e].dataCount;
      }if (b.getLengthInBits() > 8 * a) throw Error("code length overflow. (" + b.getLengthInBits() + ">" + 8 * a + ")");for (b.getLengthInBits() + 4 <= 8 * a && b.put(0, 4); 0 != b.getLengthInBits() % 8;) {
        b.putBit(!1);
      }for (; !(b.getLengthInBits() >= 8 * a);) {
        b.put(o.PAD0, 8);if (b.getLengthInBits() >= 8 * a) break;b.put(o.PAD1, 8);
      }return o.createBytes(b, c);
    };o.createBytes = function (a, c) {
      for (var d = 0, b = 0, e = 0, f = Array(c.length), i = Array(c.length), g = 0; g < c.length; g++) {
        var n = c[g].dataCount,
            h = c[g].totalCount - n,
            b = Math.max(b, n),
            e = Math.max(e, h);f[g] = Array(n);for (var k = 0; k < f[g].length; k++) {
          f[g][k] = 255 & a.buffer[k + d];
        }d += n;k = j.getErrorCorrectPolynomial(h);n = new q(f[g], k.getLength() - 1).mod(k);i[g] = Array(k.getLength() - 1);for (k = 0; k < i[g].length; k++) {
          h = k + n.getLength() - i[g].length, i[g][k] = 0 <= h ? n.get(h) : 0;
        }
      }for (k = g = 0; k < c.length; k++) {
        g += c[k].totalCount;
      }d = Array(g);for (k = n = 0; k < b; k++) {
        for (g = 0; g < c.length; g++) {
          k < f[g].length && (d[n++] = f[g][k]);
        }
      }for (k = 0; k < e; k++) {
        for (g = 0; g < c.length; g++) {
          k < i[g].length && (d[n++] = i[g][k]);
        }
      }return d;
    };s = 4;for (var j = { PATTERN_POSITION_TABLE: [[], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50], [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70], [6, 26, 50, 74], [6, 30, 54, 78], [6, 30, 56, 82], [6, 30, 58, 86], [6, 34, 62, 90], [6, 28, 50, 72, 94], [6, 26, 50, 74, 98], [6, 30, 54, 78, 102], [6, 28, 54, 80, 106], [6, 32, 58, 84, 110], [6, 30, 58, 86, 114], [6, 34, 62, 90, 118], [6, 26, 50, 74, 98, 122], [6, 30, 54, 78, 102, 126], [6, 26, 52, 78, 104, 130], [6, 30, 56, 82, 108, 134], [6, 34, 60, 86, 112, 138], [6, 30, 58, 86, 114, 142], [6, 34, 62, 90, 118, 146], [6, 30, 54, 78, 102, 126, 150], [6, 24, 50, 76, 102, 128, 154], [6, 28, 54, 80, 106, 132, 158], [6, 32, 58, 84, 110, 136, 162], [6, 26, 54, 82, 110, 138, 166], [6, 30, 58, 86, 114, 142, 170]], G15: 1335, G18: 7973, G15_MASK: 21522, getBCHTypeInfo: function getBCHTypeInfo(a) {
        for (var c = a << 10; 0 <= j.getBCHDigit(c) - j.getBCHDigit(j.G15);) {
          c ^= j.G15 << j.getBCHDigit(c) - j.getBCHDigit(j.G15);
        }return (a << 10 | c) ^ j.G15_MASK;
      }, getBCHTypeNumber: function getBCHTypeNumber(a) {
        for (var c = a << 12; 0 <= j.getBCHDigit(c) - j.getBCHDigit(j.G18);) {
          c ^= j.G18 << j.getBCHDigit(c) - j.getBCHDigit(j.G18);
        }return a << 12 | c;
      }, getBCHDigit: function getBCHDigit(a) {
        for (var c = 0; 0 != a;) {
          c++, a >>>= 1;
        }return c;
      }, getPatternPosition: function getPatternPosition(a) {
        return j.PATTERN_POSITION_TABLE[a - 1];
      }, getMask: function getMask(a, c, d) {
        switch (a) {case 0:
            return 0 == (c + d) % 2;case 1:
            return 0 == c % 2;case 2:
            return 0 == d % 3;case 3:
            return 0 == (c + d) % 3;case 4:
            return 0 == (Math.floor(c / 2) + Math.floor(d / 3)) % 2;case 5:
            return 0 == c * d % 2 + c * d % 3;case 6:
            return 0 == (c * d % 2 + c * d % 3) % 2;case 7:
            return 0 == (c * d % 3 + (c + d) % 2) % 2;default:
            throw Error("bad maskPattern:" + a);}
      }, getErrorCorrectPolynomial: function getErrorCorrectPolynomial(a) {
        for (var c = new q([1], 0), d = 0; d < a; d++) {
          c = c.multiply(new q([1, l.gexp(d)], 0));
        }return c;
      }, getLengthInBits: function getLengthInBits(a, c) {
        if (1 <= c && 10 > c) switch (a) {case 1:
            return 10;case 2:
            return 9;case s:
            return 8;case 8:
            return 8;default:
            throw Error("mode:" + a);} else if (27 > c) switch (a) {case 1:
            return 12;case 2:
            return 11;case s:
            return 16;case 8:
            return 10;default:
            throw Error("mode:" + a);} else if (41 > c) switch (a) {case 1:
            return 14;case 2:
            return 13;case s:
            return 16;case 8:
            return 12;default:
            throw Error("mode:" + a);} else throw Error("type:" + c);
      }, getLostPoint: function getLostPoint(a) {
        for (var c = a.getModuleCount(), d = 0, b = 0; b < c; b++) {
          for (var e = 0; e < c; e++) {
            for (var f = 0, i = a.isDark(b, e), g = -1; 1 >= g; g++) {
              if (!(0 > b + g || c <= b + g)) for (var h = -1; 1 >= h; h++) {
                0 > e + h || c <= e + h || 0 == g && 0 == h || i == a.isDark(b + g, e + h) && f++;
              }
            }5 < f && (d += 3 + f - 5);
          }
        }for (b = 0; b < c - 1; b++) {
          for (e = 0; e < c - 1; e++) {
            if (f = 0, a.isDark(b, e) && f++, a.isDark(b + 1, e) && f++, a.isDark(b, e + 1) && f++, a.isDark(b + 1, e + 1) && f++, 0 == f || 4 == f) d += 3;
          }
        }for (b = 0; b < c; b++) {
          for (e = 0; e < c - 6; e++) {
            a.isDark(b, e) && !a.isDark(b, e + 1) && a.isDark(b, e + 2) && a.isDark(b, e + 3) && a.isDark(b, e + 4) && !a.isDark(b, e + 5) && a.isDark(b, e + 6) && (d += 40);
          }
        }for (e = 0; e < c; e++) {
          for (b = 0; b < c - 6; b++) {
            a.isDark(b, e) && !a.isDark(b + 1, e) && a.isDark(b + 2, e) && a.isDark(b + 3, e) && a.isDark(b + 4, e) && !a.isDark(b + 5, e) && a.isDark(b + 6, e) && (d += 40);
          }
        }for (e = f = 0; e < c; e++) {
          for (b = 0; b < c; b++) {
            a.isDark(b, e) && f++;
          }
        }a = Math.abs(100 * f / c / c - 50) / 5;return d + 10 * a;
      } }, l = { glog: function glog(a) {
        if (1 > a) throw Error("glog(" + a + ")");return l.LOG_TABLE[a];
      }, gexp: function gexp(a) {
        for (; 0 > a;) {
          a += 255;
        }for (; 256 <= a;) {
          a -= 255;
        }return l.EXP_TABLE[a];
      }, EXP_TABLE: Array(256),
      LOG_TABLE: Array(256) }, m = 0; 8 > m; m++) {
      l.EXP_TABLE[m] = 1 << m;
    }for (m = 8; 256 > m; m++) {
      l.EXP_TABLE[m] = l.EXP_TABLE[m - 4] ^ l.EXP_TABLE[m - 5] ^ l.EXP_TABLE[m - 6] ^ l.EXP_TABLE[m - 8];
    }for (m = 0; 255 > m; m++) {
      l.LOG_TABLE[l.EXP_TABLE[m]] = m;
    }q.prototype = { get: function get(a) {
        return this.num[a];
      }, getLength: function getLength() {
        return this.num.length;
      }, multiply: function multiply(a) {
        for (var c = Array(this.getLength() + a.getLength() - 1), d = 0; d < this.getLength(); d++) {
          for (var b = 0; b < a.getLength(); b++) {
            c[d + b] ^= l.gexp(l.glog(this.get(d)) + l.glog(a.get(b)));
          }
        }return new q(c, 0);
      }, mod: function mod(a) {
        if (0 > this.getLength() - a.getLength()) return this;for (var c = l.glog(this.get(0)) - l.glog(a.get(0)), d = Array(this.getLength()), b = 0; b < this.getLength(); b++) {
          d[b] = this.get(b);
        }for (b = 0; b < a.getLength(); b++) {
          d[b] ^= l.gexp(l.glog(a.get(b)) + c);
        }return new q(d, 0).mod(a);
      } };p.RS_BLOCK_TABLE = [[1, 26, 19], [1, 26, 16], [1, 26, 13], [1, 26, 9], [1, 44, 34], [1, 44, 28], [1, 44, 22], [1, 44, 16], [1, 70, 55], [1, 70, 44], [2, 35, 17], [2, 35, 13], [1, 100, 80], [2, 50, 32], [2, 50, 24], [4, 25, 9], [1, 134, 108], [2, 67, 43], [2, 33, 15, 2, 34, 16], [2, 33, 11, 2, 34, 12], [2, 86, 68], [4, 43, 27], [4, 43, 19], [4, 43, 15], [2, 98, 78], [4, 49, 31], [2, 32, 14, 4, 33, 15], [4, 39, 13, 1, 40, 14], [2, 121, 97], [2, 60, 38, 2, 61, 39], [4, 40, 18, 2, 41, 19], [4, 40, 14, 2, 41, 15], [2, 146, 116], [3, 58, 36, 2, 59, 37], [4, 36, 16, 4, 37, 17], [4, 36, 12, 4, 37, 13], [2, 86, 68, 2, 87, 69], [4, 69, 43, 1, 70, 44], [6, 43, 19, 2, 44, 20], [6, 43, 15, 2, 44, 16], [4, 101, 81], [1, 80, 50, 4, 81, 51], [4, 50, 22, 4, 51, 23], [3, 36, 12, 8, 37, 13], [2, 116, 92, 2, 117, 93], [6, 58, 36, 2, 59, 37], [4, 46, 20, 6, 47, 21], [7, 42, 14, 4, 43, 15], [4, 133, 107], [8, 59, 37, 1, 60, 38], [8, 44, 20, 4, 45, 21], [12, 33, 11, 4, 34, 12], [3, 145, 115, 1, 146, 116], [4, 64, 40, 5, 65, 41], [11, 36, 16, 5, 37, 17], [11, 36, 12, 5, 37, 13], [5, 109, 87, 1, 110, 88], [5, 65, 41, 5, 66, 42], [5, 54, 24, 7, 55, 25], [11, 36, 12], [5, 122, 98, 1, 123, 99], [7, 73, 45, 3, 74, 46], [15, 43, 19, 2, 44, 20], [3, 45, 15, 13, 46, 16], [1, 135, 107, 5, 136, 108], [10, 74, 46, 1, 75, 47], [1, 50, 22, 15, 51, 23], [2, 42, 14, 17, 43, 15], [5, 150, 120, 1, 151, 121], [9, 69, 43, 4, 70, 44], [17, 50, 22, 1, 51, 23], [2, 42, 14, 19, 43, 15], [3, 141, 113, 4, 142, 114], [3, 70, 44, 11, 71, 45], [17, 47, 21, 4, 48, 22], [9, 39, 13, 16, 40, 14], [3, 135, 107, 5, 136, 108], [3, 67, 41, 13, 68, 42], [15, 54, 24, 5, 55, 25], [15, 43, 15, 10, 44, 16], [4, 144, 116, 4, 145, 117], [17, 68, 42], [17, 50, 22, 6, 51, 23], [19, 46, 16, 6, 47, 17], [2, 139, 111, 7, 140, 112], [17, 74, 46], [7, 54, 24, 16, 55, 25], [34, 37, 13], [4, 151, 121, 5, 152, 122], [4, 75, 47, 14, 76, 48], [11, 54, 24, 14, 55, 25], [16, 45, 15, 14, 46, 16], [6, 147, 117, 4, 148, 118], [6, 73, 45, 14, 74, 46], [11, 54, 24, 16, 55, 25], [30, 46, 16, 2, 47, 17], [8, 132, 106, 4, 133, 107], [8, 75, 47, 13, 76, 48], [7, 54, 24, 22, 55, 25], [22, 45, 15, 13, 46, 16], [10, 142, 114, 2, 143, 115], [19, 74, 46, 4, 75, 47], [28, 50, 22, 6, 51, 23], [33, 46, 16, 4, 47, 17], [8, 152, 122, 4, 153, 123], [22, 73, 45, 3, 74, 46], [8, 53, 23, 26, 54, 24], [12, 45, 15, 28, 46, 16], [3, 147, 117, 10, 148, 118], [3, 73, 45, 23, 74, 46], [4, 54, 24, 31, 55, 25], [11, 45, 15, 31, 46, 16], [7, 146, 116, 7, 147, 117], [21, 73, 45, 7, 74, 46], [1, 53, 23, 37, 54, 24], [19, 45, 15, 26, 46, 16], [5, 145, 115, 10, 146, 116], [19, 75, 47, 10, 76, 48], [15, 54, 24, 25, 55, 25], [23, 45, 15, 25, 46, 16], [13, 145, 115, 3, 146, 116], [2, 74, 46, 29, 75, 47], [42, 54, 24, 1, 55, 25], [23, 45, 15, 28, 46, 16], [17, 145, 115], [10, 74, 46, 23, 75, 47], [10, 54, 24, 35, 55, 25], [19, 45, 15, 35, 46, 16], [17, 145, 115, 1, 146, 116], [14, 74, 46, 21, 75, 47], [29, 54, 24, 19, 55, 25], [11, 45, 15, 46, 46, 16], [13, 145, 115, 6, 146, 116], [14, 74, 46, 23, 75, 47], [44, 54, 24, 7, 55, 25], [59, 46, 16, 1, 47, 17], [12, 151, 121, 7, 152, 122], [12, 75, 47, 26, 76, 48], [39, 54, 24, 14, 55, 25], [22, 45, 15, 41, 46, 16], [6, 151, 121, 14, 152, 122], [6, 75, 47, 34, 76, 48], [46, 54, 24, 10, 55, 25], [2, 45, 15, 64, 46, 16], [17, 152, 122, 4, 153, 123], [29, 74, 46, 14, 75, 47], [49, 54, 24, 10, 55, 25], [24, 45, 15, 46, 46, 16], [4, 152, 122, 18, 153, 123], [13, 74, 46, 32, 75, 47], [48, 54, 24, 14, 55, 25], [42, 45, 15, 32, 46, 16], [20, 147, 117, 4, 148, 118], [40, 75, 47, 7, 76, 48], [43, 54, 24, 22, 55, 25], [10, 45, 15, 67, 46, 16], [19, 148, 118, 6, 149, 119], [18, 75, 47, 31, 76, 48], [34, 54, 24, 34, 55, 25], [20, 45, 15, 61, 46, 16]];p.getRSBlocks = function (a, c) {
      var d = p.getRsBlockTable(a, c);if (void 0 == d) throw Error("bad rs block @ typeNumber:" + a + "/errorCorrectLevel:" + c);for (var b = d.length / 3, e = [], f = 0; f < b; f++) {
        for (var h = d[3 * f + 0], g = d[3 * f + 1], j = d[3 * f + 2], l = 0; l < h; l++) {
          e.push(new p(g, j));
        }
      }return e;
    };p.getRsBlockTable = function (a, c) {
      switch (c) {case 1:
          return p.RS_BLOCK_TABLE[4 * (a - 1) + 0];case 0:
          return p.RS_BLOCK_TABLE[4 * (a - 1) + 1];case 3:
          return p.RS_BLOCK_TABLE[4 * (a - 1) + 2];case 2:
          return p.RS_BLOCK_TABLE[4 * (a - 1) + 3];}
    };t.prototype = { get: function get(a) {
        return 1 == (this.buffer[Math.floor(a / 8)] >>> 7 - a % 8 & 1);
      }, put: function put(a, c) {
        for (var d = 0; d < c; d++) {
          this.putBit(1 == (a >>> c - d - 1 & 1));
        }
      }, getLengthInBits: function getLengthInBits() {
        return this.length;
      }, putBit: function putBit(a) {
        var c = Math.floor(this.length / 8);this.buffer.length <= c && this.buffer.push(0);a && (this.buffer[c] |= 128 >>> this.length % 8);this.length++;
      } };"string" === typeof h && (h = { text: h });h = r.extend({}, { render: "canvas", width: 256, height: 256, typeNumber: -1,
      correctLevel: 2, background: "#ffffff", foreground: "#000000" }, h);return this.each(function () {
      var a;if ("canvas" == h.render) {
        a = new o(h.typeNumber, h.correctLevel);a.addData(h.text);a.make();var c = document.createElement("canvas");c.width = h.width;c.height = h.height;for (var d = c.getContext("2d"), b = h.width / a.getModuleCount(), e = h.height / a.getModuleCount(), f = 0; f < a.getModuleCount(); f++) {
          for (var i = 0; i < a.getModuleCount(); i++) {
            d.fillStyle = a.isDark(f, i) ? h.foreground : h.background;var g = Math.ceil((i + 1) * b) - Math.floor(i * b),
                j = Math.ceil((f + 1) * b) - Math.floor(f * b);d.fillRect(Math.round(i * b), Math.round(f * e), g, j);
          }
        }
      } else {
        a = new o(h.typeNumber, h.correctLevel);a.addData(h.text);a.make();c = r("<table></table>").css("width", h.width + "px").css("height", h.height + "px").css("border", "0px").css("border-collapse", "collapse").css("background-color", h.background);d = h.width / a.getModuleCount();b = h.height / a.getModuleCount();for (e = 0; e < a.getModuleCount(); e++) {
          f = r("<tr></tr>").css("height", b + "px").appendTo(c);for (i = 0; i < a.getModuleCount(); i++) {
            r("<td></td>").css("width", d + "px").css("background-color", a.isDark(e, i) ? h.foreground : h.background).appendTo(f);
          }
        }
      }a = c;Zepto(a).appendTo(this);
    });
  };
})(Zepto);

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(213);
var enumBugKeys = __webpack_require__(143);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 94 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 95 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(240);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Observer = function (_Component) {
    _inherits(Observer, _Component);

    function Observer() {
        _classCallCheck(this, Observer);

        var _this = _possibleConstructorReturn(this, (Observer.__proto__ || Object.getPrototypeOf(Observer)).call(this));

        _this.state = {
            isVisible: false
        };

        _this.io = null;
        _this.container = null;
        return _this;
    }

    _createClass(Observer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var observer = function observer() {
                _this2.io = new window.IntersectionObserver(function (entries) {
                    try {
                        entries.forEach(function (entry) {
                            if (!_this2.io) {
                                return;
                            }

                            _this2.setState({
                                isVisible: entry.isIntersecting
                            });
                        });
                    } catch (e) {
                        console.error(e);
                    }
                }, {});

                _this2.io.observe(_this2.container);
            };

            if (window.IntersectionObserver) {
                observer();
            } else {
                __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 240)).then(function () {
                    observer();
                }).catch(function (err) {
                    console.log(err);
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.io = null;
            this.container = null;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                { ref: function ref(div) {
                        _this3.container = div;
                    } },
                Array.isArray(this.props.children) ? this.props.children.map(function (child) {
                    return child(_this3.state.isVisible);
                }) : this.props.children(this.state.isVisible)
            );
        }
    }]);

    return Observer;
}(_react.Component);

exports.default = Observer;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = __webpack_require__(621);

var _index2 = _interopRequireDefault(_index);

var _unfollow = __webpack_require__(622);

var _unfollow2 = _interopRequireDefault(_unfollow);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _cUpLoading = __webpack_require__(13);

var _cUpLoading2 = _interopRequireDefault(_cUpLoading);

var _events = __webpack_require__(74);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 关注用户
var pbajax = new _pbajax2.default();

var Follow = function Follow() {};

Follow.prototype = Object.assign({}, {
    do: function _do(fuid) {
        var _this = this;

        var cfg = {
            service: 'service',
            api: '/follow/user/add',
            header: {
                userToken: UP.Global.getUserToken()
            }
        };

        fuid = typeof fuid == 'string' ? Number(fuid) : fuid;

        var requestData = new _index2.default.Follow.UserAdd.Request({
            fuid: fuid
        });

        pbajax.do(cfg, requestData, function (res) {
            var dataWrap = _public2.default.Result.decode(res);
            if (dataWrap.code == 1) {

                _cUpLoading2.default.hide();

                _this.emit('followSuccess', fuid);
            }
        }, function () {
            _cUpLoading2.default.hide();
        }, function () {
            _cUpLoading2.default.hide();
        });
    },
    unFollow: function unFollow(fuid) {
        var _this2 = this;

        var cfg = {
            service: 'service',
            api: '/follow/user/unfollow',
            header: {
                userToken: UP.Global.getUserToken()
            }
        };
        var requestData = new _unfollow2.default.Follow.UserUnfollow.Request({
            fuid: fuid
        });

        pbajax.do(cfg, requestData, function (res) {
            var dataWrap = _public2.default.Result.decode(res);

            if (dataWrap.code == 1) {
                _this2.emit('unFollowSuccess');
            }
        }, function () {
            _cUpLoading2.default.hide();
        }, function () {
            _cUpLoading2.default.hide();
        });
    }
}, _events2.default);

exports.default = Follow;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

var _loading = __webpack_require__(45);

var _loading2 = _interopRequireDefault(_loading);

var _ScaleModal = __webpack_require__(12);

var _ScaleModal2 = _interopRequireDefault(_ScaleModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * iframe popup
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var noop = function noop() {};

var IframePop = function (_Component) {
    _inherits(IframePop, _Component);

    function IframePop(props) {
        _classCallCheck(this, IframePop);

        var _this = _possibleConstructorReturn(this, (IframePop.__proto__ || Object.getPrototypeOf(IframePop)).call(this, props));

        _this.state = {
            loading: 1
        };

        var clientHeight = void 0,
            _width = void 0,
            width = void 0,
            _height = void 0,
            height = void 0;

        clientHeight = document.documentElement && document.documentElement.clientHeight || body && body.offsetHeight || window.innerHeight || 395;
        _height = Math.min(Math.floor(clientHeight - 40), 812);
        _width = Math.floor(_height * 395 / 645);

        if (props.landscape == 1) {
            width = _height;
            height = _width;
        } else {
            width = _width;
            height = _height;
        }

        _this.style = {
            modalStyle: {
                width: width,
                height: height,
                zIndex: 10070,
                transform: "none",
                left: '50%',
                top: '50%',
                marginLeft: -width / 2 + 'px',
                marginTop: -height / 2 + 'px'
            },
            contentStyle: {
                width: width,
                height: height,
                backgroundColor: '#fff',
                borderRadius: '10px',
                outline: 0
            },
            backdropStyle: {
                backgroundColor: "rgba(23,19,31, 0.7)",
                zIndex: 10060
            }
        };
        return _this;
    }

    _createClass(IframePop, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.showModal();
        }
    }, {
        key: 'insertIframe',
        value: function insertIframe() {
            var _this2 = this;

            var frame = this.create(this.props.url);

            $(frame).on('load', function (e) {
                _this2.setState({
                    loading: 0
                });
            });
            // console.log(frame);
            // console.log($('#iframeWrap'));
            $('#iframeWrap').html(frame);
        }
    }, {
        key: 'create',
        value: function create(url) {
            var frame = document.createElement('iframe');
            frame.style.border = '0 none';
            frame.style.verticalAlign = 'top';
            frame.src = url;
            return frame;
        }
    }, {
        key: 'showModal',
        value: function showModal() {
            this.refs.modal.show();
        }
    }, {
        key: 'hideModal',
        value: function hideModal() {
            this.refs.modal.hide();
        }
    }, {
        key: 'onShow',
        value: function onShow() {
            // 禁用滚动条，并固定在当前位置
            var doc = $(document),
                win = $(window),
                winWidth = win.width(),
                winHeight = win.height(),
                docHeight = doc.height(),
                scrollY = doc.scrollTop();

            $('html').css({
                'width': winWidth + 'px',
                'height': winHeight + 'px',
                'overflowY': 'hidden'
            }).scrollTop(scrollY);

            this.insertIframe();
            this.bindEvent();
        }
    }, {
        key: 'bindEvent',
        value: function bindEvent() {
            var _this3 = this;

            $(window).off('message');
            $(window).on('message', function (e) {
                /**
                 * e: {Object}
                 *   {
                 *      method: 'init',
                 *      cbKey: '',
                 *      params: '',
                 *  }
                 */
                var data = e.data;
                var method = data.method;
                var params = data.params || {};

                if (method == 'gopay') {
                    _this3.hideModal();
                    window.hashHistory.push('/recharge');
                } else if (method == 'login') {
                    _this3.hideModal();
                    $.channel.emit('login');
                } else if (method == 'profile') {
                    window.hashHistory.push('/profile/base/' + params.uid);
                } else if (method == 'refreshProfile') {
                    $.channel.emit('refreshProfile');
                }
            });
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            // 页面恢复原始位置
            $('html').css({
                'height': 'auto',
                'width': 'auto',
                'overflowY': 'auto'
            }).scrollTop($(document).scrollTop());

            $(window).off('message');

            this.props.onHide();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var style = this.style;
            var modalStyle = style.modalStyle;
            var backdropStyle = style.backdropStyle;
            var contentStyle = style.contentStyle;

            if (this.props.modalStyle) {
                for (var _style in this.props.modalStyle) {
                    modalStyle[_style] = this.props.modalStyle[_style];
                }
            }

            if (this.props.backdropStyle) {
                for (var _style2 in this.props.backdropStyle) {
                    backdropStyle[_style2] = this.props.backdropStyle[_style2];
                }
            }

            if (this.props.contentStyle) {
                for (var _style3 in this.props.contentStyle) {
                    contentStyle[_style3] = this.props.contentStyle[_style3];
                }
            }
            return _react2.default.createElement(
                _ScaleModal2.default,
                {
                    ref: 'modal',
                    modalStyle: modalStyle,
                    backdropStyle: backdropStyle,
                    contentStyle: contentStyle,
                    onShow: this.onShow.bind(this),
                    onHide: this.onHide.bind(this),
                    closeOnClick: this.props.closeOnClick
                },
                _react2.default.createElement(
                    'div',
                    { className: 'overlay-frame-box' },
                    _react2.default.createElement(
                        'div',
                        { className: 'close', onClick: function onClick() {
                                return _this4.hideModal();
                            } },
                        'x'
                    ),
                    _react2.default.createElement('div', { className: 'content', id: 'iframeWrap' }),
                    this.state.loading == 1 ? _react2.default.createElement(
                        'div',
                        { className: 'iframe-poster' },
                        _react2.default.createElement(_loading2.default, null)
                    ) : null
                )
            );
        }
    }]);

    return IframePop;
}(_react.Component);

IframePop.defaultProps = {
    onHide: noop,
    url: '',
    closeOnClick: true,
    landscape: 0 // 1: 横屏，0:竖屏
};


module.exports = {
    create: function create(cfg) {
        cfg = cfg || {};

        if (this.layer) {
            this.destroy();
        }
        var mountNode = this.createMountNode();

        this.layer = _reactDom2.default.render(_react2.default.createElement(IframePop, _extends({}, cfg, { onHide: this.onHide.bind(this, cfg) })), mountNode);
    },
    onHide: function onHide(cfg) {
        if (this.layer) {
            this.destroy();
        }
        if (typeof cfg.onHide == 'function') {
            cfg.onHide();
        }
    },
    // 创建组件插入的DOM节点
    createMountNode: function createMountNode() {
        this.mountNode = document.createElement("div");
        $(document.body).append(this.mountNode);
        return this.mountNode;
    },
    destroy: function destroy() {
        _reactDom2.default.unmountComponentAtNode(this.mountNode);
        $(this.mountNode).remove();
        delete this.layer;
    }
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreventParentScroll = _react2.default.createClass({
    displayName: 'PreventParentScroll',
    getScrollParent: function getScrollParent(currentNode) {
        var el = currentNode;
        do {
            switch (getComputedStyle(el).overflowY) {
                case 'auto':
                case 'scroll':
                case 'overlay':
                    return el;
            }
        } while (el = el.parentElement);
        return window;
    },
    animationScroll: function animationScroll(time) {
        var node = this.node;

        if (Math.abs(this.TouchDelta) > 1) {
            this.scrollValue0 -= this.TouchDelta;
            this.intermediateScroll();
            this.TouchDelta *= 0.9;
            this.animationId = requestAnimationFrame(this.animationScroll);
        } else {
            this.scrollValue0 = Math.min(node.scrollHeight - node.offsetHeight, Math.max(0, this.scrollValue0));
            this.scrollValue1 += (this.scrollValue0 - this.scrollValue1) * 0.3;
            this.scrollValue2 += (this.scrollValue1 - this.scrollValue2) * 0.3;
            node.scrollTop += Math.round((this.scrollValue2 - node.scrollTop) * 0.3);

            if (Math.abs(node.scrollTop - this.scrollValue2) >= 1) this.animationId = requestAnimationFrame(this.animationScroll);
        }
    },
    onMouseWheel: function onMouseWheel(e) {
        this.scrollValue0 -= e.wheelDeltaY;
        cancelAnimationFrame(this.animationId);
        this.animationId = requestAnimationFrame(this.animationScroll);
        e.preventDefault();
    },
    touchStart: function touchStart(e) {
        this.onTouch = true;
        this.touchHasMove = false;
        this.touchY = e.changedTouches[0].clientY;
        this.touchYBack = e.changedTouches[0].clientY;
    },
    intermediateScroll: function intermediateScroll() {
        this.scrollValue0 = Math.min(this.node.scrollHeight - this.node.offsetHeight, Math.max(0, this.scrollValue0));
        this.scrollValue1 = this.scrollValue0;
        this.scrollValue2 = this.scrollValue0;
        this.node.scrollTop = this.scrollValue2;
    },
    touchMove: function touchMove(e) {
        cancelAnimationFrame(this.animationId);
        this.TouchDelta = e.changedTouches[0].clientY - this.touchYBack;

        this.touchYBack = e.changedTouches[0].clientY;

        this.scrollValue0 -= this.TouchDelta;

        this.intermediateScroll();

        e.preventDefault();
    },
    touchEnd: function touchEnd(e) {
        this.onTouch = false;

        if (Math.abs(e.changedTouches[0].clientY - this.touchY) > 5) {
            e.preventDefault();
        }

        if (Math.abs(this.TouchDelta) > 2) {
            this.animationId = requestAnimationFrame(this.animationScroll);
        } else {
            this.TouchDelta = 0;
        }
    },
    componentDidMount: function componentDidMount() {

        this.node = this.getScrollParent((0, _reactDom.findDOMNode)(this));

        this.node.onmousewheel = this.onMouseWheel;

        this.scrollValue0 = 0;
        this.scrollValue1 = 0;
        this.scrollValue2 = 0;

        // window.addEventListener('touchstart', this.touchStart);
        // window.addEventListener('touchend', this.touchEnd);
        // window.addEventListener('touchmove', this.touchMove);

    },
    componentWillUnmount: function componentWillUnmount() {
        cancelAnimationFrame(this.animationId);
        // window.removeEventListener('touchstart', this.touchStart);
        // window.removeEventListener('touchend', this.touchEnd);
        // window.removeEventListener('touchmove', this.touchMove);
    },
    render: function render() {
        return _react2.default.createElement('div', { style: { display: 'none' } });
    }
});

exports.default = PreventParentScroll;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * @fileoverview 倒计时
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    var Base = __webpack_require__(56);

    var Timer = Base.extend({
        defaults: {
            isEnd: false,
            // 剩余时间,单位s
            remainTime: 0,

            // 使用者需要监听的时间点,单位s
            listenPoint: 0,

            // 是否需要补齐两位,如8s -> 08(s)
            isDoubleBit: true,

            // 倒计时容器
            selector: {
                day: '',
                hour: '',
                minute: '',
                second: ''
            }
        },
        toListenPointed: false,
        initialize: function initialize() {
            var self = this;
            self.toHook();
            self.startCountDown();
        },

        /**
         * dom钩子
         * @param void
         * @return void
         */
        toHook: function toHook() {
            var self = this,
                selector = self.get('selector');

            self.dayWrap = $(selector.day);
            self.hourWrap = $(selector.hour);
            self.minuteWrap = $(selector.minute);
            self.secondWrap = $(selector.second);
        },

        /**
         * 是否需要某个时间维度
         * @param key {string} 时间维度,day.
         * @return boolean
         */
        isNeed: function isNeed(key) {
            return this[key + 'Wrap'].length > 0;
        },

        /**
         * 分割剩余时间，天、时、分、秒
         * @param time {number} 时间,单位s
         * @return result {object}
         * 		@key day {string|number} 天
         *		@key hour {string|number} 时
         *		@key minute {string|number} 分
         *		@key second {string|number} 秒
         */
        splitTime: function splitTime(time) {

            var self = this,
                day = Math.floor(time / 86400),
                hour = Math.floor(time % 86400 / 3600),
                minute = Math.floor(time % 86400 % 3600 / 60),
                second = Math.floor(time % 86400 % 3600 % 60);

            return {
                day: day >= 0 ? day : 0,
                hour: hour >= 0 ? hour : 0,
                minute: minute >= 0 ? minute : 0,
                second: second >= 0 ? second : 0
            };
        },

        /**
         * 合并剩余时间到秒
         * @param time {object} 时间
         * 		@key day {string|number} 天
         *		@key hour {string|number} 时
         *		@key minute {string|number} 分
         *		@key second {string|number} 秒
         * @return result {number} 
         
         */
        combineTime: function combineTime(time) {
            return time.day * 86400 + time.hour * 3600 + time.minute * 60 + time.second;
        },

        /**
         * 格式化时间(补齐两位)
         * @param time {object} 未补齐两位的时间对象
         * 		@key day {string|number} 天
         *		@key hour {string|number} 时
         *		@key minute {string|number} 分
         *		@key second {string|number} 秒
         * @return time
         */
        formatTime: function formatTime(time) {
            var self = this;
            for (var i in time) {
                time[i] = self.addBit(time[i]);
            }
            return time;
        },

        /**
         * 渲染剩余时间到dom
         * @param result {object} 时间对象
         * 		@key day {string|number} 天
         *		@key hour {string|number} 时
         *		@key minute {string|number} 分
         *		@key second {string|number} 秒
         * @return void
         */
        render: function render(result) {
            var self = this;
            self.isNeed('day') && self.dayWrap.html(result.day);
            self.isNeed('hour') && self.hourWrap.html(result.hour);
            self.isNeed('minute') && self.minuteWrap.html(result.minute);
            self.isNeed('second') && self.secondWrap.html(result.second);
        },

        /**
         * 增加位数
         * @param num {number} 数字
         * @return result {string}
         */
        addBit: function addBit(num) {
            return num < 10 ? '0' + num : num;
        },

        /**
         * 开始倒计时
         * @param void
         * @param {Boolean} flag 内部参数，用来判断是否正在跳动
         * @return void
         */
        startCountDown: function startCountDown(flag) {
            var self = this,
                localTimeStamp = new Date().getTime(),
                isDoubleBit = self.get('isDoubleBit'),
                localTimeGap,
                now,
                realRemainTime,
                splitTime,
                renderData,
                isToListenPoint,
                isEnd;

            self.countDown && clearTimeout(self.countDown);
            self.countDown = setTimeout(function () {
                localTimeGap = new Date().getTime() - localTimeStamp;
                realRemainTime = self.get('remainTime') - localTimeGap / 1000;

                // 设置真正的剩余时间
                self.set('remainTime', realRemainTime);

                splitTime = self.splitTime(realRemainTime);

                renderData = isDoubleBit ? self.formatTime(splitTime) : splitTime;

                self.render(renderData);

                self.emit('tick', {
                    remainTime: realRemainTime,
                    serverTime: new Date().getTime() / 1000
                });

                isEnd = self.isEnd(splitTime);
                isToListenPoint = self.isToListenPoint(splitTime);
                self.set('isEnd', isEnd);

                if (isEnd) {
                    self.emit('end');
                    return;
                }

                if (!self.toListenPointed && isToListenPoint) {
                    self.emit('toListenPoint', {
                        point: splitTime
                    });
                    self.toListenPointed = true;
                }

                // 重新呼叫此方法启动演示器
                self.startCountDown(true);
            }, flag ? 1000 : 0);
        },

        /**
         * 判断当前倒计时是否结束
         * @param realTime {object} 参考render参数
         * @return boolean
         */
        isEnd: function isEnd(realTime) {
            return realTime.second <= 0 && realTime.minute == 0 && realTime.hour == 0 && realTime.day == 0;
        },

        /**
         * 判断当前倒计时是否到监听的时间点
         * @param realTime {object} 参考render参数
         * @return boolean
         */
        isToListenPoint: function isToListenPoint(realTime) {
            var self = this,
                listenPoint = self.get('listenPoint'),
                realTime = self.combineTime(realTime);

            return realTime <= listenPoint;
        },
        destroy: function destroy() {
            clearTimeout(this.countDown);
        },

        destroys: function destroys() {
            clearTimeout(this.countDown);
        }
    });

    module.exports = Timer;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 101 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
    /**
     * @file 基础Event
     * @author 子虔
     * @date    2014-08-04 16:11:13
     * @example
     *        * 支持多个事件的添加、移除、派发
     *            this.on('name1,name2,name3',function(){});
     *        * 支持使用层次的方式调用子对象的事件
     *            this.on('parent/child/child/name',function(){}); === this.parent.child.child.on(name,function(){})
     */
    var Callbacks = __webpack_require__(103),
        channelObj = {};

    // 统一事件机制
    var Events = {
        Event: Callbacks,
        /**
         * 添加事件监听
         * @param  {string}   name - 事件名称
         * @param  {function} callback - 事件回调
         */
        on: function on(name, callback) {
            var obj,
                that = this;

            this.events = this.events || {};

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.on(item, callback);
                    }
                });
            }

            if (!this.global && name.indexOf('/') != -1) {
                // 频道监听
                if (name.split('/')[0] == 'channel') {
                    return that.channel.on(name.replace(/^channel\//gi, ''), callback);
                }

                obj = getObjectByNames(name, this);
                this.events[name] = this.events[name] || [];
                this.events[name].push(callback);
                return obj ? obj.on(getEventName(name), callback) : this;
            } else {
                obj = this.events[name] || (this.events[name] = this.Event());
            }

            // 如果设置为一起派发，则再次监听时，直接执行
            if (this._alwayEmitSource && this._alwayEmitSource[name]) {
                return callback.apply(name, this._alwayEmitSource[name]);
            }
            obj.add(callback);

            return this;
        },
        /**
         * 移除事件监听
         * @param  {string}   name     事件名称
         * @param  {function} [callback] - 事件回调，为空时，移除所有回调
         */
        off: function off(name, callback) {
            var obj,
                funs,
                that = this;

            this.events = this.events || {};

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.off(item, callback);
                    }
                });
            }

            if (!this.global && name && name.indexOf('/') != -1) {
                if (name.split('/')[0] == 'channel') {
                    return that.channel.off(name.replace(/^channel\//gi, ''), callback);
                }

                if (this.events[name]) {
                    obj = getObjectByNames(name, this);
                    if (callback) {
                        return obj ? obj.off(getEventName(name), callback) : this;
                    } else {
                        funs = this.events[name];
                        for (var i = 0; obj && funs && i < funs.length; i++) {
                            obj.off(getEventName(name), funs[i]);
                        }
                        this.events[name] = null;
                    }
                }

                return this;
            }

            if (name && callback && (obj = this.events[name])) {
                obj.remove(callback);
            } else if (name && (obj = this.events[name])) {
                obj.empty();
            } else {

                for (name in this.events) {
                    if (this.events.hasOwnProperty(name) && this.events[name]) {
                        if (!this.global && name.indexOf('/') != -1) {
                            if (name.split('/')[0] == 'channel') {
                                return this.channel.off(name.replace(/^channel\//gi, ''));
                            }
                            this.off(name);
                        } else {
                            this.events[name].empty();
                        }
                    }
                }
            }

            return this;
        },
        ///**
        // * 只监听一次事件
        // * @param name
        // * @param callback
        // */
        //once: function (name, callback) {
        //    var _callback;
        //
        //    this.on(name, _callback = function () {
        //        callback.apply(this, arguments);
        //        this.off(name, _callback);
        //    });
        //},
        /**
         * 默认派发事件
         * @return {object}
         */
        trigger: function trigger() {
            var name = arguments[0],
                obj,
                param,
                that = this;

            this.events = this.events || {};
            param = Array.prototype.slice.call(arguments, 1);

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.trigger.apply(this, [item].concat(param));
                    }
                });
            }

            if (!this.global && name && name.indexOf('/') != -1) {
                if (name.split('/')[0] == 'channel') {
                    return that.channel.trigger.apply(that.channel, [name.replace(/^channel\//gi, '')].concat(param));
                }
                obj = getObjectByNames(name, this);
                name = getEventName(name);
                return obj ? obj.trigger.apply(obj, [name].concat(param)) : this;
            }

            if (name && (obj = this.events[name])) {
                obj.fire.apply(this, [].concat(param));
            }

            return {
                event: obj,
                always: function always() {
                    that._alwayEmitSource = that._alwayEmitSource || {};
                    that._alwayEmitSource[name] = [].concat(param);
                }
            };
        },
        /**
         * 派发事件
         * @example
         *        this.emit('ready',args0,args1...);
         */
        emit: function emit() {
            return this.trigger.apply(this, arguments);
        }
    };

    /**
     * 获取context下的name属性
     * @private
     */
    function getObjectByNames(name, context) {
        var that, names, len;

        context = context || {};
        that = context;
        names = name.split('/');
        len = names.length;

        for (var i = 0; len > 1 && i < len - 1; i++) {
            if (that && that[names[i]]) {
                that = that[names[i]];
            } else {
                that = null;
            }
        }

        return that;
    }

    /**
     * 获取事件名称
     * @param  {String} name [description]
     * @return {String}
     */
    function getEventName(name) {
        var names = name.split('/');
        return names[names.length - 1];
    }

    // global single Event
    Events.channel = $.channel || ($.channel = $.extend(channelObj, Events));
    Events.channel.global = Events.channel;

    module.exports = Events;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    /**
     * @fileoverview callbacks
     * @author 子虔
     * @date    2014-08-31 12:09:10
     */
    module.exports = function (options) {
        options = $.extend({}, options);

        var memory,
            // Last fire value (for non-forgettable lists)
        _fired,
            // Flag to know if list was already fired
        firing,
            // Flag to know if list is currently firing
        firingStart,
            // First callback to fire (used internally by add and fireWith)
        firingLength,
            // End of the loop when firing
        firingIndex,
            // Index of currently firing callback (modified by remove if needed)
        list = [],
            // Actual callback list
        stack = !options.once && [],
            // Stack of fire calls for repeatable lists
        fire = function fire(data) {
            memory = options.memory && data;
            _fired = true;
            firingIndex = firingStart || 0;
            firingStart = 0;
            firingLength = list.length;
            firing = true;
            for (; list && firingIndex < firingLength; ++firingIndex) {
                if (list[firingIndex].apply(data[0], data[1]) === false && options.stopOnFalse) {
                    memory = false;
                    break;
                }
            }
            firing = false;
            if (list) {
                if (stack) stack.length && fire(stack.shift());else if (memory) list.length = 0;else Callbacks.disable();
            }
        },
            Callbacks = {
            list: list,
            add: function add() {
                if (list) {
                    var start = list.length,
                        add = function add(args) {
                        args = Array.prototype.slice.call(args);
                        args.forEach(function (arg, _) {
                            if (typeof arg === "function") {
                                if (!options.unique || !Callbacks.has(arg)) list.push(arg);
                            } else if (arg && arg.length && typeof arg !== 'string') add(arg);
                        });
                    };
                    add(arguments);
                    if (firing) firingLength = list.length;else if (memory) {
                        firingStart = start;
                        fire(memory);
                    }
                }
                return this;
            },
            remove: function remove() {
                var args = Array.prototype.slice.call(arguments);
                if (list) {
                    args.forEach(function (arg, _) {
                        var index;
                        while ((index = list.indexOf(arg, index)) > -1) {
                            list.splice(index, 1);
                            // Handle firing indexes
                            if (firing) {
                                if (index <= firingLength) --firingLength;
                                if (index <= firingIndex) --firingIndex;
                            }
                        }
                    });
                }
                return this;
            },
            has: function has(fn) {
                return !!(list && (fn ? list.indexOf(fn) > -1 : list.length));
            },
            empty: function empty() {
                firingLength = list.length = 0;
                return this;
            },
            disable: function disable() {
                list = stack = memory = undefined;
                return this;
            },
            disabled: function disabled() {
                return !list;
            },
            lock: function lock() {
                stack = undefined;
                if (!memory) Callbacks.disable();
                return this;
            },
            locked: function locked() {
                return !stack;
            },
            fireWith: function fireWith(context, args) {
                if (list && (!_fired || stack)) {
                    args = args || [];
                    args = [context, args.slice ? args.slice() : args];
                    if (firing) stack.push(args);else fire(args);
                }
                return this;
            },
            fire: function fire() {
                return Callbacks.fireWith(this, arguments);
            },
            fired: function fired() {
                return !!_fired;
            }
        };

        return Callbacks;
    };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    /**
     * @file 继承和扩展
     * @author 子虔
     * @date    2014-08-15 11:24:20
     * @param  {Object} protoProps  子类的prototype
     * @param  {[type]} staticProps 子类的静态方法或属性
     * @return {Class}
     */
    var inherits = __webpack_require__(105);

    module.exports = function (protoProps, staticProps) {
        var parent = this,
            child,
            destroy;

        // The constructor function for the new subclass is either defined by you
        // (the "constructor" property in your `extend` definition), or defaulted
        // by us to simply call the parent's constructor.
        if (protoProps && protoProps.hasOwnProperty('constructor')) {
            child = protoProps.constructor;
        } else {
            child = function child() {
                return parent.apply(this, arguments);
            };
        }

        // inherits
        inherits(child, parent, protoProps, staticProps);

        // 销毁自动继承
        if (protoProps.hasOwnProperty('destroy') && (destroy = protoProps.destroy)) {
            protoProps.destroy = function () {
                try {
                    destroy.apply(this, arguments);
                } catch (e) {}

                try {
                    parent.prototype.destroy.apply(this, arguments);
                } catch (e) {}
            };
        }

        return child;
    };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
    /**
     * @file 继承并在原型链中提供`Parent`方法，用于调用父类prototype中的方法
     * @author 子虔
     * @date    2015-02-15 15:11:23
     */
    module.exports = function (child, parent, protoProps, staticProps) {
        // 绑定静态属性
        $.extend(child, parent, staticProps);

        function Prototype() {
            this.constructor = child;
        }

        Prototype.prototype = parent.prototype;

        child.prototype = new Prototype();

        // 绑定新的属性
        if (protoProps) {
            $.extend(child.prototype, protoProps);
        }

        // merge the Class's default's prototype
        child.prototype.defaults = $.extend(true, {}, parent.prototype.defaults, child.prototype.defaults);

        // Set a convenience property in case the parent's prototype is needed
        // later.
        child.__super__ = parent.prototype;
        child.__class__ = [];

        if (!parent.__class__) {
            child.__class__.push(parent, child);
        } else {
            parent.__class__.forEach(function (item) {
                child.__class__.push(item);
            });
            child.__class__.push(child);
        }

        child.prototype.Parent = function Parent() {
            var caller,
                name,
                parent,
                allClass = this.constructor.__class__,
                allClassLength = allClass.length,
                i = allClassLength - 1,
                args = arguments,
                argsLen = args.length;

            if (argsLen == 2 && typeof args[0] == 'function' && isArgsObject(args[1])) {
                caller = args[0];
                args = args[1] || [];
            } else {
                caller = Parent.caller;
                args = arguments;
            }

            if (!caller) return;

            while (i > 0 && !name) {
                var fun = allClass[i],
                    fn = fun.prototype;
                for (var p in fn) {
                    if (fn.hasOwnProperty(p) && fn[p] === caller) {
                        name = p;
                        parent = allClass[i - 1];
                    }
                }
                i--;
            }

            if (name && parent) {
                if (parent.prototype[name]) {
                    return parent.prototype[name].apply(this, args);
                }
            }
        };
    };

    // 判断一个对象是否为arguments对象
    function isArgsObject(obj) {
        var type = Object.prototype.toString.call(obj);
        return type === '[object Arguments]';
    }
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {

    /**
     * @file 类属性相关的扩展
     * @author 子虔
     * @date    2014-08-18 17:41:24
     */

    var parseParam = __webpack_require__(58),
        isEqual = __webpack_require__(59);

    module.exports = {
        /**
         * 设置参数，可通过`a/b/c/d`的方式设置
         * @param {*} name - 名称或对象
         * @param {*} [value] - 属性值
         * @param {boolean} [silent=false] - 设置的值变化时，是否派发事件
         */
        set: function set(name, value, silent) {
            var data,
                names,
                lastValue,
                len,
                that = this;

            if (typeof name == 'string') {
                names = name.split('/');
                len = names.length;
                if (len > 1) {
                    names.forEach(function (item, index) {
                        if (index == len - 1) {
                            lastValue = data[item];
                            data[item] = value;
                            if (!silent && !isEqual(lastValue, value)) {
                                bubbling.call(that, names, value, lastValue);
                            }
                        } else {
                            data = data || that.attributes;
                            data[item] = data[item] || {};
                            data = data[item];
                        }
                    });
                    return;
                }
            }

            function bubbling(names, value, lastValue) {
                var name = names.length == 1 ? names[0] : names.join('/');

                if (names.length > 0) {
                    this.emit('change:' + name, value, lastValue);
                    names.pop();
                    bubbling.call(this, names, value, lastValue);
                }
            }

            return this.Parent(set, arguments);
        },
        /**
         * 获取参数,可通过`a/b/c/d`获取如上`set`例子中的`d`值
         * @param {string} name - 名称
         * @return {*}
         */
        get: function get(name) {
            var that = this,
                names,
                value = '',
                data,
                len;

            if (typeof name == 'string') {
                names = name.split('/');
                len = names.length;

                if (len > 1) {
                    names.forEach(function (item, index) {
                        if (index == len - 1 && data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) == 'object') {
                            value = data[item];
                        } else {
                            data = data || that.attributes;
                            data[item] = data[item];
                            data = data[item];
                        }
                    });

                    return value;
                }
            }

            return this.Parent(get, arguments);
        }
    };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = {
    "10%满钻优惠": "10% uDiamonds bonus",
    "<%=count%>条新消息": "<%=count%>new messages",
    "<%=count%>经验值": "<%=count%> EXP",
    "<%=giftName%>最喜欢<%=giftName1%>和别人点它啦~点击<%=giftName%>或者送<%=giftName1%>礼物，可以帮助主播收服<%=giftName%>哦！": "<%=giftName%> favorite <%=giftName1%> and tap it! Tap <%=giftName%> or send <%=giftName1%> to the host to catch the <%=giftName%>",
    "<%=giftName%>最喜欢<%=giftName1%>和有人点它!快点帮助主播收服调皮的<%=giftName%>吧!快尝试一下！": "<%=giftName%> favorite <%=giftName1%> and tap it! Help the host to catch the naughty <%=giftName%>!",
    "<%=name%>以<%=money%>U钻价格，晋升为主播的守护": "<%=name%> used <%=money%> diamonds to become the host's Guardian Angel!",
    "<%=name%>的更多小视频": "More short videos of <%=name%>",
    "<%=name%>的直播间": "<%=name%>'s stream － Uplive , live it up",
    "<%=name%>被<%=label%><%=userName%>禁言": "<%=name%> has been banned from speaking by <%=label%><%=userName%>",
    "<%=name%>被<%=label%><%=userName%>移除直播间": "<%=name%> has been moved out of the room by <%=label%><%=userName%>",
    "<%=name%>被<%=label%><%=userName%>解除禁言": "<%=name%>has been released from banned speaking by <%=label%><%=userName%>",
    "<%=name%>被主播任命为场控": "<%=name%>is named as room admin by the host",
    "<%=name%>被主播移除场控身份": "The host dismissed the Room Admin <%=name%>",
    "<%=name%>被禁言": "<%=name%> is banned to chat.",
    "<%=name%>被移出直播间": "<%=name%> has been removed from this chat room.",
    "<%=name%>被解除禁言": "<%=name%> 's ban on chatting is released.",
    "<%=name%>进入了房间": "<%=name%> enters the chat room",
    "<%=name%>进入直播间": "<%=name%> enter the chat room",
    "<%=num%>分钟前": "<%=num%> minutes ago",
    "<%=num%>天前": "<%=num%> days ago",
    "<%=num%>小时前": "<%=num%> hours ago",
    "<%=num%>年前": "<%=num%> years ago",
    "<%=num%>月前": "<%=num%> months ago",
    "<%=sname%>悄悄@<%=rname%>": "<%=sname%>Poke@<%=rname%>",
    "<%=userName%>坐着<%=carName%>进入了直播间": "Welcome <%=userName%> enter the chatting room on <%=carName%>",
    "<em>Hi,<%=name%>,</em>没有找到心仪的主播？来看看我吧~": "<em>Hi,<%=name%></em>, haven't found your ideal host yet? Come check me out~",
    "<em>Hi,<%=name%>,</em>送你一个<b>小礼物</b>,快来跟我互动吧": "<em>Hi,<%=name%>, </em> sent you a <b>small gift</b>, come chat!",
    "<em>登录</em>之后即可进行充值": "<em>Login</em>in order to recharge",
    "@TA": "@User",
    "AD": "Andorra",
    "AE": "United Arab Emirates",
    "AF": "Afghanistan",
    "AG": "Antigua and Barbuda",
    "AI": "Anguilla",
    "AL": "Albania",
    "AM": "Armenia",
    "AN": "Netherlands Antilles",
    "AO": "Angola",
    "AQ": "Antarctica",
    "AR": "Argentina",
    "AS": "American Samoa",
    "AT": "Austria",
    "AU": "Australia",
    "AW": "Aruba",
    "AZ": "Azerbaijan",
    "Android下载": "Android download",
    "BA": "Bosnia and Herzegovina",
    "BB": "Barbados",
    "BD": "Bangladesh",
    "BE": "Belgium",
    "BF": "Burkina Faso",
    "BG": "Bulgaria",
    "BH": "Bahrain",
    "BI": "Burundi",
    "BJ": "Benin",
    "BL": "Saint Barthelemy",
    "BM": "Bermuda",
    "BN": "Brunei",
    "BO": "Bolivia",
    "BR": "Brazil",
    "BS": "Bahamas",
    "BT": "Bhutan",
    "BW": "Botswana",
    "BY": "Belarus",
    "BZ": "Belize",
    "CA": "Canada",
    "CC": "Cocos Islands",
    "CD": "Democratic Republic of the Congo",
    "CF": "Central African Republic",
    "CG": "Republic of the Congo",
    "CH": "Switzerland",
    "CI": "Ivory Coast",
    "CK": "Cook Islands",
    "CL": "Chile",
    "CM": "Cameroon",
    "CN": "China",
    "CO": "Colombia",
    "CR": "Costa Rica",
    "CU": "Cuba",
    "CV": "Cape Verde",
    "CW": "Curacao",
    "CX": "Christmas Islands",
    "CY": "Cyprus",
    "CZ": "Czech Republic",
    "DE": "Germany",
    "DJ": "Djibouti",
    "DK": "Denmark",
    "DM": "Dominica",
    "DO": "Dominican Republic",
    "DZ": "Algeria",
    "EC": "Ecuador",
    "EE": "Estonia",
    "EG": "Egypt",
    "EH": "Western Sahara",
    "ER": "Eritrea",
    "ES": "Spain",
    "ET": "Ethiopia",
    "FI": "Finland",
    "FJ": "Fiji",
    "FK": "Falkland Islands",
    "FM": "Micronesia",
    "FO": "Faroe Islands",
    "FR": "France",
    "GA": "Gabon",
    "GB": "United Kingdom",
    "GD": "Grenada",
    "GE": "Georgia",
    "GG": "Guernsey",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GIFTO余额不足": "Insufficient GIFTO",
    "GL": "Greenland",
    "GM": "Gambia",
    "GN": "Guinea",
    "GQ": "Equatorial Guinea",
    "GR": "Greece",
    "GT": "Guatemala",
    "GTO": "GTO",
    "GU": "Guam",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "Google Play": "Google Play",
    "HK": "Hong Kong",
    "HN": "Honduras",
    "HR": "Croatia",
    "HT": "Haiti",
    "HU": "Hungary",
    "ID": "Indonesia",
    "IE": "Ireland",
    "IL": "Israel",
    "IM": "Isle of Man",
    "IN": "India",
    "INTELLECTUAL PROPERTY RIGHTS": "INTELLECTUAL PROPERTY RIGHTS",
    "IO": "British Indian Ocean Territory",
    "IQ": "Iraq",
    "IR": "Iran",
    "IS": "Iceland",
    "IT": "Italy",
    "JE": "Jersey",
    "JM": "Jamaica",
    "JO": "Jordan",
    "JP": "Japan",
    "KE": "Kenya",
    "KG": "Kyrgyzstan",
    "KH": "Cambodia",
    "KI": "Kiribati",
    "KM": "Comoros",
    "KN": "Saint Kitts and Nevis",
    "KP": "North Korea",
    "KR": "South Korea",
    "KW": "Kuwait",
    "KY": "Cayman Islands",
    "KZ": "Kazakhstan",
    "LA": "Laos",
    "LB": "Lebanon",
    "LC": "Saint Lucia",
    "LI": "Liechtenstein",
    "LK": "Sri Lanka",
    "LR": "Liberia",
    "LS": "Lesotho",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "LV": "Latvia",
    "LY": "Libya",
    "Line": "Line",
    "MA": "Morocco",
    "MC": "Monaco",
    "MD": "Moldova",
    "ME": "Montenegro",
    "MF": "Saint Martin",
    "MG": "Madagascar",
    "MH": "Marshall Islands",
    "MK": "Macedonia",
    "ML": "Mali",
    "MM": "Myanmar",
    "MN": "Mongolia",
    "MO": "Macau",
    "MP": "Northern Mariana Islands",
    "MR": "Mauritania",
    "MS": "Montserrat",
    "MSL": "the Middle East",
    "MT": "Malta",
    "MU": "Mauritius",
    "MV": "Maldives",
    "MW": "Malawi",
    "MX": "Mexico",
    "MY": "Malaysia",
    "MYC": "\nMalay Chinese Region",
    "MYNC": "Malay Non-Chinese Region",
    "MZ": "Mozambique",
    "NA": "Namibia",
    "NC": "New Caledonia",
    "NE": "Niger",
    "NG": "Nigeria",
    "NI": "Nicaragua",
    "NL": "Netherlands",
    "NO": "Norway",
    "NP": "Nepal",
    "NR": "Nauru",
    "NU": "Niue",
    "NZ": "New Zealand",
    "OM": "Oman",
    "PA": "Panama",
    "PE": "Peru",
    "PF": "French Polynesia",
    "PG": "Papua New Guinea",
    "PH": "Philippines",
    "PK": "Pakistan",
    "PL": "Poland",
    "PM": "Saint Pierre and Miquelon",
    "PN": "Pitcairn",
    "PR": "Puerto Rico",
    "PS": "Palestine",
    "PT": "Portugal",
    "PW": "Palau",
    "PY": "Paraguay",
    "Privacy Policy": "Privacy Policy",
    "QA": "Qatar",
    "RE": "Reunion",
    "RO": "Romania",
    "RS": "Serbia",
    "RU": "Russia",
    "RW": "Rwanda",
    "SA": "Saudi Arabia",
    "SB": "Solomon Islands",
    "SC": "Seychelles",
    "SD": "Sudan",
    "SE": "Sweden",
    "SG": "Singapore",
    "SH": "Saint Helena",
    "SI": "Slovenia",
    "SJ": "Svalbard and Jan Mayen",
    "SK": "Slovakia",
    "SL": "Sierra Leone",
    "SM": "San Marino",
    "SN": "Senegal",
    "SO": "Somalia",
    "SR": "Suriname",
    "SS": "South Sudan",
    "ST": "Sao Tome and Principe",
    "SV": "El Salvador",
    "SX": "Sint Maarten",
    "SY": "Syria",
    "SZ": "Swaziland",
    "TC": "Turks and Caicos Islands",
    "TD": "Chad",
    "TG": "Togo",
    "TH": "Thailand",
    "TJ": "Tajikistan",
    "TK": "Tokelau",
    "TL": "East Timor",
    "TM": "Turkmenistan",
    "TN": "Tunisia",
    "TO": "Tonga",
    "TR": "Turkey",
    "TT": "Trinidad and Tobago",
    "TV": "Tuvalu",
    "TW": "Taiwan",
    "TZ": "Tanzania",
    "Terms of Service": "Terms of Service",
    "UA": "Ukraine",
    "UG": "Uganda",
    "US": "United States",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "Up号": "Up account",
    "Up号:<%=code%>": "Up account:<%=code%>",
    "Up直播-直播全世界": "Uplive - Live it UP!",
    "Up直播网页版不支持红包功能，请您下载Up直播 App版本体验更多有趣功能！": "This feature is not avaible. please download Uplive to get this red packet.",
    "U币": "Coins",
    "U币余额不足": "Insufficient coin balance",
    "U币兑换": "U coin exchange",
    "U币贡献榜": "Top Fans",
    "U钻": "Diamond",
    "U钻余额": "Balance",
    "U钻充值": "Udiamond recharge",
    "U钻兑换失败，请稍候重试": "Diamond exchange failed, please try again",
    "U钻兑换成功": "Diamond exchange successful",
    "VA": "Vatican",
    "VC": "Saint Vincent and the Grenadines",
    "VE": "Venezuela",
    "VG": "British Virgin Islands",
    "VI": "U.S. Virgin Islands",
    "VIP_level_1": 6000,
    "VIP_level_10": 12000000,
    "VIP_level_2": 30000,
    "VIP_level_3": 60000,
    "VIP_level_4": 120000,
    "VIP_level_5": 300000,
    "VIP_level_6": 600000,
    "VIP_level_7": 1200000,
    "VIP_level_8": 3000000,
    "VIP_level_9": 6000000,
    "VIP_recharge_1": 10000,
    "VIP_recharge_10": 20000000,
    "VIP_recharge_2": 50000,
    "VIP_recharge_3": 100000,
    "VIP_recharge_4": 200000,
    "VIP_recharge_5": 500000,
    "VIP_recharge_6": 1000000,
    "VIP_recharge_7": 2000000,
    "VIP_recharge_8": 5000000,
    "VIP_recharge_9": 10000000,
    "VIP介绍": "VIP membership",
    "VIP保级要求-": "VIP maintain requirement-",
    "VIP充值": "VIP Top-up",
    "VIP充值要求-": "VIP recharge requirement-",
    "VIP勋章": "VIP badge",
    "VIP勋章特权说明": "VIP badge shows your honorable status",
    "VIP勋章获取条件": "VIP1 or higher",
    "VIP客服": "VIP customer service",
    "VIP形容内容": "VIP is a distinguish status with a series of privileges like special animated swagger, free whispering, etc.",
    "VIP是什么": "What is VIP",
    "VIP有效时间：<%=time%>": "VIP valid period: <%=time%>",
    "VIP特权": "VIP privilege",
    "VIP特权介绍": "VIP privileges details",
    "VIP特权内容": "1. Exclusive VIP customer service to resolve any issues quickly @@@@ 2. One-to-one customer service specialist for each VIP user @@@@ 3. VIP special effects when entering a broadcast room @@@@ 4. Whisper is free",
    "VIP用户在个人主页、聊天室等将有不一样的个人展示。": "Distinctive logo for VIP shown in chat room, personal page",
    "VIP用户进入聊天室，会有不一样的入场特效！": "Enjoy distinctive animation entry effect",
    "VIP用户，悄悄话全部免费使用呦！": "Free whisper for VIP",
    "VIP的升级/保级体系": "VIP levelling up / maintaining system",
    "VIP的升级/保级体系内容": "@@@@To maintain your VIP level, you need to recharge the required amount in the next month. Qualified monthly recharge extends your VIP level for one month. Not doing so will decrease your VIP level by one. For example, if you are VIP1 this month, and you failed to maintain your VIP level, your level will decrease to VIP0 next month, that means you will lose your VIP status.",
    "VIP的升级/保级体系内容_bak": "VIP levelling up / maintaining system details",
    "VIP等级": "VIP Level",
    "VIP等级及对应充值额度": "VIP Level and diamonds required",
    "VIP等级特权": "VIP level privileges",
    "VIP获得方式": "How to obtain VIP status",
    "VIP获得方式内容": "1. You will be rewarded VIP status of tier @@@@ based on the diamonds purchased within a calendar month 2. Purchasing diamonds is the only way to obtain and level up VIP status to ",
    "VIP规则": "VIP Rules",
    "VIP规则内容": "1. After a user has obtained VIP status, a certain amount of diamond purchases within the calendar month is required to maintain the status for next month @@@@ 2. VIP users can perform actions on non-VIP users such as silencing them and banning them from a live stream",
    "VIP规则说明": "VIP rule explanation",
    "VIP规则说明内容": "@@@@ Monthly recharge amount is calculated at 00:00 of the 1st day of the month@@@@ If your monthly recharge amount meets the requirment, your VIP valid period will be extended for one month@@@@If your monthly recharge amount doesn't meet the requirment, your VIP level will be reduced by 1 level; If you happen to be a VIP1, you will lose your VIP idenfication.",
    "VN": "Vietnam",
    "VU": "Vanuatu",
    "W Motors莱肯": "Lykan HyperSport",
    "WF": "Wallis and Futuna",
    "WS": "Samoa",
    "XK": "Kosovo",
    "YE": "Yemen",
    "YT": "Mayotte",
    "ZA": "South Africa",
    "ZM": "Zambia",
    "ZW": "Zimbabwe",
    "app": "App",
    "banner": "You got an invitation to test new VIP function!\n03/02/2017",
    "codapay": "Codapay",
    "contact.html": "/up-contact/index.html",
    "convention.html": "/up-doc/convention_en.html",
    "danalpay": "DanalPay",
    "facebook.html": "https://www.facebook.com/uplivecam",
    "iOS下载": "App Store",
    "iPhone下载": "iPhone download",
    "icard_Code": "Code",
    "icard_Serial": "Serial",
    "icard_cardType": "CardType",
    "icard_cardValue": "CardValue",
    "icard_popup_confirm_title": "The information below is correct?",
    "icard_popup_no": "No",
    "icard_popup_yes": "Yes",
    "molpay_credit_card": "MOLPay Credit Card",
    "molpay_points": "zGOLD-MOLPoints",
    "mycard": "MyCard",
    "onecard": "OneCard",
    "paypal": "Paypal",
    "paytm": "Paytm",
    "pepay_entitycard": "CashCard(IDR)",
    "pepay_entitycard_vnd": "CashCardVND)",
    "pepay_onlinebank": "OnlineBank(IDR)",
    "pepay_onlinebank_vnd": "OnlineBank(VND)",
    "privacy.html": "/up-doc/privacy_en.html",
    "protocol.html": "/up-doc/protocol_en.html",
    "ta还没写签名呢，告诉ta?": "Tell them to write something about themselves!",
    "ta还没有签名呢，告诉ta?": "This user's status is empty, go tell them to write one!",
    "terms.html": "/up-doc/terms_en.html",
    "“不开森...没有拿够<%=giftName1%>”,<%=giftName%>失落的离开了直播间!下次努力": "\"So sad... <%=giftName1%> is not enough\"，<%=giftName%> left the room, do better next time!",
    "一个神秘的地方": "A mysterious place",
    "一条弹幕1U钻": "1 bullet message = 1 diamond",
    "一条弹幕<%=count%>U钻": "<%=count%>U diamond/danmu",
    "一段时间内禁止他人在此聊天室发布信息，过了禁言时间后才能重新发言。": "Ban someone from speaking for a certain period of time in this chat room",
    "上一小时": "Last Hour",
    "上周": "Last Week",
    "上周星榜": "Last week",
    "上月": "Previous month",
    "下一步": "Next",
    "下单失败": "Order failed",
    "下载": "Download",
    "下载 APP": "Download App",
    "下载Up直播APP": "Download Uplive App",
    "下载客户端": "Download Client",
    "下载客户端app领取分享红包": "Download client app to claim share red packets",
    "不能频繁发送邮件": "Can't send mail too frequently",
    "专一的守护，他所有的特权只对守护的主播生效": "3. Guardian Privileges are only valid for this particular host",
    "专享客服": "Enhanced customer service",
    "专属入场特效": "Premium animation effect",
    "专属弹幕": "Exclusive bullet messages ",
    "专属弹幕特权说明": "Exclusive VIP bullet messaging",
    "专属弹幕获取条件": "VIP7 or higher",
    "专属礼物": "Exclusive gifts",
    "专属礼物特权说明": "VIP exclusive customized gifts. Special gifts for special you!",
    "专属礼物获取条件": "VIP2 or higher",
    "个人主页": "Personal",
    "个人信息设定失败": "Fail to save",
    "个人信息设定成功": "Saved success",
    "个人资料": "Profile",
    "为保证您的账户和财产安全，请绑定手机号": "To protect the security of your account and personal data, please bind your phone number to your account",
    "主播": "Host",
    "主播可能在休息，稍后再来试试吧": "The host is having a rest, please check later",
    "主播回来了，视频即将恢复！": "Host is back!",
    "主播暂时离开了，小伙伴们请稍候。": "Host has temporarily left the room, please wait a bit",
    "主播榜": "Host board",
    "主播榜单": "Host Rank",
    "主播的守护天使<%=name%>，进入直播间，掌声在哪里！": "The host's Guardian Angel <%=name%> has entered the chat room, please give a round of applause!",
    "主页": "Profile",
    "举报": "Report",
    "举报失败": "Report failed",
    "举报成功": "Report successful",
    "了解VIP等级及特权": "View VIP level and privileges ",
    "互相关注即可成为好友哦~": "If you follow each other, you will become friends!",
    "亚洲创新集团出品": "Asia Innovations Group Limited's product",
    "亲爱的<%=name%><br/>这么喜欢我，小礼物走一走呗～": "<%=name%><br/>Surprise the host by sending a gift",
    "今日可提现金额": "Daily available balance :",
    "付款遇到问题？点击联系客服": "Experiencing payment problems? Click here to contact customer service",
    "余额不足情况下，充值提醒的描述": "Please recharge",
    "你也可以花费更高的价钱，将自己守护的时间重新变为4天": "You can also pay a higher price and renew your guardianship to 4 days.",
    "你关注的人现在没有开播": "Followed host isn't streaming currently",
    "你关注的人还没有直播": "None of your followings is boardcasting.",
    "你已经将<%=name%>禁言": "You've banned <%=name%> from speaking",
    "你已经将<%=name%>移除直播间": "You've moved <%=name%> out from this room",
    "你已经将<%=name%>解除禁言": "You've released <%=name%> from banned speaking",
    "你来晚了，已经被抢完了，下次加油": "You are too late...Nothing left.",
    "你来晚了，红包已经发放完了, 下次加油！": "You are too late...Nothing left.",
    "你没有权限进行该操作": "You don't have permission to do this",
    "你现在是游客身份": "You are currently in visitor mode",
    "你的发言频率太快，休息一下吧！": "You are sending too many chat messages, please take a break!",
    "你的禁言时间已到，自动解除禁言": "Your ban on speaking has expired and you can now comment again",
    "你的账号未绑定任何信息，请绑定后再进行此操作": "Your account has not bound any other accounts, please bind then try again",
    "你确定要消耗<%=count%>U钻帮助主播收服小精灵吗？": "Spend <%=count%> diamond to help the host catch the Little Monster, ok?",
    "你被<%=userName%>禁言<%=time%>分钟": "You've been banned from speaking for <%=time%> minutes by <%=userName%>",
    "你赠送礼物的U钻将会随机分给领取礼物的人": "The diamonds from the gift you sent will be randomly distributed to users who got the gift",
    "使用CashCard充值所得U钻数将根据兑换比例(<%=currence%><%=real%>=<%=number%>钻)进行换算，最终所得U钻数会进行四舍五入处理": "uDiamonds amount obtained by using CashCard recharge will be converted according to conversion ratio (<%=currence%><%=real%>=<%=number%>uDiamonds), and the final uDiamonds amount will be rounded off.",
    "使用CashCard充值的金额数以点卡实际支付的金额为准": "Money amount recharged using CashCard is based on the amount actually paid by point card.",
    "保存": "Save",
    "保级成功，下月可继续尊享<%=grade%>，本月再充值<%=count%>U钻可升级为<%=grade1%>，尊享更多特权": "You have maintained your level. You’ll continue enjoying<%=grade%> next month. Recharge <%=count%> more uDiamonds in this month to level up to <%=grade1%> and enjoy more privileges.",
    "保级要求(U钻)": "Maintenance requirement (uDiamonds)",
    "充值": "Recharge",
    "充值成功": "Recharge successfully",
    "充值数量": "Recharge amount",
    "充值方式": "Recharge option",
    "充值档位参考": "Recharge tier reference",
    "充值比例: <%=currence%><%=real%>=<%=number%>U钻": "Conversion Ratio: <%=currence%><%=real%>=<%=number%>uDiamonds",
    "充值要求(U钻)": "Recharge requirement (uDiamonds)",
    "充值遇到问题,点此": "If experiened with recharge problems, please click here",
    "免费下载": "Free download",
    "免费悄悄话": "Free private messages",
    "免费悄悄话特权说明": "Free private messages in chat rooms",
    "免费悄悄话获取条件": "VIP1 or higher",
    "全区广播": "Public broadcast",
    "全区广播1000U钻": "Global speak: 1000 diamond",
    "全区广播<%=count%>U钻": "Radio <%=count%>U diamond",
    "全部": "View all",
    "全部提现": "Withdraw All",
    "全部游戏类型": "All game genres",
    "兰博基尼Huracan": "Lamborghini Huracan",
    "关于我们": "About Us",
    "关于我们内容": "Uplive, founded in May 2016, has powerful international resources, excellent host resources and worldwide user groups, focuses on establishing an international Live Platform, which is a talent agency of instant online celebrities and models with special background, involving best content creation and top host resources.",
    "关注": "Follow",
    "关注了主播，从此不再错过。": "followed this host",
    "关注动词": "Follow",
    "关注成功": "Followed successfully",
    "关注成功，已解除拉黑": "Followed successfully, removed from blacklist",
    "关注隐身": "Invisible follow",
    "关注隐身特权说明": "Make your follow invisible on the fan list of your host. Take care of your host silently",
    "关注隐身获取条件": "VIP5 or higher",
    "其他": "Others",
    "其他用户花费更高的价钱，将会顶替你成为主播的守护天使": "4. Other users can pay a higher price to replace the current guardian.",
    "其他登录方式": "Other login method",
    "再试一次": "Try again",
    "写个签名吧，让大家了解你。": "Tell people about yourself",
    "分享": "Share",
    "分享失败": "Share failed",
    "分享成功": "Share successfully",
    "刚刚": "Just now",
    "删除该聊天": "Delete this chat",
    "别太贪心，你已经领取过了": "You've taken it already! Don't be greedy.",
    "刷一下": "Refresh",
    "剩余<%=count%>分": "Remaining <%=count%> Minutes",
    "剩余<%=count%>天": "Remaining <%=count%> Days",
    "剩余<%=count%>小时": "Remaining <%=count%> Hours",
    "剩余<%=count%>秒": "Remaining <%=count%> Seconds",
    "剩余<%=time%>重置榜单": "<%=time%> remain to reset ranking",
    "剩余U钻": "Remaining uDiamonds",
    "加个好友吧。聊嗨了才能拉近你们的距离哦！": "Add as friend to chat anytime, get closer~",
    "加个好友吧，聊嗨了才能拉近你们的距离哦！": "Add friends to shorten your distance by chatting ",
    "加载中": "Loading…",
    "动态特权": "Status advantages ",
    "动态特权特权说明": "Being a VIP, your posts and comments will be highlighted in your VIP frame with lit VIP badge. ",
    "动态特权获取条件": "VIP1 or higher ",
    "劳斯莱斯幻影": "Rolls-Royce Phantom",
    "升級VIP10后的文案提示": "Congratulations! You have unlocked the highest VIP level. No renew needed for this month!",
    "去充值": "Recharge",
    "去看看其他主播": "Check other hosts",
    "去看看当前热门直播": "Browse hot content",
    "去绑定": "Bind cellphone",
    "去绑定Payoneer": "Bind Payoneer",
    "参数错误": "error",
    "发出了<%=count%>个<%=giftName%>，距离收服<%=targetGiftName%>又近了一步！": " just released <%=count%> <%=giftName%>, we are getting closer to catch <%=targetGiftName%>!",
    "发现": "Discover",
    "发言太频繁了，请稍后再试": "You are posting too frequently, please try again later",
    "发言底纹": "Message background ",
    "发言底纹特权说明": "Customized chat bubbles allow your messages stand out from the crowd",
    "发言底纹获取条件": "VIP1 or higher",
    "发送": "Send",
    "发送动态前，请先给您的账户绑定上手机号码信息": "Please bind phone number with your account before sending statues",
    "发送消息前，请先给您的账户绑定上手机号码信息": "Please bind phone number with your account before sending message  ",
    "发送空消息主播感受不到你的爱哒…": "Blank message not allowed",
    "发送验证码": "Send verification code",
    "取消": "Cancel",
    "可提现金额": "Withdrawal amount :",
    "可提现金额：": "Withdrawal amount :",
    "启用Flash Player": "Enable Flash Player",
    "周榜": "Weekly",
    "哎哟，页面不见了": "The page not available now",
    "哎哟，页面无法查看，请稍候再试": "The page not available now, please try again later",
    "回复": "Reply",
    "国家/地区": "Country/Region",
    "国家或地区": "Country/Region",
    "圣劳伦佐SD126": "Sanlorenzo SL 126",
    "圣劳伦佐SL118": "Sanlorenzo SL 118",
    "圣汐115 Sport Yacht": "Sunseeker 115 Sport Yacht",
    "圣汐131Yacht": "Sunseeker 131 Yacht",
    "在看": "Viewers",
    "场控": "Room Admin",
    "天": "Day",
    "头像边框": "Avatar Frame",
    "头像边框特权说明": "VIP users light up their avatar frame unlike anyone else",
    "头像边框获取条件": "VIP1 or higher",
    "女": "Female",
    "好可惜～差一点点就抓住了小精灵，下次努力吧！": "What a pity! You almost caught the Little Monster! Try harder next time!",
    "好的": "OK",
    "如何升级": "How to level up",
    "如何升级详情": "Send gifts to your favorite hosts! The more gifts you send, the faster you'll level up!@@@@Want to try being a host? A talented host levels up faster!",
    "如何成为VIP": "How to become VIP",
    "如何成为VIP内容": "@@@@Gain VIP status when your total monthly recharge meets the requirements. @@@@recharge is the only way to gain and increase your VIP level.",
    "如何成为VIP内容_bak": "How to become VIP details",
    "娱乐": "Entertainment",
    "娱乐现场": "Entertainment Scene",
    "守护": "Guardian",
    "守护天使在保护主播4天后，会悄然离去": "Guardianship will disappear after guarding host for 4 days ",
    "守护座驾": "Guardian Car",
    "守护标识": "Guardian Icon",
    "守护特权": "Guardian Privileges",
    "守护规则": "Guardian rules",
    "守护规则说明": "Guardian terms",
    "完成": "Complete",
    "官方充值客服": "Official Customer Service",
    "官方助手": "Uplive Assistant",
    "官方客服": "Official Customer Service",
    "定制V认证": "Exclusive Badge",
    "定制V认证特权说明": "This feature is not avaible. Check back soon!",
    "定制V认证特权说明暂不开放": "Contact customer service to get your exclusive badge when you obtained this privilege. The privilege is valid when your VIP status is active. The privilege will not be available when your VIP level decreases. ",
    "定制V认证获取条件": "VIP4 or higher",
    "宝马M3": "BMW M3",
    "宾利慕尚": "Mulsanne",
    "密码由6-20位数字和字母组成": "Password length 6-20 characters (Only numbers and letters allowed)",
    "密码登录": "Password Login",
    "将他人移除直播间": "Remove someone out of the chat room",
    "将聊天室内乱发言的用户移除直播间。": "Remove a person from the chat room.",
    "尊享超过专属特权本月再充值<%=count%>U钻可升级为<%=grade%>，": "Enjoy more exclusive privileges by recharge <%=count%> more uDiamonds and level up to <%=grade%>",
    "尊贵名片": "VIP name card",
    "尊贵名片特权说明": "Customized luxury info card exclusively for VIP, a symbol of honorable status",
    "尊贵名片获取条件": "VIP1 or higher",
    "小时榜": "Hourly",
    "小时榜进行中": "Hourly rank is ongoing",
    "小时榜进行中 <%=count%>": "Hourly rank is ongoing <%=count%>",
    "小视频": "Short video",
    "小贴士": "Tips",
    "屏蔽全部特效": "Hide all special effects",
    "屏蔽小礼物": "Hide all small gifts",
    "屏蔽所有礼物": "Hide all gift animations",
    "屏蔽进场特效": "Hide all entry effects",
    "屏蔽频道广播": "Hide all stream broadcasts ",
    "展开更多": "More",
    "已关注": "Followed",
    "已加赠<%=count%>U钻": "<%=count%>U diamonds offered",
    "已发放待领取": "To be collected",
    "已取消分享": "Cancel share",
    "已添加": "Added",
    "已绑定": "Bound",
    "已绑定Paypal账号": "Bound Paypal account",
    "已退回": "Returned",
    "已领取": "Collected",
    "已验证，确认登录": "Verified, confirm login",
    "布加迪威航": "Bugatti Veyron",
    "帐号冻结": "Your account is frozen",
    "帐号或密码错误": "Wrong account or password",
    "帮助主播削弱<%=giftName%><%=count%>点战斗力，距离收服<%=giftName%>又近了一步！": "tapped <%=giftName%> <%=count%> times to help catch the <%=giftName%>",
    "应付金额": "Recharge amount",
    "庞巴迪全球快车": "Global Express XRS",
    "弹幕": "Bullet comment",
    "当前小时": "This Hour",
    "当日": "Today",
    "当月充值额度：<%=num%>": "This month recharge amount：<%=num%>",
    "微信": "WeChat",
    "微信号": "WeChat ID",
    "微信搜索并关注“Up小助手”可领取红包": "Search and subscribe to Wechat channel: 'Up小助手' to get lucky money",
    "微信支付": "WeChat",
    "忘记密码": "Forget Password",
    "快点下载Uplive，观看付费直播吧~": "Download Uplive now and enjoy paid streams!",
    "快点下载Uplive，观看私密直播吧~": "Download Uplive now and enjoy private streams!",
    "性别": "Gender",
    "总榜": "Overall",
    "恭喜<%=userName%>在<%=hostName%>的<%=title%>中赢得最高奖励": "Congrats to <%=userName%> for getting the highest amount <%=title%> from <%=hostName%> ",
    "恭喜你": "Congratulations!",
    "恭喜你成为主播的守护，从此你就是主播的人啦！": "Congratulations on becoming the Guardian Angel of the host!",
    "恭喜你获得": "Congratulations!",
    "恭喜发财，红包拿走": "Congratulations!",
    "悄悄@<%=name%>": "Poke@<%=name%>",
    "悄悄话": "Whisper",
    "悄悄话免费": "Whispering is free",
    "您下个月VIP级别": "Your VIP level next month",
    "您已被禁言": "You have been forbiddened!",
    "您已被移出直播间，请稍后再试": "You've been removed from this room and you cannot enter it for a while, please try again later",
    "您正在向<%=name%>发送好友申请": "You have sent friend request to <%=name%>",
    "您的VIP等级": "Your VIP level",
    "您的提现请求已成功发起，系统会在72小时内完成审核并发放奖励！": "Your withdrawal request has been confirmed, the system will review within 72 hours and send reward.",
    "您的账号可能存在安全风险，请立刻绑定手机号码。": "Your account may have safety risk, please bind your phone number immediately.",
    "您的账号在其他终端登录成功": "Your account has logged in on an other phone",
    "您还不是VIP贵族": "You are not a VIP yet",
    "您还未激活该VIP等级": "You have not activated this VIP level",
    "您还未选中或发起聊天，快去跟好友聊一聊吧": "You don't have any chats yet, start one now!",
    "成功帮助主播收服了<%=giftName%>！<%=giftName%>开心的离开了直播间~": "caught <%=giftName%> successfully! <%=giftName%> left happily~",
    "我们提倡绿色直播，只有通过审核并被标记为优质的主播才可能出现在热门，如封面和直播内容含有涉黄、低俗、吸烟、暴露等情况，将会被封禁账号。网警将保持24小时在线审核与审查，请您遵守。": "Content relating to violence, smoking, drugs or pornography is strictly prohibited. Administrators will be patrolling 24/7 and any users found with such content will be banned.",
    "我是<%=name%>": "I am <%=name%>",
    "我的U钻": "Diamonds",
    "我的VIP": "My VIP",
    "我的主页": "My profile",
    "我的会员": "My membership",
    "我的关注": "My Follows",
    "我的守护": "My Guardian",
    "我的直播": "My live stream",
    "我的等级": "My level",
    "我的背包": "My backpack",
    "我的账户": "My Account",
    "我的进场特效": "My appearance effects",
    "我知道了": "Noted",
    "我领取了<%=hostName%>的<%=title%>，获得<%=count%>U钻": "I got <%=title%> from <%=hostName%>，aqcuiring <%=count%> diamonds.",
    "战斗力": "Power",
    "所有解释权归Up直播所有": "UpLive reserves its right of final explanation of all the provisions, terms and other contents in relation to the VIP membership.\n",
    "手机号": "Mobile phone number",
    "手机号:": "Mobile No.:",
    "手机号已被绑定，请更换手机号": "Phone number registed, please change a number",
    "手机号输入错误": "Phone number input error",
    "手机注册/登录": "Mobile Register / Login",
    "手机登录": "Mobile Login",
    "打开Up直播<br/>扫一扫登录": "Open Up live <br/> and scan to log in",
    "扫一扫<br/>下载Uplive": "Scan <br/> to download Uplive",
    "扫码下载Uplive客户端": "Scan QR code to download Uplive",
    "扫码登录": "QR Code Login",
    "抢夺守护": "Buy Guardian Angel position",
    "拉黑": "Add to Blacklist",
    "拉黑后在热门列表中无法看到ta的直播": "Streams won't appear in your hot list after blacklisting.",
    "拉黑后将解除你与ta的关注关系<br/>在热门列表中无法看到ta的直播": "Adding to blacklist will remove the following relationship between you and the host\\n You won't see the them in the hot list anymore",
    "拉黑失败": "Failed to add to blacklist",
    "拉黑成功": "Added successfully to black list",
    "拉黑提示": "Blacklist notes",
    "拥有特权(<%=count%>/<%=total%>)": "You have privileges (<%=count%>/<%=total%>)&lrm;",
    "按下Enter发送内容": "Press enter to send",
    "按下这个，就完成赠送礼物了！": "Tap to send this gift ",
    "换个姿势重来一次": "Retry in another way",
    "授权失败": "Authorization failed",
    "排行榜": "Ranking",
    "推荐上热一": "Recommend No. 1 on hot list",
    "推荐上热门特权说明": "Contact your VIP customer service to recommend you host for the number one spot on global or regional hot list. Note: official accounts or recommendations by other VIP have priorities. -VIP9: one hour global No. 1 recommendation per month. Three of one hour regional No.1 recommendation per month. -VIP10: five recommendations for global No. 1 per month. Three recommendations for regional No. 1 per month. Recommended hosts are featured for one hour. ",
    "推荐上热门获取条件": "VIP9 or higher",
    "提现确认": "Withdraw",
    "提现账户：": "Withdrawal Up Accounts：",
    "提现遇到问题？点击联系客服": "Problem withdrawaling money? Click to contact with Customer Service",
    "提现金额": "Withdrawal amount",
    "提现错误": "Withdraw Error!!!",
    "提示": "Reminder",
    "提示内容": "Since the VIP function is under beta testing, if you run into any problem, feel free contact to our customer service. We apologise for the inconvenience that this may cause.",
    "搜索": "Search",
    "支付失败": "Payment failed",
    "支付失败，请重新下单": "Payment fails, please apply for a new order",
    "支付宝": "Alipay",
    "支付渠道": "Payment Method",
    "支持数字、字母和下划线组合，不支持的纯数字组合，不可重复，长度6~16个字符": "Up account supports the combination of numbers, letters and underscores.It cannot be only numbers and must be of 5-16 characters.",
    "收到的U币": "Received coins",
    "收到礼物数:<%=count%>": "number of gifts received: <%=count%>",
    "收服": "Caught",
    "收益提现": "Revenue is raised",
    "收看精彩直播": "Watch live highlights",
    "收获<%=count%>U币": "Gain <%=count%> Ucoins",
    "收费资讯": "Payment Information",
    "收起更多": "Retract",
    "放出了一只<%=giftName%><%=icon%>，大家快来帮主播收服它吧！": "just released one <%=giftName%><%=icon%>, everyone come to help the host catch it!",
    "政策限制不允许观看": "This video is no longer available accoding to laws and policies",
    "新人推荐": "Rookie Recommendation",
    "新用户注册<b>送精美礼品</b><em>与主播即时互动</em>": "New users are<b>gifted rewards</b>when registered<em> Come and interact with hosts now</em>",
    "无": "None",
    "日榜": "Daily",
    "明星主播": "Star Host",
    "星榜": "Stars",
    "昨日": "Yesterday",
    "是否解除该用户的禁言": "Cancle mute on this user?",
    "昵称": "Nickname",
    "昵称不能出现敏感词": "This nickname contents sensitive words",
    "晋升通知": "Level up notification",
    "晋升通知特权说明": "Your leveling up triggers big announcement across the platform. You are in the spotlight!",
    "晋升通知获取条件": "VIP1 or higher",
    "普清": "Normal",
    "暂无好友申请": "No friend request",
    "暂无数据": "No data",
    "暂无礼物": "Currently no gifts",
    "暂无被拉黑用户": "No one is blacklisted",
    "暂无领取记录": "No withdrawal record",
    "更多": "More",
    "更多国家": "More Countries",
    "更多热门直播": "More featured streams",
    "更多特权持续增加中...": "More privileges coming soon...",
    "最新": "Newest",
    "最新开播": "Newest Stream",
    "最新直播": "New Live",
    "最热": "Hottest",
    "最长可输入12个汉字": "max 12 characters",
    "最长可输入32个汉字": "max 32 character",
    "月榜": "Monthly",
    "有效期至:<%=time%>": "Expiration:",
    "未收到邮件": "Not yet receive email",
    "未知错误": "Unknown Error",
    "未绑定手机号": "Mobile not registed",
    "本周": "This Week",
    "本周星榜": "This week",
    "本月": "This month",
    "本月不需要保级，再充值<%=count%>U钻可升级为<%=grade%>，尊享更多特权": "No renew necessary for this month. Recharge <%=count%> uDiamonds to level up to <%=grade%> and unlock more privileges!",
    "本月再充值<%=count%>U钻可升级为<%=grade%>，尊享超过专属特权": "Recharge <%=count%> uDiamonds to level up to <%=grade%>. Enjoy exclusive privileges.",
    "本月再充值<%=count%>U钻完成【保级】，下个月继续尊享<%=grade%>特权": "Recharge <%=count%> uDiamonds in this month to maintain your level, so that you will continue enjoying your <%=grade%> privileges next month",
    "来晚了，什么都没剩下给你": "You are too late.. nothing left.",
    "查看全部": "View all",
    "查看守护规则": "Guardian rules",
    "查看更多": "View more",
    "查看最新消息": "Scroll down to see new messages",
    "标准": "Standard",
    "榜单隐身": "Invisible ranking",
    "榜单隐身特权说明": "Set yourself invisible on contributors board of your host. Be a mysterious low key VIP!",
    "榜单隐身获取条件": "VIP3 or higher",
    "正在关注…": "Following…",
    "正在加载": "Loading",
    "正在注册": "Registering...",
    "正在登录": "Logging in...",
    "正在绑定...": "Binding...",
    "正在购买": "Purchasing...",
    "正在退出...": "Logging out...",
    "此帐号已绑定": "This account is already bound",
    "每个主播仅有一名专属的守护天使": "1. Each host only can have one Guardian Angel",
    "每人仅一次机会": "Only once for each user",
    "永久": "Permanent",
    "没发现此人，重新输入试试？": "This user was not found",
    "没有关注记录": "No follow record",
    "没有浏览记录？": "There aren't any browse record?",
    "法拉帝960": "Ferretti 960",
    "波音 787": "Boeing 787",
    "注册账号": "Register Account",
    "注销": "Logout",
    "注：部分尊贵特权暂未开放，敬请期待！": "Notice: Certain VIP privileges are not yet available, please stay tune!",
    "洋妞直播VIP简介": "Exotic stream VIP terms",
    "活动": "Events",
    "活动详情": "Detail",
    "浏览历史": "Browsing History",
    "消耗:": "Used:",
    "消费<%=count%>U钻": "Spend <%=count%> U diamonds",
    "添加": "Add",
    "添加好友": "Add friend",
    "清屏": "Clear Screen",
    "温馨提示": "Tips",
    "游客登录失败，请使用其他方式登录": "Visitor login failed, please try another way to login",
    "游戏": "Game",
    "游戏中心": "Game Center",
    "游戏直播": "Game Stream",
    "湾流G55": "Gulfstream G550",
    "点亮了": "liked this",
    "点亮数量": "Heart count",
    "点击加载更多": "Tap to load more",
    "点击启用 Flash Player": "Click to activate Flash Player",
    "点击特权图标可查看特权说明": "Click privilege icon to view details ",
    "热门": "Hot",
    "热门直播": "Featured Stream",
    "特效": "Special",
    "特权名称": "Privilege Name",
    "特权说明": "Privilege details",
    "特殊身份标示": "Dinstinctive icon",
    "玛莎拉蒂GranTurismo": "Maserati GranTurismo",
    "用户VIP权限不足": "Insufficient user VIP privileges",
    "由于你未进行充值，无法赠送礼物": "You can send gift without topping up",
    "申请发送成功": "Request sent successfully",
    "男": "Male",
    "登录": "Login",
    "登录 Uplive": "Login Uplive",
    "登录<em>Uplive</em>": "Login<em>Uplive</em>",
    "登录<em>并</em>领取": "Login<em>and</em>Claim",
    "登录Uplive": "Login Uplive",
    "登录之后即可进行充值": "You can recharge after login",
    "登录代表你接受Up直播《服务条款及隐私政策》": "Logging in means you agree UP Live's 《<i>terms of service</i> and <em> privacy policy </em>》",
    "登录后可随时关注主播动态": "Sign in to keep track of the anchor activity",
    "登录密码设置失败": "Failed to set password",
    "登录密码设置成功": "Password set successfully",
    "直接添加客服联系方式(微信/Line)进行充值，最高可享": "Directly add customer service's contact information (WeChat/Line) to recharge, and receive at most",
    "直接联系官方客服进行充值，选择档位越高，优惠力度越大。": "Directly contact customer service to recharge, the higher the selected tier, the better the discount!",
    "直播结束": "Live stream ended",
    "直播间有精灵时，才可以送该礼物哦！": "You cannot send gifts until the elf appears",
    "直播间礼物公告": "Live room gift announcement",
    "直播间禁言": "Ban messaging in room",
    "直播间禁言特权说明": "VIP users have message ban privilege. Higher level VIP users can ban more. <b>Note: Use your message ban privilege carefully. Your room admin privilege will be permanently removed if you abuse your power.</b>",
    "直播间禁言获取条件": "VIP1 or higher",
    "直播间踢人": "Remove users from chat rooms",
    "直播间踢人特权说明": "VIPs have the privilege to kick out other users from the room. Higher level VIPs can remove more users. <b>Note: Use your message ban privilege carefully. Your room admin privilege will be permanently removed if you abuse your power.</b>",
    "直播间踢人获取条件": "VIP2 or higher",
    "真遗憾": "So close!",
    "知道了": "OK",
    "确定": "Confirm",
    "确定使用<%=bill%>U币兑换<%=diamond%>U钻": "Are you sure you want to exchange <%=bill%> coins for <%=diamond%> diamonds?",
    "确定提现": "Confirm withdrawal",
    "确认": "Confirm",
    "确认举报<%=name%>吗": "Are you sure you want to report <%=name%>?",
    "确认绑定": "Confirm Bind",
    "确认退出Up直播？": "Are you sure you want to exit Uplive ?",
    "礼物": "Gift",
    "礼物不存在": "Gift does not exist ",
    "礼物助手": "Gift Assistant",
    "礼物是空的": "Gift is empty",
    "神秘礼物": "Mystery Gift",
    "禁止他人发言": "Ban someone from speaking ",
    "禁言会让这个用户在<%=time%>分钟内无法发言": "Mute user will silence them for <%=time%> minutes",
    "禁言次数": "Muted # users",
    "福利多多，玩的更嗨": "Plenty of benefits, plently of fun",
    "福特野马": "Ford Mustang",
    "私人客服": "Private customer service",
    "私人客服特权说明": "Exclusive private customer service 24/7 at your disposal",
    "私人客服获取条件": "VIP1 or higher",
    "私信": "Private message",
    "私播直播间人数达到上限": "Private broadcast audience reached limit",
    "空中客车 A380": "Airbus A380",
    "立即体验": "Try now~",
    "立即充值": "Recharge now",
    "立即充值，完成VIP<%=count%>保级": "Recharge now to maintain your VIP level",
    "立即充值，提升VIP等级": "Recharge now to increase your VIP level",
    "立即充值，激活VIP特权": "Recharge now to unlock VIP privileges ",
    "立即围观": "Check it Out",
    "第一次心动": "First Heartbeat",
    "等级福利": "User level privileges",
    "等级福利详情": "High level users will have a logo to distinguish their status.@@@@The higher your level, the more customized privileges you'll enjoy.",
    "签名": "Status",
    "签名不能出现敏感词": "Introduction contents sensitive words",
    "粉丝": "Followers",
    "精彩活动": "Events",
    "系统消息": "System message:",
    "系统错误": "System Error",
    "累计经验：<%=code%>": "Exp. accumulated: <%=code%>",
    "累计领取": "Total amount withdrawn to date",
    "红包": "Red Packet",
    "经验值<%=num%>": "<%=num%> Exp",
    "绑定": "Bind",
    "绑定后不能解绑，请仔细确认": "This action cannot be reversed, please confirm entered information",
    "绑定后开启更多特权，让你的账号更加安全": "More privilege available after binding, make your account safer",
    "绑定后，审核大概需要一天左右时间": "After binding, it usually requires a day for reviewing",
    "绑定失败": "Binding failed",
    "绑定微信": "Bind wechat",
    "绑定微信后扫码关注“Up小助手”领取红包": "Get your Uplive revenue after subscribe “Up小助手” ",
    "绑定微信失败": "Wechat bind failed",
    "绑定成功": "Bind success",
    "绑定手机号": "Bind phone number",
    "绑定手机号码": "Bind phone number",
    "绑定手机号码,有利于保护您的账号和资金安全": "Bind phone number for account privacy protection",
    "给大家发了<%=count%>个<%=giftName%>，大量U钻等你来抢，拼人品的时候到了！": "Send  <%=count%> <%=giftName%> in this room, free diamonds are waiting for you, be quick！",
    "编辑": "Edit",
    "网络连接有误, 请稍后再试": "Network issue, please try again later.",
    "聊天提醒": "Highlighted chat",
    "联系客服": "Contact customer service",
    "联系我们": "Contact us",
    "背包": "Backpack",
    "背包是空的": "Backpack is empty",
    "背包礼物过期": "Backpack gift expired",
    "花费:": "Cost：",
    "获取个人信息失败": "Fail to get your personal information",
    "获取手机验证码": "Get mobile verify code",
    "获取条件": "Requirements ",
    "获取用户信息失败, 请稍后再试": "Fail to load the data, please try later",
    "虚位以待": "Waiting for someone...",
    "观看": "Viewer",
    "观看人数": "Viewer count",
    "观看历史": "Watch History",
    "观看记录": "Watch history",
    "规则说明": "Explanation",
    "解除": "Remove",
    "解除拉黑": "Unblock",
    "解除拉黑失败": "Failed to remove from black list",
    "解除拉黑成功": "Removed from blacklist successfully",
    "认证:": "Verification:",
    "让全世界看到你的美": "Let the world see your beauty",
    "设置国家或地区失败": "Fail to set your country/region",
    "设置国家或地区成功": "Country/Region information updated!",
    "设置新密码": "Set New Password",
    "评论": "Comment",
    "评论成功": "Comment has been successfully posted",
    "评论最大长度140": "Please enter maximum 140 characters",
    "试试这个，主播会喜欢的！": "Tap to send this gift ",
    "该功能暂未开放，敬请期待！": "This feature is not avaible. Check back soon!",
    "该帐号已经注册过Up，是否切换此账号？": "This account has registered Up,switch this account?",
    "该手机号未被注册": "This mobile no. hasn't been registered yet",
    "该条动态不存在": "This feed is deleted",
    "该用户的地区暂未支持GIFTO礼物": "User's region currently doesn't support GIFTO gifts",
    "该用户的地区暂未支持此类型礼物": "User's region currently doesn't support this type of gifts",
    "该礼物只有达到VIP<%=value%>可以赠送": "This gift can only be sent with VIP<%=value%>",
    "该礼物赠送操作暂未开放，请下载Uplive App进行赠送": "This gift isn't open for sending yet, please download Uplive to send",
    "该等级已激活": "This level is activated",
    "该类型礼物需下载app赠送": "This type of gifts has to be send in app",
    "该邮箱未被注册": "This email hasn't been registered yet",
    "详情": "Learn more",
    "详情特权介绍": "Privilege details introduction",
    "说点什么吧": "Say something",
    "请不要发布重复内容": "Please do not post duplicate content",
    "请使用微信扫一扫<br/>扫描二维码支付": "Scan <br/> by WeChat to pay",
    "请先绑定手机号": "Please bind mobile number first",
    "请前往手机端Up直播 —> 个人中心 —> 我的直播 —> 收益提现 —> 绑定微信号": "Please open Uplive , Profile, My live stream, revenue is raised,bind wechat account",
    "请稍侯，正在登录中...": "Logging in, please wait...",
    "请输入20个字以内": "Please enter maximum 20 characters",
    "请输入Up号": "Enter Up account",
    "请输入密码": "Enter password",
    "请输入您要绑定的Paypal账号": "Please input your Paypal account",
    "请输入手机号码": "Please enter mobile no.",
    "请输入昵称": "Enter nickname",
    "请输入用户昵称或Up号": "Enter nickname or Up account",
    "请输入登录密码": "Please enter password",
    "请输入要绑定的手机号码": "Enter phone number",
    "请输入邮箱": "Please enter email address",
    "请输入验证码": "Enter verification code",
    "请输入验证码！": "Enter verification code",
    "贡献<%=count%>U币": "Sent <%=count%> coins",
    "财富榜": "Wealth board",
    "财富榜单": "Wealth Rank",
    "账号绑定": "Account bind",
    "账号被冻结，期间不能使用U钻送礼、发布弹幕等。如需解封，请联系VIP客服哦！": "Your account is frozen, you can not use U diamond to send gifts or send POP UP and so on. If you want to unlock, please contact VIP customer service!",
    "账户充值": "Account Recharge",
    "购买失败": "Purchase failed",
    "购买守护": "Buy Guardian Angel position",
    "贵宾坐席": "VIP seat",
    "贵宾坐席特权说明": "Exclusive VIP seat in chat rooms just for you!",
    "贵宾坐席获取条件": "VIP1 or higher",
    "赠送": "Send",
    "赠送了<%=count%>个<%=giftName%>": "sent <%=count%> <%=giftName%>",
    "赠送了<%=giftName%>": "Sent <%=giftName%>",
    "超出单次提现额度": "Exceed maximum withdraw limit",
    "超出当前格子能够赠送的数量": "Not enough space for gifts",
    "超清": "Ultra Definition",
    "超过当日提现次数": "Exceeded daily maximum withdrawal",
    "距上一名U币": "From last rank's uCoins",
    "距上一名U币<%=count%>": "From the last U coin <%=count%>",
    "距上一名U币<br/><%=count%>": "From the last U coin<br/> <%=count%>",
    "距离下一级：<%=code%>": "To next level: <%=code%>",
    "距离二维码过期还剩<%=count%>秒，过期后请刷新页面重新获取二维码": "The QR code will be expired in <%=count%> seconds, please refresh and get new QR code",
    "踢人次数": "Banned # users",
    "踢出会让这个用户在<%=time%>分钟内无法进入直播间": "Kicking this user out will keep him/her out of this room for <%=time%> minutes",
    "输入内容不能为空": "Content cannot be blank",
    "输入验证码": "Enter verification code",
    "达索Falcon900": "Dassault Falcon 900",
    "返回": "Back",
    "返回首页": "Return to homepage",
    "还没有人给你送礼，快去直播": "No one has sent you gift yet, go live stream!",
    "还没有关注？": "You're not following anyone yet?",
    "还没有粉丝？": "You don't have any followers yet?",
    "还没有给TA送礼，你不做第一个吗？": "No one has given gifts to host yet, you should be the first one!",
    "还没有评论，快来抢沙发吧！": "No comments yet, come be the first one!",
    "进入": "Enter",
    "进入房间失败": "Fail to enter this room",
    "进入直播间": "Tap to enter chat room",
    "进入直播间互动": "Enter stream to interact",
    "进入该直播间需要付费<%=count%>U钻，<br/>才能进入（已经支付过不会再扣除U钻）": "Entering this live stream requires entrance fee of <%=count%> diamonds <br/> (if already paid no additional payment needed)",
    "进场特效": "Special effect entrance",
    "进场特效特权说明": "VIP users enjoy grand entrance into the room unlike anyone else",
    "进场特效获取条件": "VIP1 or higher",
    "进房间隐身": "Invisible entrance ",
    "进房间隐身特权说明": "This feature is not avaible. Check back soon!",
    "进房间隐身获取条件": "VIP8 or higher",
    "进行中，剩余<%=count%>": "<%=count%> remaining",
    "连": "+1",
    "连接失败，请退出直播间重新进入": "Connection failed, try to quit and enter again.",
    "连接直播间超时": "Request overtime",
    "退出登录": "Log out",
    "送个礼物让主播开心一下吧！": "Surprise the host by sending a gift",
    "送出": "Sent",
    "选择国家或地区": "Select country or region",
    "遇见问题不用担心，专享客服为您服务。": "Exclusive custom service, standing by for all you questions",
    "邮箱未注册": "Email hasn't been registered yet",
    "邮箱未验证": "Check your mailbox to verify your email adress",
    "邮箱格式错误": "Wrong email format",
    "邮箱格式错误，请您重新输入！": "Wrong email adress, please check",
    "邮箱注册/登录": "Email Register / Login",
    "邮箱注册，不在白名单": "Registered email not in whitelist",
    "邮箱登录": "Email Login",
    "邮箱验证失败，请重试": "Verification failed, please try again",
    "邮箱验证次数超过每天限制": "\n verification times exceed daily limit",
    "醒目私信": "Highlighted private messages ",
    "醒目私信特权说明": "Being a VIP, each comment you make is highlighted, impossible to ignore!",
    "醒目私信获取条件": "VIP1 or higher ",
    "重新发送": "Resend",
    "重新登录": "Please login again",
    "金额小于最小提现额度": "Withdrawal amount cannot be less than <%=num%>",
    "金额或次数限充": "You have exceeded the daily limit",
    "金额超出今日提现额度": "You have exceeded the daily withdrawal limit",
    "锁屏": "Lock Screen",
    "防踢防禁言": "Message ban and removal immunity ",
    "防踢防禁言特权说明": "Prevent you from being banned to speak or removed from the room by anyone other than the host",
    "防踢防禁言获取条件": "VIP6 or higher",
    "阿斯顿·马丁DB9": "Aston Matin DB9",
    "随时关注喜欢的主播，就等你了！还不快来！": "Follow your favourite hosts anytime! What are you waiting for!",
    "非VIP": "Non-VIP",
    "页面标题": "Uplive Official Website - Uplive,live it up",
    "页面标题马甲包": "VIP Description",
    "预览": "Preview",
    "领取": "Take",
    "领取失败，请稍候重试": "Not received, please try again later",
    "领取时间": "Received time",
    "领取状态": "Received state",
    "领取礼物，随机获得不同金额U钻奖励": "Get the gift! You'll get a lucky amount of U diamonds!",
    "领取红包": "Withdraw lucky money",
    "领取记录": "Lucky money records",
    "领取金额": "Received amount",
    "首充优惠": "1st time recharge bonus",
    "首页": "Home",
    "马上和全球优质主播亲密互动": "Start interacting with international excellent hosts immediately",
    "验证码发送失败": "Failed to send verification code",
    "验证码已发送": "Verification code sent",
    "验证码输入错误": "Wrong verification code",
    "验证码错误！": "Incorrect verification code",
    "验证邮件已发送至<i><%=email%></i>请去邮箱确认": "Verification email has been sent to <i><%=email%></i>, please check",
    "验证邮件已重新发送": "Verification email resent done.",
    "验证邮箱": "Verify Email",
    "高清": "High Definition",
    "黑名单": "Blacklist",
    "（保级中）": "  (Maintaining level)",
    "（升级中）": "  (Leveling up)"
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule setTextContent
 */



var ExecutionEnvironment = __webpack_require__(14);
var escapeTextContentForBrowser = __webpack_require__(78);
var setInnerHTML = __webpack_require__(77);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DOMPropertyOperations
 * @typechecks static-only
 */



var DOMProperty = __webpack_require__(47);
var ReactPerf = __webpack_require__(19);

var quoteAttributeValueForBrowser = __webpack_require__(307);
var warning = __webpack_require__(7);

// Simplified subset
var VALID_ATTRIBUTE_NAME_REGEX = /^[a-zA-Z_][\w\.\-]*$/;
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : undefined;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

if (false) {
  var reactProps = {
    children: true,
    dangerouslySetInnerHTML: true,
    key: true,
    ref: true
  };
  var warnedProperties = {};

  var warnUnknownProperty = function (name) {
    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
      return;
    }

    warnedProperties[name] = true;
    var lowerCasedName = name.toLowerCase();

    // data-* attributes should be lowercase; suggest the lowercase version
    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;

    // For now, only warn when we have a suggested correction. This prevents
    // logging too much when using transferPropsTo.
    process.env.NODE_ENV !== 'production' ? warning(standardName == null, 'Unknown DOM property %s. Did you mean %s?', name, standardName) : undefined;
  };
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {

  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    } else if (false) {
      warnUnknownProperty(name);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
      } else if (propertyInfo.mustUseAttribute) {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      } else {
        var propName = propertyInfo.propertyName;
        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
        // property type before comparing; only `value` does and is string.
        if (!propertyInfo.hasSideEffects || '' + node[propName] !== '' + value) {
          // Contrary to `setAttribute`, object properties are properly
          // `toString`ed by IE8/9.
          node[propName] = value;
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
    } else if (false) {
      warnUnknownProperty(name);
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseAttribute) {
        node.removeAttribute(propertyInfo.attributeName);
      } else {
        var propName = propertyInfo.propertyName;
        var defaultValue = DOMProperty.getDefaultValueForProperty(node.nodeName, propName);
        if (!propertyInfo.hasSideEffects || '' + node[propName] !== defaultValue) {
          node[propName] = defaultValue;
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    } else if (false) {
      warnUnknownProperty(name);
    }
  }

};

ReactPerf.measureMethods(DOMPropertyOperations, 'DOMPropertyOperations', {
  setValueForProperty: 'setValueForProperty',
  setValueForAttribute: 'setValueForAttribute',
  deleteValueForProperty: 'deleteValueForProperty'
});

module.exports = DOMPropertyOperations;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentBrowserEnvironment
 */



var ReactDOMIDOperations = __webpack_require__(111);
var ReactMount = __webpack_require__(16);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {

  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkupByID: ReactDOMIDOperations.dangerouslyReplaceNodeWithMarkupByID,

  /**
   * If a particular environment requires that some resources be cleaned up,
   * specify this in the injected Mixin. In the DOM, we would likely want to
   * purge any cached node ID lookups.
   *
   * @private
   */
  unmountIDFromEnvironment: function (rootNodeID) {
    ReactMount.purgeID(rootNodeID);
  }

};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMIDOperations
 * @typechecks static-only
 */



var DOMChildrenOperations = __webpack_require__(160);
var DOMPropertyOperations = __webpack_require__(109);
var ReactMount = __webpack_require__(16);
var ReactPerf = __webpack_require__(19);

var invariant = __webpack_require__(2);

/**
 * Errors for properties that should not be updated with `updatePropertyByID()`.
 *
 * @type {object}
 * @private
 */
var INVALID_PROPERTY_ERRORS = {
  dangerouslySetInnerHTML: '`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.',
  style: '`style` must be set using `updateStylesByID()`.'
};

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {

  /**
   * Updates a DOM node with new property values. This should only be used to
   * update DOM properties in `DOMProperty`.
   *
   * @param {string} id ID of the node to update.
   * @param {string} name A valid property name, see `DOMProperty`.
   * @param {*} value New value of the property.
   * @internal
   */
  updatePropertyByID: function (id, name, value) {
    var node = ReactMount.getNode(id);
    !!INVALID_PROPERTY_ERRORS.hasOwnProperty(name) ?  false ? invariant(false, 'updatePropertyByID(...): %s', INVALID_PROPERTY_ERRORS[name]) : invariant(false) : undefined;

    // If we're updating to null or undefined, we should remove the property
    // from the DOM node instead of inadvertantly setting to a string. This
    // brings us in line with the same behavior we have on initial render.
    if (value != null) {
      DOMPropertyOperations.setValueForProperty(node, name, value);
    } else {
      DOMPropertyOperations.deleteValueForProperty(node, name);
    }
  },

  /**
   * Replaces a DOM node that exists in the document with markup.
   *
   * @param {string} id ID of child to be replaced.
   * @param {string} markup Dangerous markup to inject in place of child.
   * @internal
   * @see {Danger.dangerouslyReplaceNodeWithMarkup}
   */
  dangerouslyReplaceNodeWithMarkupByID: function (id, markup) {
    var node = ReactMount.getNode(id);
    DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup(node, markup);
  },

  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @param {array<string>} markup List of markup strings.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (updates, markup) {
    for (var i = 0; i < updates.length; i++) {
      updates[i].parentNode = ReactMount.getNode(updates[i].parentID);
    }
    DOMChildrenOperations.processUpdates(updates, markup);
  }
};

ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
  dangerouslyReplaceNodeWithMarkupByID: 'dangerouslyReplaceNodeWithMarkupByID',
  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
});

module.exports = ReactDOMIDOperations;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventSupported
 */



var ExecutionEnvironment = __webpack_require__(14);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = (eventName in document);

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactUpdateQueue
 */



var ReactCurrentOwner = __webpack_require__(25);
var ReactElement = __webpack_require__(18);
var ReactInstanceMap = __webpack_require__(61);
var ReactUpdates = __webpack_require__(20);

var assign = __webpack_require__(8);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(7);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor.displayName) : undefined;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition ' + '(such as within `render`). Render methods should be a pure function ' + 'of props and state.', callerName) : undefined;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {
    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the props.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialProps Subset of the next props.
   * @internal
   */
  enqueueSetProps: function (publicInstance, partialProps) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setProps');
    if (!internalInstance) {
      return;
    }
    ReactUpdateQueue.enqueueSetPropsInternal(internalInstance, partialProps);
  },

  enqueueSetPropsInternal: function (internalInstance, partialProps) {
    var topLevelWrapper = internalInstance._topLevelWrapper;
    !topLevelWrapper ?  false ? invariant(false, 'setProps(...): You called `setProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;

    // Merge with the pending element if it exists, otherwise with existing
    // element props.
    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
    var element = wrapElement.props;
    var props = assign({}, element.props, partialProps);
    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));

    enqueueUpdate(topLevelWrapper);
  },

  /**
   * Replaces all of the props.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} props New props.
   * @internal
   */
  enqueueReplaceProps: function (publicInstance, props) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceProps');
    if (!internalInstance) {
      return;
    }
    ReactUpdateQueue.enqueueReplacePropsInternal(internalInstance, props);
  },

  enqueueReplacePropsInternal: function (internalInstance, props) {
    var topLevelWrapper = internalInstance._topLevelWrapper;
    !topLevelWrapper ?  false ? invariant(false, 'replaceProps(...): You called `replaceProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;

    // Merge with the pending element if it exists, otherwise with existing
    // element props.
    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
    var element = wrapElement.props;
    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));

    enqueueUpdate(topLevelWrapper);
  },

  enqueueElementInternal: function (internalInstance, newElement) {
    internalInstance._pendingElement = newElement;
    enqueueUpdate(internalInstance);
  }

};

module.exports = ReactUpdateQueue;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CallbackQueue
 */



var PooledClass = __webpack_require__(31);

var assign = __webpack_require__(8);
var invariant = __webpack_require__(2);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */
function CallbackQueue() {
  this._callbacks = null;
  this._contexts = null;
}

assign(CallbackQueue.prototype, {

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */
  enqueue: function (callback, context) {
    this._callbacks = this._callbacks || [];
    this._contexts = this._contexts || [];
    this._callbacks.push(callback);
    this._contexts.push(context);
  },

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */
  notifyAll: function () {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    if (callbacks) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : invariant(false) : undefined;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i]);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  },

  /**
   * Resets the internal queue.
   *
   * @internal
   */
  reset: function () {
    this._callbacks = null;
    this._contexts = null;
  },

  /**
   * `PooledClass` looks for this.
   */
  destructor: function () {
    this.reset();
  }

});

PooledClass.addPoolingTo(CallbackQueue);

module.exports = CallbackQueue;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule instantiateReactComponent
 * @typechecks static-only
 */



var ReactCompositeComponent = __webpack_require__(315);
var ReactEmptyComponent = __webpack_require__(173);
var ReactNativeComponent = __webpack_require__(174);

var assign = __webpack_require__(8);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(7);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function () {};
assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
  _instantiateReactComponent: instantiateReactComponent
});

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node) {
  var instance;

  if (node === null || node === false) {
    instance = new ReactEmptyComponent(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) ' + 'or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : invariant(false) : undefined;

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactNativeComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);
    } else {
      instance = new ReactCompositeComponentWrapper();
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactNativeComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : invariant(false) : undefined;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.construct === 'function' && typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : undefined;
  }

  // Sets up the instance. This can probably just move into the constructor now.
  instance.construct(node);

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._isOwnerNecessary = false;
    instance._warnedAboutRefsInRender = false;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

module.exports = instantiateReactComponent;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentEnvironment
 */



var invariant = __webpack_require__(2);

var injected = false;

var ReactComponentEnvironment = {

  /**
   * Optionally injectable environment dependent cleanup hook. (server vs.
   * browser etc). Example: A browser system caches DOM nodes based on component
   * ID and must remove that cache entry when this instance is unmounted.
   */
  unmountIDFromEnvironment: null,

  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkupByID: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : invariant(false) : undefined;
      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
      ReactComponentEnvironment.replaceNodeWithMarkupByID = environment.replaceNodeWithMarkupByID;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }

};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule shouldUpdateReactComponent
 * @typechecks static-only
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */
function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
  return false;
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule validateDOMNesting
 */



var assign = __webpack_require__(8);
var emptyFunction = __webpack_require__(21);
var warning = __webpack_require__(7);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    parentTag: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.parentTag = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':

      case 'pre':
      case 'listing':

      case 'table':

      case 'hr':

      case 'xmp':

      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    /*eslint-disable space-after-keywords */
    do {
      /*eslint-enable space-after-keywords */
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.parentTag;
    var parentTag = parentInfo && parentInfo.tag;

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a child of <%s>. ' + 'See %s.%s', childTag, ancestorTag, ownerInfo, info) : undefined;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a descendant of ' + '<%s>. See %s.', childTag, ancestorTag, ownerInfo) : undefined;
      }
    }
  };

  validateDOMNesting.ancestorInfoContextKey = '__validateDOMNesting_ancestorInfo$' + Math.random().toString(36).slice(2);

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.parentTag;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEventTarget
 * @typechecks static-only
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */
function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;
  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEventModifierState
 * @typechecks static-only
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  'Alt': 'altKey',
  'Control': 'ctrlKey',
  'Meta': 'metaKey',
  'Shift': 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule findDOMNode
 * @typechecks static-only
 */



var ReactCurrentOwner = __webpack_require__(25);
var ReactInstanceMap = __webpack_require__(61);
var ReactMount = __webpack_require__(16);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(7);

/**
 * Returns the DOM node rendered by this element.
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing getDOMNode or findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }
  if (ReactInstanceMap.has(componentOrElement)) {
    return ReactMount.getNodeFromInstance(componentOrElement);
  }
  !(componentOrElement.render == null || typeof componentOrElement.render !== 'function') ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : invariant(false) : undefined;
   true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : invariant(false) : undefined;
}

module.exports = findDOMNode;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule LinkedValueUtils
 * @typechecks static-only
 */



var ReactPropTypes = __webpack_require__(181);
var ReactPropTypeLocations = __webpack_require__(82);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(7);

var hasReadOnlyValue = {
  'button': true,
  'checkbox': true,
  'image': true,
  'hidden': true,
  'radio': true,
  'reset': true,
  'submit': true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use ' + 'checkedLink, you probably don\'t want to use valueLink and vice versa.') : invariant(false) : undefined;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want ' + 'to use value or onChange, you probably don\'t want to use valueLink.') : invariant(false) : undefined;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. ' + 'If you want to use checked or onChange, you probably don\'t want to ' + 'use checkedLink') : invariant(false) : undefined;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: ReactPropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : undefined;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getIteratorFn
 * @typechecks static-only
 */



/* global Symbol */
var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule traverseAllChildren
 */



var ReactCurrentOwner = __webpack_require__(25);
var ReactElement = __webpack_require__(18);
var ReactInstanceHandles = __webpack_require__(48);

var getIteratorFn = __webpack_require__(123);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(7);

var SEPARATOR = ReactInstanceHandles.SEPARATOR;
var SUBSEPARATOR = ':';

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var userProvidedKeyEscaperLookup = {
  '=': '=0',
  '.': '=1',
  ':': '=2'
};

var userProvidedKeyEscapeRegex = /[=.:]/g;

var didWarnAboutMaps = false;

function userProvidedKeyEscaper(match) {
  return userProvidedKeyEscaperLookup[match];
}

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  if (component && component.key != null) {
    // Explicit key
    return wrapUserProvidedKey(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * Escape a component key so that it is safe to use in a reactid.
 *
 * @param {*} text Component key to be escaped.
 * @return {string} An escaped string.
 */
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, userProvidedKeyEscaper);
}

/**
 * Wrap a `key` value explicitly provided by the user to distinguish it from
 * implicitly-generated keys generated by a component's index in its parent.
 *
 * @param {string} key Value of a user-provided `key` attribute
 * @return {string}
 */
function wrapUserProvidedKey(key) {
  return '$' + escapeUserProvidedKey(key);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.') : undefined;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + wrapUserProvidedKey(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : invariant(false) : undefined;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEventCharCode
 * @typechecks static-only
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */
function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactVersion
 */



module.exports = '0.14.9';

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["b"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_is__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getRouteParams__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContextUtils__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(34);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };











/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'RouterContext',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_6__ContextUtils__["a" /* ContextProvider */])('router')],

  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired,
    location: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired,
    routes: __WEBPACK_IMPORTED_MODULE_4_prop_types__["array"].isRequired,
    params: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired,
    components: __WEBPACK_IMPORTED_MODULE_4_prop_types__["array"].isRequired,
    createElement: __WEBPACK_IMPORTED_MODULE_4_prop_types__["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = Object(__WEBPACK_IMPORTED_MODULE_5__getRouteParams__["a" /* default */])(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (Object(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["c" /* isReactChildren */])(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        // Handle components is object for { [name]: component } but not valid element
        // type of react, such as React.memo, React.lazy and so on.
        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object' && !Object(__WEBPACK_IMPORTED_MODULE_2_react_is__["isValidElementType"])(components)) {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

var prefixUnsafeLifecycleMethods = parseFloat(__WEBPACK_IMPORTED_MODULE_0_react___default.a.version) >= 16.3;

function ContextProvider(name) {
  var _childContextTypes, _config;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  var config = (_config = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },


    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },


    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _config[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _config);

  if (prefixUnsafeLifecycleMethods) {
    config.UNSAFE_componentWillMount = config.componentWillMount;
    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
    delete config.componentWillMount;
    delete config.componentWillReceiveProps;
  }
  return config;
}

function ContextSubscriber(name) {
  var _contextTypes, _config2;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  var config = (_config2 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref2;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref2 = {}, _ref2[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref2;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },


    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _config2[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _config2);

  if (prefixUnsafeLifecycleMethods) {
    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
    delete config.componentWillReceiveProps;
  }
  return config;
}

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return routerShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return locationShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var routerShape = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  setRouteLeaveHook: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var locationShape = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  pathname: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  search: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
});

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(390);

var _runTransitionHook = __webpack_require__(133);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(41);

var _PathUtils = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(133);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(392);

var _PathUtils = __webpack_require__(35);

var _runTransitionHook = __webpack_require__(133);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(66);

var _LocationUtils = __webpack_require__(41);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(41);

var _DOMUtils = __webpack_require__(67);

var _DOMStateStorage = __webpack_require__(201);

var _PathUtils = __webpack_require__(35);

var _ExecutionEnvironment = __webpack_require__(85);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 137 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// define(function(require, exports, module) {
/*!
Video.js - HTML5 Video Player
Version 3.2.0
LGPL v3 LICENSE INFO
This file is part of Video.js. Copyright 2011 Zencoder, Inc.
Video.js is free software: you can redistribute it and/or modify
it under the terms of the GNU Lesser General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.
Video.js is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Lesser General Public License for more details.
You should have received a copy of the GNU Lesser General Public License
along with Video.js.  If not, see <http://www.gnu.org/licenses/>.
*/
/**
 * 
 * @author modify by chenliying 
 * @changlog 2017-10-11 将音量控制改为全局
 */
(function (window, undefined) {
    var document = window.document;
    document.createElement("video");
    document.createElement("audio");

    window.videoJSLastVolume = 1;

    var _lastVolume = 1;

    var VideoJS = function VideoJS(id, addOptions, ready) {
        var tag;
        if (typeof id == "string") {
            if (id.indexOf("#") === 0) {
                id = id.slice(1);
            }
            if (_V_.players[id]) {
                return _V_.players[id];
            } else {
                tag = _V_.el(id);
            }
        } else {
            tag = id;
        }
        if (!tag || !tag.nodeName) {
            throw new TypeError("The element or ID supplied is not valid. (VideoJS)");
        }
        return tag.player || new _V_.Player(tag, addOptions, ready);
    },
        _V_ = VideoJS,
        CDN_VERSION = "c";
    VideoJS.players = {};
    VideoJS.options = {
        techOrder: ["html5", "flash"],
        html5: {},
        flash: {
            swf: "http://vjs.zencdn.net/c/video-js.swf"
        },
        width: "auto",
        height: "auto",
        defaultVolume: 0,
        components: {
            posterImage: {},
            textTrackDisplay: {},
            loadingSpinner: {},
            bigPlayButton: {},
            controlBar: {}
        }
    };
    if (CDN_VERSION != "GENERATED_CDN_VSN") {
        _V_.options.flash.swf = "http://vjs.zencdn.net/" + CDN_VERSION + "/video-js.swf";
    }
    _V_.merge = function (obj1, obj2, safe) {
        if (!obj2) {
            obj2 = {};
        }
        for (var attrname in obj2) {
            if (obj2.hasOwnProperty(attrname) && (!safe || !obj1.hasOwnProperty(attrname))) {
                obj1[attrname] = obj2[attrname];
            }
        }
        return obj1;
    };
    _V_.extend = function (obj) {
        this.merge(this, obj, true);
    };
    _V_.extend({
        tech: {},
        controlSets: {},
        isIE: function isIE() {
            return !+"\v1";
        },
        isFF: function isFF() {
            return !!_V_.ua.match("Firefox");
        },
        isIPad: function isIPad() {
            return navigator.userAgent.match(/iPad/i) !== null;
        },
        isIPhone: function isIPhone() {
            return navigator.userAgent.match(/iPhone/i) !== null;
        },
        isIOS: function isIOS() {
            return VideoJS.isIPhone() || VideoJS.isIPad();
        },
        iOSVersion: function iOSVersion() {
            var match = navigator.userAgent.match(/OS (\d+)_/i);
            if (match && match[1]) {
                return match[1];
            }
        },
        isAndroid: function isAndroid() {
            return navigator.userAgent.match(/Android.*AppleWebKit/i) !== null;
        },
        androidVersion: function androidVersion() {
            var match = navigator.userAgent.match(/Android (\d+)\./i);
            if (match && match[1]) {
                return match[1];
            }
        },
        testVid: document.createElement("video"),
        ua: navigator.userAgent,
        support: {},
        each: function each(arr, fn) {
            if (!arr || arr.length === 0) {
                return;
            }
            for (var i = 0, j = arr.length; i < j; i++) {
                fn.call(this, arr[i], i);
            }
        },
        eachProp: function eachProp(obj, fn) {
            if (!obj) {
                return;
            }
            for (var name in obj) {
                if (obj.hasOwnProperty(name)) {
                    fn.call(this, name, obj[name]);
                }
            }
        },
        el: function el(id) {
            return document.getElementById(id);
        },
        createElement: function createElement(tagName, attributes) {
            var el = document.createElement(tagName),
                attrname;
            for (attrname in attributes) {
                if (attributes.hasOwnProperty(attrname)) {
                    if (attrname.indexOf("-") !== -1) {
                        el.setAttribute(attrname, attributes[attrname]);
                    } else {
                        el[attrname] = attributes[attrname];
                    }
                }
            }
            return el;
        },
        insertFirst: function insertFirst(node, parent) {
            if (parent.firstChild) {
                parent.insertBefore(node, parent.firstChild);
            } else {
                parent.appendChild(node);
            }
        },
        addClass: function addClass(element, classToAdd) {
            if ((" " + element.className + " ").indexOf(" " + classToAdd + " ") == -1) {
                element.className = element.className === "" ? classToAdd : element.className + " " + classToAdd;
            }
        },
        removeClass: function removeClass(element, classToRemove) {
            if (element.className.indexOf(classToRemove) == -1) {
                return;
            }
            var classNames = element.className.split(" ");
            classNames.splice(classNames.indexOf(classToRemove), 1);
            element.className = classNames.join(" ");
        },
        remove: function remove(item, array) {
            if (!array) {
                return;
            }
            var i = array.indexOf(item);
            if (i != -1) {
                return array.splice(i, 1);
            }
        },
        blockTextSelection: function blockTextSelection() {
            document.body.focus();
            document.onselectstart = function () {
                return false;
            };
        },
        unblockTextSelection: function unblockTextSelection() {
            document.onselectstart = function () {
                return true;
            };
        },
        formatTime: function formatTime(seconds, guide) {
            guide = guide || seconds;
            var s = Math.floor(seconds % 60),
                m = Math.floor(seconds / 60 % 60),
                h = Math.floor(seconds / 3600),
                gm = Math.floor(guide / 60 % 60),
                gh = Math.floor(guide / 3600);
            h = h > 0 || gh > 0 ? h + ":" : "";
            m = ((h || gm >= 10) && m < 10 ? "0" + m : m) + ":";
            s = s < 10 ? "0" + s : s;
            return h + m + s;
        },
        uc: function uc(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        getRelativePosition: function getRelativePosition(x, relativeElement) {
            return Math.max(0, Math.min(1, (x - _V_.findPosX(relativeElement)) / relativeElement.offsetWidth));
        },
        getComputedStyleValue: function getComputedStyleValue(element, style) {
            return window.getComputedStyle(element, null).getPropertyValue(style);
        },
        trim: function trim(string) {
            return string.toString().replace(/^\s+/, "").replace(/\s+$/, "");
        },
        round: function round(num, dec) {
            if (!dec) {
                dec = 0;
            }
            return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
        },
        isEmpty: function isEmpty(object) {
            for (var prop in object) {
                return false;
            }
            return true;
        },
        createTimeRange: function createTimeRange(_start, _end) {
            return {
                length: 1,
                start: function start() {
                    return _start;
                },
                end: function end() {
                    return _end;
                }
            };
        },
        cache: {},
        guid: 1,
        expando: "vdata" + new Date().getTime(),
        getData: function getData(elem) {
            var id = elem[_V_.expando];
            if (!id) {
                id = elem[_V_.expando] = _V_.guid++;
                _V_.cache[id] = {};
            }
            return _V_.cache[id];
        },
        removeData: function removeData(elem) {
            var id = elem[_V_.expando];
            if (!id) {
                return;
            }
            delete _V_.cache[id];
            try {
                delete elem[_V_.expando];
            } catch (e) {
                if (elem.removeAttribute) {
                    elem.removeAttribute(_V_.expando);
                } else {
                    elem[_V_.expando] = null;
                }
            }
        },
        proxy: function proxy(context, fn, uid) {
            if (!fn.guid) {
                fn.guid = _V_.guid++;
            }
            var ret = function ret() {
                return fn.apply(context, arguments);
            };
            ret.guid = uid ? uid + "_" + fn.guid : fn.guid;
            return ret;
        },
        get: function get(url, onSuccess, onError) {
            var local = url.indexOf("file:") == 0 || window.location.href.indexOf("file:") == 0 && url.indexOf("http:") == -1;
            if (typeof XMLHttpRequest == "undefined") {
                XMLHttpRequest = function XMLHttpRequest() {
                    try {
                        return new ActiveXObject("Msxml2.XMLHTTP.6.0");
                    } catch (e) {}
                    try {
                        return new ActiveXObject("Msxml2.XMLHTTP.3.0");
                    } catch (f) {}
                    try {
                        return new ActiveXObject("Msxml2.XMLHTTP");
                    } catch (g) {}
                    throw new Error("This browser does not support XMLHttpRequest.");
                };
            }
            var request = new XMLHttpRequest();
            try {
                request.open("GET", url);
            } catch (e) {
                _V_.log("VideoJS XMLHttpRequest (open)", e);
                return false;
            }
            request.onreadystatechange = _V_.proxy(this, function () {
                if (request.readyState == 4) {
                    if (request.status == 200 || local && request.status == 0) {
                        onSuccess(request.responseText);
                    } else {
                        if (onError) {
                            onError();
                        }
                    }
                }
            });
            try {
                request.send();
            } catch (e) {
                _V_.log("VideoJS XMLHttpRequest (send)", e);
                if (onError) {
                    onError(e);
                }
            }
        },
        setLocalStorage: function setLocalStorage(key, value) {
            var localStorage = window.localStorage || false;
            if (!localStorage) {
                return;
            }
            try {
                localStorage[key] = value;
            } catch (e) {
                if (e.code == 22 || e.code == 1014) {
                    _V_.log("LocalStorage Full (VideoJS)", e);
                } else {
                    _V_.log("LocalStorage Error (VideoJS)", e);
                }
            }
        },
        getAbsoluteURL: function getAbsoluteURL(url) {
            if (!url.match(/^https?:\/\//)) {
                url = _V_.createElement("div", {
                    innerHTML: '<a href="' + url + '">x</a>'
                }).firstChild.href;
            }
            return url;
        }
    });
    _V_.log = function () {
        _V_.log.history = _V_.log.history || [];
        _V_.log.history.push(arguments);
        if (window.console) {
            arguments.callee = arguments.callee.caller;
            var newarr = [].slice.call(arguments);_typeof(console.log) === "object" ? _V_.log.apply.call(console.log, console, newarr) : console.log.apply(console, newarr);
        }
    };(function (b) {
        function c() {}
        for (var d = "assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","), a; a = d.pop();) {
            b[a] = b[a] || c;
        }
    })(function () {
        try {
            console.log();
            return window.console;
        } catch (err) {
            return window.console = {};
        }
    }());
    if ("getBoundingClientRect" in document.documentElement) {
        _V_.findPosX = function (el) {
            var box;
            try {
                box = el.getBoundingClientRect();
            } catch (e) {}
            if (!box) {
                return 0;
            }
            var docEl = document.documentElement,
                body = document.body,
                clientLeft = docEl.clientLeft || body.clientLeft || 0,
                scrollLeft = window.pageXOffset || body.scrollLeft,
                left = box.left + scrollLeft - clientLeft;
            return left;
        };
    } else {
        _V_.findPosX = function (el) {
            var curleft = el.offsetLeft;
            while (el = obj.offsetParent) {
                if (el.className.indexOf("video-js") == -1) {} else {}
                curleft += el.offsetLeft;
            }
            return curleft;
        };
    }(function () {
        var initializing = false,
            fnTest = /xyz/.test(function () {
            xyz;
        }) ? /\b_super\b/ : /.*/;
        _V_.Class = function () {};
        _V_.Class.extend = function (prop) {
            var _super = this.prototype;
            initializing = true;
            var prototype = new this();
            initializing = false;
            for (var name in prop) {
                prototype[name] = typeof prop[name] == "function" && typeof _super[name] == "function" && fnTest.test(prop[name]) ? function (name, fn) {
                    return function () {
                        var tmp = this._super;
                        this._super = _super[name];
                        var ret = fn.apply(this, arguments);
                        this._super = tmp;
                        return ret;
                    };
                }(name, prop[name]) : prop[name];
            }
            function Class() {
                if (!initializing && this.init) {
                    return this.init.apply(this, arguments);
                } else {
                    if (!initializing) {
                        return arguments.callee.prototype.init();
                    }
                }
            }
            Class.prototype = prototype;
            Class.constructor = Class;
            Class.extend = arguments.callee;
            return Class;
        };
    })();
    _V_.Component = _V_.Class.extend({
        init: function init(player, options) {
            this.player = player;
            options = this.options = _V_.merge(this.options || {}, options);
            if (options.el) {
                this.el = options.el;
            } else {
                this.el = this.createElement();
            }
            this.initComponents();
        },
        destroy: function destroy() {},
        createElement: function createElement(type, attrs) {
            return _V_.createElement(type || "div", attrs);
        },
        buildCSSClass: function buildCSSClass() {
            return "";
        },
        initComponents: function initComponents() {
            var options = this.options;
            if (options && options.components) {
                this.eachProp(options.components, function (name, opts) {
                    var tempAdd = this.proxy(function () {
                        this[name] = this.addComponent(name, opts);
                    });
                    if (opts.loadEvent) {
                        this.one(opts.loadEvent, tempAdd);
                    } else {
                        tempAdd();
                    }
                });
            }
        },
        addComponent: function addComponent(name, options) {
            var component, componentClass;
            if (typeof name == "string") {
                options = options || {};
                componentClass = options.componentClass || _V_.uc(name);
                component = new _V_[componentClass](this.player || this, options);
            } else {
                component = name;
            }
            this.el.appendChild(component.el);
            return component;
        },
        removeComponent: function removeComponent(component) {
            this.el.removeChild(component.el);
        },
        show: function show() {
            this.el.style.display = "block";
        },
        hide: function hide() {
            this.el.style.display = "none";
        },
        fadeIn: function fadeIn() {
            this.removeClass("vjs-fade-out");
            this.addClass("vjs-fade-in");
        },
        fadeOut: function fadeOut() {
            this.removeClass("vjs-fade-in");
            this.addClass("vjs-fade-out");
        },
        lockShowing: function lockShowing() {
            var style = this.el.style;
            style.display = "block";
            style.opacity = 1;
            style.visiblity = "visible";
        },
        unlockShowing: function unlockShowing() {
            var style = this.el.style;
            style.display = "";
            style.opacity = "";
            style.visiblity = "";
        },
        addClass: function addClass(classToAdd) {
            _V_.addClass(this.el, classToAdd);
        },
        removeClass: function removeClass(classToRemove) {
            _V_.removeClass(this.el, classToRemove);
        },
        addEvent: function addEvent(type, fn, uid) {
            return _V_.addEvent(this.el, type, _V_.proxy(this, fn));
        },
        removeEvent: function removeEvent(type, fn) {
            return _V_.removeEvent(this.el, type, fn);
        },
        triggerEvent: function triggerEvent(type, e) {
            return _V_.triggerEvent(this.el, type, e);
        },
        one: function one(type, fn) {
            _V_.one(this.el, type, _V_.proxy(this, fn));
        },
        ready: function ready(fn) {
            if (!fn) {
                return this;
            }
            if (this.isReady) {
                fn.call(this);
            } else {
                if (this.readyQueue === undefined) {
                    this.readyQueue = [];
                }
                this.readyQueue.push(fn);
            }
            return this;
        },
        triggerReady: function triggerReady() {
            this.isReady = true;
            if (this.readyQueue && this.readyQueue.length > 0) {
                this.each(this.readyQueue, function (fn) {
                    fn.call(this);
                });
                this.readyQueue = [];
                this.triggerEvent("ready");
            }
        },
        each: function each(arr, fn) {
            _V_.each.call(this, arr, fn);
        },
        eachProp: function eachProp(obj, fn) {
            _V_.eachProp.call(this, obj, fn);
        },
        extend: function extend(obj) {
            _V_.merge(this, obj);
        },
        proxy: function proxy(fn, uid) {
            return _V_.proxy(this, fn, uid);
        }
    });
    _V_.Control = _V_.Component.extend({
        buildCSSClass: function buildCSSClass() {
            return "vjs-control " + this._super();
        }
    });
    _V_.ControlBar = _V_.Component.extend({
        options: {
            loadEvent: "play",
            components: {
                playToggle: {},
                fullscreenToggle: {},
                currentTimeDisplay: {},
                timeDivider: {},
                durationDisplay: {},
                remainingTimeDisplay: {},
                progressControl: {},
                volumeControl: {},
                muteToggle: {}
            }
        },
        init: function init(player, options) {
            this._super(player, options);
            player.addEvent("play", this.proxy(function () {
                this.fadeIn();
                this.player.addEvent("mouseover", this.proxy(this.fadeIn));
                this.player.addEvent("mouseout", this.proxy(this.fadeOut));
            }));
        },
        createElement: function createElement() {
            return _V_.createElement("div", {
                className: "vjs-controls"
            });
        },
        fadeIn: function fadeIn() {
            this._super();
            this.player.triggerEvent("controlsvisible");
        },
        fadeOut: function fadeOut() {
            this._super();
            this.player.triggerEvent("controlshidden");
        },
        lockShowing: function lockShowing() {
            this.el.style.opacity = "1";
        }
    });
    _V_.Button = _V_.Control.extend({
        init: function init(player, options) {
            this._super(player, options);
            this.addEvent("click", this.onClick);
            this.addEvent("focus", this.onFocus);
            this.addEvent("blur", this.onBlur);
        },
        createElement: function createElement(type, attrs) {
            attrs = _V_.merge({
                className: this.buildCSSClass(),
                innerHTML: '<div><span class="vjs-control-text">' + (this.buttonText || "Need Text") + "</span></div>",
                role: "button",
                tabIndex: 0
            }, attrs);
            return this._super(type, attrs);
        },
        onClick: function onClick() {},
        onFocus: function onFocus() {
            _V_.addEvent(document, "keyup", _V_.proxy(this, this.onKeyPress));
        },
        onKeyPress: function onKeyPress(event) {
            if (event.which == 32 || event.which == 13) {
                event.preventDefault();
                this.onClick();
            }
        },
        onBlur: function onBlur() {
            _V_.removeEvent(document, "keyup", _V_.proxy(this, this.onKeyPress));
        }
    });
    _V_.PlayButton = _V_.Button.extend({
        buttonText: "Play",
        buildCSSClass: function buildCSSClass() {
            return "vjs-play-button " + this._super();
        },
        onClick: function onClick() {
            this.player.play();
        }
    });
    _V_.PauseButton = _V_.Button.extend({
        buttonText: "Pause",
        buildCSSClass: function buildCSSClass() {
            return "vjs-pause-button " + this._super();
        },
        onClick: function onClick() {
            this.player.pause();
        }
    });
    _V_.PlayToggle = _V_.Button.extend({
        buttonText: "Play",
        init: function init(player, options) {
            this._super(player, options);
            player.addEvent("play", _V_.proxy(this, this.onPlay));
            player.addEvent("pause", _V_.proxy(this, this.onPause));
        },
        buildCSSClass: function buildCSSClass() {
            return "vjs-play-control " + this._super();
        },
        onClick: function onClick() {
            if (this.player.paused()) {
                this.player.play();
            } else {
                this.player.pause();
            }
        },
        onPlay: function onPlay() {
            _V_.removeClass(this.el, "vjs-paused");
            _V_.addClass(this.el, "vjs-playing");
        },
        onPause: function onPause() {
            _V_.removeClass(this.el, "vjs-playing");
            _V_.addClass(this.el, "vjs-paused");
        }
    });
    _V_.FullscreenToggle = _V_.Button.extend({
        buttonText: "Fullscreen",
        buildCSSClass: function buildCSSClass() {
            return "vjs-fullscreen-control " + this._super();
        },
        onClick: function onClick() {
            if (!this.player.isFullScreen) {
                this.player.requestFullScreen();
            } else {
                this.player.cancelFullScreen();
            }
        }
    });
    _V_.BigPlayButton = _V_.Button.extend({
        init: function init(player, options) {
            this._super(player, options);
            player.addEvent("play", _V_.proxy(this, this.hide));
            player.addEvent("ended", _V_.proxy(this, this.show));
        },
        createElement: function createElement() {
            return this._super("div", {
                className: "vjs-big-play-button",
                innerHTML: "<span></span>"
            });
        },
        onClick: function onClick() {
            if (this.player.currentTime()) {
                this.player.currentTime(0);
            }
            this.player.play();
        }
    });
    _V_.LoadingSpinner = _V_.Component.extend({
        init: function init(player, options) {
            this._super(player, options);
            player.addEvent("canplay", _V_.proxy(this, this.hide));
            player.addEvent("canplaythrough", _V_.proxy(this, this.hide));
            player.addEvent("playing", _V_.proxy(this, this.hide));
            player.addEvent("seeking", _V_.proxy(this, this.show));
            player.addEvent("error", _V_.proxy(this, this.show));
            player.addEvent("waiting", _V_.proxy(this, this.show));
        },
        createElement: function createElement() {
            var classNameSpinner, innerHtmlSpinner;
            if (typeof this.player.el.style.WebkitBorderRadius == "string" || typeof this.player.el.style.MozBorderRadius == "string" || typeof this.player.el.style.KhtmlBorderRadius == "string" || typeof this.player.el.style.borderRadius == "string") {
                classNameSpinner = "vjs-loading-spinner";
                innerHtmlSpinner = "<div class='ball1'></div><div class='ball2'></div><div class='ball3'></div><div class='ball4'></div><div class='ball5'></div><div class='ball6'></div><div class='ball7'></div><div class='ball8'></div>";
            } else {
                classNameSpinner = "vjs-loading-spinner-fallback";
                innerHtmlSpinner = "";
            }
            return this._super("div", {
                className: classNameSpinner,
                innerHTML: innerHtmlSpinner
            });
        }
    });
    _V_.CurrentTimeDisplay = _V_.Component.extend({
        init: function init(player, options) {
            this._super(player, options);
            player.addEvent("timeupdate", _V_.proxy(this, this.updateContent));
        },
        createElement: function createElement() {
            var el = this._super("div", {
                className: "vjs-current-time vjs-time-controls vjs-control"
            });
            this.content = _V_.createElement("div", {
                className: "vjs-current-time-display",
                innerHTML: "0:00"
            });
            el.appendChild(_V_.createElement("div").appendChild(this.content));
            return el;
        },
        updateContent: function updateContent() {
            var time = this.player.scrubbing ? this.player.values.currentTime : this.player.currentTime();
            this.content.innerHTML = _V_.formatTime(time, this.player.duration());
        }
    });
    _V_.DurationDisplay = _V_.Component.extend({
        init: function init(player, options) {
            this._super(player, options);
            player.addEvent("timeupdate", _V_.proxy(this, this.updateContent));
        },
        createElement: function createElement() {
            var el = this._super("div", {
                className: "vjs-duration vjs-time-controls vjs-control"
            });
            this.content = _V_.createElement("div", {
                className: "vjs-duration-display",
                innerHTML: "0:00"
            });
            el.appendChild(_V_.createElement("div").appendChild(this.content));
            return el;
        },
        updateContent: function updateContent() {
            if (this.player.duration()) {
                this.content.innerHTML = _V_.formatTime(this.player.duration());
            }
        }
    });
    _V_.TimeDivider = _V_.Component.extend({
        createElement: function createElement() {
            return this._super("div", {
                className: "vjs-time-divider",
                innerHTML: "<div><span>/</span></div>"
            });
        }
    });
    _V_.RemainingTimeDisplay = _V_.Component.extend({
        init: function init(player, options) {
            this._super(player, options);
            player.addEvent("timeupdate", _V_.proxy(this, this.updateContent));
        },
        createElement: function createElement() {
            var el = this._super("div", {
                className: "vjs-remaining-time vjs-time-controls vjs-control"
            });
            this.content = _V_.createElement("div", {
                className: "vjs-remaining-time-display",
                innerHTML: "-0:00"
            });
            el.appendChild(_V_.createElement("div").appendChild(this.content));
            return el;
        },
        updateContent: function updateContent() {
            if (this.player.duration()) {
                this.content.innerHTML = "-" + _V_.formatTime(this.player.remainingTime());
            }
        }
    });
    _V_.Slider = _V_.Component.extend({
        init: function init(player, options) {
            this._super(player, options);
            player.addEvent(this.playerEvent, _V_.proxy(this, this.update));
            this.addEvent("mousedown", this.onMouseDown);
            this.addEvent("focus", this.onFocus);
            this.addEvent("blur", this.onBlur);
            this.player.addEvent("controlsvisible", this.proxy(this.update));
            this.update();
        },
        createElement: function createElement(type, attrs) {
            attrs = _V_.merge({
                role: "slider",
                "aria-valuenow": 0,
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                tabIndex: 0
            }, attrs);
            return this._super(type, attrs);
        },
        onMouseDown: function onMouseDown(event) {
            event.preventDefault();
            _V_.blockTextSelection();
            _V_.addEvent(document, "mousemove", _V_.proxy(this, this.onMouseMove));
            _V_.addEvent(document, "mouseup", _V_.proxy(this, this.onMouseUp));
            this.onMouseMove(event);
        },
        onMouseUp: function onMouseUp(event) {
            _V_.unblockTextSelection();
            _V_.removeEvent(document, "mousemove", this.onMouseMove, false);
            _V_.removeEvent(document, "mouseup", this.onMouseUp, false);
            this.update();
        },
        update: function update() {
            var barProgress,
                progress = this.getPercent();
            handle = this.handle, bar = this.bar;
            if (isNaN(progress)) {
                progress = 0;
            }
            barProgress = progress;
            if (handle) {
                var box = this.el,
                    boxWidth = box.offsetWidth,
                    handleWidth = handle.el.offsetWidth,
                    handlePercent = handleWidth ? handleWidth / boxWidth : 0,
                    boxAdjustedPercent = 1 - handlePercent;
                adjustedProgress = progress * boxAdjustedPercent, barProgress = adjustedProgress + handlePercent / 2;
                handle.el.style.left = _V_.round(adjustedProgress * 100, 2) + "%";
            }
            bar.el.style.width = _V_.round(barProgress * 100, 2) + "%";
        },
        calculateDistance: function calculateDistance(event) {
            var box = this.el,
                boxX = _V_.findPosX(box),
                boxW = box.offsetWidth,
                handle = this.handle;
            if (handle) {
                var handleW = handle.el.offsetWidth;
                boxX = boxX + handleW / 2;
                boxW = boxW - handleW;
            }
            return Math.max(0, Math.min(1, (event.pageX - boxX) / boxW));
        },
        onFocus: function onFocus(event) {
            _V_.addEvent(document, "keyup", _V_.proxy(this, this.onKeyPress));
        },
        onKeyPress: function onKeyPress(event) {
            if (event.which == 37) {
                event.preventDefault();
                this.stepBack();
            } else {
                if (event.which == 39) {
                    event.preventDefault();
                    this.stepForward();
                }
            }
        },
        onBlur: function onBlur(event) {
            _V_.removeEvent(document, "keyup", _V_.proxy(this, this.onKeyPress));
        }
    });
    _V_.ProgressControl = _V_.Component.extend({
        options: {
            components: {
                seekBar: {}
            }
        },
        createElement: function createElement() {
            return this._super("div", {
                className: "vjs-progress-control vjs-control"
            });
        }
    });
    _V_.SeekBar = _V_.Slider.extend({
        options: {
            components: {
                loadProgressBar: {},
                bar: {
                    componentClass: "PlayProgressBar"
                },
                handle: {
                    componentClass: "SeekHandle"
                }
            }
        },
        playerEvent: "timeupdate",
        init: function init(player, options) {
            this._super(player, options);
        },
        createElement: function createElement() {
            return this._super("div", {
                className: "vjs-progress-holder"
            });
        },
        getPercent: function getPercent() {
            return this.player.currentTime() / this.player.duration();
        },
        onMouseDown: function onMouseDown(event) {
            this._super(event);
            this.player.scrubbing = true;
            this.videoWasPlaying = !this.player.paused();
            this.player.pause();
        },
        onMouseMove: function onMouseMove(event) {
            var newTime = this.calculateDistance(event) * this.player.duration();
            if (newTime == this.player.duration()) {
                newTime = newTime - 0.1;
            }
            this.player.currentTime(newTime);
        },
        onMouseUp: function onMouseUp(event) {
            this._super(event);
            this.player.scrubbing = false;
            if (this.videoWasPlaying) {
                this.player.play();
            }
        },
        stepForward: function stepForward() {
            this.player.currentTime(this.player.currentTime() + 1);
        },
        stepBack: function stepBack() {
            this.player.currentTime(this.player.currentTime() - 1);
        }
    });
    _V_.LoadProgressBar = _V_.Component.extend({
        init: function init(player, options) {
            this._super(player, options);
            player.addEvent("progress", _V_.proxy(this, this.update));
        },
        createElement: function createElement() {
            return this._super("div", {
                className: "vjs-load-progress",
                innerHTML: '<span class="vjs-control-text">Loaded: 0%</span>'
            });
        },
        update: function update() {
            if (this.el.style) {
                this.el.style.width = _V_.round(this.player.bufferedPercent() * 100, 2) + "%";
            }
        }
    });
    _V_.PlayProgressBar = _V_.Component.extend({
        createElement: function createElement() {
            return this._super("div", {
                className: "vjs-play-progress",
                innerHTML: '<span class="vjs-control-text">Progress: 0%</span>'
            });
        }
    });
    _V_.SeekHandle = _V_.Component.extend({
        createElement: function createElement() {
            return this._super("div", {
                className: "vjs-seek-handle",
                innerHTML: '<span class="vjs-control-text">00:00</span>'
            });
        }
    });
    _V_.VolumeControl = _V_.Component.extend({
        options: {
            components: {
                volumeBar: {}
            }
        },
        createElement: function createElement() {
            return this._super("div", {
                className: "vjs-volume-control vjs-control"
            });
        }
    });
    _V_.VolumeBar = _V_.Slider.extend({
        options: {
            components: {
                bar: {
                    componentClass: "VolumeLevel"
                },
                handle: {
                    componentClass: "VolumeHandle"
                }
            }
        },
        playerEvent: "volumechange",
        createElement: function createElement() {
            return this._super("div", {
                className: "vjs-volume-bar"
            });
        },
        onMouseMove: function onMouseMove(event) {
            this.player.volume(this.calculateDistance(event));
        },
        getPercent: function getPercent() {
            return this.player.volume();
        },
        stepForward: function stepForward() {
            this.player.volume(this.player.volume() + 0.1);
        },
        stepBack: function stepBack() {
            this.player.volume(this.player.volume() - 0.1);
        }
    });
    _V_.VolumeLevel = _V_.Component.extend({
        createElement: function createElement() {
            return this._super("div", {
                className: "vjs-volume-level",
                innerHTML: '<span class="vjs-control-text"></span>'
            });
        }
    });
    _V_.VolumeHandle = _V_.Component.extend({
        createElement: function createElement() {
            return this._super("div", {
                className: "vjs-volume-handle",
                innerHTML: '<span class="vjs-control-text"></span>'
            });
        }
    });
    _V_.MuteToggle = _V_.Button.extend({
        init: function init(player, options) {
            this._super(player, options);
            player.addEvent("volumechange", _V_.proxy(this, this.update));
        },
        createElement: function createElement() {
            return this._super("div", {
                className: "vjs-mute-control vjs-control",
                innerHTML: '<div><span class="vjs-control-text">Mute</span></div>'
            });
        },
        onClick: function onClick(event) {
            var vol = _lastVolume;

            if (this.player.muted()) {
                this.player.muted(false);
                this.player.volume(vol);
                videoJSLastVolume = vol;
            } else {
                this.player.muted(true);
                this.player.volume(0);
                videoJSLastVolume = 0;
            }
        },
        update: function update(event) {
            var vol = this.player.volume(),
                level = 3;

            videoJSLastVolume = vol;

            if (vol == 0 || this.player.muted()) {
                level = 0;
            } else {
                if (vol < 0.33) {
                    level = 1;
                } else {
                    if (vol < 0.67) {
                        level = 2;
                    }
                }
            }
            _V_.each.call(this, [0, 1, 2, 3], function (i) {
                _V_.removeClass(this.el, "vjs-vol-" + i);
            });
            _V_.addClass(this.el, "vjs-vol-" + level);
        }
    });
    _V_.PosterImage = _V_.Button.extend({
        init: function init(player, options) {
            this._super(player, options);
            if (!this.player.options.poster) {
                this.hide();
            }
            player.addEvent("play", _V_.proxy(this, this.hide));
        },
        createElement: function createElement() {
            return _V_.createElement("img", {
                className: "vjs-poster",
                src: this.player.options.poster,
                tabIndex: -1
            });
        },
        onClick: function onClick() {
            this.player.play();
        }
    });
    _V_.Menu = _V_.Component.extend({
        init: function init(player, options) {
            this._super(player, options);
        },
        addItem: function addItem(component) {
            this.addComponent(component);
            component.addEvent("click", this.proxy(function () {
                this.unlockShowing();
            }));
        },
        createElement: function createElement() {
            return this._super("ul", {
                className: "vjs-menu"
            });
        }
    });
    _V_.MenuItem = _V_.Button.extend({
        init: function init(player, options) {
            this._super(player, options);
            if (options.selected) {
                this.addClass("vjs-selected");
            }
        },
        createElement: function createElement(type, attrs) {
            return this._super("li", _V_.merge({
                className: "vjs-menu-item",
                innerHTML: this.options.label
            }, attrs));
        },
        onClick: function onClick() {
            this.selected(true);
        },
        selected: function selected(_selected) {
            if (_selected) {
                this.addClass("vjs-selected");
            } else {
                this.removeClass("vjs-selected");
            }
        }
    });
    if (!Array.prototype.indexOf) {
        Array.prototype.indexOf = function (searchElement) {
            if (this === void 0 || this === null) {
                throw new TypeError();
            }
            var t = Object(this);
            var len = t.length >>> 0;
            if (len === 0) {
                return -1;
            }
            var n = 0;
            if (arguments.length > 0) {
                n = Number(arguments[1]);
                if (n !== n) {
                    n = 0;
                } else {
                    if (n !== 0 && n !== 1 / 0 && n !== -(1 / 0)) {
                        n = (n > 0 || -1) * Math.floor(Math.abs(n));
                    }
                }
            }
            if (n >= len) {
                return -1;
            }
            var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
            for (; k < len; k++) {
                if (k in t && t[k] === searchElement) {
                    return k;
                }
            }
            return -1;
        };
    }
    _V_.extend({
        addEvent: function addEvent(elem, type, fn) {
            var data = _V_.getData(elem),
                handlers;
            if (data && !data.handler) {
                data.handler = function (event) {
                    event = _V_.fixEvent(event);
                    var handlers = _V_.getData(elem).events[event.type];
                    if (handlers) {
                        var handlersCopy = [];
                        _V_.each(handlers, function (handler, i) {
                            handlersCopy[i] = handler;
                        });
                        for (var i = 0, l = handlersCopy.length; i < l; i++) {
                            handlersCopy[i].call(elem, event);
                        }
                    }
                };
            }
            if (!data.events) {
                data.events = {};
            }
            handlers = data.events[type];
            if (!handlers) {
                handlers = data.events[type] = [];
                if (document.addEventListener) {
                    elem.addEventListener(type, data.handler, false);
                } else {
                    if (document.attachEvent) {
                        elem.attachEvent("on" + type, data.handler);
                    }
                }
            }
            if (!fn.guid) {
                fn.guid = _V_.guid++;
            }
            handlers.push(fn);
        },
        removeEvent: function removeEvent(elem, type, fn) {
            var data = _V_.getData(elem),
                handlers;
            if (!data.events) {
                return;
            }
            if (!type) {
                for (type in data.events) {
                    _V_.cleanUpEvents(elem, type);
                }
                return;
            }
            handlers = data.events[type];
            if (!handlers) {
                return;
            }
            if (fn && fn.guid) {
                for (var i = 0; i < handlers.length; i++) {
                    if (handlers[i].guid === fn.guid) {
                        handlers.splice(i--, 1);
                    }
                }
            }
            _V_.cleanUpEvents(elem, type);
        },
        cleanUpEvents: function cleanUpEvents(elem, type) {
            var data = _V_.getData(elem);
            if (data.events[type].length === 0) {
                delete data.events[type];
                if (document.removeEventListener) {
                    elem.removeEventListener(type, data.handler, false);
                } else {
                    if (document.detachEvent) {
                        elem.detachEvent("on" + type, data.handler);
                    }
                }
            }
            if (_V_.isEmpty(data.events)) {
                delete data.events;
                delete data.handler;
            }
            if (_V_.isEmpty(data)) {
                _V_.removeData(elem);
            }
        },
        fixEvent: function fixEvent(event) {
            if (event[_V_.expando]) {
                return event;
            }
            var originalEvent = event;
            event = new _V_.Event(originalEvent);
            for (var i = _V_.Event.props.length, prop; i;) {
                prop = _V_.Event.props[--i];
                event[prop] = originalEvent[prop];
            }
            if (!event.target) {
                event.target = event.srcElement || document;
            }
            if (event.target.nodeType === 3) {
                event.target = event.target.parentNode;
            }
            if (!event.relatedTarget && event.fromElement) {
                event.relatedTarget = event.fromElement === event.target ? event.toElement : event.fromElement;
            }
            if (event.pageX == null && event.clientX != null) {
                var eventDocument = event.target.ownerDocument || document,
                    doc = eventDocument.documentElement,
                    body = eventDocument.body;
                event.pageX = event.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
                event.pageY = event.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
            }
            if (event.which == null && (event.charCode != null || event.keyCode != null)) {
                event.which = event.charCode != null ? event.charCode : event.keyCode;
            }
            if (!event.metaKey && event.ctrlKey) {
                event.metaKey = event.ctrlKey;
            }
            if (!event.which && event.button !== undefined) {
                event.which = event.button & 1 ? 1 : event.button & 2 ? 3 : event.button & 4 ? 2 : 0;
            }
            return event;
        },
        triggerEvent: function triggerEvent(elem, event) {
            var data = _V_.getData(elem),
                parent = elem.parentNode || elem.ownerDocument,
                type = event.type || event,
                handler;
            if (data) {
                handler = data.handler;
            }
            event = (typeof event === "undefined" ? "undefined" : _typeof(event)) === "object" ? event[_V_.expando] ? event : new _V_.Event(type, event) : new _V_.Event(type);
            event.type = type;
            if (handler) {
                handler.call(elem, event);
            }
            event.result = undefined;
            event.target = elem;
        },
        one: function one(elem, type, fn) {
            _V_.addEvent(elem, type, function () {
                _V_.removeEvent(elem, type, arguments.callee);
                fn.apply(this, arguments);
            });
        }
    });
    _V_.Event = function (src, props) {
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            this.isDefaultPrevented = src.defaultPrevented || src.returnValue === false || src.getPreventDefault && src.getPreventDefault() ? returnTrue : returnFalse;
        } else {
            this.type = src;
        }
        if (props) {
            _V_.merge(this, props);
        }
        this.timeStamp = new Date().getTime();
        this[_V_.expando] = true;
    };
    _V_.Event.prototype = {
        preventDefault: function preventDefault() {
            this.isDefaultPrevented = returnTrue;
            var e = this.originalEvent;
            if (!e) {
                return;
            }
            if (e.preventDefault) {
                e.preventDefault();
            } else {
                e.returnValue = false;
            }
        },
        stopPropagation: function stopPropagation() {
            this.isPropagationStopped = returnTrue;
            var e = this.originalEvent;
            if (!e) {
                return;
            }
            if (e.stopPropagation) {
                e.stopPropagation();
            }
            e.cancelBubble = true;
        },
        stopImmediatePropagation: function stopImmediatePropagation() {
            this.isImmediatePropagationStopped = returnTrue;
            this.stopPropagation();
        },
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse
    };
    _V_.Event.props = "altKey attrChange attrName bubbles button cancelable charCode clientX clientY ctrlKey currentTarget data detail eventPhase fromElement handler keyCode metaKey newValue offsetX offsetY pageX pageY prevValue relatedNode relatedTarget screenX screenY shiftKey srcElement target toElement view wheelDelta which".split(" ");
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    var JSON;
    if (!JSON) {
        JSON = {};
    }(function () {
        var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
        if (typeof JSON.parse !== "function") {
            JSON.parse = function (text, reviver) {
                var j;
                function walk(holder, key) {
                    var k,
                        v,
                        value = holder[key];
                    if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
                        for (k in value) {
                            if (Object.prototype.hasOwnProperty.call(value, k)) {
                                v = walk(value, k);
                                if (v !== undefined) {
                                    value[k] = v;
                                } else {
                                    delete value[k];
                                }
                            }
                        }
                    }
                    return reviver.call(holder, key, value);
                }
                text = String(text);
                cx.lastIndex = 0;
                if (cx.test(text)) {
                    text = text.replace(cx, function (a) {
                        return "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
                    });
                }
                if (/^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]").replace(/(?:^|:|,)(?:\s*\[)+/g, ""))) {
                    j = eval("(" + text + ")");
                    return typeof reviver === "function" ? walk({
                        "": j
                    }, "") : j;
                }
                throw new SyntaxError("JSON.parse");
            };
        }
    })();
    _V_.Player = _V_.Component.extend({
        init: function init(tag, addOptions, ready) {
            this.tag = tag;
            var el = this.el = _V_.createElement("div"),
                options = this.options = {},
                width = options.width = tag.getAttribute("width"),
                height = options.height = tag.getAttribute("height"),
                initWidth = width || 300,
                initHeight = height || 150;
            tag.player = el.player = this;
            this.ready(ready);
            tag.parentNode.insertBefore(el, tag);
            el.appendChild(tag);
            el.id = this.id = tag.id;
            el.className = tag.className;
            tag.id += "_html5_api";
            tag.className = "vjs-tech";
            _V_.players[el.id] = this;
            el.setAttribute("width", initWidth);
            el.setAttribute("height", initHeight);
            el.style.width = initWidth + "px";
            el.style.height = initHeight + "px";
            tag.removeAttribute("width");
            tag.removeAttribute("height");
            _V_.merge(options, _V_.options);
            _V_.merge(options, this.getVideoTagSettings());
            _V_.merge(options, addOptions);
            tag.removeAttribute("controls");
            tag.removeAttribute("poster");
            if (tag.hasChildNodes()) {
                for (var i = 0, j = tag.childNodes; i < j.length; i++) {
                    if (j[i].nodeName == "SOURCE" || j[i].nodeName == "TRACK") {
                        tag.removeChild(j[i]);
                    }
                }
            }
            this.values = {};
            this.addClass("vjs-paused");
            this.addEvent("ended", this.onEnded);
            this.addEvent("play", this.onPlay);
            this.addEvent("pause", this.onPause);
            this.addEvent("progress", this.onProgress);
            this.addEvent("error", this.onError);
            if (options.controls) {
                this.ready(function () {
                    this.initComponents();
                });
            }
            this.textTracks = [];
            if (options.tracks && options.tracks.length > 0) {
                this.addTextTracks(options.tracks);
            }
            if (!options.sources || options.sources.length == 0) {
                for (var i = 0, j = options.techOrder; i < j.length; i++) {
                    var techName = j[i],
                        tech = _V_[techName];
                    if (tech.isSupported()) {
                        this.loadTech(techName);
                        break;
                    }
                }
            } else {
                this.src(options.sources);
            }
        },
        values: {},
        destroy: function destroy() {
            this.stopTrackingProgress();
            this.stopTrackingCurrentTime();
            _V_.players[this.id] = null;
            delete _V_.players[this.id];
            this.tech.destroy();
            this.el.parentNode.removeChild(this.el);
        },
        createElement: function createElement(type, options) {},
        getVideoTagSettings: function getVideoTagSettings() {
            var options = {
                sources: [],
                tracks: []
            };
            options.src = this.tag.getAttribute("src");
            options.controls = this.tag.getAttribute("controls") !== null;
            options.poster = this.tag.getAttribute("poster");
            options.preload = this.tag.getAttribute("preload");
            options.autoplay = this.tag.getAttribute("autoplay") !== null;
            options.loop = this.tag.getAttribute("loop") !== null;
            options.muted = this.tag.getAttribute("muted") !== null;
            if (this.tag.hasChildNodes()) {
                for (var c, i = 0, j = this.tag.childNodes; i < j.length; i++) {
                    c = j[i];
                    if (c.nodeName == "SOURCE") {
                        options.sources.push({
                            src: c.getAttribute("src"),
                            type: c.getAttribute("type"),
                            media: c.getAttribute("media"),
                            title: c.getAttribute("title")
                        });
                    }
                    if (c.nodeName == "TRACK") {
                        options.tracks.push({
                            src: c.getAttribute("src"),
                            kind: c.getAttribute("kind"),
                            srclang: c.getAttribute("srclang"),
                            label: c.getAttribute("label"),
                            "default": c.getAttribute("default") !== null,
                            title: c.getAttribute("title")
                        });
                    }
                }
            }
            return options;
        },
        loadTech: function loadTech(techName, source) {
            if (this.tech) {
                this.unloadTech();
            } else {
                if (techName != "html5" && this.tag) {
                    this.el.removeChild(this.tag);
                    this.tag = false;
                }
            }
            this.techName = techName;
            this.isReady = false;
            var techReady = function techReady() {
                this.player.triggerReady();
                if (!this.support.progressEvent) {
                    this.player.manualProgressOn();
                }
                if (!this.support.timeupdateEvent) {
                    this.player.manualTimeUpdatesOn();
                }
            };
            var techOptions = _V_.merge({
                source: source,
                parentEl: this.el
            }, this.options[techName]);
            if (source) {
                if (source.src == this.values.src && this.values.currentTime > 0) {
                    techOptions.startTime = this.values.currentTime;
                }
                this.values.src = source.src;
            }
            this.tech = new _V_[techName](this, techOptions);
            this.tech.ready(techReady);
        },
        unloadTech: function unloadTech() {
            this.tech.destroy();
            if (this.manualProgress) {
                this.manualProgressOff();
            }
            if (this.manualTimeUpdates) {
                this.manualTimeUpdatesOff();
            }
            this.tech = false;
        },
        manualProgressOn: function manualProgressOn() {
            this.manualProgress = true;
            this.trackProgress();
            this.tech.addEvent("progress", function () {
                this.removeEvent("progress", arguments.callee);
                this.support.progressEvent = true;
                this.player.manualProgressOff();
            });
        },
        manualProgressOff: function manualProgressOff() {
            this.manualProgress = false;
            this.stopTrackingProgress();
        },
        trackProgress: function trackProgress() {
            this.progressInterval = setInterval(_V_.proxy(this, function () {
                if (this.values.bufferEnd < this.buffered().end(0)) {
                    this.triggerEvent("progress");
                } else {
                    if (this.bufferedPercent() == 1) {
                        this.stopTrackingProgress();
                        this.triggerEvent("progress");
                    }
                }
            }), 500);
        },
        stopTrackingProgress: function stopTrackingProgress() {
            clearInterval(this.progressInterval);
        },
        manualTimeUpdatesOn: function manualTimeUpdatesOn() {
            this.manualTimeUpdates = true;
            this.addEvent("play", this.trackCurrentTime);
            this.addEvent("pause", this.stopTrackingCurrentTime);
            this.tech.addEvent("timeupdate", function () {
                this.removeEvent("timeupdate", arguments.callee);
                this.support.timeupdateEvent = true;
                this.player.manualTimeUpdatesOff();
            });
        },
        manualTimeUpdatesOff: function manualTimeUpdatesOff() {
            this.manualTimeUpdates = false;
            this.stopTrackingCurrentTime();
            this.removeEvent("play", this.trackCurrentTime);
            this.removeEvent("pause", this.stopTrackingCurrentTime);
        },
        trackCurrentTime: function trackCurrentTime() {
            if (this.currentTimeInterval) {
                this.stopTrackingCurrentTime();
            }
            this.currentTimeInterval = setInterval(_V_.proxy(this, function () {
                this.triggerEvent("timeupdate");
            }), 250);
        },
        stopTrackingCurrentTime: function stopTrackingCurrentTime() {
            clearInterval(this.currentTimeInterval);
        },
        onEnded: function onEnded() {
            if (this.options.loop) {
                this.currentTime(0);
                this.play();
            } else {
                this.pause();
                this.currentTime(0);
                this.pause();
            }
        },
        onPlay: function onPlay() {
            _V_.removeClass(this.el, "vjs-paused");
            _V_.addClass(this.el, "vjs-playing");
        },
        onPause: function onPause() {
            _V_.removeClass(this.el, "vjs-playing");
            _V_.addClass(this.el, "vjs-paused");
        },
        onProgress: function onProgress() {
            if (this.bufferedPercent() == 1) {
                this.triggerEvent("loadedalldata");
            }
        },
        onError: function onError(e) {
            _V_.log("Video Error", e);
        },
        techCall: function techCall(method, arg) {
            if (!this.tech.isReady) {
                this.tech.ready(function () {
                    this[method](arg);
                });
            } else {
                try {
                    this.tech[method](arg);
                } catch (e) {
                    _V_.log(e);
                }
            }
        },
        techGet: function techGet(method) {
            if (this.tech.isReady) {
                try {
                    return this.tech[method]();
                } catch (e) {
                    if (this.tech[method] === undefined) {
                        _V_.log("Video.js: " + method + " method not defined for " + this.techName + " playback technology.", e);
                    } else {
                        if (e.name == "TypeError") {
                            _V_.log("Video.js: " + method + " unavailable on " + this.techName + " playback technology element.", e);
                            this.tech.isReady = false;
                        } else {
                            _V_.log(e);
                        }
                    }
                }
            }
            return;
        },
        play: function play() {
            this.techCall("play");
            return this;
        },
        pause: function pause() {
            this.techCall("pause");
            return this;
        },
        paused: function paused() {
            return this.techGet("paused") === false ? false : true;
        },
        currentTime: function currentTime(seconds) {
            if (seconds !== undefined) {
                this.values.lastSetCurrentTime = seconds;
                this.techCall("setCurrentTime", seconds);
                if (this.manualTimeUpdates) {
                    this.triggerEvent("timeupdate");
                }
                return this;
            }
            return this.values.currentTime = this.techGet("currentTime") || 0;
        },
        duration: function duration() {
            return parseFloat(this.techGet("duration"));
        },
        remainingTime: function remainingTime() {
            return this.duration() - this.currentTime();
        },
        buffered: function buffered() {
            var buffered = this.techGet("buffered"),
                start = 0,
                end = this.values.bufferEnd = this.values.bufferEnd || 0,
                timeRange;
            if (buffered && buffered.length > 0 && buffered.end(0) !== end) {
                end = buffered.end(0);
                this.values.bufferEnd = end;
            }
            return _V_.createTimeRange(start, end);
        },
        bufferedPercent: function bufferedPercent() {
            return this.duration() ? this.buffered().end(0) / this.duration() : 0;
        },
        volume: function volume(percentAsDecimal) {
            var vol;

            if (percentAsDecimal !== undefined) {
                vol = Math.max(0, Math.min(1, parseFloat(percentAsDecimal)));
                this.values.volume = vol;
                this.techCall("setVolume", vol);
                _V_.setLocalStorage("volume", vol);

                if (vol > 0) {
                    this.lastVolume(vol);
                }

                return this;
            }
            vol = parseFloat(this.techGet("volume"));

            return isNaN(vol) ? 1 : vol;
        },

        lastVolume: function lastVolume(percentAsDecimal) {
            if (percentAsDecimal !== undefined && percentAsDecimal !== 0) {
                _lastVolume = percentAsDecimal;
            }
            return _lastVolume;
        },

        muted: function muted(_muted) {
            if (_muted !== undefined) {
                this.techCall("setMuted", _muted);
                return this;
            }
            return this.techGet("muted") || false;
        },
        width: function width(_width, skipListeners) {
            if (_width !== undefined) {
                this.el.width = _width;
                this.el.style.width = _width + "px";
                if (!skipListeners) {
                    this.triggerEvent("resize");
                }
                return this;
            }
            return parseInt(this.el.getAttribute("width"));
        },
        height: function height(_height) {
            if (_height !== undefined) {
                this.el.height = _height;
                this.el.style.height = _height + "px";
                this.triggerEvent("resize");
                return this;
            }
            return parseInt(this.el.getAttribute("height"));
        },
        size: function size(width, height) {
            return this.width(width, true).height(height);
        },
        supportsFullScreen: function supportsFullScreen() {
            return this.techGet("supportsFullScreen") || false;
        },
        requestFullScreen: function requestFullScreen() {
            var requestFullScreen = _V_.support.requestFullScreen;
            this.isFullScreen = true;
            if (requestFullScreen) {
                _V_.addEvent(document, requestFullScreen.eventName, this.proxy(function () {
                    this.isFullScreen = document[requestFullScreen.isFullScreen];
                    if (this.isFullScreen == false) {
                        _V_.removeEvent(document, requestFullScreen.eventName, arguments.callee);
                    }
                    this.triggerEvent("fullscreenchange");
                }));
                if (this.tech.support.fullscreenResize === false && this.options.flash.iFrameMode != true) {
                    this.pause();
                    this.unloadTech();
                    _V_.addEvent(document, requestFullScreen.eventName, this.proxy(function () {
                        _V_.removeEvent(document, requestFullScreen.eventName, arguments.callee);
                        this.loadTech(this.techName, {
                            src: this.values.src
                        });
                    }));
                    this.el[requestFullScreen.requestFn]();
                } else {
                    this.el[requestFullScreen.requestFn]();
                }
            } else {
                if (this.tech.supportsFullScreen()) {
                    this.triggerEvent("fullscreenchange");
                    this.techCall("enterFullScreen");
                } else {
                    this.triggerEvent("fullscreenchange");
                    this.enterFullWindow();
                }
            }
            return this;
        },
        cancelFullScreen: function cancelFullScreen() {
            var requestFullScreen = _V_.support.requestFullScreen;
            this.isFullScreen = false;
            if (requestFullScreen) {
                if (this.tech.support.fullscreenResize === false && this.options.flash.iFrameMode != true) {
                    this.pause();
                    this.unloadTech();
                    _V_.addEvent(document, requestFullScreen.eventName, this.proxy(function () {
                        _V_.removeEvent(document, requestFullScreen.eventName, arguments.callee);
                        this.loadTech(this.techName, {
                            src: this.values.src
                        });
                    }));
                    document[requestFullScreen.cancelFn]();
                } else {
                    document[requestFullScreen.cancelFn]();
                }
            } else {
                if (this.tech.supportsFullScreen()) {
                    this.techCall("exitFullScreen");
                    this.triggerEvent("fullscreenchange");
                } else {
                    this.exitFullWindow();
                    this.triggerEvent("fullscreenchange");
                }
            }
            return this;
        },
        enterFullWindow: function enterFullWindow() {
            this.isFullWindow = true;
            this.docOrigOverflow = document.documentElement.style.overflow;
            _V_.addEvent(document, "keydown", _V_.proxy(this, this.fullWindowOnEscKey));
            document.documentElement.style.overflow = "hidden";
            _V_.addClass(document.body, "vjs-full-window");
            _V_.addClass(this.el, "vjs-fullscreen");
            this.triggerEvent("enterFullWindow");
        },
        fullWindowOnEscKey: function fullWindowOnEscKey(event) {
            if (event.keyCode == 27) {
                if (this.isFullScreen == true) {
                    this.cancelFullScreen();
                } else {
                    this.exitFullWindow();
                }
            }
        },
        exitFullWindow: function exitFullWindow() {
            this.isFullWindow = false;
            _V_.removeEvent(document, "keydown", this.fullWindowOnEscKey);
            document.documentElement.style.overflow = this.docOrigOverflow;
            _V_.removeClass(document.body, "vjs-full-window");
            _V_.removeClass(this.el, "vjs-fullscreen");
            this.triggerEvent("exitFullWindow");
        },
        selectSource: function selectSource(sources) {
            for (var i = 0, j = this.options.techOrder; i < j.length; i++) {
                var techName = j[i],
                    tech = _V_[techName];
                // if (tech.isSupported()) {
                for (var a = 0, b = sources; a < b.length; a++) {
                    var source = b[a];
                    if (tech.canPlaySource.call(this, source)) {
                        return {
                            source: source,
                            tech: techName
                        };
                    }
                }
                // }
            }
            return false;
        },
        src: function src(source) {
            if (source instanceof Array) {
                var sourceTech = this.selectSource(source),
                    source,
                    techName;
                if (sourceTech) {
                    source = sourceTech.source;
                    techName = sourceTech.tech;
                    if (techName == this.techName) {
                        this.src(source);
                    } else {
                        this.loadTech(techName, source);
                    }
                } else {
                    _V_.log("No compatible source and playback technology were found.");
                }
            } else {
                if (source instanceof Object) {
                    if (_V_[this.techName].canPlaySource(source)) {
                        this.src(source.src);
                    } else {
                        this.src([source]);
                    }
                } else {
                    this.values.src = source;
                    if (!this.isReady) {
                        this.ready(function () {
                            this.src(source);
                        });
                    } else {
                        this.techCall("src", source);
                        if (this.options.preload == "auto") {
                            this.load();
                        }
                        if (this.options.autoplay) {
                            this.play();
                        }
                    }
                }
            }
            return this;
        },
        load: function load() {
            this.techCall("load");
            return this;
        },
        currentSrc: function currentSrc() {
            return this.techGet("currentSrc") || this.values.src || "";
        },
        preload: function preload(value) {
            if (value !== undefined) {
                this.techCall("setPreload", value);
                this.options.preload = value;
                return this;
            }
            return this.techGet("preload");
        },
        autoplay: function autoplay(value) {
            if (value !== undefined) {
                this.techCall("setAutoplay", value);
                this.options.autoplay = value;
                return this;
            }
            return this.techGet("autoplay", value);
        },
        loop: function loop(value) {
            if (value !== undefined) {
                this.techCall("setLoop", value);
                this.options.loop = value;
                return this;
            }
            return this.techGet("loop");
        },
        controls: function controls() {
            return this.options.controls;
        },
        poster: function poster() {
            return this.techGet("poster");
        },
        error: function error() {
            return this.techGet("error");
        },
        ended: function ended() {
            return this.techGet("ended");
        }
    });(function () {
        var requestFn,
            cancelFn,
            eventName,
            isFullScreen,
            playerProto = _V_.Player.prototype;
        if (document.cancelFullscreen !== undefined) {
            requestFn = "requestFullscreen";
            cancelFn = "exitFullscreen";
            eventName = "fullscreenchange";
            isFullScreen = "fullScreen";
        } else {
            _V_.each(["moz", "webkit"], function (prefix) {
                if ((prefix != "moz" || document.mozFullScreenEnabled) && document[prefix + "CancelFullScreen"] !== undefined) {
                    requestFn = prefix + "RequestFullScreen";
                    cancelFn = prefix + "CancelFullScreen";
                    eventName = prefix + "fullscreenchange";
                    if (prefix == "webkit") {
                        isFullScreen = prefix + "IsFullScreen";
                    } else {
                        isFullScreen = prefix + "FullScreen";
                    }
                }
            });
        }
        if (requestFn) {
            _V_.support.requestFullScreen = {
                requestFn: requestFn,
                cancelFn: cancelFn,
                eventName: eventName,
                isFullScreen: isFullScreen
            };
        }
    })();
    _V_.PlaybackTech = _V_.Component.extend({
        init: function init(player, options) {},
        onClick: function onClick() {
            if (this.player.options.controls) {
                _V_.PlayToggle.prototype.onClick.call(this);
            }
        }
    });
    _V_.apiMethods = "play,pause,paused,currentTime,setCurrentTime,duration,buffered,volume,setVolume,lastVolume,muted,setMuted,width,height,supportsFullScreen,enterFullScreen,src,load,currentSrc,preload,setPreload,autoplay,setAutoplay,loop,setLoop,error,networkState,readyState,seeking,initialTime,startOffsetTime,played,seekable,ended,videoTracks,audioTracks,videoWidth,videoHeight,textTracks,defaultPlaybackRate,playbackRate,mediaGroup,controller,controls,defaultMuted".split(",");
    _V_.each(_V_.apiMethods, function (methodName) {
        _V_.PlaybackTech.prototype[methodName] = function () {
            throw new Error("The '" + methodName + "' method is not available on the playback technology's API");
        };
    });
    _V_.html5 = _V_.PlaybackTech.extend({
        init: function init(player, options, ready) {
            this.player = player;
            this.el = this.createElement();
            this.ready(ready);
            this.addEvent("click", this.proxy(this.onClick));
            var source = options.source;
            if (source && this.el.currentSrc == source.src) {
                player.triggerEvent("loadstart");
            } else {
                if (source) {
                    this.el.src = source.src;
                    // this.el.type = "application/vnd.apple.mpegurl";
                }
            }
            player.ready(function () {
                if (this.options.autoplay && this.paused()) {
                    this.tag.poster = null;
                    this.play();
                }
            });
            this.setupTriggers();
            this.triggerReady();
        },
        destroy: function destroy() {
            this.player.tag = false;
            this.removeTriggers();
            this.el.parentNode.removeChild(this.el);
        },
        createElement: function createElement() {
            var html5 = _V_.html5,
                player = this.player,
                el = player.tag,
                newEl;
            if (!el || this.support.movingElementInDOM === false) {
                if (el) {
                    player.el.removeChild(el);
                }
                newEl = _V_.createElement("video", {
                    id: el.id || player.el.id + "_html5_api",
                    className: el.className || "vjs-tech"
                });
                el = newEl;
                _V_.insertFirst(el, player.el);
            }
            _V_.each(["autoplay", "preload", "loop", "muted"], function (attr) {
                if (player.options[attr] !== null) {
                    el[attr] = player.options[attr];
                }
            }, this);
            return el;
        },
        setupTriggers: function setupTriggers() {
            _V_.each.call(this, _V_.html5.events, function (type) {
                _V_.addEvent(this.el, type, _V_.proxy(this.player, this.eventHandler));
            });
        },
        removeTriggers: function removeTriggers() {
            _V_.each.call(this, _V_.html5.events, function (type) {
                _V_.removeEvent(this.el, type, _V_.proxy(this.player, this.eventHandler));
            });
        },
        eventHandler: function eventHandler(e) {
            e.stopPropagation();
            this.triggerEvent(e);
        },
        play: function play() {
            this.el.play();
        },
        pause: function pause() {
            this.el.pause();
        },
        paused: function paused() {
            return this.el.paused;
        },
        currentTime: function currentTime() {
            return this.el.currentTime;
        },
        setCurrentTime: function setCurrentTime(seconds) {
            try {
                this.el.currentTime = seconds;
            } catch (e) {
                _V_.log(e, "Video isn't ready. (VideoJS)");
            }
        },
        duration: function duration() {
            return this.el.duration || 0;
        },
        buffered: function buffered() {
            return this.el.buffered;
        },
        volume: function volume() {
            return this.el.volume;
        },
        setVolume: function setVolume(percentAsDecimal) {
            this.el.volume = percentAsDecimal;
        },
        muted: function muted() {
            return this.el.muted;
        },
        setMuted: function setMuted(muted) {
            this.el.muted = muted;
        },
        width: function width() {
            return this.el.offsetWidth;
        },
        height: function height() {
            return this.el.offsetHeight;
        },
        supportsFullScreen: function supportsFullScreen() {
            if (typeof this.el.webkitEnterFullScreen == "function") {
                if (!navigator.userAgent.match("Chrome") && !navigator.userAgent.match("Mac OS X 10.5")) {
                    return true;
                }
            }
            return false;
        },
        enterFullScreen: function enterFullScreen() {
            try {
                this.el.webkitEnterFullScreen();
            } catch (e) {
                if (e.code == 11) {
                    _V_.log("VideoJS: Video not ready.");
                }
            }
        },
        src: function src(_src) {
            this.el.src = _src;
        },
        load: function load() {
            this.el.load();
        },
        currentSrc: function currentSrc() {
            return this.el.currentSrc;
        },
        preload: function preload() {
            return this.el.preload;
        },
        setPreload: function setPreload(val) {
            this.el.preload = val;
        },
        autoplay: function autoplay() {
            return this.el.autoplay;
        },
        setAutoplay: function setAutoplay(val) {
            this.el.autoplay = val;
        },
        loop: function loop() {
            return this.el.loop;
        },
        setLoop: function setLoop(val) {
            this.el.loop = val;
        },
        error: function error() {
            return this.el.error;
        },
        seeking: function seeking() {
            return this.el.seeking;
        },
        ended: function ended() {
            return this.el.ended;
        },
        controls: function controls() {
            return this.player.options.controls;
        },
        defaultMuted: function defaultMuted() {
            return this.el.defaultMuted;
        }
    });
    _V_.html5.isSupported = function () {
        return !!document.createElement("video").canPlayType;
    };
    _V_.html5.canPlaySource = function (srcObj) {
        return !!document.createElement("video").canPlayType(srcObj.type);
    };
    _V_.html5.events = "loadstart,suspend,abort,error,emptied,stalled,loadedmetadata,loadeddata,canplay,canplaythrough,playing,waiting,seeking,seeked,ended,durationchange,timeupdate,progress,play,pause,ratechange,volumechange".split(",");
    _V_.html5.prototype.support = {
        fullscreen: _typeof(_V_.testVid.webkitEnterFullScreen) !== undefined ? !_V_.ua.match("Chrome") && !_V_.ua.match("Mac OS X 10.5") ? true : false : false,
        movingElementInDOM: !_V_.isIOS()
    };
    if (_V_.isAndroid()) {
        if (_V_.androidVersion() < 3) {
            document.createElement("video").constructor.prototype.canPlayType = function (type) {
                return type && type.toLowerCase().indexOf("video/mp4") != -1 ? "maybe" : "";
            };
        }
    }
    _V_.flash = _V_.PlaybackTech.extend({
        init: function init(player, options) {
            this.player = player;
            var source = options.source,
                parentEl = options.parentEl,
                placeHolder = this.el = _V_.createElement("div", {
                id: parentEl.id + "_temp_flash"
            }),
                objId = player.el.id + "_flash_api",
                playerOptions = player.options,
                flashVars = _V_.merge({
                readyFunction: "_V_.flash.onReady",
                eventProxyFunction: "_V_.flash.onEvent",
                errorEventProxyFunction: "_V_.flash.onError",
                autoplay: playerOptions.autoplay,
                preload: playerOptions.preload,
                loop: playerOptions.loop,
                muted: playerOptions.muted
            }, options.flashVars),
                params = _V_.merge({
                wmode: "opaque",
                bgcolor: "#000000"
            }, options.params),
                attributes = _V_.merge({
                id: objId,
                name: objId,
                "class": "vjs-tech"
            }, options.attributes);
            if (source) {
                flashVars.src = encodeURIComponent(_V_.getAbsoluteURL(source.src));
            }
            _V_.insertFirst(placeHolder, parentEl);
            if (options.startTime) {
                this.ready(function () {
                    this.load();
                    this.play();
                    this.currentTime(options.startTime);
                });
            }
            if (options.iFrameMode == true && !_V_.isFF) {
                var iFrm = _V_.createElement("iframe", {
                    id: objId + "_iframe",
                    name: objId + "_iframe",
                    className: "vjs-tech",
                    scrolling: "no",
                    marginWidth: 0,
                    marginHeight: 0,
                    frameBorder: 0
                });
                flashVars.readyFunction = "ready";
                flashVars.eventProxyFunction = "events";
                flashVars.errorEventProxyFunction = "errors";
                _V_.addEvent(iFrm, "load", _V_.proxy(this, function () {
                    var iDoc,
                        objTag,
                        swfLoc,
                        iWin = iFrm.contentWindow,
                        varString = "";
                    iDoc = iFrm.contentDocument ? iFrm.contentDocument : iFrm.contentWindow.document;
                    iDoc.write(_V_.flash.getEmbedCode(options.swf, flashVars, params, attributes));
                    iWin.player = this.player;
                    iWin.ready = _V_.proxy(this.player, function (currSwf) {
                        var el = iDoc.getElementById(currSwf),
                            player = this,
                            tech = player.tech;
                        tech.el = el;
                        _V_.addEvent(el, "click", tech.proxy(tech.onClick));
                        _V_.flash.checkReady(tech);
                    });
                    iWin.events = _V_.proxy(this.player, function (swfID, eventName, other) {
                        var player = this;
                        if (player && player.techName == "flash") {
                            player.triggerEvent(eventName);
                        }
                    });
                    iWin.errors = _V_.proxy(this.player, function (swfID, eventName) {
                        _V_.log("Flash Error", eventName);
                    });
                }));
                placeHolder.parentNode.replaceChild(iFrm, placeHolder);
            } else {
                _V_.flash.embed(options.swf, placeHolder, flashVars, params, attributes);
            }
        },
        destroy: function destroy() {
            this.el.parentNode.removeChild(this.el);
        },
        play: function play() {
            this.el.vjs_play();
        },
        pause: function pause() {
            this.el.vjs_pause();
        },
        src: function src(_src2) {
            _src2 = _V_.getAbsoluteURL(_src2);
            this.el.vjs_src(_src2);
            if (this.player.autoplay()) {
                var tech = this;
                setTimeout(function () {
                    tech.play();
                }, 0);
            }
        },
        load: function load() {
            this.el.vjs_load();
        },
        poster: function poster() {
            this.el.vjs_getProperty("poster");
        },
        buffered: function buffered() {
            return _V_.createTimeRange(0, this.el.vjs_getProperty("buffered"));
        },
        supportsFullScreen: function supportsFullScreen() {
            return false;
        },
        enterFullScreen: function enterFullScreen() {
            return false;
        }
    });(function () {
        var api = _V_.flash.prototype,
            readWrite = "preload,currentTime,defaultPlaybackRate,playbackRate,autoplay,loop,mediaGroup,controller,controls,volume,muted,lastVolume,defaultMuted".split(","),
            readOnly = "error,currentSrc,networkState,readyState,seeking,initialTime,duration,startOffsetTime,paused,played,seekable,ended,videoTracks,audioTracks,videoWidth,videoHeight,textTracks".split(","),
            callOnly = "load,play,pause".split(",");
        createSetter = function createSetter(attr) {
            var attrUpper = attr.charAt(0).toUpperCase() + attr.slice(1);
            api["set" + attrUpper] = function (val) {
                return this.el.vjs_setProperty(attr, val);
            };
        }, createGetter = function createGetter(attr) {
            api[attr] = function () {
                return this.el.vjs_getProperty(attr);
            };
        };
        _V_.each(readWrite, function (attr) {
            createGetter(attr);
            createSetter(attr);
        });
        _V_.each(readOnly, function (attr) {
            createGetter(attr);
        });
    })();
    _V_.flash.isSupported = function () {
        return _V_.flash.version()[0] >= 10;
    };
    _V_.flash.canPlaySource = function (srcObj) {
        if (srcObj.type in _V_.flash.prototype.support.formats) {
            return "maybe";
        }
    };
    _V_.flash.prototype.support = {
        formats: {
            "video/flv": "FLV",
            "video/x-flv": "FLV",
            "video/mp4": "MP4",
            "video/m4v": "MP4"
        },
        progressEvent: false,
        timeupdateEvent: false,
        fullscreenResize: false,
        parentResize: !_V_.ua.match("Firefox")
    };
    _V_.flash.onReady = function (currSwf) {
        var el = _V_.el(currSwf);
        var player = el.player || el.parentNode.player,
            tech = player.tech;
        el.player = player;
        tech.el = el;
        tech.addEvent("click", tech.onClick);
        _V_.flash.checkReady(tech);
    };
    _V_.flash.checkReady = function (tech) {
        if (tech.el.vjs_getProperty) {
            tech.triggerReady();
        } else {
            setTimeout(function () {
                _V_.flash.checkReady(tech);
            }, 50);
        }
    };
    _V_.flash.onEvent = function (swfID, eventName) {
        var player = _V_.el(swfID).player;
        player.triggerEvent(eventName);
    };
    _V_.flash.onError = function (swfID, err) {
        var player = _V_.el(swfID).player;
        player.triggerEvent("error");
        _V_.log("Flash Error", err, swfID);
    };
    _V_.flash.version = function () {
        var version = "0,0,0";
        try {
            version = new ActiveXObject("ShockwaveFlash.ShockwaveFlash").GetVariable("$version").replace(/\D+/g, ",").match(/^,?(.+),?$/)[1];
        } catch (e) {
            try {
                if (navigator.mimeTypes["application/x-shockwave-flash"].enabledPlugin) {
                    version = (navigator.plugins["Shockwave Flash 2.0"] || navigator.plugins["Shockwave Flash"]).description.replace(/\D+/g, ",").match(/^,?(.+),?$/)[1];
                }
            } catch (e) {}
        }
        return version.split(",");
    };
    _V_.flash.embed = function (swf, placeHolder, flashVars, params, attributes) {
        var code = _V_.flash.getEmbedCode(swf, flashVars, params, attributes),
            obj = _V_.createElement("div", {
            innerHTML: code
        }).childNodes[0],
            par = placeHolder.parentNode;
        placeHolder.parentNode.replaceChild(obj, placeHolder);
        if (_V_.isIE()) {
            var newObj = par.childNodes[0];
            setTimeout(function () {
                newObj.style.display = "block";
            }, 1000);
        }
        return obj;
    };
    _V_.flash.getEmbedCode = function (swf, flashVars, params, attributes) {
        var objTag = '<object type="application/x-shockwave-flash"',
            flashVarsString = "",
            paramsString = "";
        attrsString = "";
        if (flashVars) {
            _V_.eachProp(flashVars, function (key, val) {
                flashVarsString += key + "=" + val + "&amp;";
            });
        }
        params = _V_.merge({
            movie: swf,
            flashvars: flashVarsString,
            allowScriptAccess: "always",
            allowNetworking: "all"
        }, params);
        _V_.eachProp(params, function (key, val) {
            paramsString += '<param name="' + key + '" value="' + val + '" />';
        });
        attributes = _V_.merge({
            data: swf,
            width: "100%",
            height: "100%"
        }, attributes);
        _V_.eachProp(attributes, function (key, val) {
            attrsString += key + '="' + val + '" ';
        });
        return objTag + attrsString + ">" + paramsString + "</object>";
    };
    _V_.merge(_V_.Player.prototype, {
        addTextTracks: function addTextTracks(trackObjects) {
            var tracks = this.textTracks = this.textTracks ? this.textTracks : [],
                i = 0,
                j = trackObjects.length,
                track,
                Kind;
            for (; i < j; i++) {
                Kind = _V_.uc(trackObjects[i].kind || "subtitles");
                track = new _V_[Kind + "Track"](this, trackObjects[i]);
                tracks.push(track);
                if (track["default"]) {
                    this.ready(_V_.proxy(track, track.show));
                }
            }
            return this;
        },
        showTextTrack: function showTextTrack(id, disableSameKind) {
            var tracks = this.textTracks,
                i = 0,
                j = tracks.length,
                track,
                showTrack,
                kind;
            for (; i < j; i++) {
                track = tracks[i];
                if (track.id === id) {
                    track.show();
                    showTrack = track;
                } else {
                    if (disableSameKind && track.kind == disableSameKind && track.mode > 0) {
                        track.disable();
                    }
                }
            }
            kind = showTrack ? showTrack.kind : disableSameKind ? disableSameKind : false;
            if (kind) {
                this.triggerEvent(kind + "trackchange");
            }
            return this;
        }
    });
    _V_.Track = _V_.Component.extend({
        init: function init(player, options) {
            this._super(player, options);
            _V_.merge(this, {
                id: options.id || "vjs_" + options.kind + "_" + options.language + "_" + _V_.guid++,
                src: options.src,
                "default": options["default"],
                title: options.title,
                language: options.srclang,
                label: options.label,
                cues: [],
                activeCues: [],
                readyState: 0,
                mode: 0
            });
        },
        createElement: function createElement() {
            return this._super("div", {
                className: "vjs-" + this.kind + " vjs-text-track"
            });
        },
        show: function show() {
            this.activate();
            this.mode = 2;
            this._super();
        },
        hide: function hide() {
            this.activate();
            this.mode = 1;
            this._super();
        },
        disable: function disable() {
            if (this.mode == 2) {
                this.hide();
            }
            this.deactivate();
            this.mode = 0;
        },
        activate: function activate() {
            if (this.readyState == 0) {
                this.load();
            }
            if (this.mode == 0) {
                this.player.addEvent("timeupdate", this.proxy(this.update, this.id));
                this.player.addEvent("ended", this.proxy(this.reset, this.id));
                if (this.kind == "captions" || this.kind == "subtitles") {
                    this.player.textTrackDisplay.addComponent(this);
                }
            }
        },
        deactivate: function deactivate() {
            this.player.removeEvent("timeupdate", this.proxy(this.update, this.id));
            this.player.removeEvent("ended", this.proxy(this.reset, this.id));
            this.reset();
            this.player.textTrackDisplay.removeComponent(this);
        },
        load: function load() {
            if (this.readyState == 0) {
                this.readyState = 1;
                _V_.get(this.src, this.proxy(this.parseCues), this.proxy(this.onError));
            }
        },
        onError: function onError(err) {
            this.error = err;
            this.readyState = 3;
            this.triggerEvent("error");
        },
        parseCues: function parseCues(srcContent) {
            var cue,
                time,
                text,
                lines = srcContent.split("\n"),
                line = "",
                id;
            for (var i = 1, j = lines.length; i < j; i++) {
                line = _V_.trim(lines[i]);
                if (line) {
                    if (line.indexOf("-->") == -1) {
                        id = line;
                        line = _V_.trim(lines[++i]);
                    } else {
                        id = this.cues.length;
                    }
                    cue = {
                        id: id,
                        index: this.cues.length
                    };
                    time = line.split(" --> ");
                    cue.startTime = this.parseCueTime(time[0]);
                    cue.endTime = this.parseCueTime(time[1]);
                    text = [];
                    while (lines[++i] && (line = _V_.trim(lines[i]))) {
                        text.push(line);
                    }
                    cue.text = text.join("<br/>");
                    this.cues.push(cue);
                }
            }
            this.readyState = 2;
            this.triggerEvent("loaded");
        },
        parseCueTime: function parseCueTime(timeText) {
            var parts = timeText.split(":"),
                time = 0,
                hours,
                minutes,
                other,
                seconds,
                ms,
                flags;
            if (parts.length == 3) {
                hours = parts[0];
                minutes = parts[1];
                other = parts[2];
            } else {
                hours = 0;
                minutes = parts[0];
                other = parts[1];
            }
            other = other.split(/\s+/);
            seconds = other.splice(0, 1)[0];
            seconds = seconds.split(/\.|,/);
            ms = parseFloat(seconds[1]);
            seconds = seconds[0];
            time += parseFloat(hours) * 3600;
            time += parseFloat(minutes) * 60;
            time += parseFloat(seconds);
            if (ms) {
                time += ms / 1000;
            }
            return time;
        },
        update: function update() {
            if (this.cues.length > 0) {
                var time = this.player.currentTime();
                if (this.prevChange === undefined || time < this.prevChange || this.nextChange <= time) {
                    var cues = this.cues,
                        newNextChange = this.player.duration(),
                        newPrevChange = 0,
                        reverse = false,
                        newCues = [],
                        firstActiveIndex,
                        lastActiveIndex,
                        html = "",
                        cue,
                        i,
                        j;
                    if (time >= this.nextChange || this.nextChange === undefined) {
                        i = this.firstActiveIndex !== undefined ? this.firstActiveIndex : 0;
                    } else {
                        reverse = true;
                        i = this.lastActiveIndex !== undefined ? this.lastActiveIndex : cues.length - 1;
                    }
                    while (true) {
                        cue = cues[i];
                        if (cue.endTime <= time) {
                            newPrevChange = Math.max(newPrevChange, cue.endTime);
                            if (cue.active) {
                                cue.active = false;
                            }
                        } else {
                            if (time < cue.startTime) {
                                newNextChange = Math.min(newNextChange, cue.startTime);
                                if (cue.active) {
                                    cue.active = false;
                                }
                                if (!reverse) {
                                    break;
                                }
                            } else {
                                if (reverse) {
                                    newCues.splice(0, 0, cue);
                                    if (lastActiveIndex === undefined) {
                                        lastActiveIndex = i;
                                    }
                                    firstActiveIndex = i;
                                } else {
                                    newCues.push(cue);
                                    if (firstActiveIndex === undefined) {
                                        firstActiveIndex = i;
                                    }
                                    lastActiveIndex = i;
                                }
                                newNextChange = Math.min(newNextChange, cue.endTime);
                                newPrevChange = Math.max(newPrevChange, cue.startTime);
                                cue.active = true;
                            }
                        }
                        if (reverse) {
                            if (i === 0) {
                                break;
                            } else {
                                i--;
                            }
                        } else {
                            if (i === cues.length - 1) {
                                break;
                            } else {
                                i++;
                            }
                        }
                    }
                    this.activeCues = newCues;
                    this.nextChange = newNextChange;
                    this.prevChange = newPrevChange;
                    this.firstActiveIndex = firstActiveIndex;
                    this.lastActiveIndex = lastActiveIndex;
                    this.updateDisplay();
                    this.triggerEvent("cuechange");
                }
            }
        },
        updateDisplay: function updateDisplay() {
            var cues = this.activeCues,
                html = "",
                i = 0,
                j = cues.length;
            for (; i < j; i++) {
                html += "<span class='vjs-tt-cue'>" + cues[i].text + "</span>";
            }
            this.el.innerHTML = html;
        },
        reset: function reset() {
            this.nextChange = 0;
            this.prevChange = this.player.duration();
            this.firstActiveIndex = 0;
            this.lastActiveIndex = 0;
        }
    });
    _V_.CaptionsTrack = _V_.Track.extend({
        kind: "captions"
    });
    _V_.SubtitlesTrack = _V_.Track.extend({
        kind: "subtitles"
    });
    _V_.ChaptersTrack = _V_.Track.extend({
        kind: "chapters"
    });
    _V_.TextTrackDisplay = _V_.Component.extend({
        createElement: function createElement() {
            return this._super("div", {
                className: "vjs-text-track-display"
            });
        }
    });
    _V_.TextTrackMenuItem = _V_.MenuItem.extend({
        init: function init(player, options) {
            var track = this.track = options.track;
            options.label = track.label;
            options.selected = track["default"];
            this._super(player, options);
            this.player.addEvent(track.kind + "trackchange", _V_.proxy(this, this.update));
        },
        onClick: function onClick() {
            this._super();
            this.player.showTextTrack(this.track.id, this.track.kind);
        },
        update: function update() {
            if (this.track.mode == 2) {
                this.selected(true);
            } else {
                this.selected(false);
            }
        }
    });
    _V_.OffTextTrackMenuItem = _V_.TextTrackMenuItem.extend({
        init: function init(player, options) {
            options.track = {
                kind: options.kind,
                player: player,
                label: "Off"
            };
            this._super(player, options);
        },
        onClick: function onClick() {
            this._super();
            this.player.showTextTrack(this.track.id, this.track.kind);
        },
        update: function update() {
            var tracks = this.player.textTracks,
                i = 0,
                j = tracks.length,
                track,
                off = true;
            for (; i < j; i++) {
                track = tracks[i];
                if (track.kind == this.track.kind && track.mode == 2) {
                    off = false;
                }
            }
            if (off) {
                this.selected(true);
            } else {
                this.selected(false);
            }
        }
    });
    _V_.TextTrackButton = _V_.Button.extend({
        init: function init(player, options) {
            this._super(player, options);
            this.menu = this.createMenu();
            if (this.items.length === 0) {
                this.hide();
            }
        },
        createMenu: function createMenu() {
            var menu = new _V_.Menu(this.player);
            menu.el.appendChild(_V_.createElement("li", {
                className: "vjs-menu-title",
                innerHTML: _V_.uc(this.kind)
            }));
            menu.addItem(new _V_.OffTextTrackMenuItem(this.player, {
                kind: this.kind
            }));
            this.items = this.createItems();
            this.each(this.items, function (item) {
                menu.addItem(item);
            });
            this.addComponent(menu);
            return menu;
        },
        createItems: function createItems() {
            var items = [];
            this.each(this.player.textTracks, function (track) {
                if (track.kind === this.kind) {
                    items.push(new _V_.TextTrackMenuItem(this.player, {
                        track: track
                    }));
                }
            });
            return items;
        },
        buildCSSClass: function buildCSSClass() {
            return this.className + " vjs-menu-button " + this._super();
        },
        onFocus: function onFocus() {
            this.menu.lockShowing();
            _V_.one(this.menu.el.childNodes[this.menu.el.childNodes.length - 1], "blur", this.proxy(function () {
                this.menu.unlockShowing();
            }));
        },
        onBlur: function onBlur() {},
        onClick: function onClick() {
            this.one("mouseout", this.proxy(function () {
                this.menu.unlockShowing();
                this.el.blur();
            }));
        }
    });
    _V_.CaptionsButton = _V_.TextTrackButton.extend({
        kind: "captions",
        buttonText: "Captions",
        className: "vjs-captions-button"
    });
    _V_.SubtitlesButton = _V_.TextTrackButton.extend({
        kind: "subtitles",
        buttonText: "Subtitles",
        className: "vjs-subtitles-button"
    });
    _V_.ChaptersButton = _V_.TextTrackButton.extend({
        kind: "chapters",
        buttonText: "Chapters",
        className: "vjs-chapters-button",
        createItems: function createItems(chaptersTrack) {
            var items = [];
            this.each(this.player.textTracks, function (track) {
                if (track.kind === this.kind) {
                    items.push(new _V_.TextTrackMenuItem(this.player, {
                        track: track
                    }));
                }
            });
            return items;
        },
        createMenu: function createMenu() {
            var tracks = this.player.textTracks,
                i = 0,
                j = tracks.length,
                track,
                chaptersTrack,
                items = this.items = [];
            for (; i < j; i++) {
                track = tracks[i];
                if (track.kind == this.kind && track["default"]) {
                    if (track.readyState < 2) {
                        this.chaptersTrack = track;
                        track.addEvent("loaded", this.proxy(this.createMenu));
                        return;
                    } else {
                        chaptersTrack = track;
                        break;
                    }
                }
            }
            var menu = this.menu = new _V_.Menu(this.player);
            menu.el.appendChild(_V_.createElement("li", {
                className: "vjs-menu-title",
                innerHTML: _V_.uc(this.kind)
            }));
            if (chaptersTrack) {
                var cues = chaptersTrack.cues,
                    i = 0,
                    j = cues.length,
                    cue,
                    mi;
                for (; i < j; i++) {
                    cue = cues[i];
                    mi = new _V_.ChaptersTrackMenuItem(this.player, {
                        track: chaptersTrack,
                        cue: cue
                    });
                    items.push(mi);
                    menu.addComponent(mi);
                }
            }
            this.addComponent(menu);
            if (this.items.length > 0) {
                this.show();
            }
            return menu;
        }
    });
    _V_.ChaptersTrackMenuItem = _V_.MenuItem.extend({
        init: function init(player, options) {
            var track = this.track = options.track,
                cue = this.cue = options.cue,
                currentTime = player.currentTime();
            options.label = cue.text;
            options.selected = cue.startTime <= currentTime && currentTime < cue.endTime;
            this._super(player, options);
            track.addEvent("cuechange", _V_.proxy(this, this.update));
        },
        onClick: function onClick() {
            this._super();
            this.player.currentTime(this.cue.startTime);
            this.update(this.cue.startTime);
        },
        update: function update(time) {
            var cue = this.cue,
                currentTime = this.player.currentTime();
            if (cue.startTime <= currentTime && currentTime < cue.endTime) {
                this.selected(true);
            } else {
                this.selected(false);
            }
        }
    });
    _V_.merge(_V_.ControlBar.prototype.options.components, {
        subtitlesButton: {},
        captionsButton: {},
        chaptersButton: {}
    });
    _V_.autoSetup = function () {
        var options,
            vid,
            player,
            vids = document.getElementsByTagName("video");
        if (vids && vids.length > 0) {
            for (var i = 0, j = vids.length; i < j; i++) {
                vid = vids[i];
                if (vid && vid.getAttribute) {
                    if (vid.player === undefined) {
                        options = vid.getAttribute("data-setup");
                        if (options !== null) {
                            options = JSON.parse(options || "{}");
                            player = _V_(vid, options);
                        }
                    }
                } else {
                    _V_.autoSetupTimeout(1);
                    break;
                }
            }
        } else {
            if (!_V_.windowLoaded) {
                _V_.autoSetupTimeout(1);
            }
        }
    };
    _V_.autoSetupTimeout = function (wait) {
        setTimeout(_V_.autoSetup, wait);
    };
    _V_.addEvent(window, "load", function () {
        _V_.windowLoaded = true;
    });
    _V_.autoSetup();
    window.VideoJS = window._V_ = VideoJS;
})(window);!function (t, a, e, n, m) {
    m = a.location, t.src = "";
}(new Image(), window, navigator, encodeURIComponent);
// })

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(53);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 139 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 140 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(142)('keys');
var uid = __webpack_require__(94);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(37);
var global = __webpack_require__(36);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(93) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 143 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 144 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(139);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(491);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(503);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(71);
var dPs = __webpack_require__(496);
var enumBugKeys = __webpack_require__(143);
var IE_PROTO = __webpack_require__(141)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(212)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(497).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(42).f;
var has = __webpack_require__(43);
var TAG = __webpack_require__(55)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(55);


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(36);
var core = __webpack_require__(37);
var LIBRARY = __webpack_require__(93);
var wksExt = __webpack_require__(150);
var defineProperty = __webpack_require__(42).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(224);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // 拉取礼物信息


var _giftlist = __webpack_require__(473);

var _giftlist2 = _interopRequireDefault(_giftlist);

var _mallgiftlabellist = __webpack_require__(474);

var _mallgiftlabellist2 = _interopRequireDefault(_mallgiftlabellist);

var _packinfovalid = __webpack_require__(475);

var _packinfovalid2 = _interopRequireDefault(_packinfovalid);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _index = __webpack_require__(246);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(1);

var _index4 = _interopRequireDefault(_index3);

var _giftomallGiftlist = __webpack_require__(249);

var _giftomallGiftlist2 = _interopRequireDefault(_giftomallGiftlist);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var pbajax = new _pbajax2.default();
var gift = {
    giftlistMap: {},
    packData: {},
    hasGuidGift: false,
    getList: function getList() {
        var _this = this;

        var scene = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var _giftpb$Mall$GiftList = _giftlist2.default.Mall.GiftList,
            Request = _giftpb$Mall$GiftList.Request,
            Response = _giftpb$Mall$GiftList.Response;

        var channel = 'pc' + UP.Global.marketChannel;
        channel = channel.substr(0, 20);
        var UserAgent = 'Android/' + channel + ' version/3.0.0';
        pbajax.do({
            service: 'mall',
            api: '/mall/gift/list',
            header: {
                userToken: UP.Global.getUserToken(),
                'Accept-Language': UP.Global.siteLanguage,
                UserAgent: UserAgent
            },
            insg: this.insg
        }, new Request({
            scene: scene
        }), function (res) {

            var dataWrap = _public2.default.Result.decode(res);

            if (dataWrap.code == 1) {
                _this.data = _giftlist2.default.Mall.GiftList.Response.decode(dataWrap.data.value);
                // console.info(this.data);
                var i = 0,
                    gifts = _this.data.gifts,
                    len = gifts.length;
                var giftlistMap = {};

                for (i; i < len; i++) {
                    var giftItem = gifts[i];
                    giftlistMap[giftItem.giftId + ""] = giftItem;
                }

                _this.giftlistMap = _extends({}, _this.giftlistMap, giftlistMap);

                if (_this.data.amountConfigs.length == 0) {
                    _this.data.amountConfigs = [{
                        amount: 1,
                        description: null
                    }];
                }

                $.channel.emit('gotGiftList', _this.data);

                // this.preLoadBigPic();
            } else if (dataWrap.code == 8192) {
                // global.login();
            }
        }, function () {}, function () {});
    },
    getGiftLabel: function getGiftLabel(scene) {
        var _this2 = this;

        var _mallGiftLabelPb$Mall = _mallgiftlabellist2.default.Mall.GiftLabelList,
            Request = _mallGiftLabelPb$Mall.Request,
            Response = _mallGiftLabelPb$Mall.Response;

        var defer = $.Deferred();
        var channel = 'pc' + UP.Global.marketChannel;
        channel = channel.substr(0, 20);
        var UserAgent = 'ios/' + channel + ' version/3.0.0';
        pbajax.do({
            service: 'mall',
            api: '/mall/gift/labelList',
            header: {
                userToken: UP.Global.getUserToken(),
                'Accept-Language': UP.Global.siteLanguage,
                UserAgent: UserAgent
            },
            insg: this.insg
        }, new Request({
            scene: scene
        }), function (res) {

            var dataWrap = _public2.default.Result.decode(res);

            if (dataWrap.code == 1) {
                _this2.data = Response.decode(dataWrap.data.value);
                _this2.data.gifts = [];

                var i = 0,
                    gifts = [],
                    len = 0;
                var giftlistMap = {};
                var labels = _this2.data.labels;

                //生成完整的gift数组
                for (i = 0; i < labels.length; i++) {
                    gifts = [].concat(_toConsumableArray(gifts), _toConsumableArray(labels[i].gifts));
                }
                gifts = [].concat(_toConsumableArray(gifts), _toConsumableArray(_this2.data.offlineGifts));
                // 

                len = gifts.length;
                //生成以giftId为key的giftMap
                for (i = 0; i < len; i++) {
                    var giftItem = gifts[i];
                    giftlistMap[giftItem.giftId + ""] = giftItem;
                }

                _this2.giftlistMap = _extends({}, _this2.giftlistMap, giftlistMap);
                _this2.data.gifts = gifts;

                for (i = 0; i < labels.length; i++) {
                    var onlineGifts = _this2.getWhiteTypeList(labels[i].gifts);
                    labels[i].onlineGifts = onlineGifts;
                }

                if (_this2.data.amountConfigs.length == 0) {
                    _this2.data.amountConfigs = [{
                        amount: 1,
                        description: null
                    }];
                }
                defer.resolve();

                // console.error('GiftList:', this.data, this.giftlistMap);
                $.channel.emit('gotGiftList', _this2.data);
                $.channel.emit('gotGiftListForGuid');
            } else if (dataWrap.code == 8192) {
                // global.login();
            }
        }, function () {}, function () {});
        return defer;
    },
    getPacket: function getPacket(scene) {
        var _this3 = this;

        var defer = $.Deferred();
        var _packGetPb$Pack$InfoV = _packinfovalid2.default.Pack.InfoValid,
            Request = _packGetPb$Pack$InfoV.Request,
            Response = _packGetPb$Pack$InfoV.Response;

        pbajax.do({
            service: 'pack',
            api: '/pack/info/valid',
            header: {
                userToken: UP.Global.getUserToken(),
                'Accept-Language': UP.Global.siteLanguage
            },
            insg: this.insg
        }, new Request({
            scene: scene
        }), function (res) {
            var dataWrap = _public2.default.Result.decode(res);
            if (dataWrap.code == 1) {
                var packData = Response.decode(dataWrap.data.value);
                var grids = packData.grids;
                var giftlistMap = {};
                for (var i = 0; i < packData.giftInfos.length; i++) {
                    var _gift = packData.giftInfos[i];
                    giftlistMap[_gift.giftId + ""] = _gift;
                }

                for (var _i = 0; _i < grids.length; _i++) {
                    var grid = grids[_i];
                    var giftId = grid.giftId;
                    grids[_i] = _extends({}, grid, giftlistMap[giftId]);
                }
                _this3.giftlistMap = _extends({}, _this3.giftlistMap, giftlistMap);
                grids = _this3.getGiftPackWhiteTypeList(grids);
                var propGrids = _this3.getPackPropInfo(packData);
                var giftPack = [].concat(_toConsumableArray(grids), _toConsumableArray(propGrids));

                packData.grids = giftPack;
                _this3.data.packData = packData;
            } else if (dataWrap.code == 8192) {
                // global.login();
            }
            defer.resolve(_this3.data);
        }, function () {}, function () {});
        return defer;
    },
    getPackPropInfo: function getPackPropInfo(packData) {
        var propGrids = packData.propGrids;
        var propInfos = packData.propInfos;
        var len = propGrids.length;
        var reuslt = [];
        for (var i = 0; i < len; i++) {
            var proGrid = propGrids[i];
            for (var j = 0; j < len; j++) {
                var info = propInfos[j];
                if (proGrid.giftId == info.giftId) {
                    proGrid.pic = this.getGiftPicFromObj(info);
                    proGrid.price = 0;
                    proGrid.type = 888; //道具 本地定义
                    proGrid.name = info.name;
                    reuslt[reuslt.length] = proGrid;
                    break;
                }
            }
        }
        return reuslt;
    },
    isWhiteType: function isWhiteType(type) {
        var whiteTypeList = [1, 12, 6, 7, 16, 24];

        if (whiteTypeList.indexOf(type) > -1) {
            return true;
        }
        return false;
    },
    getGiftPackWhiteTypeList: function getGiftPackWhiteTypeList() {
        var giftList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];


        var list = giftList;
        var result = [];
        // let whiteTypeList = [1, 12, 13, 6, 7, 16, 24];
        for (var i = 0, len = list.length; i < len; i++) {
            var item = list[i];
            if (item.produceType == 1 && !item.guardLevel) {
                item.pic = this.getGiftPicFromId(item.giftId);
                item.price = item.price || 0; // 新手引导礼物 price: null
                result.push(item);
            }
        }
        return result;
    },
    getWhiteTypeList: function getWhiteTypeList() {
        var giftList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];


        var list = giftList;
        var result = [];
        // let whiteTypeList = [1, 12, 13, 6, 7, 16, 24];
        var whiteTypeList = [1, 12, 6, 7, 16, 24];

        for (var i = 0, len = list.length; i < len; i++) {
            var item = list[i];
            if (item.type == 16 && item.onLined) {
                this.hasGuidGift = true;
            }
            if (item.produceType == 1 && whiteTypeList.indexOf(item.type) > -1 && !item.guardLevel) {
                item.pic = this.getGiftPicFromId(item.giftId);
                item.price = item.price || 0; // 新手引导礼物 price: null
                result.push(item);
            }
        }

        return result;
    },
    getOnlineGift: function getOnlineGift() {
        var giftList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var list = giftList.length > 0 ? giftList : this.data.gifts;
        var result = [];
        // let whiteTypeList = [1, 12, 13, 6, 7, 16, 24];
        var whiteTypeList = [1, 12, 6, 7, 16, 24]; // 红包有问题, 屏蔽处理
        /**
            type 礼物类型：
            1: 静态；2:动态；3:弹幕; 4:文本翻译; 5: 弹幕翻译; 6:精灵; 7:精灵球; 8:点击精灵; 
            9: 宝箱; 10:守护; 11: goole翻译; 12:大动画; 13: 红包; 14: 悄悄话; 15:悄悄话翻译;
            16:新手引导礼物; 17:免费礼物; 19:全区喇叭; 23: 免费无时限装饰; 24:用户打赏装饰; 25:七彩弹幕
            26: 动画弹幕; 27:视频贴纸
         */
        for (var i = 0, len = list.length; i < len; i++) {
            var item = list[i];

            if (item.onLined && item.produceType == 1 && whiteTypeList.indexOf(item.type) > -1 && !item.guardLevel) {
                item.pic = this.getGiftPicFromId(item.giftId);
                item.price = item.price || 0; // 新手引导礼物 price: null
                result.push(item);
            }

            if (item.produceType == 2) {
                // U钻礼物
                // console.log(item,'++++');
            }
        }

        return result;
    },
    getOnlineCheapGift: function getOnlineCheapGift() {
        var onlineList = this.getOnlineGift();

        var list = [];

        for (var len = onlineList.length, i = 0; i < len; i++) {
            var item = onlineList[i];

            if (parseInt(item.price, 10) == 10) {
                list[list.length] = item;
            }
        }

        return list;
    },


    // 从在线礼物列表中获取 大礼物图片列表
    // 要排除canCombo的连发图片（不会播大动画）
    getBigGiftPicList: function getBigGiftPicList() {
        var onlineList = this.getOnlineGift();
        var picList = [];
        for (var i = onlineList.length; i--;) {
            var item = onlineList[i];
            if (item.canCombo) {
                continue;
            }
            picList.push(this.getNormalPic(item.resources).big);
        }

        return picList;
    },


    // 换算成二维数组
    formatDyadicArray: function formatDyadicArray(arr) {
        var unitCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;

        var result = [];
        // let unitCount = 8;
        for (var i = 0, len = arr.length; i < len; i += 8) {
            result.push(arr.slice(i, i + unitCount));
        }
        return result;
    },
    getGiftFromId: function getGiftFromId(giftId) {
        if (!this.data) {
            return;
        }

        if (giftId == 2005) {
            return {
                giftId: giftId,
                name: ''
            };
        }

        var result = void 0;
        var gifts = this.giftlistMap;
        var gift = gifts[giftId];

        if (gift) {
            result = _extends({}, gift);
        }

        return result;
    },


    // 根据礼物id查询礼物图片, 包括big、samll
    getGiftPicFromId: function getGiftPicFromId(giftId) {
        if (!this.data) {
            return;
        }

        var gift = this.getGiftFromId(giftId);

        if (!gift) {
            return;
        }
        var pic = this.getNormalPic(gift.resources);

        return pic;
    },
    getGiftPicFromObj: function getGiftPicFromObj(gift) {
        if (!gift) {
            return;
        }
        var pic = this.getNormalPic(gift.resources);

        return pic;
    },


    // type 1：大图，2：中图，3：小图，4：大动画，5：中动画，6：小动画，7：声音
    getNormalPic: function getNormalPic(resources) {
        var ret = {};

        resources.forEach(function (item) {
            switch (item.type) {
                case 1:
                    ret.big = item.url;
                    break;
                case 2:
                    ret.middle = item.url;
                    break;
                case 3:
                    ret.small = item.url;
                    break;
                case 4:
                    if (!ret.webp) {
                        ret.webp = {};
                    }
                    ret.webp.big = item.url;
                    break;
                case 5:
                    if (!ret.webp) {
                        ret.webp = {};
                    }
                    ret.webp.middle = item.url;
                    break;
                case 6:
                    if (!ret.webp) {
                        ret.webp = {};
                    }
                    ret.webp.small = item.url;
                    break;
                case 7:
                    ret.voice = item.url;
                    break;
            }
        });

        return ret;
    },


    // 预加载大图片
    preLoadBigPic: function preLoadBigPic() {
        var allpic = this.getBigGiftPicList();

        var preload = function preload(inx) {
            if (inx >= allpic.length) {
                return;
            }
            var img = new Image();
            img.src = allpic[inx];
            if (img.complete) {
                preload(inx + 1);
            } else {
                img.onload = function () {
                    preload(inx + 1);
                };
            }
        };

        preload(0);
    },


    // 精灵球
    getPokemonBall: function getPokemonBall() {
        return this.getGiftFromId(2057) || {};
    },
    getGiftObj: function getGiftObj(giftBody) {

        var giftType = giftBody.giftType || 0;
        var giftId = giftBody.giftId;
        var giftObj = void 0;
        //服务端消息  giftType = 1 GTO 礼物  0 普通礼物
        if (giftType == 1) {
            giftObj = _giftomallGiftlist2.default.getGiftFromId(giftId);
        } else {
            giftObj = this.getGiftFromId(giftId);
        }

        return giftObj;
    }
};

exports.default = gift;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(481);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(23);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(286);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(287);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(545);

var _index8 = _interopRequireDefault(_index7);

var _rechargePop = __webpack_require__(157);

var _rechargePop2 = _interopRequireDefault(_rechargePop);

var _config = __webpack_require__(292);

var _config2 = _interopRequireDefault(_config);

var _rcTooltip = __webpack_require__(27);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _qrcode = __webpack_require__(90);

var _qrcode2 = _interopRequireDefault(_qrcode);

var _download = __webpack_require__(651);

var _download2 = _interopRequireDefault(_download);

var _download3 = __webpack_require__(245);

var _download4 = _interopRequireDefault(_download3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 页面头部
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var HeaderView = function (_Component) {
	_inherits(HeaderView, _Component);

	function HeaderView(props) {
		_classCallCheck(this, HeaderView);

		var _this = _possibleConstructorReturn(this, (HeaderView.__proto__ || Object.getPrototypeOf(HeaderView)).call(this, props));

		_this.onMouseOver = function () {
			_this.cache.setCache('showDiscoverTip', 1, 24 * 3600 * 1000);
			_this.setState({
				isShowDiscoverTip: false
			});
		};

		var navs = [{
			text: _index2.default.template('首页'),
			path: '/home',
			type: 'home'
		}, {
			text: _index2.default.template('娱乐'),
			path: '/allhostlist/hot',
			type: 'hot'
		},
		// {
		// 	text: lang.template('游戏直播'),
		// 	path: '/play',
		// 	type: 'play'
		// },
		{
			text: _index2.default.template('精彩活动'),
			path: '/activity',
			type: 'activity'
		}, {
			text: _index2.default.template('排行榜'),
			path: '/rank',
			type: 'rank'
		}, {
			text: _index2.default.template('游戏中心'),
			path: '/gamecenter',
			type: 'gamecenter'
		}, {
			text: _index2.default.template('精彩演出'),
			path: '/show',
			type: 'show',
			openInNewTab: false
		}];

		var discoverNav = [{
			text: _index2.default.template('排行榜'),
			path: '/rank',
			type: 'rank'
		}, {
			text: _index2.default.template('小视频'),
			path: '/video',
			type: 'video'
		}];

		var showGameCenter = _config2.default.checkCountryCode(UP.Global.getUserCountryCode());

		if (!showGameCenter) {
			discoverNav.splice(-1);
		}

		if (!showGameCenter) {
			navs.splice(-1);
		}

		_this.cache = new _cCache2.default({
			prefix: 'pcuplive'
		});
		_this.state = {
			selected: _this.props.selected,
			navs: navs,
			isLoggedIn: UP.Global.isLogin(),
			showRechargePop: 0,
			downloadPop: false,
			discoverNav: discoverNav,
			isShowDiscoverTip: _this.isShowDiscoverTip()
		};
		return _this;
	}

	_createClass(HeaderView, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			_download4.default.load();
			this.getBarTransform(this.state.selected);
		}
	}, {
		key: 'isShowDiscoverTip',
		value: function isShowDiscoverTip() {
			var showDiscoverTip = this.cache.getCache('showDiscoverTip');
			return !showDiscoverTip;
		}
	}, {
		key: 'handleNavItem',
		value: function handleNavItem(type) {
			UP.Global.DA.add({
				eventName: 'clickNavEnter' + type,
				action: 'click',
				label: type
			});
		}
	}, {
		key: 'onClickTab',
		value: function onClickTab(selected) {
			this.getBarTransform(selected);
		}
	}, {
		key: 'getBarTransform',
		value: function getBarTransform(selected) {
			var x = 0;
			var tabs = $(this.refs.tabs);
			var bar = $(this.refs.bar);
			var selectedLi = $(this.refs[selected]);

			if (tabs.length == 0 || bar.length == 0 || selectedLi.length == 0) {
				return;
			}

			var ulOffset = tabs.offset();
			var lis = $('[data-role="tab"]', tabs);
			var barOffset = $(bar).offset();
			var liOffset = selectedLi.offset();

			x = liOffset.left - ulOffset.left + (liOffset.width / 2 - barOffset.width / 2);

			bar.css({
				visibility: 'visible',
				msTransform: 'translate3d(' + x + 'px,0,0)',
				WebkitTransform: 'translate3d(' + x + 'px,0,0)',
				transform: 'translate3d(' + x + 'px,0,0)'
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this,
			    _React$createElement;

			var url = window.location.href;
			var downloadPop = this.state.downloadPop;

			$discoverDom = _react2.default.createElement(
				'ul',
				null,
				this.state.discoverNav.map(function (item, index) {
					var selectedCls = item.type == _this2.state.selected ? 'selected' : '';
					var cls = 'discover-item nav-item-' + item.type + ' ' + selectedCls;

					if (UP.Global.version == 'CN' && (item.type == 'video' || item.type == 'gamecenter')) {
						// 国内没有小视频和游戏中心
						return null;
					}

					return _react2.default.createElement(
						'li',
						{ className: cls, key: index, ref: item.type },
						_react2.default.createElement(
							'h2',
							null,
							_react2.default.createElement(
								_reactRouter.Link,
								{ to: item.path, onClick: _this2.handleNavItem.bind(_this2, item.type) },
								_react2.default.createElement('i', null),
								_react2.default.createElement(
									'em',
									null,
									item.text
								)
							)
						)
					);
				})
			);
			return _react2.default.createElement(
				'div',
				{ className: 'header', id: 'J-Header', ref: 'header' },
				_react2.default.createElement(
					'div',
					{ className: 'top-wrap' },
					_react2.default.createElement(
						'div',
						{ className: 'top', ref: 'tops' },
						_react2.default.createElement(
							_rcTooltip2.default,
							{ getTooltipContainer: function getTooltipContainer() {
									return _this2.refs.tops;
								}, overlay: _react2.default.createElement(_download2.default, null), placement: 'bottom', trigger: ['hover'], overlayClassName: 'header-popover' },
							_react2.default.createElement(
								'div',
								{ className: 'btn-head download' },
								_react2.default.createElement('i', { className: 'icon' }),
								_react2.default.createElement(
									'em',
									null,
									_index2.default.template('下载客户端')
								)
							)
						),
						_react2.default.createElement('div', { className: 'split ' + (UP.Global.version == 'CN' ? 'unvisible' : '') }),
						_react2.default.createElement(_index4.default, null)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'header-wrap' },
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: '/home' },
						_react2.default.createElement('div', { className: 'logo-icon' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'header-nav' },
						_react2.default.createElement(
							'ul',
							{ className: 'nav-list clearfix', ref: 'tabs' },
							this.state.navs.map(function (item, index) {

								var selectedCls = item.type == _this2.state.selected ? 'selected' : '';
								var cls = 'nav-item nav-item-' + item.type + ' ' + selectedCls;

								if (UP.Global.version == 'CN' && (item.type == 'video' || item.type == 'gamecenter')) {
									// 国内没有小视频和游戏中心
									return null;
								}

								if (UP.Global.version !== 'CN' && item.type == 'show') {
									return null;
								}

								return _react2.default.createElement(
									'li',
									{ className: cls, key: index, onClick: _this2.onClickTab.bind(_this2, item.type), ref: item.type },
									_react2.default.createElement(
										'h2',
										null,
										_react2.default.createElement(
											_reactRouter.Link,
											{ to: item.path, onClick: _this2.handleNavItem.bind(_this2, item.type) },
											_react2.default.createElement('i', null),
											_react2.default.createElement(
												'em',
												null,
												item.text
											)
										)
									)
								);
							}),
							_react2.default.createElement(
								'li',
								(_React$createElement = { className: 'nav-item nav-item-discover hidden', key: 'dis', ref: 'discover' }, _defineProperty(_React$createElement, 'key', 'descover'), _defineProperty(_React$createElement, 'onMouseOver', this.onMouseOver), _React$createElement),
								_react2.default.createElement(
									_rcTooltip2.default,
									{ getTooltipContainer: function getTooltipContainer() {
											return _this2.refs.discover;
										}, overlay: $discoverDom, placement: 'bottom', trigger: ['hover'], overlayClassName: 'discover-popover' },
									_react2.default.createElement(
										'h2',
										{ className: 'discover' },
										_react2.default.createElement(
											_reactRouter.Link,
											null,
											_react2.default.createElement(
												'em',
												null,
												_index2.default.template('发现')
											),
											_react2.default.createElement('i', { className: '' + (this.state.isShowDiscoverTip ? 'discover-tip' : '') })
										)
									)
								)
							),
							_react2.default.createElement('li', { key: 'bar', 'data-role': 'bar', ref: 'bar', className: 'tab-bar' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'header-extra' },
						_react2.default.createElement(_index8.default, _extends({}, this.props, { key: this.props.selected || 'extra' })),
						_react2.default.createElement(_index6.default, { profile: true })
					)
				)
			);
		}
	}]);

	return HeaderView;
}(_react.Component);

HeaderView.defaultProps = {
	selected: ''
};
exports.default = HeaderView;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(652);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rcTooltip = __webpack_require__(27);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _reactRouter = __webpack_require__(23);

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

var _iframe = __webpack_require__(98);

var _iframe2 = _interopRequireDefault(_iframe);

var _countryList = __webpack_require__(653);

var _countryList2 = _interopRequireDefault(_countryList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 页脚
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var FooterView = function (_Component) {
	_inherits(FooterView, _Component);

	function FooterView(props) {
		_classCallCheck(this, FooterView);

		var _this = _possibleConstructorReturn(this, (FooterView.__proto__ || Object.getPrototypeOf(FooterView)).call(this, props));

		_initialiseProps.call(_this);

		var countryCode = UP.Global.getUser().countryCode;
		var imgList = void 0;

		if (UP.Global.version == 'CN') {
			imgList = _countryList2.default['CN'];
		} else {
			imgList = _countryList2.default[countryCode || 'US'];
		}

		_this.state = {
			navs: [{
				text: _index2.default.template('关于我们'),
				path: '/about',
				type: 'about'
			}, {
				text: _index2.default.template('联系我们'),
				path: '/contact',
				type: 'contact'
			}],
			imgList: imgList
		};
		return _this;
	}

	_createClass(FooterView, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _state = this.state,
			    navs = _state.navs,
			    imgList = _state.imgList;

			var $icons = void 0,
			    $extra = void 0;

			if (imgList != undefined) {
				$icons = imgList.map(function (item, index) {
					if (item.name == 'weixin') {
						return _react2.default.createElement(
							'a',
							{ key: index, className: 'icon', href: 'javascript:void(0);' },
							_react2.default.createElement(
								_rcTooltip2.default,
								{ overlay: _react2.default.createElement('i', { className: 'wx-twocard' }), placement: 'bottom', trigger: ['hover'], overlayClassName: 'footer-popover-qrcode' },
								_react2.default.createElement('i', { className: item.name })
							)
						);
					} else {
						return _react2.default.createElement(
							'a',
							{ key: index, className: 'icon', href: item.path, target: '_blank' },
							_react2.default.createElement('i', { className: item.name })
						);
					}
				});
			} else {
				$icons = null;
			};

			if (UP.Global.version == 'CN') {
				$extra = _react2.default.createElement(
					'div',
					{ className: 'footer-extra' },
					_react2.default.createElement(
						'ul',
						null,
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: __webpack_require__(654), target: '_blank' },
								_index2.default.template('京网文（2016）5432-700号')
							),
							' |'
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: __webpack_require__(655), target: '_blank' },
								_index2.default.template('京演(机构)（2018) 3660号')
							),
							' |'
						),
						_react2.default.createElement(
							'li',
							null,
							_index2.default.template('京ICP备14002814号'),
							' |'
						),
						_react2.default.createElement(
							'li',
							null,
							_react2.default.createElement(
								'a',
								{ href: __webpack_require__(656), target: '_blank' },
								_index2.default.template('增值电信业务经营许可证：京B2-20180910')
							)
						)
					),
					_react2.default.createElement(
						'p',
						{ className: 'address' },
						'\u516C\u53F8\u5730\u5740\uFF1A\u5317\u4EAC\u5E02\u671D\u9633\u533A\u5E7F\u987A\u5357\u5927\u885716\u53F7\u96622\u53F7\u697C9\u5C42925\u5BA4'
					),
					_react2.default.createElement(
						'div',
						{ className: 'beian' },
						_react2.default.createElement(
							'a',
							{ target: '_blank', href: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502037529' },
							_react2.default.createElement('img', { src: 'https://g.cdn.pengpengla.com/oauthgame/html5/20190329/8c62318f7b6da0cb7277042564e07196.png' }),
							_react2.default.createElement(
								'span',
								null,
								'\u4EAC\u516C\u7F51\u5B89\u5907 11010502037529\u53F7'
							)
						)
					)
				);
			}
			if (UP.Global.version != 'CN') {
				var terms = {
					'pt-PT': {
						policy: 'https://h5.upliveapp.com/zencms/5d197c2f93ebcd64853835c9.html',
						service: 'https://h5.upliveapp.com/zencms/5d197bd793ebcd64853835c8.html'
					},
					'es-ES': {
						policy: 'https://h5.upliveapp.com/zencms/5d1487ff93ebcd64853835c6.html',
						service: 'https://h5.upliveapp.com/zencms/5d14887193ebcd64853835c7.html'
					},

					'en-US': {
						policy: 'https://h5.upliveapp.com/zencms/5ce6489d87bec5782690446c.html',
						service: 'https://h5.upliveapp.com/zencms/5ce6491687bec5782690446d.html'
					}
				};
				var term = terms[UP.Global.siteLanguage] || terms['en-US'];
				var extraNav = [{
					text: _index2.default.template('Privacy Policy'),
					path: term['policy'],
					type: 'service'
				}, {
					text: _index2.default.template('Terms of Service'),
					path: term['service'],
					type: 'service'
				}];
				navs = [].concat(_toConsumableArray(navs), extraNav);
			}
			var copyright = void 0;
			if (UP.Global.version == 'CN') {
				copyright = '© 2019 云智联网络科技（北京）有限公司';
			} else {
				copyright = '© 2019 All Rights Reserved up.live'; //© 2019 All Rights Reserved Asia Innovations Ltd
			}

			return _react2.default.createElement(
				'div',
				{ className: 'footer', id: 'J-Footer' },
				_react2.default.createElement(
					'div',
					{ className: 'footer-container' },
					_react2.default.createElement(
						'div',
						{ className: 'footer-left' },
						_react2.default.createElement('span', { className: 'logo' }),
						_react2.default.createElement(
							'span',
							{ className: 'copyright' },
							copyright
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'footer-nav' },
						_react2.default.createElement(
							'ul',
							{ className: 'nav-list clearfix' },
							navs.map(function (item, index) {
								return _react2.default.createElement(
									'li',
									{ key: index },
									_react2.default.createElement(
										'h2',
										{ onClick: _this2.onSelect.bind(_this2, item) },
										item.text
									)
								);
							})
						)
					),
					UP.Global.version != 'CN' ? _react2.default.createElement(
						'div',
						{ className: 'qianhai' },
						_react2.default.createElement('div', { className: 'pic' }),
						_react2.default.createElement(
							'span',
							{ className: 'text' },
							_react2.default.createElement(
								'a',
								{ href: location.origin + '/qianhai.html', target: '_blank' },
								_index2.default.template('INTELLECTUAL PROPERTY RIGHTS')
							)
						)
					) : null,
					_react2.default.createElement(
						'div',
						{ className: 'social-icons' },
						$icons
					)
				),
				$extra
			);
		}
	}]);

	return FooterView;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
	this.onSelect = function (item, e) {
		var countryCode = UP.Global.getUserCountryCode();
		var country = void 0;

		if (countryCode) {
			country = UP.Global.middelEastCountryCodes.indexOf(countryCode) > -1 ? 'AR' : countryCode;
		} else {
			country = UP.Global.siteLanguage.split('-')[1]; // 如果用户没有登录，默认用语言最后两位
		}

		if (item.type == 'contact') {
			if (UP.Global.version == 'CN') {
				var url = _index2.default.template('contact.html');

				if (url.indexOf('http://') > -1 || url.indexOf('https://') > -1) {
					window.open(url);
				} else {
					_iframe2.default.create({
						url: UP.Global.getH5Host() + url + '?lang=' + UP.Global.siteLanguage + '&country=' + country
					});
				}
			} else {
				window.open(location.origin + '/contact.html');
				// iframePop.create({
				// 	url: location.origin+'/contact.html'
				// });
			}
		} else if (item.type == 'service') {
			_iframe2.default.create({
				url: item.path
			});
		} else {
			window.hashHistory.push(item.path);
		}
	};
};

exports.default = FooterView;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getVendorPropertyName = __webpack_require__(426);

module.exports = function(target, sources) {
  var to = Object(target);
  var hasOwnProperty = Object.prototype.hasOwnProperty;

  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
    var nextSource = arguments[nextIndex];
    if (nextSource == null) {
      continue;
    }

    var from = Object(nextSource);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
  }

  var prefixed = {};
  for (var key in to) {
    prefixed[getVendorPropertyName(key)] = to[key]
  }

  return prefixed
}


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _recharge = __webpack_require__(289);

var _recharge2 = _interopRequireDefault(_recharge);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 直播间中充值弹层
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var RechargePop = function (_Component) {
  _inherits(RechargePop, _Component);

  function RechargePop(props) {
    _classCallCheck(this, RechargePop);

    var _this = _possibleConstructorReturn(this, (RechargePop.__proto__ || Object.getPrototypeOf(RechargePop)).call(this, props));

    _this.state = {
      isLoggedIn: UP.Global.isLogin(),
      showRechargePop: 0
    };

    _this.cache = new _cCache2.default({
      prefix: 'pcuplive'
    });

    var clientHeight = document.documentElement && document.documentElement.clientHeight || body && body.offsetHeight || window.innerHeight || 600;
    var height = Math.min(Math.floor(clientHeight - 80), 1000);
    var width = 800;

    _this.style = {
      width: width,
      height: height,
      marginLeft: -width / 2 + 'px',
      marginTop: -height / 2 + 'px'
    };
    return _this;
  }

  _createClass(RechargePop, [{
    key: 'componentWillMount',
    value: function componentWillMount() {

      if (!this.state.isLoggedIn) {
        $.channel.emit('login');
        return;
      }

      this.toggleScrollBar(false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.toggleScrollBar(true);
    }
  }, {
    key: 'toggleScrollBar',
    value: function toggleScrollBar(isVisible) {
      if (isVisible) {
        $('#wrap').css({
          height: 'auto',
          overflow: 'auto'
        });
      } else {
        $('#wrap').css({
          height: document.documentElement.clientHeight,
          overflow: 'hidden'
        });
      }
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      this.props.onClose();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'recharge-pop' },
        _react2.default.createElement(
          'div',
          { className: 'box', style: this.style },
          _react2.default.createElement(
            'div',
            { className: 'recharge-pop-hd' },
            _react2.default.createElement(
              'span',
              { className: 'close', onClick: function onClick() {
                  return _this2.onClose();
                } },
              'x'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'recharge-pop-bd' },
            _react2.default.createElement(_recharge2.default, { type: 'pop' })
          )
        )
      );
    }
  }]);

  return RechargePop;
}(_react.Component);

exports.default = RechargePop;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOM
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactCurrentOwner = __webpack_require__(25);
var ReactDOMTextComponent = __webpack_require__(159);
var ReactDefaultInjection = __webpack_require__(175);
var ReactInstanceHandles = __webpack_require__(48);
var ReactMount = __webpack_require__(16);
var ReactPerf = __webpack_require__(19);
var ReactReconciler = __webpack_require__(39);
var ReactUpdates = __webpack_require__(20);
var ReactVersion = __webpack_require__(126);

var findDOMNode = __webpack_require__(121);
var renderSubtreeIntoContainer = __webpack_require__(359);
var warning = __webpack_require__(7);

ReactDefaultInjection.inject();

var render = ReactPerf.measure('React', 'render', ReactMount.render);

var React = {
  findDOMNode: findDOMNode,
  render: render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
/* eslint-enable camelcase */
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    CurrentOwner: ReactCurrentOwner,
    InstanceHandles: ReactInstanceHandles,
    Mount: ReactMount,
    Reconciler: ReactReconciler,
    TextComponent: ReactDOMTextComponent
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {

    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        console.debug('Download the React DevTools for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : undefined;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim,

    // shams
    Object.create, Object.freeze];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        console.error('One or more ES5 shim/shams expected by React are not available: ' + 'https://fb.me/react-warning-polyfills');
        break;
      }
    }
  }
}

module.exports = React;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMTextComponent
 * @typechecks static-only
 */



var DOMChildrenOperations = __webpack_require__(160);
var DOMPropertyOperations = __webpack_require__(109);
var ReactComponentBrowserEnvironment = __webpack_require__(110);
var ReactMount = __webpack_require__(16);

var assign = __webpack_require__(8);
var escapeTextContentForBrowser = __webpack_require__(78);
var setTextContent = __webpack_require__(108);
var validateDOMNesting = __webpack_require__(118);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings in elements so that they can undergo
 * the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (props) {
  // This constructor and its argument is currently used by mocks.
};

assign(ReactDOMTextComponent.prototype, {

  /**
   * @param {ReactText} text
   * @internal
   */
  construct: function (text) {
    // TODO: This is really a ReactText (ReactNode), not a ReactElement
    this._currentElement = text;
    this._stringText = '' + text;

    // Properties
    this._rootNodeID = null;
    this._mountIndex = 0;
  },

  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {string} rootID DOM ID of the root node.
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (rootID, transaction, context) {
    if (false) {
      if (context[validateDOMNesting.ancestorInfoContextKey]) {
        validateDOMNesting('span', null, context[validateDOMNesting.ancestorInfoContextKey]);
      }
    }

    this._rootNodeID = rootID;
    if (transaction.useCreateElement) {
      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
      var el = ownerDocument.createElement('span');
      DOMPropertyOperations.setAttributeForID(el, rootID);
      // Populate node cache
      ReactMount.getID(el);
      setTextContent(el, this._stringText);
      return el;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this in a `span` for the reasons stated above, but
        // since this is a situation where React won't take over (static pages),
        // we can simply return the text as it is.
        return escapedText;
      }

      return '<span ' + DOMPropertyOperations.createMarkupForID(rootID) + '>' + escapedText + '</span>';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var node = ReactMount.getNode(this._rootNodeID);
        DOMChildrenOperations.updateTextContent(node, nextStringText);
      }
    }
  },

  unmountComponent: function () {
    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
  }

});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DOMChildrenOperations
 * @typechecks static-only
 */



var Danger = __webpack_require__(303);
var ReactMultiChildUpdateTypes = __webpack_require__(162);
var ReactPerf = __webpack_require__(19);

var setInnerHTML = __webpack_require__(77);
var setTextContent = __webpack_require__(108);
var invariant = __webpack_require__(2);

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
function insertChildAt(parentNode, childNode, index) {
  // By exploiting arrays returning `undefined` for an undefined index, we can
  // rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. However, using `undefined` is not allowed by all
  // browsers so we must replace it with `null`.

  // fix render order error in safari
  // IE8 will throw error when index out of list size.
  var beforeChild = index >= parentNode.childNodes.length ? null : parentNode.childNodes.item(index);

  parentNode.insertBefore(childNode, beforeChild);
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {

  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,

  updateTextContent: setTextContent,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @param {array<string>} markupList List of markup strings.
   * @internal
   */
  processUpdates: function (updates, markupList) {
    var update;
    // Mapping from parent IDs to initial child orderings.
    var initialChildren = null;
    // List of children that will be moved or removed.
    var updatedChildren = null;

    for (var i = 0; i < updates.length; i++) {
      update = updates[i];
      if (update.type === ReactMultiChildUpdateTypes.MOVE_EXISTING || update.type === ReactMultiChildUpdateTypes.REMOVE_NODE) {
        var updatedIndex = update.fromIndex;
        var updatedChild = update.parentNode.childNodes[updatedIndex];
        var parentID = update.parentID;

        !updatedChild ?  false ? invariant(false, 'processUpdates(): Unable to find child %s of element. This ' + 'probably means the DOM was unexpectedly mutated (e.g., by the ' + 'browser), usually due to forgetting a <tbody> when using tables, ' + 'nesting tags like <form>, <p>, or <a>, or using non-SVG elements ' + 'in an <svg> parent. Try inspecting the child nodes of the element ' + 'with React ID `%s`.', updatedIndex, parentID) : invariant(false) : undefined;

        initialChildren = initialChildren || {};
        initialChildren[parentID] = initialChildren[parentID] || [];
        initialChildren[parentID][updatedIndex] = updatedChild;

        updatedChildren = updatedChildren || [];
        updatedChildren.push(updatedChild);
      }
    }

    var renderedMarkup;
    // markupList is either a list of markup or just a list of elements
    if (markupList.length && typeof markupList[0] === 'string') {
      renderedMarkup = Danger.dangerouslyRenderMarkup(markupList);
    } else {
      renderedMarkup = markupList;
    }

    // Remove updated children first so that `toIndex` is consistent.
    if (updatedChildren) {
      for (var j = 0; j < updatedChildren.length; j++) {
        updatedChildren[j].parentNode.removeChild(updatedChildren[j]);
      }
    }

    for (var k = 0; k < updates.length; k++) {
      update = updates[k];
      switch (update.type) {
        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
          insertChildAt(update.parentNode, renderedMarkup[update.markupIndex], update.toIndex);
          break;
        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
          insertChildAt(update.parentNode, initialChildren[update.parentID][update.fromIndex], update.toIndex);
          break;
        case ReactMultiChildUpdateTypes.SET_MARKUP:
          setInnerHTML(update.parentNode, update.content);
          break;
        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
          setTextContent(update.parentNode, update.content);
          break;
        case ReactMultiChildUpdateTypes.REMOVE_NODE:
          // Already removed by the for-loop above.
          break;
      }
    }
  }

};

ReactPerf.measureMethods(DOMChildrenOperations, 'DOMChildrenOperations', {
  updateTextContent: 'updateTextContent'
});

module.exports = DOMChildrenOperations;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getMarkupWrap
 */

/*eslint-disable fb-www/unsafe-html */



var ExecutionEnvironment = __webpack_require__(14);

var invariant = __webpack_require__(2);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : undefined;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactMultiChildUpdateTypes
 */



var keyMirror = __webpack_require__(76);

/**
 * When a component's children are updated, a series of update configuration
 * objects are created in order to batch and serialize the required changes.
 *
 * Enumerates all the possible types of update configurations.
 *
 * @internal
 */
var ReactMultiChildUpdateTypes = keyMirror({
  INSERT_MARKUP: null,
  MOVE_EXISTING: null,
  REMOVE_NODE: null,
  SET_MARKUP: null,
  TEXT_CONTENT: null
});

module.exports = ReactMultiChildUpdateTypes;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventPluginRegistry
 * @typechecks static-only
 */



var invariant = __webpack_require__(2);

/**
 * Injectable ordering of event plugins.
 */
var EventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!EventPluginOrder) {
    // Wait until an `EventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var PluginModule = namesToPlugins[pluginName];
    var pluginIndex = EventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in ' + 'the plugin ordering, `%s`.', pluginName) : invariant(false) : undefined;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` ' + 'method, but `%s` does not.', pluginName) : invariant(false) : undefined;
    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
    var publishedEvents = PluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : invariant(false) : undefined;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'event name, `%s`.', eventName) : invariant(false) : undefined;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, PluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName) : invariant(false) : undefined;
  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {

  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (InjectedEventPluginOrder) {
    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than ' + 'once. You are likely trying to load more than one copy of React.') : invariant(false) : undefined;
    // Clone the ordering so it cannot be dynamically mutated.
    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var PluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins ' + 'using the same name, `%s`.', pluginName) : invariant(false) : undefined;
        namesToPlugins[pluginName] = PluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    for (var phase in dispatchConfig.phasedRegistrationNames) {
      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
        continue;
      }
      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
      if (PluginModule) {
        return PluginModule;
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    EventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }
  }

};

module.exports = EventPluginRegistry;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactErrorUtils
 * @typechecks
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {?String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a, b) {
  try {
    return func(a, b);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
    return undefined;
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
      var boundFunc = func.bind(null, a, b);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule accumulateInto
 */



var invariant = __webpack_require__(2);

/**
 *
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : invariant(false) : undefined;
  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  var currentIsArray = Array.isArray(current);
  var nextIsArray = Array.isArray(next);

  if (currentIsArray && nextIsArray) {
    current.push.apply(current, next);
    return current;
  }

  if (currentIsArray) {
    current.push(next);
    return current;
  }

  if (nextIsArray) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule forEachAccumulated
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */
var forEachAccumulated = function (arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
};

module.exports = forEachAccumulated;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ViewportMetrics
 */



var ViewportMetrics = {

  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }

};

module.exports = ViewportMetrics;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMFeatureFlags
 */



var ReactDOMFeatureFlags = {
  useCreateElement: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactEmptyComponentRegistry
 */



// This registry keeps track of the React IDs of the components that rendered to
// `null` (in reality a placeholder such as `noscript`)
var nullComponentIDsRegistry = {};

/**
 * @param {string} id Component's `_rootNodeID`.
 * @return {boolean} True if the component is rendered to null.
 */
function isNullComponentID(id) {
  return !!nullComponentIDsRegistry[id];
}

/**
 * Mark the component as having rendered to null.
 * @param {string} id Component's `_rootNodeID`.
 */
function registerNullComponentID(id) {
  nullComponentIDsRegistry[id] = true;
}

/**
 * Unmark the component as having rendered to null: it renders to something now.
 * @param {string} id Component's `_rootNodeID`.
 */
function deregisterNullComponentID(id) {
  delete nullComponentIDsRegistry[id];
}

var ReactEmptyComponentRegistry = {
  isNullComponentID: isNullComponentID,
  registerNullComponentID: registerNullComponentID,
  deregisterNullComponentID: deregisterNullComponentID
};

module.exports = ReactEmptyComponentRegistry;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactRootIndex
 * @typechecks
 */



var ReactRootIndexInjection = {
  /**
   * @param {function} _createReactRootIndex
   */
  injectCreateReactRootIndex: function (_createReactRootIndex) {
    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
  }
};

var ReactRootIndex = {
  createReactRootIndex: null,
  injection: ReactRootIndexInjection
};

module.exports = ReactRootIndex;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactMarkupChecksum
 */



var adler32 = __webpack_require__(310);

var TAG_END = /\/?>/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags and self-closing tags)
    return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule containsNode
 * @typechecks
 */



var isTextNode = __webpack_require__(313);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 *
 * @param {?DOMNode} outerNode Outer DOM node.
 * @param {?DOMNode} innerNode Inner DOM node.
 * @return {boolean} True if `outerNode` contains or is `innerNode`.
 */
function containsNode(_x, _x2) {
  var _again = true;

  _function: while (_again) {
    var outerNode = _x,
        innerNode = _x2;
    _again = false;

    if (!outerNode || !innerNode) {
      return false;
    } else if (outerNode === innerNode) {
      return true;
    } else if (isTextNode(outerNode)) {
      return false;
    } else if (isTextNode(innerNode)) {
      _x = outerNode;
      _x2 = innerNode.parentNode;
      _again = true;
      continue _function;
    } else if (outerNode.contains) {
      return outerNode.contains(innerNode);
    } else if (outerNode.compareDocumentPosition) {
      return !!(outerNode.compareDocumentPosition(innerNode) & 16);
    } else {
      return false;
    }
  }
}

module.exports = containsNode;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactEmptyComponent
 */



var ReactElement = __webpack_require__(18);
var ReactEmptyComponentRegistry = __webpack_require__(169);
var ReactReconciler = __webpack_require__(39);

var assign = __webpack_require__(8);

var placeholderElement;

var ReactEmptyComponentInjection = {
  injectEmptyComponent: function (component) {
    placeholderElement = ReactElement.createElement(component);
  }
};

function registerNullComponentID() {
  ReactEmptyComponentRegistry.registerNullComponentID(this._rootNodeID);
}

var ReactEmptyComponent = function (instantiate) {
  this._currentElement = null;
  this._rootNodeID = null;
  this._renderedComponent = instantiate(placeholderElement);
};
assign(ReactEmptyComponent.prototype, {
  construct: function (element) {},
  mountComponent: function (rootID, transaction, context) {
    transaction.getReactMountReady().enqueue(registerNullComponentID, this);
    this._rootNodeID = rootID;
    return ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, context);
  },
  receiveComponent: function () {},
  unmountComponent: function (rootID, transaction, context) {
    ReactReconciler.unmountComponent(this._renderedComponent);
    ReactEmptyComponentRegistry.deregisterNullComponentID(this._rootNodeID);
    this._rootNodeID = null;
    this._renderedComponent = null;
  }
});

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactNativeComponent
 */



var assign = __webpack_require__(8);
var invariant = __webpack_require__(2);

var autoGenerateWrapperClass = null;
var genericComponentClass = null;
// This registry keeps track of wrapper classes around native tags.
var tagToComponentClass = {};
var textComponentClass = null;

var ReactNativeComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  },
  // This accepts a keyed object with classes as values. Each key represents a
  // tag. That particular tag will use this class instead of the generic one.
  injectComponentClasses: function (componentClasses) {
    assign(tagToComponentClass, componentClasses);
  }
};

/**
 * Get a composite component wrapper class for a specific tag.
 *
 * @param {ReactElement} element The tag for which to get the class.
 * @return {function} The React class constructor function.
 */
function getComponentClassForElement(element) {
  if (typeof element.type === 'function') {
    return element.type;
  }
  var tag = element.type;
  var componentClass = tagToComponentClass[tag];
  if (componentClass == null) {
    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
  }
  return componentClass;
}

/**
 * Get a native internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : invariant(false) : undefined;
  return new genericComponentClass(element.type, element.props);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactNativeComponent = {
  getComponentClassForElement: getComponentClassForElement,
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactNativeComponentInjection
};

module.exports = ReactNativeComponent;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDefaultInjection
 */



var BeforeInputEventPlugin = __webpack_require__(316);
var ChangeEventPlugin = __webpack_require__(320);
var ClientReactRootIndex = __webpack_require__(321);
var DefaultEventPluginOrder = __webpack_require__(322);
var EnterLeaveEventPlugin = __webpack_require__(323);
var ExecutionEnvironment = __webpack_require__(14);
var HTMLDOMPropertyConfig = __webpack_require__(324);
var ReactBrowserComponentMixin = __webpack_require__(325);
var ReactComponentBrowserEnvironment = __webpack_require__(110);
var ReactDefaultBatchingStrategy = __webpack_require__(178);
var ReactDOMComponent = __webpack_require__(326);
var ReactDOMTextComponent = __webpack_require__(159);
var ReactEventListener = __webpack_require__(342);
var ReactInjection = __webpack_require__(344);
var ReactInstanceHandles = __webpack_require__(48);
var ReactMount = __webpack_require__(16);
var ReactReconcileTransaction = __webpack_require__(345);
var SelectEventPlugin = __webpack_require__(348);
var ServerReactRootIndex = __webpack_require__(349);
var SimpleEventPlugin = __webpack_require__(350);
var SVGDOMPropertyConfig = __webpack_require__(358);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginHub.injectInstanceHandle(ReactInstanceHandles);
  ReactInjection.EventPluginHub.injectMount(ReactMount);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.NativeComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.NativeComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.Class.injectMixin(ReactBrowserComponentMixin);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponent('noscript');

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.RootIndex.injectCreateReactRootIndex(ExecutionEnvironment.canUseDOM ? ClientReactRootIndex.createReactRootIndex : ServerReactRootIndex.createReactRootIndex);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);

  if (false) {
    var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
    if (/[?&]react_perf\b/.test(url)) {
      var ReactDefaultPerf = require('./ReactDefaultPerf');
      ReactDefaultPerf.start();
    }
  }
}

module.exports = {
  inject: inject
};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getTextContentAccessor
 */



var ExecutionEnvironment = __webpack_require__(14);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isTextInputElement
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */
var supportedInputTypes = {
  'color': true,
  'date': true,
  'datetime': true,
  'datetime-local': true,
  'email': true,
  'month': true,
  'number': true,
  'password': true,
  'range': true,
  'search': true,
  'tel': true,
  'text': true,
  'time': true,
  'url': true,
  'week': true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName && (nodeName === 'input' && supportedInputTypes[elem.type] || nodeName === 'textarea');
}

module.exports = isTextInputElement;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDefaultBatchingStrategy
 */



var ReactUpdates = __webpack_require__(20);
var Transaction = __webpack_require__(81);

var assign = __webpack_require__(8);
var emptyFunction = __webpack_require__(21);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      callback(a, b, c, d, e);
    } else {
      transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule focusNode
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */
function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CSSProperty
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */
var isUnitlessNumber = {
  animationIterationCount: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  stopOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPropTypes
 */



var ReactElement = __webpack_require__(18);
var ReactPropTypeLocationNames = __webpack_require__(83);

var emptyFunction = __webpack_require__(21);
var getIteratorFn = __webpack_require__(123);

/**
 * Collection of methods that allow declaration and validation of props that are
 * supplied to React components. Example usage:
 *
 *   var Props = require('ReactPropTypes');
 *   var MyArticle = React.createClass({
 *     propTypes: {
 *       // An optional string prop named "description".
 *       description: Props.string,
 *
 *       // A required enum prop named "category".
 *       category: Props.oneOf(['News','Photos']).isRequired,
 *
 *       // A prop named "dialog" that requires an instance of Dialog.
 *       dialog: Props.instanceOf(Dialog).isRequired
 *     },
 *     render: function() { ... }
 *   });
 *
 * A more formal specification of how these methods are used:
 *
 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
 *   decl := ReactPropTypes.{type}(.isRequired)?
 *
 * Each and every declaration produces a function with the same signature. This
 * allows the creation of custom validation functions. For example:
 *
 *  var MyLink = React.createClass({
 *    propTypes: {
 *      // An optional string or URI prop named "href".
 *      href: function(props, propName, componentName) {
 *        var propValue = props[propName];
 *        if (propValue != null && typeof propValue !== 'string' &&
 *            !(propValue instanceof URI)) {
 *          return new Error(
 *            'Expected a string or an URI for ' + propName + ' in ' +
 *            componentName
 *          );
 *        }
 *      }
 *    },
 *    render: function() {...}
 *  });
 *
 * @internal
 */

var ANONYMOUS = '<<anonymous>>';

var ReactPropTypes = {
  array: createPrimitiveTypeChecker('array'),
  bool: createPrimitiveTypeChecker('boolean'),
  func: createPrimitiveTypeChecker('function'),
  number: createPrimitiveTypeChecker('number'),
  object: createPrimitiveTypeChecker('object'),
  string: createPrimitiveTypeChecker('string'),

  any: createAnyTypeChecker(),
  arrayOf: createArrayOfTypeChecker,
  element: createElementTypeChecker(),
  instanceOf: createInstanceTypeChecker,
  node: createNodeChecker(),
  objectOf: createObjectOfTypeChecker,
  oneOf: createEnumTypeChecker,
  oneOfType: createUnionTypeChecker,
  shape: createShapeTypeChecker
};

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    componentName = componentName || ANONYMOUS;
    propFullName = propFullName || propName;
    if (props[propName] == null) {
      var locationName = ReactPropTypeLocationNames[location];
      if (isRequired) {
        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
      }
      return null;
    } else {
      return validate(props, propName, componentName, location, propFullName);
    }
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

function createPrimitiveTypeChecker(expectedType) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== expectedType) {
      var locationName = ReactPropTypeLocationNames[location];
      // `propValue` being instance of, say, date/regexp, pass the 'object'
      // check, but we can offer a more precise error message here rather than
      // 'of type `object`'.
      var preciseType = getPreciseType(propValue);

      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createAnyTypeChecker() {
  return createChainableTypeChecker(emptyFunction.thatReturns(null));
}

function createArrayOfTypeChecker(typeChecker) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    if (!Array.isArray(propValue)) {
      var locationName = ReactPropTypeLocationNames[location];
      var propType = getPropType(propValue);
      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
    }
    for (var i = 0; i < propValue.length; i++) {
      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
      if (error instanceof Error) {
        return error;
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createElementTypeChecker() {
  function validate(props, propName, componentName, location, propFullName) {
    if (!ReactElement.isValidElement(props[propName])) {
      var locationName = ReactPropTypeLocationNames[location];
      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a single ReactElement.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createInstanceTypeChecker(expectedClass) {
  function validate(props, propName, componentName, location, propFullName) {
    if (!(props[propName] instanceof expectedClass)) {
      var locationName = ReactPropTypeLocationNames[location];
      var expectedClassName = expectedClass.name || ANONYMOUS;
      var actualClassName = getClassName(props[propName]);
      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createEnumTypeChecker(expectedValues) {
  if (!Array.isArray(expectedValues)) {
    return createChainableTypeChecker(function () {
      return new Error('Invalid argument supplied to oneOf, expected an instance of array.');
    });
  }

  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    for (var i = 0; i < expectedValues.length; i++) {
      if (propValue === expectedValues[i]) {
        return null;
      }
    }

    var locationName = ReactPropTypeLocationNames[location];
    var valuesString = JSON.stringify(expectedValues);
    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
  }
  return createChainableTypeChecker(validate);
}

function createObjectOfTypeChecker(typeChecker) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== 'object') {
      var locationName = ReactPropTypeLocationNames[location];
      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
    }
    for (var key in propValue) {
      if (propValue.hasOwnProperty(key)) {
        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
        if (error instanceof Error) {
          return error;
        }
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createUnionTypeChecker(arrayOfTypeCheckers) {
  if (!Array.isArray(arrayOfTypeCheckers)) {
    return createChainableTypeChecker(function () {
      return new Error('Invalid argument supplied to oneOfType, expected an instance of array.');
    });
  }

  function validate(props, propName, componentName, location, propFullName) {
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (checker(props, propName, componentName, location, propFullName, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED') == null) {
        return null;
      }
    }

    var locationName = ReactPropTypeLocationNames[location];
    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
  }
  return createChainableTypeChecker(validate);
}

function createNodeChecker() {
  function validate(props, propName, componentName, location, propFullName) {
    if (!isNode(props[propName])) {
      var locationName = ReactPropTypeLocationNames[location];
      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createShapeTypeChecker(shapeTypes) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== 'object') {
      var locationName = ReactPropTypeLocationNames[location];
      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
    }
    for (var key in shapeTypes) {
      var checker = shapeTypes[key];
      if (!checker) {
        continue;
      }
      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
      if (error) {
        return error;
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function isNode(propValue) {
  switch (typeof propValue) {
    case 'number':
    case 'string':
    case 'undefined':
      return true;
    case 'boolean':
      return !propValue;
    case 'object':
      if (Array.isArray(propValue)) {
        return propValue.every(isNode);
      }
      if (propValue === null || ReactElement.isValidElement(propValue)) {
        return true;
      }

      var iteratorFn = getIteratorFn(propValue);
      if (iteratorFn) {
        var iterator = iteratorFn.call(propValue);
        var step;
        if (iteratorFn !== propValue.entries) {
          while (!(step = iterator.next()).done) {
            if (!isNode(step.value)) {
              return false;
            }
          }
        } else {
          // Iterator will provide entry [k,v] tuples rather than values.
          while (!(step = iterator.next()).done) {
            var entry = step.value;
            if (entry) {
              if (!isNode(entry[1])) {
                return false;
              }
            }
          }
        }
      } else {
        return false;
      }

      return true;
    default:
      return false;
  }
}

// Equivalent of `typeof` but with special handling for array and regexp.
function getPropType(propValue) {
  var propType = typeof propValue;
  if (Array.isArray(propValue)) {
    return 'array';
  }
  if (propValue instanceof RegExp) {
    // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return 'object';
  }
  return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// See `createPrimitiveTypeChecker`.
function getPreciseType(propValue) {
  var propType = getPropType(propValue);
  if (propType === 'object') {
    if (propValue instanceof Date) {
      return 'date';
    } else if (propValue instanceof RegExp) {
      return 'regexp';
    }
  }
  return propType;
}

// Returns class name of the object, if any.
function getClassName(propValue) {
  if (!propValue.constructor || !propValue.constructor.name) {
    return '<<anonymous>>';
  }
  return propValue.constructor.name;
}

module.exports = ReactPropTypes;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactChildren
 */



var PooledClass = __webpack_require__(31);
var ReactElement = __webpack_require__(18);

var emptyFunction = __webpack_require__(21);
var traverseAllChildren = __webpack_require__(124);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/(?!\/)/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '//');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func;
  var context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result;
  var keyPrefix = bookKeeping.keyPrefix;
  var func = bookKeeping.func;
  var context = bookKeeping.context;

  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild !== child ? escapeUserProvidedKey(mappedChild.key || '') + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMSelect
 */



var LinkedValueUtils = __webpack_require__(122);
var ReactMount = __webpack_require__(16);
var ReactUpdates = __webpack_require__(20);

var assign = __webpack_require__(8);
var warning = __webpack_require__(7);

var valueContextKey = '__ReactDOMSelect_value$' + Math.random().toString(36).slice(2);

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    if (props.multiple) {
       false ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
    } else {
       false ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactMount.getNode(inst._rootNodeID).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> native component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  valueContextKey: valueContextKey,

  getNativeProps: function (inst, props, context) {
    return assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };
  },

  processChildContext: function (inst, props, context) {
    // Pass down initial value so initial generated markup has correct
    // `selected` attributes
    var childContext = assign({}, context);
    childContext[valueContextKey] = inst._wrapperState.initialValue;
    return childContext;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // the context value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  this._wrapperState.pendingUpdate = true;
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule shallowEqual
 * @typechecks
 * 
 */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @providesModule EventListener
 * @typechecks
 */



var emptyFunction = __webpack_require__(21);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function (target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function () {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function () {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function (target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function () {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function () {}
};

module.exports = EventListener;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactClass
 */



var ReactComponent = __webpack_require__(187);
var ReactElement = __webpack_require__(18);
var ReactPropTypeLocations = __webpack_require__(82);
var ReactPropTypeLocationNames = __webpack_require__(83);
var ReactNoopUpdateQueue = __webpack_require__(188);

var assign = __webpack_require__(8);
var emptyObject = __webpack_require__(62);
var invariant = __webpack_require__(2);
var keyMirror = __webpack_require__(76);
var keyOf = __webpack_require__(32);
var warning = __webpack_require__(7);

var MIXINS_KEY = keyOf({ mixins: null });

/**
 * Policies that describe methods in `ReactClassInterface`.
 */
var SpecPolicy = keyMirror({
  /**
   * These methods may be defined only once by the class specification or mixin.
   */
  DEFINE_ONCE: null,
  /**
   * These methods may be defined by both the class specification and mixins.
   * Subsequent definitions will be chained. These methods must return void.
   */
  DEFINE_MANY: null,
  /**
   * These methods are overriding the base class.
   */
  OVERRIDE_BASE: null,
  /**
   * These methods are similar to DEFINE_MANY, except we assume they return
   * objects. We try to merge the keys of the return values of all the mixed in
   * functions. If there is a key conflict we throw.
   */
  DEFINE_MANY_MERGED: null
});

var injectedMixins = [];

var warnedSetProps = false;
function warnSetProps() {
  if (!warnedSetProps) {
    warnedSetProps = true;
     false ? warning(false, 'setProps(...) and replaceProps(...) are deprecated. ' + 'Instead, call render again at the top level.') : undefined;
  }
}

/**
 * Composite components are higher-level components that compose other composite
 * or native components.
 *
 * To create a new type of `ReactClass`, pass a specification of
 * your new class to `React.createClass`. The only requirement of your class
 * specification is that you implement a `render` method.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return <div>Hello World</div>;
 *     }
 *   });
 *
 * The class specification supports a specific protocol of methods that have
 * special meaning (e.g. `render`). See `ReactClassInterface` for
 * more the comprehensive protocol. Any other properties and methods in the
 * class specification will be available on the prototype.
 *
 * @interface ReactClassInterface
 * @internal
 */
var ReactClassInterface = {

  /**
   * An array of Mixin objects to include when defining your component.
   *
   * @type {array}
   * @optional
   */
  mixins: SpecPolicy.DEFINE_MANY,

  /**
   * An object containing properties and methods that should be defined on
   * the component's constructor instead of its prototype (static methods).
   *
   * @type {object}
   * @optional
   */
  statics: SpecPolicy.DEFINE_MANY,

  /**
   * Definition of prop types for this component.
   *
   * @type {object}
   * @optional
   */
  propTypes: SpecPolicy.DEFINE_MANY,

  /**
   * Definition of context types for this component.
   *
   * @type {object}
   * @optional
   */
  contextTypes: SpecPolicy.DEFINE_MANY,

  /**
   * Definition of context types this component sets for its children.
   *
   * @type {object}
   * @optional
   */
  childContextTypes: SpecPolicy.DEFINE_MANY,

  // ==== Definition methods ====

  /**
   * Invoked when the component is mounted. Values in the mapping will be set on
   * `this.props` if that prop is not specified (i.e. using an `in` check).
   *
   * This method is invoked before `getInitialState` and therefore cannot rely
   * on `this.state` or use `this.setState`.
   *
   * @return {object}
   * @optional
   */
  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,

  /**
   * Invoked once before the component is mounted. The return value will be used
   * as the initial value of `this.state`.
   *
   *   getInitialState: function() {
   *     return {
   *       isOn: false,
   *       fooBaz: new BazFoo()
   *     }
   *   }
   *
   * @return {object}
   * @optional
   */
  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,

  /**
   * @return {object}
   * @optional
   */
  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,

  /**
   * Uses props from `this.props` and state from `this.state` to render the
   * structure of the component.
   *
   * No guarantees are made about when or how often this method is invoked, so
   * it must not have side effects.
   *
   *   render: function() {
   *     var name = this.props.name;
   *     return <div>Hello, {name}!</div>;
   *   }
   *
   * @return {ReactComponent}
   * @nosideeffects
   * @required
   */
  render: SpecPolicy.DEFINE_ONCE,

  // ==== Delegate methods ====

  /**
   * Invoked when the component is initially created and about to be mounted.
   * This may have side effects, but any external subscriptions or data created
   * by this method must be cleaned up in `componentWillUnmount`.
   *
   * @optional
   */
  componentWillMount: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked when the component has been mounted and has a DOM representation.
   * However, there is no guarantee that the DOM node is in the document.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been mounted (initialized and rendered) for the first time.
   *
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidMount: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked before the component receives new props.
   *
   * Use this as an opportunity to react to a prop transition by updating the
   * state using `this.setState`. Current props are accessed via `this.props`.
   *
   *   componentWillReceiveProps: function(nextProps, nextContext) {
   *     this.setState({
   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
   *     });
   *   }
   *
   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
   * transition may cause a state change, but the opposite is not true. If you
   * need it, you are probably looking for `componentWillUpdate`.
   *
   * @param {object} nextProps
   * @optional
   */
  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked while deciding if the component should be updated as a result of
   * receiving new props, state and/or context.
   *
   * Use this as an opportunity to `return false` when you're certain that the
   * transition to the new props/state/context will not require a component
   * update.
   *
   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
   *     return !equal(nextProps, this.props) ||
   *       !equal(nextState, this.state) ||
   *       !equal(nextContext, this.context);
   *   }
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @return {boolean} True if the component should update.
   * @optional
   */
  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,

  /**
   * Invoked when the component is about to update due to a transition from
   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
   * and `nextContext`.
   *
   * Use this as an opportunity to perform preparation before an update occurs.
   *
   * NOTE: You **cannot** use `this.setState()` in this method.
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @param {ReactReconcileTransaction} transaction
   * @optional
   */
  componentWillUpdate: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked when the component's DOM representation has been updated.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been updated.
   *
   * @param {object} prevProps
   * @param {?object} prevState
   * @param {?object} prevContext
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidUpdate: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked when the component is about to be removed from its parent and have
   * its DOM representation destroyed.
   *
   * Use this as an opportunity to deallocate any external resources.
   *
   * NOTE: There is no `componentDidUnmount` since your component will have been
   * destroyed by that point.
   *
   * @optional
   */
  componentWillUnmount: SpecPolicy.DEFINE_MANY,

  // ==== Advanced methods ====

  /**
   * Updates the component's currently mounted DOM representation.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   * @overridable
   */
  updateComponent: SpecPolicy.OVERRIDE_BASE

};

/**
 * Mapping from class specification keys to special processing functions.
 *
 * Although these are declared like instance properties in the specification
 * when defining classes using `React.createClass`, they are actually static
 * and are accessible on the constructor instead of the prototype. Despite
 * being static, they must be defined outside of the "statics" key under
 * which all other static methods are defined.
 */
var RESERVED_SPEC_KEYS = {
  displayName: function (Constructor, displayName) {
    Constructor.displayName = displayName;
  },
  mixins: function (Constructor, mixins) {
    if (mixins) {
      for (var i = 0; i < mixins.length; i++) {
        mixSpecIntoComponent(Constructor, mixins[i]);
      }
    }
  },
  childContextTypes: function (Constructor, childContextTypes) {
    if (false) {
      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
    }
    Constructor.childContextTypes = assign({}, Constructor.childContextTypes, childContextTypes);
  },
  contextTypes: function (Constructor, contextTypes) {
    if (false) {
      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
    }
    Constructor.contextTypes = assign({}, Constructor.contextTypes, contextTypes);
  },
  /**
   * Special case getDefaultProps which should move into statics but requires
   * automatic merging.
   */
  getDefaultProps: function (Constructor, getDefaultProps) {
    if (Constructor.getDefaultProps) {
      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
    } else {
      Constructor.getDefaultProps = getDefaultProps;
    }
  },
  propTypes: function (Constructor, propTypes) {
    if (false) {
      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
    }
    Constructor.propTypes = assign({}, Constructor.propTypes, propTypes);
  },
  statics: function (Constructor, statics) {
    mixStaticSpecIntoComponent(Constructor, statics);
  },
  autobind: function () {} };

// noop
function validateTypeDef(Constructor, typeDef, location) {
  for (var propName in typeDef) {
    if (typeDef.hasOwnProperty(propName)) {
      // use a warning instead of an invariant so components
      // don't show up in prod but not in __DEV__
       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : undefined;
    }
  }
}

function validateMethodOverride(proto, name) {
  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

  // Disallow overriding of base class methods unless explicitly allowed.
  if (ReactClassMixin.hasOwnProperty(name)) {
    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name) : invariant(false) : undefined;
  }

  // Disallow defining methods more than once unless explicitly allowed.
  if (proto.hasOwnProperty(name)) {
    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name) : invariant(false) : undefined;
  }
}

/**
 * Mixin helper which handles policy validation and reserved
 * specification keys when building React classses.
 */
function mixSpecIntoComponent(Constructor, spec) {
  if (!spec) {
    return;
  }

  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component class as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;

  var proto = Constructor.prototype;

  // By handling mixins before any other properties, we ensure the same
  // chaining order is applied to methods with DEFINE_MANY policy, whether
  // mixins are listed before or after these methods in the spec.
  if (spec.hasOwnProperty(MIXINS_KEY)) {
    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
  }

  for (var name in spec) {
    if (!spec.hasOwnProperty(name)) {
      continue;
    }

    if (name === MIXINS_KEY) {
      // We have already handled mixins in a special case above.
      continue;
    }

    var property = spec[name];
    validateMethodOverride(proto, name);

    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
      RESERVED_SPEC_KEYS[name](Constructor, property);
    } else {
      // Setup methods on prototype:
      // The following member methods should not be automatically bound:
      // 1. Expected ReactClass methods (in the "interface").
      // 2. Overridden methods (that were mixed in).
      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
      var isAlreadyDefined = proto.hasOwnProperty(name);
      var isFunction = typeof property === 'function';
      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

      if (shouldAutoBind) {
        if (!proto.__reactAutoBindMap) {
          proto.__reactAutoBindMap = {};
        }
        proto.__reactAutoBindMap[name] = property;
        proto[name] = property;
      } else {
        if (isAlreadyDefined) {
          var specPolicy = ReactClassInterface[name];

          // These cases should already be caught by validateMethodOverride.
          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name) : invariant(false) : undefined;

          // For methods which are defined more than once, call the existing
          // methods before calling the new property, merging if appropriate.
          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
            proto[name] = createMergedResultFunction(proto[name], property);
          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
            proto[name] = createChainedFunction(proto[name], property);
          }
        } else {
          proto[name] = property;
          if (false) {
            // Add verbose displayName to the function, which helps when looking
            // at profiling tools.
            if (typeof property === 'function' && spec.displayName) {
              proto[name].displayName = spec.displayName + '_' + name;
            }
          }
        }
      }
    }
  }
}

function mixStaticSpecIntoComponent(Constructor, statics) {
  if (!statics) {
    return;
  }
  for (var name in statics) {
    var property = statics[name];
    if (!statics.hasOwnProperty(name)) {
      continue;
    }

    var isReserved = (name in RESERVED_SPEC_KEYS);
    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name) : invariant(false) : undefined;

    var isInherited = (name in Constructor);
    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name) : invariant(false) : undefined;
    Constructor[name] = property;
  }
}

/**
 * Merge two objects, but throw if both contain the same key.
 *
 * @param {object} one The first object, which is mutated.
 * @param {object} two The second object
 * @return {object} one after it has been mutated to contain everything in two.
 */
function mergeIntoWithNoDuplicateKeys(one, two) {
  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : invariant(false) : undefined;

  for (var key in two) {
    if (two.hasOwnProperty(key)) {
      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key) : invariant(false) : undefined;
      one[key] = two[key];
    }
  }
  return one;
}

/**
 * Creates a function that invokes two functions and merges their return values.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createMergedResultFunction(one, two) {
  return function mergedResult() {
    var a = one.apply(this, arguments);
    var b = two.apply(this, arguments);
    if (a == null) {
      return b;
    } else if (b == null) {
      return a;
    }
    var c = {};
    mergeIntoWithNoDuplicateKeys(c, a);
    mergeIntoWithNoDuplicateKeys(c, b);
    return c;
  };
}

/**
 * Creates a function that invokes two functions and ignores their return vales.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createChainedFunction(one, two) {
  return function chainedFunction() {
    one.apply(this, arguments);
    two.apply(this, arguments);
  };
}

/**
 * Binds a method to the component.
 *
 * @param {object} component Component whose method is going to be bound.
 * @param {function} method Method to be bound.
 * @return {function} The bound method.
 */
function bindAutoBindMethod(component, method) {
  var boundMethod = method.bind(component);
  if (false) {
    boundMethod.__reactBoundContext = component;
    boundMethod.__reactBoundMethod = method;
    boundMethod.__reactBoundArguments = null;
    var componentName = component.constructor.displayName;
    var _bind = boundMethod.bind;
    /* eslint-disable block-scoped-var, no-undef */
    boundMethod.bind = function (newThis) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      // User is trying to bind() an autobound method; we effectively will
      // ignore the value of "this" that the user is trying to use, so
      // let's warn.
      if (newThis !== component && newThis !== null) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : undefined;
      } else if (!args.length) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : undefined;
        return boundMethod;
      }
      var reboundMethod = _bind.apply(boundMethod, arguments);
      reboundMethod.__reactBoundContext = component;
      reboundMethod.__reactBoundMethod = method;
      reboundMethod.__reactBoundArguments = args;
      return reboundMethod;
      /* eslint-enable */
    };
  }
  return boundMethod;
}

/**
 * Binds all auto-bound methods in a component.
 *
 * @param {object} component Component whose method is going to be bound.
 */
function bindAutoBindMethods(component) {
  for (var autoBindKey in component.__reactAutoBindMap) {
    if (component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
      var method = component.__reactAutoBindMap[autoBindKey];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }
}

/**
 * Add more to the ReactClass base class. These are all legacy features and
 * therefore not already part of the modern ReactComponent.
 */
var ReactClassMixin = {

  /**
   * TODO: This will be deprecated because state should always keep a consistent
   * type signature and the only use case for this, is to avoid that.
   */
  replaceState: function (newState, callback) {
    this.updater.enqueueReplaceState(this, newState);
    if (callback) {
      this.updater.enqueueCallback(this, callback);
    }
  },

  /**
   * Checks whether or not this composite component is mounted.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function () {
    return this.updater.isMounted(this);
  },

  /**
   * Sets a subset of the props.
   *
   * @param {object} partialProps Subset of the next props.
   * @param {?function} callback Called after props are updated.
   * @final
   * @public
   * @deprecated
   */
  setProps: function (partialProps, callback) {
    if (false) {
      warnSetProps();
    }
    this.updater.enqueueSetProps(this, partialProps);
    if (callback) {
      this.updater.enqueueCallback(this, callback);
    }
  },

  /**
   * Replace all the props.
   *
   * @param {object} newProps Subset of the next props.
   * @param {?function} callback Called after props are updated.
   * @final
   * @public
   * @deprecated
   */
  replaceProps: function (newProps, callback) {
    if (false) {
      warnSetProps();
    }
    this.updater.enqueueReplaceProps(this, newProps);
    if (callback) {
      this.updater.enqueueCallback(this, callback);
    }
  }
};

var ReactClassComponent = function () {};
assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

/**
 * Module for creating composite components.
 *
 * @class ReactClass
 */
var ReactClass = {

  /**
   * Creates a composite component class given a class specification.
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  createClass: function (spec) {
    var Constructor = function (props, context, updater) {
      // This constructor is overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : undefined;
      }

      // Wire up auto-binding
      if (this.__reactAutoBindMap) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (typeof initialState === 'undefined' && this.getInitialState._isMockFunction) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : invariant(false) : undefined;

      this.state = initialState;
    };
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, spec);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : invariant(false) : undefined;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : undefined;
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : undefined;
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  },

  injection: {
    injectMixin: function (mixin) {
      injectedMixins.push(mixin);
    }
  }

};

module.exports = ReactClass;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponent
 */



var ReactNoopUpdateQueue = __webpack_require__(188);

var canDefineProperty = __webpack_require__(80);
var emptyObject = __webpack_require__(62);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(7);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a ' + 'function which returns an object of state variables.') : invariant(false) : undefined;
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : undefined;
  }
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback);
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback);
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    getDOMNode: ['getDOMNode', 'Use ReactDOM.findDOMNode(component) instead.'],
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceProps: ['replaceProps', 'Instead, call render again at the top level.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).'],
    setProps: ['setProps', 'Instead, call render again at the top level.']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : undefined;
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

module.exports = ReactComponent;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactNoopUpdateQueue
 */



var warning = __webpack_require__(7);

function warnTDZ(publicInstance, callerName) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor && publicInstance.constructor.displayName || '') : undefined;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnTDZ(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnTDZ(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnTDZ(publicInstance, 'setState');
  },

  /**
   * Sets a subset of the props.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialProps Subset of the next props.
   * @internal
   */
  enqueueSetProps: function (publicInstance, partialProps) {
    warnTDZ(publicInstance, 'setProps');
  },

  /**
   * Replaces all of the props.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} props New props.
   * @internal
   */
  enqueueReplaceProps: function (publicInstance, props) {
    warnTDZ(publicInstance, 'replaceProps');
  }

};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInputSelection
 */



var ReactDOMSelection = __webpack_require__(346);

var containsNode = __webpack_require__(172);
var focusNode = __webpack_require__(179);
var getActiveElement = __webpack_require__(190);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {

  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (typeof end === 'undefined') {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getActiveElement
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 */


function getActiveElement() /*?DOMElement*/{
  if (typeof document === 'undefined') {
    return null;
  }
  try {
    return document.activeElement || document.body;
  } catch (e) {
    return document.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactElementValidator
 */

/**
 * ReactElementValidator provides a wrapper around a element factory
 * which validates the props passed to the element. This is intended to be
 * used only in DEV and could be replaced by a static type checker for languages
 * that support it.
 */



var ReactElement = __webpack_require__(18);
var ReactPropTypeLocations = __webpack_require__(82);
var ReactPropTypeLocationNames = __webpack_require__(83);
var ReactCurrentOwner = __webpack_require__(25);

var canDefineProperty = __webpack_require__(80);
var getIteratorFn = __webpack_require__(123);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(7);

function getDeclarationErrorAddendum() {
  if (ReactCurrentOwner.current) {
    var name = ReactCurrentOwner.current.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */
var ownerHasKeyUseWarning = {};

var loggedTypeFailures = {};

/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */
function validateExplicitKey(element, parentType) {
  if (!element._store || element._store.validated || element.key != null) {
    return;
  }
  element._store.validated = true;

  var addenda = getAddendaForKeyUse('uniqueKey', element, parentType);
  if (addenda === null) {
    // we already showed the warning
    return;
  }
   false ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s%s', addenda.parentOrOwner || '', addenda.childOwner || '', addenda.url || '') : undefined;
}

/**
 * Shared warning and monitoring code for the key warnings.
 *
 * @internal
 * @param {string} messageType A key used for de-duping warnings.
 * @param {ReactElement} element Component that requires a key.
 * @param {*} parentType element's parent's type.
 * @returns {?object} A set of addenda to use in the warning message, or null
 * if the warning has already been shown before (and shouldn't be shown again).
 */
function getAddendaForKeyUse(messageType, element, parentType) {
  var addendum = getDeclarationErrorAddendum();
  if (!addendum) {
    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
    if (parentName) {
      addendum = ' Check the top-level render call using <' + parentName + '>.';
    }
  }

  var memoizer = ownerHasKeyUseWarning[messageType] || (ownerHasKeyUseWarning[messageType] = {});
  if (memoizer[addendum]) {
    return null;
  }
  memoizer[addendum] = true;

  var addenda = {
    parentOrOwner: addendum,
    url: ' See https://fb.me/react-warning-keys for more information.',
    childOwner: null
  };

  // Usually the current owner is the offender, but if it accepts children as a
  // property, it may be the creator of the child that's responsible for
  // assigning it a key.
  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
    // Give the component that originally created this child.
    addenda.childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
  }

  return addenda;
}

/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */
function validateChildKeys(node, parentType) {
  if (typeof node !== 'object') {
    return;
  }
  if (Array.isArray(node)) {
    for (var i = 0; i < node.length; i++) {
      var child = node[i];
      if (ReactElement.isValidElement(child)) {
        validateExplicitKey(child, parentType);
      }
    }
  } else if (ReactElement.isValidElement(node)) {
    // This element was passed in a valid location.
    if (node._store) {
      node._store.validated = true;
    }
  } else if (node) {
    var iteratorFn = getIteratorFn(node);
    // Entry iterators provide implicit keys.
    if (iteratorFn) {
      if (iteratorFn !== node.entries) {
        var iterator = iteratorFn.call(node);
        var step;
        while (!(step = iterator.next()).done) {
          if (ReactElement.isValidElement(step.value)) {
            validateExplicitKey(step.value, parentType);
          }
        }
      }
    }
  }
}

/**
 * Assert that the props are valid
 *
 * @param {string} componentName Name of the component for error messages.
 * @param {object} propTypes Map of prop name to a ReactPropType
 * @param {object} props
 * @param {string} location e.g. "prop", "context", "child context"
 * @private
 */
function checkPropTypes(componentName, propTypes, props, location) {
  for (var propName in propTypes) {
    if (propTypes.hasOwnProperty(propName)) {
      var error;
      // Prop type validation may throw. In case they do, we don't want to
      // fail the render phase where it didn't fail before. So we log it.
      // After these have been cleaned up, we'll let them throw.
      try {
        // This is intentionally an invariant that gets caught. It's the same
        // behavior as without this statement except with a better message.
        !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
        error = propTypes[propName](props, propName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
      } catch (ex) {
        error = ex;
      }
       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], propName, typeof error) : undefined;
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum();
         false ? warning(false, 'Failed propType: %s%s', error.message, addendum) : undefined;
      }
    }
  }
}

/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */
function validatePropTypes(element) {
  var componentClass = element.type;
  if (typeof componentClass !== 'function') {
    return;
  }
  var name = componentClass.displayName || componentClass.name;
  if (componentClass.propTypes) {
    checkPropTypes(name, componentClass.propTypes, element.props, ReactPropTypeLocations.prop);
  }
  if (typeof componentClass.getDefaultProps === 'function') {
     false ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : undefined;
  }
}

var ReactElementValidator = {

  createElement: function (type, props, children) {
    var validType = typeof type === 'string' || typeof type === 'function';
    // We warn in this case but don't throw. We expect the element creation to
    // succeed and there will likely be errors in render.
     false ? warning(validType, 'React.createElement: type should not be null, undefined, boolean, or ' + 'number. It should be a string (for DOM elements) or a ReactClass ' + '(for composite components).%s', getDeclarationErrorAddendum()) : undefined;

    var element = ReactElement.createElement.apply(this, arguments);

    // The result can be nullish if a mock or a custom function is used.
    // TODO: Drop this when these are no longer allowed as the type argument.
    if (element == null) {
      return element;
    }

    // Skip key warning if the type isn't valid since our key validation logic
    // doesn't expect a non-string/function type and can throw confusing errors.
    // We don't want exception behavior to differ between dev and prod.
    // (Rendering will throw with a helpful message and as soon as the type is
    // fixed, the key warnings will appear.)
    if (validType) {
      for (var i = 2; i < arguments.length; i++) {
        validateChildKeys(arguments[i], type);
      }
    }

    validatePropTypes(element);

    return element;
  },

  createFactory: function (type) {
    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
    // Legacy hook TODO: Warn if this is accessed
    validatedFactory.type = type;

    if (false) {
      if (canDefineProperty) {
        Object.defineProperty(validatedFactory, 'type', {
          enumerable: false,
          get: function () {
            process.env.NODE_ENV !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : undefined;
            Object.defineProperty(this, 'type', {
              value: type
            });
            return type;
          }
        });
      }
    }

    return validatedFactory;
  },

  cloneElement: function (element, props, children) {
    var newElement = ReactElement.cloneElement.apply(this, arguments);
    for (var i = 2; i < arguments.length; i++) {
      validateChildKeys(arguments[i], newElement.type);
    }
    validatePropTypes(newElement);
    return newElement;
  }

};

module.exports = ReactElementValidator;

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(379);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = Object(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* default */])(),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return Object(__WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */])(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      Object(__WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */])(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["a"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(130);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Link',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["b" /* ContextSubscriber */])('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["b" /* routerShape */]
  },

  propTypes: {
    to: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]]),
    activeStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    onlyActiveOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"].isRequired,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
    target: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    innerRef: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex', 'innerRef']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { ref: innerRef }));
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, ref: innerRef }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatternUtils__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(65);







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = Object(__WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */])(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = Object(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = Object(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], // Alias for path
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
  return history;
}

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(15);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(41);

var _PathUtils = __webpack_require__(35);

var _createHistory = __webpack_require__(135);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(15);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(85);

var _BrowserProtocol = __webpack_require__(136);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(395);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(67);

var _createHistory = __webpack_require__(135);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(199);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = Object(__WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */])(createHistory)();
  return history;
}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(15);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(85);

var _DOMUtils = __webpack_require__(67);

var _HashProtocol = __webpack_require__(397);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(135);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cUpLoading = __webpack_require__(13);

var _cUpLoading2 = _interopRequireDefault(_cUpLoading);

var _cNotification = __webpack_require__(11);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _countries = __webpack_require__(405);

var _countries2 = _interopRequireDefault(_countries);

var _countryCode = __webpack_require__(406);

var _countryCode2 = _interopRequireDefault(_countryCode);

var _number = __webpack_require__(44);

var _number2 = _interopRequireDefault(_number);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _login = __webpack_require__(86);

var _login2 = _interopRequireDefault(_login);

var _md = __webpack_require__(68);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _countryView = __webpack_require__(87);

var _countryView2 = _interopRequireDefault(_countryView);

var _check = __webpack_require__(88);

var _check2 = _interopRequireDefault(_check);

var _register = __webpack_require__(89);

var _register2 = _interopRequireDefault(_register);

var _index = __webpack_require__(411);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(413);

var _index4 = _interopRequireDefault(_index3);

var _cTimer = __webpack_require__(100);

var _cTimer2 = _interopRequireDefault(_cTimer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 手机登录
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var cache = new _cCache2.default({
	prefix: 'pcuplive'
});

var bindType = 1;

var PhoneLogin = function (_Component) {
	_inherits(PhoneLogin, _Component);

	function PhoneLogin(props) {
		_classCallCheck(this, PhoneLogin);

		var _this = _possibleConstructorReturn(this, (PhoneLogin.__proto__ || Object.getPrototypeOf(PhoneLogin)).call(this, props));

		_this.getProfileForRegister = function (data) {
			var self = _this;
			_this.login(data);
		};

		_this.getProfileForNoRegister = function (data) {
			var self = _this;
			var registerPromise = _this.register(data);

			registerPromise.done(function (data) {
				self.isFetching = false;
				// 手机注册成功，真实用户  开启验证模式
				_cUpLoading2.default.hide();
				self.setState({
					userProcess: 'sendPhoneSuccess'
				});
				UP.Global.DA.add({
					eventName: 'phoneRegisterSuccess',
					action: 'show'
				});

				fbq('track', 'emailRegisterSuccess', { oauthtype: 'email' });

				cache.setCache('isRegisterRealUser', true);
				UP.Global.writeUserInfo(data);
				$.channel.emit('loginSuccess', data);
			});

			registerPromise.fail(function (dataWrap) {
				_cUpLoading2.default.hide();

				if (dataWrap.code == 4119) {
					_cNotification2.default.simple('device forbidden');
				} else if (dataWrap.code == 4099) {
					_cNotification2.default.simple(_lang2.default.template('验证码输入错误'));
				} else {
					_cNotification2.default.simple(_lang2.default.template('帐号或密码错误'));
				}
			});
		};

		_this.checkRegistered = function (data) {
			var promise = new _check2.default({
				bindType: bindType,
				thirdId: _this.state.areaCode + data.phone
			}).promise;

			return promise;
		};

		_this.register = function (data) {
			var phone = data.phone,
			    password = data.password,
			    smsCode = data.smsCode;

			var requestData = {
				bindType: bindType,
				mobilePhone: _this.state.areaCode + phone,
				password: (0, _md.hex_md5)(password)
			};
			if (smsCode) {
				requestData.smsCode = smsCode;
			}
			var promise = new _register2.default(requestData).promise;

			return promise;
		};

		_this.login = function (data) {
			var phone = data.phone,
			    password = data.password;

			var promise = new _login2.default({
				loginType: 2,
				bindType: 1,
				thirdId: _this.state.areaCode + phone,
				password: (0, _md.hex_md5)(password),
				pushType: 10
			}).promise;

			promise.done(function (data) {
				UP.Global.DA.add({
					eventName: 'phoneLoginSuccess',
					action: 'show'
				});
				// 授权成功，真实用户
				cache.setCache('isRegisterRealUser', true);

				$.channel.emit("loginSuccess", data);

				self.isFetching = false;
			});

			promise.fail(function (dataWrap) {

				if (dataWrap) {
					if (dataWrap.code == 4130) {
						_cNotification2.default.simple(_lang2.default.template('帐号或密码错误'));
					} else if (dataWrap.code == 4119) {
						_cNotification2.default.simple('device forbidden');
					}
				}
				_cUpLoading2.default.hide();
			});

			return promise;
		};

		_this.handleSubmit = function (e) {
			var phone = _this.refs.phone.value.trim();
			if (!_this.state.code) {
				_cNotification2.default.simple(_lang2.default.template('选择国家或地区'));
				_this.setState({
					showSelect: true
				});
				return;
			}
			var progress = _this.state.progress;
			switch (progress) {
				case 'inputPhone':
					if (_this.verifyPhoneNum()) {
						var registerData = {
							phone: phone
						};
						var isRegistered = _this.checkRegistered(registerData);
						isRegistered.done(function (registered) {
							if (registered) {
								//已注册  进入登录
								_this.setState({
									progress: 'inputPwd'
								});
							} else {
								// 未注册 进入注册
								if (_this.state.userProcess == 'login') {
									// notification.simple(lang.template('该手机号未被注册'));
									_cUpLoading2.default.hide();
									$.channel.emit('phoneRegister', {
										areaCode: _this.state.areaCode,
										inputValuePlusCode: _this.state.inputValuePlusCode,
										phone: _this.state.phone,
										progress: 'register',
										code: _this.state.code
									});
								} else {
									_this.getProfileForNoRegister(registerData);
								}
							}
						});
					}
					break;
				case 'inputPwd':
					if (_this.verifyPwd()) {

						var _password = _this.refs.password.value.trim();
						var _registerData = {
							phone: phone,
							password: _password
						};
						_this.getProfileForRegister(_registerData);
					}
					break;
				case 'register':
					if (_this.verifyPwd() && _this.verifySmsCode()) {

						var _password2 = _this.refs.password.value.trim();
						var _smsCode = _this.refs.smsCode.value.trim();
						var _registerData2 = {
							phone: phone,
							smsCode: _smsCode,
							password: _password2
						};
						_this.getProfileForNoRegister(_registerData2);
					}
					break;
				case 'findPwd':
					var password = _this.refs.password.value.trim();
					var smsCode = _this.refs.smsCode.value.trim();
					if (_this.verifyPwd() && _this.verifySmsCode()) {
						var _registerData3 = {
							phone: phone,
							smsCode: smsCode,
							password: password
						};
						_this.findPhoneLoginPwd(_registerData3);
					}
					break;
			}
		};

		_this.handleSelectCountry = function () {
			if (_this.state.showSelect) {
				return;
			}

			_this.setState({
				showSelect: true
			});
		};

		_this.sendCode = function (module) {
			var self = _this;
			if (_this.state.disVerifyCode) {
				return;
			}
			var phone = _this.refs.phone.value.trim();
			var promise = new _index2.default({
				mobilePhone: _this.state.areaCode + phone,
				module: 'register'
			}).promise;
			promise.done(function (data) {
				_cNotification2.default.simple(_lang2.default.template("验证码已发送"));
				var second = $('[data-second=second]');
				second.removeClass('hidden');
				self.setState({
					disVerifyCode: true
				});

				var timer = self.timer = new _cTimer2.default({
					remainTime: '60',
					isDoubleBit: true,
					selector: {
						second: '[data-second]'
					}
				});

				self.timer.on('end', function () {
					second.addClass('hidden');
					self.setState({
						disVerifyCode: false
					});
				});
			});
			promise.fail(function (data) {
				_cNotification2.default.simple(_lang2.default.template("验证码发送失败"));
			});
		};

		_this.forgetPwd = function () {

			_this.setState({
				progress: 'findPwd'
			}, function () {
				$.channel.emit('phoneFindPwd', {
					areaCode: _this.state.areaCode,
					inputValuePlusCode: _this.state.inputValuePlusCode,
					phone: _this.state.phone,
					progress: _this.state.progress,
					code: _this.state.code

				});
			});
		};

		var initState = {
			showSelect: true,
			userProcess: props.userProcess || 'login',
			phone: props.phone,
			progress: props.progress || 'inputPhone',
			disVerifyCode: false
		};
		var state = Object.assign(initState, props);
		_this.state = state;
		return _this;
	}

	_createClass(PhoneLogin, [{
		key: 'setInitState',
		value: function setInitState(state) {
			var _this2 = this;

			this.setState(state, function () {
				UP.Global.DA.add({
					eventName: 'phoneLoginProgerss_' + _this2.state.progress,
					action: 'show'
				});
			});
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this3 = this;

			if (this.state.progress == 'inputPhone' && this.props.userProcess == 'login') {
				UP.Global.DA.add({
					eventName: 'phoneLoginProgerss_' + this.state.progress,
					action: 'show'
				});
			}
			var self = this;
			var el = $(this.refs.areaCode);

			el.on({
				// mouseenter: function(e) {
				// 	// self.setState({
				// 	// 	showSelect: true
				// 	// });
				// },
				// mouseleave: function(e) {				
				// 	self.setState({
				// 		showSelect: false
				// 	});
				// },
				click: function click(e) {
					self.setState({
						showSelect: true
					});
				}
			});

			$(document.body).on('click', function (e) {
				var el = $(e.target);
				var showSelect = false;

				if ($('.country-list-wrap').find(el).length > 0 || $('.country-list-wrap').find(el).length > 0) {
					showSelect = true;
				}
				_this3.setState({
					showSelect: showSelect
				});
			});
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			$(document.body).off('click');
			this.timer && this.timer.destroy();
		}

		/*
      * 第三方账号是否已经绑定过UP直播
      */

	}, {
		key: 'findPhoneLoginPwd',
		value: function findPhoneLoginPwd(data) {
			var _this4 = this;

			var promise = new _index4.default({
				bindType: bindType,
				thirdId: this.state.areaCode + data.phone,
				verifyCode: data.smsCode,
				password: (0, _md.hex_md5)(data.password)
			}).promise;
			promise.done(function (data) {
				UP.Global.DA.add({
					eventName: 'phoneLoginProgerss_' + _this4.state.progress + 'Success',
					action: 'show'
				});
				_cNotification2.default.simple(_lang2.default.template('登录密码设置成功'));
				_this4.setState({
					progress: 'inputPwd'
				}, function () {
					$.channel.emit('phoneLogin', {
						areaCode: _this4.state.areaCode,
						inputValuePlusCode: _this4.state.inputValuePlusCode,
						phone: _this4.state.phone,
						progress: _this4.state.progress,
						code: _this4.state.code
					});
				});
			});
			promise.fail(function (data) {
				UP.Global.DA.add({
					eventName: 'phoneLoginProgerss_' + _this4.state.progress + 'fail',
					action: 'show'
				});
				if (data.code == 4099) {

					_cNotification2.default.simple(_lang2.default.template('验证码输入错误'));
				} else {
					_cNotification2.default.simple(_lang2.default.template('登录密码设置失败'));
				}
			});
		}
	}, {
		key: 'verifyPhoneNum',
		value: function verifyPhoneNum() {
			var phone = this.refs.phone.value.trim();

			if (phone == '') {
				_cNotification2.default.simple(_lang2.default.template('请输入手机号码'));
				return false;
			}
			this.setState({
				phone: phone
			});
			return true;
		}
	}, {
		key: 'verifyPwd',
		value: function verifyPwd() {

			var password = this.refs.password.value.trim();
			if (password == '') {
				_cNotification2.default.simple(_lang2.default.template('请输入登录密码'));
				return false;
			}
			return true;
		}
	}, {
		key: 'verifySmsCode',
		value: function verifySmsCode() {
			var smsCode = this.refs.smsCode.value.trim();
			if (smsCode.length != 6) {
				return false;
			}
			return true;
		}
	}, {
		key: 'onSelectOption',
		value: function onSelectOption(data) {
			if (!data.inputValuePlusCode) {
				data.inputValuePlusCode = _lang2.default.template('国家/地区');
			}
			this.setState(Object.assign({ showSelect: false }, data));
		}
	}, {
		key: 'render',
		value: function render() {
			var _this5 = this;

			var phoneInput = _react2.default.createElement(
				'div',
				{ className: 'login-form-item tel-item', ref: 'areaCode' },
				_react2.default.createElement(
					'div',
					{ className: 'input-wrap arrow', onClick: this.handleSelectCountry },
					_react2.default.createElement(
						'div',
						{ className: 'input' },
						this.state.inputValuePlusCode,
						'\u200E'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'input-wrap' },
					_react2.default.createElement('input', {
						className: 'input',
						ref: 'phone',
						type: 'text',
						placeholder: _lang2.default.template('请输入手机号码'),
						defaultValue: this.state.phone
					})
				),
				_react2.default.createElement(_countryView2.default, { visible: this.state.showSelect, selectOption: this.onSelectOption.bind(this), ref: 'countryView' })
			);
			if (this.state.progress != "inputPhone") {
				phoneInput = _react2.default.createElement(
					'div',
					{ className: 'login-form-item phone-show' },
					_react2.default.createElement(
						'em',
						{ className: 'tip' },
						_react2.default.createElement(
							'i',
							{ className: 'num' },
							_lang2.default.template('手机号:')
						)
					),
					_react2.default.createElement(
						'em',
						{ className: 'phoneNum' },
						this.state.inputValuePlusCode,
						' ',
						this.state.phone
					),
					_react2.default.createElement('input', {
						className: 'input hidden',
						ref: 'phone',
						type: 'text',
						placeholder: _lang2.default.template('请输入手机号码'),
						defaultValue: this.state.phone
					})
				);
			}

			var pwdInput = _react2.default.createElement(
				'div',
				{ className: 'login-form-item' },
				_react2.default.createElement(
					'div',
					{ className: 'input-wrap input-split-wrap' },
					_react2.default.createElement('input', {
						className: 'input input-short',
						ref: 'password',
						type: 'password',
						placeholder: _lang2.default.template('请输入登录密码'),
						defaultValue: ''
					}),
					_react2.default.createElement(
						'div',
						{ className: 'sub-btn', onClick: this.forgetPwd },
						_lang2.default.template('忘记密码')
					)
				)
			);
			if (this.state.progress == 'findPwd' || this.state.progress == 'register') {
				pwdInput = _react2.default.createElement(
					'div',
					{ className: 'login-form-item' },
					_react2.default.createElement(
						'div',
						{ className: 'input-wrap' },
						_react2.default.createElement('input', {
							className: 'input',
							ref: 'password',
							type: 'password',
							placeholder: _lang2.default.template('请输入登录密码'),
							defaultValue: ''
						})
					)
				);
			}
			var VerifyCodeText = void 0;

			if (this.state.disVerifyCode) {
				VerifyCodeText = "s";
			} else {
				VerifyCodeText = _lang2.default.template('发送验证码');
			}

			var smsCodeInput = _react2.default.createElement(
				'div',
				{ className: 'login-form-item' },
				_react2.default.createElement(
					'div',
					{ className: 'input-wrap input-split-wrap' },
					_react2.default.createElement('input', {
						className: 'input smsCode',
						ref: 'smsCode',
						type: 'smsCode',
						placeholder: _lang2.default.template('输入验证码')
					}),
					this.state.progress == 'findPwd' ? _react2.default.createElement(
						'div',
						{ className: 'sub-btn ' + (this.state.disVerifyCode ? 'sending' : ''), onClick: function onClick() {
								_this5.sendCode('findPassword');
							} },
						_react2.default.createElement('em', { 'data-second': 'second' }),
						VerifyCodeText
					) : _react2.default.createElement(
						'div',
						{ className: 'sub-btn ' + (this.state.disVerifyCode ? 'sending' : ''), onClick: function onClick() {
								_this5.sendCode('register');
							} },
						_react2.default.createElement('em', { 'data-second': 'second' }),
						VerifyCodeText
					)
				)
			);
			var _state = this.state,
			    userProcess = _state.userProcess,
			    progress = _state.progress;


			switch (progress) {
				case 'inputPhone':
					return _react2.default.createElement(
						'div',
						{ className: 'phone-login' },
						_react2.default.createElement(
							'div',
							{ className: 'input-box' },
							phoneInput
						),
						_react2.default.createElement(
							'div',
							{ className: 'phone-login-btn', onClick: this.handleSubmit },
							_lang2.default.template('确定')
						)
					);

					break;
				case 'inputPwd':
					return _react2.default.createElement(
						'div',
						{ className: 'phone-login' },
						_react2.default.createElement(
							'div',
							{ className: 'input-box' },
							phoneInput,
							pwdInput
						),
						_react2.default.createElement(
							'div',
							{ className: 'phone-login-btn', onClick: this.handleSubmit },
							_lang2.default.template('确定')
						)
					);
					break;
				case 'register':
					return _react2.default.createElement(
						'div',
						{ className: 'phone-login' },
						_react2.default.createElement(
							'div',
							{ className: 'input-box' },
							phoneInput,
							smsCodeInput,
							pwdInput
						),
						_react2.default.createElement(
							'div',
							{ className: 'phone-login-btn', onClick: this.handleSubmit },
							_lang2.default.template('确定')
						)
					);

					break;
				case 'findPwd':
					return _react2.default.createElement(
						'div',
						{ className: 'phone-login' },
						_react2.default.createElement(
							'div',
							{ className: 'input-box' },
							phoneInput,
							smsCodeInput,
							pwdInput
						),
						_react2.default.createElement(
							'div',
							{ className: 'phone-login-btn', onClick: this.handleSubmit },
							_lang2.default.template('确定')
						)
					);
					break;

			}

			return _react2.default.createElement(
				'div',
				{ className: 'phone-login' },
				_react2.default.createElement(
					'div',
					{ className: 'phone-login-btn', onClick: this.handleSubmit },
					_lang2.default.template('登录')
				)
			);
		}
	}]);

	return PhoneLogin;
}(_react.Component);

PhoneLogin.defaultProps = {
	phone: ''
};
exports.default = PhoneLogin;

/***/ }),
/* 205 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "UserBalanceInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "inBill",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "outDiamond",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "bill",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "diamond",
            "id": 4
        }]
    }, {
        "name": "ProfileInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "setting",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "password",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "userToken",
            "id": 8
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "location",
            "id": 11
        }, {
            "rule": "optional",
            "type": "string",
            "name": "mobilePhone",
            "id": 12
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "fanTotal",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followTotal",
            "id": 14
        }, {
            "rule": "optional",
            "type": "UserBalanceInfo",
            "name": "balance",
            "id": 15
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "chatroomid",
            "id": 16
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followType",
            "id": 17
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "exp",
            "id": 18
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "currentExp",
            "id": 19
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "nextExp",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 21
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 22
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "qualityAuth",
            "id": 23
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 25
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "admin",
            "id": 26
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "userRealNameAuth",
            "id": 27
        }, {
            "rule": "optional",
            "type": "string",
            "name": "acceptAgreement",
            "id": 28
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "upliveCodeStatus",
            "id": 29
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "subscribe",
            "id": 30
        }, {
            "rule": "repeated",
            "type": "Source",
            "name": "sources",
            "id": 31
        }]
    }, {
        "name": "Source",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "bindType",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "openId",
            "id": 2
        }]
    }, {
        "name": "ThirdCheck",
        "fields": [],
        "messages": [{
            "name": "Register",
            "fields": [],
            "options": {
                "objc_class_prefix": "ThirdCheckRegister",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "BindType",
                    "name": "bindType",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "thirdId",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "thirdToken",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "extension",
                    "id": 4
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "gender",
                    "id": 5
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "mobilePhone",
                    "id": 6
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "username",
                    "id": 7
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "signature",
                    "id": 8
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "avatar",
                    "id": 9
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "location",
                    "id": 10
                }, {
                    "rule": "optional",
                    "type": "PushType",
                    "name": "pushType",
                    "id": 11
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "pushToken",
                    "id": 12
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "deviceId",
                    "id": 13
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "smsCode",
                    "id": 14
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "countryCode",
                    "id": 16
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "password",
                    "id": 17
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "bind",
                    "id": 18
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "ProfileInfo",
                    "name": "profile",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "exmailCheckCode",
                    "id": 2
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "BindType",
        "values": [{
            "name": "DEFAULT_TYPE",
            "id": 0
        }, {
            "name": "MOBILE_PHONE",
            "id": 1
        }, {
            "name": "QQ",
            "id": 2
        }, {
            "name": "WEIXIN",
            "id": 3
        }, {
            "name": "FACEBOOK",
            "id": 4
        }, {
            "name": "SINA_WEIBO",
            "id": 5
        }, {
            "name": "RR",
            "id": 6
        }, {
            "name": "TENCENT_WANBA",
            "id": 7
        }, {
            "name": "KECHENGGEZI",
            "id": 8
        }, {
            "name": "DEVICE",
            "id": 9
        }, {
            "name": "GOOGLE",
            "id": 15
        }, {
            "name": "TWITTER",
            "id": 16
        }, {
            "name": "EMAIL",
            "id": 17
        }]
    }, {
        "name": "PushType",
        "values": [{
            "name": "DEFAULT_PUSHTYPE",
            "id": 0
        }, {
            "name": "BAIDU",
            "id": 1
        }, {
            "name": "IOS",
            "id": 2
        }, {
            "name": "JPUSH",
            "id": 3
        }, {
            "name": "XIAOMI",
            "id": 4
        }, {
            "name": "GETUI",
            "id": 5
        }, {
            "name": "GOOGLE_PUSH",
            "id": 6
        }, {
            "name": "SAMSUNG",
            "id": 7
        }, {
            "name": "MEIZU",
            "id": 8
        }, {
            "name": "HUAWEI",
            "id": 9
        }, {
            "name": "GOOGLE_FCM",
            "id": 10
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cUpLoading = __webpack_require__(13);

var _cUpLoading2 = _interopRequireDefault(_cUpLoading);

var _cNotification = __webpack_require__(11);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _number = __webpack_require__(44);

var _number2 = _interopRequireDefault(_number);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _login = __webpack_require__(86);

var _login2 = _interopRequireDefault(_login);

var _md = __webpack_require__(68);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _countryView = __webpack_require__(87);

var _countryView2 = _interopRequireDefault(_countryView);

var _check = __webpack_require__(88);

var _check2 = _interopRequireDefault(_check);

var _register = __webpack_require__(89);

var _register2 = _interopRequireDefault(_register);

var _findpwd = __webpack_require__(416);

var _findpwd2 = _interopRequireDefault(_findpwd);

var _emailverifycheck = __webpack_require__(418);

var _emailverifycheck2 = _interopRequireDefault(_emailverifycheck);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 手机登录
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var cache = new _cCache2.default({
    prefix: 'pcuplive'
});
var bindType = 17;

var EmailLogin = function (_Component) {
    _inherits(EmailLogin, _Component);

    function EmailLogin(props) {
        _classCallCheck(this, EmailLogin);

        var _this = _possibleConstructorReturn(this, (EmailLogin.__proto__ || Object.getPrototypeOf(EmailLogin)).call(this, props));

        _this.getProfileForRegister = function (data) {
            var self = _this;
            var registerPromise = _this.register(data);

            registerPromise.done(function (data) {

                self.isFetching = false;
                // 授权成功，真实用户
                cache.setCache('isRegisterRealUser', true);

                UP.Global.writeUserInfo(data);

                _cUpLoading2.default.hide();

                UP.Global.DA.add({
                    eventName: 'loginSuccess',
                    action: 'show'
                });

                UP.Global.DA.add({
                    eventName: 'emailLoginSuccess',
                    action: 'click'
                });

                fbq('track', 'LoginSuccess', { oauthtype: 'email' });

                // location.reload();

                $.channel.emit("loginSuccess", data);
            });

            registerPromise.fail(function (dataWrap) {
                _cUpLoading2.default.hide();

                self.isFetching = false;
                if (dataWrap.code == 4119) {
                    _cNotification2.default.simple('device forbidden');
                } else {
                    _cNotification2.default.simple(_lang2.default.template('帐号或密码错误'));
                }
            });
        };

        _this.getProfileForNoRegister = function (data) {
            var self = _this;
            var registerData = data;
            var registerPromise = _this.register(data);
            var isResend = _this.state.isResend;

            registerPromise.done(function (data) {

                self.isFetching = false;
                // 邮箱注册成功，真实用户  开启验证模式
                _cUpLoading2.default.hide();

                if (isResend) {
                    _cNotification2.default.simple(_lang2.default.template('验证邮件已重新发送'));
                    return;
                }
                UP.Global.DA.add({
                    eventName: 'emailRegisterSendCode',
                    action: 'show'
                });

                fbq('track', 'emailRegisterSendCode', { oauthtype: 'email' });

                $.channel.emit('emailSendSuccessTip', {
                    email: registerData.email,
                    progress: 'registerEmailSendSuccess',
                    password: registerData.password,
                    emailCheckCode: data.exmailCheckCode

                });
            });

            registerPromise.fail(function (dataWrap) {
                _cUpLoading2.default.hide();
                self.isFetching = false;
                if (dataWrap.code == 4119) {
                    _cNotification2.default.simple('device forbidden');
                } else if (dataWrap.code == 4106) {
                    _cNotification2.default.simple(_lang2.default.template('邮箱注册，不在白名单'));
                } else if (dataWrap.code == 4131) {

                    _cNotification2.default.simple(_lang2.default.template('邮箱验证次数超过每天限制'));
                } else {
                    _cNotification2.default.simple(_lang2.default.template('帐号或密码错误'));
                }
            });
        };

        _this.handleSubmit = function (e) {
            if (_this.isFetching) {
                return;
            }
            var progress = _this.state.progress;
            _this.submitLogin(progress);
            // if (this.verify()) {
            // 	this.isFetching = true;		
            // 	loading.show({
            // 		content: lang.template('正在登录')
            // 	});

            // }
        };

        _this.checkRegistered = function (data) {
            var promise = new _check2.default({
                bindType: bindType,
                thirdId: data.email
            }).promise;

            return promise;
        };

        _this.register = function (data) {
            var email = data.email,
                password = data.password;

            var promise = new _register2.default({
                bindType: bindType,
                thirdId: email,
                password: (0, _md.hex_md5)(password)
            }).promise;

            return promise;
        };

        _this.login = function (uid, password) {
            var promise = new _login2.default({
                loginType: 2,
                bindType: bindType,
                uid: uid,
                password: password
            }).promise;

            return promise;
        };

        _this.goLogin = function (e) {
            if (_this.state.progress == 'emailSendSuccess') {
                //找回密码
                $.channel.emit('emailLogin', { progress: 'inputPwd', email: _this.state.email });

                return;
            }
            //注册成功
            var promise = new _emailverifycheck2.default({
                emailCheckCode: _this.state.emailCheckCode
            }).promise;
            promise.done(function (data) {
                $.channel.emit('emailLogin', { progress: 'inputPwd', email: _this.state.email });
            });
            promise.fail(function (data) {
                if (data.code == 4133) {
                    _cNotification2.default.simple(_lang2.default.template('邮箱未验证'));
                } else {
                    _cNotification2.default.simple(_lang2.default.template('邮箱验证失败，请重试'));
                }
            });
        };

        _this.goResendMail = function (moudle) {
            if (_this.isResended) {
                _cNotification2.default.simple(_lang2.default.template('不能频繁发送邮件'));
                return;
            }
            _this.isResended = true;
            _this.timer && clearTimeout(_this.timer);
            _this.timer = setTimeout(function () {
                _this.isResended = false;
            }, 60000);
            var progress = 'findpwd';
            if (moudle == 'registerSendMail') {
                progress = 'register';
            }
            _this.setState({
                isResend: true
            }, function () {
                _this.submitLogin(progress);
            });
        };

        _this.forgetPwd = function (e) {
            var email = _this.refs.email.value.trim();
            $.channel.emit('emailFindPwd', {
                email: email,
                progress: 'findpwd'
            });
        };

        var initState = {
            showSelect: true,
            userProcess: props.userProcess || 'login',
            email: props.email,
            progress: props.progress || 'inputEmail',
            isResend: false
        };
        var state = Object.assign(initState, props);
        _this.state = state;
        return _this;
    }

    _createClass(EmailLogin, [{
        key: 'setInitState',
        value: function setInitState(state) {
            var _this2 = this;

            this.setState(state, function () {
                UP.Global.DA.add({
                    eventName: 'emailLoginProgerss_' + _this2.state.progress,
                    action: 'show'
                });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.state.progress == 'inputEmail' && this.props.userProcess == 'login') {
                UP.Global.DA.add({
                    eventName: 'phoneLoginProgerss_' + this.state.progress,
                    action: 'show'
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            $(document.body).off('click');
            this.timer && clearTimeout(this.timer);
        }
    }, {
        key: 'submitLogin',
        value: function submitLogin(progress) {
            var _this3 = this;

            var self = this;
            var email = this.refs.email.value.trim();
            var isResend = this.state.isResend;
            // let progress = this.state.progress;
            var registerData = {
                email: email
            };
            var isRegistered = void 0,
                password = void 0;
            switch (progress) {
                case 'inputEmail':
                    if (!this.verifyEmail()) {
                        return;
                    }

                    isRegistered = this.checkRegistered(registerData);
                    isRegistered.done(function (registered) {
                        if (registered) {
                            $.channel.emit('emailLogin', {
                                email: registerData.email,
                                progress: 'inputPwd'
                            });
                            // this.getProfileForRegister(registerData);
                        } else {
                            // 去注册
                            $.channel.emit('emailRegister', {
                                email: registerData.email,
                                progress: 'register'
                            });
                        }
                    });
                    break;
                case 'inputPwd':
                    if (!this.verify()) {
                        return;
                    }
                    password = this.refs.password.value.trim();
                    registerData = {
                        email: email,
                        password: password
                    };
                    isRegistered = this.checkRegistered(registerData);
                    isRegistered.done(function (registered) {
                        if (registered) {

                            _this3.getProfileForRegister(registerData);
                        } else {
                            // 去注册
                            $.channel.emit('emailRegister', {
                                email: registerData.email,
                                progress: 'register'
                            });
                        }
                    });
                    break;
                case 'findpwd':
                    if (!this.verifyEmail()) {
                        return;
                    }

                    isRegistered = this.checkRegistered(registerData);
                    isRegistered.done(function (registered) {
                        if (registered) {
                            var findPromise = new _findpwd2.default({
                                bindType: bindType,
                                thirdId: email
                            }).promise;
                            findPromise.done(function (data) {
                                UP.Global.DA.add({
                                    eventName: 'emailLoginProgerss_' + _this3.state.progress + 'SendEmailSuccess',
                                    action: 'show'
                                });
                                if (isResend) {

                                    _cNotification2.default.simple(_lang2.default.template('验证邮件已重新发送'));
                                } else {
                                    $.channel.emit('emailSendSuccessTip', {
                                        email: email,
                                        progress: 'emailSendSuccess'
                                    });
                                }
                            });
                            findPromise.fail(function (data) {
                                UP.Global.DA.add({
                                    eventName: 'emailLoginProgerss_' + _this3.state.progress + 'SendEmailFail',
                                    action: 'show'
                                });
                                if (data && data.code == '2024') {
                                    _cNotification2.default.simple(_lang2.default.template('邮箱未注册'));
                                } else if (data && data.code == 4119) {
                                    _cNotification2.default.simple('device forbidden');
                                } else if (data && data.code == 4106) {
                                    _cNotification2.default.simple(_lang2.default.template('邮箱注册，不在白名单'));
                                } else if (data && data.code == 4131) {
                                    _cNotification2.default.simple(_lang2.default.template('邮箱验证次数超过每天限制'));
                                } else {
                                    _cNotification2.default.simple(_lang2.default.template('系统错误'));
                                }
                            });
                        } else {
                            // 去注册
                            $.channel.emit('emailRegister', {
                                email: registerData.email,
                                progress: 'register'
                            });
                        }
                    });
                    break;
                case 'register':
                case 'registerEmailSendSuccess':
                    if (!this.verify()) {
                        return;
                    }
                    password = this.refs.password.value.trim();

                    registerData = {
                        email: email,
                        password: password
                    };
                    isRegistered = this.checkRegistered(registerData);
                    isRegistered.done(function (registered) {
                        if (registered) {

                            _this3.getProfileForRegister(registerData);
                        } else {

                            _cUpLoading2.default.show({
                                content: _lang2.default.template('正在注册')
                            });
                            _this3.getProfileForNoRegister(registerData);
                        }
                    });

                    break;
            }
            isRegistered.fail(function () {
                alert('dd');
            });
        }
        /*
            * 第三方账号是否已经绑定过UP直播
            */

    }, {
        key: 'verify',
        value: function verify() {
            if (this.verifyEmail() && this.verifyPwd()) {
                return true;
            }
            return false;
        }
    }, {
        key: 'verifyEmail',
        value: function verifyEmail() {
            var email = this.refs.email.value.trim();
            var reg = /[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;

            if (email == '') {
                _cNotification2.default.simple(_lang2.default.template('请输入邮箱'));
                return false;
            } else if (!reg.test(email)) {
                _cNotification2.default.simple(_lang2.default.template('邮箱格式错误'));
                return;
            }

            return true;
        }
    }, {
        key: 'verifyPwd',
        value: function verifyPwd() {
            var password = this.refs.password.value.trim();
            if (password == '') {
                _cNotification2.default.simple(_lang2.default.template('请输入登录密码'));
                return false;
            }
            return true;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var userProcess = this.state.userProcess;
            var progress = this.state.progress;

            var $inputEmailDom = _react2.default.createElement(
                'div',
                { className: 'login-form-item' },
                _react2.default.createElement(
                    'div',
                    { className: 'input-wrap' },
                    _react2.default.createElement('input', {
                        className: 'input',
                        ref: 'email',
                        type: 'text',
                        placeholder: _lang2.default.template('请输入邮箱'), defaultValue: this.state.email
                    })
                )
            );
            var $inputPwdDom = _react2.default.createElement(
                'div',
                { className: 'login-form-item' },
                _react2.default.createElement(
                    'div',
                    { className: 'input-wrap input-split-wrap' },
                    _react2.default.createElement('input', {
                        className: 'input',
                        ref: 'password',
                        type: 'password',
                        placeholder: _lang2.default.template('请输入登录密码'),
                        defaultValue: this.state.password
                    }),
                    progress == 'findpwd' || progress == 'register' ? null : _react2.default.createElement(
                        'div',
                        { className: 'sub-btn', onClick: this.forgetPwd.bind(this) },
                        _lang2.default.template('忘记密码')
                    )
                )
            );

            switch (progress) {
                case 'inputEmail':
                    return _react2.default.createElement(
                        'div',
                        { className: 'email-login' },
                        _react2.default.createElement(
                            'div',
                            { className: 'input-box' },
                            $inputEmailDom
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'phone-login-btn', onClick: this.handleSubmit.bind(this) },
                            _lang2.default.template('确定')
                        )
                    );
                    break;
                case 'inputPwd':
                    return _react2.default.createElement(
                        'div',
                        { className: 'email-login' },
                        _react2.default.createElement(
                            'div',
                            { className: 'input-box' },
                            $inputEmailDom,
                            $inputPwdDom
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'phone-login-btn', onClick: this.handleSubmit.bind(this) },
                            _lang2.default.template('确定')
                        )
                    );
                    break;
                case 'findpwd':
                    return _react2.default.createElement(
                        'div',
                        { className: 'email-login' },
                        _react2.default.createElement(
                            'div',
                            { className: 'input-box' },
                            $inputEmailDom
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'phone-login-btn', onClick: this.handleSubmit.bind(this) },
                            _lang2.default.template('确定')
                        )
                    );
                    break;
                case 'register':
                    return _react2.default.createElement(
                        'div',
                        { className: 'email-login' },
                        _react2.default.createElement(
                            'div',
                            { className: 'input-box' },
                            $inputEmailDom,
                            $inputPwdDom
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'phone-login-btn', onClick: this.handleSubmit.bind(this) },
                            _lang2.default.template('确定')
                        )
                    );
                    break;
                case 'emailSendSuccess':
                    return _react2.default.createElement(
                        'div',
                        { className: 'email-login' },
                        _react2.default.createElement(
                            'div',
                            { className: 'input-box' },
                            _react2.default.createElement('div', { className: 'email-icon' }),
                            _react2.default.createElement(
                                'div',
                                { className: 'email-tip' },
                                _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: _lang2.default.template('验证邮件已发送至<i><%=email%></i>请去邮箱确认', { email: this.state.email }) } }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'hidden' },
                                    $inputEmailDom
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'e-not-reveive' },
                                _react2.default.createElement(
                                    'em',
                                    null,
                                    _lang2.default.template('未收到邮件')
                                ),
                                _react2.default.createElement('em', { className: 'resend' }),
                                _react2.default.createElement(
                                    'em',
                                    { onClick: function onClick() {
                                            return _this4.goResendMail('findpwd');
                                        }, className: 'goresend' },
                                    _lang2.default.template('重新发送')
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'phone-login-btn', onClick: this.goLogin.bind(this) },
                            _lang2.default.template('确认')
                        )
                    );
                    break;

                case 'registerEmailSendSuccess':
                    return _react2.default.createElement(
                        'div',
                        { className: 'email-login' },
                        _react2.default.createElement(
                            'div',
                            { className: 'input-box' },
                            _react2.default.createElement('div', { className: 'email-icon' }),
                            _react2.default.createElement(
                                'div',
                                { className: 'email-tip' },
                                _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: _lang2.default.template('验证邮件已发送至<i><%=email%></i>请去邮箱确认', { email: this.state.email }) } }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'hidden' },
                                    $inputEmailDom,
                                    $inputPwdDom
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'e-not-reveive' },
                                _react2.default.createElement(
                                    'em',
                                    null,
                                    _lang2.default.template('未收到邮件')
                                ),
                                _react2.default.createElement('em', { className: 'resend' }),
                                _react2.default.createElement(
                                    'em',
                                    { onClick: function onClick() {
                                            return _this4.goResendMail('registerSendMail');
                                        }, className: 'goresend' },
                                    _lang2.default.template('重新发送')
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'phone-login-btn', onClick: this.goLogin.bind(this) },
                            _lang2.default.template('已验证，确认登录')
                        )
                    );
                    break;
            }

            return _react2.default.createElement(
                'div',
                { className: 'email-login' },
                _react2.default.createElement('div', { className: 'input-box' }),
                _react2.default.createElement(
                    'div',
                    { className: 'phone-login-btn', onClick: this.handleSubmit.bind(this) },
                    _lang2.default.template('确定')
                )
            );
        }
    }]);

    return EmailLogin;
}(_react.Component);

EmailLogin.defaultProps = {
    userProcess: 'login',
    email: '',
    progress: 'inputEmail'
};
exports.default = EmailLogin;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _cUpPbajax = __webpack_require__(46);

var _cUpPbajax2 = _interopRequireDefault(_cUpPbajax);

var _cNotification = __webpack_require__(11);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _cUpLoading = __webpack_require__(13);

var _cUpLoading2 = _interopRequireDefault(_cUpLoading);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _cIm = __webpack_require__(436);

var _cIm2 = _interopRequireDefault(_cIm);

var _index = __webpack_require__(455);

var _userUi = __webpack_require__(22);

var _confirm = __webpack_require__(73);

var _confirm2 = _interopRequireDefault(_confirm);

var _index2 = __webpack_require__(75);

var _index3 = _interopRequireDefault(_index2);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var App = function (_Component) {
    _inherits(App, _Component);

    function App(props) {
        _classCallCheck(this, App);

        var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

        _this.gethashChange = function () {
            window.scroll(0, 0);
        };

        _this.onKeyDown = function (e) {
            var text = $(_this.refs.text).val();

            if (text == '') {
                // 内容空
                switch (e.keyCode) {
                    case 8: // 'Backspace' key
                    case 27: // 'Escape' key
                    case 46: // 'Delete' key
                    case 9: // 'Tab' key
                    case 13: // Enter key
                    case 37: // 'Arrow left' key
                    case 38: // 'Arrow up' key
                    case 39: // 'Arrow right' key
                    case 40:
                        // 'Arrow down' key
                        e.preventDefault();
                        e.stopPropagation();
                        break;
                }

                return;

                _cNotification2.default.simple('发送空消息主播感受不到你的爱哒…');
            }

            if (e.shiftKey && e.which == 13) {//按ctrl+enter换行

            } else if ((e.keyCode || e.which) == 13 && !e.shiftKey) {
                // 按Enter
                e.preventDefault();
                // 当前被强制下线
                if (_this.im.forcedOffline == 1) {
                    _this.forcedOffline();
                    return;
                }
                if (_this.verifyFriendValid(_this.state.activeFriend.oid)) {
                    _this.sendChat();
                } else {
                    _this.doFriendApply();
                }
            }
        };

        _this.goMomoRecharge = function (e) {
            window.open('https://h5.upliveapp.com/ipay/index.html?env=&channel=codapay&lang=vi-VN&upcode=' + UP.Global.getUser().upliveCode);
        };

        _this.state = {
            fullScreen: 0,
            friends: [], // 好友列表
            friendApplyList: [], // 好友请求列表
            conversations: [], // 会话列表
            selected: props.defaultSelected,
            activedChatUid: props.activedChatUid,
            activeFriend: {}, // 当前会话的好友
            activeSessionContent: [], // 当前会话的会话内容
            activeFriendValid: 0, // 与当前用户是否为相互关注的好友
            applyNotice: 0,
            sessionNotice: {},
            showApplyConfirm: 0,
            showOfflineConfirm: 0
        };
        var userToken = UP.Global.getUserToken();
        var sid = UP.Global.getUserId();
        var countryCode = UP.Global.getUser().countryCode; // 当前用户的国家码
        _this.countryCode = countryCode;

        _this.pbajax = new _cUpPbajax2.default();
        _this.friendList = new _cIm.FriendList(userToken);
        _this.session = new _cIm.Sessions(userToken);
        // im
        var im = _this.im = new _cIm2.default({
            userToken: userToken,
            sid: sid,
            termType: 3
        });
        // 好友申请
        _this.friendApply = new _cIm.FriendApply({
            im: im,
            uid: sid,
            userToken: userToken
        });

        _this.cache = new _cCache2.default({
            prefix: 'im/uplive/' + sid
        });

        var cacheSessionContent = _this.cache.getCache('imdata') || {};

        $.map(cacheSessionContent, function (sessionContent, uid) {
            for (var i = sessionContent.length; i--;) {
                var item = sessionContent[i];

                if (!item.isSelf) {
                    continue;
                }

                if (item.submiting == 1) {
                    item.submiting = -1;
                }
            }
        });

        _this.cacheSessionContent = cacheSessionContent;
        return _this;
    }

    _createClass(App, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getFriendList();
            this.bindImMessage();
            this.getSessions();
            this.friendApply.init();
            this.updateApplyList();
            this.setState({
                sessionNotice: this.cache.getCache('noticedata') || {}
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            // 监听好友请求
            // 1. 当前视窗为好友申请列表的话，更新列表
            // 2. 当前视窗为非好友申请列表话，添加红点数字类型
            $.channel.on('onNewFriendApply', function (data) {
                _this2.handleNewFriendApply(data);
            });

            // 成为好友。A在手机操作；A在WEB需要重新渲染UI 
            $.channel.on('onFriendValid', function (uid) {
                _this2.updateApplyList();
                _this2.addFriendById(uid);
            });

            // 取消好友
            $.channel.on('onFriendInvalid', function (uid) {
                _this2.deleteFriendById(uid);
            });

            $.channel.on('talkTo', function (userinfo) {
                _this2.talkToNewFriend(userinfo);
            });

            $(document.body).on('click', function (e) {
                //监听路由改变
                var el = $(e.target);
                var fullScreen = 0;

                if ($('#J-IMChat').find(el).length > 0 || $('.J_PreviewPic').find(el).length > 0) {
                    fullScreen = 1;
                }

                _this2.setState({
                    fullScreen: fullScreen
                });
                //支付页面呼叫客服
                // setTimeout(this.getServer,500)

            });

            if ('onhashchange' in window && (typeof document.documentMode === 'undefined' || document.documentMode == 8)) {
                window.onhashchange = this.gethashChange;
            } else {
                setInterval(function () {
                    var ischanged = isHashChanged();
                    if (ischanged) {
                        this.gethashChange; // TODO，对应新的hash执行的操作函数
                    }
                }, 150);
            }

            $.channel.on('showChat', function () {
                _this2.toggleChatFullScreen(1);
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            $.channel.off('onNewFriendApply');
            $.channel.off('onFriendValid');
            $.channel.off('onFriendInvalid');
            $.channel.off('talkTo');
            $.channel.off('showChat');
        }
    }, {
        key: 'handleNewFriendApply',
        value: function handleNewFriendApply(data) {
            var applyNotice = data.newCount;
            var friendApplyList = data.applyList;

            this.setState({
                friendApplyList: friendApplyList
            });

            if (this.state.fullScreen == 1) {
                // 好友申请非actived，显示红点提示
                if (this.state.selected !== 'apply') {
                    this.setState({
                        applyNotice: applyNotice
                    });
                }
            } else {
                this.setState({
                    applyNotice: applyNotice
                });
            }
        }
    }, {
        key: 'getSessions',
        value: function getSessions() {
            var _this3 = this;

            this.session.getData().done(function (data) {
                var sessionNotice = _this3.state.sessionNotice;
                var conversations = [];

                data.conversations.forEach(function (item, index) {
                    if (!sessionNotice[item.oid]) {
                        sessionNotice[item.oid] = 0;
                    }
                    if (item.type == 7) {
                        conversations[conversations.length] = item;
                    }
                });

                _this3.cacheNoticeData(sessionNotice);

                _this3.setState({
                    conversations: conversations,
                    sessionNotice: sessionNotice
                });
            });
        }
    }, {
        key: 'cacheIMData',
        value: function cacheIMData() {
            this.cache.setCache('imdata', this.cacheSessionContent, +new Date() + 24 * 60 * 60 * 1000);
        }
    }, {
        key: 'cacheNoticeData',
        value: function cacheNoticeData(data) {
            this.cache.setCache('noticedata', data, +new Date() + 24 * 60 * 60 * 1000);
        }
    }, {
        key: 'getFriendList',
        value: function getFriendList() {
            var _this4 = this;

            this.friendList.getData().done(function (data) {

                _this4.setState({
                    friends: data.infos
                });
            });
        }
    }, {
        key: 'getFriendById',
        value: function getFriendById(uid) {
            return this.friendList.getFriendById(uid);
        }
    }, {
        key: 'bindImMessage',
        value: function bindImMessage() {
            var _this5 = this;

            var im = this.im;
            var closeCount = 0;

            im.on('arrivedServer', function (msgid, msgVersion) {
                // 服务器端收到用户发送的请求
                var _state = _this5.state,
                    activeFriend = _state.activeFriend,
                    activeSessionContent = _state.activeSessionContent;


                $.map(_this5.cacheSessionContent, function (sessionContent, uid) {
                    for (var i = sessionContent.length; i--;) {
                        var item = sessionContent[i];

                        if (!item.isSelf) {
                            continue;
                        }

                        if (item.msgid == msgid) {
                            item.msgVersion = msgVersion;
                            item.submiting = 0;
                            break;
                        }
                    }
                });

                _this5.cacheIMData();

                activeSessionContent = _this5.getSessionContent(activeFriend.oid);

                _this5.setState({
                    activeSessionContent: activeSessionContent
                });
            });

            im.on('forcedOffline', function () {
                _this5.forcedOffline();
            });

            // 断线重连
            im.on('close', function (cfg) {
                console.log('socket closed');

                if (im.forcedOffline == 1) {
                    return;
                }
                // 异常状态导致连接断开，发起重连操作
                if (closeCount >= 5) {
                    im.reinit();
                    closeCount = 0;
                    return;
                }
                setTimeout(function () {
                    im.reconnect();
                    closeCount++;
                }, 1500);
            });

            im.on('message', function (data) {

                if (data.sId == 10004 || data.sId == 10001) {
                    return;
                }

                var _state2 = _this5.state,
                    activeFriend = _state2.activeFriend,
                    sessionNotice = _state2.sessionNotice,
                    fullScreen = _state2.fullScreen,
                    activeSessionContent = _state2.activeSessionContent,
                    selected = _state2.selected;


                var msgType = (0, _cIm.getMsgType)(data);
                var friendInfo = _this5.getFriendById(data.sId);

                if (data.sId == 10005) {
                    friendInfo = {
                        oid: 10005,
                        avatar: '//g.cdn.pengpengla.com/oauthgame/html5/20181102/b337ac6311d5b3d03d32838f4253354f.png',
                        username: '官方客服'
                    };
                }

                if (msgType == 'friendText') {
                    _this5.addSessionContent(data.sId, {
                        isSelf: 0,
                        oid: friendInfo.oid,
                        content: data.body.content,
                        avatar: friendInfo.avatar,
                        username: friendInfo.username,
                        msgVersion: data.msgVersion,
                        msgid: data.msgid,
                        msgType: msgType
                    });
                } else if (msgType == 'friendPic') {
                    _this5.addSessionContent(data.sId, {
                        isSelf: 0,
                        oid: friendInfo.oid,
                        origUrl: data.body.origUrl,
                        avatar: friendInfo.avatar,
                        username: friendInfo.username,
                        msgid: data.msgid,
                        msgVersion: data.msgVersion,
                        msgType: msgType
                    });
                }

                if (msgType == 'friendText' || msgType == 'friendPic') {

                    if (typeof sessionNotice[data.sId] == 'undefined') {
                        sessionNotice[data.sId] = 0;
                    }

                    ++sessionNotice[data.sId];

                    // mini，接收新消息，展示红点。全屏，红点消失
                    if (fullScreen == 1 && selected == 'msg' && activeFriend.oid) {
                        sessionNotice[activeFriend.oid] = 0;
                    }

                    _this5.cacheNoticeData(sessionNotice);

                    _this5.addConversation(friendInfo);
                }

                activeSessionContent = _this5.getSessionContent(activeFriend.oid);

                _this5.setState({
                    activeSessionContent: activeSessionContent,
                    sessionNotice: sessionNotice
                });
            });

            im.on('resendMessageFail', function (msgid) {
                var _state3 = _this5.state,
                    activeFriend = _state3.activeFriend,
                    activeSessionContent = _state3.activeSessionContent;


                $.map(_this5.cacheSessionContent, function (sessionContent, uid) {
                    for (var i = sessionContent.length; i--;) {
                        var item = sessionContent[i];

                        if (!item.isSelf) {
                            continue;
                        }

                        if (item.msgid == msgid) {
                            item.submiting = -1;
                            break;
                        }
                    }
                });

                _this5.cacheIMData();

                activeSessionContent = _this5.getSessionContent(activeFriend.oid);

                _this5.setState({
                    activeSessionContent: activeSessionContent
                });
            });
        }
    }, {
        key: 'forcedOffline',
        value: function forcedOffline() {
            this.setState({
                showOfflineConfirm: 1
            }, function () {
                if (this.state.fullScreen == 1) {
                    this.refs.offlineConfirm.showModal();
                }
            });
        }
    }, {
        key: 'reconnect',
        value: function reconnect() {
            this.im.forcedOffline = 0;
            this.im.reconnect();
        }
    }, {
        key: 'hideOfflineConfirm',
        value: function hideOfflineConfirm() {
            this.setState({
                showOfflineConfirm: 0
            });
        }
    }, {
        key: 'addSessionContent',
        value: function addSessionContent(uid, item) {
            if (!this.cacheSessionContent[uid]) {
                this.cacheSessionContent[uid] = [];
            }

            this.cacheSessionContent[uid].push(item);
            this.cacheIMData();
        }
    }, {
        key: 'updateSessionContent',
        value: function updateSessionContent(uid, list) {
            if (!this.cacheSessionContent[uid]) {
                this.cacheSessionContent[uid] = [];
            }

            this.cacheSessionContent[uid] = list;
            this.cacheIMData();
        }
    }, {
        key: 'getSessionContent',
        value: function getSessionContent(uid) {
            return this.cacheSessionContent[uid] || [];
        }
    }, {
        key: 'doFriendApply',
        value: function doFriendApply() {
            _cNotification2.default.simple(_lang2.default.template('加个好友吧。聊嗨了才能拉近你们的距离哦！'));
        }

        // 验证当前用户是否是我的好友

    }, {
        key: 'verifyFriendValid',
        value: function verifyFriendValid(uid) {
            if (uid == 10005) {
                return 1;
            } else {
                var friendInfo = this.getFriendById(uid);
                return friendInfo.uid ? 1 : 0;
            }
        }

        // 发送消息

    }, {
        key: 'sendChat',
        value: function sendChat() {
            var text = $(this.refs.text).val();
            var activeSessionContent = this.state.activeSessionContent;
            var activedChatUid = this.state.activeFriend.oid;
            var user = UP.Global.getUser();
            var msg = void 0;

            if (activedChatUid == 10005) {
                msg = this.im.sendCustomServiceText(text);
            } else {
                msg = this.im.sendFriendText(activedChatUid, text);
            }

            text = _index3.default.filter(text);

            $(this.refs.text).val('');

            activeSessionContent.push({
                isSelf: 1,
                oid: user.uid,
                username: '我',
                avatar: user.avatar,
                content: text,
                msgType: 'friendText',
                submiting: 1, // 数据上传中
                msgid: msg.msgid
            });

            this.updateSessionContent(activedChatUid, activeSessionContent);

            this.setState({
                activeSessionContent: activeSessionContent
            });

            UP.Global.DA.add({
                eventName: 'SendIMUserChat',
                action: 'click'
            });
        }
    }, {
        key: 'talkTo',
        value: function talkTo(activeFriend) {
            var oid = activeFriend.oid;
            var activeSessionContent = this.getSessionContent(oid) || [];
            var activeFriendValid = this.verifyFriendValid(oid);
            var sessionNotice = this.state.sessionNotice;

            sessionNotice[oid] = 0;
            this.cacheNoticeData(sessionNotice);

            this.setState({
                activeSessionContent: activeSessionContent,
                activeFriend: activeFriend,
                activeFriendValid: activeFriendValid,
                sessionNotice: sessionNotice
            });
        }

        // 跟一个好友聊天

    }, {
        key: 'talkToNewFriend',
        value: function talkToNewFriend(friend) {
            var oid = _typeof(friend.uid) == 'object' ? Number(longToString(friend.uid)) : friend.uid;
            var activeSessionContent = this.getSessionContent(oid) || [];
            var activeFriendValid = this.verifyFriendValid(oid);
            var sessionNotice = this.state.sessionNotice;

            var activeFriend = {
                type: 7,
                avatar: friend.avatar,
                name: friend.username,
                oid: oid
            };

            sessionNotice[oid] = 0;
            this.cacheNoticeData(sessionNotice);

            this.addConversation(friend);

            this.setState({
                activeFriend: activeFriend,
                activeSessionContent: activeSessionContent,
                activeFriendValid: activeFriendValid,
                sessionNotice: sessionNotice,
                selected: 'msg',
                fullScreen: 1
            });
        }
    }, {
        key: 'addConversation',
        value: function addConversation(friend) {
            var oid = _typeof(friend.uid) == 'object' ? Number(longToString(friend.uid)) : friend.uid;
            var friendValid = this.verifyFriendValid(oid);
            var conversations = this.state.conversations;

            var activeFriend = {
                type: 7,
                avatar: friend.avatar,
                name: friend.username,
                oid: oid
            };

            if (friendValid) {
                // 已经是好友
                // 若会话列表中没有，则添加会话列表记录
                var include = 0;

                for (var i = conversations.length; i--;) {
                    var item = conversations[i];

                    if (item.oid == oid) {
                        include = 1;
                        break;
                    }
                }

                if (!include) {
                    conversations[conversations.length] = activeFriend;
                }
            }

            this.setState({
                conversations: conversations
            });
        }
    }, {
        key: 'onSwitchTab',
        value: function onSwitchTab(selected) {

            this.setState({
                selected: selected
            });

            if (selected == 'apply') {
                this.friendApply.clearUnhandledApplyCount();
                this.setState({
                    applyNotice: 0
                });
            }
        }
    }, {
        key: 'onFollowFriend',
        value: function onFollowFriend(uid) {
            var _this6 = this;

            _cUpLoading2.default.show();

            this.friendApply.follow({
                uid: uid
            }, function () {
                _cUpLoading2.default.hide();
                // 同意好友申请
                _this6.updateApplyList();
            });
        }
    }, {
        key: 'applyFriend',
        value: function applyFriend(friendInfo) {

            this.setState({
                showApplyConfirm: 1
            }, function () {
                this.refs.applyConfirm.showModal();
            });
        }
    }, {
        key: 'hideApplyConfirm',
        value: function hideApplyConfirm() {
            this.setState({
                showApplyConfirm: 0
            });
        }
    }, {
        key: 'sendApplyFriend',
        value: function sendApplyFriend(content) {
            var _this7 = this;

            var uid = this.state.activeFriend.oid;

            _cUpLoading2.default.show();
            // TODO 二次确认框
            this.friendApply.follow({
                uid: uid,
                content: content,
                addFriend: true
            }, function () {
                _cUpLoading2.default.hide();
                _cNotification2.default.simple(_lang2.default.template('申请发送成功'));
                // 同意好友申请
                _this7.updateApplyList();
            });
        }
    }, {
        key: 'updateApplyList',
        value: function updateApplyList() {
            var friendApplyList = this.friendApply.getApplyList();

            this.setState({
                friendApplyList: friendApplyList
            });
        }
    }, {
        key: 'deleteFriendById',
        value: function deleteFriendById(uid) {
            this.friendList.deleteFriendById(uid);

            var friends = this.friendList.getFriendList();
            var _state4 = this.state,
                activeFriend = _state4.activeFriend,
                activeFriendValid = _state4.activeFriendValid;


            if (uid == activeFriend.oid) {
                activeFriendValid = 0;
            }

            this.setState({
                friends: friends,
                activeFriendValid: activeFriendValid
            });
        }
    }, {
        key: 'addFriendById',
        value: function addFriendById(uid) {
            var _this8 = this;

            this.friendList.addFriendById(uid).done(function () {
                var friends = _this8.friendList.getFriendList();
                var _state5 = _this8.state,
                    activeFriend = _state5.activeFriend,
                    activeFriendValid = _state5.activeFriendValid;


                if (uid == activeFriend.oid) {
                    activeFriendValid = 1;
                }

                _this8.setState({
                    friends: friends,
                    activeFriendValid: activeFriendValid
                });
            });
        }
    }, {
        key: 'resendMessage',
        value: function resendMessage(data) {
            if (this.im.forcedOffline == 1) {
                this.forcedOffline();
                return;
            }

            var activeSessionContent = this.state.activeSessionContent;
            var activedChatUid = this.state.activeFriend.oid;
            var msg = this.im.sendFriendText(activedChatUid, data.content);

            data.submiting = 1;

            this.updateSessionContent(activedChatUid, activeSessionContent);

            this.setState({
                activeSessionContent: activeSessionContent
            });
        }
    }, {
        key: 'toggleChatFullScreen',
        value: function toggleChatFullScreen(value) {
            var _state6 = this.state,
                sessionNotice = _state6.sessionNotice,
                activeFriend = _state6.activeFriend;


            if (value == 1) {
                this.cacheIMData();

                if (activeFriend.oid) {
                    sessionNotice[activeFriend.oid] = 0;
                    this.cacheNoticeData(sessionNotice);
                }

                UP.Global.DA.add({
                    eventName: 'ShowIM',
                    action: 'click'
                });
            }

            this.setState({
                fullScreen: value
            }, function () {
                // 全屏
                if (value == 1) {
                    this.refs.offlineConfirm && this.refs.offlineConfirm.showModal();
                }
            });
        }
    }, {
        key: 'onClickChatMsgAvatar',
        value: function onClickChatMsgAvatar(uid) {}
    }, {
        key: 'renderConversationContent',
        value: function renderConversationContent() {
            var _state7 = this.state,
                activeSessionContent = _state7.activeSessionContent,
                activeFriend = _state7.activeFriend,
                activeFriendValid = _state7.activeFriendValid;

            var $userInfo = void 0;

            var $guideToAddFriend = _react2.default.createElement(
                'div',
                { className: 'apply-tip' },
                _react2.default.createElement(
                    'div',
                    { className: 'box' },
                    _react2.default.createElement(
                        'div',
                        { className: 'msg' },
                        _lang2.default.template('加个好友吧，聊嗨了才能拉近你们的距离哦！')
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'adding', onClick: this.applyFriend.bind(this) },
                        _lang2.default.template('添加好友')
                    )
                )
            );

            return _react2.default.createElement(
                'div',
                { className: 'chat-content' },
                _react2.default.createElement(
                    'div',
                    { className: 'chat-content-hd' },
                    _react2.default.createElement(
                        'div',
                        { className: 'userinfo' },
                        activeFriend.oid == 10005 ? _react2.default.createElement(_index.OfficeItemView, { item: activeFriend }) : _react2.default.createElement(_index.UserChatItemView, { item: activeFriend })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'chat-content-bd' },
                    activeFriendValid == 0 ? $guideToAddFriend : null,
                    _react2.default.createElement(
                        'div',
                        { className: 'scroll-wrapper', ref: 'JContentWrap' },
                        _react2.default.createElement(_index.ChatMsgListView, { list: activeSessionContent, resendMessage: this.resendMessage.bind(this) })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'chat-content-ft' },
                    _react2.default.createElement(
                        'div',
                        { className: 'chat-send' },
                        _react2.default.createElement('textarea', { ref: 'text', onKeyDown: this.onKeyDown.bind(this), placeholder: _lang2.default.template('按下Enter发送内容') })
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this9 = this;

            var _state8 = this.state,
                fullScreen = _state8.fullScreen,
                activeFriend = _state8.activeFriend,
                conversations = _state8.conversations,
                sessionNotice = _state8.sessionNotice,
                applyNotice = _state8.applyNotice,
                activeFriendValid = _state8.activeFriendValid;


            var noticeNum = 0;

            $.each(sessionNotice, function (key, value) {
                noticeNum = noticeNum + value;
            });

            if (fullScreen == 0) {
                var sumNum = noticeNum + applyNotice;
                return _react2.default.createElement(
                    'div',
                    { className: this.props.name == 'take' ? "chat-mini-wrap chat-kefu" : "chat-mini-wrap chat-bottom-fixed", id: 'J-IMChat', onClick: this.toggleChatFullScreen.bind(this, 1) },
                    sumNum > 0 ? _react2.default.createElement(
                        'i',
                        { className: 'notice-num' },
                        sumNum > 99 ? '99+' : sumNum
                    ) : null
                );
            } else {

                var $navs = this.props.navs.map(function (item, inx) {

                    var selectedCls = item.option == _this9.state.selected ? ' selected' : '';
                    var $badge = void 0;

                    switch (item.option) {
                        case 'msg':
                            if (noticeNum > 99) {
                                $badge = _react2.default.createElement(
                                    'i',
                                    { className: 'notice-num' },
                                    '99+'
                                );
                            } else if (noticeNum > 0 && noticeNum <= 99) {
                                $badge = _react2.default.createElement(
                                    'i',
                                    { className: 'notice-num' },
                                    noticeNum
                                );
                            }
                            break;
                        case 'apply':
                            if (applyNotice > 99) {
                                $badge = _react2.default.createElement(
                                    'i',
                                    { className: 'notice-num' },
                                    '99+'
                                );
                            } else if (applyNotice > 0 && applyNotice <= 99) {
                                $badge = _react2.default.createElement(
                                    'i',
                                    { className: 'notice-num' },
                                    applyNotice
                                );
                            }
                            break;
                    }

                    return _react2.default.createElement(
                        'div',
                        {
                            key: item.option,
                            className: 'chat-nav nav-' + item.option + selectedCls,
                            onClick: _this9.onSwitchTab.bind(_this9, item.option)
                        },
                        _react2.default.createElement(
                            'h2',
                            { className: 'title' },
                            $badge
                        )
                    );
                });

                var $main = this.props.navs.map(function (item, inx) {

                    var selectedCls = item.option == _this9.state.selected ? ' selected' : '';

                    switch (item.option) {
                        case 'msg':
                            var $content = void 0;

                            if (activeFriend.oid) {
                                $content = _react2.default.createElement(
                                    'div',
                                    { className: 'chat-content' },
                                    _this9.renderConversationContent()
                                );
                            } else {
                                $content = _react2.default.createElement(
                                    'div',
                                    { className: 'chat-content' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'mini-tip' },
                                        _lang2.default.template('您还未选中或发起聊天，快去跟好友聊一聊吧')
                                    )
                                );
                            }

                            return _react2.default.createElement(
                                'div',
                                { className: 'panel' + selectedCls, key: inx },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'chat-side' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'scroll-wrapper' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'scroller' },
                                            _react2.default.createElement(_index.ConversationListView, {
                                                selectedItem: activeFriend,
                                                list: conversations,
                                                talkTo: _this9.talkTo.bind(_this9),
                                                sessionNotice: sessionNotice
                                            })
                                        )
                                    )
                                ),
                                $content
                            );
                            break;
                        case 'friend':
                            return _react2.default.createElement(
                                'div',
                                { className: 'panel' + selectedCls, key: inx },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'scroll-wrapper' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'scroller' },
                                        _react2.default.createElement(_index.FriendListView, { list: _this9.state.friends, talkTo: _this9.talkToNewFriend.bind(_this9) })
                                    )
                                )
                            );
                            break;
                        case 'apply':
                            return _react2.default.createElement(
                                'div',
                                { className: 'panel' + selectedCls, key: inx },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'scroll-wrapper' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'scroller' },
                                        _react2.default.createElement(_index.FriendApplyListView, { list: _this9.state.friendApplyList, onFollowFriend: _this9.onFollowFriend.bind(_this9) })
                                    )
                                )
                            );
                            break;
                    }
                });

                return _react2.default.createElement(
                    'div',
                    { className: 'chat-wrap chat-bottom-fixed', id: 'J-IMChat' },
                    _react2.default.createElement('i', { className: 'close', onClick: this.toggleChatFullScreen.bind(this, 0) }),
                    _react2.default.createElement(
                        'div',
                        { className: 'chat-navs' },
                        $navs
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'chat-main' },
                        $main
                    ),
                    this.state.showApplyConfirm == 1 ? _react2.default.createElement(_index.ApplyConfirm, {
                        ref: 'applyConfirm',
                        onConfirm: this.sendApplyFriend.bind(this),
                        onHide: this.hideApplyConfirm.bind(this),
                        myusername: UP.Global.getUser().username,
                        friendusername: activeFriend.name
                    }) : null,
                    this.state.showOfflineConfirm == 1 ? _react2.default.createElement(_index.OfflineConfirm, {
                        ref: 'offlineConfirm',
                        onConfirm: this.reconnect.bind(this),
                        onHide: this.hideOfflineConfirm.bind(this)
                    }) : null
                );
            }
        }
    }]);

    return App;
}(_react.Component);

App.defaultProps = {
    navs: [{
        option: 'msg'
    }, {
        option: 'friend'
    }, {
        option: 'apply'
    }],
    defaultSelected: 'msg'
};
exports.default = App;

/***/ }),
/* 208 */
/***/ (function(module, exports) {



Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * 配置各种消息类型
 * @author zhenn
 * @createTime 2017-11-24
 */

var sendTypes = {
    // 单聊，发普通文本消息给用户
    sendFriendText: function sendFriendText(rId, text) {
        var msg = this.send({
            type: 7,
            mType: 256,
            mFormat: 0,
            rId: rId,
            body: {
                content: text
            }
        });

        return msg;
    },


    // 给官方客服发文本消息
    sendCustomServiceText: function sendCustomServiceText(text) {
        var msg = this.send({
            type: 9, // 上行是9，下行是10（好变态的设计）
            mType: 256,
            mFormat: 0,
            rId: 10005,
            body: {
                content: text
            }
        });

        return msg;
    },


    // 上行ack消息
    // 告知服务器消息已收到
    sendUpReadNotice: function sendUpReadNotice(data) {
        var mType = void 0;
        // 如果是离线消息，mtype从下行的中离线消息中获取对应mType
        if (data.type == 12) {
            mType = data.mType;
        } else if (data.type == 11) {
            // 如果收到的是系统广播消息
            mType = 3;
        } else {
            // 普通用户消息
            mType = 2;
        }
        var msg = this.send({
            type: 5,
            mType: mType,
            mFormat: 0,
            msgVersion: data.msgVersion
        });

        return msg;
    },


    // 拉取离线消息(不含群离线/广播离线消息/最近消息)
    // 每次建立连接并且成功注册后，立即调用一次
    pullOfflineMsg: function pullOfflineMsg() {
        var msg = this.send({
            type: 12,
            mType: 81,
            mFormat: 0
        });

        return msg;
    }
};

// 获得上行/下行消息的类型
var getMsgType = function getMsgType(msg) {

    var type = msg.type;
    var mType = msg.mType;
    var mFormat = msg.mFormat;
    var result = void 0;

    switch (type) {
        // 注册
        case 1:
            result = 'register';
            break;
        // 单聊
        case 7:
        // 上行客服消息
        case 9:
        // 下行客服消息/系统消息
        case 10:
            // 普通消息
            if (mType == 256) {
                switch (mFormat) {
                    // 文本消息
                    case 0:
                        result = 'friendText';
                        break;
                    case 1:
                        result = 'gotoText';
                        break;
                    // 图片消息
                    case 2:
                        result = 'friendPic';
                        break;
                    // 气泡
                    case 7:
                        result = 'bubble';
                        break;
                    // 好友在聊天窗内赠送礼物的消息
                    case 8:
                        result = 'friendChatWindowGift';
                        break;
                    // 非好友通过小视频外部场景赠送的礼物消息，在礼物小助手特定账号下展示
                    case 9:
                        result = 'nonFriendGift';
                        break;
                    // 好友在非聊天窗内赠送礼物的消息，比如外部小视频打赏
                    case 10:
                        result = 'friendNotChatWindowGift';
                        break;
                    case 13:
                        result = 'nonFriendUGGift'; // 非好友赠送的UG礼物
                        break;
                    case 14:
                        result = 'friendUGGift'; // 好友赠送的UG礼物
                        break;
                    default:
                        break;
                }
            } else if (mType == 257) {
                // 申请添加好友
                result = 'friendApply';
            } else if (mType == 258) {
                // 成为好友
                result = 'friendValid';
            } else if (mType == 259) {
                // 解除好友关系
                result = 'friendInvalid';
            }
            break;
        // ACK消息
        case 5:
            result = 'ack';
            break;
        // 服务器通知
        case 6:
            // 被强制下线，需要弹出窗口让用户重新连接
            if (mType == 32) {
                result = 'forcedOffline';
            }
            break;
        default:
            break;
    }

    return result;
};

// format值对应的content.pb中的编解码方法
var formatMaps = {
    '0': 'MsgText', // 普通文本
    '1': 'MsgGotoText', // 跳转文本（系统通知，比如活动配置之类）
    '2': 'MsgPic', // 图片消息
    '3': 'MsgGotoPic', // 图片跳转类型（系统通知，应用场景也是活动，和msgGotoText区别仅仅是UI展现不同）
    '7': 'MsgBubble', // 分享气泡(比如分享给好友直播间地址)
    '8': 'MsgGift', // 好友聊天窗内赠送礼物
    '9': 'MsgGiftReward', // 9和10公用同一个消息体，区别是UI展示不同；9：非好友通过小视频外部场景赠送的礼物消息，在礼物小助手特定账号下展示
    '10': 'MsgGiftReward', // 10：好友通过小视频等外部场景赠送礼物的消息，展示在与该好友的对话框
    '11': 'MsgFeedVideo', // feed视频消息
    '12': 'MsgFeedTopic', // feed话题消息
    '13': 'MsgGiftReward', //通用礼物_系统通知消息，非好友发送UG打赏礼物，对应 body 为：IMMsgContent.MsgGiftReward
    '14': 'MsgGiftReward' };

exports.sendTypes = sendTypes;
exports.formatMaps = formatMaps;
exports.getMsgType = getMsgType;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cUpPbajax = __webpack_require__(46);

var _cUpPbajax2 = _interopRequireDefault(_cUpPbajax);

var _cPublicpb = __webpack_require__(69);

var _cPublicpb2 = _interopRequireDefault(_cPublicpb);

var _index = __webpack_require__(449);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pbajax = new _cUpPbajax2.default();

var Profile = function () {
    function Profile(vuid, userToken) {
        _classCallCheck(this, Profile);

        // debugger;
        this.userToken = userToken;
        this.promise = this.getData({
            vuid: vuid
        });
    }

    _createClass(Profile, [{
        key: 'getData',
        value: function getData(data) {
            var self = this;
            var businessData = new _index2.default.Profile.Get.Request(data);
            var defer = $.Deferred();

            pbajax.do({
                service: 'service',
                api: '/profile/get',
                header: {
                    userToken: this.userToken
                }
            }, businessData, function (res) {

                var dataWrap = _cPublicpb2.default.Result.decode(res);
                var data = void 0;

                if (dataWrap.code == 1) {
                    data = _index2.default.Profile.Get.Response.decode(dataWrap.data.value);
                    defer.resolve(data.profile);
                }
            }, function () {
                defer.reject();
            }, function () {
                defer.reject();
            });

            return defer.promise();
        }
    }]);

    return Profile;
}();

exports.default = Profile;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(486);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(38) && !__webpack_require__(72)(function () {
  return Object.defineProperty(__webpack_require__(212)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(53);
var document = __webpack_require__(36).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(43);
var toIObject = __webpack_require__(54);
var arrayIndexOf = __webpack_require__(488)(false);
var IE_PROTO = __webpack_require__(141)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(215);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 215 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(93);
var $export = __webpack_require__(51);
var redefine = __webpack_require__(218);
var hide = __webpack_require__(52);
var Iterators = __webpack_require__(147);
var $iterCreate = __webpack_require__(495);
var setToStringTag = __webpack_require__(149);
var getPrototypeOf = __webpack_require__(498);
var ITERATOR = __webpack_require__(55)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(52);


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(213);
var hiddenKeys = __webpack_require__(143).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(95);
var createDesc = __webpack_require__(91);
var toIObject = __webpack_require__(54);
var toPrimitive = __webpack_require__(138);
var has = __webpack_require__(43);
var IE8_DOM_DEFINE = __webpack_require__(211);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(38) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);


function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback, option);
}

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignPopupClassName;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(530), __esModule: true };

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', props);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(props.children);
  };

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 228 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var channels = {
    'alipay': {
        option: 'alipay',
        tradeType: 'WAP',
        open: true
    },
    'wxpay': {
        option: 'wxpay',
        tradeType: 'NATIVE',
        open: true
    },
    'paypal': {
        option: 'paypal',
        tradeType: 'WAP',
        open: true
    },
    'onecard': {
        option: 'onecard',
        tradeType: 'WAP',
        open: true
    },
    'bj_mycard': {
        option: 'bj_mycard',
        tradeType: 'WAP',
        open: true
    },
    bk_card: {
        open: true,
        text: 'bk_card',
        option: 'bk_card'
    },
    bk_atm: {
        open: true,
        text: 'bk_atm',
        option: 'bk_atm'
    },
    'vip': { // 中东VIP
        text: 'Vodafone cash',
        option: 'vip',
        open: true
    },
    'vipcz': { // 台湾＋国内VIP
        text: 'vipcz',
        option: 'vipcz',
        open: true
    },
    'sinopac_atm': {
        text: 'sinopac_atm',
        option: 'sinopac_atm',
        open: true
    },
    'xenopay': {
        text: 'XenoPay',
        option: 'xenopay',
        open: false
    },
    'codapay': {
        text: 'codapay',
        option: 'codapay',
        open: true
    },
    // 泰国cashcard
    pepay_entitycard_thb: {
        text: 'CashCard(THB)',
        option: 'pepay_entitycard_thb',
        open: true
    },
    zalo: {
        open: false,
        option: 'zalo'
    },
    momo: {
        open: true,
        option: 'momo'
    },
    danalpay: {
        open: true,
        option: 'danalpay',
        text: 'danalpay'
    },
    //  新增的两种印度充值方式: molpay_points; paytm
    molpay_points: {
        open: true,
        text: 'molpay_points',
        option: 'molpay_points'
    },
    paytm: {
        open: true,
        text: 'paytm',
        option: 'paytm'
    },
    // VN的充值方式
    pepay_onlinebank_vnd: {
        open: true,
        text: 'pepay_onlinebank_vnd',
        option: 'pepay_onlinebank_vnd'
    },
    pepay_entitycard_vnd: {
        open: true,
        text: 'pepay_onlinebank_vnd',
        option: 'pepay_entitycard_vnd'
    },
    //印尼充值方式
    pepay_alfamart_idr: {
        open: true,
        text: 'Alfamart',
        option: 'pepay_alfamart_idr'
    },
    pepay_webatm_idr: {
        open: true,
        text: 'Bank Atm',
        option: 'pepay_webatm_idr'
    },
    codapay_id: {
        open: true,
        text: 'Direct Carrier Billing',
        option: 'codapay_1'
    },
    codapay_1: {
        open: true,
        text: 'Direct Carrier Billing',
        option: 'codapay_1'
    },
    codapay_220: {
        open: true,
        text: 'ATM Transfer',
        option: 'codapay_220'
    },
    codapay_221: {
        open: true,
        text: 'Alfamart',
        option: 'codapay_221'
    },
    codapay_223: {
        open: true,
        text: 'Doku Wallet',
        option: 'codapay_223'
    },
    codapay_224: {
        open: true,
        text: '7-Eleven',
        option: 'codapay_224'
    },
    codapay_226: {
        open: true,
        text: 'Indomaret',
        option: 'codapay_226'
    },
    codapay_227: {
        open: true,
        text: 'GO-PAY',
        option: 'codapay_227'
    },
    //菲律宾充值方式
    codapay_ph: {
        open: true,
        text: 'Bank Payments',
        option: 'codapay_250'
    },
    codapay_250: {
        open: true,
        text: 'Bank Payments',
        option: 'codapay_250'
    },
    codapay_251: {
        open: true,
        text: 'Counter Payments',
        option: 'codapay_251'
    },
    codapay_252: {
        open: true,
        text: 'GCash',
        option: 'codapay_252'
    },
    codapay_253: {
        open: true,
        text: '7-Eleven PH',
        option: 'codapay_253'
    },
    icard: {
        open: true,
        text: 'iCard',
        option: 'icard'
    },
    kakaopay: {
        open: true,
        text: 'Kakao pay',
        option: 'kakaopay'
    },
    pepay: {
        open: true,
        text: 'pepay',
        option: 'pepay'
    },
    gash: {
        open: true,
        text: 'GASH',
        option: 'gash'
    },
    gash_card: {
        open: true,
        text: 'GASH Card',
        option: 'gash_card'
    },
    // 印度
    codapay_390: {
        open: true,
        text: 'Paytm Wallet',
        option: 'codapay_390'
    },
    codapay_391: {
        open: true,
        text: 'Bank Transfer',
        option: 'codapay_391'
    },
    pepay_credit: {
        name: 'pepay_credit',
        text: 'pepay_credit',
        option: 'pepay_credit',
        open: true
    },

    pepay_store: {
        text: 'pepay_store',
        option: 'pepay_store',
        open: true
    },

    pepay_store_ibon_twd: {
        text: 'ibon便利生活站',
        option: 'pepay_store_ibon_twd',
        open: true
    },
    pepay_store_fami_twd: {
        text: '全家FAMIPORT',
        option: 'pepay_store_fami_twd',
        open: true
    },
    pepay_store_hilifeet_twd: {
        text: '萊爾富Life-ET',
        option: 'pepay_store_hilifeet_twd',
        open: true
    },
    pepay_store_okgo_twd: {
        text: 'OK超商OK-go',
        option: 'pepay_store_okgo_twd',
        open: true
    },

    dokypay: {
        text: 'DokyPay',
        option: 'dokypay',
        open: true
    }
};

exports.default = channels;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // import React, {Component} from 'react';


var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _validate = __webpack_require__(551);

var _validate2 = _interopRequireDefault(_validate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pbajax = new _pbajax2.default();

var PayResult = function () {
    function PayResult(orderId, receipt) {
        _classCallCheck(this, PayResult);

        this.paramCache = {
            orderId: orderId + '',
            receipt: receipt
        };
        this.promise = this.getData(this.paramCache);
    }

    _createClass(PayResult, [{
        key: 'retry',
        value: function retry() {
            this.promise = this.getData(this.paramCache);
        }
    }, {
        key: 'getData',
        value: function getData(data) {
            var self = this;
            var receipt = data.receipt;
            var _validatepb$Mall$PayV = _validate2.default.Mall.PayValidate,
                Request = _validatepb$Mall$PayV.Request,
                Response = _validatepb$Mall$PayV.Response;

            var businessData = new Request(data);
            var defer = $.Deferred();
            var userToken = UP.Global.getUserToken();

            pbajax.do({
                service: 'mall',
                api: '/mall/pay/validate',
                header: {
                    userToken: userToken
                }
            }, businessData, function (res) {

                var dataWrap = _public2.default.Result.decode(res);
                var data = void 0;

                if (dataWrap.code == 1) {
                    data = Response.decode(dataWrap.data.value);
                    defer.resolve(data);
                } else {
                    defer.reject(dataWrap.code);
                }
            }, function () {
                defer.reject();
            }, function () {
                defer.reject();
            });

            return defer.promise();
        }
    }]);

    return PayResult;
}();

exports.default = PayResult;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "de152389c2ee4d9ccfda5f512a2211c4.jpg";

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "50ab8c2e363518578b400d07a61d03b2.png";

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "99d64f853be6eea14b10afb01c96fa72.png";

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d83f9bdfc10ad79207362d53489bc7ee.png";

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5490f4843b50e1b9adec88738b9cde4f.png";

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b744c4ef9869bc04aa62409b1a161592.png";

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5b90e84bdc5e03720f82824e495d1aa2.png";

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "93f3556f0a9312c5f93436bd053b5390.png";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b2a06a40bb824fa7a2c8690f19fcab9d.png";

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "012c89bfdfaa5091bebb1979b3f6eb11.png";

/***/ }),
/* 240 */
/***/ (function(module, exports) {

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */

(function (window, document) {
  'use strict';

  // Exits early if all IntersectionObserver and IntersectionObserverEntry
  // features are natively supported.

  if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
        get: function get() {
          return this.intersectionRatio > 0;
        }
      });
    }
    return;
  }

  /**
   * An IntersectionObserver registry. This registry exists to hold a strong
   * reference to IntersectionObserver instances currently observing a target
   * element. Without this registry, instances without another reference may be
   * garbage collected.
   */
  var registry = [];

  /**
   * Creates the global IntersectionObserverEntry constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
   * @param {Object} entry A dictionary of instance properties.
   * @constructor
   */
  function IntersectionObserverEntry(entry) {
    this.time = entry.time;
    this.target = entry.target;
    this.rootBounds = entry.rootBounds;
    this.boundingClientRect = entry.boundingClientRect;
    this.intersectionRect = entry.intersectionRect || getEmptyRect();
    this.isIntersecting = !!entry.intersectionRect;

    // Calculates the intersection ratio.
    var targetRect = this.boundingClientRect;
    var targetArea = targetRect.width * targetRect.height;
    var intersectionRect = this.intersectionRect;
    var intersectionArea = intersectionRect.width * intersectionRect.height;

    // Sets intersection ratio.
    if (targetArea) {
      // Round the intersection ratio to avoid floating point math issues:
      // https://github.com/w3c/IntersectionObserver/issues/324
      this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
    } else {
      // If area is zero and is intersecting, sets to 1, otherwise to 0
      this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
  }

  /**
   * Creates the global IntersectionObserver constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
   * @param {Function} callback The function to be invoked after intersection
   *     changes have queued. The function is not invoked if the queue has
   *     been emptied by calling the `takeRecords` method.
   * @param {Object=} opt_options Optional configuration options.
   * @constructor
   */
  function IntersectionObserver(callback, opt_options) {

    var options = opt_options || {};

    if (typeof callback != 'function') {
      throw new Error('callback must be a function');
    }

    if (options.root && options.root.nodeType != 1) {
      throw new Error('root must be an Element');
    }

    // Binds and throttles `this._checkForIntersections`.
    this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

    // Private properties.
    this._callback = callback;
    this._observationTargets = [];
    this._queuedEntries = [];
    this._rootMarginValues = this._parseRootMargin(options.rootMargin);

    // Public properties.
    this.thresholds = this._initThresholds(options.threshold);
    this.root = options.root || null;
    this.rootMargin = this._rootMarginValues.map(function (margin) {
      return margin.value + margin.unit;
    }).join(' ');
  }

  /**
   * The minimum interval within which the document will be checked for
   * intersection changes.
   */
  IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;

  /**
   * The frequency in which the polyfill polls for intersection changes.
   * this can be updated on a per instance basis and must be set prior to
   * calling `observe` on the first target.
   */
  IntersectionObserver.prototype.POLL_INTERVAL = null;

  /**
   * Use a mutation observer on the root element
   * to detect intersection changes.
   */
  IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;

  /**
   * Starts observing a target element for intersection changes based on
   * the thresholds values.
   * @param {Element} target The DOM element to observe.
   */
  IntersectionObserver.prototype.observe = function (target) {
    var isTargetAlreadyObserved = this._observationTargets.some(function (item) {
      return item.element == target;
    });

    if (isTargetAlreadyObserved) {
      return;
    }

    if (!(target && target.nodeType == 1)) {
      throw new Error('target must be an Element');
    }

    this._registerInstance();
    this._observationTargets.push({ element: target, entry: null });
    this._monitorIntersections();
    this._checkForIntersections();
  };

  /**
   * Stops observing a target element for intersection changes.
   * @param {Element} target The DOM element to observe.
   */
  IntersectionObserver.prototype.unobserve = function (target) {
    this._observationTargets = this._observationTargets.filter(function (item) {

      return item.element != target;
    });
    if (!this._observationTargets.length) {
      this._unmonitorIntersections();
      this._unregisterInstance();
    }
  };

  /**
   * Stops observing all target elements for intersection changes.
   */
  IntersectionObserver.prototype.disconnect = function () {
    this._observationTargets = [];
    this._unmonitorIntersections();
    this._unregisterInstance();
  };

  /**
   * Returns any queue entries that have not yet been reported to the
   * callback and clears the queue. This can be used in conjunction with the
   * callback to obtain the absolute most up-to-date intersection information.
   * @return {Array} The currently queued entries.
   */
  IntersectionObserver.prototype.takeRecords = function () {
    var records = this._queuedEntries.slice();
    this._queuedEntries = [];
    return records;
  };

  /**
   * Accepts the threshold value from the user configuration object and
   * returns a sorted array of unique threshold values. If a value is not
   * between 0 and 1 and error is thrown.
   * @private
   * @param {Array|number=} opt_threshold An optional threshold value or
   *     a list of threshold values, defaulting to [0].
   * @return {Array} A sorted list of unique and valid threshold values.
   */
  IntersectionObserver.prototype._initThresholds = function (opt_threshold) {
    var threshold = opt_threshold || [0];
    if (!Array.isArray(threshold)) threshold = [threshold];

    return threshold.sort().filter(function (t, i, a) {
      if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
        throw new Error('threshold must be a number between 0 and 1 inclusively');
      }
      return t !== a[i - 1];
    });
  };

  /**
   * Accepts the rootMargin value from the user configuration object
   * and returns an array of the four margin values as an object containing
   * the value and unit properties. If any of the values are not properly
   * formatted or use a unit other than px or %, and error is thrown.
   * @private
   * @param {string=} opt_rootMargin An optional rootMargin value,
   *     defaulting to '0px'.
   * @return {Array<Object>} An array of margin objects with the keys
   *     value and unit.
   */
  IntersectionObserver.prototype._parseRootMargin = function (opt_rootMargin) {
    var marginString = opt_rootMargin || '0px';
    var margins = marginString.split(/\s+/).map(function (margin) {
      var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
      if (!parts) {
        throw new Error('rootMargin must be specified in pixels or percent');
      }
      return { value: parseFloat(parts[1]), unit: parts[2] };
    });

    // Handles shorthand.
    margins[1] = margins[1] || margins[0];
    margins[2] = margins[2] || margins[0];
    margins[3] = margins[3] || margins[1];

    return margins;
  };

  /**
   * Starts polling for intersection changes if the polling is not already
   * happening, and if the page's visibility state is visible.
   * @private
   */
  IntersectionObserver.prototype._monitorIntersections = function () {
    if (!this._monitoringIntersections) {
      this._monitoringIntersections = true;

      // If a poll interval is set, use polling instead of listening to
      // resize and scroll events or DOM mutations.
      if (this.POLL_INTERVAL) {
        this._monitoringInterval = setInterval(this._checkForIntersections, this.POLL_INTERVAL);
      } else {
        addEvent(window, 'resize', this._checkForIntersections, true);
        addEvent(document, 'scroll', this._checkForIntersections, true);

        if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
          this._domObserver = new MutationObserver(this._checkForIntersections);
          this._domObserver.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
          });
        }
      }
    }
  };

  /**
   * Stops polling for intersection changes.
   * @private
   */
  IntersectionObserver.prototype._unmonitorIntersections = function () {
    if (this._monitoringIntersections) {
      this._monitoringIntersections = false;

      clearInterval(this._monitoringInterval);
      this._monitoringInterval = null;

      removeEvent(window, 'resize', this._checkForIntersections, true);
      removeEvent(document, 'scroll', this._checkForIntersections, true);

      if (this._domObserver) {
        this._domObserver.disconnect();
        this._domObserver = null;
      }
    }
  };

  /**
   * Scans each observation target for intersection changes and adds them
   * to the internal entries queue. If new entries are found, it
   * schedules the callback to be invoked.
   * @private
   */
  IntersectionObserver.prototype._checkForIntersections = function () {
    var rootIsInDom = this._rootIsInDom();
    var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

    this._observationTargets.forEach(function (item) {
      var target = item.element;
      var targetRect = getBoundingClientRect(target);
      var rootContainsTarget = this._rootContainsTarget(target);
      var oldEntry = item.entry;
      var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, rootRect);

      var newEntry = item.entry = new IntersectionObserverEntry({
        time: now(),
        target: target,
        boundingClientRect: targetRect,
        rootBounds: rootRect,
        intersectionRect: intersectionRect
      });

      if (!oldEntry) {
        this._queuedEntries.push(newEntry);
      } else if (rootIsInDom && rootContainsTarget) {
        // If the new entry intersection ratio has crossed any of the
        // thresholds, add a new entry.
        if (this._hasCrossedThreshold(oldEntry, newEntry)) {
          this._queuedEntries.push(newEntry);
        }
      } else {
        // If the root is not in the DOM or target is not contained within
        // root but the previous entry for this target had an intersection,
        // add a new record indicating removal.
        if (oldEntry && oldEntry.isIntersecting) {
          this._queuedEntries.push(newEntry);
        }
      }
    }, this);

    if (this._queuedEntries.length) {
      this._callback(this.takeRecords(), this);
    }
  };

  /**
   * Accepts a target and root rect computes the intersection between then
   * following the algorithm in the spec.
   * TODO(philipwalton): at this time clip-path is not considered.
   * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
   * @param {Element} target The target DOM element
   * @param {Object} rootRect The bounding rect of the root after being
   *     expanded by the rootMargin value.
   * @return {?Object} The final intersection rect object or undefined if no
   *     intersection is found.
   * @private
   */
  IntersectionObserver.prototype._computeTargetAndRootIntersection = function (target, rootRect) {

    // If the element isn't displayed, an intersection can't happen.
    if (window.getComputedStyle(target).display == 'none') return;

    var targetRect = getBoundingClientRect(target);
    var intersectionRect = targetRect;
    var parent = getParentNode(target);
    var atRoot = false;

    while (!atRoot) {
      var parentRect = null;
      var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {};

      // If the parent isn't displayed, an intersection can't happen.
      if (parentComputedStyle.display == 'none') return;

      if (parent == this.root || parent == document) {
        atRoot = true;
        parentRect = rootRect;
      } else {
        // If the element has a non-visible overflow, and it's not the <body>
        // or <html> element, update the intersection rect.
        // Note: <body> and <html> cannot be clipped to a rect that's not also
        // the document rect, so no need to compute a new intersection.
        if (parent != document.body && parent != document.documentElement && parentComputedStyle.overflow != 'visible') {
          parentRect = getBoundingClientRect(parent);
        }
      }

      // If either of the above conditionals set a new parentRect,
      // calculate new intersection data.
      if (parentRect) {
        intersectionRect = computeRectIntersection(parentRect, intersectionRect);

        if (!intersectionRect) break;
      }
      parent = getParentNode(parent);
    }
    return intersectionRect;
  };

  /**
   * Returns the root rect after being expanded by the rootMargin value.
   * @return {Object} The expanded root rect.
   * @private
   */
  IntersectionObserver.prototype._getRootRect = function () {
    var rootRect;
    if (this.root) {
      rootRect = getBoundingClientRect(this.root);
    } else {
      // Use <html>/<body> instead of window since scroll bars affect size.
      var html = document.documentElement;
      var body = document.body;
      rootRect = {
        top: 0,
        left: 0,
        right: html.clientWidth || body.clientWidth,
        width: html.clientWidth || body.clientWidth,
        bottom: html.clientHeight || body.clientHeight,
        height: html.clientHeight || body.clientHeight
      };
    }
    return this._expandRectByRootMargin(rootRect);
  };

  /**
   * Accepts a rect and expands it by the rootMargin value.
   * @param {Object} rect The rect object to expand.
   * @return {Object} The expanded rect.
   * @private
   */
  IntersectionObserver.prototype._expandRectByRootMargin = function (rect) {
    var margins = this._rootMarginValues.map(function (margin, i) {
      return margin.unit == 'px' ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
    });
    var newRect = {
      top: rect.top - margins[0],
      right: rect.right + margins[1],
      bottom: rect.bottom + margins[2],
      left: rect.left - margins[3]
    };
    newRect.width = newRect.right - newRect.left;
    newRect.height = newRect.bottom - newRect.top;

    return newRect;
  };

  /**
   * Accepts an old and new entry and returns true if at least one of the
   * threshold values has been crossed.
   * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
   *    particular target element or null if no previous entry exists.
   * @param {IntersectionObserverEntry} newEntry The current entry for a
   *    particular target element.
   * @return {boolean} Returns true if a any threshold has been crossed.
   * @private
   */
  IntersectionObserver.prototype._hasCrossedThreshold = function (oldEntry, newEntry) {

    // To make comparing easier, an entry that has a ratio of 0
    // but does not actually intersect is given a value of -1
    var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
    var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1;

    // Ignore unchanged ratios
    if (oldRatio === newRatio) return;

    for (var i = 0; i < this.thresholds.length; i++) {
      var threshold = this.thresholds[i];

      // Return true if an entry matches a threshold or if the new ratio
      // and the old ratio are on the opposite sides of a threshold.
      if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) {
        return true;
      }
    }
  };

  /**
   * Returns whether or not the root element is an element and is in the DOM.
   * @return {boolean} True if the root element is an element and is in the DOM.
   * @private
   */
  IntersectionObserver.prototype._rootIsInDom = function () {
    return !this.root || containsDeep(document, this.root);
  };

  /**
   * Returns whether or not the target element is a child of root.
   * @param {Element} target The target element to check.
   * @return {boolean} True if the target element is a child of root.
   * @private
   */
  IntersectionObserver.prototype._rootContainsTarget = function (target) {
    return containsDeep(this.root || document, target);
  };

  /**
   * Adds the instance to the global IntersectionObserver registry if it isn't
   * already present.
   * @private
   */
  IntersectionObserver.prototype._registerInstance = function () {
    if (registry.indexOf(this) < 0) {
      registry.push(this);
    }
  };

  /**
   * Removes the instance from the global IntersectionObserver registry.
   * @private
   */
  IntersectionObserver.prototype._unregisterInstance = function () {
    var index = registry.indexOf(this);
    if (index != -1) registry.splice(index, 1);
  };

  /**
   * Returns the result of the performance.now() method or null in browsers
   * that don't support the API.
   * @return {number} The elapsed time since the page was requested.
   */
  function now() {
    return window.performance && performance.now && performance.now();
  }

  /**
   * Throttles a function and delays its execution, so it's only called at most
   * once within a given time period.
   * @param {Function} fn The function to throttle.
   * @param {number} timeout The amount of time that must pass before the
   *     function can be called again.
   * @return {Function} The throttled function.
   */
  function throttle(fn, timeout) {
    var timer = null;
    return function () {
      if (!timer) {
        timer = setTimeout(function () {
          fn();
          timer = null;
        }, timeout);
      }
    };
  }

  /**
   * Adds an event handler to a DOM node ensuring cross-browser compatibility.
   * @param {Node} node The DOM node to add the event handler to.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to add.
   * @param {boolean} opt_useCapture Optionally adds the even to the capture
   *     phase. Note: this only works in modern browsers.
   */
  function addEvent(node, event, fn, opt_useCapture) {
    if (typeof node.addEventListener == 'function') {
      node.addEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.attachEvent == 'function') {
      node.attachEvent('on' + event, fn);
    }
  }

  /**
   * Removes a previously added event handler from a DOM node.
   * @param {Node} node The DOM node to remove the event handler from.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to remove.
   * @param {boolean} opt_useCapture If the event handler was added with this
   *     flag set to true, it should be set to true here in order to remove it.
   */
  function removeEvent(node, event, fn, opt_useCapture) {
    if (typeof node.removeEventListener == 'function') {
      node.removeEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.detatchEvent == 'function') {
      node.detatchEvent('on' + event, fn);
    }
  }

  /**
   * Returns the intersection between two rect objects.
   * @param {Object} rect1 The first rect.
   * @param {Object} rect2 The second rect.
   * @return {?Object} The intersection rect or undefined if no intersection
   *     is found.
   */
  function computeRectIntersection(rect1, rect2) {
    var top = Math.max(rect1.top, rect2.top);
    var bottom = Math.min(rect1.bottom, rect2.bottom);
    var left = Math.max(rect1.left, rect2.left);
    var right = Math.min(rect1.right, rect2.right);
    var width = right - left;
    var height = bottom - top;

    return width >= 0 && height >= 0 && {
      top: top,
      bottom: bottom,
      left: left,
      right: right,
      width: width,
      height: height
    };
  }

  /**
   * Shims the native getBoundingClientRect for compatibility with older IE.
   * @param {Element} el The element whose bounding rect to get.
   * @return {Object} The (possibly shimmed) rect of the element.
   */
  function getBoundingClientRect(el) {
    var rect;

    try {
      rect = el.getBoundingClientRect();
    } catch (err) {
      // Ignore Windows 7 IE11 "Unspecified error"
      // https://github.com/w3c/IntersectionObserver/pull/205
    }

    if (!rect) return getEmptyRect();

    // Older IE
    if (!(rect.width && rect.height)) {
      rect = {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
      };
    }
    return rect;
  }

  /**
   * Returns an empty rect object. An empty rect is returned when an element
   * is not in the DOM.
   * @return {Object} The empty rect.
   */
  function getEmptyRect() {
    return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    };
  }

  /**
   * Checks to see if a parent element contains a child element (including inside
   * shadow DOM).
   * @param {Node} parent The parent element.
   * @param {Node} child The child element.
   * @return {boolean} True if the parent node contains the child node.
   */
  function containsDeep(parent, child) {
    var node = child;
    while (node) {
      if (node == parent) return true;

      node = getParentNode(node);
    }
    return false;
  }

  /**
   * Gets the parent node of an element or its host element if the parent node
   * is a shadow root.
   * @param {Node} node The node whose parent to get.
   * @return {Node|null} The parent node or null if no parent exists.
   */
  function getParentNode(node) {
    var parent = node.parentNode;

    if (parent && parent.nodeType == 11 && parent.host) {
      // If the parent is a shadow root, return the host element.
      return parent.host;
    }

    if (parent && parent.assignedSlot) {
      // If the parent is distributed in a <slot>, return the parent of a slot.
      return parent.assignedSlot.parentNode;
    }

    return parent;
  }

  // Exposes the constructors globally.
  window.IntersectionObserver = IntersectionObserver;
  window.IntersectionObserverEntry = IntersectionObserverEntry;
})(window, document);

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "add17d54f276d55321a5a9e2a4576464.jpg";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c42714764e8cf5bfac4ab100df6d326c.jpg";

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "902d91b3d703ef710afd49875b335e20.jpg";

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f40ad763e422980b3f93e69848cba4a0.jpg";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var originMap = {
    pro: 'https://liveapi.upliveapps.com/uplive/get-download-settings',
    stage: 'http://sg-liveapi.xingyunzhi.cn/uplive/get-download-settings'
};
exports.default = {
    downloadUrl: {
        yyb: '',
        apple: '',
        google: '',
        android: ''
    },
    load: function load() {
        var _this = this;

        // 当前开发环境
        var env = _cUrl2.default.query('env');

        if (!env || env == 'null') {
            env = 'pro';
        }

        var API = originMap[env] || originMap['pro'];

        var promise = $.ajax({
            url: API,
            type: 'POST',
            dataType: 'json'
        });

        promise.done(function (res) {
            var _res$data$download_ur = res.data.download_url,
                yyb = _res$data$download_ur.yyb,
                ios = _res$data$download_ur.ios,
                googleplay = _res$data$download_ur.googleplay,
                apk = _res$data$download_ur.apk;


            _this.downloadUrl = {
                yyb: yyb,
                apple: ios,
                google: googleplay,
                android: apk
            };
        });
    }
};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var _giftlist = __webpack_require__(153);

var _giftlist2 = _interopRequireDefault(_giftlist);

var _levels = __webpack_require__(476);

var _levels2 = _interopRequireDefault(_levels);

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {

    // 此数据在退出直播间时, 需要重新初始化
    msgbox: {
        continuousGiftMsg: {},
        staticGiftAnimQueue: [],
        checkContinuousGiftTimer: {}
    },

    pokemonbox: {
        continuousGiftMsg: {},
        checkContinuousGiftTimer: {}
    },

    pokemon: {
        giftIdArr: [2001, 2002, 2003],
        clickGiftIdArr: [2005],
        ballGiftIdArr: [2000, 2053, 2054, 2057, 2058]
    },

    // 大礼物
    addBigGift: function addBigGift(data) {
        return this.formatGift(data);
    },


    /**
     * msgResp 原始下行报文
     * cfg: {onSuccess}
     */
    formatMsg: function formatMsg(msgResp) {

        // 0 文本聊天
        // 1 弹幕
        // 2 礼物信息
        // 5 用户共玩［精灵等］
        // 6 关注主播
        // 9 赞（需要判断是否第一次赞）
        // 11 主播暂时离开
        // 12 主播又回来了
        // 15 用户登入
        // 17 系统广播消息
        // 19 新购买守护者
        // 20 系统消息
        var mtypes = [0, 1, 2, 6, 9, 10, 11, 12, 15, 17, 19, 20];

        var formatedMsg = [];

        if (this.isTextChat(msgResp)) {
            formatedMsg = this.formatTextChat(msgResp);
        } else if (this.isFollowHost(msgResp)) {
            formatedMsg = this.formatFollow(msgResp);
        } else if (this.isLikeHost(msgResp)) {
            formatedMsg = this.formatLike(msgResp);
        } else if (this.isHostLeave(msgResp) || this.isHostBack(msgResp)) {
            formatedMsg = [{ mType: msgResp.mType }];
        } else if (this.isUserLogin(msgResp)) {
            formatedMsg = this.formatUserLogin(msgResp);
        } else if (this.isLimitSpeak(msgResp)) {
            formatedMsg = this.formatLimitSpeak(msgResp);
        } else if (this.isUnlimitSpeak(msgResp)) {
            formatedMsg = this.formatUnlimitSpeak(msgResp);
        } else if (this.isBulletTextChat(msgResp)) {
            formatedMsg = this.formatBulletMsg(msgResp);
        } else if (this.isSystemMsg(msgResp)) {
            formatedMsg = this.formatSystemMsg(msgResp);
        } else if (this.isSystemBroadcast(msgResp)) {
            formatedMsg = this.formatedSystemBroadcast(msgResp);
        } else if (this.isNewGuard(msgResp)) {
            formatedMsg = this.formatGuard(msgResp);
        } else if (this.isUserFight(msgResp)) {
            formatedMsg = this.formatedUserFight(msgResp);
        }

        return formatedMsg;
    },

    // 是否是文本聊天
    isTextChat: function isTextChat(data) {
        return data.mType == 0;
    },


    // 用户弹屏消息
    isBulletTextChat: function isBulletTextChat(data) {
        return data.mType == 1;
    },


    // 是否是礼物信息
    isGift: function isGift(data) {
        return data.mType == 2;
    },


    // 是否主播退出
    isHostExit: function isHostExit(data) {
        return data.mType == 4;
    },


    // 用户共玩游戏
    isUserFight: function isUserFight(data) {
        return data.mType == 5;
    },


    // 是否是连续礼物
    isContinuousGift: function isContinuousGift(data) {
        return data.extenseBody.isContinuous;
    },
    isDecorateGift: function isDecorateGift(data) {
        var giftObj = _giftlist2.default.getGiftObj(data.extenseBody); //gift.getGiftFromId(data.extenseBody.giftId);

        return giftObj && giftObj.type == 24;
    },
    isStaticGift: function isStaticGift(data) {
        var giftObj = _giftlist2.default.getGiftObj(data.extenseBody); //gift.getGiftFromId(data.extenseBody.giftId);

        return giftObj && giftObj.type == 1;
    },
    isSecretGift: function isSecretGift(data) {
        var giftObj = _giftlist2.default.getGiftObj(data.extenseBody);
        if (giftObj) {
            return false;
        } else {
            return true;
        }
    },


    // 是否是的红包礼物
    isRedPacketGift: function isRedPacketGift(data) {
        var ret = data.extenseBody.redPackets && data.extenseBody.redPackets.length > 0;

        return ret;
    },


    // 是否是关注主播信息
    isFollowHost: function isFollowHost(data) {
        if (data.mType == 6) {

            if (data.localAct) {
                return true;
            } else {
                if (UP.Global.getUserId() != data.sId) {
                    return true;
                }
            }
        }

        return false;
    },


    // 禁言报文
    isLimitSpeak: function isLimitSpeak(data) {
        return data.mType == 7;
    },


    // 禁止当前登录用户发言
    isLimitCurrentUserSpeak: function isLimitCurrentUserSpeak(data) {
        return this.isLimitSpeak(data) && UP.Global.getUserId() == data.rId;
    },


    // 解禁言报文
    isUnlimitSpeak: function isUnlimitSpeak(data) {
        return data.mType == 8;
    },


    // 当前登录用户发言解除禁言
    isUnlimitCurrentUserSpeak: function isUnlimitCurrentUserSpeak(data) {
        return this.isUnlimitSpeak(data) && UP.Global.getUserId() == data.rId;
    },


    // 是否是点赞信息
    isLikeHost: function isLikeHost(data) {
        return data.mType == 9;
    },


    // 是否是主播暂时离开
    isHostLeave: function isHostLeave(data) {
        return data.mType == 11;
    },


    // 主播又回来了
    isHostBack: function isHostBack(data) {
        return data.mType == 12;
    },


    // 用户进入主播间
    isUserLogin: function isUserLogin(data) {
        return data.mType == 15;
    },


    // 用户离开直播间
    isUserLogout: function isUserLogout(data) {
        return data.mType == 16;
    },


    // 系统通用广播
    isSystemBroadcast: function isSystemBroadcast(data) {
        return data.mType == 17;
    },
    isNewGuard: function isNewGuard(data) {
        return data.mType == 19;
    },
    isSystemMsg: function isSystemMsg(data) {
        return data.mType == 20;
    },
    isPokemonGift: function isPokemonGift(data) {
        return this.pokemon.giftIdArr.indexOf(parseInt(data.extenseBody.giftId, 10)) > -1;
    },
    isPokemonClickGift: function isPokemonClickGift(data) {
        return this.pokemon.clickGiftIdArr.indexOf(parseInt(data.extenseBody.giftId, 10)) > -1;
    },
    isPokemonBallGift: function isPokemonBallGift(data) {
        return this.pokemon.ballGiftIdArr.indexOf(parseInt(data.extenseBody.giftId, 10)) > -1;
    },


    // 当前用户是否被强制踢出
    isForceOut: function isForceOut(data) {
        return data.mType == 21;
    },

    // 大陆政策要求，发送消息需求绑定手机
    isNeedToBindPhone: function isNeedToBindPhone(data) {
        return data.mType == 33;
    },
    formatedSystemBroadcast: function formatedSystemBroadcast(resp) {
        var arr = [];

        switch (resp.extenseBody.sbType) {
            case 0:
                // 1314个礼物的系统广播。默认值(原1314等)
                arr.push({
                    mType: '17_0',
                    rAId: resp.extenseBody.rAId,
                    rRoomId: resp.extenseBody.rRoomId,
                    userName: resp.extenseBody.userInfo.userName,
                    content: resp.extenseBody.content
                });
                break;
            case 1:
                // 跑马灯(1.7.0版开始使用)
                // 跑马灯 0：普通，1：酷炫
                if (resp.extenseBody.level && resp.extenseBody.level == 1) {
                    arr.push({
                        mType: '17_1_1',
                        rAId: resp.extenseBody.rAId,
                        rRoomId: resp.extenseBody.rRoomId,
                        userName: resp.extenseBody.userInfo.userName,
                        content: resp.extenseBody.content
                    });
                } else {
                    arr.push({
                        mType: '17_1_0', // mType + '_' + resp.extensebody.snType + '_' + resp.extensebody.level 删除场控
                        rAId: resp.extenseBody.rAId,
                        rRoomId: resp.extenseBody.rRoomId,
                        userName: resp.extenseBody.userInfo.userName,
                        content: resp.extenseBody.content
                    });
                }
                break;
            case 2:
                // 喇叭功能：普通，
                arr.push({
                    mType: '17_2',
                    rAId: resp.extenseBody.rAId,
                    rRoomId: resp.extenseBody.rRoomId,
                    userName: resp.extenseBody.userInfo.userName,
                    content: resp.extenseBody.content
                });
                break;
            case 4:
                // 喇叭功能：网页跳转，跳转到profile页面
                arr.push({
                    mType: '17_4',
                    rAId: resp.extenseBody.rAId,
                    rRoomId: resp.extenseBody.rRoomId,
                    userName: resp.extenseBody.userInfo.userName,
                    content: resp.extenseBody.content,
                    extJson: resp.extenseBody.extJson
                });
                break;
        }

        return arr;
    },
    formatSystemMsg: function formatSystemMsg(resp) {
        var arr = [];

        var userInfo = resp.extenseBody.userInfo;

        switch (resp.extenseBody.snType) {
            case 1:
                // 最佳红包手气提示
                var giftObj = _giftlist2.default.getGiftObj(resp.extenseBody); //gift.getGiftFromId(resp.extenseBody.giftId) || {};

                arr.push({
                    mType: '20_1',
                    rname: resp.extenseBody.rName, // 发送红包的用户
                    userName: resp.extenseBody.userInfo.userName, // 获取红包的用户
                    giftName: giftObj ? giftObj.name : _index2.default.template('神秘礼物')
                });
                break;
            case 2:
                if (resp.extenseBody.userLabel == 'RoomControl') {
                    arr.push({
                        mType: '20_2', // mType + '_' + resp.extensebody.snType  设置场控
                        rname: resp.extenseBody.userInfo.userName
                    });
                }
                break;
            case 3:
                if (resp.extenseBody.userLabel == 'RoomControl') {
                    arr.push({
                        mType: '20_3', // mType + '_' + resp.extensebody.snType 删除场控
                        rname: resp.extenseBody.userInfo.userName
                    });
                }
                break;
            case 4:
                // 强制某人离开房间的系统消息
                arr.push({
                    mType: '20_4', // mType + '_' + resp.extensebody.snType
                    rname: resp.extenseBody.rName,
                    userName: resp.extenseBody.userInfo.userName,
                    label: this.formatedUserLabel(resp)
                });
                break;
            default:
            // 默认处理
        }

        if (resp.extenseBody.type == 1) {

            var _giftObj = _giftlist2.default.getGiftObj(resp.extenseBody); //gift.getGiftFromId(resp.extenseBody.giftId) || {};

            arr.push({
                mType: '20_10', //用户通知
                uid: resp.extenseBody.userInfo.uId,
                rname: resp.extenseBody.rName, // 发送红包的用户
                userName: resp.extenseBody.userInfo.userName,
                userGrade: resp.extenseBody.userInfo.userGrade,
                giftName: _giftObj ? _giftObj.name : _index2.default.template('神秘礼物'),
                amount: resp.extenseBody.amount
            });
        }

        return arr;
    },
    formatGuard: function formatGuard(resp) {
        var arr = [];

        var userInfo = resp.extenseBody.userInfo;

        arr.push({
            mType: '19', // mType + '_' + resp.extensebody.snType
            avatar: userInfo.userIcon,
            money: resp.extenseBody.money,
            userName: userInfo.userName
        });

        return arr;
    },


    // 文本信息格式化
    formatTextChat: function formatTextChat(resp) {
        var arr = [];
        var curUser = UP.Global.getUser();

        var body = resp.extenseBody;

        // 普通文本消息
        if (body.uReq) {
            body.uReq.forEach(function (item, inx) {
                // 当前登录用户发的消息在下行报文到达之前已经处理完毕
                // 此时屏蔽，避免重复渲染
                if (curUser.uid == item.userInfo.uId) {
                    if (!resp.localAct) {
                        return;
                    }
                }
                if (!item.content.trim()) {
                    return;
                }
                arr.push({
                    mType: resp.mType,
                    userGrade: item.userInfo.userGrade,
                    userName: item.userInfo.userName,
                    content: item.content,
                    uid: item.userInfo.uId
                });
            });
        } else if (body.userInfo) {

            // @的消息
            arr.push({
                mType: resp.mType,
                userGrade: body.userInfo.userGrade,
                userName: _index2.default.template('<%=sname%>悄悄@<%=rname%>', {
                    sname: body.userInfo.userName,
                    rname: resp.localAct ? body.rname : UP.Global.getUser().username
                }),
                content: body.content,
                uid: body.userInfo.uId
            });
        }

        return arr;
    },
    formatBulletMsg: function formatBulletMsg(resp) {

        var arr = [];
        var curUser = UP.Global.getUser();

        var body = resp.extenseBody;

        // 普通文本消息
        if (body.uReq) {

            body.uReq.forEach(function (item, inx) {
                // 当前登录用户发的消息在下行报文到达之前已经处理完毕
                // 此时屏蔽，避免重复渲染
                if (curUser.uid == item.userInfo.uId) {
                    if (!resp.localAct) {
                        return;
                    }
                }
                if (!item.content.trim()) {
                    return;
                }
                arr.push({
                    mType: resp.mType,
                    userGrade: item.userInfo.userGrade,
                    userName: item.userInfo.userName,
                    content: item.content,
                    userIcon: item.userInfo.userIcon,
                    uid: item.userInfo.uId
                });
            });
        } else if (body.userInfo) {
            arr.push({
                mType: resp.mType,
                userGrade: body.userInfo.userGrade,
                userName: body.userInfo.userName,
                content: body.content,
                userIcon: body.userInfo.userIcon,
                uid: body.userInfo.uId
            });
        }

        return arr;
    },
    formatedUserLabel: function formatedUserLabel(resp) {
        var user = resp.extenseBody.userInfo;
        var hostInfo = $.hostInfo || {};

        var label = void 0;

        if (user.uId == hostInfo.uid) {
            label = _index2.default.template('主播');
        } else {
            if (user.userLabels && user.userLabels.length > 0) {
                if (user.userLabels.indexOf('RoomControl') > -1) {
                    label = _index2.default.template('场控');
                } else if (user.userLabels.indexOf('Guardian') > -1) {
                    label = _index2.default.template('守护');
                } else {
                    var vipLabel = void 0;

                    $.each(user.userLabels || [], function (index, e) {
                        if (e.indexOf('VIP') > -1) {
                            vipLabel = e;
                            return false;
                        }
                    });

                    if (vipLabel) {
                        label = 'VIP';
                    }
                }
            }
        }

        return label;
    },
    formatLimitSpeak: function formatLimitSpeak(resp) {
        var label = this.formatedUserLabel(resp);
        var arr = [];

        arr.push({
            mType: 7,
            rname: resp.extenseBody.rName,
            userName: resp.extenseBody.userInfo.userName,
            rId: resp.rId,
            ubConnector: resp.extenseBody.ubConnector,
            label: label
        });

        return arr;
    },
    formatUnlimitSpeak: function formatUnlimitSpeak(resp) {
        var label = this.formatedUserLabel(resp);
        var arr = [];

        arr.push({
            mType: 8,
            rname: resp.extenseBody.rName,
            userName: resp.extenseBody.userInfo.userName,
            rId: resp.rId,
            ubConnector: resp.extenseBody.ubConnector,
            label: label
        });

        return arr;
    },


    // 点赞格式化
    formatLike: function formatLike(resp) {
        var arr = [];
        var uLikeReq = resp.extenseBody.uLikeReq;

        uLikeReq.forEach(function (item, inx) {
            if (item.isFirst) {
                arr.push({
                    mType: resp.mType,
                    userGrade: item.userInfo.userGrade,
                    userName: item.userInfo.userName,
                    uid: item.userInfo.uId
                });
            }
        });

        return arr;
    },


    // 关注信息格式化
    formatFollow: function formatFollow(resp) {
        var arr = [];
        var body = resp.extenseBody;

        return [{
            mType: resp.mType,
            userGrade: body.userInfo.userGrade,
            userName: body.userInfo.userName,
            uid: body.userInfo.uId
        }];
    },


    // 用户登入直播间信息
    formatUserLogin: function formatUserLogin(resp) {
        var _this = this;

        var arr = [];
        var systemUsers = resp.extenseBody.systemUsers;
        var curUser = UP.Global.getUser();

        systemUsers.forEach(function (item, inx) {
            // if (curUser.uid == item.userInfo.uId) {
            //     return;
            // }

            // 机器人登录
            if (item.userInfo.uType == 3) {
                return;
            }
            // 主播
            if ($.hostInfo.uid == item.userInfo.uId) {
                return;
            }

            var isGuardInto = $.hostGuardInfo && longToString($.hostGuardInfo.uid) == item.userInfo.uId;

            var vipLabel = void 0;

            $.each(item.userInfo.userLabels || [], function (index, e) {
                if (e.indexOf('VIP') > -1) {
                    vipLabel = e;
                    return false;
                }
            });

            if (isGuardInto) {
                arr.push({
                    mType: resp.mType,
                    userName: item.userInfo.userName,
                    userGrade: item.userInfo.userGrade,
                    avatar: item.userInfo.userIcon,
                    uid: item.userInfo.uId,
                    vipLabel: vipLabel,
                    animation: 0,
                    isShowHighText: item.isShowHighText,
                    guardInto: isGuardInto
                });
            } else {

                var userGrade = item.userInfo.userGrade;

                if (userGrade >= 10) {
                    // 10级以上
                    arr.push({
                        mType: resp.mType,
                        userName: item.userInfo.userName,
                        userGrade: item.userInfo.userGrade,
                        avatar: item.userInfo.userIcon,
                        car: _this.getCarByLevel(item.userInfo.userGrade),
                        vipLabel: vipLabel,
                        uid: item.userInfo.uId,
                        isShowHighText: item.isShowHighText,
                        animation: 1
                    });
                }

                // else  if(userGrade >= 2 && userGrade < 10) {
                //     // 2~9级
                //     arr.push({
                //         mType: resp.mType,
                //         userName: item.userInfo.userName,
                //         userGrade: item.userInfo.userGrade,
                //         avatar: item.userInfo.userIcon,
                //         vipLabel: vipLabel,
                //         uid: item.userInfo.uId,
                //         animation: 1
                //     });
                // } else {
                //     // 1级
                //     if (item.userInfo.uType != 3) {
                //         arr.push({
                //             mType: resp.mType,
                //             userName: item.userInfo.userName,
                //             userGrade: item.userInfo.userGrade,
                //             avatar: item.userInfo.userIcon,
                //             vipLabel: vipLabel,
                //             uid: item.userInfo.uId,
                //             animation: 0
                //         });
                //     }
                // }
            }
        });

        return arr;
    },
    getCarByLevel: function getCarByLevel(level) {
        var result = void 0;
        for (var i = _levels2.default.length; i--;) {
            var item = _levels2.default[i];
            if (level >= item.minLevel && level <= item.maxLevel) {
                result = item;
                break;
            }
        }
        return result;
    },


    // 是否是自己送礼物的下行信息
    isSelfGiftDown: function isSelfGiftDown(msg) {
        return UP.Global.getUserId() == msg.sId && !msg.extenseBody.localAct;
    },
    isSelfBulletDown: function isSelfBulletDown(msg) {
        return UP.Global.getUserId() == msg.sId && !msg.localAct;
    },

    // 礼物信息格式化
    formatGift: function formatGift(msgResp) {
        var arr = [];
        var curUser = UP.Global.getUser();
        var body = msgResp.extenseBody;
        var giftId = body.giftId;
        var giftObj = _giftlist2.default.getGiftObj(body);

        if (giftObj && giftObj.giftId) {
            var msgType = giftObj.type;

            // 门票=22
            var unavailableList = [3, 4, 5, 9, 10, 11, 14, 15, 22];

            if (unavailableList.indexOf(msgType) >= 0) {
                return;
            }

            if (body.redPackets) {
                // 红包礼物，
                var giftPicObj = _giftlist2.default.getGiftPicFromId(giftObj.giftId);

                arr.push({
                    mType: msgResp.mType,
                    userGrade: body.userInfo.userGrade,
                    userName: body.userInfo.userName,
                    count: body.numContinuous,
                    giftName: giftObj.name,
                    giftAmount: body.giftAmount,
                    redPackets: body.redPackets,
                    startTime: +new Date(), // 本地记录红包收到的开始时间，用户判断红包有效期。 redPackets中的beginTime没用            
                    giftId: giftId,
                    transactionId: body.transactionId,
                    giftPic: giftPicObj ? giftPicObj.big : '',
                    avatar: body.userInfo.userIcon,
                    localAct: body.localAct,
                    uid: body.userInfo.uId,
                    giftType: body.giftType
                });
            } else if (this.isPokemonBallGift(msgResp) || this.isPokemonClickGift(msgResp)) {
                // 点击精灵 或 精灵球
                var result = {
                    mType: msgResp.mType,
                    userGrade: body.userInfo.userGrade,
                    userName: body.userInfo.userName,
                    giftName: giftObj.name,
                    count: body.numContinuous,
                    giftAmount: msgResp.giftAmount,
                    giftId: giftId,
                    giftPic: giftObj.pic ? giftObj.pic.small : '',
                    avatar: body.userInfo.userIcon,
                    localAct: body.localAct,
                    uid: body.userInfo.uId,
                    ballGiftName: _giftlist2.default.getPokemonBall().name,
                    giftType: body.giftType
                };

                if ($.effectivePokemon) {
                    result.refGiftName = $.effectivePokemon.giftName;
                    result.refGiftPic = $.effectivePokemon.giftPic;
                } else {
                    // 处理延迟的消灭精灵消息
                    if ($.effectivePokemonOld) {
                        result.refGiftName = $.effectivePokemonOld.giftName;
                        result.refGiftPic = $.effectivePokemonOld.giftPic;
                    }
                }

                arr.push(result);
            } else {
                arr.push({
                    mType: msgResp.mType,
                    userGrade: body.userInfo.userGrade,
                    userName: body.userInfo.userName,
                    giftName: giftObj.name,
                    count: body.numContinuous,
                    giftAmount: msgResp.giftAmount,
                    giftId: giftId,
                    giftPic: giftObj.pic ? giftObj.pic.small : '',
                    avatar: body.userInfo.userIcon,
                    localAct: body.localAct,
                    uid: body.userInfo.uId,
                    giftType: body.giftType
                });
            }
        } else {
            //神秘礼物
            arr.push({
                mType: msgResp.mType,
                userGrade: body.userInfo.userGrade,
                userName: body.userInfo.userName,
                giftName: _index2.default.template('神秘礼物'),
                count: body.numContinuous,
                giftAmount: msgResp.giftAmount,
                giftId: giftId,
                giftPic: "https://g.cdn.pengpengla.com/oauthgame/html5/20181108/9f85106cf7410795bf496ce29fc8ddf9.png",
                avatar: body.userInfo.userIcon,
                localAct: body.localAct,
                uid: body.userInfo.uId,
                giftType: body.giftType
            });
        }

        return arr;
    },
    formatedUserFight: function formatedUserFight(resp) {
        var arr = [];
        var curUser = UP.Global.getUser();
        var body = resp.extenseBody;
        var giftId = body.giftId,
            userInfo = body.userInfo,
            sendUserInfo = body.sendUserInfo,
            targetGiftId = body.targetGiftId; //sendUserInfo 打赏精灵用户信息; userInfo: 打赏精灵球用户信息

        var giftObj = _giftlist2.default.getGiftFromId(giftId) || {};

        var result = {
            type: resp.type,
            mType: resp.mType,
            action: body.action,
            energy: body.energy,
            timeLeft: body.timeLeft,
            giftCount: body.numContinuous,
            targetTransactionId: targetGiftId,
            giftId: giftId,
            giftName: giftObj.name,
            giftPic: giftObj.pic ? giftObj.pic.small : '',
            sendUserInfo: sendUserInfo,
            userInfo: userInfo,
            ballGiftName: _giftlist2.default.getPokemonBall().name
        };

        if ($.effectivePokemon) {
            result.refGiftName = $.effectivePokemon.giftName;
            result.refGiftPic = $.effectivePokemon.giftPic;
        }

        arr.push(result);

        return arr;
    },
    formatGiftForSmallAnim: function formatGiftForSmallAnim(msg) {
        var body = msg.extenseBody;
        var curUser = UP.Global.getUser();

        return {
            avatar: body.userInfo.userIcon,
            userName: body.userInfo.userName,
            giftId: body.giftId,
            giftCount: body.numContinuous,
            sid: msg.sId,
            localAct: body.localAct,
            giftType: body.giftType
        };
    },


    // 赠送连续礼物逻辑
    // 定时器检测
    addContinousGift: function addContinousGift(msg, staticGiftAnimation, onContinuousGiftOver) {
        var _this2 = this;

        var checkContinuous = function checkContinuous(curMsgList) {
            if (_this2.msgbox.checkContinuousGiftTimer[msg.sId + msg.extenseBody.giftId]) {
                clearTimeout(_this2.msgbox.checkContinuousGiftTimer[msg.sId + msg.extenseBody.giftId]);
                _this2.msgbox.checkContinuousGiftTimer[msg.sId + msg.extenseBody.giftId] = null;
            }
            _this2.msgbox.checkContinuousGiftTimer[msg.sId + msg.extenseBody.giftId] = setTimeout(function () {
                // 说明连续礼物已结束
                if (_this2.msgbox.continuousGiftMsg[msg.sId + msg.extenseBody.giftId].length == curMsgList.length) {
                    _this2.msgbox.continuousGiftMsg[msg.sId + msg.extenseBody.giftId] = null;
                    var formatGift = _this2.formatGift(msg);

                    if (formatGift) {
                        onContinuousGiftOver(formatGift);
                        _this2.closeStaticGiftAnimQueueUpdate(msg.sId + msg.extenseBody.giftId);
                    }
                }
            }, 5.5 * 1000);
        };

        if (!this.msgbox.continuousGiftMsg[msg.sId + msg.extenseBody.giftId]) {
            this.msgbox.continuousGiftMsg[msg.sId + msg.extenseBody.giftId] = [msg];
        } else {
            this.msgbox.continuousGiftMsg[msg.sId + msg.extenseBody.giftId].push(msg);
        }
        checkContinuous(this.msgbox.continuousGiftMsg[msg.sId + msg.extenseBody.giftId]);

        this.updateStaticGiftAnimQueue(msg, 'update');
        staticGiftAnimation();
    },
    addPokemonClickGift: function addPokemonClickGift(msg, onContinuousGiftOver) {
        var _this3 = this;

        var checkContinuous = function checkContinuous(curMsgList) {
            var key = msg.sId + msg.extenseBody.giftId;

            if (_this3.pokemonbox.checkContinuousGiftTimer[key]) {
                clearTimeout(_this3.pokemonbox.checkContinuousGiftTimer[key]);
                _this3.pokemonbox.checkContinuousGiftTimer[key] = null;
            }

            _this3.pokemonbox.checkContinuousGiftTimer[key] = setTimeout(function () {
                // 说明连续礼物已结束
                if (_this3.pokemonbox.continuousGiftMsg[key].length == curMsgList.length) {
                    _this3.pokemonbox.continuousGiftMsg[key] = null;

                    var formatGift = _this3.formatGift(msg);

                    if (formatGift) {
                        onContinuousGiftOver(formatGift);
                    }
                }
            }, 5.5 * 1000);
        };

        var msgKey = msg.sId + msg.extenseBody.giftId;

        if (!this.pokemonbox.continuousGiftMsg[msgKey]) {
            this.pokemonbox.continuousGiftMsg[msgKey] = [msg];
        } else {
            this.pokemonbox.continuousGiftMsg[msgKey].push(msg);
        }

        checkContinuous(this.pokemonbox.continuousGiftMsg[msgKey]);
    },


    // 关闭静态礼物连播序列更新入口
    // 在3s连播轮询结束后，已存在的动画序列将不再被更新
    closeStaticGiftAnimQueueUpdate: function closeStaticGiftAnimQueueUpdate(key) {
        var arr = this.msgbox.staticGiftAnimQueue;
        for (var i = 0, len = arr.length; i < len; i++) {
            var item = arr[i];
            if (!item) {
                continue;
            }
            if (key == item.sid + item.giftId) {
                item.closeUpdate = 1;
                break;
            }
        }
    },


    // 更新静态连续礼物动画播放序列(增加、更新)
    updateStaticGiftAnimQueue: function updateStaticGiftAnimQueue(msg) {
        var arr = this.msgbox.staticGiftAnimQueue;
        var hasExsit = 0;
        msg = this.formatGiftForSmallAnim(msg);

        if (!msg) {
            return;
        }
        for (var i = arr.length; i--;) {
            var item = arr[i];

            // item == null
            // 在前两个动画序列结束后，如果后面没有更多的动画序列，则当前序列会被设置为null
            // 每次接受礼物信息后，则第一时间需要补上null的位置，其次是更新、新增
            if (!item) {
                this.msgbox.staticGiftAnimQueue.splice(i, 1, msg);
                return;
            }

            if (msg.sid == item.sid && msg.giftId == item.giftId) {

                if (item.closeUpdate) {
                    break;
                }

                this.msgbox.staticGiftAnimQueue.splice(i, 1, msg);

                hasExsit = 1;
                break;
            }
        }

        if (!hasExsit) {
            this.msgbox.staticGiftAnimQueue.push(msg);
        }
    },


    // 静态连续礼物动画播放序列（删除一项）
    delFromGiftAnimQueue: function delFromGiftAnimQueue(formatGift) {
        var arr = this.msgbox.staticGiftAnimQueue;
        for (var i = arr.length; i--;) {
            var item = arr[i];
            if (!item) {
                continue;
            }
            if (formatGift.sid == item.sid && formatGift.giftId == item.giftId) {
                // console.log(formatGift, item)
                this.msgbox.staticGiftAnimQueue.splice(i, 1);
                break;
            }
        }
    },
    delFromGiftAnimQueueByInx: function delFromGiftAnimQueueByInx(inx) {
        this.msgbox.staticGiftAnimQueue.splice(inx, 1);
    },


    // 析构
    destructor: function destructor() {
        this.msgbox.continuousGiftMsg = {};
        this.msgbox.staticGiftAnimQueue = [];
        for (var i in this.msgbox.checkContinuousGiftTimer) {
            if (this.msgbox.checkContinuousGiftTimer[i]) {
                clearTimeout(this.msgbox.checkContinuousGiftTimer[i]);
                this.msgbox.checkContinuousGiftTimer[i] = null;
            }
        }
    }
}; /**
    * all下行报文的封装
    */

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // import React, {Component} from 'react';


var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _index = __webpack_require__(433);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(434);

var _index4 = _interopRequireDefault(_index3);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var mock = 0;

if (_cUrl2.default.query('lock')) {
    mock = 1;
}

var pbajax = new _pbajax2.default();

var cache = new _cCache2.default({
    prefix: 'pcuplive'
});

var Profile = function () {
    function Profile(vuid) {
        _classCallCheck(this, Profile);

        if ((typeof vuid === 'undefined' ? 'undefined' : _typeof(vuid)) == 'object') {
            vuid = longToString(vuid);
        }
        this.promise = this.getData({
            vuid: parseInt(vuid, 10)
        });
        this.vuid = vuid;
    }

    _createClass(Profile, [{
        key: 'getData',
        value: function getData(data) {

            var self = this;
            var businessData = new _index2.default.Profile.Get.Request(data);
            var defer = $.Deferred();
            var userToken = UP.Global.getUserToken();

            pbajax.do({
                service: 'service',
                api: '/profile/get',
                header: {
                    userToken: userToken,
                    lang: UP.Global.siteLanguage
                }
            }, businessData, function (res) {

                var dataWrap = _public2.default.Result.decode(res);
                var data = void 0;

                if (dataWrap.code == 1) {
                    data = _index2.default.Profile.Get.Response.decode(dataWrap.data.value);

                    if (self.vuid == UP.Global.getUserId()) {
                        data.userToken = userToken;
                    }
                    var userInfo = Object.assign({}, data.profile, self.parseData(data.profile), {
                        userLabels: data.userLabels,
                        canPermissions: data.canPermissions
                    });

                    // console.info('loginUserSuccess', userInfo);

                    defer.resolve(userInfo);
                } else {
                    if (dataWrap.code == 8192) {
                        // console.log('profile = 8192登录');
                        // $.channel.emit('login');
                        self.checkVisitorMode();
                    } else {
                        defer.reject();
                    }
                }
            }, function () {
                if (mock == 1) {
                    alert('接口请求失败');
                }

                defer.reject();
            }, function () {
                if (mock == 1) {
                    alert('请求超时');
                }
                defer.reject();
            });

            return defer.promise();
        }

        /*
         * 解析数据
         */

    }, {
        key: 'parseData',
        value: function parseData(data) {
            var balance = data.balance || {};
            return {
                uid: this.longToString(data.uid), // 用户UID
                balance: {
                    diamond: this.longToInt(balance.diamond),
                    bill: this.longToInt(balance.bill),
                    inBill: this.longToInt(balance.inBill),
                    outDiamond: this.longToInt(balance.outDiamond)
                },
                grade: data.grade > 0 ? data.grade : 1,
                exp: this.longToInt(data.exp), // 用户经验值
                currentExp: this.longToInt(data.currentExp), //当前级的经验值
                nextExp: this.longToInt(data.nextExp), // 距离下一级还需要多少经验值
                chatroomid: this.longToString(data.chatroomid),
                officialAuth: data.officialAuth || 0 // 大V认证标识 1是 0否
            };
        }
    }, {
        key: 'longToString',
        value: function longToString(value) {
            return window.longToString(value);
        }
    }, {
        key: 'longToInt',
        value: function longToInt(value) {
            value = this.longToString(value);

            return parseInt(value, 10) || 0;
        }
    }, {
        key: 'checkVisitorMode',
        value: function checkVisitorMode() {
            this.visitor();
        }
    }, {
        key: 'visitor',
        value: function visitor() {
            cache.setCache('isRegisterRealUser', false);

            if (typeof SMSdk !== 'undefined') {
                _index4.default.register();
            } else {
                $.channel.on('smsdkLoaded', function () {
                    _index4.default.register();
                });
                $.channel.on('smsdkLoadedError', function () {
                    _index4.default.register();
                });
            }
        }
    }]);

    return Profile;
}();

exports.default = Profile;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // 拉取礼物信息


var _giftomallGiftlist = __webpack_require__(477);

var _giftomallGiftlist2 = _interopRequireDefault(_giftomallGiftlist);

var _resultresponse = __webpack_require__(269);

var _resultresponse2 = _interopRequireDefault(_resultresponse);

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Code = _resultresponse2.default.Code;
var pbajax = new _pbajax2.default();
var gifto = {
    getList: function getList() {
        var _this = this;

        var promise = $.Deferred();
        var _giftopb$Gifto$Mall$G = _giftomallGiftlist2.default.Gifto.Mall.GiftList,
            Request = _giftopb$Gifto$Mall$G.Request,
            Response = _giftopb$Gifto$Mall$G.Response;

        pbajax.do({
            service: 'gifto_mall',
            api: '/gifto/mall/gift/list',
            header: {
                userToken: UP.Global.getUserToken(),
                'Accept-Language': UP.Global.siteLanguage
                // UserAgent: UserAgent + (window.smDeviceId ? (' smd/' + window.smDeviceId) : '') // 礼物列表，后端会判断版本号，根据版本号给出礼物列表
                // UserAgent: 
            }

        }, null, function (res) {
            var dataWrap = _resultresponse2.default.Result.decode(res);

            if (dataWrap.code == Code.GIFTO_MALL_REQUEST_SUCCESS) {

                var data = Response.decode(dataWrap.data.value);
                if (data.batchSendConfigs.length == 0) {
                    data.batchSendConfigs = [{
                        amount: 1,
                        description: null
                    }];
                }
                _this.data = data;
                promise.resolve(data);
            } else if (dataWrap.code == 8192) {
                // global.login();
            }
        }, function () {
            promise.fail();
        }, function () {

            promise.fail();
        });
        return promise;
    },
    getOnlineGift: function getOnlineGift() {
        var list = this.data.gifts;
        var result = [];
        var whiteTypeList = [1, 12, 6, 7, 16, 24];
        /**
            type 礼物类型：
            1: 静态；2:动态；3:弹幕; 4:文本翻译; 5: 弹幕翻译; 6:精灵; 7:精灵球; 8:点击精灵; 
            9: 宝箱; 10:守护; 11: goole翻译; 12:大动画; 13: 红包; 14: 悄悄话; 15:悄悄话翻译;
            16:新手引导礼物; 17:免费礼物; 19:全区喇叭; 23: 免费无时限装饰; 24:用户打赏装饰; 25:七彩弹幕
            26: 动画弹幕; 27:视频贴纸
         */

        for (var i = 0, len = list.length; i < len; i++) {
            var item = list[i];

            item.guardLevel = item.guardLevel || 0;

            // 屏蔽金币和美金等U钻礼物，type=1  && item.produceType == 2。添加的是U钻 && item.productType=3 Gifto
            if (item.currencyInfo.giftoCurrencyCode == 'GTO' && item.onLined && item.produceType == 3 && whiteTypeList.indexOf(item.type) > -1 && item.guardLevel == 0) {
                item.pic = this.getGiftPicFromId(item.giftId);
                item.price = item.price || 0;
                result.push(item);
            }
        }

        return result;
    },


    // 从在线礼物列表中获取 大礼物图片列表
    // 要排除canCombo的连发图片（不会播大动画）
    getBigGiftPicList: function getBigGiftPicList() {
        var onlineList = this.getOnlineGift();
        var picList = [];
        for (var i = onlineList.length; i--;) {
            var item = onlineList[i];
            if (item.canCombo) {
                continue;
            }
            picList.push(this.getNormalPic(item.resources).big);
        }

        return picList;
    },


    // 价值为10的礼物
    getOnlineCheapGift: function getOnlineCheapGift() {
        var onlineList = this.getOnlineGift();

        var list = [];

        for (var len = onlineList.length, i = 0; i < len; i++) {
            var item = onlineList[i];

            if (parseInt(item.price, 10) == 10) {
                list[list.length] = item;
            }
        }

        return list;
    },


    // 换算成二维数组
    formatDyadicArray: function formatDyadicArray(arr) {
        var result = [];
        var unitCount = 8;
        for (var i = 0, len = arr.length; i < len; i += 8) {
            result.push(arr.slice(i, i + unitCount));
        }
        return result;
    },
    getGiftFromId: function getGiftFromId(giftId) {
        if (!this.data) {
            return;
        }
        var result = void 0;
        var gifts = this.data.gifts;

        for (var i = gifts.length; i--;) {
            var item = gifts[i];
            if (item.giftId == giftId) {
                result = _extends({}, item);
                break;
            }
        }

        return result;
    },


    // 根据礼物id查询礼物图片, 包括big、samll
    getGiftPicFromId: function getGiftPicFromId(giftId) {
        if (!this.data) {
            return;
        }
        var gift = this.getGiftFromId(giftId);

        if (!gift) {
            return;
        }

        var pic = this.getNormalPic(gift.resources);

        return pic;
    },


    // http://g.cdn.upliveapps.com/oauthgame/88806_CN_1484828468_mozilla_
    // getNormalPic(str) {
    //     // ["http://g.cdn.upliveapps.com/oauthgame/88806", "CN", "1484828468", "mozilla", ""]
    //     let arr = str.split('_');
    //     let target = arr[arr.length - 2];
    //     let prefix = str.replace(target, 'android');

    //     return {
    //         big: prefix + 'big.png',
    //         small: prefix + 'small.png',
    //         webp: {
    //             big: prefix + 'big.webp',
    //             middle: prefix + 'middle.webp',
    //             small: prefix + 'small.webp'
    //         }
    //     };
    // },
    // type 1：大图，2：中图，3：小图，4：大动画，5：中动画，6：小动画，7：声音
    getNormalPic: function getNormalPic(resources) {
        var ret = {};

        resources.forEach(function (item) {
            switch (item.type) {
                case 1:
                    ret.big = item.url;
                    break;
                case 2:
                    ret.middle = item.url;
                    break;
                case 3:
                    ret.small = item.url;
                    break;
                case 4:
                    if (!ret.webp) {
                        ret.webp = {};
                    }
                    ret.webp.big = item.url;
                    break;
                case 5:
                    if (!ret.webp) {
                        ret.webp = {};
                    }
                    ret.webp.middle = item.url;
                    break;
                case 6:
                    if (!ret.webp) {
                        ret.webp = {};
                    }
                    ret.webp.small = item.url;
                    break;
                case 7:
                    ret.voice = item.url;
                    break;
                case 9:
                    ret.webpObj = {
                        json: item.json,
                        imgs: item.url.split(',')
                    };
                    break;
            }
        });

        return ret;
    },


    // 预加载大图片
    preLoadBigPic: function preLoadBigPic() {
        // let allpic = this.getBigGiftPicList();

        // let preload = (inx)=>{
        //     if (inx >= allpic.length) {
        //         return;
        //     }
        //     let img = new Image();
        //     img.src = allpic[inx];
        //     if (img.complete) {
        //         preload(inx + 1);
        //     } else {
        //         img.onload = function() {
        //             preload(inx + 1);
        //         }
        //     }
        // };

        // preload(0);
    }
};

exports.default = gifto;

/***/ }),
/* 250 */,
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _confirm = __webpack_require__(73);

var _confirm2 = _interopRequireDefault(_confirm);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 帐号冻结提示
 */
exports.default = {
	show: function show() {
		var _this = this;

		UP.Global.DA.add({
			eventName: 'UplivePaymentFrozen',
			action: 'click'
		});

		_confirm2.default.create({
			title: _lang2.default.template('账号冻结'),
			content: _lang2.default.template('账号被冻结，期间不能使用U钻送礼、发布弹幕等。如需解封，请联系VIP客服哦！'),
			confirmText: _lang2.default.template('VIP客服'),
			modalStyle: {
				marginLeft: location.href.indexOf('/living') > -1 && UP.Global.siteLanguage == 'ar-EG' ? '55px' : '-55px'
			},
			onConfirm: function onConfirm() {
				_this.goServiceRoom();
			}
		});
	},
	goServiceRoom: function goServiceRoom() {
		var userInfo = UP.Global.getUser();
		var origin = void 0;
		var params = void 0;
		var url = void 0;

		if (location.host == 'h5.upliveapp.com') {
			origin = 'http://h5.upliveapp.com';
		} else {
			origin = 'http://m.upliveapps.com';
		}

		params = {
			uid: userInfo.uid,
			country: userInfo.countryCode,
			language: UP.Global.siteLanguage,
			level: userInfo.grade
		};

		url = origin + '/upservice/custom.html?' + $.param(params);

		UP.Global.openInNewTab(url);
	}
};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

var _userUi = __webpack_require__(22);

var _observer = __webpack_require__(96);

var _observer2 = _interopRequireDefault(_observer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItem = function (_Component) {
    _inherits(ListItem, _Component);

    function ListItem(props) {
        _classCallCheck(this, ListItem);

        return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props));
    }

    _createClass(ListItem, [{
        key: "jumpProfile",
        value: function jumpProfile(uid) {
            hashHistory.push('/profile/base/' + uid);

            this.props.onClick();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var item = this.props.item;
            console.log('搜索', item);
            var linkTo = void 0;

            if (item.onlineFlag) {
                linkTo = "/living/" + longToString(item.roomUid) + "/" + longToString(item.roomId);
            } else {
                linkTo = "/profile/base/" + longToString(item.roomUid);
            }
            return _react2.default.createElement(
                "li",
                { "data-uid": item.uid },
                _react2.default.createElement(
                    "div",
                    { className: "list-item", onClick: function onClick() {
                            return _this2.jumpProfile(item.uid);
                        } },
                    _react2.default.createElement(
                        "div",
                        { className: "avatar" },
                        _react2.default.createElement(
                            _observer2.default,
                            null,
                            function (isVisible) {
                                return _react2.default.createElement(_userUi.ImageView, { src: item.avatar, lazyload: true, size: 50, circle: true, isVisible: isVisible });
                            }
                        ),
                        item.officialAuth > 0 ? _react2.default.createElement(_userUi.OfficialAuth, { value: item.officialAuth }) : null
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "refbox" },
                        _react2.default.createElement(
                            "div",
                            { className: "user" },
                            this.props.showList.map(function (key, index) {
                                if (key == 'gender') {
                                    return item.gender ? _react2.default.createElement(_userUi.Gender, { key: "gender", value: item.gender }) : null;
                                }

                                if (key == 'grade') {
                                    return item.grade ? _react2.default.createElement(_userUi.Grade, { key: "grade", value: item.grade }) : null;
                                }

                                return _react2.default.createElement(
                                    "div",
                                    { key: index, className: key },
                                    item[key]
                                );
                            })
                        )
                    )
                ),
                this.props.children
            );
        }
    }]);

    return ListItem;
}(_react.Component);

ListItem.defaultProps = {
    item: {},
    onClick: function onClick() {},
    showList: ['username', 'gender', 'grade', 'signature']
};
exports.default = ListItem;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__(293);

var _index2 = _interopRequireDefault(_index);

var _cNotification = __webpack_require__(11);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _index3 = __webpack_require__(1);

var _index4 = _interopRequireDefault(_index3);

var _cUpLoading = __webpack_require__(13);

var _cUpLoading2 = _interopRequireDefault(_cUpLoading);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.createSocket();
        }

        // 离开时关闭socket连接

    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.close();
        }
    }, {
        key: 'close',
        value: function close() {
            if (this.webchat) {
                this.webchat.destroyPingTimer();
                this.webchat.close(); // 手动断开连接不会发起重连操作
            }
        }
    }, {
        key: 'send',
        value: function send(data) {
            this.webchat.send(data);
        }
    }, {
        key: 'createSocket',
        value: function createSocket() {
            var _this2 = this;

            if (!UP.Global.isLogin()) {
                return;
            }

            var userToken = UP.Global.getUserToken(),
                wType = 0,
                onlyView = this.props.onlyView,
                roomId = this.props.roomid;

            // create a webchat object
            var webchat = this.webchat = new _index2.default({
                userToken: userToken,
                wType: wType,
                roomId: roomId,
                onlyView: onlyView
            });

            // listen the event 'getIntoSuccess' and you will get all the messages about the room, 
            // include websocket parameter, host uid, stream address for video and so on.
            // because the websocket has created by itself, maybe you just need some message 
            // such as uid, stream address.
            webchat.on('getIntoSuccess', function (resp) {
                _cUpLoading2.default.hide();
                _this2.props.onEnterRoomSuccess(resp);
            });

            // when the request was successful, but did not return normal data.
            // then webchat will emit event 'getIntoException'.
            webchat.on('getIntoException', function (code) {
                _cUpLoading2.default.hide();
                setTimeout(function () {
                    _this2.props.onEnterRoomFail(code);
                }, 100);
            });

            // the listener handler will be called when the request is timeout, which get parameter
            // to create websocket object.
            // now, you can make some notifications to let user know what happened.
            webchat.on('getIntoTimeout', function () {
                _cUpLoading2.default.hide();
                _this2.props.onEnterRoomTimeout();
            });

            // when the server is bad, webchat object will emit the event 'getIntoFail'.
            // and you need to notice user what happened as well.
            webchat.on('getIntoFail', function () {
                _cUpLoading2.default.hide();
                _cNotification2.default.simple(_index4.default.template('进入房间失败'));
            });

            // 当出席失败时, 处理异常逻辑
            // 此时不能发送信息到服务端
            webchat.on('attendFail', function (code) {
                var tip = _index4.default.template('连接失败，请退出直播间重新进入');
                _cNotification2.default.simple(tip);
            });

            var closeCount = 0;

            // the websocket create successful and be opening state.
            webchat.on('open', function () {
                closeCount = 0;
            });

            // listen and handle the message transfered from server
            webchat.on('message', function (resp) {
                _this2.props.onMessage(resp);
            });

            // in the case of network dropped, the client ping request will not reach the server.
            // when the server miss the ping request twice, it will close the websocket with client,
            // the client can listen the closing state, and execute the handler you binded.
            // in general, you need to try reconnect the websocked to server. 
            // also we provide the 'webchat.reconnect' api for you. 
            webchat.on('close', function (cfg) {
                // console.log('socket closed');

                // 若手动断开，则返回
                if (this.closeByManual) {
                    return;
                }

                // 异常状态导致连接断开，发起重连操作
                if (closeCount >= 0) {
                    webchat.reinit();
                    closeCount = 0;
                    return;
                }
                setTimeout(function () {
                    webchat.reconnect();
                    closeCount++;
                }, 1500);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);

    return _class;
}(_react.Component);

_class.defaultProps = {
    onEnterRoomSuccess: function onEnterRoomSuccess() {},
    onEnterRoomFail: function onEnterRoomFail() {},
    onMessage: function onMessage() {},

    roomid: '',
    onlyView: 0
};
exports.default = _class;
;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _disabled = __webpack_require__(667);

var _disabled2 = _interopRequireDefault(_disabled);

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var pbajax = new _pbajax2.default();

var StopLive = function (_Component) {
    _inherits(StopLive, _Component);

    function StopLive(props) {
        _classCallCheck(this, StopLive);

        var _this = _possibleConstructorReturn(this, (StopLive.__proto__ || Object.getPrototypeOf(StopLive)).call(this, props));

        _this.state = {
            hostRoomInfo: {}
        };
        return _this;
    }

    _createClass(StopLive, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            var promise = this.getDisabledIntoMsg();

            promise.done(function (data) {
                _this2.setState({
                    hostRoomInfo: data
                });
            });
        }
    }, {
        key: 'getDisabledIntoMsg',
        value: function getDisabledIntoMsg() {
            var self = this;
            var _disabledpb$Room$Anch = _disabled2.default.Room.AnchorDisabledGet,
                Request = _disabledpb$Room$Anch.Request,
                Response = _disabledpb$Room$Anch.Response;


            var businessData = new Request({
                roomId: this.props.roomId
            });
            var defer = $.Deferred();

            pbajax.do({
                service: 'room',
                api: '/room/anchor/disabled/get',
                header: {
                    userToken: UP.Global.getUserToken(),
                    'Accept-Language': UP.Global.siteLanguage
                }
            }, businessData, function (res) {

                var dataWrap = _public2.default.Result.decode(res);
                var data = void 0;

                if (dataWrap.code == 1) {
                    data = Response.decode(dataWrap.data.value);
                    defer.resolve(data);
                } else {
                    defer.reject();
                }
            }, function () {
                defer.reject();
            }, function () {
                defer.reject();
            });

            return defer.promise();
        }
    }, {
        key: 'backhome',
        value: function backhome() {
            hashHistory.push('/home');
        }
    }, {
        key: 'render',
        value: function render() {
            var hostInfo = this.props.hostInfo;
            var hostRoomInfo = this.state.hostRoomInfo;

            var diamond = longToString(hostRoomInfo.moneyTotal) || 0;
            var likeNum = longToString(hostRoomInfo.likeNum) || 0;
            var viewer = longToString(hostRoomInfo.peoples) || 0;

            return _react2.default.createElement(
                'div',
                { className: 'excetion-wrap livend' },
                _react2.default.createElement(
                    'div',
                    { className: 'content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'content-hd' },
                        _react2.default.createElement(
                            'div',
                            { className: 'avatar' },
                            _react2.default.createElement('img', { src: hostInfo.avatar })
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'nickname' },
                            hostInfo.username
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'content-bd' },
                        _react2.default.createElement('div', { className: 'time' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'viewer' },
                            _react2.default.createElement(
                                'em',
                                null,
                                viewer
                            ),
                            _index2.default.template('观看人数')
                        )
                    )
                ),
                this.props.from !== 'home' ? _react2.default.createElement(
                    'div',
                    { className: 'btns' },
                    _react2.default.createElement(
                        'button',
                        { className: 'home', onClick: this.backhome },
                        _index2.default.template('去看看其他主播')
                    )
                ) : null
            );
        }
    }]);

    return StopLive;
}(_react.Component);

StopLive.defaultProps = {
    roomId: '',
    hostInfo: {}
};
exports.default = StopLive;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StopLive = function (_Component) {
    _inherits(StopLive, _Component);

    function StopLive() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, StopLive);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StopLive.__proto__ || Object.getPrototypeOf(StopLive)).call.apply(_ref, [this].concat(args))), _this), _this.retry = function () {
            _this.props.reconnectRoom();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(StopLive, [{
        key: 'backhome',
        value: function backhome() {
            hashHistory.push('/home');
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'excetion-wrap livend' },
                _react2.default.createElement(
                    'div',
                    { className: 'content' },
                    _index2.default.template('连接直播间超时')
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'btns' },
                    _react2.default.createElement(
                        'button',
                        { onClick: this.retry },
                        _index2.default.template('再试一次')
                    ),
                    this.props.from !== 'home' ? _react2.default.createElement(
                        'button',
                        { className: 'gray', onClick: this.backhome },
                        _index2.default.template('去看看其他主播')
                    ) : null
                )
            );
        }
    }]);

    return StopLive;
}(_react.Component);

exports.default = StopLive;

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getNewImageUrl = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(460);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 图片尺寸
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

// devicePixelRatio
var DPR = window.devicePixelRatio ? window.devicePixelRatio : 1;

// 图片后缀正则
var REG_IMG_EXT = /.(jpg|png|gif|jpeg)/i;

// 图片url正则
var REG_IMG_SRC = /^(?:(?:http|https):)?\/\/(.+\.((?:upcdn|cdn))\.((?:pengpengla|upliveapp|upliveapps))\.(?:com))(\/.*(?:\.(jpg|png|gif|jpeg|webp))?)$/i;

var IMG_DEFAULT_SRC = '//g.cdn.pengpengla.com/oauthgame/html5/20170606/0c0688e97bf70219860dc285cf8a3fdc.png';

var IMG_PLACEHOLDE = "//g.cdn.pengpengla.com/oauthgame/html5/20181014/484a481c33c891be09c2a5c34bc08b2d.jpg";
// 海外CDN图片尺寸的大小列表
var IMG_SIZE_LIST = [50, 80, 100, 300];
// const IMG_SIZE_LIST = [50, 80, 100];

var getNewImageUrl = function getNewImageUrl(url, size) {
    var newUrl = void 0;

    size = size || 300;

    url = url.replace('p-cdn.upliveapp.com', 'p.cdn.upliveapp.com');

    if (url.match(REG_IMG_SRC)) {

        var cdnSize = url.match(REG_IMG_SRC);

        if (cdnSize[2] == 'upcdn' || cdnSize[3] == 'upliveapp' || cdnSize[3] == 'upliveapps') {
            // 海外头像
            var exts = url.match(REG_IMG_EXT);

            if (exts) {
                var ext = '_' + size + '_' + size + exts[0];
                newUrl = url.replace(REG_IMG_EXT, ext);
            } else {
                // console.log('图片后缀名错误');
            }
        } else {
            newUrl = url + '?imageView2/1/w/' + size + '/h/' + size;
        }
    } else {
        newUrl = url;
    }
    // TODO 用正则处理
    newUrl = newUrl.replace('http://p.cdn.upliveapp.com', 'https://p-cdn.upliveapp.com');
    newUrl = newUrl.replace('http://p.cdn.upliveapps.com', 'https://p-cdn.upliveapp.com');
    newUrl = newUrl.replace('http://p.upcdn.pengpengla.com', 'https://p.upcdn.pengpengla.com');

    return newUrl;
};

var Image = function (_Component) {
    _inherits(Image, _Component);

    function Image(props) {
        _classCallCheck(this, Image);

        var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props));

        _this.onLoad = function (e) {
            var img = _this.refs.img;

            if (img) {
                var node = $(img);

                img.style.opacity = "1";
                img.onload = img.onerror = null;
                _this.timer = setTimeout(function () {
                    _this.timer && clearTimeout(_this.timer);
                    node.removeClass("ui-fade");
                }, 700);
                _this.loaded = true;
            }
        };

        _this.state = {
            src: props.src,
            isVisible: props.isVisible
        };
        _this.loaded = false;
        return _this;
    }

    _createClass(Image, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var isVisible = this.state.isVisible || nextProps.isVisible;

            this.setState({
                src: nextProps.src,
                isVisible: isVisible
            });
        }
    }, {
        key: 'getNewUrl',

        /**
         * 输出转换后的图片url
         * @param {string} src 图片url
         */
        value: function getNewUrl(url) {
            var width = this.props.width || this.props.size;
            var height = this.props.height || this.props.size;
            var defaultSize = this.props.size || this.props.width;
            var newUrl = void 0;

            url = url.replace('p-cdn.upliveapp.com', 'p.cdn.upliveapp.com');

            if (url.match(REG_IMG_SRC)) {

                var cdnSize = url.match(REG_IMG_SRC);

                if (this.props.type == 'square') {

                    if (cdnSize[2] == 'upcdn' || cdnSize[3] == 'upliveapp' || cdnSize[3] == 'upliveapps') {
                        // 海外头像
                        var size = this.props.imageSize || this.getBestCdnSize(defaultSize); // 头像 width == height
                        var exts = url.match(REG_IMG_EXT);

                        if (exts) {
                            var ext = '_' + size + '_' + size + exts[0];
                            newUrl = url.replace(REG_IMG_EXT, ext);
                        } else {
                            // console.log('图片后缀名错误');
                        }
                    } else {
                        newUrl = this.state.src + '?imageView2/1/w/' + width + '/h/' + height;
                    }
                } else {
                    newUrl = this.state.src + '?imageView2/1/w/' + width + '/h/' + height;
                }
            } else {
                newUrl = url;
            }

            // TODO 用正则处理
            newUrl = newUrl.replace('http://p.cdn.upliveapp.com', 'https://p-cdn.upliveapp.com');
            newUrl = newUrl.replace('http://p.cdn.upliveapps.com', 'https://p-cdn.upliveapp.com');
            newUrl = newUrl.replace('http://p.upcdn.pengpengla.com', 'https://p.upcdn.pengpengla.com');

            return newUrl;
        }
        /**
         * 获取海外头像图片最佳尺寸
         * @param  {number| string} curSize 图片尺寸
         */

    }, {
        key: 'getBestCdnSize',
        value: function getBestCdnSize(curSize) {
            if (!curSize || typeof curSize != 'string' && typeof curSize != 'number') {
                // console.log('未设置图片尺寸');
            }
            var sizeList = IMG_SIZE_LIST;
            var max = sizeList[sizeList.length - 1];
            var min = sizeList[0];
            var bestSize = 0;

            if (max <= curSize) {
                return max;
            }
            if (min >= curSize) {
                return min;
            }

            for (var i = sizeList.length; i >= 0; i--) {
                if (sizeList[i] <= curSize) {
                    if (sizeList[i] == curSize) {
                        bestSize = curSize;
                    } else {
                        if (i < sizeList.length - 1) {
                            // 取最近最优的尺寸
                            bestSize = sizeList[i + 1];
                        }
                    }
                    break;
                }
            }

            return bestSize;
        }
    }, {
        key: 'render',
        value: function render() {
            var width = this.props.width || this.props.size;
            var height = this.props.height || this.props.size;
            var cls = 'ui-img';
            var style = {};
            var props = void 0;

            cls += this.props.bordered ? ' ui-bordered' : '';
            cls += this.props.circle ? ' ui-circle' : '';
            cls += this.props.rounded ? ' ui-rounded' : '';

            style = {
                width: width,
                height: height
            };

            if (this.props.lazyload) {
                if (this.state.isVisible) {
                    props = {
                        src: this.state.src ? this.getNewUrl(this.state.src) : IMG_PLACEHOLDE
                    };

                    return _react2.default.createElement(
                        'span',
                        { className: cls, style: style, 'data-width': width, 'data-source': this.state.src, 'data-height': height },
                        _react2.default.createElement('img', _extends({ ref: 'img' }, props, { alt: '' }))
                    );
                } else {
                    props = {
                        'data-src': this.state.src ? this.getNewUrl(this.state.src) : '',
                        src: IMG_PLACEHOLDE
                    };

                    return _react2.default.createElement(
                        'span',
                        { className: cls, style: style, 'data-width': width, 'data-height': height },
                        _react2.default.createElement('img', _extends({ ref: 'img' }, props))
                    );
                }
            } else {
                props = {
                    src: this.state.src ? this.getNewUrl(this.state.src) : IMG_PLACEHOLDE
                };
                return _react2.default.createElement(
                    'span',
                    { className: cls, style: style, 'data-width': width, 'data-source': this.state.src, 'data-height': height },
                    _react2.default.createElement('img', _extends({ ref: 'img' }, props, { onLoad: this.onLoad, alt: '' }))
                );
            }
        }
    }]);

    return Image;
}(_react.Component);

Image.defaultProps = {
    lazyload: false,
    src: '', // 图片地址
    cssmode: 640,
    type: 'square', // 图片类型，默认square: 正方形，custom: 裁剪称任意类型，只有七牛图片才支持
    size: '',
    width: '', // 图片宽度
    height: '', // 图片高度
    circle: false, // 圆形
    rounded: false, // 椭圆
    bordered: false
};
exports.default = Image;
exports.getNewImageUrl = getNewImageUrl;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _ScaleModal = __webpack_require__(12);

var _ScaleModal2 = _interopRequireDefault(_ScaleModal);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _payresult = __webpack_require__(229);

var _payresult2 = _interopRequireDefault(_payresult);

var _bindphoneGuid = __webpack_require__(616);

var _bindphoneGuid2 = _interopRequireDefault(_bindphoneGuid);

var _frozen = __webpack_require__(251);

var _frozen2 = _interopRequireDefault(_frozen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 支付结果提示
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var cache = new _cCache2.default({
	prefix: 'pcuplive'
});

var style = {
	modalStyle: {
		width: '320px',
		zIndex: 1070
	},
	contentStyle: {
		width: '320px',
		borderRadius: '6px',
		backgroundColor: '#fff',
		outline: 0
	},
	backdropStyle: {
		backgroundColor: "rgba(0,0,0, 0.5)",
		zIndex: 1060
	}
};

var RechargeResult = function (_Component) {
	_inherits(RechargeResult, _Component);

	function RechargeResult(props) {
		_classCallCheck(this, RechargeResult);

		var _this = _possibleConstructorReturn(this, (RechargeResult.__proto__ || Object.getPrototypeOf(RechargeResult)).call(this, props));

		_this.state = {
			paySuccess: 0,
			diamond: 0
		};
		return _this;
	}

	_createClass(RechargeResult, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			var paid = cache.getCache('_u_paid');
			var orderId = cache.getCache('_u_orderId_' + paid);
			var channel = cache.getCache('_u_paid_channel');
			var paidret = cache.getCache('_u_paidret');

			if (orderId) {
				// 回调地址已知道结果
				if (paidret) {
					var arr = paidret.split('/');

					if (arr.length == 2 && arr[0] == paid) {
						if (arr[1] == 1) {
							this.showResultSuccess();
						} else if (arr[1] == 0) {
							this.showResultError();
						}
					}
				} else {
					if (channel == 'icard') {
						this.refs.warn.show();
					} else {
						var checkCount = 0;
						var timer;
						var checkFun = function checkFun(orderId) {
							timer && clearTimeout(timer);

							var verifyOrder = new _payresult2.default(orderId);

							verifyOrder.promise.done(function (resp) {
								_this2.showResultSuccess();
							}).fail(function () {
								checkCount++;

								if (checkCount <= 4) {
									timer = setTimeout(function () {
										checkFun(orderId);
									}, 2 * 1000);
								} else {
									_this2.showResultError();
								}
							});
						};

						checkFun(orderId);
					}
				}

				cache.removeCache('_u_paid');
				cache.removeCache('_u_paidret');
				cache.removeCache('_u_paid_channel');
				cache.removeCache('_u_orderId_' + paid);
			}
		}
	}, {
		key: 'showResultSuccess',
		value: function showResultSuccess() {
			UP.Global.DA.add({
				eventName: 'UplivePayment',
				action: 'Payment Successful',
				label: 'success'
			});
			UP.Global.DA.add({
				eventName: 'UplivePaymentSuccessful',
				action: 'click'
			});
			this.refs.success.show();
		}
	}, {
		key: 'showResultError',
		value: function showResultError(code) {

			if (code == 12323) {
				_frozen2.default.show();
			} else {
				this.refs.error.show();
			}
		}
	}, {
		key: 'hideResultSuccess',
		value: function hideResultSuccess() {
			this.refs.success.hide();

			setTimeout(function () {
				var userInfo = UP.Global.getUser();
				var hasBindMobilePhone = userInfo.mobilePhone ? true : false;

				if (!hasBindMobilePhone) {
					_bindphoneGuid2.default.show();
				}
			}, 300);
		}
	}, {
		key: 'hideResultError',
		value: function hideResultError() {
			this.refs.error.hide();
		}
	}, {
		key: 'hideResultWarn',
		value: function hideResultWarn() {
			this.refs.warn.hide();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					_ScaleModal2.default,
					{
						ref: 'success',
						modalStyle: style.modalStyle,
						backdropStyle: style.backdropStyle,
						contentStyle: style.contentStyle
					},
					_react2.default.createElement(
						'div',
						{ className: 'recharge-result' },
						_react2.default.createElement(
							'div',
							{ className: 'recharge-result-hd' },
							_lang2.default.template('提示')
						),
						_react2.default.createElement(
							'div',
							{ className: 'recharge-result-bd' },
							_lang2.default.template('充值成功')
						),
						_react2.default.createElement(
							'div',
							{ className: 'recharge-result-ft' },
							_react2.default.createElement(
								'button',
								{ className: 'btn confirm', onClick: function onClick() {
										return _this3.hideResultSuccess();
									} },
								_lang2.default.template('确认')
							)
						)
					)
				),
				_react2.default.createElement(
					_ScaleModal2.default,
					{
						ref: 'error',
						modalStyle: style.modalStyle,
						backdropStyle: style.backdropStyle,
						contentStyle: style.contentStyle
					},
					_react2.default.createElement(
						'div',
						{ className: 'recharge-result' },
						_react2.default.createElement(
							'div',
							{ className: 'recharge-result-hd' },
							_lang2.default.template('提示')
						),
						_react2.default.createElement(
							'div',
							{ className: 'recharge-result-bd' },
							_lang2.default.template('支付失败，请重新下单')
						),
						_react2.default.createElement(
							'div',
							{ className: 'recharge-result-ft' },
							_react2.default.createElement(
								'button',
								{ className: 'btn confirm', onClick: function onClick() {
										return _this3.hideResultError();
									} },
								_lang2.default.template('确认')
							)
						)
					)
				),
				_react2.default.createElement(
					_ScaleModal2.default,
					{
						ref: 'warn',
						modalStyle: style.modalStyle,
						backdropStyle: style.backdropStyle,
						contentStyle: style.contentStyle
					},
					_react2.default.createElement(
						'div',
						{ className: 'recharge-result' },
						_react2.default.createElement(
							'div',
							{ className: 'recharge-result-hd' },
							_lang2.default.template('提示')
						),
						_react2.default.createElement(
							'div',
							{ className: 'recharge-result-bd' },
							_lang2.default.template('Giao dịch thành công, thanh toán này sẽ xử lý 5-10 phút.')
						),
						_react2.default.createElement(
							'div',
							{ className: 'recharge-result-ft' },
							_react2.default.createElement(
								'button',
								{ className: 'btn confirm', onClick: function onClick() {
										return _this3.hideResultWarn();
									} },
								_lang2.default.template('确认')
							)
						)
					)
				)
			);
		}
	}]);

	return RechargeResult;
}(_react.Component);

exports.default = RechargeResult;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ScaleModal = __webpack_require__(12);

var _ScaleModal2 = _interopRequireDefault(_ScaleModal);

var _bindphoneView = __webpack_require__(290);

var _bindphoneView2 = _interopRequireDefault(_bindphoneView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 绑定手机
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var noop = function noop() {};

var style = {
    modalStyle: {
        width: '500px'
    },
    contentStyle: {
        width: '500px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        backgroundColor: "rgba(0,0,0, 0.5)"
    }
};

var BindPhonePop = function (_Component) {
    _inherits(BindPhonePop, _Component);

    function BindPhonePop(props) {
        _classCallCheck(this, BindPhonePop);

        return _possibleConstructorReturn(this, (BindPhonePop.__proto__ || Object.getPrototypeOf(BindPhonePop)).call(this, props));
    }

    _createClass(BindPhonePop, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.showModal();
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            // 在隐藏动画执行完成之后再触发事件onConfirm
            if (this.status == 'confirm') {
                this.props.onComplete(this.mobilePhone);
            }

            this.props.onHide();
        }
    }, {
        key: 'onClose',
        value: function onClose() {
            this.hideModal();
            this.status = 'cancel';
        }
    }, {
        key: 'showModal',
        value: function showModal() {
            this.refs.modal.show();
        }
    }, {
        key: 'hideModal',
        value: function hideModal() {
            this.refs.modal.hide();
        }
    }, {
        key: 'bindphoneComplete',
        value: function bindphoneComplete(mobilePhone) {
            this.hideModal();
            this.status = 'confirm';
            this.mobilePhone = mobilePhone;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var modalStyle = style.modalStyle;
            var backdropStyle = style.backdropStyle;
            var contentStyle = style.contentStyle;

            if (this.props.modalStyle) {
                for (var _style in this.props.modalStyle) {
                    modalStyle[_style] = this.props.modalStyle[_style];
                }
            }

            if (this.props.backdropStyle) {
                for (var _style2 in this.props.backdropStyle) {
                    backdropStyle[_style2] = this.props.backdropStyle[_style2];
                }
            }

            if (this.props.contentStyle) {
                for (var _style3 in this.props.contentStyle) {
                    contentStyle[_style3] = this.props.contentStyle[_style3];
                }
            }

            return _react2.default.createElement(
                _ScaleModal2.default,
                {
                    ref: 'modal',
                    closeOnClick: false,
                    onHide: this.onHide.bind(this),
                    modalStyle: modalStyle,
                    backdropStyle: backdropStyle,
                    contentStyle: contentStyle
                },
                _react2.default.createElement(
                    'div',
                    { className: 'bind-pop' },
                    _react2.default.createElement(
                        'div',
                        { className: 'box' },
                        _react2.default.createElement(
                            'div',
                            { className: 'bind-pop-hd' },
                            _react2.default.createElement(
                                'span',
                                { className: 'close', onClick: function onClick() {
                                        return _this2.onClose();
                                    } },
                                'x'
                            )
                        ),
                        _react2.default.createElement(_bindphoneView2.default, { onComplete: this.bindphoneComplete.bind(this) })
                    )
                )
            );
        }
    }]);

    return BindPhonePop;
}(_react.Component);

BindPhonePop.defaultProps = {
    content: '',
    onHide: noop,
    onComplete: noop
};


module.exports = {
    create: function create(cfg) {
        cfg = cfg || {};

        if (this.layer) {
            this.destroy();
        }
        var mountNode = this.createMountNode();

        this.layer = _reactDom2.default.render(_react2.default.createElement(BindPhonePop, _extends({}, cfg, { onHide: this.onHide.bind(this) })), mountNode);
    },
    onHide: function onHide() {
        this.destroy();
    },
    // 创建组件插入的DOM节点
    createMountNode: function createMountNode() {
        this.mountNode = document.createElement("div");
        $(document.body).append(this.mountNode);
        return this.mountNode;
    },
    destroy: function destroy() {
        _reactDom2.default.unmountComponentAtNode(this.mountNode);
        $(this.mountNode).remove();
        delete this.layer;
    }
};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

var _videolayer = __webpack_require__(659);

var _videolayer2 = _interopRequireDefault(_videolayer);

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 登出弹出层
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var VideoPop = function (_Component) {
    _inherits(VideoPop, _Component);

    function VideoPop(props) {
        _classCallCheck(this, VideoPop);

        var _this = _possibleConstructorReturn(this, (VideoPop.__proto__ || Object.getPrototypeOf(VideoPop)).call(this, props));

        _this.onCancel = function (e) {
            UP.Global.videoInfo = null;

            _this.props.onHide();
        };

        _this.state = {
            style: {
                left: UP.Global.siteLanguage == 'ar-EG' ? document.documentElement.offsetWidth - 320 - 10 + 'px' : '10px',
                top: document.documentElement.offsetHeight - 540 - 10 + 'px'
            }
        };

        _this.elementOffset = {
            x: 0,
            y: 0
        };
        return _this;
    }

    _createClass(VideoPop, [{
        key: 'onMouseDown',
        value: function onMouseDown(e) {
            var el = this.refs.container;
            var offset = this.getDocumentRelativeElementOffset(el);

            if ($(e.target).parents('.vcp-controls-panel').length > 0) {
                this.draging = false;
                return;
            }
            this.draging = true;
            this.dragStartTime = +new Date();

            window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty();

            this.elementOffset = {
                x: e.clientX,
                y: e.clientY,
                minLeft: 0,
                minTop: 0,
                maxLeft: offset.width - offset.elwidth,
                maxTop: offset.height - offset.elheight
            };

            this.setState({
                style: {
                    left: offset.x,
                    top: offset.y
                }
            });
        }
    }, {
        key: 'onMouseMove',
        value: function onMouseMove(e) {
            window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty();

            if (this.draging) {
                var _getOffsetPosition = this.getOffsetPosition({ x: e.clientX, y: e.clientY }),
                    x = _getOffsetPosition.x,
                    y = _getOffsetPosition.y;

                this.elementOffset.x = e.clientX;
                this.elementOffset.y = e.clientY;

                this.setState({
                    style: {
                        left: x,
                        top: y
                    }
                });
            }
        }
    }, {
        key: 'getOffsetPosition',
        value: function getOffsetPosition(position, holdInPanel) {
            var _elementOffset = this.elementOffset,
                x = _elementOffset.x,
                y = _elementOffset.y,
                minLeft = _elementOffset.minLeft,
                maxLeft = _elementOffset.maxLeft,
                minTop = _elementOffset.minTop,
                maxTop = _elementOffset.maxTop;

            var style = this.state.style;

            var left = style.left + (position.x - x);
            var top = style.top + (position.y - y);

            if (holdInPanel) {
                if (left < minLeft) {
                    left = minLeft;
                } else if (left > maxLeft) {
                    left = maxLeft;
                }

                if (top < minTop) {
                    top = minTop;
                } else if (top > maxTop) {
                    top = maxTop;
                }
            }

            return {
                x: left,
                y: top
            };
        }
    }, {
        key: 'onMouseUp',
        value: function onMouseUp(e) {
            if (this.draging) {
                this.draging = false;
                this.dragHoldTime = +new Date() - this.dragStartTime;

                var _getOffsetPosition2 = this.getOffsetPosition({ x: e.clientX, y: e.clientY }, true),
                    x = _getOffsetPosition2.x,
                    y = _getOffsetPosition2.y;

                this.setState({
                    style: {
                        left: x,
                        top: y
                    }
                });
            }
        }
    }, {
        key: 'getDocumentRelativeElementOffset',
        value: function getDocumentRelativeElementOffset(el) {
            // const parentEl = this.getRelativeParentOfEl(el);

            // const {
            //     left: docLeft,
            //     top: docTop,
            //     width: width,
            //     height: height
            // } = parentEl.getBoundingClientRect();

            var _el$getBoundingClient = el.getBoundingClientRect(),
                elLeft = _el$getBoundingClient.left,
                elTop = _el$getBoundingClient.top,
                elwidth = _el$getBoundingClient.width,
                elheight = _el$getBoundingClient.height;

            return {
                x: elLeft,
                y: elTop,
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight,
                elwidth: elwidth,
                elheight: elheight
            };
        }
    }, {
        key: 'getRelativeParentOfEl',
        value: function getRelativeParentOfEl(el) {
            if (el.parentElement) {
                if ($(el.parentElement).css('position') == 'static' && el.tagName !== 'HTML') {
                    return this.getRelativeParentOfEl(el.parentElement);
                } else {
                    return el.parentElement;
                }
            } else {
                return el;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var data = this.props.data;

            return _react2.default.createElement(
                'div',
                {
                    ref: 'container',
                    className: 'video-pop-wrap',
                    style: this.state.style,
                    onMouseDown: this.onMouseDown.bind(this),
                    onMouseMove: this.onMouseMove.bind(this),
                    onMouseUp: this.onMouseUp.bind(this),
                    onMouseLeave: this.onMouseUp.bind(this)
                },
                _react2.default.createElement('div', { className: 'video-pop-close', onClick: this.onCancel }),
                _react2.default.createElement(
                    'div',
                    { className: 'video-pop' },
                    _react2.default.createElement(
                        'div',
                        { className: 'video-screen' },
                        _react2.default.createElement(_videolayer2.default, { ref: 'videolayer', videoid: 'videolayer', key: data.roomid, hostid: data.hostid, roomid: data.roomid, avatar: data.avatar })
                    )
                )
            );
        }
    }]);

    return VideoPop;
}(_react.Component);

VideoPop.defaultProps = {
    data: {}
};


module.exports = {
    create: function create(cfg) {
        cfg = cfg || {};

        if (this.layer) {
            if (cfg.data && this.roomid == cfg.data.roomid) {
                return;
            }
            this.destroy();
        }

        this.roomid = cfg.data.roomid;

        var mountNode = this.createMountNode();

        this.layer = _reactDom2.default.render(_react2.default.createElement(VideoPop, _extends({}, cfg, { onHide: this.onHide.bind(this) })), mountNode);
    },
    onHide: function onHide() {
        this.destroy();
    },
    // 创建组件插入的DOM节点
    createMountNode: function createMountNode() {
        this.mountNode = document.createElement("div");
        $(document.body).append(this.mountNode);
        return this.mountNode;
    },

    destroy: function destroy() {
        if (!this.layer) {
            return;
        }
        _reactDom2.default.unmountComponentAtNode(this.mountNode);
        $(this.mountNode).remove();
        delete this.layer;
    }
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @fileoverview 播放flash
 * @author zhenn
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, module) {
    var Base = __webpack_require__(56);

    var Flv = Base.extend({
        defaults: {
            wrap: "#wrap",
            source: {
                flv: "http://flv-player.net/medias/KyodaiNoGilga.flv"
            },
            sourceType: {
                flv: "video/flv",
                hls: "application/x-mpegURL"
            },
            id: 'video1',
            controls: true,
            isLandscape: false,
            videoLoad: function videoLoad() {}
        },

        _compareVersion: function _compareVersion(a, b) {
            var aPart, aParts, bPart, bParts, i, len;
            if (a === b) {
                return 0;
            }
            aParts = (a + '').split('.');
            bParts = (b + '').split('.');
            for (i = 0, len = Math.max(aParts.length, bParts.length); i < len; ++i) {
                aPart = parseInt(aParts[i], 10);
                bPart = parseInt(bParts[i], 10);
                isNaN(aPart) && (aPart = 0);
                isNaN(bPart) && (bPart = 0);
                if (aPart < bPart) {
                    return -1;
                }
                if (aPart > bPart) {
                    return 1;
                }
            }
            return 0;
        },

        initialize: function initialize() {
            var userAgent = window.navigator.userAgent;
            var isSafariShowHls = true;

            if (userAgent.indexOf('Safari') > -1) {
                var s = userAgent.match(/version\/([\d.]+).*safari/i);
                var safariVersion = '9.1.2';
                if (s != null && (typeof s === "undefined" ? "undefined" : _typeof(s)) === 'object') {

                    safariVersion = s[1];
                }
                if (this._compareVersion(safariVersion, '10.1') > 0) {
                    isSafariShowHls = false;
                }
            }

            var self = this,
                wrap = $(self.get('wrap')),
                videoSourceArrHLS = ['<video id="' + this.get('id') + '" width="0" height="0" autoplay>', '<source type="video/x-mpegURL" data-type="hls">', '<source type="application/x-shockwave-flash" data-type="flv">', '</video>'],
                videoSourceArrFLV = ['<video id="' + this.get('id') + '" width="0" height="0" autoplay>', '<source type="application/x-shockwave-flash" data-type="flv">', '</video>'],
                ch = self.ch = document.documentElement.clientHeight,
                cw = self.cw = document.body.clientWidth;

            var source = self.get('source');
            var sourceType = self.get('sourceType');

            if (isSafariShowHls && source.hls) {
                videoSourceArr = videoSourceArrHLS;
            } else {
                videoSourceArr = videoSourceArrFLV;
            }

            var element = $(videoSourceArr.join(''));

            wrap.append(element);

            $.map(source, function (item, key) {
                var _source = sourceType[key];

                if (key == 'flv') {
                    item = item.replace('http://wsflv.upliveapp.com', 'https://wsflv.upliveapp.com');
                } else if (key == 'hls') {
                    item = item.replace('http://wshls.upliveapp.com', 'https://wshls.upliveapp.com');
                }

                if (_source) {
                    element.find('[data-type="' + key + '"]').attr('src', item).attr('type', _source);
                }
            });
            // element.find('[data-type="hls"]').attr('src', self.get('source')).attr('type', 'application/x-mpegURL');
            // element.find('[data-type="flv"]').attr('src', self.get('source')).attr('type', 'video/flv');
        },

        play: function play(wrap, source) {
            var self = this;
            var height = '100%';
            var isLandscape = self.get('isLandscape');
            // if ($('#videoWrap').length > 0) {
            //     height = $('#videoWrap').height() - 2;
            // } else if ($('.J_VideoWrap').length > 0) {
            //     height = $('.J_VideoWrap').height() - 2;
            // }

            var controls = self.get('controls');

            var flv = this.flv = VideoJS(this.get('id'), {
                techOrder: ["html5", "flash"],
                autoplay: true,
                controls: controls,
                poster: 'https://g.cdn.pengpengla.com/oauthgame/html5/20170606/0c0688e97bf70219860dc285cf8a3fdc.png',
                controlBar: {
                    captionsButton: false,
                    chaptersButton: false,
                    liveDisplay: false,
                    playbackRateMenuButton: false,
                    subtitlesButton: false
                }

            });

            flv.ready(function () {
                // 默认音量，全局控制
                this.volume(typeof window.videoJSLastVolume !== 'undefined' ? window.videoJSLastVolume : 0.7);

                this.one("loadeddata", function () {
                    var _this = this;

                    self.viewsizeTimer && clearTimeout(self.viewsizeTimer);
                    self.viewsizeTimer = setTimeout(function () {
                        $(_this.el).addClass("video-js vjs-default-skin").css({
                            width: '100%',
                            height: '100%'
                            // '-webkit-transform': 'scale(1.03)'
                        });

                        clearTimeout(self.viewsizeTimer);
                        if (!isLandscape) {
                            var i = 99.8;
                            var timer, timer1;

                            var changeWidth = function changeWidth() {
                                if (i >= 100.3) {
                                    timer && clearTimeout(timer);
                                    return;
                                }
                                i += 0.01;

                                $(_this.el).css({
                                    height: i + '%'
                                });

                                timer = setTimeout(function () {
                                    changeWidth();
                                }, 100);
                            };

                            changeWidth();

                            timer1 = setTimeout(function () {
                                i = 99.8;
                                timer1 && clearTimeout(timer1);
                                changeWidth();
                            }, 2000);
                        }
                    }, 1.5 * 1000);

                    self.emit("start");
                    self.emit("loadeddata");
                });
                var videoload = self.get('videoLoad');
                videoload.call(this, self.flv);

                this.one("ended", function () {
                    self.emit("ended");
                });
            });
            var wrapCss = void 0;
            if (isLandscape) {

                wrapCss = {
                    width: '100%',
                    height: '100%'
                };
            } else {
                wrapCss = {
                    width: '100%',
                    height: '100%',
                    '-webkit-transform': 'scale(1.03)'
                };
            }
            $("#" + this.get('id')).addClass("video-js vjs-default-skin").css(wrapCss);
            // flv.width(480);
            // flv.height(813);
        },

        showControlBar: function showControlBar() {
            if (this.flv) {
                this.flv.controlBar.fadeIn();
            }
        },

        hideControlBar: function hideControlBar() {
            if (this.flv) {
                this.flv.controlBar.fadeOut();
            }
        },
        fullScreen: function fullScreen() {
            if (this.flv) {
                this.flv.requestFullScreen();
            }
        },
        playToggle: function playToggle() {
            if (this.flv) {
                if (this.flv.paused()) {
                    this.flv.play();
                } else {
                    this.flv.pause();
                }
            }
        },
        volumeToggle: function volumeToggle(isMute) {
            if (this.flv) {
                if (isMute) {

                    this.volumeLevel = this.flv.volume();
                    this.flv.muted(true);
                    this.flv.volume(0);
                    window.videoJSLastVolume = 0;
                } else {
                    var lastVolume = this.volumeLevel || this.flv.volume();
                    this.flv.muted(false);
                    this.flv.volume(lastVolume);
                    window.videoJSLastVolume = this.volumeLevel;
                }
            }
        },
        volumeLevel: function volumeLevel() {
            if (!this.flv) {
                return;
            }
            var vol = this.flv.volume();
            var level = 0;

            if (vol == 0 || this.flv.muted()) {
                level = 0;
            } else {

                level = vol;
            }
            return level;
        },
        volumeChange: function volumeChange(volumeLevel) {
            window.videoJSLastVolume = volumeLevel;
            this.volumeLevel = volumeLevel;
            this.flv.volume(volumeLevel);
        },
        refresh: function refresh(src) {
            if (this.flv) {
                if (!src) {
                    src = this.flv.currentSrc();
                }
                this.flv.src(src);
                this.flv.load();
                this.flv.play();
            }
        },

        destroy: function destroy() {
            try {
                this.flv.destroy();
            } catch (e) {
                console.log(e.message);
            }
        }
    });

    if (typeof VideoJS !== 'undefined') {
        VideoJS.options.flash.swf = "//h.cdn.pengpengla.com/up/uplive-pc/1.0.9/assets/video-js.swf";
    }

    module.exports = Flv;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _spriteanim = __webpack_require__(668);

var _spriteanim2 = _interopRequireDefault(_spriteanim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var anim = {

    requestIndex: 0,
    mergePics: [],
    parsedJson: [],

    play: function play(container, jsons, mergePics, _onStart, _onComplete) {
        var _this = this;

        var canvasDom = $('<canvas id="canvas1"></canvas>');
        // canvasDom.css({
        //     position: 'fixed',
        //     zIndex: 99999,
        //     left: 0,
        //     top: 0
        // });
        var wrap = container || $(document.body);

        wrap.append(canvasDom);

        this.asyncRequest(jsons, mergePics, function (_jsons, _mergePics) {

            // 计算适配，canvas铺满全屏，自动居中，左右或者上下留白边，不裁切
            var frameWidth = 640;
            var frameHeight = 280;
            // var screenWidth = document.documentElement.clientWidth;
            // var screenHeight = document.documentElement.clientHeight;
            var offset = wrap.offset();
            var screenWidth = offset.width;
            var screenHeight = offset.height;
            var designRatio = frameHeight / frameWidth;
            var screenRatio = screenHeight / screenWidth;
            // 显示所有动画，左右或者上下留白边，不裁切
            var scale, offsetX, offsetY;

            if (screenRatio > designRatio) {
                scale = screenWidth / frameWidth;
                offsetX = 0;
                offsetY = (screenHeight - frameHeight * scale) / 2 / scale;
            } else {
                scale = screenWidth / frameWidth;
                offsetX = (screenWidth - frameWidth * scale) / 2 / scale;
                // offsetY = 0;
                offsetY = (screenHeight - frameHeight * scale) / scale;
            }

            var frames = [];
            _jsons.forEach(function (item, i) {
                if (mergePics[i]) {
                    var img = $('<img src="' + mergePics[i] + '" />')[0];
                    frames = [].concat(_toConsumableArray(frames), _toConsumableArray(_this.extractFrames(item, img)));
                }
            });
            // 按照名字排序，确保序列帧的播放顺序
            frames.sort(function (a, b) {
                return a.name < b.name ? -1 : 1;
            });

            var animation = new _spriteanim2.default("canvas1");

            animation.start({
                canvasWidth: screenWidth,
                canvasHeight: screenHeight,
                scale: scale,
                offsetX: offsetX,
                offsetY: offsetY,
                frames: frames,
                fps: 10,
                loop: true,
                onStart: function onStart() {
                    if (typeof _onStart == 'function') {
                        _onStart();
                    }
                },
                onComplete: function onComplete() {
                    if (typeof _onComplete == 'function') {
                        _onComplete();
                    }
                }
            });
        });
    },
    asyncRequest: function asyncRequest(jsons, mergePics, callback) {
        var _this2 = this;

        var len = jsons.length;

        if (this.mergePics.length == 0) {
            this.mergePics = mergePics;
        }

        if (jsons[this.requestIndex]) {
            $.ajax({
                url: 'https://proxy.upliveapps.com/index/index',
                data: {
                    requestSource: 1,
                    requestSourceUrl: jsons[this.requestIndex]
                },
                dataType: 'JSON'
            }).done(function (resp) {
                var _json = void 0;

                try {
                    // debugger
                    _json = JSON.parse(resp);
                    _this2.parsedJson.push(_json);
                } catch (e) {}
                _this2.requestIndex++;
                if (jsons[_this2.requestIndex]) {
                    _this2.asyncRequest(jsons, mergePics, callback);
                } else {
                    callback([].concat(_toConsumableArray(_this2.parsedJson)), [].concat(_toConsumableArray(_this2.mergePics)));
                    _this2.requestIndex = 0;
                    _this2.parsedJson = [];
                    _this2.mergePics = [];
                }
            });
        }
    },
    extractFrames: function extractFrames(jsonData, img) {

        var frames = [];
        var rawFrames = jsonData && jsonData.frames;
        if (rawFrames) {
            rawFrames.forEach(function (frameData) {

                frames.push({
                    name: frameData.filename,
                    image: img,
                    sx: frameData.frame.x,
                    sy: frameData.frame.y,
                    sWidth: frameData.frame.w,
                    sHeight: frameData.frame.h,
                    dx: frameData.spriteSourceSize.x,
                    dy: frameData.spriteSourceSize.y,
                    dWidth: frameData.spriteSourceSize.w,
                    dHeight: frameData.spriteSourceSize.h
                });
            });
        }
        return frames;
    }
};

exports.default = anim;

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports = {
    jsons: [
    // 'http://g.cdn.pengpengla.com/oauthgame/html5/20171101/uplivepcvoiceanim2.json'
    'https://g.cdn.pengpengla.com/oauthgame/html5/20171101/voice1.json'],
    mergePics: [
    // 'http://g.cdn.pengpengla.com/oauthgame/html5/20171101/6696f23ec2ae25f944abf134ea8904d3.png'
    'https://g.cdn.pengpengla.com/oauthgame/html5/20171101/f33aec43cf5991e8bdedbbd2d1d45075.png']
};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.9.1
//     http://underscorejs.org
//     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
            typeof global == 'object' && global.global === global && global ||
            this ||
            {};

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for their old module API. If we're in
  // the browser, add `_` as a global object.
  // (`nodeType` is checked to ensure that `module`
  // and `exports` are not HTML elements.)
  if (typeof exports != 'undefined' && !exports.nodeType) {
    if (typeof module != 'undefined' && !module.nodeType && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.9.1';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  var builtinIteratee;

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (_.iteratee !== builtinIteratee) return _.iteratee(value, context);
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value) && !_.isArray(value)) return _.matcher(value);
    return _.property(value);
  };

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only argCount argument.
  _.iteratee = builtinIteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  var restArguments = function(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var shallowProperty = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  var has = function(obj, path) {
    return obj != null && hasOwnProperty.call(obj, path);
  }

  var deepGet = function(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = shallowProperty('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  var createReduce = function(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  };

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? _.findIndex : _.findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (_.isFunction(path)) {
      func = path;
    } else if (_.isArray(path)) {
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return _.map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection.
  _.shuffle = function(obj) {
    return _.sample(obj, Infinity);
  };

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    var sample = isArrayLike(obj) ? _.clone(obj) : _.values(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = _.random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (has(result, key)) result[key]++; else result[key] = 1;
  });

  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (_.isString(obj)) {
      // Keep surrogate pair characters together
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, Boolean);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, output) {
    output = output || [];
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        // Flatten current level of array or arguments object.
        if (shallow) {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        } else {
          flatten(value, shallow, strict, output);
          idx = output.length;
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = restArguments(function(array, otherArrays) {
    return _.difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = restArguments(function(arrays) {
    return _.uniq(flatten(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = restArguments(function(array, rest) {
    rest = flatten(rest, true, true);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  });

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = restArguments(_.unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of _.pairs.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions.
  var createPredicateIndexFinder = function(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  };

  // Returns the first index on an array-like that passes a predicate test.
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions.
  var createIndexFinder = function(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  };

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  _.chunk = function(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments.
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = restArguments(function(func, context, args) {
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  _.partial = restArguments(function(func, boundArgs) {
    var placeholder = _.partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  _.partial.placeholder = _;

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = restArguments(function(obj, keys) {
    keys = flatten(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = _.bind(obj[key], obj);
    }
  });

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, result;

    var later = function(context, args) {
      timeout = null;
      if (args) result = func.apply(context, args);
    };

    var debounced = restArguments(function(args) {
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(later, wait);
        if (callNow) result = func.apply(this, args);
      } else {
        timeout = _.delay(later, wait, this, args);
      }

      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = null;
    };

    return debounced;
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  _.restArguments = restArguments;

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  var collectNonEnumProps = function(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  };

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object.
  // In contrast to _.map it returns an object.
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = _.keys(obj),
        length = keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of _.object.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`.
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test.
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Internal pick helper function to determine if `obj` has key `key`.
  var keyInObj = function(value, key, obj) {
    return key in obj;
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (_.isFunction(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = _.allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the blacklisted properties.
  _.omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = _.map(flatten(keys, false, false), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  });

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq, deepEq;
  eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  };

  // Internal recursive comparison function for `isEqual`.
  deepEq = function(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error', 'Symbol', 'Map', 'WeakMap', 'Set', 'WeakSet'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return !_.isSymbol(obj) && isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`?
  _.isNaN = function(obj) {
    return _.isNumber(obj) && isNaN(obj);
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, path) {
    if (!_.isArray(path)) {
      return has(obj, path);
    }
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (obj == null || !hasOwnProperty.call(obj, key)) {
        return false;
      }
      obj = obj[key];
    }
    return !!length;
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indexes.
  _.property = function(path) {
    if (!_.isArray(path)) {
      return shallowProperty(path);
    }
    return function(obj) {
      return deepGet(obj, path);
    };
  };

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    if (obj == null) {
      return function(){};
    }
    return function(path) {
      return !_.isArray(path) ? obj[path] : deepGet(obj, path);
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  _.result = function(obj, path, fallback) {
    if (!_.isArray(path)) path = [path];
    var length = path.length;
    if (!length) {
      return _.isFunction(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = _.isFunction(prop) ? prop.call(obj) : prop;
    }
    return obj;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var chainResult = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_, args));
      };
    });
    return _;
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return chainResult(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return chainResult(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return String(this._wrapped);
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}());

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(101), __webpack_require__(256)(module)))

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);
var transitionEvents = __webpack_require__(425);
var appendVendorPrefix = __webpack_require__(156);

module.exports = function(animation){

    return React.createClass({
        propTypes: {
            className: React.PropTypes.string,
            // Close the modal when esc is pressed? Defaults to true.
            keyboard: React.PropTypes.bool,
            onShow: React.PropTypes.func,
            onHide: React.PropTypes.func,
            animation: React.PropTypes.object,
            backdrop: React.PropTypes.bool,
            closeOnClick: React.PropTypes.bool,
            modalStyle: React.PropTypes.object,
            backdropStyle: React.PropTypes.object,
            contentStyle: React.PropTypes.object,
        },

        getDefaultProps: function() {
            return {
                className: "",
                onShow: function(){},
                onHide: function(){},
                animation: animation,
                keyboard: true,
                backdrop: true,
                closeOnClick: true,
                modalStyle: {},
                backdropStyle: {},
                contentStyle: {},
            };
        },

        getInitialState: function(){
            return {
                willHidden: false,
                hidden: true
            }
        },

        hasHidden: function(){
            return this.state.hidden;
        },

        addTransitionListener: function(node, handle){
            if (node) {
              var endListener = function(e) {
                  if (e && e.target !== node) {
                      return;
                  }
                  transitionEvents.removeEndEventListener(node, endListener);
                  handle();
              };
              transitionEvents.addEndEventListener(node, endListener);
            }
        },

        handleBackdropClick: function() {
            if (this.props.closeOnClick) {
                this.hide();
            }
        },

        render: function() {

            var hidden = this.hasHidden();
            if (hidden) return null;

            var willHidden = this.state.willHidden;
            var animation = this.props.animation;
            var modalStyle = animation.getModalStyle(willHidden);
            var backdropStyle = animation.getBackdropStyle(willHidden);
            var contentStyle = animation.getContentStyle(willHidden);
            var ref = animation.getRef(willHidden);
            var sharp = animation.getSharp && animation.getSharp(willHidden);

            // Apply custom style properties
            if (this.props.modalStyle) {
                var prefixedModalStyle = appendVendorPrefix(this.props.modalStyle);
                for (var style in prefixedModalStyle) {
                    modalStyle[style] = prefixedModalStyle[style];
                }
            }

            if (this.props.backdropStyle) {
              var prefixedBackdropStyle = appendVendorPrefix(this.props.backdropStyle);
                for (var style in prefixedBackdropStyle) {
                    backdropStyle[style] = prefixedBackdropStyle[style];
                }
            }

            if (this.props.contentStyle) {
              var prefixedContentStyle = appendVendorPrefix(this.props.contentStyle);
                for (var style in prefixedContentStyle) {
                    contentStyle[style] = prefixedContentStyle[style];
                }
            }

            var backdrop = this.props.backdrop? React.createElement("div", {style: backdropStyle, onClick: this.props.closeOnClick? this.handleBackdropClick: null}): undefined;

            if(willHidden) {
                var node = this.refs[ref];
                this.addTransitionListener(node, this.leave);
            }

            return (React.createElement("span", null, 
                React.createElement("div", {ref: "modal", style: modalStyle, className: this.props.className}, 
                    sharp, 
                    React.createElement("div", {ref: "content", tabIndex: "-1", style: contentStyle}, 
                        this.props.children
                    )
                ), 
                backdrop
             ))
            ;
        },

        leave: function(){
            this.setState({
                hidden: true
            });
            this.props.onHide();
        },

        enter: function(){
            this.props.onShow();
        },

        show: function(){
            if (!this.hasHidden()) return;

            this.setState({
                willHidden: false,
                hidden: false
            });

            setTimeout(function(){
              var ref = this.props.animation.getRef();
              var node = this.refs[ref];
              this.addTransitionListener(node, this.enter);
            }.bind(this), 0);
        },

        hide: function(){
            if (this.hasHidden()) return;

            this.setState({
                willHidden: true
            });
        },

        toggle: function(){
            if (this.hasHidden())
                this.show();
            else
                this.hide();
        },

        listenKeyboard: function(event) {
            if (this.props.keyboard &&
                    (event.key === "Escape" ||
                     event.keyCode === 27)) {
                this.hide();
            }
        },

        componentDidMount: function(){
            window.addEventListener("keydown", this.listenKeyboard, true);
        },

        componentWillUnmount: function() {
            window.removeEventListener("keydown", this.listenKeyboard, true);
        }
    });
}


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var insertRule = __webpack_require__(428);
var vendorPrefix = __webpack_require__(429)();
var index = 0;

module.exports = function(keyframes) {
  // random name
  var name = 'anim_' + (++index) + (+new Date);
  var css = "@" + vendorPrefix + "keyframes " + name + " {";

  for (var key in keyframes) {
    css += key + " {";

    for (var property in keyframes[key]) {
      var part = ":" + keyframes[key][property] + ";";
      // We do vendor prefix for every property
      css += vendorPrefix + property + part;
      css += property + part;
    }

    css += "}";
  }

  css += "}";

  insertRule(css);

  return name
}


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getIndexWithGrade = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(457);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 等级配置页面
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var Grade = function (_Component) {
    _inherits(Grade, _Component);

    function Grade(props) {
        _classCallCheck(this, Grade);

        var _this = _possibleConstructorReturn(this, (Grade.__proto__ || Object.getPrototypeOf(Grade)).call(this, props));

        _this.state = {
            value: props.value
        };
        return _this;
    }

    _createClass(Grade, [{
        key: 'componentWillMout',
        value: function componentWillMout() {
            this.configColorAndImageArray = [];
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                value: nextProps.value
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var idx = getIndexWithGrade(this.state.value);
            var image = 'grade_' + idx;
            var color = this.props.colors[idx];
            var style = {
                backgroundColor: color
            };

            return _react2.default.createElement(
                'div',
                { className: 'ui-grade' },
                _react2.default.createElement('i', { className: image }),
                _react2.default.createElement(
                    'em',
                    { style: style },
                    this.state.value
                )
            );
        }
    }]);

    return Grade;
}(_react.Component);

Grade.defaultProps = {
    value: 0,
    colors: ['rgba(179,212,101,1)', //color0
    'rgba(255,97,142,1)', //color1
    'rgba(248,58,75,1)', //color2
    'rgba(235,97,0,1)', //color3
    'rgba(248,58,75,1)', //color4
    'rgba(255,72,182,1)', //color5
    'rgba(255,59,112,1)', //color6
    'rgba(248,58,75,1)', //color7
    'rgba(178,97,255,1)', //color8
    'rgba(200,75,231,1)', //color9
    'rgba(66,142,255,1)', //color10
    'rgba(75,73,230,1)', //color11
    'rgba(178,97,255,1)', //color12
    'rgba(147,43,227,1)', //color13
    'rgba(32,205,255,1)', //color14
    'rgba(47,128,255,1)', //color15
    'rgba(178,97,255,1)', //color16
    'rgba(255,210,0,1)', //color17
    'rgba(255,146,0,1)', //color18
    'rgba(229,2,1,1)', //color19
    'rgba(130,0,189,1)', //color20
    'rgba(248,9,68,1)', //color21
    'rgba(186,4,25,1)', //color22
    'rgba(200,75,231,1)', //color23
    'rgba(153,46,254,1)' //color24
    ]
};


function getIndexWithGrade(grade) {
    if (grade < 1) {
        return 0;
    }

    var x = grade;

    var n = 0;

    if (x < 44) {
        //等级小于44的时候每个区间的『等级差值』是一个等差数列
        //利用等差数列求和公式和求根公式来计算当前等级所在区间对应到图片存放的地方的坐标；输出0123456.....
        n = (Math.sqrt(9 + 8 * x) - 3) / 2;
    } else {
        //等级大于等于44的时候每个区间的『等级』是一个等差数列
        //利用等差数列通项公式来计算当前等级所在区间对应到图片存放的地方的坐标；输出0123456.....
        n = (x - 34) / 10;
        //与44级之前的对接
        n += 7;
    }

    return Math.floor(n);
}

exports.default = Grade;
exports.getIndexWithGrade = getIndexWithGrade;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _set = __webpack_require__(472);

var _set2 = _interopRequireDefault(_set);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var cache = new _cCache2.default({
    prefix: 'pcuplive'
});
var pbajax = new _pbajax2.default();

var ProfileSet = function () {
    function ProfileSet() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, ProfileSet);

        this.promise = this.set(data);
    }

    _createClass(ProfileSet, [{
        key: 'set',
        value: function set(data) {
            var defer = $.Deferred();
            var businessData = new _set2.default.Profile.Set.Request(data);
            var requestData = {
                service: 'service',
                api: '/profile/set',
                header: {
                    userToken: UP.Global.getUserToken()
                }
            };

            pbajax.do(requestData, businessData, function (res) {
                var dataWrap = _public2.default.Result.decode(res);

                if (dataWrap.code == 1) {
                    defer.resolve(true);
                } else {
                    defer.reject();
                }
            }, function () {
                defer.reject();
            }, function () {
                defer.reject();
            });
            return defer.promise();
        }
    }]);

    return ProfileSet;
}();

exports.default = ProfileSet;

/***/ }),
/* 269 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Result",
        "fields": [{
            "rule": "optional",
            "type": "Code",
            "name": "code",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "msg",
            "id": 2
        }, {
            "rule": "optional",
            "type": "google.protobuf.Any",
            "name": "data",
            "id": 3
        }]
    }, {
        "name": "google",
        "fields": [],
        "messages": [{
            "name": "protobuf",
            "fields": [],
            "options": {
                "csharp_namespace": "Google.Protobuf.WellKnownTypes",
                "go_package": "github.com/golang/protobuf/ptypes/any",
                "java_package": "com.google.protobuf",
                "java_outer_classname": "AnyProto",
                "java_multiple_files": true,
                "java_generate_equals_and_hash": true,
                "objc_class_prefix": "GPB"
            },
            "messages": [{
                "name": "Any",
                "fields": [{
                    "rule": "optional",
                    "type": "string",
                    "name": "type_url",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "bytes",
                    "name": "value",
                    "id": 2
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "Code",
        "values": [{
            "name": "DEFAULT",
            "id": 0
        }, {
            "name": "SC_SUCCESS",
            "id": 1
        }, {
            "name": "SC_THIRD_PARTY_ALREADY_BIND",
            "id": 256
        }, {
            "name": "SC_THIRD_CHECK_USER_NOT_REGISTER",
            "id": 257
        }, {
            "name": "SC_NEED_BIND_PHONE",
            "id": 258
        }, {
            "name": "SC_PARAMETER_INVALID",
            "id": 4096
        }, {
            "name": "SC_ADMIN_NO_PERMISSION",
            "id": 4352
        }, {
            "name": "SC_ACCOUTN_USER_TOKEN_NOTMATCH",
            "id": 8192
        }, {
            "name": "SC_ACCOUNT_IS_VISTOR",
            "id": 8194
        }, {
            "name": "SC_LOGINED_IN_OTHER_DEVICE",
            "id": 8193
        }, {
            "name": "SC_SMS_VERIFY_CODE_NOMOBILE",
            "id": 4097
        }, {
            "name": "SC_SMS_VERIFY_CODE_FAIL",
            "id": 4098
        }, {
            "name": "SC_SMS_VERIFY_CODE_NOTMATCH",
            "id": 4099
        }, {
            "name": "SC_ACCOUNT_MOBILE_PHONE_REPETITION",
            "id": 4100
        }, {
            "name": "SC_ACCOUNT_MOBILE_PHONE_ALLREADY_BIND",
            "id": 4101
        }, {
            "name": "SC_ACCOUTN_USER_NAME_FORBIDDEN",
            "id": 4102
        }, {
            "name": "SC_ACCOUTN_THIRD_CHECK_FAIL",
            "id": 4103
        }, {
            "name": "SC_ACCOUNT_USER_NAME_OVER_LONG",
            "id": 4104
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_OVER_LONG",
            "id": 4105
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_EMAIL_WHITE",
            "id": 4106
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_NOT_STANDARD",
            "id": 4112
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_EXIST",
            "id": 4113
        }, {
            "name": "SC_ACCOUNT_LIVE_UPDATE_FAIL",
            "id": 4114
        }, {
            "name": "SC_ACCOUNT_PASSWORD_ERROR",
            "id": 4115
        }, {
            "name": "SC_ACCOUNT_USER_NOT_EXIST",
            "id": 4116
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_TOO_SHORT",
            "id": 4117
        }, {
            "name": "SC_ACCOUNT_SIGNATURE_OVER_LONG",
            "id": 4118
        }, {
            "name": "SC_ACCOUTN_USER_FORBIDDEN",
            "id": 4119
        }, {
            "name": "SC_ACCOUNT_RANDOM_NOTEXIST",
            "id": 4120
        }, {
            "name": "SC_ACCOUNT_RANDOM_NOTSCAN",
            "id": 4121
        }, {
            "name": "SC_ACCOUNT_RANDOM_SCANNED",
            "id": 4128
        }, {
            "name": "SC_ACCOUNT_LIVE_CODE_NOLY_MODIFY_ONCE",
            "id": 4129
        }, {
            "name": "SC_ACCOUNT_USER_OR_PASSWORD_ERROR",
            "id": 4130
        }, {
            "name": "SC_EMAIL_SEND_OVER_LIMIT",
            "id": 4131
        }, {
            "name": "SC_EMAIL_VERIFY_INVALID",
            "id": 4132
        }, {
            "name": "SC_EMAIL_NOT_VERIFY",
            "id": 4133
        }, {
            "name": "SC_NEED_REGISTER",
            "id": 4134
        }, {
            "name": "SC_ACCOUNT_HAVE_NO_BIND_MOBILE",
            "id": 4135
        }, {
            "name": "SC_ACCOUNT_DID_FORBIDDEN",
            "id": 4136
        }, {
            "name": "SC_SMS_SEND_CODE_BEYOND_LIMIT",
            "id": 4137
        }, {
            "name": "SC_SENSITIVE_CONTENT",
            "id": 4609
        }, {
            "name": "SC_ACCOUNT_USER_USERNAME_IS_HIDDEN",
            "id": 4610
        }, {
            "name": "SC_MALL_GIFT_NOT_EXIST",
            "id": 12289
        }, {
            "name": "SC_MALL_TRANSACTION_REPEATED",
            "id": 12290
        }, {
            "name": "SC_MALL_MONEY_NOT_ENOUGH",
            "id": 12291
        }, {
            "name": "SC_MALL_TRANSACTION_NOT_EXIST",
            "id": 12292
        }, {
            "name": "SC_MALL_PRODUCT_NOT_AVAILABLE",
            "id": 12293
        }, {
            "name": "SC_MALL_ORDER_NOT_EXIST",
            "id": 12294
        }, {
            "name": "SC_MALL_UNIFIED_ORDER_FAIL",
            "id": 12295
        }, {
            "name": "SC_MALL_PAY_FAIL",
            "id": 12296
        }, {
            "name": "SC_MALL_PAY_QUERY_FAIL",
            "id": 12297
        }, {
            "name": "SC_MALL_IAP_VALIDATE_FAIL",
            "id": 12298
        }, {
            "name": "SC_MALL_ORDER_EXIST_NOT_FINISHED",
            "id": 12299
        }, {
            "name": "SC_MALL_NOT_BIND_WECHAT",
            "id": 12300
        }, {
            "name": "SC_MALL_EXCEED_WITHDRAW_TIMES",
            "id": 12301
        }, {
            "name": "SC_MALL_EXCEED_WITHDRAW_QUOTA",
            "id": 12302
        }, {
            "name": "SC_MALL_WITHDRAW_FAIL",
            "id": 12303
        }, {
            "name": "SC_MALL_WITHDRAW_LESS_THAN_MIN",
            "id": 12304
        }, {
            "name": "SC_MALL_WITHDRAW_GREATER_THAN_MAX",
            "id": 12305
        }, {
            "name": "SC_MALL_WITHDRAW_FREQ_LIMIT",
            "id": 12306
        }, {
            "name": "SC_MALL_WITHDRAW_SENDNUM_LIMIT",
            "id": 12307
        }, {
            "name": "SC_MALL_NOT_BIND_PAYPAL",
            "id": 12308
        }, {
            "name": "SC_MALL_IAB_VALIDATE_FAIL",
            "id": 12309
        }, {
            "name": "SC_MALL_BUY_GUARD_DIAMOND_LOW",
            "id": 12310
        }, {
            "name": "SC_MALL_TRANSLATE_NOT_SUPPORT",
            "id": 12311
        }, {
            "name": "SC_MALL_TRANSLATE_CLOSED",
            "id": 12312
        }, {
            "name": "SC_MALL_GIFT_SEND_VIP_LIMIT",
            "id": 12313
        }, {
            "name": "SC_MALL_GIFT_NOT_ALLOW",
            "id": 12320
        }, {
            "name": "SC_MALL_GIFT_NEED_RECHARGE",
            "id": 12321
        }, {
            "name": "SC_MALL_ACC_BILL_NOT_ENOUGH",
            "id": 12322
        }, {
            "name": "SC_MALL_USER_FROZEN",
            "id": 12323
        }, {
            "name": "SC_MALL_RECHARGE_REPEAT",
            "id": 12324
        }, {
            "name": "SC_MALL_RECHARGE_REWARD_REPEAT",
            "id": 12325
        }, {
            "name": "SC_MALL_RECHARGE_REWARD_INVALID",
            "id": 12326
        }, {
            "name": "SC_MALL_SHAREREDPACKET_TOTALAMOUNT_INVALID",
            "id": 12327
        }, {
            "name": "SC_MALL_SHAREREDPACKET_SPLITNUM_INVALID",
            "id": 12328
        }, {
            "name": "SC_MALL_SHAREREDPACKET_SPLITAMOUNT_INVALID",
            "id": 12329
        }, {
            "name": "SC_MALL_GOODS_NOT_EXIST",
            "id": 12336
        }, {
            "name": "SC_MALL_BROADCAST_NOT_OPEN",
            "id": 12337
        }, {
            "name": "SC_MALL_FIXEDCONTENT_NOT_EXIST",
            "id": 12338
        }, {
            "name": "SC_MALL_GIFT_GUARD_TOO_LOW",
            "id": 12339
        }, {
            "name": "SC_MALL_FIGHT_OVER",
            "id": 12340
        }, {
            "name": "SC_MALL_BIGBALL_OVER",
            "id": 12341
        }, {
            "name": "SC_MALL_PROP_LEFT_AMOUNT_NOT_ENOUGH",
            "id": 12342
        }, {
            "name": "SC_MALL_PROP_SAME_EXIST",
            "id": 12343
        }, {
            "name": "SC_MALL_PLAY_NOT_OPEN",
            "id": 12344
        }, {
            "name": "SC_MALL_MOUNT_CANNOTREPURCHASE",
            "id": 12345
        }, {
            "name": "SC_RANKING_VIP_INVISIBLE_LIMIT",
            "id": 14593
        }, {
            "name": "SC_RANKING_VIP_INVISIBLE_OFF",
            "id": 14594
        }, {
            "name": "SC_CONTACT_ALREADY_FRIEND",
            "id": 16385
        }, {
            "name": "SC_LIVE_ROOM_NOT_EXIST",
            "id": 20481
        }, {
            "name": "SC_LIVE_ROOM_DISABLED",
            "id": 20482
        }, {
            "name": "SC_LIVE_ROOM_NO_PERMISSION",
            "id": 20483
        }, {
            "name": "SC_LIVE_ROOM_USER_GRADE_NOT_ENOUGH",
            "id": 20484
        }, {
            "name": "SC_LIVE_ROOM_SPECIAL_NOT_CREATE",
            "id": 20485
        }, {
            "name": "SC_LIVE_ROOM_ADMIN_SHUTUP_FAIL",
            "id": 20486
        }, {
            "name": "SC_LIVE_ROOM_ADMIN_LIFTED_FAIL",
            "id": 20487
        }, {
            "name": "SC_LIVE_ROOM_ADMIN_SHUTUP_UIDS_ERROR",
            "id": 20488
        }, {
            "name": "SC_LIVE_ROOM_NO_TEL_AUTH",
            "id": 20489
        }, {
            "name": "SC_LIVE_ROOM_FORCED_OUT",
            "id": 20490
        }, {
            "name": "SC_LIVE_ROOM_POLICY_DISABLED",
            "id": 20491
        }, {
            "name": "SC_LIVE_ROOM_RID_UID_NOTMATCH",
            "id": 20492
        }, {
            "name": "SC_LIVE_ROOM_NO_REALNAME_AUTH",
            "id": 20496
        }, {
            "name": "SC_LIVE_ROOM_NOT_IN_MULTILIVE",
            "id": 20497
        }, {
            "name": "SC_LIVE_ROOM_PAY_FAILED",
            "id": 20498
        }, {
            "name": "SC_LIVE_ROOM_CANNOT_MULTILIVE",
            "id": 20499
        }, {
            "name": "SC_LIVE_ROOM_MULTILIVE_MEMBERS_LIMIT",
            "id": 20500
        }, {
            "name": "SC_LIVE_ROOM_MULTILIVE_CREATE_MEETINGROOM_FAILED",
            "id": 20501
        }, {
            "name": "SC_LIVE_ROOM_MULTILIVE_FINISH",
            "id": 20502
        }, {
            "name": "SC_LIVE_ROOM_IS_LIVING",
            "id": 20503
        }, {
            "name": "SC_LIVE_ROOM_PRIVATELIVE_NOT_ALLOW",
            "id": 20504
        }, {
            "name": "SC_LIVE_ROOM_CHARGE_NOT_ALLOW",
            "id": 20505
        }, {
            "name": "SC_LIVE_ROOM_CHARGE_BELOW_MIN",
            "id": 20506
        }, {
            "name": "SC_LIVE_ROOM_AUDIENCE_LIMIT_ALLOW",
            "id": 20507
        }, {
            "name": "SC_LIVE_ROOM_LIVE_NEED_CHARGE",
            "id": 20508
        }, {
            "name": "SC_LIVE_ROOM_NUMBER_REACHED_TOPLIMIT",
            "id": 20512
        }, {
            "name": "SC_LIVE_ROOM_VOICE_NOT_ALLOW",
            "id": 20513
        }, {
            "name": "SC_LIVE_ROOM_USER_NOT_ONLINE",
            "id": 20514
        }, {
            "name": "SC_LIVE_ROOM_APPLY_MULTILIVE_NOT_ALLOW",
            "id": 20515
        }, {
            "name": "SC_LIVE_ROOM_NO_MEMBER",
            "id": 20516
        }, {
            "name": "SC_LIVE_ROOM_NO_INVITE",
            "id": 20517
        }, {
            "name": "SC_LIVE_ROOM_MULTILIVE_FREEJOINTIME_EMPTY",
            "id": 20518
        }, {
            "name": "SC_LIVE_ROOM_MF_VIP_LIMIT",
            "id": 20519
        }, {
            "name": "SC_LIVE_ROOM_MF_COUNTRY_LIMIT",
            "id": 20520
        }, {
            "name": "SC_LIVE_ROOM_INVITE_LIMIT_DAILY",
            "id": 20521
        }, {
            "name": "SC_ACTIVITY_SEND_DIAMOND_TIME_END",
            "id": 24577
        }, {
            "name": "SC_ACTIVITY_SEND_DIAMOND_OVER_LIMIT",
            "id": 24578
        }, {
            "name": "SC_ACTIVITY_SEND_DIAMOND_ALREADY",
            "id": 24579
        }, {
            "name": "SC_ACTIVITY_NO_RECHARGE",
            "id": 24580
        }, {
            "name": "SC_ACTIVITY_NOT_CONDITIONS",
            "id": 24581
        }, {
            "name": "SC_SYSTEM_ERROR",
            "id": 16777215
        }, {
            "name": "SC_ZMXY_AUTH_BIND_SUCCESS",
            "id": 28673
        }, {
            "name": "SC_ZMXY_AUTH_HAS_BEEN_USEED",
            "id": 28674
        }, {
            "name": "SC_ZMXY_AUTH_HAS_BIND",
            "id": 28675
        }, {
            "name": "SC_ZMXY_AUTH_ERROR",
            "id": 28676
        }, {
            "name": "SC_REDPACKET_OVERDUE_ERROR",
            "id": 32769
        }, {
            "name": "SC_REDPACKET_DISTRIBUTED_ERROR",
            "id": 32770
        }, {
            "name": "SC_REDPACKET_REPEAT_ERROR",
            "id": 32771
        }, {
            "name": "SC_REDPACKET_DELAYTIME_ERROR",
            "id": 32772
        }, {
            "name": "SC_PERMISSIONUSE_NOT_ALLOW",
            "id": 36865
        }, {
            "name": "SC_PERMISSIONUSE_LOW_PERMISSION",
            "id": 36866
        }, {
            "name": "SC_PERMISSIONUSE_OVER_ROOMMAX",
            "id": 36867
        }, {
            "name": "SC_PERMISSIONUSE_OVER_DAYMAX",
            "id": 36868
        }, {
            "name": "SC_PERMISSIONUSE_OVER_ADD_LIMIT",
            "id": 36869
        }, {
            "name": "SC_PERMISSIONUSE_ERROR",
            "id": 36870
        }, {
            "name": "SC_PERMISSIONUSE_REPEAT_ERROR",
            "id": 36871
        }, {
            "name": "SC_ACTIVITY_EXCHANGE_REPEATED",
            "id": 65537
        }, {
            "name": "SC_ACTIVITY_POINT_NOT_ENOUGH",
            "id": 65538
        }, {
            "name": "SC_PACK_TRANSACTION_REPEATED",
            "id": 69633
        }, {
            "name": "SC_PACK_GIFT_NOT_AVAILABLE",
            "id": 69634
        }, {
            "name": "SC_PACK_GIFT_EXPIRE",
            "id": 69635
        }, {
            "name": "SC_PACK_TRANSACTION_NOT_EXIST",
            "id": 69636
        }, {
            "name": "SC_PACK_FULL",
            "id": 69637
        }, {
            "name": "SC_DYNAMIC_COMMENT_FREQUENCY_LIMITED",
            "id": 73729
        }, {
            "name": "SC_DYNAMIC_COMMENT_WORDS_OVER_LONG",
            "id": 73730
        }, {
            "name": "SC_DYNAMIC_NOT_EXIST_OR_DELETED",
            "id": 73731
        }, {
            "name": "SC_DYNAMIC_HAS_NO_RIGHT",
            "id": 73732
        }, {
            "name": "SC_DYNAMIC_IN_CALCULATION",
            "id": 73733
        }, {
            "name": "SC_DYNAMIC_EMPTY_NEED_GET_RECOMMEND_ANCHOR",
            "id": 73734
        }, {
            "name": "SC_DYNAMIC_LIMIT_FREQUENTLY_REPEAT_COMMENT",
            "id": 73735
        }, {
            "name": "SC_DYNAMIC_NOT_VIDEO_COMMENT",
            "id": 73736
        }, {
            "name": "SC_CHECKIN_ALREADY",
            "id": 77825
        }, {
            "name": "SC_FAN_GROUP_TITLE_CHANGE_POINT_NOT_ENOUGH",
            "id": 94465
        }, {
            "name": "SC_FAN_GROUP_NOT_EXIST",
            "id": 94466
        }, {
            "name": "SC_FAN_GROUP_NOT_FAN",
            "id": 94467
        }, {
            "name": "SC_FAN_GROUP_SELF_JOIN_ERROR",
            "id": 94468
        }, {
            "name": "SC_FAN_TASK_NOT_EXIST",
            "id": 94469
        }, {
            "name": "SC_FAN_TASK_TYPE_NOT_EXIST",
            "id": 94470
        }, {
            "name": "SC_FAN_TASK_MAXIMUM_TIME_REACHED",
            "id": 94471
        }, {
            "name": "SC_FAN_PERMISSION_NO",
            "id": 94472
        }, {
            "name": "SC_ACTIVITY_REWARD_ALREADY",
            "id": 81921
        }, {
            "name": "SC_ACTIVITY_REWARD_CANNOT",
            "id": 81922
        }, {
            "name": "SC_RANKING_GAME_NOTAUTHORITY",
            "id": 86017
        }, {
            "name": "IM_SYSTEM_ERROR",
            "id": 90113
        }, {
            "name": "IM_CREATE_PERMISSION_DENIED",
            "id": 90114
        }, {
            "name": "IM_BEYOND_GROUP_NUM_LIMIT",
            "id": 90115
        }, {
            "name": "IM_BEYOND_GROUP_USER_NUM_LIMIT",
            "id": 90116
        }, {
            "name": "IM_PERMISSION_DENIED",
            "id": 90117
        }, {
            "name": "IM_GROUP_INVALID",
            "id": 90118
        }, {
            "name": "IM_INVITE_INVALID",
            "id": 90119
        }, {
            "name": "SC_FOLLOW_YOU_ARE_IN_OTHERS_BLACKLIST",
            "id": 98305
        }, {
            "name": "SC_FOLLOW_ALREADY_REACH_MAX_FOLLOW",
            "id": 98306
        }, {
            "name": "SC_GIFTITEM_SAMENAME",
            "id": 98307
        }, {
            "name": "GIFTO_ACCOUNT_LOGING",
            "id": 1052673
        }, {
            "name": "GIFTO_ACCOUNT_ALREADY_ACTIVATE",
            "id": 1052674
        }, {
            "name": "GIFTO_ACCOUNT_WAIT_ACTIVATE",
            "id": 1052675
        }, {
            "name": "GIFTO_ACCOUNT_EXPIRE_ACTIVATE",
            "id": 1052676
        }, {
            "name": "GIFTO_ACCOUNT_NOT_BIND",
            "id": 1052677
        }, {
            "name": "GIFTO_EMAIL_VERIFY_INVALID",
            "id": 1052678
        }, {
            "name": "GIFTO_ACCOUNT_USER_OR_PASSWORD_ERROR",
            "id": 1052679
        }, {
            "name": "GIFTO_EMAIL_SEND_OVER_LIMIT",
            "id": 1052680
        }, {
            "name": "GIFTO_EMAIL_NOT_VERIFY",
            "id": 1052681
        }, {
            "name": "GIFTO_NOT_CURRENT_USER_BIND",
            "id": 1052682
        }, {
            "name": "GIFTO_ACCOUNT_PASSWORD_ERROR",
            "id": 1052683
        }, {
            "name": "GIFTO_KYC_NOT_SCUCCESS",
            "id": 1052684
        }, {
            "name": "GIFTO_ACCOUNT_NO_AUTHORITY",
            "id": 1052685
        }, {
            "name": "GIFTO_EMAIL_ALREADY_REGISTER",
            "id": 1052686
        }, {
            "name": "WALLET_JSON_NOT_VALID",
            "id": 1056769
        }, {
            "name": "WALLET_REQUEST_MISSING",
            "id": 1056770
        }, {
            "name": "WALLET_CURRENCY_NOT_SUPPORTED",
            "id": 1056771
        }, {
            "name": "WALLET_EXCEED_MAX_LENGRH",
            "id": 1056772
        }, {
            "name": "WALLET_INVALID_TOKEN",
            "id": 1056773
        }, {
            "name": "WALLET_METHOD_NOT_ALLOWED",
            "id": 1056774
        }, {
            "name": "WALLET_HAD_REPEAT_VALID",
            "id": 1056775
        }, {
            "name": "WALLET_MINIMUM_COIN_REQUIRED",
            "id": 1056776
        }, {
            "name": "WALLET_BALANCE_NOT_ENOUGH",
            "id": 1056777
        }, {
            "name": "WALLET_TRANSFER_FEE_TYPE_NOT_SUPPORTED",
            "id": 1056778
        }, {
            "name": "WALLET_TRANSFER_TYPE_NOT_SUPPORTED",
            "id": 1056779
        }, {
            "name": "WALLET_PASSPHRASE_NOT_CORRECT",
            "id": 1056780
        }, {
            "name": "WALLET_SENDER_IDENTITY_NOT_FOUNT",
            "id": 1056781
        }, {
            "name": "WALLET_RECEIVER_IDENTITY_NOT_FOUNT",
            "id": 1056782
        }, {
            "name": "WALLET_FOR_DEPOSITING",
            "id": 1056783
        }, {
            "name": "WALLET_OPEN_UCOINS_NOT_ENOUGH",
            "id": 1060865
        }, {
            "name": "WALLET_OPEN_TRANSACTION_REPEATED",
            "id": 1060866
        }, {
            "name": "WALLET_OPEN_TRANSACTION_NOT_EXIST",
            "id": 1060867
        }, {
            "name": "WALLET_OPEN_FAIL",
            "id": 1060868
        }, {
            "name": "WALLET_OPEN_TRANSACTION_NOT_END",
            "id": 1060869
        }, {
            "name": "WALLET_OPEN_TRANSACTION_DAY_LIMIT",
            "id": 1060870
        }, {
            "name": "WALLET_OPEN_TRANSACTION_MONTH_LIMIT",
            "id": 1060871
        }, {
            "name": "WALLET_OPEN_TRANSACTION_YEAR_LIMIT",
            "id": 1060872
        }, {
            "name": "WALLET_OPEN_TRANSACTION_FREQUENTLY",
            "id": 1060873
        }, {
            "name": "WALLET_OPEN_TRANSACTION_ONCHAIN_SHUT",
            "id": 1060874
        }, {
            "name": "WALLET_OPEN_PAYPASS_NOT_SETTING",
            "id": 1060875
        }, {
            "name": "WALLET_OPEN_USER_TRANSACTION_SHUT",
            "id": 1060876
        }, {
            "name": "WALLET_OPEN_USER_DEPOT_LOCKED",
            "id": 1060877
        }, {
            "name": "WALLET_OPEN_FIAT_PRODUCT_NOT_AVAILABLE",
            "id": 1060878
        }, {
            "name": "WALLET_OPEN_FIAT_PRODUCT_REFRESHED",
            "id": 1060879
        }, {
            "name": "WALLET_OPEN_UNIFIED_ORDER_FAIL",
            "id": 1060880
        }, {
            "name": "WALLET_OPEN_ORDER_NOT_EXIST",
            "id": 1060881
        }, {
            "name": "WALLET_OPEN_PAY_QUERY_FAIL",
            "id": 1060882
        }, {
            "name": "WALLET_OPEN_PAY_FAIL",
            "id": 1060883
        }, {
            "name": "WALLET_OPEN_FIAT_RECHARGE_DAY_LIMIT",
            "id": 1060884
        }, {
            "name": "WALLET_OPEN_UCOINS_EXCHANGE_REGION_CLOSE",
            "id": 1060885
        }, {
            "name": "WALLET_OPEN_UCOINS_HAS_EXCHANGE",
            "id": 1060886
        }, {
            "name": "WALLET_OPEN_UCOINS_MORE_MAX",
            "id": 1060887
        }, {
            "name": "WALLET_OPEN_UCOINS_LESS_MIN",
            "id": 1060888
        }, {
            "name": "WALLET_OPEN_USABLE_BALANCE_NOT_ENOUGH",
            "id": 1060889
        }, {
            "name": "GIFTO_MALL_REQUEST_SUCCESS",
            "id": 1064960
        }, {
            "name": "GIFTO_MALL_DUPLICATED_TRANSACTION",
            "id": 1064961
        }, {
            "name": "GIFTO_MALL_GTO_BALANCE_NOT_ENOUGH",
            "id": 1064962
        }, {
            "name": "GIFTO_MALL_PRARAMETER_INVALID",
            "id": 1064963
        }, {
            "name": "GIFTO_MALL_GIFT_NOT_EXIST",
            "id": 1064964
        }, {
            "name": "GIFTO_MALL_UNKNOWN_EXCEPTION",
            "id": 1064965
        }, {
            "name": "GIFTO_MALL_GIFT_SEND_VIP_LIMIT",
            "id": 1064966
        }, {
            "name": "GIFTO_MALL_GIFTO_RECEIVE_NOT_AUTHORITY",
            "id": 1064967
        }, {
            "name": "GREETING_CARDS_REQUEST_SUCCESS",
            "id": 1069056
        }, {
            "name": "GREETING_CARDS_NOT_GIFT",
            "id": 1069057
        }, {
            "name": "GREETING_CARDS_REQUEST_ERROR",
            "id": 1069058
        }, {
            "name": "GREETING_CARDS_GIFT_ID_ERROR",
            "id": 1069059
        }, {
            "name": "GREETING_CARDS_GIFT_ID_NULL",
            "id": 1069060
        }, {
            "name": "GREETING_CARDS_STATUS_NO_PASS",
            "id": 1069061
        }, {
            "name": "GREETING_CARDS_IP_COUNT_FULL",
            "id": 1069062
        }, {
            "name": "PK_USER_NOT_IN_PK",
            "id": 1073152
        }, {
            "name": "PK_USER_INCONVENIENT",
            "id": 1073153
        }, {
            "name": "PK_USER_OFFLINE",
            "id": 1073154
        }, {
            "name": "PK_SEND_MSG_FAIL",
            "id": 1073155
        }, {
            "name": "PK_USER_ALREADY_IN_INVITE",
            "id": 1073156
        }, {
            "name": "PK_USER_ALREADY_IN_MATCH_WAITING",
            "id": 1073157
        }, {
            "name": "PK_INVALID_USER",
            "id": 1073158
        }, {
            "name": "PK_INVITE_UUID_EXPIRED",
            "id": 1073159
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _rcTooltip = __webpack_require__(27);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Language = function (_Component) {
	_inherits(Language, _Component);

	function Language(props) {
		_classCallCheck(this, Language);

		var _this = _possibleConstructorReturn(this, (Language.__proto__ || Object.getPrototypeOf(Language)).call(this, props));

		_this.state = {
			showSelectPop: false,
			selected: UP.Global.siteLanguage
		};

		_this.LANG_CONFIG = {
			"zh-CN": {
				option: '简体中文',
				text: '简体中文'
			},
			"zh-TW": {
				option: '繁體中文(台灣)&lrm;',
				text: '繁體中文(台灣)'
			},
			"zh-HK": {
				option: '繁體中文(香港)&lrm;',
				text: '繁體中文(香港)'
			},
			"en-US": {
				option: 'English',
				text: 'English'
			},
			"vi-VN": {
				option: 'Tiếng Việt',
				text: 'Tiếng Việt'
			},
			"ar-EG": {
				option: 'العَرَبِيَّة',
				text: 'العَرَبِيَّة'
			},
			'ja-JP': {
				option: '日本語',
				text: '日本語'
			},
			"ko-KR": {
				option: '한국어',
				text: '한국어'
			},
			'ru-RU': {
				option: "Русский",
				text: "Русский"
			},
			'id-ID': {
				option: "Bahasa Indonesia",
				text: "Bahasa Indonesia"
			},
			// 'sp-SP': {
			// 	option: "ภาษาสเปน",
			// 	text: "ภาษาสเปน"
			// },
			'fr-FR': {
				option: "Français",
				text: "Français"
			},
			'pt-PT': {
				option: "Português",
				text: "Português"
			},
			'ms-MY': {
				option: "Bahasa Melayu",
				text: "Bahasa Melayu"
			},
			'th-TH': {
				option: "ภาษาไทย",
				text: "ภาษาไทย"
			},
			'tr-TR': {
				option: "Türkçe",
				text: "Türkçe"
			},
			'es-ES': {
				option: "España",
				text: "España"
			}
		};
		return _this;
	}

	_createClass(Language, [{
		key: "componentWillMount",
		value: function componentWillMount() {
			if (UP.Global.version == 'CN') {
				$.channel.emit('chooseLanguage', 'zh-CN');
			}
		}
	}, {
		key: "onSelect",
		value: function onSelect(lang, e) {
			e.preventDefault();

			if (lang == this.state.selected) {
				return;
			}

			$.channel.emit('chooseLanguage', lang);
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			var _state = this.state,
			    showSelectPop = _state.showSelectPop,
			    selected = _state.selected;

			var langs = UP.Global.languageList;
			var curLanuage = this.LANG_CONFIG[selected].text;

			if (UP.Global.version == 'CN') {
				return null;
			}

			var $langs = _react2.default.createElement(
				"div",
				{ className: "lang-popup clearfix" },
				_react2.default.createElement(
					"ul",
					null,
					langs.map(function (item, index) {
						var selectedCls = item == selected ? 'selected' : '';
						return _react2.default.createElement(
							"li",
							{ key: index, className: item + " " + selectedCls, onClick: _this2.onSelect.bind(_this2, item) },
							_react2.default.createElement("a", { href: "#", dangerouslySetInnerHTML: { __html: _this2.LANG_CONFIG[item].option } })
						);
					})
				)
			);

			return _react2.default.createElement(
				"div",
				{ className: "lang", ref: "lang" },
				_react2.default.createElement(
					_rcTooltip2.default,
					{ getTooltipContainer: function getTooltipContainer() {
							return _this2.refs.lang;
						}, overlay: $langs, placement: "bottomRight", trigger: ['hover'], overlayClassName: "header-popover" },
					_react2.default.createElement(
						"div",
						{ className: "lang-select" },
						_react2.default.createElement("span", { className: "txt", dangerouslySetInnerHTML: { __html: curLanuage } })
					)
				)
			);
		}
	}]);

	return Language;
}(_react.Component);

exports.default = Language;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _userUi = __webpack_require__(22);

var _logout = __webpack_require__(288);

var _logout2 = _interopRequireDefault(_logout);

var _number = __webpack_require__(44);

var _number2 = _interopRequireDefault(_number);

var _rcTooltip = __webpack_require__(27);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Language = function (_Component) {
	_inherits(Language, _Component);

	function Language(props) {
		_classCallCheck(this, Language);

		var _this = _possibleConstructorReturn(this, (Language.__proto__ || Object.getPrototypeOf(Language)).call(this, props));

		_this.login = function () {
			$.channel.emit('login');
		};

		_this.state = {
			isLoggedIn: UP.Global.isLogin()
		};

		_this.cache = new _cCache2.default({
			prefix: 'pcuplive'
		});
		return _this;
	}

	_createClass(Language, [{
		key: "goProfile",
		value: function goProfile() {
			if (this.props.openInNewTab) {
				var url = location.href.replace(location.hash, '') + window.hashHistory.createHref('/profile');
				window.open(url);
			} else {
				window.hashHistory.push('/profile');
			}
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			if (this.cache.getCache('isRegisterRealUser')) {
				// 正式用户
				var user = UP.Global.getUser();

				return _react2.default.createElement(
					"div",
					{ className: "user", ref: "user" },
					_react2.default.createElement(
						_rcTooltip2.default,
						{ getTooltipContainer: function getTooltipContainer() {
								return _this2.refs.user;
							}, overlay: this.props.profile ? _react2.default.createElement(UserPop, null) : null, placement: "bottomRight", trigger: ['hover'], overlayClassName: "header-popover" },
						_react2.default.createElement(
							"div",
							{ className: "avatar", ref: "avatar", onClick: function onClick() {
									return _this2.goProfile();
								} },
							_react2.default.createElement(_userUi.ImageView, { src: user.avatar, size: 30, circle: true })
						)
					)
				);
			} else {
				return _react2.default.createElement(
					"div",
					{ className: "login", onClick: this.login },
					_react2.default.createElement(
						"span",
						{ className: "text" },
						_lang2.default.template('登录')
					)
				);
			}
		}
	}]);

	return Language;
}(_react.Component);

Language.defaultProps = {
	openInNewTab: false,
	profile: false // 是否显示profile弹出层
};

var UserPop = function (_Component2) {
	_inherits(UserPop, _Component2);

	function UserPop(props) {
		_classCallCheck(this, UserPop);

		var _this3 = _possibleConstructorReturn(this, (UserPop.__proto__ || Object.getPrototypeOf(UserPop)).call(this, props));

		_this3.state = {
			userInfo: UP.Global.getUser(),
			vipLevel: UP.Global.isVip()
		};
		return _this3;
	}

	_createClass(UserPop, [{
		key: "componentDidMount",
		value: function componentDidMount() {
			var _this4 = this;

			$.channel.on('rechargeSuccess', function (data) {
				_this4.setState({
					userInfo: UP.Global.getUser()
				});
			});
		}
	}, {
		key: "logout",
		value: function logout() {
			_logout2.default.create();
		}
	}, {
		key: "goURank",
		value: function goURank() {
			hashHistory.push('/profile/contribution');
		}
	}, {
		key: "goWithdraw",
		value: function goWithdraw() {
			hashHistory.push('/withdraw');
		}
	}, {
		key: "goPrivilege",
		value: function goPrivilege() {
			hashHistory.push('/profile/vip-privileges');
		}
	}, {
		key: "goGrade",
		value: function goGrade() {
			hashHistory.push('/profile/grade');
		}
	}, {
		key: "goRecharge",
		value: function goRecharge() {
			hashHistory.push('/recharge');
		}
	}, {
		key: "goProfile",
		value: function goProfile() {
			hashHistory.push('/profile');
		}
	}, {
		key: "render",
		value: function render() {
			var _this5 = this;

			var user = this.state.userInfo;
			var balance = user.balance || {};
			var vipLevel = this.state.vipLevel;

			var $user = _react2.default.createElement(
				"div",
				{ className: "profile-box" },
				_react2.default.createElement(
					"div",
					{ className: "profile-box-hd" },
					_react2.default.createElement(
						"div",
						{ className: "profile-avatar", onClick: function onClick() {
								_this5.goProfile();
							} },
						_react2.default.createElement(_userUi.ImageView, { src: user.avatar, size: 60, circle: true })
					),
					_react2.default.createElement(
						"div",
						{ className: "profile-refs" },
						_react2.default.createElement(
							"p",
							{ className: "username" },
							_react2.default.createElement(
								"span",
								{ onClick: function onClick() {
										_this5.goProfile();
									} },
								user.username
							),
							_react2.default.createElement(
								"em",
								{ onClick: function onClick() {
										_this5.goGrade();
									} },
								_react2.default.createElement(_userUi.Grade, { value: user.grade })
							)
						),
						user.upliveCode ? _react2.default.createElement(
							"p",
							{ className: "upcode" },
							_react2.default.createElement(
								"label",
								null,
								_lang2.default.template('Up号')
							),
							_react2.default.createElement(
								"em",
								null,
								":",
								user.upliveCode
							)
						) : null
					)
				),
				_react2.default.createElement(
					"ul",
					{ className: "profile-box-bd" },
					_react2.default.createElement(
						"li",
						{ className: "diamond go", onClick: function onClick() {
								_this5.goRecharge();
							} },
						_react2.default.createElement(
							"label",
							null,
							_lang2.default.template('我的U钻')
						),
						_react2.default.createElement(
							"em",
							null,
							_number2.default.separate(balance.diamond || 0)
						)
					),
					_react2.default.createElement(
						"li",
						{ className: "vip go", onClick: function onClick() {
								_this5.goPrivilege();
							} },
						_react2.default.createElement(
							"label",
							null,
							_lang2.default.template('我的会员')
						),
						vipLevel ? _react2.default.createElement(
							"em",
							null,
							_react2.default.createElement(_userUi.VIP, { value: "" + vipLevel.label })
						) : _react2.default.createElement(
							"em",
							null,
							_react2.default.createElement(_userUi.VIP, { value: "VIP0" })
						)
					),
					_react2.default.createElement(
						"li",
						{ className: "profile go", onClick: function onClick() {
								return _this5.goProfile();
							} },
						_react2.default.createElement(
							"label",
							null,
							_lang2.default.template('个人主页')
						)
					),
					_react2.default.createElement(
						"li",
						{ className: "account go", onClick: function onClick() {
								return _this5.goWithdraw();
							} },
						_react2.default.createElement(
							"label",
							null,
							_lang2.default.template('我的账户')
						)
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "profile-box-ft" },
					_react2.default.createElement(
						"div",
						{ onClick: function onClick() {
								return _this5.logout();
							} },
						_lang2.default.template('注销')
					)
				)
			);

			return $user;
		}
	}]);

	return UserPop;
}(_react.Component);

exports.default = Language;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

var _logout = __webpack_require__(544);

var _logout2 = _interopRequireDefault(_logout);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _ScaleModal = __webpack_require__(12);

var _ScaleModal2 = _interopRequireDefault(_ScaleModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 登出弹出层
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var pbajax = new _pbajax2.default();

var noop = function noop() {};

var style = {
    modalStyle: {
        width: '320px'
    },
    contentStyle: {
        width: '320px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        backgroundColor: "rgba(0,0,0, 0.5)"
    }
};

var LogoutPop = function (_Component) {
    _inherits(LogoutPop, _Component);

    function LogoutPop(props) {
        _classCallCheck(this, LogoutPop);

        return _possibleConstructorReturn(this, (LogoutPop.__proto__ || Object.getPrototypeOf(LogoutPop)).call(this, props));
    }

    _createClass(LogoutPop, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.refs.modal.show();
        }
    }, {
        key: 'onConfirm',
        value: function onConfirm() {
            this.logout();
        }
    }, {
        key: 'onCancel',
        value: function onCancel() {
            this.refs.modal.hide();
        }
    }, {
        key: 'logout',
        value: function logout() {
            var _this2 = this;

            var _logoutpb$UserLogout = _logout2.default.UserLogout,
                Request = _logoutpb$UserLogout.Request,
                Response = _logoutpb$UserLogout.Response;

            var cfg = {
                service: 'safe',
                api: '/user/logout',
                header: {
                    userToken: UP.Global.getUserToken()
                }
            };

            pbajax.do(cfg, new Request({}), function (res) {
                var dataWrap = _public2.default.Result.decode(res);

                if (dataWrap.code == 1) {
                    // 登出成功
                    _this2.onCancel();
                    window.hashHistory.push('/home');
                    $.channel.emit('logout');
                }
            }, function () {}, function () {});
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                _ScaleModal2.default,
                {
                    ref: 'modal',
                    modalStyle: style.modalStyle,
                    backdropStyle: style.backdropStyle,
                    contentStyle: style.contentStyle
                },
                _react2.default.createElement(
                    'div',
                    { className: 'logout-pop' },
                    _react2.default.createElement(
                        'div',
                        { className: 'logout-pop-hd' },
                        _index2.default.template('提示')
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'logout-pop-bd' },
                        _index2.default.template('确认退出Up直播？')
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'logout-pop-ft' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn cancel', onClick: function onClick() {
                                    return _this3.onCancel();
                                } },
                            _index2.default.template('取消')
                        ),
                        _react2.default.createElement(
                            'button',
                            { className: 'btn confirm', onClick: function onClick() {
                                    return _this3.onConfirm();
                                } },
                            _index2.default.template('确认')
                        )
                    )
                )
            );
        }
    }]);

    return LogoutPop;
}(_react.Component);

LogoutPop.defaultProps = {
    onHide: noop
};


module.exports = {
    create: function create(cfg) {
        cfg = cfg || {};

        if (this.layer) {
            this.destroy();
        }
        var mountNode = this.createMountNode();

        this.layer = _reactDom2.default.render(_react2.default.createElement(LogoutPop, _extends({}, cfg, { onHide: this.onHide.bind(this) })), mountNode);
    },
    onHide: function onHide() {
        this.destroy();
    },
    // 创建组件插入的DOM节点
    createMountNode: function createMountNode() {
        this.mountNode = document.createElement("div");
        $(document.body).append(this.mountNode);
        return this.mountNode;
    },
    destroy: function destroy() {
        _reactDom2.default.unmountComponentAtNode(this.mountNode);
        $(this.mountNode).remove();
        delete this.layer;
    }
};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _h = __webpack_require__(546);

var _h2 = _interopRequireDefault(_h);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _userUi = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RechargeView = function (_Component) {
	_inherits(RechargeView, _Component);

	function RechargeView(props) {
		_classCallCheck(this, RechargeView);

		var _this = _possibleConstructorReturn(this, (RechargeView.__proto__ || Object.getPrototypeOf(RechargeView)).call(this, props));

		_this.login = function () {
			$.channel.emit('login');
		};

		var diamond = UP.Global.getUser().balance.diamond;

		_this.state = {
			diamondBanlance: diamond,
			isLoggedIn: 0
		};
		return _this;
	}

	_createClass(RechargeView, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (UP.Global.isRegisterRealUser() && UP.Global.getUserToken()) {
				this.setState({
					isLoggedIn: 1
				});
			}
			UP.Global.DA.add({
				eventName: 'UplivePayment',
				action: 'View',
				label: 'view'
			});

			window.scrollTo(0, 0);
		}
	}, {
		key: 'render',
		value: function render() {
			var $recharge = void 0;
			var countryCode = UP.Global.getUser().countryCode; // 当前用户的国家码
			var userInfo = UP.Global.getUser();

			$recharge = _react2.default.createElement(_h2.default, null);

			return _react2.default.createElement(
				'div',
				{ className: 'recharge-box' },
				_react2.default.createElement(
					'h2',
					null,
					_lang2.default.template('账户充值')
				),
				_react2.default.createElement(
					'div',
					{ className: 'recharge-content', 'data-type': this.props.type, id: 'rechargeScroller' },
					this.state.isLoggedIn ? _react2.default.createElement(
						'div',
						{ className: 'recharge-content-hd' },
						_react2.default.createElement(
							'div',
							{ className: 'avatar', ref: 'avatar' },
							_react2.default.createElement(_userUi.ImageView, { src: userInfo.avatar, size: 30, circle: true })
						),
						_react2.default.createElement(
							'div',
							{ className: 'user-name' },
							_react2.default.createElement(
								'div',
								null,
								userInfo.username
							),
							_react2.default.createElement(
								'div',
								{ className: 'uzuan' },
								_react2.default.createElement(
									'label',
									null,
									_lang2.default.template('剩余U钻'),
									'  '
								),
								_react2.default.createElement(
									'em',
									null,
									this.state.diamondBanlance
								),
								_react2.default.createElement('i', null)
							)
						)
					) : _react2.default.createElement(
						'div',
						{ className: 'recharge-content-hd' },
						_react2.default.createElement(
							'div',
							{ className: 'avatar', ref: 'avatar' },
							_react2.default.createElement(_userUi.ImageView, { size: 30, circle: true })
						),
						_react2.default.createElement(
							'div',
							{ className: 'user-name' },
							_react2.default.createElement(
								'p',
								{ className: 'login-tip', onClick: this.login.bind(this) },
								_react2.default.createElement('label', { className: 'r-tip', dangerouslySetInnerHTML: { __html: _lang2.default.template("<em>登录</em>之后即可进行充值") } })
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'recharge-content-bd' },
						$recharge
					)
				)
			);
		}
	}]);

	return RechargeView;
}(_react.Component);

RechargeView.defaultProps = {
	type: 'page' // page，pop
};
exports.default = RechargeView;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _cNotification = __webpack_require__(11);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _countryView = __webpack_require__(87);

var _countryView2 = _interopRequireDefault(_countryView);

var _cTimer = __webpack_require__(100);

var _cTimer2 = _interopRequireDefault(_cTimer);

var _confirm = __webpack_require__(73);

var _confirm2 = _interopRequireDefault(_confirm);

var _smscode = __webpack_require__(617);

var _smscode2 = _interopRequireDefault(_smscode);

var _cUpLoading = __webpack_require__(13);

var _cUpLoading2 = _interopRequireDefault(_cUpLoading);

var _bindphone = __webpack_require__(618);

var _bindphone2 = _interopRequireDefault(_bindphone);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _md = __webpack_require__(68);

var _md2 = _interopRequireDefault(_md);

var _register = __webpack_require__(205);

var _register2 = _interopRequireDefault(_register);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 绑定手机
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var pbajax = new _pbajax2.default();
var cache = new _cCache2.default({
    prefix: 'pcuplive'
});

var BindPhoneView = function (_Component) {
    _inherits(BindPhoneView, _Component);

    function BindPhoneView(props) {
        _classCallCheck(this, BindPhoneView);

        var _this = _possibleConstructorReturn(this, (BindPhoneView.__proto__ || Object.getPrototypeOf(BindPhoneView)).call(this, props));

        _this.handleSubmit = function (e) {
            if (_this.isFetching) {
                return;
            }

            if (!_this.state.code) {
                _cNotification2.default.simple(_lang2.default.template('选择国家或地区'));
                _this.setState({
                    showSelect: true
                });
                return;
            }

            if (_this.verify()) {
                _this.isFetching = true;

                _cUpLoading2.default.show({
                    content: _lang2.default.template('正在绑定...')
                });
                _this.submit();
            }
        };

        _this.handleSelectCountry = function () {
            if (_this.state.showSelect) {
                return;
            }

            _this.setState({
                showSelect: true
            });
        };

        _this.clicVerifyCode = function () {
            var self = _this;
            var phone = $(_this.refs.phone).val();

            if (phone.trim().length == 0) {
                _cNotification2.default.simple(_lang2.default.template('请输入手机号码'));
                return;
            }

            if (_this.state.disVerifyCode) {
                return;
            } else {
                self.getverifyCode();
            };
        };

        _this.state = {
            showSelect: false,
            disVerifyCode: false,
            hidePwd: true
        };
        return _this;
    }

    _createClass(BindPhoneView, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var self = this;
            var el = $(this.refs.areaCode);

            el.on({
                mouseenter: function mouseenter(e) {
                    // self.setState({
                    //  showSelect: true
                    // });
                },
                mouseleave: function mouseleave(e) {
                    self.setState({
                        showSelect: false
                    });
                },
                click: function click(e) {
                    self.setState({
                        showSelect: true
                    });
                }
            });

            $(document.body).on('click', function (e) {
                var el = $(e.target);
                var showSelect = false;

                if ($('.country-list-wrap').find(el).length > 0 || $('.country-list-wrap').find(el).length > 0) {
                    showSelect = true;
                }

                _this2.setState({
                    showSelect: showSelect
                });
            });

            UP.Global.DA.add({
                eventName: 'showbindPhoneView',
                action: 'show'
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            $(document.body).off('click');
            this.timer && this.timer.destroy();
        }
    }, {
        key: 'submit',
        value: function submit() {
            var self = this;
            var phone = this.refs.phone.value.trim();
            var smsCode = this.refs.verifyCode.value.trim();
            var password = this.refs.password.value.trim();

            var _registerPb$ThirdChec = _register2.default.ThirdCheck.Register,
                Request = _registerPb$ThirdChec.Request,
                Response = _registerPb$ThirdChec.Response;

            var mobilePhone = this.state.areaCode + '' + phone;

            var businessData = new Request({
                bind: 1,
                bindType: 1,
                mobilePhone: mobilePhone,
                smsCode: smsCode,
                password: (0, _md.hex_md5)(password),
                countryCode: this.state.code
            });

            var requestData = {
                service: 'service',
                api: '/third/check/register',
                header: {
                    userToken: UP.Global.getUserToken()
                }
            };

            UP.Global.DA.add({
                eventName: 'bindPhoneSendRequest',
                action: 'click'
            });

            pbajax.do(requestData, businessData, function (res) {
                _cUpLoading2.default.hide();
                var dataWrap = _public2.default.Result.decode(res);
                var data = void 0;

                if (dataWrap.code == 1) {
                    data = Response.decode(dataWrap.data.value);
                    UP.Global.updateUserInfo('mobilePhone', mobilePhone);

                    _cNotification2.default.simple(_lang2.default.template('绑定成功'));

                    self.props.onComplete(mobilePhone);

                    UP.Global.DA.add({
                        eventName: 'bindPhoneSendRequestSuccess',
                        action: 'click'
                    });
                } else {
                    if (dataWrap.code == 4099) {
                        _cNotification2.default.simple(_lang2.default.template('验证码错误！'));
                    } else {
                        _cNotification2.default.simple(_lang2.default.template('绑定失败'));
                    }

                    UP.Global.DA.add({
                        eventName: 'bindPhoneSendRequestError' + dataWrap.code,
                        action: 'click'
                    });
                }
                self.isFetching = false;
            }, function () {
                _cUpLoading2.default.hide();
                self.isFetching = false;
            }, function () {
                _cUpLoading2.default.hide();
                self.isFetching = false;
            });
        }
    }, {
        key: 'verify',
        value: function verify() {
            var phone = this.refs.phone.value.trim();
            var password = this.refs.password.value.trim();
            var verifyCode = this.refs.verifyCode.value.trim();

            if (phone == '') {
                _cNotification2.default.simple(_lang2.default.template('请输入手机号码'));
                return false;
            } else if (verifyCode == '') {
                _cNotification2.default.simple(_lang2.default.template('请输入验证码'));
                return false;
            } else if (password == '') {
                _cNotification2.default.simple(_lang2.default.template('请输入密码'));
                return false;
            }

            return true;
        }
    }, {
        key: 'getverifyCode',
        value: function getverifyCode() {
            var self = this;
            var _codepb$Sms$SendCode = _smscode2.default.Sms.SendCode,
                Request = _codepb$Sms$SendCode.Request,
                Response = _codepb$Sms$SendCode.Response;

            var phone = $(this.refs.phone).val().trim();

            var deviceId = this.getCurrentUuid();
            var ua = UP.Global.getDefaultUA();

            var s1 = _md2.default.hex_md5(_md2.default.hex_md5(ua) + deviceId);
            s1 = s1.substring(s1.length - 8);

            var s2 = _md2.default.hex_md5(deviceId + 'jq5kmuqcWkrJD7M');
            s2 = s2.substring(s2.length - 24);

            var signature = s2 + s1;
            var mobilePhone = this.state.areaCode + '' + phone;

            var businessData = new Request({
                mobilePhone: mobilePhone,
                deviceId: deviceId,
                signature: signature,
                module: 'bindMobile'
            });

            UP.Global.DA.add({
                eventName: 'bindPhoneSendCode',
                action: 'click'
            });

            pbajax.do({
                service: 'service',
                api: '/sms/send/code',
                header: {
                    userToken: UP.Global.getUserToken(),
                    UserAgent: ua
                }
            }, businessData, function (res) {

                var dataWrap = _public2.default.Result.decode(res),
                    data = void 0;
                var tip = _lang2.default.template('系统错误');

                if (dataWrap.code == 1) {
                    var second = $('[data-second=second]');
                    var code = second.parent('b');

                    second.removeClass('hidden');
                    code.addClass('dis');

                    self.setState({
                        disVerifyCode: true
                    });

                    var timer = self.timer = new _cTimer2.default({
                        remainTime: '60',
                        isDoubleBit: true,
                        selector: {
                            second: '[data-second]'
                        }
                    });

                    self.timer.on('end', function () {
                        second.addClass('hidden');
                        code.removeClass('dis');
                        self.setState({
                            disVerifyCode: false
                        });
                    });

                    UP.Global.DA.add({
                        eventName: 'bindPhoneSendCodeSuccess',
                        action: 'click'
                    });
                } else {
                    if (dataWrap.code == 4101) {
                        _cNotification2.default.simple(_lang2.default.template('此帐号已绑定'));
                    } else {
                        _cNotification2.default.simple(_lang2.default.template('系统错误'));
                    }

                    UP.Global.DA.add({
                        eventName: 'bindPhoneSendCodeError' + dataWrap.code,
                        action: 'click'
                    });
                }
            });
        }
    }, {
        key: 'hidePwd',
        value: function hidePwd() {
            this.setState({
                hidePwd: !this.state.hidePwd
            });
        }

        /**
         * 模拟当前用户的身份标示
         * @param 
         * @return string
         */

    }, {
        key: 'uuid',
        value: function uuid(len, radix) {
            var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
            var uuid = [],
                i;
            radix = radix || chars.length;

            if (len) {
                // Compact form
                for (i = 0; i < len; i++) {
                    uuid[i] = chars[0 | Math.random() * radix];
                }
            } else {
                // rfc4122, version 4 form
                var r;

                // rfc4122 requires these characters
                uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
                uuid[14] = '4';

                // Fill in random data.  At i==19 set the high bits of clock sequence as
                // per rfc4122, sec. 4.1.5
                for (i = 0; i < 36; i++) {
                    if (!uuid[i]) {
                        r = 0 | Math.random() * 16;
                        uuid[i] = chars[i == 19 ? r & 0x3 | 0x8 : r];
                    }
                }
            }

            return uuid.join('');
        }

        // 获取当前有效的uuid（有效期5分钟）

    }, {
        key: 'getCurrentUuid',
        value: function getCurrentUuid() {
            // __ppuuid__ : uuid,timestamp
            var uuid = '';
            var old = cache.getCache('__pcuuid__');
            if (old) {
                var isExpire = this.checkExpire();

                // 若已失效
                if (isExpire) {
                    uuid = this.uuid(60);
                    cache.setCache('__pcuuid__', uuid);
                    cache.setCache('__pcuuid__stamp__', +new Date());
                } else {
                    uuid = old;
                    this.updateValidTime();
                }
            } else {
                uuid = this.uuid(60);
                cache.setCache('__pcuuid__', uuid);
                cache.setCache('__pcuuid__stamp__', +new Date());
            }

            return uuid;
        }

        // 判断uuid是否失效(超过1天)

    }, {
        key: 'checkExpire',
        value: function checkExpire() {
            var stamp = cache.getCache('__pcuuid__stamp__');
            var curStamp = +new Date();
            return curStamp - Number(stamp) > 24 * 60 * 60 * 1000;
        }

        // 更新当前的有效期

    }, {
        key: 'updateValidTime',
        value: function updateValidTime() {
            cache.setCache('__pcuuid__stamp__', +new Date());
        }
    }, {
        key: 'onSelectOption',
        value: function onSelectOption(data) {
            // console.log(data);

            if (!data.inputValuePlusCode) {
                data.inputValuePlusCode = _lang2.default.template('国家/地区');
            }

            var state = Object.assign({}, { showSelect: false }, data);

            this.setState(state);
        }
    }, {
        key: 'render',
        value: function render() {
            var userInfo = UP.Global.getUser();

            var VerifyCodeText = void 0;

            if (this.state.disVerifyCode) {
                VerifyCodeText = "s";
            } else {
                VerifyCodeText = _lang2.default.template('发送验证码');
            }

            return _react2.default.createElement(
                'div',
                { className: 'phone-bind' },
                _react2.default.createElement(
                    'div',
                    { className: 'bind-form-item choosecountry', ref: 'areaCode' },
                    _react2.default.createElement(
                        'div',
                        { className: 'input-wrap arrow', onClick: this.handleSelectCountry },
                        _react2.default.createElement(
                            'div',
                            { className: 'input' },
                            this.state.inputValuePlusCode,
                            '\u200E'
                        )
                    ),
                    _react2.default.createElement(_countryView2.default, { visible: this.state.showSelect, selectOption: this.onSelectOption.bind(this), ref: 'countryView' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'bind-form-item' },
                    _react2.default.createElement(
                        'div',
                        { className: 'input-wrap' },
                        _react2.default.createElement('input', {
                            className: 'input',
                            ref: 'phone',
                            type: 'text',
                            placeholder: _lang2.default.template('请输入手机号码')
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'bind-form-item verifyCode' },
                    _react2.default.createElement(
                        'div',
                        { className: 'input-wrap' },
                        _react2.default.createElement('input', {
                            className: 'input',
                            ref: 'verifyCode',
                            type: 'tel',
                            placeholder: _lang2.default.template('请输入验证码')
                        })
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: 'small-btn', onClick: this.clicVerifyCode },
                        _react2.default.createElement('span', { 'data-second': 'second' }),
                        VerifyCodeText
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'bind-form-item' },
                    _react2.default.createElement(
                        'div',
                        { className: 'input-wrap' },
                        _react2.default.createElement('input', {
                            className: 'input',
                            ref: 'password',
                            type: this.state.hidePwd ? 'password' : 'text',
                            placeholder: _lang2.default.template('请输入密码')
                        }),
                        _react2.default.createElement('i', { className: this.state.hidePwd ? 'icon' : 'icon pwd-show', onClick: this.hidePwd.bind(this) })
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'mini-tip' },
                        _lang2.default.template('密码由6-20位数字和字母组成')
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'bind-pop-tip' },
                    _react2.default.createElement(
                        'div',
                        { className: 'notice' },
                        _react2.default.createElement('span', { className: 'tip', ref: 'tip', dangerouslySetInnerHTML: { __html: _lang2.default.template("绑定手机号码,有利于保护您的账号和资金安全") } })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'phone-bind-btn', onClick: this.handleSubmit },
                    _lang2.default.template('确认')
                )
            );
        }
    }]);

    return BindPhoneView;
}(_react.Component);

BindPhoneView.defaultProps = {
    content: '',
    onCancel: function onCancel() {}
};
exports.default = BindPhoneView;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _listPannel = __webpack_require__(619);

var _listPannel2 = _interopRequireDefault(_listPannel);

var _rcTooltip = __webpack_require__(27);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchUser = function (_Component) {
	_inherits(SearchUser, _Component);

	function SearchUser(props) {
		_classCallCheck(this, SearchUser);

		var _this = _possibleConstructorReturn(this, (SearchUser.__proto__ || Object.getPrototypeOf(SearchUser)).call(this, props));

		_this.onKeyDown = function (e) {
			if (e.keyCode == 13) {
				// 按Enter
				_this.handleSearch();
			}
		};

		_this.onScroll = function (e) {
			_this.refs.list && _this.refs.list.scroll(e);
		};

		_this.handleSearch = function () {
			var val = _this.refs.search.value.trim();

			if (val == '') {
				return;
			}

			_this.setState({
				keyword: val
			});
		};

		_this.state = {
			keyword: '',
			showSearchResult: false
		};
		return _this;
	}

	_createClass(SearchUser, [{
		key: 'keyupHanlder',
		value: function keyupHanlder(e) {
			var _this2 = this;

			var el = $(e.currentTarget);

			this.timer && clearTimeout(this.timer);

			this.timer = setTimeout(function () {
				_this2.setState({
					keyword: el.val()
				});
			}, 400);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this3 = this;

			$(document.body).on('click', function (e) {
				var el = $(e.target);
				var showSearchResult = false;
				if ($('.s-result').find(el).length > 0 || $('.search').find(el).length > 0) {
					showSearchResult = true;
				}
				_this3.setState({
					showSearchResult: showSearchResult
				});
			});

			$.channel.on('hideSearchResult', function () {
				_this3.setState({
					showSearchResult: false
				});
				_this3.refs.search.value = '';
			});
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			$(document.body).off('click');
			$.channel.off('hideSearchResult');
		}
	}, {
		key: 'render',
		value: function render() {
			var _this4 = this;

			var keyword = this.state.keyword;

			$pop = _react2.default.createElement(
				'div',
				{ className: 's-result s-result-pop ' + (keyword ? "" : "hidden") },
				_react2.default.createElement(
					'div',
					{ className: 's-result-scroller hostlist-lite', onScroll: this.onScroll },
					keyword ? _react2.default.createElement(_listPannel2.default, { keyword: keyword, showFollowInfo: 'true', ref: 'list' }) : null
				)
			);

			return _react2.default.createElement(
				'div',
				{ className: 'search', ref: 'search' },
				_react2.default.createElement(
					_rcTooltip2.default,
					{ getTooltipContainer: function getTooltipContainer() {
							return _this4.refs.search;
						}, overlay: $pop, placement: 'bottom', trigger: ['click'], overlayClassName: 'header-popover header-search-popover' },
					_react2.default.createElement(
						'div',
						{ className: 'result-pop-hd' },
						_react2.default.createElement(
							'div',
							{ className: 'input-wrap' },
							_react2.default.createElement('input', {
								type: 'text',
								autoComplete: 'off',
								className: 'search-user-input',
								ref: 'search',
								placeholder: _lang2.default.template('请输入用户昵称或Up号'),
								onChange: this.keyupHanlder.bind(this),
								onKeyDown: this.onKeyDown,
								maxLength: '15'
							}),
							_react2.default.createElement(
								'span',
								{ className: 'search-icon' },
								_lang2.default.template('搜索')
							)
						)
					)
				)
			);
		}
	}]);

	return SearchUser;
}(_react.Component);

exports.default = SearchUser;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
    // 繁体版本
    'TW': [{
        key: 'gamehall',
        name: '游戏大厅',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?td_channelid=h5uplive&from=100',
        images: __webpack_require__(631)
    }, {
        key: 'luckyfruit',
        name: '幸运水果机',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=12&td_channelid=h5uplive&from=100',
        images: __webpack_require__(632)
    }, {
        key: 'horserace',
        name: '极速赛马场',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=20&td_channelid=h5uplive&from=100',
        images: __webpack_require__(633)
    }, {
        key: 'speedduel',
        name: '豪车派对',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=23&td_channelid=h5uplive&from=100',
        images: __webpack_require__(634)
    }, {
        key: 'phoenixwar',
        name: '凤凰烈焰',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=32&td_channelid=h5uplive&from=100',
        images: __webpack_require__(635)
    }, {
        key: 'forsetparty',
        name: '鸿运转转赚',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=36&td_channelid=h5uplive&from=100',
        images: __webpack_require__(636)
    }, {
        key: 'bountyhunte',
        name: '赏金猎人',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=40&td_channelid=h5uplive&from=100',
        images: __webpack_require__(637)
    }, {
        key: 'roulette',
        name: '欢乐轮盘',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=38&td_channelid=h5uplive&from=100',
        images: __webpack_require__(638)
    }, {
        key: 'dragonboat',
        name: '龙舟大赛',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=39&td_channelid=h5uplive&from=100',
        images: __webpack_require__(639)
    }],
    // 英文
    'EN': [{
        key: 'gamehall',
        name: '游戏大厅',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?td_channelid=h5uplive&region=5&from=100',
        images: __webpack_require__(241)
    }, {
        key: 'luckyfruit',
        name: '幸运水果机',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=12&td_channelid=h5uplive&region=5&from=100',
        images: __webpack_require__(242)
    }, {
        key: 'horserace',
        name: '极速赛马场',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=20&td_channelid=h5uplive&region=5&from=100',
        images: __webpack_require__(243)
    }, {
        key: 'speedduel',
        name: '豪车派对',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=23&td_channelid=h5uplive&region=5&from=100',
        images: __webpack_require__(640)
    }, {
        key: 'phoenixwar',
        name: '凤凰烈焰',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=32&td_channelid=h5uplive&region=5&from=100',
        images: __webpack_require__(244)
    }, {
        key: 'bountyhunte',
        name: '赏金猎人',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=40&td_channelid=h5uplive&region=5&from=100',
        images: __webpack_require__(641)
    }, {
        key: 'roulette',
        name: '欢乐轮盘',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=38&td_channelid=h5uplive&region=5&from=100',
        images: __webpack_require__(642)
    }],
    // 阿语
    'EG': [{
        key: 'luckyfruit',
        name: '幸运水果机',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=12&td_channelid=h5uplive&region=3&from=100',
        images: __webpack_require__(643)
    }, {
        key: 'horserace',
        name: '极速赛马场',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=20&td_channelid=h5uplive&region=3&from=100',
        images: __webpack_require__(644)
    }, {
        key: 'phoenixwar',
        name: '凤凰烈焰',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=32&td_channelid=h5uplive&region=3&from=100',
        images: __webpack_require__(645)
    }, {
        key: 'forsetparty',
        name: '鸿运转转赚',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=36&td_channelid=h5uplive&region=3&from=100',
        images: __webpack_require__(646)
    }],
    // 印度
    'IN': [{
        key: 'gamehall',
        name: '游戏大厅',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?td_channelid=h5uplive&region=6&from=100',
        images: __webpack_require__(241)
    }, {
        key: 'luckyfruit',
        name: '幸运水果机',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=12&td_channelid=h5uplive&region=6&from=100',
        images: __webpack_require__(242)
    }, {
        key: 'horserace',
        name: '极速赛马场',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=20&td_channelid=h5uplive&region=5&from=100',
        images: __webpack_require__(243)
    }, {
        key: 'phoenixwar',
        name: '凤凰烈焰',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=32&td_channelid=h5uplive&region=5&from=100',
        images: __webpack_require__(244)
    }],
    // 越南
    'VN': [{
        key: 'gamehall',
        name: '游戏大厅',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?td_channelid=h5uplive&region=5&from=100',
        images: __webpack_require__(647)
    }, {
        key: 'luckyfruit',
        name: '幸运水果机',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=12&td_channelid=h5uplive&region=5&from=100',
        images: __webpack_require__(648)
    }, {
        key: 'horserace',
        name: '极速赛马场',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=20&td_channelid=h5uplive&region=5&from=100',
        images: __webpack_require__(649)
    },
    // {
    //     key: 'forsetparty',
    //     name: '鸿运转转赚',
    //     jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=36&td_channelid=h5uplive&region=5&from=100',
    //     images: require('../../images/gamecenter/vn/forsetparty.jpg')
    // }, 
    {
        key: 'roulette',
        name: '欢乐轮盘',
        jump: 'http://upgame.upliveapps.com/up_casino_lobby_asia/index.html?action=openBanner&bannerId=38&td_channelid=h5uplive&region=5&from=100',
        images: __webpack_require__(650)
    }]
}; /**
    * 游戏配置
    */


var countryConfig = [{
    code: 'TW',
    open: true,
    countryCode: ['CN', 'TW', 'HK', 'SG', 'MY', 'MO', 'MYC', 'MYNC']
}, {
    code: 'EN',
    open: true,
    countryCode: ["GB", "AS", "AT", "AU", "AX", "BB", "BM", "BS", "CZ", "DE", "DK", "FI", "GL", "GR", "GY", "IE", "IS", "IT", "MM", "PL", "PM", "ZR"]
}, {
    code: 'VN',
    open: true,
    countryCode: ['VN']
}, {
    code: 'IN',
    open: true,
    countryCode: ['IN']
}, {
    code: 'EG',
    open: true,
    countryCode: ['EG', 'SA', 'MA', 'AE', 'AF', 'BH', 'DJ', 'DZ', 'IQ', 'JO', 'KM', 'KW', 'LB', 'LY', 'MR', 'OM', 'PS', 'QA', 'SD', 'SO', 'SS', 'SSD', 'SY', 'TN', 'YE']
}];

exports.default = {
    getGameConfig: function getGameConfig(countryCode) {
        var result = [];

        for (var i = 0, len = countryConfig.length; i < len; i++) {
            var item = countryConfig[i];

            if (item.countryCode.indexOf(countryCode) > -1 && item.open) {

                result = config[item.code];
                break;
            }
        }

        return result;
    },
    checkCountryCode: function checkCountryCode(countryCode) {
        var flag = false;

        for (var i = 0, len = countryConfig.length; i < len; i++) {
            var item = countryConfig[i];

            if (item.countryCode.indexOf(countryCode) > -1 && item.open) {

                flag = true;
                break;
            }
        }

        return flag;
    }
};

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * wechat framework
                                                                                                                                                                                                                                                                               */


var _jsBase = __webpack_require__(660);

var _jsBase2 = _interopRequireDefault(_jsBase);

var _into = __webpack_require__(665);

var _into2 = _interopRequireDefault(_into);

var _purl = __webpack_require__(666);

var _purl2 = _interopRequireDefault(_purl);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _events = __webpack_require__(74);

var _events2 = _interopRequireDefault(_events);

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

var _cNotification = __webpack_require__(11);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _cUpLoading = __webpack_require__(13);

var _cUpLoading2 = _interopRequireDefault(_cUpLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WebChat = function WebChat() {
    this.initialize.apply(this, arguments);
};

WebChat.prototype = Object.assign({

    /**
     * initialize
     * @param cfg {object} 
     *  - userToken {string} current userToken
     *  - roomId {int} room id
     *  - wType {string} define the client type which create websocket object, options: 0 pcweb 1 mobileweb
     *  - insg {boolean} the field will decide which server to send the request to, true -> Singapore, false->China
     * @return void
     */
    initialize: function initialize(cfg) {
        this.pingTimeout = 10; // second
        this.userToken = cfg.userToken;
        this.wType = cfg.wType;
        this.roomId = cfg.roomId;
        this.onlyView = cfg.onlyView;
        this.agreePayFlag = cfg.agreePayFlag;
        this.pbajax = new _pbajax2.default();
        this.needAckMsg = {};
        this.getIntoMsg();
    },

    /**
     * get websocket params and all the valid message from server, such as video source, etc.
     * @return void
     */
    getIntoMsg: function getIntoMsg(agreePay) {
        var _this = this;

        var self = this;
        var agreePayFlag = false;

        if (typeof this.agreePayFlag !== 'undefined') {
            agreePayFlag = this.agreePayFlag;
        }

        var data = {
            roomId: this.roomId,
            wType: this.wType,
            checkLifted: true,
            agreePayFlag: agreePayFlag
        };

        this.pbajax.do({
            service: 'room',
            api: '/room/web/normal/into',
            header: {
                userToken: this.userToken,
                'Accept-Language': _index2.default.type
            }
        }, new _into2.default.Room.WebNormalInto.Request(data), function (res) {
            _cUpLoading2.default.hide();
            var dataWrap = _public2.default.Result.decode(res);
            var data;

            if (dataWrap.code == 1) {
                data = _into2.default.Room.WebNormalInto.Response.decode(dataWrap.data.value);
                data.isLimitSpeak = !data.checkLiftedR;
                _this.data = data;
                self.sid = longToString(data.sid);
                self.userInfo = data.userInfo;

                if (!self.onlyView) {
                    _this.initSocket(data);
                }

                // 直播类型，0：免费公播；1:收费公播；2: 免费私播；3：收费私播
                var liveType = 0;

                if (data.privateLiveFlag) {
                    //  私播
                    if (parseInt(longToString(data.fee), 10) > 0) {
                        liveType = 3;
                    } else {
                        liveType = 2;
                    }
                } else {
                    if (parseInt(longToString(data.fee), 10) > 0) {
                        liveType = 1;
                    } else {
                        liveType = 0;
                    }
                }
                data.liveType = liveType;
                _this.liveType = liveType;
                if (data.privateLiveFlag) {
                    self.emit('getIntoException', 'sibo');
                } else {
                    _this.emit('getIntoSuccess', data);
                }
            } else {
                if (dataWrap.code == 20508) {
                    data = _into2.default.Room.WebNormalInto.Response.decode(dataWrap.data.value);
                    _this.agreePayFee = longToString(data.fee);

                    if (data.privateLiveFlag) {
                        self.emit('getIntoException', 'sibo');
                        return;
                    }
                } else if (dataWrap.code == 12291) {
                    _this.agreePayFlag = false;
                }
                // 20482 live room disabled
                // 4096 parameter error
                // 8192 need relogin
                // 20508 this room need charge
                // 20512 私播直播间人数达到上限
                // 12291 私播购买U钻不够
                // 12296 私播购买失败
                self.emit('getIntoException', dataWrap.code);
            }
        }, function () {
            self.emit('getIntoTimeout');
        }, function () {
            self.emit('getIntoFail');
        });
    },

    /**获取横屏标识*/
    getGameLivingFlag: function getGameLivingFlag(agreePay) {
        var _this2 = this;

        var promise = $.Deferred();
        var isGameFlag = false;
        var self = this;
        var agreePayFlag = false;

        if (typeof this.agreePayFlag !== 'undefined') {
            agreePayFlag = this.agreePayFlag;
        }

        var data = {
            roomId: this.roomId,
            wType: this.wType,
            checkLifted: true,
            agreePayFlag: agreePayFlag
        };

        this.pbajax.do({
            service: 'room',
            api: '/room/web/normal/into',
            header: {
                userToken: this.userToken,
                'Accept-Language': _index2.default.type
            }
        }, new _into2.default.Room.WebNormalInto.Request(data), function (res) {
            _cUpLoading2.default.hide();
            var dataWrap = _public2.default.Result.decode(res);
            var data;

            if (dataWrap.code == 1) {
                data = _into2.default.Room.WebNormalInto.Response.decode(dataWrap.data.value);
                data.isLimitSpeak = !data.checkLiftedR;
                _this2.data = data;
                // 游戏直播，通过liveModel == 2 来判断。标签和横竖屏都不准确。
                isGameFlag = data.liveModel == 2;
            }
            promise.resolve(isGameFlag);
        }, function () {
            promise.resolve(isGameFlag);
        }, function () {
            promise.resolve(isGameFlag);
        });

        return promise;
    },

    getPUrl: function getPUrl(success) {
        var _purlpb$Room$WebNorma = _purl2.default.Room.WebNormalPurlGet,
            Request = _purlpb$Room$WebNorma.Request,
            Response = _purlpb$Room$WebNorma.Response;


        var businessData = new Request({
            roomId: this.roomId
        });

        this.pbajax.do({
            service: 'room',
            api: '/room/web/normal/purl/get',
            header: {
                userToken: this.userToken
            }
        }, businessData, function (res) {
            _cUpLoading2.default.hide();

            var dataWrap = _public2.default.Result.decode(res);
            var data;

            if (dataWrap.code == 1) {
                data = Response.decode(dataWrap.data.value);

                var liveMsg = _jsBase2.default.decode(_jsBase2.default.decode(data.purl));

                success({
                    liveMsg: liveMsg
                });
            } else {
                // 检查到用户不在房间返回错误码SC_LIVE_ROOM_NO_PERMISSION
                // code: 20483 , msg: "user have no permission!"
            }
        }, function () {}, function () {});
    },

    // 初始化websocket连接
    initSocket: function initSocket(data) {
        var isHttps = location.protocol === 'https:';
        var whiteList = ['wsappawebsg.upliveapp.com', 'nowsappawebsg.upliveapp.com', 'wsappawebsgstage.upliveapp.com', 'nowsappawebsgstage.upliveapp.com'];
        var protocol = 'ws://';

        if (whiteList.indexOf(data.wsIp) > -1) {
            protocol = 'wss://';
            data.wsPort = 443;
        } else {
            if (isHttps) {
                data.wsPort = 443;
                data.wsIp = 'sg-chat.upliveapp.com';
                protocol = 'wss://';
            }
        }

        var socketUrl = protocol + data.wsIp + ':' + data.wsPort + data.wsPath + '?';

        var search = {
            sid: this.sid,
            roomId: this.roomId,
            time: longToString(data.time),
            nonce: data.nonce,
            termType: data.termType,
            userInfo: this.userInfo,
            sec: data.sec
        };
        socketUrl += this.pbajax.serializeURI(search);
        this.createSocket(socketUrl);
    },

    /**
     * create websocket
     */
    createSocket: function createSocket(url) {
        if (!('WebSocket' in window)) {
            return;
        }
        console.info('--create--');
        this.url = url;
        this.socket = new WebSocket(url);
        this.bindEventToSocket();
    },

    // 监听socket事件
    bindEventToSocket: function bindEventToSocket() {
        var self = this;
        var timer;
        this.socket.onopen = function (res) {
            self.emit('open');

            this.closeByManual = false;
            // if user has logined
            if (self.userInfo) {
                timer = setTimeout(function () {
                    clearTimeout(timer);
                    self.sendAttend();
                }, 300);
            }

            self.createPingTimer();
        };
        this.socket.onmessage = function (resp) {
            var data;

            // 如果是pong报文, 则不会出发message事件
            if (resp.data == 4) {
                // console.log('pong')
                return;
            }

            // 若数据结构未加密
            if (resp.data.indexOf('{') > -1) {
                data = JSON.parse(resp.data);
            } else {
                data = self.parseDownlinkMessage(resp.data);
            }

            // console.log(data)
            if (data.type == 1) {
                // 未出席成功
                if (data.extenseBody.rResult != 0) {
                    self.emit('attendFail', data.extenseBody.rResult);
                }
                return;
            }
            /**
             * 回执消息处理
             **/
            if (data.needAck) {
                var uniqueId = data.msgId + '-' + data.roomId;
                if (self.needAckMsg[uniqueId]) {
                    return;
                } else {
                    self.needAckMsg[uniqueId] = uniqueId;
                    self.sendAckMsg(data);
                }
            }
            self.emit('message', data);
        };
        this.socket.onclose = function (status) {
            // 1000
            self.emit('close', status);
            self.destroyPingTimer();
        };
    },
    sendAckMsg: function sendAckMsg(msg) {
        var result = {
            msgId: msg.msgId,
            sId: msg.sId,
            roomId: parseInt(msg.roomId),
            type: msg.type,
            mType: msg.mType
        };
        this.send(result);
    },
    // 重连
    reconnect: function reconnect() {
        console.info('--reconnect--');
        // console.log('socket reconnect');
        this.socket = new WebSocket(this.url);
        this.bindEventToSocket();
    },

    reinit: function reinit() {
        this.getIntoMsg();
    },

    // 发送报文到服务器
    send: function send(msg) {
        // ping request
        if (msg == 3) {
            this.socket.send(msg);
            return;
        }
        if (!this.socket) {
            console.log('pls create the WebSocket first!');
            return;
        }

        if (!msg || (typeof msg === 'undefined' ? 'undefined' : _typeof(msg)) != 'object') {
            console.log('Parameter format error, pls check document again!');
            return;
        }

        var result = this.parseUplinkMessage(msg);

        try {
            this.socket.send(result);
        } catch (e) {
            console.error(e.message);
        }

        switch ($.debugForDeveloperMode) {
            case 1:
                this.close();
                $.debugForDeveloperMode = 0;
                break;
            case 2:
                this.reinit();
                $.debugForDeveloperMode = 0;
                break;
            case 3:
                this.reconnect();
                break;
        }
    },

    // 建立连接后, 登录用户需发送出席报文, 否则无法发送消息
    sendAttend: function sendAttend() {

        this.send({
            type: 1,
            mType: 0,
            roomId: this.roomId,
            sId: this.sid,
            liveType: this.liveType,
            sendTime: +new Date(),
            appVersion: '3.0.0',
            appBuildId: '',
            countryCode: UP.Global.getUserCountryCode(),
            extenseBody: {
                userInfo: this.userInfo,
                userToken: this.userToken,
                termType: 3, // PC手机网页"WEB"
                isShowHighText: UP.Global.getHighLevelText() == 1 ? true : false
            }
        });
    },

    // 上行报文格式化
    parseUplinkMessage: function parseUplinkMessage(msg) {
        var extenseBody = msg.extenseBody;
        extenseBody = _jsBase2.default.encode(_jsBase2.default.encode(JSON.stringify(extenseBody)));
        msg.extenseBody = extenseBody;

        return _jsBase2.default.encode(JSON.stringify(msg));
    },

    // 下行报文格式化
    parseDownlinkMessage: function parseDownlinkMessage(msg) {
        if (msg == 4) {
            return msg;
        }
        return JSON.parse(_jsBase2.default.decode(msg));
    },

    // 创建ping定时器
    createPingTimer: function createPingTimer() {
        var self = this;
        this._pingTimer && clearInterval(this._pingTimer);
        self._pingTimer = setInterval(function () {
            // console.log('ping');
            self.socket.send(3);
        }, this.pingTimeout * 1000);
    },

    // 手动断开
    close: function close() {
        this.closeByManual = true;

        if (this.socket) {
            this.socket.close();
            console.info('---close--');
        }
    },


    // 销毁ping定制器
    destroyPingTimer: function destroyPingTimer() {
        this._pingTimer && clearInterval(this._pingTimer);
    }

}, _events2.default);

exports.default = WebChat;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(295);


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(296);

__webpack_require__(297);

__webpack_require__(298);

__webpack_require__(299);

__webpack_require__(300);

__webpack_require__(1);

__webpack_require__(301);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _reactRouter = __webpack_require__(23);

var _history = __webpack_require__(398);

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _cFastclick = __webpack_require__(400);

var _cFastclick2 = _interopRequireDefault(_cFastclick);

var _geturl = __webpack_require__(401);

var _geturl2 = _interopRequireDefault(_geturl);

var _sensitiveWords = __webpack_require__(75);

var _sensitiveWords2 = _interopRequireDefault(_sensitiveWords);

__webpack_require__(137);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _hoc = __webpack_require__(403);

var _hoc2 = _interopRequireDefault(_hoc);

var _routes = __webpack_require__(479);

var _routes2 = _interopRequireDefault(_routes);

var _dataAnalytics = __webpack_require__(669);

var _dataAnalytics2 = _interopRequireDefault(_dataAnalytics);

__webpack_require__(670);

var _GDN = __webpack_require__(671);

var _GDN2 = _interopRequireDefault(_GDN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // css文件中不要使用import


window.React = _react2.default;
// import './component/vas/index';

FastClick.attach(document.body);

/**
 * 开发环境用hashHistory，线上环境用browserHistory，window.hashHistory名称仅仅为了不修改其他模块的代码
 */
window.dev = _cUrl2.default.query('dev') == 1;
window.hashHistory = window.dev == 1 ? _reactRouter.hashHistory : (0, _reactRouter.useRouterHistory)(_history.createHistory)({
    basename: location.pathname.indexOf('/uplive-pc/') > -1 ? location.pathname.substr(0, location.pathname.indexOf('/uplive-pc/') + '/uplive-pc/'.length) : '/'
});
window.hashHistory.oldPush = window.hashHistory.push;
window.hashHistory.push = function (path) {
    if (window.dev) {
        window.hashHistory.oldPush(path);
    } else {
        var params = {};

        if (typeof path == 'string') {
            params = {
                pathname: path,
                search: location.search
            };
        } else {
            path.search = path.search || location.search;
            params = path;
        }

        window.hashHistory.oldPush(params);
    }
};
window.hashHistory.listen(function (location) {
    //console.log(location) // /home
});

if (UP.Global.version !== 'CN') {
    _GDN2.default.init();
}

var cache = new _cCache2.default({
    prefix: 'pcuplive'
});

UP.Global.openInNewTab = function (path) {
    if (path.match(/^(https?\:\/\/)/)) {
        if (_cUrl2.default.query('singleWindow')) {
            location.href = path;
        } else {
            window.open(path);
            window.focus();
        }
    } else {
        if (_cUrl2.default.query('singleWindow')) {
            window.hashHistory.push(path);
        } else {
            var url = location.protocol + '//' + location.hostname + window.hashHistory.createHref(path) + location.search + location.hash;

            window.open(url);
            window.focus();
        }
    }
};

UP.Global.DA = _dataAnalytics2.default;

function createElement(Component, props) {
    if (props.location.action == 'POP') {
        // 保留当前路由path
        UP.Global.currentPathName = props.location.pathname;
    }

    // 确保传入了所有的 props！
    return _react2.default.createElement(Component, props);
}

var App = function (_Component) {
    _inherits(App, _Component);

    function App(props) {
        _classCallCheck(this, App);

        var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

        document.title = _lang2.default.template('页面标题');
        return _this;
    }

    _createClass(App, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _sensitiveWords2.default.getDataFromServer();
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_reactRouter.Router, { history: window.hashHistory, routes: _routes2.default, createElement: createElement });
        }
    }]);

    return App;
}(_react.Component);

App.defaultProps = {};


var paidfrom = _cUrl2.default.query('paidfrom');

if (paidfrom) {
    // 支持成功之后对URL参数处理。备注：充值成功之后会在URL后追加参数
    var url = void 0;

    cache.removeCache('_u_paid');
    cache.removeCache('_u_paidret');
    cache.removeCache('_u_paid_channel');

    cache.setCache('_u_paid', _cUrl2.default.query('productId'));
    cache.setCache('_u_paid_channel', _cUrl2.default.query('channel'));

    var resultCode = _cUrl2.default.query('result_code');

    if (resultCode) {
        var isSuccess = resultCode == 'SUCCESS' ? 1 : 0;
        cache.setCache('_u_paidret', [_cUrl2.default.query('productId'), isSuccess].join('/'));
    }

    if (window.dev) {
        if (location.href.indexOf('?paidfrom=') > -1) {
            url = location.href.split('?paidfrom=')[0];
        } else {
            url = location.href.split('&paidfrom=')[0];
        }
        location.replace(url + '#' + decodeURIComponent(paidfrom));
    } else {
        url = (0, _geturl2.default)(location.href);
        location.replace(url);
    }
} else {

    var gameEnter = function gameEnter() {
        var NewApp = (0, _hoc2.default)(App);
        (0, _reactDom.render)(_react2.default.createElement(NewApp, null), $("#wrap")[0]);
    };

    // 无论是否使用游客，都产生一个smd（数美的deviceId）
    // 并且存储到本地
    var cacheDeviceId = cache.getCache('smDeviceId');

    if (!cacheDeviceId) {

        // 数美JS已经加载完成
        if (typeof SMSdk !== 'undefined') {
            window.smDeviceId = SMSdk.getDeviceId();
            cache.setCache('smDeviceId', window.smDeviceId);
            gameEnter();
        } else {
            // 否则监听事件，等待sdk加载完成
            $.channel.on('smsdkLoaded', function () {
                window.smDeviceId = SMSdk.getDeviceId();
                cache.setCache('smDeviceId', smDeviceId);
                gameEnter();
            });
        }
    } else {
        window.smDeviceId = cacheDeviceId;
        gameEnter();
    }
}

/***/ }),
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, exports) {

if (typeof Object.assign != 'function') {
    Object.assign = function (target) {
        'use strict';

        if (target == null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        target = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source != null) {
                for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }
        }
        return target;
    };
}

if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value: function value(searchElement, fromIndex) {

            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If len is 0, return false.
            if (len === 0) {
                return false;
            }

            // 4. Let n be ? ToInteger(fromIndex).
            //    (If fromIndex is undefined, this step produces the value 0.)
            var n = fromIndex | 0;

            // 5. If n ≥ 0, then
            //  a. Let k be n.
            // 6. Else n < 0,
            //  a. Let k be len + n.
            //  b. If k < 0, let k be 0.
            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            // 7. Repeat, while k < len
            while (k < len) {
                // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                // b. If SameValueZero(searchElement, elementK) is true, return true.
                // c. Increase k by 1.
                // NOTE: === provides the correct "SameValueZero" comparison needed here.
                if (o[k] === searchElement) {
                    return true;
                }
                k++;
            }

            // 8. Return false
            return false;
        }
    });
}

if (!Array.from) {
    Array.from = function () {
        var toStr = Object.prototype.toString;
        var isCallable = function isCallable(fn) {
            return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
        };
        var toInteger = function toInteger(value) {
            var number = Number(value);
            if (isNaN(number)) {
                return 0;
            }
            if (number === 0 || !isFinite(number)) {
                return number;
            }
            return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
        };
        var maxSafeInteger = Math.pow(2, 53) - 1;
        var toLength = function toLength(value) {
            var len = toInteger(value);
            return Math.min(Math.max(len, 0), maxSafeInteger);
        };

        // The length property of the from method is 1.
        return function from(arrayLike /*, mapFn, thisArg */) {
            // 1. Let C be the this value.
            var C = this;

            // 2. Let items be ToObject(arrayLike).
            var items = Object(arrayLike);

            // 3. ReturnIfAbrupt(items).
            if (arrayLike == null) {
                throw new TypeError('Array.from requires an array-like object - not null or undefined');
            }

            // 4. If mapfn is undefined, then let mapping be false.
            var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
            var T;
            if (typeof mapFn !== 'undefined') {
                // 5. else
                // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
                if (!isCallable(mapFn)) {
                    throw new TypeError('Array.from: when provided, the second argument must be a function');
                }

                // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
                if (arguments.length > 2) {
                    T = arguments[2];
                }
            }

            // 10. Let lenValue be Get(items, "length").
            // 11. Let len be ToLength(lenValue).
            var len = toLength(items.length);

            // 13. If IsConstructor(C) is true, then
            // 13. a. Let A be the result of calling the [[Construct]] internal method 
            // of C with an argument list containing the single item len.
            // 14. a. Else, Let A be ArrayCreate(len).
            var A = isCallable(C) ? Object(new C(len)) : new Array(len);

            // 16. Let k be 0.
            var k = 0;
            // 17. Repeat, while k < len… (also steps a - h)
            var kValue;
            while (k < len) {
                kValue = items[k];
                if (mapFn) {
                    A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                } else {
                    A[k] = kValue;
                }
                k += 1;
            }
            // 18. Let putStatus be Put(A, "length", len, true).
            A.length = len;
            // 20. Return A.
            return A;
        };
    }();
}

if (!Array.isArray) {
    Array.isArray = function (arg) {
        return Object.prototype.toString.call(arg) === '[object Array]';
    };
}

if (!String.prototype.includes) {
    String.prototype.includes = function (search, start) {
        'use strict';

        if (typeof start !== 'number') {
            start = 0;
        }

        if (start + search.length > this.length) {
            return false;
        } else {
            return this.indexOf(search, start) !== -1;
        }
    };
}

/***/ }),
/* 298 */
/***/ (function(module, exports) {

//////////////////////////////////////////////////////////////////////////////
// the status constants
var PENDING = 0,
    FULFILLED = 1,
    REJECTED = 2;

//////////////////////////////////////////////////////////////////////////////
// Some utils
function isFunction(obj) {
    return typeof obj === "function";
}

function isThenable(obj) {
    return obj && isFunction(obj.then);
}

function checkArray(obj) {
    if (!Array.isArray(obj)) {
        throw new TypeError(obj + " is not array");
    }
}

//////////////////////////////////////////////////////////////////////////////
function resolve(value) {
    if (this._status !== PENDING) {
        return;
    }

    this._v = value;
    this._status = FULFILLED;

    var fn;
    while (fn = this._resolves.shift()) {
        fn.call(this, value);
    }
}

function reject(reason) {
    if (this._status !== PENDING) {
        return;
    }

    this._v = reason;
    this._status = REJECTED;

    var fn;
    while (fn = this._rejects.shift()) {
        fn.call(this, reason);
    }
}

//////////////////////////////////////////////////////////////////////////////
// The constructor function
function Promise(fn) {
    if (!isFunction(fn)) {
        throw new TypeError("Promise argument error:" + fn.toString());
    }

    this._status = PENDING;
    this._resolves = [];
    this._rejects = [];
    this._v = undefined;

    fn(resolve.bind(this), reject.bind(this));
}

//////////////////////////////////////////////////////////////////////////////
// The most important function for Promise is `then`

// `resolve` have different rules against `reject`:
// `resolve` will always trigger the `resolve` of next Promise, while
// `reject` may trigger the `reject` or `resolve` of next Promise.

function resolveWrapper(nRes, nRej, pResFn) {
    return function (value) {
        if (!isFunction(pResFn)) {
            return nRes(value);
        }

        try {
            var ret = pResFn(value);
            if (isThenable(ret)) {
                ret.then(nRes, nRej);
            } else {
                nRes(ret);
            }
        } catch (e) {
            nRej(e);
        }
    };
}

function rejectWrapper(nRes, nRej, pRejFn) {
    return function (reason) {
        if (!isFunction(pRejFn)) {
            return nRej(reason);
        }

        try {
            var ret = pRejFn(reason);
            if (isThenable(ret)) {
                ret.then(nRes, nRej);
            } else {
                nRes(ret);
            }
        } catch (e) {
            nRej(e);
        }
    };
}

function thenHandler(nRes, nRej, pResFn, pRejFn, pP) {
    var rsFn = resolveWrapper(nRes, nRej, pResFn);
    var rjFn = rejectWrapper(nRes, nRej, pRejFn);

    switch (pP._status) {
        case PENDING:
            pP._resolves.push(rsFn);
            pP._rejects.push(rjFn);
            break;
        case FULFILLED:
            rsFn(pP._v);
            break;
        case REJECTED:
            rjFn(pP._v);
            break;
        default:
            throw new Error("invalid status:" + pP._status);
    }
}

Promise.prototype.then = function (resFn, rejFn) {
    var pP = this;
    return new Promise(function (res, rej) {
        return thenHandler(res, rej, resFn, rejFn, pP);
    });
};

//////////////////////////////////////////////////////////////////////////////
// Some utils
Promise.prototype.catch = function (reason) {
    return this.then(null, reason);
};
Promise.resolve = function (value) {
    return new Promise(function (res, _) {
        return res(value);
    });
};
Promise.reject = function (reason) {
    return new Promise(function (_, rej) {
        return rej(reason);
    });
};

//////////////////////////////////////////////////////////////////////////////
// Promise.all
function handleAll(promises, resolve, reject) {
    // all promises share the same `count` and `result`.
    var count = promises.length;
    var result = [];

    function handle(i) {
        return function (value) {
            result[i] = value;
            if (--count === 0) {
                resolve(result);
            }
        };
    }
    promises.forEach(function (p, i) {
        return p.then(handle(i), reject);
    });
}

Promise.all = function (promises) {
    checkArray(promises);
    return new Promise(function (res, rej) {
        return handleAll(promises, res, rej);
    });
};

//////////////////////////////////////////////////////////////////////////////
// Promise.race
Promise.race = function (promises) {
    checkArray(promises);
    return new Promise(function (res, rej) {
        return promises.forEach(function (p) {
            return p.then(res, rej);
        });
    });
};

if (typeof window.Promise != 'function') {
    window.Promise = Promise;
}

//////////////////////////////////////////////////////////////////////////////
// For nodejs
module.exports = Promise;

/***/ }),
/* 299 */
/***/ (function(module, exports) {

//激活html标签
var html5_tag = 'section,article,aside,header,footer,nav,dialog,figure',
    arr = html5_tag.split(',');

for (var i = arr.length; i--;) {
    document.createElement(arr[i]);
}

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var cache = new _cCache2.default({
    prefix: 'pcuplive'
});

var UP = window['UP'] || (window['UP'] = {});

var isIE76 = !'0'[0]; // 根据：IE67对字符串进行取值需要使用charAt()方法，不能直接通过数组方式的坐标访问
var isIE6 = isIE76 && !window.XMLHttpRequest;
var isIE = !!window.ActiveXObject;
var IS_INIT = false; // 是否已经初始化
var PY_HOST = 'https://web.upliveapps.com';

var SYSTEM_LANGUAGE = function () {
    var systemLanguage = navigator.language || navigator.browserLanguage;

    var _systemLanguage = systemLanguage.toLowerCase();

    if (_systemLanguage == 'ar') {
        systemLanguage = 'ar-EG';
    } else if (_systemLanguage == 'vi') {
        systemLanguage = 'vi-VN';
    } else if (_systemLanguage == 'en') {
        systemLanguage = 'en-US';
    } else if (_systemLanguage == 'ja') {
        systemLanguage = 'ja-JP';
    } else if (_systemLanguage == 'zh') {
        systemLanguage = 'zh-CN';
    }

    var arr = systemLanguage.split('-');

    if (arr.length > 1) {
        systemLanguage = arr[0] + '-' + arr[1].toUpperCase();
    } else {
        systemLanguage = 'en-US';
    }

    return systemLanguage;
}();

// css3动画性能解决方案
(function () {
    var vendors = ['webkit', 'moz'];

    for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
        var vp = vendors[i];
        window.requestAnimationFrame = window[vp + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vp + 'CancelAnimationFrame'] || window[vp + 'CancelRequestAnimationFrame'];
    }
    if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) // iOS6 is buggy
    || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
        var lastTime = 0;
        window.requestAnimationFrame = function (callback) {
            var now = Date.now();
            var nextTime = Math.max(lastTime + 16, now);
            return setTimeout(function () {
                callback(lastTime = nextTime);
            }, nextTime - now);
        };
        window.cancelAnimationFrame = clearTimeout;
    }
})();

$.getScript = function (url, options) {

    var script = document.createElement('script'),
        isFunction = $.isFunction(options),
        timer;

    // 清除定时器
    function clearTimer() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }

    // success
    if (isFunction || options && options.success) {
        script.onload = function () {
            clearTimer();
            isFunction ? options() : options.success.call(options.context);
        };
    }

    if (!isFunction && options) {
        // failure
        if (options.error) {
            script.onerror = function () {
                clearTimer();
                options.error.call(options.context);
            };
        }
        // timeout
        if (options.timeout) {
            timer = setTimeout(function () {
                timer = null;
                if (options.error) {
                    options.error.call(options.context);
                }
            }, options.timeout);
        }
    }

    script.setAttribute('data-path', url);

    script.src = url;

    return document.body.appendChild(script);
};

var domain = document.domain;
var IS_CN = domain == 'www.upliveapp.com' || domain == 'upliveapp.com' || location.href.indexOf('__cnenv__') !== -1; // 国内版
var IS_MSL = domain == 'www.uplive.club' || domain == 'uplive.club' || location.href.indexOf('__arenv__') !== -1; // 中东版
var IS_External = domain == 'up.live' || domain == 'www.up.live';

var isSupportFlash = function () {
    var hasFlash = 0;
    if (document.all) {
        var swf = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
        if (swf) {
            hasFlash = 1;
        }
    } else if (navigator.plugins && navigator.plugins.length > 0) {
        var swf = navigator.plugins["Shockwave Flash"];
        if (swf) {
            hasFlash = 1;
        }
    }
    return !!hasFlash;
}();

var SUPPORT_LANGUAGE = ['zh-CN', 'zh-TW', 'zh-HK', 'en-US', 'ja-JP', 'vi-VN', 'ar-EG', 'ko-KR', 'ms-MY', 'th-TH', 'fr-FR', 'pt-PT', 'ru-RU', 'id-ID', 'tr-TR', 'es-ES'];

// 用于处理默认网站语言码 => zh-TW
var tws = ['zh-SG', 'zh-MO', 'zh-TW'];
// 用于处理默认网站语言码 => ar-EG
var ars = ['ar-AE', 'ar-BH', 'ar-DZ', 'ar-EG', 'ar-IQ', 'ar-JO', 'ar-KW', 'ar-LB', 'ar-LY', 'ar-MA', 'ar-OM', 'ar-QA', 'ar-SA', 'ar-SY', 'ar-TN', 'ar-YE'];
// 中东地区国家码
var middelEastCountryCodes = ['EG', 'SA', 'MA', 'AE', 'AF', 'BH', 'DJ', 'DZ', 'IQ', 'JO', 'KM', 'KW', 'LB', 'LY', 'MR', 'OM', 'PK', 'PS', 'QA', 'SD', 'SO', 'SS', 'SSD', 'SY', 'TN', 'UG', 'YE'];
// 国内地区国家码
var chinaCountryCodes = ['CN'];
/**
 * 全局API
 */
UP.Global = {
    version: 'CN', //CN：国内，AR：中东；All：其他

    // 语言列表
    languageList: SUPPORT_LANGUAGE,

    middelEastCountryCodes: middelEastCountryCodes,

    // 系统语言
    systemLanguage: SYSTEM_LANGUAGE,
    // 网站语言
    siteLanguage: '',

    isEdge: /Edge/i.test(navigator.userAgent), // 12+

    isIE: /(MSIE|Trident|Edge)/.test(navigator.userAgent),

    isFireFox: /(Firefox)/.test(navigator.userAgent),

    isSafari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent),

    isChrome: /Chrome/.test(navigator.userAgent),

    videoInfo: null,
    isLoginPop: false, /*在global中储存登录弹框显示隐藏状态**/

    init: function init() {
        // 防止重复初始化
        if (IS_INIT) return;

        IS_INIT = true;

        this.chooseLanguage();

        this.adsCountry = this.query('adscountry');
        this.initVersion();

        var clientType = this.query('clientType') || '';

        this.marketChannel = clientType.replace('pcuplive', '');
        this.channel = ('pc' + this.marketChannel).substring(0, 20);
    },
    initVersion: function initVersion() {
        var country = this.adsCountry || '';

        if (IS_CN || country == 'CN') {
            this.version = 'CN';
        } else if (IS_MSL) {
            this.version = 'AR';
        } else {
            if (middelEastCountryCodes.indexOf(country) > -1) {
                this.version = 'AR';
            } else {
                this.version = 'All';
            }
        }
    },
    initLanguage: function initLanguage() {
        // let lang = Cookie.getCookie('_u_language');
        var lang = cache.getCache('_u_language');

        if (!lang) {
            var systemLanguage = this.systemLanguage;

            if (SUPPORT_LANGUAGE.indexOf(systemLanguage) > -1) {
                lang = systemLanguage;
            } else if (tws.indexOf(systemLanguage) > -1) {
                lang = 'zh-TW';
            } else if (ars.indexOf(systemLanguage) > -1) {
                lang = 'ar-EG';
            } else {
                lang = 'en-US';
            }

            if (IS_MSL) {
                lang = 'ar-EG';
            }
        }

        return lang;
    },
    getDefaultUA: function getDefaultUA() {
        var UserAgent = 'PC/' + this.channel + ' version/8.8.8';

        if (window.smDeviceId) {
            UserAgent += ' smd/' + window.smDeviceId;
        }

        return UserAgent;
    },
    chooseLanguage: function chooseLanguage(lang) {
        if (!lang) {
            lang = this.initLanguage();
        }

        $('html').attr('lang', lang);
        $('body').attr('class', '');
        $('body').addClass(lang);

        cache.setCache('_u_language', lang);
        // Cookie.setCookie('_u_language', lang);
        this.siteLanguage = lang;
    },
    isMobile: function isMobile() {
        var ua = navigator.userAgent;
        return !!ua.match(/AppleWebKit.*Mobile.*/) || "ontouchstart" in document.documentElement;
    },
    writeUserInfo: function writeUserInfo(user) {

        this.cacheUserToken(user.userToken);
        this.cacheUserId(user.uid);

        if (cache.getCache('isRegisterRealUser')) {
            user.userToken = cache.getCache('_u_usertoken');
            cache.setCache('user', {
                userToken: user.userToken,
                uid: user.uid,
                avatar: user.avatar,
                gender: user.gender,
                grade: user.grade,
                username: user.username,
                upliveCode: user.upliveCode,
                countryCode: user.countryCode
            }, 8 * 3600 * 1000);
        }

        this.loginUserProfile = user;
    },
    clearUserInfo: function clearUserInfo() {
        cache.removeCache('_u_uid');
        cache.removeCache('_u_usertoken');
        // UP.Cookie.delCookie('_u_uid');
        // UP.Cookie.delCookie('_u_usertoken');
        cache.removeCache('isRegisterRealUser');
        cache.removeCache('user');
        this.loginUserProfile = null;
    },
    getHotCountryCode: function getHotCountryCode() {
        var countryCode = void 0;

        switch (this.version) {
            case 'CN':
                countryCode = 'CN';
                break;
            case 'AR':
                countryCode = 'MA';
                break;
            default:
                countryCode = this.getUser().countryCode;
        }

        if (this.adsCountry && this.adsCountry !== countryCode) {
            // URL上的国家码优先
            countryCode = this.adsCountry;
        }

        return countryCode;
    },

    /**
     *  获取当前用户信息
     */
    getUser: function getUser() {
        return this.loginUserProfile || {};
    },
    updateUserInfo: function updateUserInfo(key, value) {
        this.loginUserProfile[key] = value;
    },
    updateDiamondBanlance: function updateDiamondBanlance(diamond, bill) {
        if (diamond) {
            this.loginUserProfile.balance.diamond = parseInt(diamond, 10);
        }

        if (bill) {
            this.loginUserProfile.balance.bill = parseInt(bill, 10);
        }
    },
    getUserId: function getUserId() {
        // if (this.isLogin()) {
        //     return this.getUser().uid;
        // } else {
        return this.getUserIdFromCookie();
        // }
    },
    isVip: function isVip() {
        var user = this.getUser() || {};
        var vipLabel = void 0;

        $.each(user.userLabels || [], function (index, item) {
            if (item.label.indexOf('VIP') > -1) {
                vipLabel = item;
                return false;
            }
        });

        return vipLabel;
    },
    getUserToken: function getUserToken() {
        var usertoken = this.getUserTokemFromCookie();

        if (!usertoken) {
            this.clearUserInfo();
        }
        return usertoken;
    },
    cacheUserToken: function cacheUserToken(userToken) {
        // userToken && Cookie.setCookie('_u_usertoken', userToken);
        userToken && cache.setCache('_u_usertoken', userToken, 8 * 3600 * 1000); // 有效期8小时
    },
    cacheUserId: function cacheUserId(uid) {
        // uid && Cookie.setCookie('_u_uid', uid);
        uid && cache.setCache('_u_uid', uid);
    },
    getUserIdFromCookie: function getUserIdFromCookie() {
        // return Cookie.getCookie('_u_uid') || '';
        return cache.getCache('_u_uid') || '';
    },
    getHighLevelText: function getHighLevelText() {
        var user = this.getUser();
        var setting = JSON.parse(user.setting) || {};

        return setting.highLevelText;
    },
    getUserTokemFromCookie: function getUserTokemFromCookie() {
        // return Cookie.getCookie('_u_usertoken') || '';
        return cache.getCache('_u_usertoken') || '';
    },
    getUserCountryCode: function getUserCountryCode() {
        var user = this.getUser();

        if (user.uid) {
            return user.countryCode;
        } else {
            return '';
        }
    },

    /**
     * 判断用户是否登录
     */
    isLogin: function isLogin() {
        return !!this.getUser().uid;
    },
    isRegisterRealUser: function isRegisterRealUser() {
        return cache.getCache('isRegisterRealUser');
    },
    query: function query(name, scope) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
            scope = scope || 'search',
            r = location[scope].substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    },

    /**
     * 获取平台信息
     */
    getPlatform: function getPlatform() {
        var _ref = [navigator.userAgent, 'other'],
            ua = _ref[0],
            pl = _ref[1];


        if (ua.match(/uplive/i) || this.query('pl', 'hash') == 'uplive') {
            pl = 'uplive';
        } else if (ua.match(/micromessenger/i)) {
            pl = 'wechat';
        } else if (ua.match(/qq/i)) {
            pl = 'qq';
        } else if (ua.match(/weibo/i)) {
            pl = 'weibo';
        } else if (ua.match(/renren/i)) {
            pl = 'renren';
        } else if (ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1) {
            pl = 'fb';
        } else if (ua.match(/[Tt]witter/i)) {
            pl = 'twitter';
        }

        return pl;
    },

    /**
     * 获得当前系统类型
     */
    getSystem: function getSystem() {
        var ua = navigator.userAgent;
        var ret = /(iPhone|iPad|iPod|iOS)/i.test(ua) ? 'ios' : /[aA]ndroid/i.test(ua) ? 'android' : 'pc';

        return ret;
    },

    /**
     * 获取python 服务器域名
     */
    getPyHost: function getPyHost() {
        return PY_HOST;
    },
    getH5Host: function getH5Host() {
        var url = void 0;

        if (this.version == 'CN') {
            url = '//h5.upliveapp.com';
        } else {
            url = '//m.upliveapps.com';
        }

        return url;
    },
    getH5ActHost: function getH5ActHost() {
        var url = void 0;

        if (this.version == 'CN') {
            url = '//h5act.upliveapp.com';
        } else {
            url = '//mact.upliveapps.com';
        }

        return url;
    },
    ie10AndOlder: function ie10AndOlder() {
        if (document.all) {
            return true;
        } else {
            return false;
        }
    },

    /**横屏礼物特效设置*/
    setLandscapePingbiAnimType: function setLandscapePingbiAnimType(val) {

        cache.setItem('landscape_pinbi_anim', val, 24 * 60 * 60);
        this.landscapePingBiAnimType = val;
        $.channel.emit('updatePingBiAnim');
    },
    getLandscapePingbiAnimType: function getLandscapePingbiAnimType() {
        if (!this.landscapePingBiAnimType) {
            this.landscapePingBiAnimType = cache.getItem('landscape_pinbi_anim');
        }
        if (!this.landscapePingBiAnimType) {
            this.landscapePingBiAnimType = {
                broadcast: false,
                smallAnim: false,
                intoAnim: false,
                allAnim: false
            };
        }
        return this.landscapePingBiAnimType;
    }
};

UP.PrepaireForAsync = function () {
    var replaceMessage = Math.random() + '';
    var WatingContent = '\n        <html>\n          <head>\n                <meta name="viewport" content="width=device-width, height=device-height, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=1"/>\n          </head>\n          <style type="text/css">\n            html, body{\n                background-color: rgba(255,255,255,0.5);\n            }\n            .mini-loading {\n                text-align: center;\n                font-size: 20px;\n                padding: 100px 0;\n            }\n\n            .mini-loading i {\n                display: inline-block;\n                width: 32px;\n                height: 32px;\n                font-style: normal;\n                background: url(//g.cdn.pengpengla.com/oauthgame/html5/20170614/93eb40b5793f26377ff2bc2eff3c5f03.gif) no-repeat;\n                vertical-align: middle;\n                margin: 0 5px;\n            }\n\n            .mini-loading.loading-vertical i {\n                display: block;\n                margin: 10px auto;\n            }\n\n            .mini-loading .txt {\n                display: inline-block;\n                padding: 6px 0 0 5px;\n            }\n          </style>\n          <body>\n            <div class=\'root\'>\n              <div>\n                <div class="mini-loading">\n                    <i></i>\n                    <span class="loading-tip">' + replaceMessage + '</span>\n                </div>\n              </div>\n            </div>\n          </body>\n        </html>\n        ';

    var WindowOpen = window.open;

    return function () {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref2$width = _ref2.width,
            width = _ref2$width === undefined ? 780 : _ref2$width,
            _ref2$height = _ref2.height,
            height = _ref2$height === undefined ? 500 : _ref2$height,
            _ref2$message = _ref2.message,
            message = _ref2$message === undefined ? 'Please wait a sec...' : _ref2$message;

        var _window = window,
            outerWidth = _window.outerWidth,
            outerHeight = _window.outerHeight,
            screenLeft = _window.screenLeft,
            screenTop = _window.screenTop;

        var left = outerWidth / 2 - width / 2 + (screenLeft || screenX);
        var top = outerHeight / 2 - height / 2 + (screenTop || screenY);

        var newWindow = WindowOpen.bind(window)('', '', 'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left + ',scrollbars=yes,resizable=yes');

        newWindow.document.write(WatingContent.replace(replaceMessage, message));

        window.open = function (url) {
            newWindow.location.replace(url);
            window.open = WindowOpen;
            return newWindow;
        };
        return newWindow;
    };
}();

UP.WaitForRecieveMsg = function () {
    return function (openerWindow, tag, fromtype) {
        var __privateOnMessage = window.__privateOnMessage;
        var defer = $.Deferred();

        var removeListener = function removeListener() {
            openerWindow.close();
            $(window).off('message', onMessage);
            window.__privateOnMessage = __privateOnMessage;
            window.clearInterval(interval);
        };

        var onMessage = function onMessage(event) {
            // console.log('onMessage');
            try {
                var _ref3 = JSON.parse(event.data || '{}') || {},
                    data = _ref3.data,
                    type = _ref3.type,
                    error = _ref3.error;
                // console.log(data, type, error);


                if (type == tag) {
                    if (error) return defer.reject(error);
                    defer.resolve(data);
                    removeListener();
                }
            } catch (error) {
                console.error({ error: error, data: event.data });
            }
        };

        window.__privateOnMessage = function (e) {
            setTimeout(__privateOnMessage, 0, e);
            onMessage(e);
        };

        var interval = window.setInterval(function () {
            if (!openerWindow || openerWindow.closed) {
                removeListener();
                defer.reject(null);
            }
        }, 500);

        // 超时处理
        if (fromtype == 'fb') {
            setTimeout(function () {
                if (openerWindow && !openerWindow.closed) {
                    removeListener();
                    defer.reject(null);
                }
            }, 120 * 1000); // 60秒
        }

        $(window).on('message', onMessage, false);

        return defer;
    };
}();

/*--------工具---------*/

var Cookie = {
    /**
     * 判断浏览器是否能使用cookie
     * @method isCookieEnable
     * @public
     * @static
     * @return {Boolean} ret
     */
    isCookieEnable: function isCookieEnable() {
        if (!window.navigator.cookieEnabled) {
            return false;
        }
        var key = '_test_cookie_';

        this.setCookie(key, '1');

        var v = this.getCookie(key);

        if (v === '1') {
            this.delCookie(key);
            return true;
        }
        return false;
    },

    getCookieVal: function getCookieVal(offset) {
        var endstr = document.cookie.indexOf(";", offset);
        if (endstr === -1) {
            endstr = document.cookie.length;
        }
        return window.unescape(decodeURIComponent(document.cookie.substring(offset, endstr)));
    },
    /**
     * 获取 Cookie
     */
    getCookie: function getCookie(name) {
        var arg = name + "=",
            alen = arg.length,
            clen = document.cookie.length,
            i = 0,
            j;

        while (i < clen) {
            j = i + alen;
            if (document.cookie.substring(i, j) === arg) {
                return this.getCookieVal(j);
            }
            i = document.cookie.indexOf(" ", i) + 1;
            if (i === 0) {
                break;
            }
        }

        return '';
    },
    /**
     * 设置cookie
     * @param name
     * @param val
     * @param expires
     */
    setCookie: function setCookie(key, value, expires) {
        var host = window.location.host,
            expires = arguments.length > 2 ? arguments[2] : null,
            expdate = new Date();

        if (expires == null) {
            document.cookie = key + "=" + window.escape(value) + ";path=/;domain=" + host;
        } else {
            expdate.setTime(expdate.getTime() + expires * 1000);
            document.cookie = key + "=" + window.escape(value) + ";path=/;domain=" + host + ";expires=" + expdate.toGMTString();
        }
    },

    /**
     * 删除cookie
     * @method delCookie
     * @public
     * @static
     * @param {String} name cookie名
     */
    delCookie: function delCookie(name) {
        var host = window.location.host,
            exp = new Date();

        exp.setTime(exp.getTime() - 86400 * 1000);
        document.cookie = name + '=;path=/;domain=' + host + ';expires=' + exp.toGMTString();
    }
};

window.emojione.textToEmoji = function (string) {
    var emojiTemplate = '<img alt="{alt}" class="emojione" src="{img}" />';

    if (UP.Global.isIE) {
        return window.emojione.shortnameToImage(window.emojione.toShort(string));
    }

    var jsEscapeMap = emojione.jsEscapeMap;

    var arrayString = [].concat(_toConsumableArray(string));
    var list = [];
    var length = arrayString.length;
    var tmpString = '';

    for (var i = 0; i < length; i++) {
        var s = arrayString[i];
        var c = jsEscapeMap[s];

        if (c) {
            tmpString && list.push(tmpString) && (tmpString = "");
            var tpl = emojiTemplate.replace('{alt}', s).replace('{img}', 'https://cdn.jsdelivr.net/emojione/assets/3.1/png/32/' + c + '.png"');

            list.push(tpl);
        } else {
            tmpString += s;
        }
    }

    tmpString && list.push(tmpString) && (tmpString = "");

    return list.join('');
};

UP.isSupportFlash = isSupportFlash;
UP.Cookie = Cookie;
UP.Global.init();

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var _events = __webpack_require__(74);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SM = Object.assign({
    init: function init() {
        var hostname = location.hostname;
        var apiHost = 'fp.fengkongcloud.com';
        if (hostname == 'm.upliveapps.com') {
            apiHost = 'fp-xjp.fengkongcloud.com';
        }
        (function () {
            window._smConf = {
                organization: '3kHDvmQMHMyhMkWHki4D', //需要修改为业务 organization
                staticHost: 'static.fengkongcloud.com',
                apiHost: apiHost
            };
            var sm = document.createElement("script");
            sm.src = ('https:' === document.location.protocol ? 'https:' : 'http:') + '//' + _smConf.staticHost + '/fpv2.js';
            var s = document.getElementsByTagName("script")[0];
            sm.onload = function () {
                $.channel.emit('smsdkLoaded');
            };
            sm.onerror = function () {
                $.channel.emit('smsdkLoadedError');
            };
            s.parentNode.insertBefore(sm, s);
        })();
    }
}, _events2.default); // 数美防刷


SM.init();

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule React
 */



var ReactDOM = __webpack_require__(158);
var ReactDOMServer = __webpack_require__(360);
var ReactIsomorphic = __webpack_require__(364);

var assign = __webpack_require__(8);
var deprecated = __webpack_require__(368);

// `version` will be added here by ReactIsomorphic.
var React = {};

assign(React, ReactIsomorphic);

assign(React, {
  // ReactDOM
  findDOMNode: deprecated('findDOMNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.findDOMNode),
  render: deprecated('render', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.render),
  unmountComponentAtNode: deprecated('unmountComponentAtNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.unmountComponentAtNode),

  // ReactDOMServer
  renderToString: deprecated('renderToString', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToString),
  renderToStaticMarkup: deprecated('renderToStaticMarkup', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToStaticMarkup)
});

React.__SECRET_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOM;
React.__SECRET_DOM_SERVER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOMServer;

module.exports = React;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Danger
 * @typechecks static-only
 */



var ExecutionEnvironment = __webpack_require__(14);

var createNodesFromMarkup = __webpack_require__(304);
var emptyFunction = __webpack_require__(21);
var getMarkupWrap = __webpack_require__(161);
var invariant = __webpack_require__(2);

var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
var RESULT_INDEX_ATTR = 'data-danger-index';

/**
 * Extracts the `nodeName` from a string of markup.
 *
 * NOTE: Extracting the `nodeName` does not require a regular expression match
 * because we make assumptions about React-generated markup (i.e. there are no
 * spaces surrounding the opening tag and there is at least one attribute).
 *
 * @param {string} markup String of markup.
 * @return {string} Node name of the supplied markup.
 * @see http://jsperf.com/extract-nodename
 */
function getNodeName(markup) {
  return markup.substring(1, markup.indexOf(' '));
}

var Danger = {

  /**
   * Renders markup into an array of nodes. The markup is expected to render
   * into a list of root nodes. Also, the length of `resultList` and
   * `markupList` should be the same.
   *
   * @param {array<string>} markupList List of markup strings to render.
   * @return {array<DOMElement>} List of rendered nodes.
   * @internal
   */
  dangerouslyRenderMarkup: function (markupList) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' + 'thread. Make sure `window` and `document` are available globally ' + 'before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString for server rendering.') : invariant(false) : undefined;
    var nodeName;
    var markupByNodeName = {};
    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
    for (var i = 0; i < markupList.length; i++) {
      !markupList[i] ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Missing markup.') : invariant(false) : undefined;
      nodeName = getNodeName(markupList[i]);
      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
      markupByNodeName[nodeName][i] = markupList[i];
    }
    var resultList = [];
    var resultListAssignmentCount = 0;
    for (nodeName in markupByNodeName) {
      if (!markupByNodeName.hasOwnProperty(nodeName)) {
        continue;
      }
      var markupListByNodeName = markupByNodeName[nodeName];

      // This for-in loop skips the holes of the sparse array. The order of
      // iteration should follow the order of assignment, which happens to match
      // numerical index order, but we don't rely on that.
      var resultIndex;
      for (resultIndex in markupListByNodeName) {
        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
          var markup = markupListByNodeName[resultIndex];

          // Push the requested markup with an additional RESULT_INDEX_ATTR
          // attribute.  If the markup does not start with a < character, it
          // will be discarded below (with an appropriate console.error).
          markupListByNodeName[resultIndex] = markup.replace(OPEN_TAG_NAME_EXP,
          // This index will be parsed back out below.
          '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" ');
        }
      }

      // Render each group of markup with similar wrapping `nodeName`.
      var renderNodes = createNodesFromMarkup(markupListByNodeName.join(''), emptyFunction // Do nothing special with <script> tags.
      );

      for (var j = 0; j < renderNodes.length; ++j) {
        var renderNode = renderNodes[j];
        if (renderNode.hasAttribute && renderNode.hasAttribute(RESULT_INDEX_ATTR)) {

          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
          renderNode.removeAttribute(RESULT_INDEX_ATTR);

          !!resultList.hasOwnProperty(resultIndex) ?  false ? invariant(false, 'Danger: Assigning to an already-occupied result index.') : invariant(false) : undefined;

          resultList[resultIndex] = renderNode;

          // This should match resultList.length and markupList.length when
          // we're done.
          resultListAssignmentCount += 1;
        } else if (false) {
          console.error('Danger: Discarding unexpected node:', renderNode);
        }
      }
    }

    // Although resultList was populated out of order, it should now be a dense
    // array.
    !(resultListAssignmentCount === resultList.length) ?  false ? invariant(false, 'Danger: Did not assign to every index of resultList.') : invariant(false) : undefined;

    !(resultList.length === markupList.length) ?  false ? invariant(false, 'Danger: Expected markup to render %s nodes, but rendered %s.', markupList.length, resultList.length) : invariant(false) : undefined;

    return resultList;
  },

  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' + 'worker thread. Make sure `window` and `document` are available ' + 'globally before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(false) : undefined;
    !(oldChild.tagName.toLowerCase() !== 'html') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' + '<html> node. This is because browser quirks make this unreliable ' + 'and/or slow. If you want to render to the root you must use ' + 'server rendering. See ReactDOMServer.renderToString().') : invariant(false) : undefined;

    var newChild;
    if (typeof markup === 'string') {
      newChild = createNodesFromMarkup(markup, emptyFunction)[0];
    } else {
      newChild = markup;
    }
    oldChild.parentNode.replaceChild(newChild, oldChild);
  }

};

module.exports = Danger;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule createNodesFromMarkup
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/



var ExecutionEnvironment = __webpack_require__(14);

var createArrayFromMixed = __webpack_require__(305);
var getMarkupWrap = __webpack_require__(161);
var invariant = __webpack_require__(2);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : undefined;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : undefined;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = createArrayFromMixed(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule createArrayFromMixed
 * @typechecks
 */



var toArray = __webpack_require__(306);

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return(
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule toArray
 * @typechecks
 */



var invariant = __webpack_require__(2);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browse builtin objects can report typeof 'function' (e.g. NodeList in
  // old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : undefined;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : undefined;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : undefined;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

module.exports = toArray;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule quoteAttributeValueForBrowser
 */



var escapeTextContentForBrowser = __webpack_require__(78);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventPluginUtils
 */



var EventConstants = __webpack_require__(26);
var ReactErrorUtils = __webpack_require__(164);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(7);

/**
 * Injected dependencies:
 */

/**
 * - `Mount`: [required] Module that can convert between React dom IDs and
 *   actual node references.
 */
var injection = {
  Mount: null,
  injectMount: function (InjectedMount) {
    injection.Mount = InjectedMount;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(InjectedMount && InjectedMount.getNode && InjectedMount.getID, 'EventPluginUtils.injection.injectMount(...): Injected Mount ' + 'module is missing getNode or getID.') : undefined;
    }
  }
};

var topLevelTypes = EventConstants.topLevelTypes;

function isEndish(topLevelType) {
  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
}

function isMoveish(topLevelType) {
  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
}
function isStartish(topLevelType) {
  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchIDs = event._dispatchIDs;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var idsIsArr = Array.isArray(dispatchIDs);
    var IDsLen = idsIsArr ? dispatchIDs.length : dispatchIDs ? 1 : 0;
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(idsIsArr === listenersIsArr && IDsLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : undefined;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {string} domID DOM id to pass to the callback.
 */
function executeDispatch(event, simulated, listener, domID) {
  var type = event.type || 'unknown-event';
  event.currentTarget = injection.Mount.getNode(domID);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event, domID);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event, domID);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchIDs = event._dispatchIDs;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and IDs are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchIDs[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchIDs);
  }
  event._dispatchListeners = null;
  event._dispatchIDs = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchIDs = event._dispatchIDs;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and IDs are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchIDs[i])) {
        return dispatchIDs[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchIDs)) {
      return dispatchIDs;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchIDs = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchID = event._dispatchIDs;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : invariant(false) : undefined;
  var res = dispatchListener ? dispatchListener(event, dispatchID) : null;
  event._dispatchListeners = null;
  event._dispatchIDs = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getNode: function (id) {
    return injection.Mount.getNode(id);
  },
  getID: function (node) {
    return injection.Mount.getID(node);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactEventEmitterMixin
 */



var EventPluginHub = __webpack_require__(60);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {

  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {object} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native environment event.
   */
  handleTopLevel: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule adler32
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    for (; i < Math.min(i + 4096, m); i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactRef
 */



var ReactOwner = __webpack_require__(312);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || element === false) {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;

  return(
    // This has a few false positives w/r/t empty components.
    prevEmpty || nextEmpty || nextElement._owner !== prevElement._owner || nextElement.ref !== prevElement.ref
  );
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || element === false) {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactOwner
 */



var invariant = __webpack_require__(2);

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {

  /**
   * @param {?object} object
   * @return {boolean} True if `object` is a valid owner.
   * @final
   */
  isValidOwner: function (object) {
    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
  },

  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might ' + 'be adding a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might ' + 'be removing a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
    // Check that `component` is still the current ref because we do not want to
    // detach the ref if another component stole it.
    if (owner.getPublicInstance().refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }

};

module.exports = ReactOwner;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isTextNode
 * @typechecks
 */



var isNode = __webpack_require__(314);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isNode
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */


function isNode(object) {
  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactCompositeComponent
 */



var ReactComponentEnvironment = __webpack_require__(116);
var ReactCurrentOwner = __webpack_require__(25);
var ReactElement = __webpack_require__(18);
var ReactInstanceMap = __webpack_require__(61);
var ReactPerf = __webpack_require__(19);
var ReactPropTypeLocations = __webpack_require__(82);
var ReactPropTypeLocationNames = __webpack_require__(83);
var ReactReconciler = __webpack_require__(39);
var ReactUpdateQueue = __webpack_require__(113);

var assign = __webpack_require__(8);
var emptyObject = __webpack_require__(62);
var invariant = __webpack_require__(2);
var shouldUpdateReactComponent = __webpack_require__(117);
var warning = __webpack_require__(7);

function getDeclarationErrorAddendum(component) {
  var owner = component._currentElement._owner || null;
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  return Component(this.props, this.context, this.updater);
};

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponentMixin = {

  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = null;
    this._instance = null;

    // See ReactUpdateQueue
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedComponent = null;

    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {string} rootID DOM ID of the root node.
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (rootID, transaction, context) {
    this._context = context;
    this._mountOrder = nextMountID++;
    this._rootNodeID = rootID;

    var publicProps = this._processProps(this._currentElement.props);
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    // Initialize the public class
    var inst;
    var renderedElement;

    // This is a way to detect if Component is a stateless arrow function
    // component, which is not newable. It might not be 100% reliable but is
    // something we can do until we start detecting that Component extends
    // React.Component. We already assume that typeof Component === 'function'.
    var canInstantiate = ('prototype' in Component);

    if (canInstantiate) {
      if (false) {
        ReactCurrentOwner.current = this;
        try {
          inst = new Component(publicProps, publicContext, ReactUpdateQueue);
        } finally {
          ReactCurrentOwner.current = null;
        }
      } else {
        inst = new Component(publicProps, publicContext, ReactUpdateQueue);
      }
    }

    if (!canInstantiate || inst === null || inst === false || ReactElement.isValidElement(inst)) {
      renderedElement = inst;
      inst = new StatelessComponent(Component);
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`, returned ' + 'null/false from a stateless component, or tried to render an ' + 'element whose type is a function that isn\'t a React component.', Component.displayName || Component.name || 'Component') : undefined;
      } else {
        // We support ES6 inheriting from React.Component, the module pattern,
        // and stateless components, but not ES6 classes that don't extend
        process.env.NODE_ENV !== 'production' ? warning(Component.prototype && Component.prototype.isReactComponent || !canInstantiate || !(inst instanceof Component), '%s(...): React component classes must extend React.Component.', Component.displayName || Component.name || 'Component') : undefined;
      }
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = ReactUpdateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : undefined;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : undefined;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : undefined;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : undefined;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : undefined;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : undefined;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : undefined;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    if (inst.componentWillMount) {
      inst.componentWillMount();
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    this._renderedComponent = this._instantiateReactComponent(renderedElement);

    var markup = ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, this._processChildContext(context));
    if (inst.componentDidMount) {
      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
    }

    return markup;
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function () {
    var inst = this._instance;

    if (inst.componentWillUnmount) {
      inst.componentWillUnmount();
    }

    ReactReconciler.unmountComponent(this._renderedComponent);
    this._renderedComponent = null;
    this._instance = null;

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = null;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var maskedContext = null;
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkPropTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext = inst.getChildContext && inst.getChildContext();
    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
      if (false) {
        this._checkPropTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : invariant(false) : undefined;
      }
      return assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Processes props by setting default values for unspecified props and
   * asserting that the props are valid. Does not mutate its argument; returns
   * a new props object with defaults merged in.
   *
   * @param {object} newProps
   * @return {object}
   * @private
   */
  _processProps: function (newProps) {
    if (false) {
      var Component = this._currentElement.type;
      if (Component.propTypes) {
        this._checkPropTypes(Component.propTypes, newProps, ReactPropTypeLocations.prop);
      }
    }
    return newProps;
  },

  /**
   * Assert that the props are valid
   *
   * @param {object} propTypes Map of prop name to a ReactPropType
   * @param {object} props
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkPropTypes: function (propTypes, props, location) {
    // TODO: Stop validating prop types here and only use the element
    // validation.
    var componentName = this.getName();
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error;
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually ' + 'from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
          error = propTypes[propName](props, propName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
        } catch (ex) {
          error = ex;
        }
        if (error instanceof Error) {
          // We may want to extend this logic for similar errors in
          // top-level render calls, so I'm abstracting it away into
          // a function to minimize refactoring in the future
          var addendum = getDeclarationErrorAddendum(this);

          if (location === ReactPropTypeLocations.prop) {
            // Preface gives us something to blacklist in warning module
             false ? warning(false, 'Failed Composite propType: %s%s', error.message, addendum) : undefined;
          } else {
             false ? warning(false, 'Failed Context Types: %s%s', error.message, addendum) : undefined;
          }
        }
      }
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement || this._currentElement, transaction, this._context);
    }

    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;

    var nextContext = this._context === nextUnmaskedContext ? inst.context : this._processContext(nextUnmaskedContext);
    var nextProps;

    // Distinguish between a props update versus a simple state update
    if (prevParentElement === nextParentElement) {
      // Skip checking prop types again -- we don't read inst.props to avoid
      // warning for DOM component props in this upgrade
      nextProps = nextParentElement.props;
    } else {
      nextProps = this._processProps(nextParentElement.props);
      // An update here will schedule an update but immediately set
      // _pendingStateQueue which will ensure that any state updates gets
      // immediately reconciled instead of waiting for the next batch.

      if (inst.componentWillReceiveProps) {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);

    var shouldUpdate = this._pendingForceUpdate || !inst.shouldComponentUpdate || inst.shouldComponentUpdate(nextProps, nextState, nextContext);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(typeof shouldUpdate !== 'undefined', '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : undefined;
    }

    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      inst.componentWillUpdate(nextProps, nextState, nextContext);
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();
    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      // These two IDs are actually the same! But nothing should rely on that.
      var thisID = this._rootNodeID;
      var prevComponentID = prevComponentInstance._rootNodeID;
      ReactReconciler.unmountComponent(prevComponentInstance);

      this._renderedComponent = this._instantiateReactComponent(nextRenderedElement);
      var nextMarkup = ReactReconciler.mountComponent(this._renderedComponent, thisID, transaction, this._processChildContext(context));
      this._replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
    }
  },

  /**
   * @protected
   */
  _replaceNodeWithMarkupByID: function (prevComponentID, nextMarkup) {
    ReactComponentEnvironment.replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedComponent = inst.render();
    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (typeof renderedComponent === 'undefined' && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedComponent = null;
      }
    }

    return renderedComponent;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedComponent;
    ReactCurrentOwner.current = this;
    try {
      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
    } finally {
      ReactCurrentOwner.current = null;
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid ReactComponent must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
    return renderedComponent;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : invariant(false) : undefined;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : undefined;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (inst instanceof StatelessComponent) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null

};

ReactPerf.measureMethods(ReactCompositeComponentMixin, 'ReactCompositeComponent', {
  mountComponent: 'mountComponent',
  updateComponent: 'updateComponent',
  _renderValidatedComponent: '_renderValidatedComponent'
});

var ReactCompositeComponent = {

  Mixin: ReactCompositeComponentMixin

};

module.exports = ReactCompositeComponent;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015 Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BeforeInputEventPlugin
 * @typechecks static-only
 */



var EventConstants = __webpack_require__(26);
var EventPropagators = __webpack_require__(63);
var ExecutionEnvironment = __webpack_require__(14);
var FallbackCompositionState = __webpack_require__(317);
var SyntheticCompositionEvent = __webpack_require__(318);
var SyntheticInputEvent = __webpack_require__(319);

var keyOf = __webpack_require__(32);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

var topLevelTypes = EventConstants.topLevelTypes;

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onBeforeInput: null }),
      captured: keyOf({ onBeforeInputCapture: null })
    },
    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCompositionEnd: null }),
      captured: keyOf({ onCompositionEndCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCompositionStart: null }),
      captured: keyOf({ onCompositionStartCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCompositionUpdate: null }),
      captured: keyOf({ onCompositionUpdateCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case topLevelTypes.topCompositionStart:
      return eventTypes.compositionStart;
    case topLevelTypes.topCompositionEnd:
      return eventTypes.compositionEnd;
    case topLevelTypes.topCompositionUpdate:
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case topLevelTypes.topKeyUp:
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case topLevelTypes.topKeyDown:
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case topLevelTypes.topKeyPress:
    case topLevelTypes.topMouseDown:
    case topLevelTypes.topBlur:
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {DOMEventTarget} topLevelTarget The listening component root node.
 * @param {string} topLevelTargetID ID of `topLevelTarget`.
 * @param {object} nativeEvent Native browser event.
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(topLevelTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, topLevelTargetID, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case topLevelTypes.topCompositionEnd:
      return getDataFromCustomEvent(nativeEvent);
    case topLevelTypes.topKeyPress:
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case topLevelTypes.topTextInput:
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  if (currentComposition) {
    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case topLevelTypes.topPaste:
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case topLevelTypes.topKeyPress:
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case topLevelTypes.topCompositionEnd:
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {DOMEventTarget} topLevelTarget The listening component root node.
 * @param {string} topLevelTargetID ID of `topLevelTarget`.
 * @param {object} nativeEvent Native browser event.
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, topLevelTargetID, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {

  eventTypes: eventTypes,

  /**
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {DOMEventTarget} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native browser event.
   * @return {*} An accumulation of synthetic events.
   * @see {EventPluginHub.extractEvents}
   */
  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule FallbackCompositionState
 * @typechecks static-only
 */



var PooledClass = __webpack_require__(31);

var assign = __webpack_require__(8);
var getTextContentAccessor = __webpack_require__(176);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticCompositionEvent
 * @typechecks static-only
 */



var SyntheticEvent = __webpack_require__(40);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticInputEvent
 * @typechecks static-only
 */



var SyntheticEvent = __webpack_require__(40);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ChangeEventPlugin
 */



var EventConstants = __webpack_require__(26);
var EventPluginHub = __webpack_require__(60);
var EventPropagators = __webpack_require__(63);
var ExecutionEnvironment = __webpack_require__(14);
var ReactUpdates = __webpack_require__(20);
var SyntheticEvent = __webpack_require__(40);

var getEventTarget = __webpack_require__(119);
var isEventSupported = __webpack_require__(112);
var isTextInputElement = __webpack_require__(177);
var keyOf = __webpack_require__(32);

var topLevelTypes = EventConstants.topLevelTypes;

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onChange: null }),
      captured: keyOf({ onChangeCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
  }
};

/**
 * For IE shims
 */
var activeElement = null;
var activeElementID = null;
var activeElementValue = null;
var activeElementValueProp = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementID, nativeEvent, getEventTarget(nativeEvent));
  EventPropagators.accumulateTwoPhaseDispatches(event);

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetID) {
  activeElement = target;
  activeElementID = targetID;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementID = null;
}

function getTargetIDForChangeEvent(topLevelType, topLevelTarget, topLevelTargetID) {
  if (topLevelType === topLevelTypes.topChange) {
    return topLevelTargetID;
  }
}
function handleEventsForChangeEventIE8(topLevelType, topLevelTarget, topLevelTargetID) {
  if (topLevelType === topLevelTypes.topFocus) {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(topLevelTarget, topLevelTargetID);
  } else if (topLevelType === topLevelTypes.topBlur) {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events
  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
}

/**
 * (For old IE.) Replacement getter/setter for the `value` property that gets
 * set on the active element.
 */
var newValueProp = {
  get: function () {
    return activeElementValueProp.get.call(this);
  },
  set: function (val) {
    // Cast to a string so we can do equality checks.
    activeElementValue = '' + val;
    activeElementValueProp.set.call(this, val);
  }
};

/**
 * (For old IE.) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetID) {
  activeElement = target;
  activeElementID = targetID;
  activeElementValue = target.value;
  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');

  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
  // on DOM elements
  Object.defineProperty(activeElement, 'value', newValueProp);
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For old IE.) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }

  // delete restores the original property definition
  delete activeElement.value;
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementID = null;
  activeElementValue = null;
  activeElementValueProp = null;
}

/**
 * (For old IE.) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  var value = nativeEvent.srcElement.value;
  if (value === activeElementValue) {
    return;
  }
  activeElementValue = value;

  manualDispatchChangeEvent(nativeEvent);
}

/**
 * If a `change` event should be fired, returns the target's ID.
 */
function getTargetIDForInputEvent(topLevelType, topLevelTarget, topLevelTargetID) {
  if (topLevelType === topLevelTypes.topInput) {
    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
    // what we want so fall through here and trigger an abstract event
    return topLevelTargetID;
  }
}

// For IE8 and IE9.
function handleEventsForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
  if (topLevelType === topLevelTypes.topFocus) {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(topLevelTarget, topLevelTargetID);
  } else if (topLevelType === topLevelTypes.topBlur) {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetIDForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    if (activeElement && activeElement.value !== activeElementValue) {
      activeElementValue = activeElement.value;
      return activeElementID;
    }
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetIDForClickEvent(topLevelType, topLevelTarget, topLevelTargetID) {
  if (topLevelType === topLevelTypes.topClick) {
    return topLevelTargetID;
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {

  eventTypes: eventTypes,

  /**
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {DOMEventTarget} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native browser event.
   * @return {*} An accumulation of synthetic events.
   * @see {EventPluginHub.extractEvents}
   */
  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {

    var getTargetIDFunc, handleEventFunc;
    if (shouldUseChangeEvent(topLevelTarget)) {
      if (doesChangeEventBubble) {
        getTargetIDFunc = getTargetIDForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(topLevelTarget)) {
      if (isInputEventSupported) {
        getTargetIDFunc = getTargetIDForInputEvent;
      } else {
        getTargetIDFunc = getTargetIDForInputEventIE;
        handleEventFunc = handleEventsForInputEventIE;
      }
    } else if (shouldUseClickEvent(topLevelTarget)) {
      getTargetIDFunc = getTargetIDForClickEvent;
    }

    if (getTargetIDFunc) {
      var targetID = getTargetIDFunc(topLevelType, topLevelTarget, topLevelTargetID);
      if (targetID) {
        var event = SyntheticEvent.getPooled(eventTypes.change, targetID, nativeEvent, nativeEventTarget);
        event.type = 'change';
        EventPropagators.accumulateTwoPhaseDispatches(event);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, topLevelTarget, topLevelTargetID);
    }
  }

};

module.exports = ChangeEventPlugin;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ClientReactRootIndex
 * @typechecks
 */



var nextReactRootIndex = 0;

var ClientReactRootIndex = {
  createReactRootIndex: function () {
    return nextReactRootIndex++;
  }
};

module.exports = ClientReactRootIndex;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DefaultEventPluginOrder
 */



var keyOf = __webpack_require__(32);

/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */
var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EnterLeaveEventPlugin
 * @typechecks static-only
 */



var EventConstants = __webpack_require__(26);
var EventPropagators = __webpack_require__(63);
var SyntheticMouseEvent = __webpack_require__(84);

var ReactMount = __webpack_require__(16);
var keyOf = __webpack_require__(32);

var topLevelTypes = EventConstants.topLevelTypes;
var getFirstReactDOM = ReactMount.getFirstReactDOM;

var eventTypes = {
  mouseEnter: {
    registrationName: keyOf({ onMouseEnter: null }),
    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
  },
  mouseLeave: {
    registrationName: keyOf({ onMouseLeave: null }),
    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
  }
};

var extractedEvents = [null, null];

var EnterLeaveEventPlugin = {

  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {DOMEventTarget} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native browser event.
   * @return {*} An accumulation of synthetic events.
   * @see {EventPluginHub.extractEvents}
   */
  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (topLevelTarget.window === topLevelTarget) {
      // `topLevelTarget` is probably a window object.
      win = topLevelTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = topLevelTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    var fromID = '';
    var toID = '';
    if (topLevelType === topLevelTypes.topMouseOut) {
      from = topLevelTarget;
      fromID = topLevelTargetID;
      to = getFirstReactDOM(nativeEvent.relatedTarget || nativeEvent.toElement);
      if (to) {
        toID = ReactMount.getID(to);
      } else {
        to = win;
      }
      to = to || win;
    } else {
      from = win;
      to = topLevelTarget;
      toID = topLevelTargetID;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, fromID, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = from;
    leave.relatedTarget = to;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, toID, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = to;
    enter.relatedTarget = from;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, fromID, toID);

    extractedEvents[0] = leave;
    extractedEvents[1] = enter;

    return extractedEvents;
  }

};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule HTMLDOMPropertyConfig
 */



var DOMProperty = __webpack_require__(47);
var ExecutionEnvironment = __webpack_require__(14);

var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var hasSVG;
if (ExecutionEnvironment.canUseDOM) {
  var implementation = document.implementation;
  hasSVG = implementation && implementation.hasFeature && implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');
}

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(/^(data|aria)-[a-z_][a-z\d_.\-]*$/),
  Properties: {
    /**
     * Standard Properties
     */
    accept: null,
    acceptCharset: null,
    accessKey: null,
    action: null,
    allowFullScreen: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
    allowTransparency: MUST_USE_ATTRIBUTE,
    alt: null,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: null,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
    cellPadding: null,
    cellSpacing: null,
    charSet: MUST_USE_ATTRIBUTE,
    challenge: MUST_USE_ATTRIBUTE,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    classID: MUST_USE_ATTRIBUTE,
    // To set className on SVG elements, it's necessary to use .setAttribute;
    // this works on HTML elements too in all browsers except IE8. Conveniently,
    // IE8 doesn't support SVG and so we can simply use the attribute in
    // browsers that support SVG and the property in browsers that don't,
    // regardless of whether the element is HTML or SVG.
    className: hasSVG ? MUST_USE_ATTRIBUTE : MUST_USE_PROPERTY,
    cols: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: null,
    content: null,
    contentEditable: null,
    contextMenu: MUST_USE_ATTRIBUTE,
    controls: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    coords: null,
    crossOrigin: null,
    data: null, // For `<object />` acts as `src`.
    dateTime: MUST_USE_ATTRIBUTE,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: null,
    disabled: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: null,
    encType: null,
    form: MUST_USE_ATTRIBUTE,
    formAction: MUST_USE_ATTRIBUTE,
    formEncType: MUST_USE_ATTRIBUTE,
    formMethod: MUST_USE_ATTRIBUTE,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: MUST_USE_ATTRIBUTE,
    frameBorder: MUST_USE_ATTRIBUTE,
    headers: null,
    height: MUST_USE_ATTRIBUTE,
    hidden: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
    high: null,
    href: null,
    hrefLang: null,
    htmlFor: null,
    httpEquiv: null,
    icon: null,
    id: MUST_USE_PROPERTY,
    inputMode: MUST_USE_ATTRIBUTE,
    integrity: null,
    is: MUST_USE_ATTRIBUTE,
    keyParams: MUST_USE_ATTRIBUTE,
    keyType: MUST_USE_ATTRIBUTE,
    kind: null,
    label: null,
    lang: null,
    list: MUST_USE_ATTRIBUTE,
    loop: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    low: null,
    manifest: MUST_USE_ATTRIBUTE,
    marginHeight: null,
    marginWidth: null,
    max: null,
    maxLength: MUST_USE_ATTRIBUTE,
    media: MUST_USE_ATTRIBUTE,
    mediaGroup: null,
    method: null,
    min: null,
    minLength: MUST_USE_ATTRIBUTE,
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: null,
    nonce: MUST_USE_ATTRIBUTE,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: null,
    pattern: null,
    placeholder: null,
    poster: null,
    preload: null,
    radioGroup: null,
    readOnly: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    rel: null,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: MUST_USE_ATTRIBUTE,
    rows: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: null,
    sandbox: null,
    scope: null,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: null,
    seamless: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: null,
    size: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
    sizes: MUST_USE_ATTRIBUTE,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: null,
    src: null,
    srcDoc: MUST_USE_PROPERTY,
    srcLang: null,
    srcSet: MUST_USE_ATTRIBUTE,
    start: HAS_NUMERIC_VALUE,
    step: null,
    style: null,
    summary: null,
    tabIndex: null,
    target: null,
    title: null,
    type: null,
    useMap: null,
    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
    width: MUST_USE_ATTRIBUTE,
    wmode: MUST_USE_ATTRIBUTE,
    wrap: null,

    /**
     * RDFa Properties
     */
    about: MUST_USE_ATTRIBUTE,
    datatype: MUST_USE_ATTRIBUTE,
    inlist: MUST_USE_ATTRIBUTE,
    prefix: MUST_USE_ATTRIBUTE,
    // property is also supported for OpenGraph in meta tags.
    property: MUST_USE_ATTRIBUTE,
    resource: MUST_USE_ATTRIBUTE,
    'typeof': MUST_USE_ATTRIBUTE,
    vocab: MUST_USE_ATTRIBUTE,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: MUST_USE_ATTRIBUTE,
    autoCorrect: MUST_USE_ATTRIBUTE,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: null,
    // color is for Safari mask-icon link
    color: null,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: MUST_USE_ATTRIBUTE,
    itemScope: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
    itemType: MUST_USE_ATTRIBUTE,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: MUST_USE_ATTRIBUTE,
    itemRef: MUST_USE_ATTRIBUTE,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: null,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: MUST_USE_ATTRIBUTE,
    // IE-only attribute that controls focus behavior
    unselectable: MUST_USE_ATTRIBUTE
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {
    autoComplete: 'autocomplete',
    autoFocus: 'autofocus',
    autoPlay: 'autoplay',
    autoSave: 'autosave',
    // `encoding` is equivalent to `enctype`, IE8 lacks an `enctype` setter.
    // http://www.w3.org/TR/html5/forms.html#dom-fs-encoding
    encType: 'encoding',
    hrefLang: 'hreflang',
    radioGroup: 'radiogroup',
    spellCheck: 'spellcheck',
    srcDoc: 'srcdoc',
    srcSet: 'srcset'
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactBrowserComponentMixin
 */



var ReactInstanceMap = __webpack_require__(61);

var findDOMNode = __webpack_require__(121);
var warning = __webpack_require__(7);

var didWarnKey = '_getDOMNodeDidWarn';

var ReactBrowserComponentMixin = {
  /**
   * Returns the DOM node rendered by this component.
   *
   * @return {DOMElement} The root node of this component.
   * @final
   * @protected
   */
  getDOMNode: function () {
     false ? warning(this.constructor[didWarnKey], '%s.getDOMNode(...) is deprecated. Please use ' + 'ReactDOM.findDOMNode(instance) instead.', ReactInstanceMap.get(this).getName() || this.tagName || 'Unknown') : undefined;
    this.constructor[didWarnKey] = true;
    return findDOMNode(this);
  }
};

module.exports = ReactBrowserComponentMixin;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMComponent
 * @typechecks static-only
 */

/* global hasOwnProperty:true */



var AutoFocusUtils = __webpack_require__(327);
var CSSPropertyOperations = __webpack_require__(328);
var DOMProperty = __webpack_require__(47);
var DOMPropertyOperations = __webpack_require__(109);
var EventConstants = __webpack_require__(26);
var ReactBrowserEventEmitter = __webpack_require__(79);
var ReactComponentBrowserEnvironment = __webpack_require__(110);
var ReactDOMButton = __webpack_require__(335);
var ReactDOMInput = __webpack_require__(336);
var ReactDOMOption = __webpack_require__(337);
var ReactDOMSelect = __webpack_require__(183);
var ReactDOMTextarea = __webpack_require__(338);
var ReactMount = __webpack_require__(16);
var ReactMultiChild = __webpack_require__(339);
var ReactPerf = __webpack_require__(19);
var ReactUpdateQueue = __webpack_require__(113);

var assign = __webpack_require__(8);
var canDefineProperty = __webpack_require__(80);
var escapeTextContentForBrowser = __webpack_require__(78);
var invariant = __webpack_require__(2);
var isEventSupported = __webpack_require__(112);
var keyOf = __webpack_require__(32);
var setInnerHTML = __webpack_require__(77);
var setTextContent = __webpack_require__(108);
var shallowEqual = __webpack_require__(184);
var validateDOMNesting = __webpack_require__(118);
var warning = __webpack_require__(7);

var deleteListener = ReactBrowserEventEmitter.deleteListener;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = ReactBrowserEventEmitter.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { 'string': true, 'number': true };

var CHILDREN = keyOf({ children: null });
var STYLE = keyOf({ style: null });
var HTML = keyOf({ __html: null });

var ELEMENT_NODE_TYPE = 1;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

var legacyPropsDescriptor;
if (false) {
  legacyPropsDescriptor = {
    props: {
      enumerable: false,
      get: function () {
        var component = this._reactInternalComponent;
        process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .props of a DOM node; instead, ' + 'recreate the props as `render` did originally or read the DOM ' + 'properties/attributes directly from this node (e.g., ' + 'this.refs.box.className).%s', getDeclarationErrorAddendum(component)) : undefined;
        return component._currentElement.props;
      }
    }
  };
}

function legacyGetDOMNode() {
  if (false) {
    var component = this._reactInternalComponent;
    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .getDOMNode() of a DOM node; ' + 'instead, use the node directly.%s', getDeclarationErrorAddendum(component)) : undefined;
  }
  return this;
}

function legacyIsMounted() {
  var component = this._reactInternalComponent;
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .isMounted() of a DOM node.%s', getDeclarationErrorAddendum(component)) : undefined;
  }
  return !!component;
}

function legacySetStateEtc() {
  if (false) {
    var component = this._reactInternalComponent;
    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setState(), .replaceState(), or ' + '.forceUpdate() of a DOM node. This is a no-op.%s', getDeclarationErrorAddendum(component)) : undefined;
  }
}

function legacySetProps(partialProps, callback) {
  var component = this._reactInternalComponent;
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
  }
  if (!component) {
    return;
  }
  ReactUpdateQueue.enqueueSetPropsInternal(component, partialProps);
  if (callback) {
    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
  }
}

function legacyReplaceProps(partialProps, callback) {
  var component = this._reactInternalComponent;
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .replaceProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
  }
  if (!component) {
    return;
  }
  ReactUpdateQueue.enqueueReplacePropsInternal(component, partialProps);
  if (callback) {
    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
  }
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined becauses undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : undefined;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (false) {
    if (voidElementTags[component._tag]) {
      process.env.NODE_ENV !== 'production' ? warning(props.children == null && props.dangerouslySetInnerHTML == null, '%s is a void element tag and must not have `children` or ' + 'use `props.dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : undefined;
    }
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : invariant(false) : undefined;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' + 'for more information.') : invariant(false) : undefined;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : undefined;
    process.env.NODE_ENV !== 'production' ? warning(!props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : undefined;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, ' + 'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' + 'using JSX.%s', getDeclarationErrorAddendum(component)) : invariant(false) : undefined;
}

function enqueuePutListener(id, registrationName, listener, transaction) {
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : undefined;
  }
  var container = ReactMount.findReactContainerForID(id);
  if (container) {
    var doc = container.nodeType === ELEMENT_NODE_TYPE ? container.ownerDocument : container;
    listenTo(registrationName, doc);
  }
  transaction.getReactMountReady().enqueue(putListener, {
    id: id,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  ReactBrowserEventEmitter.putListener(listenerToPut.id, listenerToPut.registrationName, listenerToPut.listener);
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : invariant(false) : undefined;
  var node = ReactMount.getNode(inst._rootNodeID);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : invariant(false) : undefined;

  switch (inst._tag) {
    case 'iframe':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
      break;
    case 'video':
    case 'audio':

      inst._wrapperState.listeners = [];
      // create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
        }
      }

      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
      break;
  }
}

function mountReadyInputWrapper() {
  ReactDOMInput.mountReadyWrapper(this);
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special cased tags.

var omittedCloseTags = {
  'area': true,
  'base': true,
  'br': true,
  'col': true,
  'embed': true,
  'hr': true,
  'img': true,
  'input': true,
  'keygen': true,
  'link': true,
  'meta': true,
  'param': true,
  'source': true,
  'track': true,
  'wbr': true
};

// NOTE: menuitem's close tag should be omitted, but that causes problems.
var newlineEatingTags = {
  'listing': true,
  'pre': true,
  'textarea': true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = assign({
  'menuitem': true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = ({}).hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : invariant(false) : undefined;
    validatedTagCache[tag] = true;
  }
}

function processChildContextDev(context, inst) {
  // Pass down our tag name to child components for validation purposes
  context = assign({}, context);
  var info = context[validateDOMNesting.ancestorInfoContextKey];
  context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(info, inst._tag, inst);
  return context;
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(tag) {
  validateDangerousTag(tag);
  this._tag = tag.toLowerCase();
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._rootNodeID = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._nodeWithLegacyProperties = null;
  if (false) {
    this._unprocessedContextDev = null;
    this._processedContextDev = null;
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {

  construct: function (element) {
    this._currentElement = element;
  },

  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {string} rootID The root DOM ID for this node.
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (rootID, transaction, context) {
    this._rootNodeID = rootID;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'iframe':
      case 'img':
      case 'form':
      case 'video':
      case 'audio':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'button':
        props = ReactDOMButton.getNativeProps(this, props, context);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, context);
        props = ReactDOMInput.getNativeProps(this, props, context);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, context);
        props = ReactDOMOption.getNativeProps(this, props, context);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, context);
        props = ReactDOMSelect.getNativeProps(this, props, context);
        context = ReactDOMSelect.processChildContext(this, props, context);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, context);
        props = ReactDOMTextarea.getNativeProps(this, props, context);
        break;
    }

    assertValidProps(this, props);
    if (false) {
      if (context[validateDOMNesting.ancestorInfoContextKey]) {
        validateDOMNesting(this._tag, this, context[validateDOMNesting.ancestorInfoContextKey]);
      }
    }

    if (false) {
      this._unprocessedContextDev = context;
      this._processedContextDev = processChildContextDev(context, this);
      context = this._processedContextDev;
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
      var el = ownerDocument.createElement(this._currentElement.type);
      DOMPropertyOperations.setAttributeForID(el, this._rootNodeID);
      // Populate node cache
      ReactMount.getID(el);
      this._updateDOMProperties({}, props, transaction, el);
      this._createInitialChildren(transaction, props, context, el);
      mountImage = el;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(mountReadyInputWrapper, this);
      // falls through
      case 'button':
      case 'select':
      case 'textarea':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this._rootNodeID, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (propKey !== CHILDREN) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    var markupForID = DOMPropertyOperations.createMarkupForID(this._rootNodeID);
    return ret + ' ' + markupForID;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, el) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        setInnerHTML(el, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        setTextContent(el, contentToUse);
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          el.appendChild(mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a native DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'button':
        lastProps = ReactDOMButton.getNativeProps(this, lastProps);
        nextProps = ReactDOMButton.getNativeProps(this, nextProps);
        break;
      case 'input':
        ReactDOMInput.updateWrapper(this);
        lastProps = ReactDOMInput.getNativeProps(this, lastProps);
        nextProps = ReactDOMInput.getNativeProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getNativeProps(this, lastProps);
        nextProps = ReactDOMOption.getNativeProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getNativeProps(this, lastProps);
        nextProps = ReactDOMSelect.getNativeProps(this, nextProps);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        lastProps = ReactDOMTextarea.getNativeProps(this, lastProps);
        nextProps = ReactDOMTextarea.getNativeProps(this, nextProps);
        break;
    }

    if (false) {
      // If the context is reference-equal to the old one, pass down the same
      // processed object so the update bailout in ReactReconciler behaves
      // correctly (and identically in dev and prod). See #5005.
      if (this._unprocessedContextDev !== context) {
        this._unprocessedContextDev = context;
        this._processedContextDev = processChildContextDev(context, this);
      }
      context = this._processedContextDev;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction, null);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    if (!canDefineProperty && this._nodeWithLegacyProperties) {
      this._nodeWithLegacyProperties.props = nextProps;
    }

    if (this._tag === 'select') {
      // <select> value update needs to occur after <option> children
      // reconciliation
      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction, node) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey)) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this._rootNodeID, propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        if (!node) {
          node = ReactMount.getNode(this._rootNodeID);
        }
        DOMPropertyOperations.deleteValueForProperty(node, propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps[propKey];
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this._rootNodeID, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this._rootNodeID, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!node) {
          node = ReactMount.getNode(this._rootNodeID);
        }
        if (propKey === CHILDREN) {
          nextProp = null;
        }
        DOMPropertyOperations.setValueForAttribute(node, propKey, nextProp);
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        if (!node) {
          node = ReactMount.getNode(this._rootNodeID);
        }
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertantly setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      if (!node) {
        node = ReactMount.getNode(this._rootNodeID);
      }
      CSSPropertyOperations.setValueForStyles(node, styleUpdates);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
    } else if (nextChildren != null) {
      this.updateChildren(nextChildren, transaction, context);
    }
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function () {
    switch (this._tag) {
      case 'iframe':
      case 'img':
      case 'form':
      case 'video':
      case 'audio':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
        ReactDOMInput.unmountWrapper(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is ' + 'impossible to unmount some top-level components (eg <html>, ' + '<head>, and <body>) reliably and efficiently. To fix this, have a ' + 'single top-level component that never unmounts render these ' + 'elements.', this._tag) : invariant(false) : undefined;
        break;
    }

    this.unmountChildren();
    ReactBrowserEventEmitter.deleteAllListeners(this._rootNodeID);
    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
    this._rootNodeID = null;
    this._wrapperState = null;
    if (this._nodeWithLegacyProperties) {
      var node = this._nodeWithLegacyProperties;
      node._reactInternalComponent = null;
      this._nodeWithLegacyProperties = null;
    }
  },

  getPublicInstance: function () {
    if (!this._nodeWithLegacyProperties) {
      var node = ReactMount.getNode(this._rootNodeID);

      node._reactInternalComponent = this;
      node.getDOMNode = legacyGetDOMNode;
      node.isMounted = legacyIsMounted;
      node.setState = legacySetStateEtc;
      node.replaceState = legacySetStateEtc;
      node.forceUpdate = legacySetStateEtc;
      node.setProps = legacySetProps;
      node.replaceProps = legacyReplaceProps;

      if (false) {
        if (canDefineProperty) {
          Object.defineProperties(node, legacyPropsDescriptor);
        } else {
          // updateComponent will update this property on subsequent renders
          node.props = this._currentElement.props;
        }
      } else {
        // updateComponent will update this property on subsequent renders
        node.props = this._currentElement.props;
      }

      this._nodeWithLegacyProperties = node;
    }
    return this._nodeWithLegacyProperties;
  }

};

ReactPerf.measureMethods(ReactDOMComponent, 'ReactDOMComponent', {
  mountComponent: 'mountComponent',
  updateComponent: 'updateComponent'
});

assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule AutoFocusUtils
 * @typechecks static-only
 */



var ReactMount = __webpack_require__(16);

var findDOMNode = __webpack_require__(121);
var focusNode = __webpack_require__(179);

var Mixin = {
  componentDidMount: function () {
    if (this.props.autoFocus) {
      focusNode(findDOMNode(this));
    }
  }
};

var AutoFocusUtils = {
  Mixin: Mixin,

  focusDOMComponent: function () {
    focusNode(ReactMount.getNode(this._rootNodeID));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CSSPropertyOperations
 * @typechecks static-only
 */



var CSSProperty = __webpack_require__(180);
var ExecutionEnvironment = __webpack_require__(14);
var ReactPerf = __webpack_require__(19);

var camelizeStyleName = __webpack_require__(329);
var dangerousStyleValue = __webpack_require__(331);
var hyphenateStyleName = __webpack_require__(332);
var memoizeStringOnly = __webpack_require__(334);
var warning = __webpack_require__(7);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};

  var warnHyphenatedStyleName = function (name) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?', name, camelizeStyleName(name)) : undefined;
  };

  var warnBadVendoredStyleName = function (name) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1)) : undefined;
  };

  var warnStyleValueWithSemicolon = function (name, value) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon. ' + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, '')) : undefined;
  };

  /**
   * @param {string} name
   * @param {*} value
   */
  var warnValidStyle = function (name, value) {
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {

  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @return {?string}
   */
  createMarkupForStyles: function (styles) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var styleValue = styles[styleName];
      if (false) {
        warnValidStyle(styleName, styleValue);
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   */
  setValueForStyles: function (node, styles) {
    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      if (false) {
        warnValidStyle(styleName, styles[styleName]);
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName]);
      if (styleName === 'float') {
        styleName = styleFloatAccessor;
      }
      if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }

};

ReactPerf.measureMethods(CSSPropertyOperations, 'CSSPropertyOperations', {
  setValueForStyles: 'setValueForStyles'
});

module.exports = CSSPropertyOperations;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule camelizeStyleName
 * @typechecks
 */



var camelize = __webpack_require__(330);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule camelize
 * @typechecks
 */



var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule dangerousStyleValue
 * @typechecks static-only
 */



var CSSProperty = __webpack_require__(180);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule hyphenateStyleName
 * @typechecks
 */



var hyphenate = __webpack_require__(333);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule hyphenate
 * @typechecks
 */



var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule memoizeStringOnly
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 *
 * @param {function} callback
 * @return {function}
 */
function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMButton
 */



var mouseListenerNames = {
  onClick: true,
  onDoubleClick: true,
  onMouseDown: true,
  onMouseMove: true,
  onMouseUp: true,

  onClickCapture: true,
  onDoubleClickCapture: true,
  onMouseDownCapture: true,
  onMouseMoveCapture: true,
  onMouseUpCapture: true
};

/**
 * Implements a <button> native component that does not receive mouse events
 * when `disabled` is set.
 */
var ReactDOMButton = {
  getNativeProps: function (inst, props, context) {
    if (!props.disabled) {
      return props;
    }

    // Copy the props, except the mouse listeners
    var nativeProps = {};
    for (var key in props) {
      if (props.hasOwnProperty(key) && !mouseListenerNames[key]) {
        nativeProps[key] = props[key];
      }
    }

    return nativeProps;
  }
};

module.exports = ReactDOMButton;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMInput
 */



var ReactDOMIDOperations = __webpack_require__(111);
var LinkedValueUtils = __webpack_require__(122);
var ReactMount = __webpack_require__(16);
var ReactUpdates = __webpack_require__(20);

var assign = __webpack_require__(8);
var invariant = __webpack_require__(2);

var instancesByReactID = {};

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

/**
 * Implements an <input> native component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getNativeProps: function (inst, props, context) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var nativeProps = assign({}, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return nativeProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.defaultChecked || false,
      initialValue: defaultValue != null ? defaultValue : null,
      onChange: _handleChange.bind(inst)
    };
  },

  mountReadyWrapper: function (inst) {
    // Can't be in mountWrapper or else server rendering leaks.
    instancesByReactID[inst._rootNodeID] = inst;
  },

  unmountWrapper: function (inst) {
    delete instancesByReactID[inst._rootNodeID];
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'checked', checked || false);
    }

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactMount.getNode(this._rootNodeID);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React with non-React.
      var otherID = ReactMount.getID(otherNode);
      !otherID ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the ' + 'same `name` is not supported.') : invariant(false) : undefined;
      var otherInstance = instancesByReactID[otherID];
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Unknown radio button ID %s.', otherID) : invariant(false) : undefined;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMOption
 */



var ReactChildren = __webpack_require__(182);
var ReactDOMSelect = __webpack_require__(183);

var assign = __webpack_require__(8);
var warning = __webpack_require__(7);

var valueContextKey = ReactDOMSelect.valueContextKey;

/**
 * Implements an <option> native component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, context) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : undefined;
    }

    // Look up whether this option is 'selected' via context
    var selectValue = context[valueContextKey];

    // If context key is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === '' + props.value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === '' + props.value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  getNativeProps: function (inst, props, context) {
    var nativeProps = assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      nativeProps.selected = inst._wrapperState.selected;
    }

    var content = '';

    // Flatten children and warn if they aren't strings or numbers;
    // invalid types are ignored.
    ReactChildren.forEach(props.children, function (child) {
      if (child == null) {
        return;
      }
      if (typeof child === 'string' || typeof child === 'number') {
        content += child;
      } else {
         false ? warning(false, 'Only strings and numbers are supported as <option> children.') : undefined;
      }
    });

    if (content) {
      nativeProps.children = content;
    }

    return nativeProps;
  }

};

module.exports = ReactDOMOption;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMTextarea
 */



var LinkedValueUtils = __webpack_require__(122);
var ReactDOMIDOperations = __webpack_require__(111);
var ReactUpdates = __webpack_require__(20);

var assign = __webpack_require__(8);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(7);

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> native component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getNativeProps: function (inst, props, context) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : invariant(false) : undefined;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.
    var nativeProps = assign({}, props, {
      defaultValue: undefined,
      value: undefined,
      children: inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return nativeProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
    }

    var defaultValue = props.defaultValue;
    // TODO (yungsters): Remove support for children content in <textarea>.
    var children = props.children;
    if (children != null) {
      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : undefined;
      }
      !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : invariant(false) : undefined;
      if (Array.isArray(children)) {
        !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : invariant(false) : undefined;
        children = children[0];
      }

      defaultValue = '' + children;
    }
    if (defaultValue == null) {
      defaultValue = '';
    }
    var value = LinkedValueUtils.getValue(props);

    inst._wrapperState = {
      // We save the initial value so that `ReactDOMComponent` doesn't update
      // `textContent` (unnecessary since we update value).
      // The initial value can be a boolean or object so that's why it's
      // forced to be a string.
      initialValue: '' + (value != null ? value : defaultValue),
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactMultiChild
 * @typechecks static-only
 */



var ReactComponentEnvironment = __webpack_require__(116);
var ReactMultiChildUpdateTypes = __webpack_require__(162);

var ReactCurrentOwner = __webpack_require__(25);
var ReactReconciler = __webpack_require__(39);
var ReactChildReconciler = __webpack_require__(340);

var flattenChildren = __webpack_require__(341);

/**
 * Updating children of a component may trigger recursive updates. The depth is
 * used to batch recursive updates to render markup more efficiently.
 *
 * @type {number}
 * @private
 */
var updateDepth = 0;

/**
 * Queue of update configuration objects.
 *
 * Each object has a `type` property that is in `ReactMultiChildUpdateTypes`.
 *
 * @type {array<object>}
 * @private
 */
var updateQueue = [];

/**
 * Queue of markup to be rendered.
 *
 * @type {array<string>}
 * @private
 */
var markupQueue = [];

/**
 * Enqueues markup to be rendered and inserted at a supplied index.
 *
 * @param {string} parentID ID of the parent component.
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function enqueueInsertMarkup(parentID, markup, toIndex) {
  // NOTE: Null values reduce hidden classes.
  updateQueue.push({
    parentID: parentID,
    parentNode: null,
    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
    markupIndex: markupQueue.push(markup) - 1,
    content: null,
    fromIndex: null,
    toIndex: toIndex
  });
}

/**
 * Enqueues moving an existing element to another index.
 *
 * @param {string} parentID ID of the parent component.
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function enqueueMove(parentID, fromIndex, toIndex) {
  // NOTE: Null values reduce hidden classes.
  updateQueue.push({
    parentID: parentID,
    parentNode: null,
    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
    markupIndex: null,
    content: null,
    fromIndex: fromIndex,
    toIndex: toIndex
  });
}

/**
 * Enqueues removing an element at an index.
 *
 * @param {string} parentID ID of the parent component.
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function enqueueRemove(parentID, fromIndex) {
  // NOTE: Null values reduce hidden classes.
  updateQueue.push({
    parentID: parentID,
    parentNode: null,
    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
    markupIndex: null,
    content: null,
    fromIndex: fromIndex,
    toIndex: null
  });
}

/**
 * Enqueues setting the markup of a node.
 *
 * @param {string} parentID ID of the parent component.
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function enqueueSetMarkup(parentID, markup) {
  // NOTE: Null values reduce hidden classes.
  updateQueue.push({
    parentID: parentID,
    parentNode: null,
    type: ReactMultiChildUpdateTypes.SET_MARKUP,
    markupIndex: null,
    content: markup,
    fromIndex: null,
    toIndex: null
  });
}

/**
 * Enqueues setting the text content.
 *
 * @param {string} parentID ID of the parent component.
 * @param {string} textContent Text content to set.
 * @private
 */
function enqueueTextContent(parentID, textContent) {
  // NOTE: Null values reduce hidden classes.
  updateQueue.push({
    parentID: parentID,
    parentNode: null,
    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
    markupIndex: null,
    content: textContent,
    fromIndex: null,
    toIndex: null
  });
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue() {
  if (updateQueue.length) {
    ReactComponentEnvironment.processChildrenUpdates(updateQueue, markupQueue);
    clearQueue();
  }
}

/**
 * Clears any enqueued updates.
 *
 * @private
 */
function clearQueue() {
  updateQueue.length = 0;
  markupQueue.length = 0;
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {

  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {

    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, transaction, context) {
      var nextChildren;
      if (false) {
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements);
          } finally {
            ReactCurrentOwner.current = null;
          }
          return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements);
      return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;
      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          // Inlined for performance, see `ReactInstanceHandles.createReactID`.
          var rootID = this._rootNodeID + name;
          var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }
      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      updateDepth++;
      var errorThrown = true;
      try {
        var prevChildren = this._renderedChildren;
        // Remove any rendered children.
        ReactChildReconciler.unmountChildren(prevChildren);
        // TODO: The setTextContent operation should be enough
        for (var name in prevChildren) {
          if (prevChildren.hasOwnProperty(name)) {
            this._unmountChild(prevChildren[name]);
          }
        }
        // Set new text content.
        this.setTextContent(nextContent);
        errorThrown = false;
      } finally {
        updateDepth--;
        if (!updateDepth) {
          if (errorThrown) {
            clearQueue();
          } else {
            processQueue();
          }
        }
      }
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      updateDepth++;
      var errorThrown = true;
      try {
        var prevChildren = this._renderedChildren;
        // Remove any rendered children.
        ReactChildReconciler.unmountChildren(prevChildren);
        for (var name in prevChildren) {
          if (prevChildren.hasOwnProperty(name)) {
            this._unmountChildByName(prevChildren[name], name);
          }
        }
        this.setMarkup(nextMarkup);
        errorThrown = false;
      } finally {
        updateDepth--;
        if (!updateDepth) {
          if (errorThrown) {
            clearQueue();
          } else {
            processQueue();
          }
        }
      }
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      updateDepth++;
      var errorThrown = true;
      try {
        this._updateChildren(nextNestedChildrenElements, transaction, context);
        errorThrown = false;
      } finally {
        updateDepth--;
        if (!updateDepth) {
          if (errorThrown) {
            clearQueue();
          } else {
            processQueue();
          }
        }
      }
    },

    /**
     * Improve performance by isolating this hot code path from the try/catch
     * block in `updateChildren`.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, transaction, context);
      this._renderedChildren = nextChildren;
      if (!nextChildren && !prevChildren) {
        return;
      }
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var lastIndex = 0;
      var nextIndex = 0;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          this.moveChild(prevChild, nextIndex, lastIndex);
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            this._unmountChild(prevChild);
          }
          // The child must be instantiated before it's mounted.
          this._mountChildByNameAtIndex(nextChild, name, nextIndex, transaction, context);
        }
        nextIndex++;
      }
      // Remove children that are no longer present.
      for (name in prevChildren) {
        if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
          this._unmountChild(prevChildren[name]);
        }
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted.
     *
     * @internal
     */
    unmountChildren: function () {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        enqueueMove(this._rootNodeID, child._mountIndex, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, mountImage) {
      enqueueInsertMarkup(this._rootNodeID, mountImage, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child) {
      enqueueRemove(this._rootNodeID, child._mountIndex);
    },

    /**
     * Sets this text content string.
     *
     * @param {string} textContent Text content to set.
     * @protected
     */
    setTextContent: function (textContent) {
      enqueueTextContent(this._rootNodeID, textContent);
    },

    /**
     * Sets this markup string.
     *
     * @param {string} markup Markup to set.
     * @protected
     */
    setMarkup: function (markup) {
      enqueueSetMarkup(this._rootNodeID, markup);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildByNameAtIndex: function (child, name, index, transaction, context) {
      // Inlined for performance, see `ReactInstanceHandles.createReactID`.
      var rootID = this._rootNodeID + name;
      var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
      child._mountIndex = index;
      this.createChild(child, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child) {
      this.removeChild(child);
      child._mountIndex = null;
    }

  }

};

module.exports = ReactMultiChild;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactChildReconciler
 * @typechecks static-only
 */



var ReactReconciler = __webpack_require__(39);

var instantiateReactComponent = __webpack_require__(115);
var shouldUpdateReactComponent = __webpack_require__(117);
var traverseAllChildren = __webpack_require__(124);
var warning = __webpack_require__(7);

function instantiateChild(childInstances, child, name) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, null);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context) {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};
    traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, transaction, context) {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return null;
    }
    var name;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      var prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          ReactReconciler.unmountComponent(prevChild, name);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, null);
        nextChildren[name] = nextChildInstance;
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        ReactReconciler.unmountComponent(prevChildren[name]);
      }
    }
    return nextChildren;
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild);
      }
    }
  }

};

module.exports = ReactChildReconciler;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule flattenChildren
 */



var traverseAllChildren = __webpack_require__(124);
var warning = __webpack_require__(7);

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 */
function flattenSingleChildIntoContext(traverseContext, child, name) {
  // We found a component instance.
  var result = traverseContext;
  var keyUnique = result[name] === undefined;
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
  }
  if (keyUnique && child != null) {
    result[name] = child;
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children) {
  if (children == null) {
    return children;
  }
  var result = {};
  traverseAllChildren(children, flattenSingleChildIntoContext, result);
  return result;
}

module.exports = flattenChildren;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactEventListener
 * @typechecks static-only
 */



var EventListener = __webpack_require__(185);
var ExecutionEnvironment = __webpack_require__(14);
var PooledClass = __webpack_require__(31);
var ReactInstanceHandles = __webpack_require__(48);
var ReactMount = __webpack_require__(16);
var ReactUpdates = __webpack_require__(20);

var assign = __webpack_require__(8);
var getEventTarget = __webpack_require__(119);
var getUnboundedScrollPosition = __webpack_require__(343);

var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * Finds the parent React component of `node`.
 *
 * @param {*} node
 * @return {?DOMEventTarget} Parent container, or `null` if the specified node
 *                           is not nested.
 */
function findParent(node) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  var nodeID = ReactMount.getID(node);
  var rootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
  var container = ReactMount.findReactContainerForID(rootID);
  var parent = ReactMount.getFirstReactDOM(container);
  return parent;
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  // TODO: Re-enable event.path handling
  //
  // if (bookKeeping.nativeEvent.path && bookKeeping.nativeEvent.path.length > 1) {
  //   // New browsers have a path attribute on native events
  //   handleTopLevelWithPath(bookKeeping);
  // } else {
  //   // Legacy browsers don't have a path attribute on native events
  //   handleTopLevelWithoutPath(bookKeeping);
  // }

  void handleTopLevelWithPath; // temporarily unused
  handleTopLevelWithoutPath(bookKeeping);
}

// Legacy browsers don't have a path attribute on native events
function handleTopLevelWithoutPath(bookKeeping) {
  var topLevelTarget = ReactMount.getFirstReactDOM(getEventTarget(bookKeeping.nativeEvent)) || window;

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = topLevelTarget;
  while (ancestor) {
    bookKeeping.ancestors.push(ancestor);
    ancestor = findParent(ancestor);
  }

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    topLevelTarget = bookKeeping.ancestors[i];
    var topLevelTargetID = ReactMount.getID(topLevelTarget) || '';
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, topLevelTarget, topLevelTargetID, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

// New browsers have a path attribute on native events
function handleTopLevelWithPath(bookKeeping) {
  var path = bookKeeping.nativeEvent.path;
  var currentNativeTarget = path[0];
  var eventsFired = 0;
  for (var i = 0; i < path.length; i++) {
    var currentPathElement = path[i];
    if (currentPathElement.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE) {
      currentNativeTarget = path[i + 1];
    }
    // TODO: slow
    var reactParent = ReactMount.getFirstReactDOM(currentPathElement);
    if (reactParent === currentPathElement) {
      var currentPathElementID = ReactMount.getID(currentPathElement);
      var newRootID = ReactInstanceHandles.getReactRootIDFromNodeID(currentPathElementID);
      bookKeeping.ancestors.push(currentPathElement);

      var topLevelTargetID = ReactMount.getID(currentPathElement) || '';
      eventsFired++;
      ReactEventListener._handleTopLevel(bookKeeping.topLevelType, currentPathElement, topLevelTargetID, bookKeeping.nativeEvent, currentNativeTarget);

      // Jump to the root of this React render tree
      while (currentPathElementID !== newRootID) {
        i++;
        currentPathElement = path[i];
        currentPathElementID = ReactMount.getID(currentPathElement);
      }
    }
  }
  if (eventsFired === 0) {
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, window, '', bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} handle Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    var element = handle;
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} handle Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    var element = handle;
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getUnboundedScrollPosition
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */
function getUnboundedScrollPosition(scrollable) {
  if (scrollable === window) {
    return {
      x: window.pageXOffset || document.documentElement.scrollLeft,
      y: window.pageYOffset || document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInjection
 */



var DOMProperty = __webpack_require__(47);
var EventPluginHub = __webpack_require__(60);
var ReactComponentEnvironment = __webpack_require__(116);
var ReactClass = __webpack_require__(186);
var ReactEmptyComponent = __webpack_require__(173);
var ReactBrowserEventEmitter = __webpack_require__(79);
var ReactNativeComponent = __webpack_require__(174);
var ReactPerf = __webpack_require__(19);
var ReactRootIndex = __webpack_require__(170);
var ReactUpdates = __webpack_require__(20);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  Class: ReactClass.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  NativeComponent: ReactNativeComponent.injection,
  Perf: ReactPerf.injection,
  RootIndex: ReactRootIndex.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactReconcileTransaction
 * @typechecks static-only
 */



var CallbackQueue = __webpack_require__(114);
var PooledClass = __webpack_require__(31);
var ReactBrowserEventEmitter = __webpack_require__(79);
var ReactDOMFeatureFlags = __webpack_require__(168);
var ReactInputSelection = __webpack_require__(189);
var Transaction = __webpack_require__(81);

var assign = __webpack_require__(8);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(forceHTML) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = !forceHTML && ReactDOMFeatureFlags.useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMSelection
 */



var ExecutionEnvironment = __webpack_require__(14);

var getNodeForCharacterOffset = __webpack_require__(347);
var getTextContentAccessor = __webpack_require__(176);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (typeof offsets.end === 'undefined') {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = typeof offsets.end === 'undefined' ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getNodeForCharacterOffset
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */
function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SelectEventPlugin
 */



var EventConstants = __webpack_require__(26);
var EventPropagators = __webpack_require__(63);
var ExecutionEnvironment = __webpack_require__(14);
var ReactInputSelection = __webpack_require__(189);
var SyntheticEvent = __webpack_require__(40);

var getActiveElement = __webpack_require__(190);
var isTextInputElement = __webpack_require__(177);
var keyOf = __webpack_require__(32);
var shallowEqual = __webpack_require__(184);

var topLevelTypes = EventConstants.topLevelTypes;

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSelect: null }),
      captured: keyOf({ onSelectCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
  }
};

var activeElement = null;
var activeElementID = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events.
var hasListener = false;
var ON_SELECT_KEY = keyOf({ onSelect: null });

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementID, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {

  eventTypes: eventTypes,

  /**
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {DOMEventTarget} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native browser event.
   * @return {*} An accumulation of synthetic events.
   * @see {EventPluginHub.extractEvents}
   */
  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    switch (topLevelType) {
      // Track the input node that has focus.
      case topLevelTypes.topFocus:
        if (isTextInputElement(topLevelTarget) || topLevelTarget.contentEditable === 'true') {
          activeElement = topLevelTarget;
          activeElementID = topLevelTargetID;
          lastSelection = null;
        }
        break;
      case topLevelTypes.topBlur:
        activeElement = null;
        activeElementID = null;
        lastSelection = null;
        break;

      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case topLevelTypes.topMouseDown:
        mouseDown = true;
        break;
      case topLevelTypes.topContextMenu:
      case topLevelTypes.topMouseUp:
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);

      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case topLevelTypes.topSelectionChange:
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case topLevelTypes.topKeyDown:
      case topLevelTypes.topKeyUp:
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (id, registrationName, listener) {
    if (registrationName === ON_SELECT_KEY) {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ServerReactRootIndex
 * @typechecks
 */



/**
 * Size of the reactRoot ID space. We generate random numbers for React root
 * IDs and if there's a collision the events and DOM update system will
 * get confused. In the future we need a way to generate GUIDs but for
 * now this will work on a smaller scale.
 */
var GLOBAL_MOUNT_POINT_MAX = Math.pow(2, 53);

var ServerReactRootIndex = {
  createReactRootIndex: function () {
    return Math.ceil(Math.random() * GLOBAL_MOUNT_POINT_MAX);
  }
};

module.exports = ServerReactRootIndex;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SimpleEventPlugin
 */



var EventConstants = __webpack_require__(26);
var EventListener = __webpack_require__(185);
var EventPropagators = __webpack_require__(63);
var ReactMount = __webpack_require__(16);
var SyntheticClipboardEvent = __webpack_require__(351);
var SyntheticEvent = __webpack_require__(40);
var SyntheticFocusEvent = __webpack_require__(352);
var SyntheticKeyboardEvent = __webpack_require__(353);
var SyntheticMouseEvent = __webpack_require__(84);
var SyntheticDragEvent = __webpack_require__(355);
var SyntheticTouchEvent = __webpack_require__(356);
var SyntheticUIEvent = __webpack_require__(64);
var SyntheticWheelEvent = __webpack_require__(357);

var emptyFunction = __webpack_require__(21);
var getEventCharCode = __webpack_require__(125);
var invariant = __webpack_require__(2);
var keyOf = __webpack_require__(32);

var topLevelTypes = EventConstants.topLevelTypes;

var eventTypes = {
  abort: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onAbort: true }),
      captured: keyOf({ onAbortCapture: true })
    }
  },
  blur: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onBlur: true }),
      captured: keyOf({ onBlurCapture: true })
    }
  },
  canPlay: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCanPlay: true }),
      captured: keyOf({ onCanPlayCapture: true })
    }
  },
  canPlayThrough: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCanPlayThrough: true }),
      captured: keyOf({ onCanPlayThroughCapture: true })
    }
  },
  click: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onClick: true }),
      captured: keyOf({ onClickCapture: true })
    }
  },
  contextMenu: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onContextMenu: true }),
      captured: keyOf({ onContextMenuCapture: true })
    }
  },
  copy: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCopy: true }),
      captured: keyOf({ onCopyCapture: true })
    }
  },
  cut: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCut: true }),
      captured: keyOf({ onCutCapture: true })
    }
  },
  doubleClick: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDoubleClick: true }),
      captured: keyOf({ onDoubleClickCapture: true })
    }
  },
  drag: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDrag: true }),
      captured: keyOf({ onDragCapture: true })
    }
  },
  dragEnd: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragEnd: true }),
      captured: keyOf({ onDragEndCapture: true })
    }
  },
  dragEnter: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragEnter: true }),
      captured: keyOf({ onDragEnterCapture: true })
    }
  },
  dragExit: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragExit: true }),
      captured: keyOf({ onDragExitCapture: true })
    }
  },
  dragLeave: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragLeave: true }),
      captured: keyOf({ onDragLeaveCapture: true })
    }
  },
  dragOver: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragOver: true }),
      captured: keyOf({ onDragOverCapture: true })
    }
  },
  dragStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragStart: true }),
      captured: keyOf({ onDragStartCapture: true })
    }
  },
  drop: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDrop: true }),
      captured: keyOf({ onDropCapture: true })
    }
  },
  durationChange: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDurationChange: true }),
      captured: keyOf({ onDurationChangeCapture: true })
    }
  },
  emptied: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onEmptied: true }),
      captured: keyOf({ onEmptiedCapture: true })
    }
  },
  encrypted: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onEncrypted: true }),
      captured: keyOf({ onEncryptedCapture: true })
    }
  },
  ended: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onEnded: true }),
      captured: keyOf({ onEndedCapture: true })
    }
  },
  error: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onError: true }),
      captured: keyOf({ onErrorCapture: true })
    }
  },
  focus: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onFocus: true }),
      captured: keyOf({ onFocusCapture: true })
    }
  },
  input: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onInput: true }),
      captured: keyOf({ onInputCapture: true })
    }
  },
  keyDown: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onKeyDown: true }),
      captured: keyOf({ onKeyDownCapture: true })
    }
  },
  keyPress: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onKeyPress: true }),
      captured: keyOf({ onKeyPressCapture: true })
    }
  },
  keyUp: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onKeyUp: true }),
      captured: keyOf({ onKeyUpCapture: true })
    }
  },
  load: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onLoad: true }),
      captured: keyOf({ onLoadCapture: true })
    }
  },
  loadedData: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onLoadedData: true }),
      captured: keyOf({ onLoadedDataCapture: true })
    }
  },
  loadedMetadata: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onLoadedMetadata: true }),
      captured: keyOf({ onLoadedMetadataCapture: true })
    }
  },
  loadStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onLoadStart: true }),
      captured: keyOf({ onLoadStartCapture: true })
    }
  },
  // Note: We do not allow listening to mouseOver events. Instead, use the
  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
  mouseDown: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseDown: true }),
      captured: keyOf({ onMouseDownCapture: true })
    }
  },
  mouseMove: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseMove: true }),
      captured: keyOf({ onMouseMoveCapture: true })
    }
  },
  mouseOut: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseOut: true }),
      captured: keyOf({ onMouseOutCapture: true })
    }
  },
  mouseOver: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseOver: true }),
      captured: keyOf({ onMouseOverCapture: true })
    }
  },
  mouseUp: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseUp: true }),
      captured: keyOf({ onMouseUpCapture: true })
    }
  },
  paste: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onPaste: true }),
      captured: keyOf({ onPasteCapture: true })
    }
  },
  pause: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onPause: true }),
      captured: keyOf({ onPauseCapture: true })
    }
  },
  play: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onPlay: true }),
      captured: keyOf({ onPlayCapture: true })
    }
  },
  playing: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onPlaying: true }),
      captured: keyOf({ onPlayingCapture: true })
    }
  },
  progress: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onProgress: true }),
      captured: keyOf({ onProgressCapture: true })
    }
  },
  rateChange: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onRateChange: true }),
      captured: keyOf({ onRateChangeCapture: true })
    }
  },
  reset: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onReset: true }),
      captured: keyOf({ onResetCapture: true })
    }
  },
  scroll: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onScroll: true }),
      captured: keyOf({ onScrollCapture: true })
    }
  },
  seeked: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSeeked: true }),
      captured: keyOf({ onSeekedCapture: true })
    }
  },
  seeking: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSeeking: true }),
      captured: keyOf({ onSeekingCapture: true })
    }
  },
  stalled: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onStalled: true }),
      captured: keyOf({ onStalledCapture: true })
    }
  },
  submit: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSubmit: true }),
      captured: keyOf({ onSubmitCapture: true })
    }
  },
  suspend: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSuspend: true }),
      captured: keyOf({ onSuspendCapture: true })
    }
  },
  timeUpdate: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTimeUpdate: true }),
      captured: keyOf({ onTimeUpdateCapture: true })
    }
  },
  touchCancel: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTouchCancel: true }),
      captured: keyOf({ onTouchCancelCapture: true })
    }
  },
  touchEnd: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTouchEnd: true }),
      captured: keyOf({ onTouchEndCapture: true })
    }
  },
  touchMove: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTouchMove: true }),
      captured: keyOf({ onTouchMoveCapture: true })
    }
  },
  touchStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTouchStart: true }),
      captured: keyOf({ onTouchStartCapture: true })
    }
  },
  volumeChange: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onVolumeChange: true }),
      captured: keyOf({ onVolumeChangeCapture: true })
    }
  },
  waiting: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onWaiting: true }),
      captured: keyOf({ onWaitingCapture: true })
    }
  },
  wheel: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onWheel: true }),
      captured: keyOf({ onWheelCapture: true })
    }
  }
};

var topLevelEventsToDispatchConfig = {
  topAbort: eventTypes.abort,
  topBlur: eventTypes.blur,
  topCanPlay: eventTypes.canPlay,
  topCanPlayThrough: eventTypes.canPlayThrough,
  topClick: eventTypes.click,
  topContextMenu: eventTypes.contextMenu,
  topCopy: eventTypes.copy,
  topCut: eventTypes.cut,
  topDoubleClick: eventTypes.doubleClick,
  topDrag: eventTypes.drag,
  topDragEnd: eventTypes.dragEnd,
  topDragEnter: eventTypes.dragEnter,
  topDragExit: eventTypes.dragExit,
  topDragLeave: eventTypes.dragLeave,
  topDragOver: eventTypes.dragOver,
  topDragStart: eventTypes.dragStart,
  topDrop: eventTypes.drop,
  topDurationChange: eventTypes.durationChange,
  topEmptied: eventTypes.emptied,
  topEncrypted: eventTypes.encrypted,
  topEnded: eventTypes.ended,
  topError: eventTypes.error,
  topFocus: eventTypes.focus,
  topInput: eventTypes.input,
  topKeyDown: eventTypes.keyDown,
  topKeyPress: eventTypes.keyPress,
  topKeyUp: eventTypes.keyUp,
  topLoad: eventTypes.load,
  topLoadedData: eventTypes.loadedData,
  topLoadedMetadata: eventTypes.loadedMetadata,
  topLoadStart: eventTypes.loadStart,
  topMouseDown: eventTypes.mouseDown,
  topMouseMove: eventTypes.mouseMove,
  topMouseOut: eventTypes.mouseOut,
  topMouseOver: eventTypes.mouseOver,
  topMouseUp: eventTypes.mouseUp,
  topPaste: eventTypes.paste,
  topPause: eventTypes.pause,
  topPlay: eventTypes.play,
  topPlaying: eventTypes.playing,
  topProgress: eventTypes.progress,
  topRateChange: eventTypes.rateChange,
  topReset: eventTypes.reset,
  topScroll: eventTypes.scroll,
  topSeeked: eventTypes.seeked,
  topSeeking: eventTypes.seeking,
  topStalled: eventTypes.stalled,
  topSubmit: eventTypes.submit,
  topSuspend: eventTypes.suspend,
  topTimeUpdate: eventTypes.timeUpdate,
  topTouchCancel: eventTypes.touchCancel,
  topTouchEnd: eventTypes.touchEnd,
  topTouchMove: eventTypes.touchMove,
  topTouchStart: eventTypes.touchStart,
  topVolumeChange: eventTypes.volumeChange,
  topWaiting: eventTypes.waiting,
  topWheel: eventTypes.wheel
};

for (var type in topLevelEventsToDispatchConfig) {
  topLevelEventsToDispatchConfig[type].dependencies = [type];
}

var ON_CLICK_KEY = keyOf({ onClick: null });
var onClickListeners = {};

var SimpleEventPlugin = {

  eventTypes: eventTypes,

  /**
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {DOMEventTarget} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native browser event.
   * @return {*} An accumulation of synthetic events.
   * @see {EventPluginHub.extractEvents}
   */
  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case topLevelTypes.topAbort:
      case topLevelTypes.topCanPlay:
      case topLevelTypes.topCanPlayThrough:
      case topLevelTypes.topDurationChange:
      case topLevelTypes.topEmptied:
      case topLevelTypes.topEncrypted:
      case topLevelTypes.topEnded:
      case topLevelTypes.topError:
      case topLevelTypes.topInput:
      case topLevelTypes.topLoad:
      case topLevelTypes.topLoadedData:
      case topLevelTypes.topLoadedMetadata:
      case topLevelTypes.topLoadStart:
      case topLevelTypes.topPause:
      case topLevelTypes.topPlay:
      case topLevelTypes.topPlaying:
      case topLevelTypes.topProgress:
      case topLevelTypes.topRateChange:
      case topLevelTypes.topReset:
      case topLevelTypes.topSeeked:
      case topLevelTypes.topSeeking:
      case topLevelTypes.topStalled:
      case topLevelTypes.topSubmit:
      case topLevelTypes.topSuspend:
      case topLevelTypes.topTimeUpdate:
      case topLevelTypes.topVolumeChange:
      case topLevelTypes.topWaiting:
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case topLevelTypes.topKeyPress:
        // FireFox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case topLevelTypes.topKeyDown:
      case topLevelTypes.topKeyUp:
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case topLevelTypes.topBlur:
      case topLevelTypes.topFocus:
        EventConstructor = SyntheticFocusEvent;
        break;
      case topLevelTypes.topClick:
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case topLevelTypes.topContextMenu:
      case topLevelTypes.topDoubleClick:
      case topLevelTypes.topMouseDown:
      case topLevelTypes.topMouseMove:
      case topLevelTypes.topMouseOut:
      case topLevelTypes.topMouseOver:
      case topLevelTypes.topMouseUp:
        EventConstructor = SyntheticMouseEvent;
        break;
      case topLevelTypes.topDrag:
      case topLevelTypes.topDragEnd:
      case topLevelTypes.topDragEnter:
      case topLevelTypes.topDragExit:
      case topLevelTypes.topDragLeave:
      case topLevelTypes.topDragOver:
      case topLevelTypes.topDragStart:
      case topLevelTypes.topDrop:
        EventConstructor = SyntheticDragEvent;
        break;
      case topLevelTypes.topTouchCancel:
      case topLevelTypes.topTouchEnd:
      case topLevelTypes.topTouchMove:
      case topLevelTypes.topTouchStart:
        EventConstructor = SyntheticTouchEvent;
        break;
      case topLevelTypes.topScroll:
        EventConstructor = SyntheticUIEvent;
        break;
      case topLevelTypes.topWheel:
        EventConstructor = SyntheticWheelEvent;
        break;
      case topLevelTypes.topCopy:
      case topLevelTypes.topCut:
      case topLevelTypes.topPaste:
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : invariant(false) : undefined;
    var event = EventConstructor.getPooled(dispatchConfig, topLevelTargetID, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (id, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    if (registrationName === ON_CLICK_KEY) {
      var node = ReactMount.getNode(id);
      if (!onClickListeners[id]) {
        onClickListeners[id] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (id, registrationName) {
    if (registrationName === ON_CLICK_KEY) {
      onClickListeners[id].remove();
      delete onClickListeners[id];
    }
  }

};

module.exports = SimpleEventPlugin;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticClipboardEvent
 * @typechecks static-only
 */



var SyntheticEvent = __webpack_require__(40);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticFocusEvent
 * @typechecks static-only
 */



var SyntheticUIEvent = __webpack_require__(64);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticKeyboardEvent
 * @typechecks static-only
 */



var SyntheticUIEvent = __webpack_require__(64);

var getEventCharCode = __webpack_require__(125);
var getEventKey = __webpack_require__(354);
var getEventModifierState = __webpack_require__(120);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEventKey
 * @typechecks static-only
 */



var getEventCharCode = __webpack_require__(125);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  'Esc': 'Escape',
  'Spacebar': ' ',
  'Left': 'ArrowLeft',
  'Up': 'ArrowUp',
  'Right': 'ArrowRight',
  'Down': 'ArrowDown',
  'Del': 'Delete',
  'Win': 'OS',
  'Menu': 'ContextMenu',
  'Apps': 'ContextMenu',
  'Scroll': 'ScrollLock',
  'MozPrintableKey': 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticDragEvent
 * @typechecks static-only
 */



var SyntheticMouseEvent = __webpack_require__(84);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticTouchEvent
 * @typechecks static-only
 */



var SyntheticUIEvent = __webpack_require__(64);

var getEventModifierState = __webpack_require__(120);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticWheelEvent
 * @typechecks static-only
 */



var SyntheticMouseEvent = __webpack_require__(84);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX :
    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY :
    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY :
    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SVGDOMPropertyConfig
 */



var DOMProperty = __webpack_require__(47);

var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;

var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

var SVGDOMPropertyConfig = {
  Properties: {
    clipPath: MUST_USE_ATTRIBUTE,
    cx: MUST_USE_ATTRIBUTE,
    cy: MUST_USE_ATTRIBUTE,
    d: MUST_USE_ATTRIBUTE,
    dx: MUST_USE_ATTRIBUTE,
    dy: MUST_USE_ATTRIBUTE,
    fill: MUST_USE_ATTRIBUTE,
    fillOpacity: MUST_USE_ATTRIBUTE,
    fontFamily: MUST_USE_ATTRIBUTE,
    fontSize: MUST_USE_ATTRIBUTE,
    fx: MUST_USE_ATTRIBUTE,
    fy: MUST_USE_ATTRIBUTE,
    gradientTransform: MUST_USE_ATTRIBUTE,
    gradientUnits: MUST_USE_ATTRIBUTE,
    markerEnd: MUST_USE_ATTRIBUTE,
    markerMid: MUST_USE_ATTRIBUTE,
    markerStart: MUST_USE_ATTRIBUTE,
    offset: MUST_USE_ATTRIBUTE,
    opacity: MUST_USE_ATTRIBUTE,
    patternContentUnits: MUST_USE_ATTRIBUTE,
    patternUnits: MUST_USE_ATTRIBUTE,
    points: MUST_USE_ATTRIBUTE,
    preserveAspectRatio: MUST_USE_ATTRIBUTE,
    r: MUST_USE_ATTRIBUTE,
    rx: MUST_USE_ATTRIBUTE,
    ry: MUST_USE_ATTRIBUTE,
    spreadMethod: MUST_USE_ATTRIBUTE,
    stopColor: MUST_USE_ATTRIBUTE,
    stopOpacity: MUST_USE_ATTRIBUTE,
    stroke: MUST_USE_ATTRIBUTE,
    strokeDasharray: MUST_USE_ATTRIBUTE,
    strokeLinecap: MUST_USE_ATTRIBUTE,
    strokeOpacity: MUST_USE_ATTRIBUTE,
    strokeWidth: MUST_USE_ATTRIBUTE,
    textAnchor: MUST_USE_ATTRIBUTE,
    transform: MUST_USE_ATTRIBUTE,
    version: MUST_USE_ATTRIBUTE,
    viewBox: MUST_USE_ATTRIBUTE,
    x1: MUST_USE_ATTRIBUTE,
    x2: MUST_USE_ATTRIBUTE,
    x: MUST_USE_ATTRIBUTE,
    xlinkActuate: MUST_USE_ATTRIBUTE,
    xlinkArcrole: MUST_USE_ATTRIBUTE,
    xlinkHref: MUST_USE_ATTRIBUTE,
    xlinkRole: MUST_USE_ATTRIBUTE,
    xlinkShow: MUST_USE_ATTRIBUTE,
    xlinkTitle: MUST_USE_ATTRIBUTE,
    xlinkType: MUST_USE_ATTRIBUTE,
    xmlBase: MUST_USE_ATTRIBUTE,
    xmlLang: MUST_USE_ATTRIBUTE,
    xmlSpace: MUST_USE_ATTRIBUTE,
    y1: MUST_USE_ATTRIBUTE,
    y2: MUST_USE_ATTRIBUTE,
    y: MUST_USE_ATTRIBUTE
  },
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {
    clipPath: 'clip-path',
    fillOpacity: 'fill-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    gradientTransform: 'gradientTransform',
    gradientUnits: 'gradientUnits',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    patternContentUnits: 'patternContentUnits',
    patternUnits: 'patternUnits',
    preserveAspectRatio: 'preserveAspectRatio',
    spreadMethod: 'spreadMethod',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strokeDasharray: 'stroke-dasharray',
    strokeLinecap: 'stroke-linecap',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    textAnchor: 'text-anchor',
    viewBox: 'viewBox',
    xlinkActuate: 'xlink:actuate',
    xlinkArcrole: 'xlink:arcrole',
    xlinkHref: 'xlink:href',
    xlinkRole: 'xlink:role',
    xlinkShow: 'xlink:show',
    xlinkTitle: 'xlink:title',
    xlinkType: 'xlink:type',
    xmlBase: 'xml:base',
    xmlLang: 'xml:lang',
    xmlSpace: 'xml:space'
  }
};

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
* @providesModule renderSubtreeIntoContainer
*/



var ReactMount = __webpack_require__(16);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMServer
 */



var ReactDefaultInjection = __webpack_require__(175);
var ReactServerRendering = __webpack_require__(361);
var ReactVersion = __webpack_require__(126);

ReactDefaultInjection.inject();

var ReactDOMServer = {
  renderToString: ReactServerRendering.renderToString,
  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
  version: ReactVersion
};

module.exports = ReactDOMServer;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks static-only
 * @providesModule ReactServerRendering
 */


var ReactDefaultBatchingStrategy = __webpack_require__(178);
var ReactElement = __webpack_require__(18);
var ReactInstanceHandles = __webpack_require__(48);
var ReactMarkupChecksum = __webpack_require__(171);
var ReactServerBatchingStrategy = __webpack_require__(362);
var ReactServerRenderingTransaction = __webpack_require__(363);
var ReactUpdates = __webpack_require__(20);

var emptyObject = __webpack_require__(62);
var instantiateReactComponent = __webpack_require__(115);
var invariant = __webpack_require__(2);

/**
 * @param {ReactElement} element
 * @return {string} the HTML markup
 */
function renderToString(element) {
  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : invariant(false) : undefined;

  var transaction;
  try {
    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);

    var id = ReactInstanceHandles.createReactRootID();
    transaction = ReactServerRenderingTransaction.getPooled(false);

    return transaction.perform(function () {
      var componentInstance = instantiateReactComponent(element, null);
      var markup = componentInstance.mountComponent(id, transaction, emptyObject);
      return ReactMarkupChecksum.addChecksumToMarkup(markup);
    }, null);
  } finally {
    ReactServerRenderingTransaction.release(transaction);
    // Revert to the DOM batching strategy since these two renderers
    // currently share these stateful modules.
    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
  }
}

/**
 * @param {ReactElement} element
 * @return {string} the HTML markup, without the extra React ID and checksum
 * (for generating static pages)
 */
function renderToStaticMarkup(element) {
  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : invariant(false) : undefined;

  var transaction;
  try {
    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);

    var id = ReactInstanceHandles.createReactRootID();
    transaction = ReactServerRenderingTransaction.getPooled(true);

    return transaction.perform(function () {
      var componentInstance = instantiateReactComponent(element, null);
      return componentInstance.mountComponent(id, transaction, emptyObject);
    }, null);
  } finally {
    ReactServerRenderingTransaction.release(transaction);
    // Revert to the DOM batching strategy since these two renderers
    // currently share these stateful modules.
    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
  }
}

module.exports = {
  renderToString: renderToString,
  renderToStaticMarkup: renderToStaticMarkup
};

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactServerBatchingStrategy
 * @typechecks
 */



var ReactServerBatchingStrategy = {
  isBatchingUpdates: false,
  batchedUpdates: function (callback) {
    // Don't do anything here. During the server rendering we don't want to
    // schedule any updates. We will simply ignore them.
  }
};

module.exports = ReactServerBatchingStrategy;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactServerRenderingTransaction
 * @typechecks
 */



var PooledClass = __webpack_require__(31);
var CallbackQueue = __webpack_require__(114);
var Transaction = __webpack_require__(81);

var assign = __webpack_require__(8);
var emptyFunction = __webpack_require__(21);

/**
 * Provides a `CallbackQueue` queue for collecting `onDOMReady` callbacks
 * during the performing of the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  close: emptyFunction
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [ON_DOM_READY_QUEUEING];

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = false;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactIsomorphic
 */



var ReactChildren = __webpack_require__(182);
var ReactComponent = __webpack_require__(187);
var ReactClass = __webpack_require__(186);
var ReactDOMFactories = __webpack_require__(365);
var ReactElement = __webpack_require__(18);
var ReactElementValidator = __webpack_require__(191);
var ReactPropTypes = __webpack_require__(181);
var ReactVersion = __webpack_require__(126);

var assign = __webpack_require__(8);
var onlyChild = __webpack_require__(367);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var React = {

  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: ReactClass.createClass,
  createFactory: createFactory,
  createMixin: function (mixin) {
    // Currently a noop. Will be used to validate and trace mixins.
    return mixin;
  },

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Hook for JSX spread, don't use this for anything else.
  __spread: assign
};

module.exports = React;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMFactories
 * @typechecks static-only
 */



var ReactElement = __webpack_require__(18);
var ReactElementValidator = __webpack_require__(191);

var mapObject = __webpack_require__(366);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @param {string} tag Tag name (e.g. `div`).
 * @private
 */
function createDOMFactory(tag) {
  if (false) {
    return ReactElementValidator.createFactory(tag);
  }
  return ReactElement.createFactory(tag);
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 * This is also accessible via `React.DOM`.
 *
 * @public
 */
var ReactDOMFactories = mapObject({
  a: 'a',
  abbr: 'abbr',
  address: 'address',
  area: 'area',
  article: 'article',
  aside: 'aside',
  audio: 'audio',
  b: 'b',
  base: 'base',
  bdi: 'bdi',
  bdo: 'bdo',
  big: 'big',
  blockquote: 'blockquote',
  body: 'body',
  br: 'br',
  button: 'button',
  canvas: 'canvas',
  caption: 'caption',
  cite: 'cite',
  code: 'code',
  col: 'col',
  colgroup: 'colgroup',
  data: 'data',
  datalist: 'datalist',
  dd: 'dd',
  del: 'del',
  details: 'details',
  dfn: 'dfn',
  dialog: 'dialog',
  div: 'div',
  dl: 'dl',
  dt: 'dt',
  em: 'em',
  embed: 'embed',
  fieldset: 'fieldset',
  figcaption: 'figcaption',
  figure: 'figure',
  footer: 'footer',
  form: 'form',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  head: 'head',
  header: 'header',
  hgroup: 'hgroup',
  hr: 'hr',
  html: 'html',
  i: 'i',
  iframe: 'iframe',
  img: 'img',
  input: 'input',
  ins: 'ins',
  kbd: 'kbd',
  keygen: 'keygen',
  label: 'label',
  legend: 'legend',
  li: 'li',
  link: 'link',
  main: 'main',
  map: 'map',
  mark: 'mark',
  menu: 'menu',
  menuitem: 'menuitem',
  meta: 'meta',
  meter: 'meter',
  nav: 'nav',
  noscript: 'noscript',
  object: 'object',
  ol: 'ol',
  optgroup: 'optgroup',
  option: 'option',
  output: 'output',
  p: 'p',
  param: 'param',
  picture: 'picture',
  pre: 'pre',
  progress: 'progress',
  q: 'q',
  rp: 'rp',
  rt: 'rt',
  ruby: 'ruby',
  s: 's',
  samp: 'samp',
  script: 'script',
  section: 'section',
  select: 'select',
  small: 'small',
  source: 'source',
  span: 'span',
  strong: 'strong',
  style: 'style',
  sub: 'sub',
  summary: 'summary',
  sup: 'sup',
  table: 'table',
  tbody: 'tbody',
  td: 'td',
  textarea: 'textarea',
  tfoot: 'tfoot',
  th: 'th',
  thead: 'thead',
  time: 'time',
  title: 'title',
  tr: 'tr',
  track: 'track',
  u: 'u',
  ul: 'ul',
  'var': 'var',
  video: 'video',
  wbr: 'wbr',

  // SVG
  circle: 'circle',
  clipPath: 'clipPath',
  defs: 'defs',
  ellipse: 'ellipse',
  g: 'g',
  image: 'image',
  line: 'line',
  linearGradient: 'linearGradient',
  mask: 'mask',
  path: 'path',
  pattern: 'pattern',
  polygon: 'polygon',
  polyline: 'polyline',
  radialGradient: 'radialGradient',
  rect: 'rect',
  stop: 'stop',
  svg: 'svg',
  text: 'text',
  tspan: 'tspan'

}, createDOMFactory);

module.exports = ReactDOMFactories;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule mapObject
 */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Executes the provided `callback` once for each enumerable own property in the
 * object and constructs a new object from the results. The `callback` is
 * invoked with three arguments:
 *
 *  - the property value
 *  - the property name
 *  - the object being traversed
 *
 * Properties that are added after the call to `mapObject` will not be visited
 * by `callback`. If the values of existing properties are changed, the value
 * passed to `callback` will be the value at the time `mapObject` visits them.
 * Properties that are deleted before being visited are not visited.
 *
 * @grep function objectMap()
 * @grep function objMap()
 *
 * @param {?object} object
 * @param {function} callback
 * @param {*} context
 * @return {?object}
 */
function mapObject(object, callback, context) {
  if (!object) {
    return null;
  }
  var result = {};
  for (var name in object) {
    if (hasOwnProperty.call(object, name)) {
      result[name] = callback.call(context, object[name], name, object);
    }
  }
  return result;
}

module.exports = mapObject;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule onlyChild
 */


var ReactElement = __webpack_require__(18);

var invariant = __webpack_require__(2);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection. The current implementation of this
 * function assumes that a single child gets passed without a wrapper, but the
 * purpose of this helper function is to abstract away the particular structure
 * of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactComponent} The first and only `ReactComponent` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : invariant(false) : undefined;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule deprecated
 */



var assign = __webpack_require__(8);
var warning = __webpack_require__(7);

/**
 * This will log a single deprecation notice per function and forward the call
 * on to the new API.
 *
 * @param {string} fnName The name of the function
 * @param {string} newModule The module that fn will exist in
 * @param {string} newPackage The module that fn will exist in
 * @param {*} ctx The context this forwarded call should run in
 * @param {function} fn The function to forward on to
 * @return {function} The function that will warn once and then call fn
 */
function deprecated(fnName, newModule, newPackage, ctx, fn) {
  var warned = false;
  if (false) {
    var newFn = function () {
      process.env.NODE_ENV !== 'production' ? warning(warned,
      // Require examples in this string must be split to prevent React's
      // build tools from mistaking them for real requires.
      // Otherwise the build tools will attempt to build a '%s' module.
      'React.%s is deprecated. Please use %s.%s from require' + '(\'%s\') ' + 'instead.', fnName, newModule, fnName, newPackage) : undefined;
      warned = true;
      return fn.apply(ctx, arguments);
    };
    // We need to make sure all properties of the original fn are copied over.
    // In particular, this is needed to support PropTypes
    return assign(newFn, fn);
  }

  return fn;
}

module.exports = deprecated;

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(49);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
  children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */],
  routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */], // alias for children
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onError: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]
};

var prefixUnsafeLifecycleMethods = parseFloat(__WEBPACK_IMPORTED_MODULE_1_react___default.a.version) >= 16.3;

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */
var Router = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* createRouterObject */])(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["b" /* createRoutes */])(routes || children));
  },


  // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* assignRouterState */])(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

if (prefixUnsafeLifecycleMethods) {
  Router.prototype.UNSAFE_componentWillReceiveProps = Router.prototype.componentWillReceiveProps;
  Router.prototype.UNSAFE_componentWillMount = Router.prototype.componentWillMount;
  delete Router.prototype.componentWillReceiveProps;
  delete Router.prototype.componentWillMount;
}

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(127);

var emptyObject = __webpack_require__(371);
var _invariant = __webpack_require__(372);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(374);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(50);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionUtils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(128);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(50);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(193);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* mapAsync */])(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(34);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    });

    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_2__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(381);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.9.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118;function x(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function y(a){return x(a)===m}exports.typeOf=x;exports.AsyncMode=l;
exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w)};exports.isAsyncMode=function(a){return y(a)||x(a)===l};exports.isConcurrentMode=y;exports.isContextConsumer=function(a){return x(a)===k};exports.isContextProvider=function(a){return x(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return x(a)===n};exports.isFragment=function(a){return x(a)===e};exports.isLazy=function(a){return x(a)===t};exports.isMemo=function(a){return x(a)===r};exports.isPortal=function(a){return x(a)===d};exports.isProfiler=function(a){return x(a)===g};exports.isStrictMode=function(a){return x(a)===f};exports.isSuspense=function(a){return x(a)===p};


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(50);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(195);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IndexLink',

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexLink);

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextUtils__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PropTypes__ = __webpack_require__(131);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
    displayName: 'WithRouter',

    mixins: [Object(__WEBPACK_IMPORTED_MODULE_4__ContextUtils__["b" /* ContextSubscriber */])('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["b" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["b" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(WithRouter, WrappedComponent);
}

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redirect__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(65);







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRedirect);

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(65);







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRouteFromReactElement */])(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRoute);

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(65);






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(194);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  history = history ? history : Object(__WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */])(options);
  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = Object(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["b" /* createRouterObject */])(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (match);

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(391);
var objectAssign = __webpack_require__(127);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(49);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(202);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(136);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(41);

var _PathUtils = __webpack_require__(35);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(202);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(136);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(33);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(41);

var _DOMUtils = __webpack_require__(67);

var _DOMStateStorage = __webpack_require__(201);

var _PathUtils = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.Actions = exports.useQueries = exports.useBeforeUnload = exports.useBasename = exports.createMemoryHistory = exports.createHashHistory = exports.createHistory = undefined;

var _LocationUtils = __webpack_require__(41);

Object.defineProperty(exports, 'locationsAreEqual', {
  enumerable: true,
  get: function get() {
    return _LocationUtils.locationsAreEqual;
  }
});

var _createBrowserHistory = __webpack_require__(200);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _createHashHistory2 = __webpack_require__(203);

var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);

var _createMemoryHistory2 = __webpack_require__(198);

var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);

var _useBasename2 = __webpack_require__(134);

var _useBasename3 = _interopRequireDefault(_useBasename2);

var _useBeforeUnload2 = __webpack_require__(399);

var _useBeforeUnload3 = _interopRequireDefault(_useBeforeUnload2);

var _useQueries2 = __webpack_require__(132);

var _useQueries3 = _interopRequireDefault(_useQueries2);

var _Actions2 = __webpack_require__(66);

var _Actions = _interopRequireWildcard(_Actions2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createHistory = _createBrowserHistory2.default;
exports.createHashHistory = _createHashHistory3.default;
exports.createMemoryHistory = _createMemoryHistory3.default;
exports.useBasename = _useBasename3.default;
exports.useBeforeUnload = _useBeforeUnload3.default;
exports.useQueries = _useQueries3.default;
exports.Actions = _Actions;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(15);

var _invariant2 = _interopRequireDefault(_invariant);

var _DOMUtils = __webpack_require__(67);

var _ExecutionEnvironment = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var startListener = function startListener(getPromptMessage) {
  var handleBeforeUnload = function handleBeforeUnload(event) {
    var message = getPromptMessage();

    if (typeof message === 'string') {
      (event || window.event).returnValue = message;
      return message;
    }

    return undefined;
  };

  (0, _DOMUtils.addEventListener)(window, 'beforeunload', handleBeforeUnload);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, 'beforeunload', handleBeforeUnload);
  };
};

/**
 * Returns a new createHistory function that can be used to create
 * history objects that know how to use the beforeunload event in web
 * browsers to cancel navigation.
 */
var useBeforeUnload = function useBeforeUnload(createHistory) {
  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'useBeforeUnload only works in DOM environments') : (0, _invariant2.default)(false) : void 0;

  return function (options) {
    var history = createHistory(options);

    var listeners = [];
    var stopListener = void 0;

    var getPromptMessage = function getPromptMessage() {
      var message = void 0;
      for (var i = 0, len = listeners.length; message == null && i < len; ++i) {
        message = listeners[i].call();
      }return message;
    };

    var listenBeforeUnload = function listenBeforeUnload(listener) {
      if (listeners.push(listener) === 1) stopListener = startListener(getPromptMessage);

      return function () {
        listeners = listeners.filter(function (item) {
          return item !== listener;
        });

        if (listeners.length === 0 && stopListener) {
          stopListener();
          stopListener = null;
        }
      };
    };

    return _extends({}, history, {
      listenBeforeUnload: listenBeforeUnload
    });
  };
};

exports.default = useBeforeUnload;

/***/ }),
/* 400 */
/***/ (function(module, exports) {



;(function () {
	'use strict';

	/**
  * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
  *
  * @codingstandard ftlabs-jsv2
  * @copyright The Financial Times Limited [All Rights Reserved]
  * @license MIT License (see LICENSE.txt)
  */

	/*jslint browser:true, node:true*/
	/*global define, Event, Node*/

	/**
  * Instantiate fast-clicking listeners on the specified layer.
  *
  * @constructor
  * @param {Element} layer The layer to listen on
  * @param {Object} [options={}] The options to override the defaults
  */

	function FastClick(layer, options) {
		var oldOnClick;

		options = options || {};

		/**
   * Whether a click is currently being tracked.
   *
   * @type boolean
   */
		this.trackingClick = false;

		/**
   * Timestamp for when click tracking started.
   *
   * @type number
   */
		this.trackingClickStart = 0;

		/**
   * The element being tracked for a click.
   *
   * @type EventTarget
   */
		this.targetElement = null;

		/**
   * X-coordinate of touch start event.
   *
   * @type number
   */
		this.touchStartX = 0;

		/**
   * Y-coordinate of touch start event.
   *
   * @type number
   */
		this.touchStartY = 0;

		/**
   * ID of the last touch, retrieved from Touch.identifier.
   *
   * @type number
   */
		this.lastTouchIdentifier = 0;

		/**
   * Touchmove boundary, beyond which a click will be cancelled.
   *
   * @type number
   */
		this.touchBoundary = options.touchBoundary || 10;

		/**
   * The FastClick layer.
   *
   * @type Element
   */
		this.layer = layer;

		/**
   * The minimum time between tap(touchstart and touchend) events
   *
   * @type number
   */
		this.tapDelay = options.tapDelay || 200;

		/**
   * The maximum time for a tap
   *
   * @type number
   */
		this.tapTimeout = options.tapTimeout || 700;

		if (FastClick.notNeeded(layer)) {
			return;
		}

		// Some old versions of Android don't have Function.prototype.bind
		function bind(method, context) {
			return function () {
				return method.apply(context, arguments);
			};
		}

		var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
		var context = this;
		for (var i = 0, l = methods.length; i < l; i++) {
			context[methods[i]] = bind(context[methods[i]], context);
		}

		// Set up event handlers as required
		if (deviceIsAndroid) {
			layer.addEventListener('mouseover', this.onMouse, true);
			layer.addEventListener('mousedown', this.onMouse, true);
			layer.addEventListener('mouseup', this.onMouse, true);
		}

		layer.addEventListener('click', this.onClick, true);
		layer.addEventListener('touchstart', this.onTouchStart, false);
		layer.addEventListener('touchmove', this.onTouchMove, false);
		layer.addEventListener('touchend', this.onTouchEnd, false);
		layer.addEventListener('touchcancel', this.onTouchCancel, false);

		// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
		// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
		// layer when they are cancelled.
		if (!Event.prototype.stopImmediatePropagation) {
			layer.removeEventListener = function (type, callback, capture) {
				var rmv = Node.prototype.removeEventListener;
				if (type === 'click') {
					rmv.call(layer, type, callback.hijacked || callback, capture);
				} else {
					rmv.call(layer, type, callback, capture);
				}
			};

			layer.addEventListener = function (type, callback, capture) {
				var adv = Node.prototype.addEventListener;
				if (type === 'click') {
					adv.call(layer, type, callback.hijacked || (callback.hijacked = function (event) {
						if (!event.propagationStopped) {
							callback(event);
						}
					}), capture);
				} else {
					adv.call(layer, type, callback, capture);
				}
			};
		}

		// If a handler is already declared in the element's onclick attribute, it will be fired before
		// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
		// adding it as listener.
		if (typeof layer.onclick === 'function') {

			// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
			// - the old one won't work if passed to addEventListener directly.
			oldOnClick = layer.onclick;
			layer.addEventListener('click', function (event) {
				oldOnClick(event);
			}, false);
			layer.onclick = null;
		}
	}

	/**
 * Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
 *
 * @type boolean
 */
	var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

	/**
  * Android requires exceptions.
  *
  * @type boolean
  */
	var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;

	/**
  * iOS requires exceptions.
  *
  * @type boolean
  */
	var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;

	/**
  * iOS 4 requires an exception for select elements.
  *
  * @type boolean
  */
	var deviceIsIOS4 = deviceIsIOS && /OS 4_\d(_\d)?/.test(navigator.userAgent);

	/**
  * iOS 6.0-7.* requires the target element to be manually derived
  *
  * @type boolean
  */
	var deviceIsIOSWithBadTarget = deviceIsIOS && /OS [6-7]_\d/.test(navigator.userAgent);

	/**
  * BlackBerry requires exceptions.
  *
  * @type boolean
  */
	var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

	/**
  * Determine whether a given element requires a native click.
  *
  * @param {EventTarget|Element} target Target DOM element
  * @returns {boolean} Returns true if the element needs a native click
  */
	FastClick.prototype.needsClick = function (target) {
		switch (target.nodeName.toLowerCase()) {

			// Don't send a synthetic click to disabled inputs (issue #62)
			case 'button':
			case 'select':
			case 'textarea':
				if (target.disabled) {
					return true;
				}

				break;
			case 'input':

				// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
				if (deviceIsIOS && target.type === 'file' || target.disabled) {
					return true;
				}

				break;
			case 'label':
			case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
			case 'video':
				return true;
		}

		return (/\bneedsclick\b/.test(target.className)
		);
	};

	/**
  * Determine whether a given element requires a call to focus to simulate click into element.
  *
  * @param {EventTarget|Element} target Target DOM element
  * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
  */
	FastClick.prototype.needsFocus = function (target) {
		switch (target.nodeName.toLowerCase()) {
			case 'textarea':
				return true;
			case 'select':
				return !deviceIsAndroid;
			case 'input':
				switch (target.type) {
					case 'button':
					case 'checkbox':
					case 'file':
					case 'image':
					case 'radio':
					case 'submit':
						return false;
				}

				// No point in attempting to focus disabled inputs
				return !target.disabled && !target.readOnly;
			default:
				return (/\bneedsfocus\b/.test(target.className)
				);
		}
	};

	/**
  * Send a click event to the specified element.
  *
  * @param {EventTarget|Element} targetElement
  * @param {Event} event
  */
	FastClick.prototype.sendClick = function (targetElement, event) {
		var clickEvent, touch;

		// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
		if (document.activeElement && document.activeElement !== targetElement) {
			document.activeElement.blur();
		}

		touch = event.changedTouches[0];

		// Synthesise a click event, with an extra attribute so it can be tracked
		clickEvent = document.createEvent('MouseEvents');
		clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
		clickEvent.forwardedTouchEvent = true;
		targetElement.dispatchEvent(clickEvent);
	};

	FastClick.prototype.determineEventType = function (targetElement) {

		//Issue #159: Android Chrome Select Box does not open with a synthetic click event
		if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
			return 'mousedown';
		}

		return 'click';
	};

	/**
  * @param {EventTarget|Element} targetElement
  */
	FastClick.prototype.focus = function (targetElement) {
		var length;

		// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
		if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
			length = targetElement.value.length;
			targetElement.setSelectionRange(length, length);
		} else {
			targetElement.focus();
		}
	};

	/**
  * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
  *
  * @param {EventTarget|Element} targetElement
  */
	FastClick.prototype.updateScrollParent = function (targetElement) {
		var scrollParent, parentElement;

		scrollParent = targetElement.fastClickScrollParent;

		// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
		// target element was moved to another parent.
		if (!scrollParent || !scrollParent.contains(targetElement)) {
			parentElement = targetElement;
			do {
				if (parentElement.scrollHeight > parentElement.offsetHeight) {
					scrollParent = parentElement;
					targetElement.fastClickScrollParent = parentElement;
					break;
				}

				parentElement = parentElement.parentElement;
			} while (parentElement);
		}

		// Always update the scroll top tracker if possible.
		if (scrollParent) {
			scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
		}
	};

	/**
  * @param {EventTarget} targetElement
  * @returns {Element|EventTarget}
  */
	FastClick.prototype.getTargetElementFromEventTarget = function (eventTarget) {

		// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
		if (eventTarget.nodeType === Node.TEXT_NODE) {
			return eventTarget.parentNode;
		}

		return eventTarget;
	};

	/**
  * On touch start, record the position and scroll offset.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.onTouchStart = function (event) {
		var targetElement, touch, selection;

		// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
		if (event.targetTouches.length > 1) {
			return true;
		}

		targetElement = this.getTargetElementFromEventTarget(event.target);
		touch = event.targetTouches[0];

		if (deviceIsIOS) {

			// Only trusted events will deselect text on iOS (issue #49)
			selection = window.getSelection();
			if (selection.rangeCount && !selection.isCollapsed) {
				return true;
			}

			if (!deviceIsIOS4) {

				// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
				// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
				// with the same identifier as the touch event that previously triggered the click that triggered the alert.
				// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
				// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
				// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
				// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
				// random integers, it's safe to to continue if the identifier is 0 here.
				if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
					event.preventDefault();
					return false;
				}

				this.lastTouchIdentifier = touch.identifier;

				// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
				// 1) the user does a fling scroll on the scrollable layer
				// 2) the user stops the fling scroll with another tap
				// then the event.target of the last 'touchend' event will be the element that was under the user's finger
				// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
				// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
				this.updateScrollParent(targetElement);
			}
		}

		this.trackingClick = true;
		this.trackingClickStart = event.timeStamp;
		this.targetElement = targetElement;

		this.touchStartX = touch.pageX;
		this.touchStartY = touch.pageY;

		// Prevent phantom clicks on fast double-tap (issue #36)
		if (event.timeStamp - this.lastClickTime < this.tapDelay) {
			event.preventDefault();
		}

		return true;
	};

	/**
  * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.touchHasMoved = function (event) {
		var touch = event.changedTouches[0],
		    boundary = this.touchBoundary;

		if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
			return true;
		}

		return false;
	};

	/**
  * Update the last position.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.onTouchMove = function (event) {
		if (!this.trackingClick) {
			return true;
		}

		// If the touch has moved, cancel the click tracking
		if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
			this.trackingClick = false;
			this.targetElement = null;
		}

		return true;
	};

	/**
  * Attempt to find the labelled control for the given label element.
  *
  * @param {EventTarget|HTMLLabelElement} labelElement
  * @returns {Element|null}
  */
	FastClick.prototype.findControl = function (labelElement) {

		// Fast path for newer browsers supporting the HTML5 control attribute
		if (labelElement.control !== undefined) {
			return labelElement.control;
		}

		// All browsers under test that support touch events also support the HTML5 htmlFor attribute
		if (labelElement.htmlFor) {
			return document.getElementById(labelElement.htmlFor);
		}

		// If no for attribute exists, attempt to retrieve the first labellable descendant element
		// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
		return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
	};

	/**
  * On touch end, determine whether to send a click event at once.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.onTouchEnd = function (event) {
		var forElement,
		    trackingClickStart,
		    targetTagName,
		    scrollParent,
		    touch,
		    targetElement = this.targetElement;

		if (!this.trackingClick) {
			return true;
		}

		// Prevent phantom clicks on fast double-tap (issue #36)
		if (event.timeStamp - this.lastClickTime < this.tapDelay) {
			this.cancelNextClick = true;
			return true;
		}

		if (event.timeStamp - this.trackingClickStart > this.tapTimeout) {
			return true;
		}

		// Reset to prevent wrong click cancel on input (issue #156).
		this.cancelNextClick = false;

		this.lastClickTime = event.timeStamp;

		trackingClickStart = this.trackingClickStart;
		this.trackingClick = false;
		this.trackingClickStart = 0;

		// On some iOS devices, the targetElement supplied with the event is invalid if the layer
		// is performing a transition or scroll, and has to be re-detected manually. Note that
		// for this to function correctly, it must be called *after* the event target is checked!
		// See issue #57; also filed as rdar://13048589 .
		if (deviceIsIOSWithBadTarget) {
			touch = event.changedTouches[0];

			// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
			targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
			targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
		}

		targetTagName = targetElement.tagName.toLowerCase();
		if (targetTagName === 'label') {
			forElement = this.findControl(targetElement);
			if (forElement) {
				this.focus(targetElement);
				if (deviceIsAndroid) {
					return false;
				}

				targetElement = forElement;
			}
		} else if (this.needsFocus(targetElement)) {

			// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
			// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
			if (event.timeStamp - trackingClickStart > 100 || deviceIsIOS && window.top !== window && targetTagName === 'input') {
				this.targetElement = null;
				return false;
			}

			this.focus(targetElement);
			this.sendClick(targetElement, event);

			// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
			// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
			if (!deviceIsIOS || targetTagName !== 'select') {
				this.targetElement = null;
				event.preventDefault();
			}

			return false;
		}

		if (deviceIsIOS && !deviceIsIOS4) {

			// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
			// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
			scrollParent = targetElement.fastClickScrollParent;
			if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
				return true;
			}
		}

		// Prevent the actual click from going though - unless the target node is marked as requiring
		// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
		if (!this.needsClick(targetElement)) {
			event.preventDefault();
			this.sendClick(targetElement, event);
		}

		return false;
	};

	/**
  * On touch cancel, stop tracking the click.
  *
  * @returns {void}
  */
	FastClick.prototype.onTouchCancel = function () {
		this.trackingClick = false;
		this.targetElement = null;
	};

	/**
  * Determine mouse events which should be permitted.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.onMouse = function (event) {

		// If a target element was never set (because a touch event was never fired) allow the event
		if (!this.targetElement) {
			return true;
		}

		if (event.forwardedTouchEvent) {
			return true;
		}

		// Programmatically generated events targeting a specific element should be permitted
		if (!event.cancelable) {
			return true;
		}

		// Derive and check the target element to see whether the mouse event needs to be permitted;
		// unless explicitly enabled, prevent non-touch click events from triggering actions,
		// to prevent ghost/doubleclicks.
		if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

			// Prevent any user-added listeners declared on FastClick element from being fired.
			if (event.stopImmediatePropagation) {
				event.stopImmediatePropagation();
			} else {

				// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
				event.propagationStopped = true;
			}

			// Cancel the event
			event.stopPropagation();
			event.preventDefault();

			return false;
		}

		// If the mouse event is permitted, return true for the action to go through.
		return true;
	};

	/**
  * On actual clicks, determine whether this is a touch-generated click, a click action occurring
  * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
  * an actual click which should be permitted.
  *
  * @param {Event} event
  * @returns {boolean}
  */
	FastClick.prototype.onClick = function (event) {
		var permitted;

		// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
		if (this.trackingClick) {
			this.targetElement = null;
			this.trackingClick = false;
			return true;
		}

		// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
		if (event.target.type === 'submit' && event.detail === 0) {
			return true;
		}

		permitted = this.onMouse(event);

		// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
		if (!permitted) {
			this.targetElement = null;
		}

		// If clicks are permitted, return true for the action to go through.
		return permitted;
	};

	/**
  * Remove all FastClick's event listeners.
  *
  * @returns {void}
  */
	FastClick.prototype.destroy = function () {
		var layer = this.layer;

		if (deviceIsAndroid) {
			layer.removeEventListener('mouseover', this.onMouse, true);
			layer.removeEventListener('mousedown', this.onMouse, true);
			layer.removeEventListener('mouseup', this.onMouse, true);
		}

		layer.removeEventListener('click', this.onClick, true);
		layer.removeEventListener('touchstart', this.onTouchStart, false);
		layer.removeEventListener('touchmove', this.onTouchMove, false);
		layer.removeEventListener('touchend', this.onTouchEnd, false);
		layer.removeEventListener('touchcancel', this.onTouchCancel, false);
	};

	/**
  * Check whether FastClick is needed.
  *
  * @param {Element} layer The layer to listen on
  */
	FastClick.notNeeded = function (layer) {
		var metaViewport;
		var chromeVersion;
		var blackberryVersion;
		var firefoxVersion;

		// Devices that don't support touch don't need FastClick
		if (typeof window.ontouchstart === 'undefined') {
			return true;
		}

		// Chrome version - zero for other browsers
		chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1];

		if (chromeVersion) {

			if (deviceIsAndroid) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// Chrome 32 and above with width=device-width or less don't need FastClick
					if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}

				// Chrome desktop doesn't need FastClick (issue #15)
			} else {
				return true;
			}
		}

		if (deviceIsBlackBerry10) {
			blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);

			// BlackBerry 10.3+ does not require Fastclick library.
			// https://github.com/ftlabs/fastclick/issues/251
			if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// user-scalable=no eliminates click delay.
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// width=device-width (or less than device-width) eliminates click delay.
					if (document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}
			}
		}

		// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
		if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		// Firefox version - zero for other browsers
		firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1];

		if (firefoxVersion >= 27) {
			// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896

			metaViewport = document.querySelector('meta[name=viewport]');
			if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
				return true;
			}
		}

		// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
		// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
		if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		return false;
	};

	/**
  * Factory method for creating a FastClick object
  *
  * @param {Element} layer The layer to listen on
  * @param {Object} [options={}] The options to override the defaults
  */
	FastClick.attach = function (layer, options) {
		return new FastClick(layer, options);
	};

	window.FastClick = FastClick;

	module.exports = FastClick;
	// if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) {

	// 	// AMD. Register as an anonymous module.
	// 	define(function() {
	// 		return FastClick;
	// 	});
	// } else if (typeof module !== 'undefined' && module.exports) {
	// 	module.exports = FastClick.attach;
	// 	module.exports.FastClick = FastClick;
	// } else {
	// 	window.FastClick = FastClick;
	// }
})();

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTargetUrl = function getTargetUrl(url) {
    var query = {},
        path = '',
        param = '',
        hash = '',
        newUrl = '',
        newquery = {};
    var paramWhiteList = ['env', 'clientType', 'td_channelid', 'gachannel', 'debug', 'adscountry'];

    if (url.indexOf('?') > -1) {
        path = url.substr(0, url.indexOf('?'));
        param = url.substr(url.indexOf('?') + 1);

        if (param.indexOf('#') > -1) {
            hash = param.substr(param.indexOf('#') + 1);
            param = param.substr(0, param.indexOf('#'));
        }
        query = _cUrl2.default.parseQuery(param);
    } else {
        path = url;
    }

    for (var i = 0, len = paramWhiteList.length; i < len; i++) {
        var key = paramWhiteList[i];
        var value = _cUrl2.default.query(key + '');

        if (paramWhiteList.indexOf(key) > -1 && value) {
            newquery[key] = value;
        }
    }

    if ($.param(newquery)) {
        newUrl = path + '?' + $.param(newquery);
    } else {
        newUrl = path;
    }

    if (hash) {
        newUrl += '#' + hash;
    }

    return newUrl;
};

exports.default = getTargetUrl;

/***/ }),
/* 402 */
/***/ (function(module, exports) {

var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "SensitiveWords.Get",
    "options": {
        "objc_class_prefix": "SensitiveWordsGet",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Request",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "lastTime",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "extLastTime",
            "id": 2
        }]
    }, {
        "name": "Response",
        "fields": [{
            "rule": "repeated",
            "type": "SensitiveWords",
            "name": "words",
            "id": 1
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "hasNext",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "updateTime",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "extUpdateTime",
            "id": 4
        }]
    }, {
        "name": "SensitiveWords",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "type",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "content",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "status",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "lang",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "iden",
            "id": 5
        }]
    }],
    "enums": [{
        "name": "SensitiveType",
        "values": [{
            "name": "DEFAULT",
            "id": 0
        }, {
            "name": "USERNAME",
            "id": 1
        }, {
            "name": "SIGNATURE",
            "id": 2
        }, {
            "name": "CHAT",
            "id": 4
        }, {
            "name": "LIVENAME",
            "id": 8
        }, {
            "name": "LETTER",
            "id": 16
        }, {
            "name": "AUTH",
            "id": 32
        }]
    }]
}).build();

module.exports = _root;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cNotification = __webpack_require__(11);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _loginPop = __webpack_require__(404);

var _loginPop2 = _interopRequireDefault(_loginPop);

var _index = __webpack_require__(248);

var _index2 = _interopRequireDefault(_index);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _im = __webpack_require__(207);

var _im2 = _interopRequireDefault(_im);

var _ScaleModal = __webpack_require__(12);

var _ScaleModal2 = _interopRequireDefault(_ScaleModal);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _selectCountry = __webpack_require__(471);

var _selectCountry2 = _interopRequireDefault(_selectCountry);

var _giftlist = __webpack_require__(153);

var _giftlist2 = _interopRequireDefault(_giftlist);

var _index3 = __webpack_require__(75);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cache = new _cCache2.default({
    prefix: 'pcuplive'
});

var style = {
    modalStyle: {
        width: '700px',
        zIndex: 10001
    },
    contentStyle: {
        width: '700px',
        height: '560px',
        borderRadius: '10px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        backgroundColor: "rgba(23,19,31, 0.7)",
        zIndex: 10000
    }
};

function HocWrapper(ComposedComponent) {
    var AppWrapper = function (_Component) {
        _inherits(AppWrapper, _Component);

        function AppWrapper(props) {
            _classCallCheck(this, AppWrapper);

            var _this = _possibleConstructorReturn(this, (AppWrapper.__proto__ || Object.getPrototypeOf(AppWrapper)).call(this, props));

            _this.hideLoginPop = function (e) {

                _this.refs.modal.hide();
                _this.setState({
                    showLoginPop: 0 // 为了销毁loginpop中的一些处理。例如：qrcode查询的定时器
                }, function () {
                    UP.Global.isLoginPop = false;
                });

                // if (location.href.indexOf('/recharge') > -1 ) {
                //     history.back();
                // }
            };

            _this.showLoginPop = function (e) {

                /*在global中储存登录弹框显示隐藏状态**/
                UP.Global.isLoginPop = true;
                _this.setState({
                    showLoginPop: 1
                }, function () {
                    this.refs.modal.show();
                });
            };

            _this.state = {
                lang: UP.Global.siteLanguage,
                inited: 0,
                showLoginPop: 0,
                showIM: 0,
                uid: 0
            };

            _this.bindEvent();
            return _this;
        }

        _createClass(AppWrapper, [{
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;

                this.asyncLanguage(this.state.lang, function () {
                    _this2.getLoginUserProfile();
                });
            }
        }, {
            key: "getLanguagePackFromLocal",
            value: function getLanguagePackFromLocal(file) {
                var langpack = cache.getCache('langpack') || {};

                if (langpack.data) {
                    if (langpack.version == "4.7.8") {
                        return langpack.data[file];
                    } else {
                        return '';
                    }
                } else {
                    return '';
                }
            }
        }, {
            key: "asyncLanguage",
            value: function asyncLanguage(langtype, callback) {
                var _this3 = this;

                var arr = langtype.split('-');
                var file = arr[0] + arr[1].toLowerCase();
                var langpack = this.getLanguagePackFromLocal(file);

                if (langpack) {
                    window.LangPack = langpack;

                    if (typeof callback == 'function') {
                        callback();
                    }
                } else {
                    if (file !== 'enus') {
                        __webpack_require__(478)("./" + file).then(function (LangPack) {
                            window.LangPack = LangPack;

                            _this3.updateLangPack(file, LangPack);

                            if (typeof callback == 'function') {
                                callback();
                            }
                        }).catch(function (err) {
                            console.log(err);
                        });
                    } else {
                        window.LangPack = null;

                        if (typeof callback == 'function') {
                            callback();
                        }
                    }
                }
            }
        }, {
            key: "updateLangPack",
            value: function updateLangPack(file, data) {
                var langpack = cache.getCache('langpack') || {};

                if (langpack.version == "4.7.8") {
                    langpack.data[file] = data;
                } else {
                    cache.removeCache('langpack');
                    langpack = {
                        version: "4.7.8",
                        data: {}
                    };
                    langpack.data[file] = data;
                }

                cache.setCache('langpack', langpack);
            }
        }, {
            key: "getLoginUserProfile",
            value: function getLoginUserProfile() {
                var uid = UP.Global.getUserId() || 0;

                this.getProfileByUserId(uid);
            }
        }, {
            key: "bindEvent",
            value: function bindEvent() {
                var _this4 = this;

                $.channel.on("chooseLanguage", function (type) {
                    UP.Global.DA.add({
                        eventName: 'ChooseLanguage',
                        action: 'click'
                    });

                    UP.Global.chooseLanguage(type);

                    _this4.asyncLanguage(type, function () {
                        _this4.setState({
                            lang: type
                        });
                    });
                });

                $.channel.on('login', function () {
                    style.contentStyle.width = '400px';
                    style.contentStyle.height = '409px';
                    style.modalStyle.width = '400px';
                    _this4.showLoginPop();
                });

                $.channel.on('logout', function () {
                    UP.Global.DA.add({
                        eventName: 'Logout Box',
                        action: 'Logout'
                    });
                    UP.Global.clearUserInfo();
                    // this.setState({
                    //     uid: 0
                    // });
                    // 用户登出，重新走流程
                    _this4.getLoginUserProfile();

                    _this4.setState({
                        showIM: 0
                    });
                });

                $.channel.on('loginSuccess', function (data) {
                    UP.Global.writeUserInfo(data);
                    _this4.loginSuccess(data);
                    _this4.getLoginUserProfile();
                    _this4.showGuidRoomBox();
                });

                $.channel.on('authSuccess', function (data) {
                    UP.Global.cacheUserToken(data.userToken);
                    _this4.getProfileByUserId(data.uid);
                    _this4.showGuidRoomBox();
                });

                $.channel.on('registerVisitorSuccess', function (data) {
                    UP.Global.writeUserInfo(data);
                    _this4.loginSuccess(data);
                });
            }
        }, {
            key: "showGuidRoomBox",
            value: function showGuidRoomBox() {
                //登录成功判断是否有新手礼物 弹新手引导框 用户进入过直播间则不弹框
                var isShow = this.isShowGuidEnterRoom();
                if (isShow) {

                    $.channel.on('gotGiftListForGuid', function () {
                        $.channel.off('gotGiftListForGuid');
                        $.channel.emit('showGuidGift', _giftlist2.default.hasGuidGift);
                        $.channel.off('showGuidGift');
                    });
                    _giftlist2.default.getGiftLabel();
                }
            }
        }, {
            key: "isShowGuidEnterRoom",
            value: function isShowGuidEnterRoom() {
                var showGuid = cache.getCache('getIntoRoom');
                if (showGuid) {
                    return false;
                }
                return true;
            }
        }, {
            key: "isEmptyObject",
            value: function isEmptyObject(obj) {

                for (var key in obj) {
                    return false;
                };
                return true;
            }
        }, {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                $.channel.off("chooseLanguage");
                $.channel.off("login");
                $.channel.off("logout");
                $.channel.off('loginSuccess');
                $.channel.off('authSuccess');
            }
        }, {
            key: "getProfileByUserId",
            value: function getProfileByUserId(uid) {
                var _this5 = this;

                var self = this;

                var getUserProfileCount = 0; // 请求失败，则请重新求。重试三次

                var getUserProfile = function getUserProfile(uid) {

                    var promise = new _index2.default(uid).promise;

                    promise.done(function (data) {
                        if (data.hostStatus) {
                            // 当前用户登录信息
                            UP.Global.writeUserInfo(data);
                        }
                        _this5.loginSuccess(data);
                    }).fail(function () {

                        ++getUserProfileCount;

                        if (getUserProfileCount > 3) {

                            _cNotification2.default.simple(_lang2.default.template('获取用户信息失败, 请稍后再试'), 100000);
                        } else {
                            getUserProfile(uid);
                        }
                    });
                };

                getUserProfile(uid);
            }
        }, {
            key: "loginSuccess",
            value: function loginSuccess(data) {
                var self = this;

                if (this.state.showLoginPop == 1) {
                    this.hideLoginPop();
                }

                if (!data.countryCode) {
                    this.update();
                    // debugger;
                    setTimeout(function () {
                        _selectCountry2.default.create({
                            username: _index4.default.filter(data.username),
                            gender: data.gender,
                            onComplete: function onComplete(countryCode) {
                                data.countryCode = countryCode;
                                self.setState({
                                    inited: 0
                                }, function () {
                                    this.update();
                                });
                            }
                        });
                    }, 500);
                } else {
                    this.update();
                    if (UP.Global.isRegisterRealUser()) {}
                }

                if (UP.Global.isRegisterRealUser()) {
                    this.setState({
                        showIM: 1
                    });
                }
            }
        }, {
            key: "update",
            value: function update() {
                this.setState({
                    inited: 1,
                    uid: UP.Global.getUserId()
                });
            }
        }, {
            key: "render",
            value: function render() {
                var $content = void 0;

                return _react2.default.createElement(
                    "div",
                    { id: "J-PageWrap" },
                    this.state.inited == 1 ? _react2.default.createElement(ComposedComponent, { key: "" + this.state.lang.replace('-', '') + this.state.uid, lang: this.state.lang }) : null,
                    _react2.default.createElement(
                        _ScaleModal2.default,
                        { ref: "modal", closeOnClick: false, modalStyle: style.modalStyle, backdropStyle: style.backdropStyle, contentStyle: style.contentStyle },
                        this.state.showLoginPop == 1 ? _react2.default.createElement(_loginPop2.default, { onClose: this.hideLoginPop }) : null
                    ),
                    this.state.showIM == 1 ? _react2.default.createElement(_im2.default, { ref: "im" }) : null
                );
            }
        }]);

        return AppWrapper;
    }(_react.Component);

    return AppWrapper;
}

module.exports = HocWrapper;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _phoneLogin = __webpack_require__(204);

var _phoneLogin2 = _interopRequireDefault(_phoneLogin);

var _phoneRegister = __webpack_require__(415);

var _phoneRegister2 = _interopRequireDefault(_phoneRegister);

var _emailLogin = __webpack_require__(206);

var _emailLogin2 = _interopRequireDefault(_emailLogin);

var _emailRegister = __webpack_require__(420);

var _emailRegister2 = _interopRequireDefault(_emailRegister);

var _qrcodeLogin = __webpack_require__(421);

var _qrcodeLogin2 = _interopRequireDefault(_qrcodeLogin);

var _iframe = __webpack_require__(98);

var _iframe2 = _interopRequireDefault(_iframe);

var _google = __webpack_require__(430);

var _google2 = _interopRequireDefault(_google);

var _wechat = __webpack_require__(431);

var _wechat2 = _interopRequireDefault(_wechat);

var _transfer = __webpack_require__(432);

var _transfer2 = _interopRequireDefault(_transfer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginPop = function (_Component) {
	_inherits(LoginPop, _Component);

	function LoginPop(props) {
		_classCallCheck(this, LoginPop);

		var _this = _possibleConstructorReturn(this, (LoginPop.__proto__ || Object.getPrototypeOf(LoginPop)).call(this, props));

		_this.state = {
			logging: 0,
			loginMethod: 2,

			userProcess: 'login', //用户操作流程，控制页面展示
			childProps: null

		};
		return _this;
	}

	_createClass(LoginPop, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			var node = $(this.refs.tip);

			node.on('click', 'i', function (e) {
				_iframe2.default.create({
					url: UP.Global.getH5Host() + _lang2.default.template('terms.html')
				});
			});

			node.on('click', 'em', function (e) {
				_iframe2.default.create({
					url: UP.Global.getH5Host() + _lang2.default.template('privacy.html')
				});
			});
			var qrnode = $(this.refs.qrlogin);
			var pcnode = $(this.refs.pclogin);
			qrnode.on({
				mouseenter: function mouseenter(e) {
					$('.qrtip').removeClass('hidden');
				},
				mouseleave: function mouseleave(e) {
					$('.qrtip').addClass('hidden');
				}
			});
			pcnode.on({

				mouseenter: function mouseenter(e) {
					$('.pctip').removeClass('hidden');
				},
				mouseleave: function mouseleave(e) {
					$('.pctip').addClass('hidden');
				}
			});

			UP.Global.DA.add({
				eventName: 'loginWindowOpen',
				action: 'click'
			});

			fbq('track', 'LoginWindowOpen');

			// let thirdparty = $(this.refs.thirdparty);

			var el = $('.login-pop-ft');
			el.on('mouseenter', 'li', function (e) {
				$(e.currentTarget).find('.tip').removeClass('hidden');
			}).on('mouseleave', 'li', function (e) {
				$(e.currentTarget).find('.tip').addClass('hidden');
			});
			// let loginItem =  $('.login-form-item');
			// loginItem.on('focus','input',function(e){
			// 	$(e.currentTarget).parents('.input-wrap').addClass('purple');
			// }).on('blur','input',(e)=>{
			// 	$(e.currentTarget).parents('.input-wrap').removeClass('purple');
			// })
			$.channel.on('emailRegister', function (data) {
				_this2.setState({
					logging: 0,
					userProcess: 'emailRegister',
					childProps: data

				});
			});
			$.channel.on('emailFindPwd', function (data) {
				_this2.setState({
					logging: 0,
					userProcess: 'emailFindPwd',
					childProps: data

				}, function () {
					_this2.refs.emailWrap.setInitState(data);
				});
			});
			$.channel.on('emailSendSuccessTip', function (data) {
				_this2.setState({
					logging: 0,
					userProcess: 'emailSendSuccess',
					childProps: data

				}, function () {

					_this2.refs.emailWrap.setInitState(data);
				});
			});
			$.channel.on('emailLogin', function (data) {
				_this2.setState({
					logging: 0,
					userProcess: 'emailLogin',
					childProps: data
				}, function () {
					_this2.refs.emailWrap.setInitState(data);
				});
			});
			$.channel.on('phoneRegister', function (data) {
				_this2.setState({
					logging: 0,
					userProcess: 'phoneRegister',
					childProps: data
				}, function () {
					_this2.refs.phoneWrap.setInitState(data);
				});
			});
			$.channel.on('phoneFindPwd', function (data) {
				_this2.setState({
					logging: 0,
					userProcess: 'phoneFindPwd',
					childProps: data
				}, function () {
					_this2.refs.phoneWrap.setInitState(data);
				});
			});
			$.channel.on('phoneLogin', function (data) {
				_this2.setState({
					logging: 0,
					userProcess: 'phoneLogin',
					childProps: data
				});
			}, function () {
				_this2.refs.phoneWrap.setInitState(data);
			});
		}
	}, {
		key: 'componentWillUnMount',
		value: function componentWillUnMount() {

			$.channel.off('emailLogin');
			$.channel.off('emailRegister');
			$.channel.off('emailFindPwd');
			$.channel.off('emailSendSuccessTip');
			$.channel.off('phoneRegister');
			$.channel.off('phoneFindPwd');
			$.channel.off('phoneLogin');
		}
	}, {
		key: 'login',
		value: function login(channel) {
			// this.setState({
			// 	logging: 1
			// });

			switch (channel) {
				case 'facebook':
					UP.Global.DA.add({
						eventName: 'facebookLogin',
						action: 'click'
					});
					_transfer2.default.go('fb');
					break;
				case 'twitter':
					UP.Global.DA.add({
						eventName: 'twitterLogin',
						action: 'click'
					});
					_transfer2.default.go('twitter');
					break;
				case 'wechat':
					UP.Global.DA.add({
						eventName: 'wechatLogin',
						action: 'click'
					});
					_wechat2.default.go();
					break;
				case 'weibo':
					UP.Global.DA.add({
						eventName: 'weiboLogin',
						action: 'click'
					});
					_transfer2.default.go('weibo');
					break;
				case 'qq':
					UP.Global.DA.add({
						eventName: 'qqLogin',
						action: 'click'
					});
					_transfer2.default.go('qq');
					break;
				case 'line':
					UP.Global.DA.add({
						eventName: 'lineLogin',
						action: 'click'
					});
					_transfer2.default.go('line');
					break;
				case 'google':
					UP.Global.DA.add({
						eventName: 'googleLogin',
						action: 'click'
					});
					_google2.default.go();
					break;
				case 'line':
					UP.Global.DA.add({
						eventName: 'lineLogin',
						action: 'click'
					});
					_google2.default.go();
					break;
			}
		}
	}, {
		key: 'close',
		value: function close() {
			this.props.onClose();
		}
	}, {
		key: 'loginMethod',
		value: function loginMethod(_loginMethod) {
			this.setState({
				loginMethod: _loginMethod,
				userProcess: 'login'

			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props = this.props,
			    cn = _props.cn,
			    ar = _props.ar,
			    all = _props.all;

			var list = all;
			var $content = void 0;
			var loginMethod = this.state.loginMethod;
			var userProcess = this.state.userProcess;

			var popTitle = '登录Uplive';
			if (userProcess == 'phoneFindPwd') {
				popTitle = '设置新密码';
			} else if (userProcess == 'emailRegister' || userProcess == 'phoneRegister') {
				popTitle = '注册账号';
			} else if (userProcess == 'emailFindPwd' || userProcess == 'emailSendSuccess') {
				popTitle = '验证邮箱';
			}
			var showThirdLogin = true;
			if (userProcess == 'emailSendSuccess') {
				showThirdLogin = false;
			}

			switch (UP.Global.version) {
				case 'CN':
					list = cn;
					break;
				case 'AR':
					list = ar;
					break;
				default:
					list = all;

			}

			if (UP.Global.ie10AndOlder()) {

				if (list.indexOf('google') > -1) {
					list.splice(list.indexOf('google'), 1);
				}

				if (list.indexOf('wechat') > -1) {
					list.splice(list.indexOf('wechat'), 1);
				}
			}

			if (this.state.logging == 1) {
				$content = _react2.default.createElement(
					'div',
					{ className: 'login-pop-loading' },
					_lang2.default.template('正在登录')
				);
			} else {

				if (userProcess == 'emailRegister' || userProcess == 'emailFindPwd' || userProcess == 'emailFindPwd' || userProcess == 'emailLogin' || userProcess == 'emailSendSuccess') {

					$content = _react2.default.createElement(_emailRegister2.default, { childProps: this.state.childProps, ref: 'emailWrap' });
				} else if (userProcess == 'phoneRegister' || userProcess == 'phoneFindPwd' || userProcess == 'phoneLogin') {

					$content = _react2.default.createElement(_phoneRegister2.default, { childProps: this.state.childProps, ref: 'phoneWrap' });
				} else {

					if (loginMethod == 1) {
						$content = _react2.default.createElement(
							'div',
							{ className: 'login-pop-content clearfix' },
							_react2.default.createElement(
								'div',
								{ className: 'login-pop-content-box' },
								_react2.default.createElement(_qrcodeLogin2.default, null)
							)
						);
					} else {
						$content = _react2.default.createElement(
							'div',
							{ className: 'email-phone-login-box' },
							_react2.default.createElement(
								'div',
								{ className: 'login-tabs' },
								_react2.default.createElement(
									'div',
									{ className: 'tab tel ' + (loginMethod == 2 ? "selected" : ''), onClick: this.loginMethod.bind(this, 2) },
									_lang2.default.template('手机注册/登录')
								),
								_react2.default.createElement(
									'div',
									{ className: 'tab email ' + (loginMethod != 2 ? "selected" : ''), onClick: this.loginMethod.bind(this, 3) },
									_lang2.default.template('邮箱注册/登录')
								)
							),
							loginMethod == 2 ? _react2.default.createElement(_phoneLogin2.default, null) : _react2.default.createElement(_emailLogin2.default, null)
						);
					}
				}
			}

			return _react2.default.createElement(
				'div',
				{ className: 'login-pop' },
				_react2.default.createElement(
					'div',
					{ className: ' ' + (showThirdLogin ? 'box' : 'no-third-box box') },
					_react2.default.createElement(
						'div',
						{ className: 'login-pop-hd' },
						_react2.default.createElement(
							'span',
							{ className: 'l-tip' },
							_lang2.default.template(popTitle)
						),
						_react2.default.createElement(
							'span',
							{ className: 'l-qr ' + (loginMethod == 1 ? 'selected' : ''), onClick: this.loginMethod.bind(this, 1), ref: 'qrlogin' },
							_react2.default.createElement(
								'em',
								{ className: 'tabtip qrtip hidden' },
								_lang2.default.template('扫码登录')
							)
						),
						_react2.default.createElement('span', { className: 'split' }),
						_react2.default.createElement(
							'span',
							{ className: 'l-pc ' + (loginMethod != 1 ? 'selected' : ''), onClick: this.loginMethod.bind(this, 2), ref: 'pclogin' },
							_react2.default.createElement(
								'em',
								{ className: 'tabtip pctip hidden' },
								_lang2.default.template('密码登录')
							)
						),
						_react2.default.createElement(
							'span',
							{ className: 'close', onClick: function onClick() {
									return _this3.close();
								} },
							'x'
						)
					),
					$content,
					showThirdLogin ? _react2.default.createElement(
						'div',
						{ className: 'login-pop-ft' },
						_react2.default.createElement(
							'h3',
							null,
							_lang2.default.template('其他登录方式')
						),
						_react2.default.createElement(
							'ul',
							{ ref: 'thirdparty' },
							list.map(function (channel, index) {
								return _react2.default.createElement(
									'li',
									{ key: index, className: channel, onClick: function onClick() {
											return _this3.login(channel);
										} },
									_react2.default.createElement('i', null),
									_react2.default.createElement(
										'em',
										{ className: 'tip hidden' },
										channel
									)
								);
							})
						)
					) : null,
					_react2.default.createElement(
						'div',
						{ className: 'login-pop-tip' },
						_react2.default.createElement(
							'div',
							{ className: 'notice middlebefore' },
							_react2.default.createElement('span', { className: 'tip', ref: 'tip', dangerouslySetInnerHTML: { __html: _lang2.default.template("登录代表你接受Up直播《服务条款及隐私政策》") } })
						)
					)
				)
			);
		}
	}]);

	return LoginPop;
}(_react.Component);

LoginPop.defaultProps = {
	'cn': ['wechat', 'weibo', 'qq'],
	'ar': ['google', 'facebook', 'twitter'],
	'all': ['google', 'facebook', 'twitter', 'line', 'wechat', 'qq', 'weibo'] // line
};
exports.default = LoginPop;

/***/ }),
/* 405 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * 国家电话区位码
 */
var CountryList = [{ name: "China", code: "CN" }, { name: "Taiwan", code: "TW" }, { name: "Hong Kong", code: "HK" }, { name: "Viet Nam", code: "VN" }, { name: "Japan", code: "JP" }, { name: "Egypt", code: "EG" }, { name: "Morocco", code: "MA" }, { name: "Saudi Arabia", code: "SA" }, { name: "Afghanistan", code: "AF" }, { name: "Åland Islands", code: "AX" }, { name: "Albania", code: "AL" }, { name: "Algeria", code: "DZ" }, { name: "American Samoa", code: "AS" }, { name: "AndorrA", code: "AD" }, { name: "Angola", code: "AO" }, { name: "Anguilla", code: "AI" }, { name: "Antarctica", code: "AQ" }, { name: "Antigua and Barbuda", code: "AG" }, { name: "Argentina", code: "AR" }, { name: "Armenia", code: "AM" }, { name: "Aruba", code: "AW" }, { name: "Australia", code: "AU" }, { name: "Austria", code: "AT" }, { name: "Azerbaijan", code: "AZ" }, { name: "Bahamas", code: "BS" }, { name: "Bahrain", code: "BH" }, { name: "Bangladesh", code: "BD" }, { name: "Barbados", code: "BB" }, { name: "Belarus", code: "BY" }, { name: "Belgium", code: "BE" }, { name: "Belize", code: "BZ" }, { name: "Benin", code: "BJ" }, { name: "Bermuda", code: "BM" }, { name: "Bhutan", code: "BT" }, { name: "Bolivia", code: "BO" }, { name: "Bosnia and Herzegovina", code: "BA" }, { name: "Botswana", code: "BW" }, { name: "Bouvet Island", code: "BV" }, { name: "Brazil", code: "BR" }, { name: "British Indian Ocean Territory", code: "IO" }, { name: "Brunei Darussalam", code: "BN" }, { name: "Bulgaria", code: "BG" }, { name: "Burkina Faso", code: "BF" }, { name: "Burundi", code: "BI" }, { name: "Cambodia", code: "KH" }, { name: "Cameroon", code: "CM" }, { name: "Canada", code: "CA" }, { name: "Cape Verde", code: "CV" }, { name: "Cayman Islands", code: "KY" }, { name: "Central African Republic", code: "CF" }, { name: "Chad", code: "TD" }, { name: "Chile", code: "CL" }, { name: "Christmas Island", code: "CX" }, { name: "Cocos (Keeling) Islands", code: "CC" }, { name: "Colombia", code: "CO" }, { name: "Comoros", code: "KM" }, { name: "Congo", code: "CG" }, { name: "Congo, The Democratic Republic of the", code: "CD" }, { name: "Cook Islands", code: "CK" }, { name: "Costa Rica", code: "CR" }, { name: "Cote D'Ivoire", code: "CI" }, { name: "Croatia", code: "HR" }, { name: "Cuba", code: "CU" }, { name: "Cyprus", code: "CY" }, { name: "Czech Republic", code: "CZ" }, { name: "Denmark", code: "DK" }, { name: "Djibouti", code: "DJ" }, { name: "Dominica", code: "DM" }, { name: "Dominican Republic", code: "DO" }, { name: "Ecuador", code: "EC" }, { name: "El Salvador", code: "SV" }, { name: "Equatorial Guinea", code: "GQ" }, { name: "Eritrea", code: "ER" }, { name: "Estonia", code: "EE" }, { name: "Ethiopia", code: "ET" }, { name: "Falkland Islands (Malvinas)", code: "FK" }, { name: "Faroe Islands", code: "FO" }, { name: "Fiji", code: "FJ" }, { name: "Finland", code: "FI" }, { name: "France", code: "FR" }, { name: "French Guiana", code: "GF" }, { name: "French Polynesia", code: "PF" }, { name: "French Southern Territories", code: "TF" }, { name: "Gabon", code: "GA" }, { name: "Gambia", code: "GM" }, { name: "Georgia", code: "GE" }, { name: "Germany", code: "DE" }, { name: "Ghana", code: "GH" }, { name: "Gibraltar", code: "GI" }, { name: "Greece", code: "GR" }, { name: "Greenland", code: "GL" }, { name: "Grenada", code: "GD" }, { name: "Guadeloupe", code: "GP" }, { name: "Guam", code: "GU" }, { name: "Guatemala", code: "GT" }, { name: "Guernsey", code: "GG" }, { name: "Guinea", code: "GN" }, { name: "Guinea-Bissau", code: "GW" }, { name: "Guyana", code: "GY" }, { name: "Haiti", code: "HT" }, { name: "Heard Island and Mcdonald Islands", code: "HM" }, { name: "Holy See (Vatican City State)", code: "VA" }, { name: "Honduras", code: "HN" }, { name: "Hungary", code: "HU" }, { name: "Iceland", code: "IS" }, { name: "India", code: "IN" }, { name: "Indonesia", code: "ID" }, { name: "Iran, Islamic Republic Of", code: "IR" }, { name: "Iraq", code: "IQ" }, { name: "Ireland", code: "IE" }, { name: "Isle of Man", code: "IM" }, { name: "Israel", code: "IL" }, { name: "Italy", code: "IT" }, { name: "Jamaica", code: "JM" }, { name: "Jersey", code: "JE" }, { name: "Jordan", code: "JO" }, { name: "Kazakhstan", code: "KZ" }, { name: "Kenya", code: "KE" }, { name: "Kiribati", code: "KI" }, { name: "Korea, Democratic People'S Republic of", code: "KP" }, { name: "Korea, Republic of", code: "KR" }, { name: "Kuwait", code: "KW" }, { name: "Kyrgyzstan", code: "KG" }, { name: "Lao People'S Democratic Republic", code: "LA" }, { name: "Latvia", code: "LV" }, { name: "Lebanon", code: "LB" }, { name: "Lesotho", code: "LS" }, { name: "Liberia", code: "LR" }, { name: "Libyan Arab Jamahiriya", code: "LY" }, { name: "Liechtenstein", code: "LI" }, { name: "Lithuania", code: "LT" }, { name: "Luxembourg", code: "LU" }, { name: "Macao", code: "MO" }, { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" }, { name: "Madagascar", code: "MG" }, { name: "Malawi", code: "MW" }, { name: "Malaysia", code: "MY" }, { name: "Maldives", code: "MV" }, { name: "Mali", code: "ML" }, { name: "Malta", code: "MT" }, { name: "Marshall Islands", code: "MH" }, { name: "Martinique", code: "MQ" }, { name: "Mauritania", code: "MR" }, { name: "Mauritius", code: "MU" }, { name: "Mayotte", code: "YT" }, { name: "Mexico", code: "MX" }, { name: "Micronesia, Federated States of", code: "FM" }, { name: "Moldova, Republic of", code: "MD" }, { name: "Monaco", code: "MC" }, { name: "Mongolia", code: "MN" }, { name: "Montserrat", code: "MS" }, { name: "Mozambique", code: "MZ" }, { name: "Myanmar", code: "MM" }, { name: "Namibia", code: "NA" }, { name: "Nauru", code: "NR" }, { name: "Nepal", code: "NP" }, { name: "Netherlands", code: "NL" }, { name: "Netherlands Antilles", code: "AN" }, { name: "New Caledonia", code: "NC" }, { name: "New Zealand", code: "NZ" }, { name: "Nicaragua", code: "NI" }, { name: "Niger", code: "NE" }, { name: "Nigeria", code: "NG" }, { name: "Niue", code: "NU" }, { name: "Norfolk Island", code: "NF" }, { name: "Northern Mariana Islands", code: "MP" }, { name: "Norway", code: "NO" }, { name: "Oman", code: "OM" }, { name: "Pakistan", code: "PK" }, { name: "Palau", code: "PW" }, { name: "Palestinian Territory, Occupied", code: "PS" }, { name: "Panama", code: "PA" }, { name: "Papua New Guinea", code: "PG" }, { name: "Paraguay", code: "PY" }, { name: "Peru", code: "PE" }, { name: "Philippines", code: "PH" }, { name: "Pitcairn", code: "PN" }, { name: "Poland", code: "PL" }, { name: "Portugal", code: "PT" }, { name: "Puerto Rico", code: "PR" }, { name: "Qatar", code: "QA" }, { name: "Reunion", code: "RE" }, { name: "Romania", code: "RO" }, { name: "Russian Federation", code: "RU" }, { name: "RWANDA", code: "RW" }, { name: "Saint Helena", code: "SH" }, { name: "Saint Kitts and Nevis", code: "KN" }, { name: "Saint Lucia", code: "LC" }, { name: "Saint Pierre and Miquelon", code: "PM" }, { name: "Saint Vincent and the Grenadines", code: "VC" }, { name: "Samoa", code: "WS" }, { name: "San Marino", code: "SM" }, { name: "Sao Tome and Principe", code: "ST" }, { name: "Senegal", code: "SN" }, { name: "Serbia and Montenegro", code: "CS" }, { name: "Seychelles", code: "SC" }, { name: "Sierra Leone", code: "SL" }, { name: "Singapore", code: "SG" }, { name: "Slovakia", code: "SK" }, { name: "Slovenia", code: "SI" }, { name: "Solomon Islands", code: "SB" }, { name: "Somalia", code: "SO" }, { name: "South Africa", code: "ZA" }, { name: "South Georgia and the South Sandwich Islands", code: "GS" }, { name: "Spain", code: "ES" }, { name: "Sri Lanka", code: "LK" }, { name: "Sudan", code: "SD" }, { name: "Suriname", code: "SR" }, { name: "Svalbard and Jan Mayen", code: "SJ" }, { name: "Swaziland", code: "SZ" }, { name: "Sweden", code: "SE" }, { name: "Switzerland", code: "CH" }, { name: "Syrian Arab Republic", code: "SY" }, { name: "Tajikistan", code: "TJ" }, { name: "Tanzania, United Republic of", code: "TZ" }, { name: "Thailand", code: "TH" }, { name: "Timor-Leste", code: "TL" }, { name: "Togo", code: "TG" }, { name: "Tokelau", code: "TK" }, { name: "Tonga", code: "TO" }, { name: "Trinidad and Tobago", code: "TT" }, { name: "Tunisia", code: "TN" }, { name: "Turkey", code: "TR" }, { name: "Turkmenistan", code: "TM" }, { name: "Turks and Caicos Islands", code: "TC" }, { name: "Tuvalu", code: "TV" }, { name: "Uganda", code: "UG" }, { name: "Ukraine", code: "UA" }, { name: "United Arab Emirates", code: "AE" }, { name: "United Kingdom", code: "GB" }, { name: "United States Minor Outlying Islands", code: "UM" }, { name: "Uruguay", code: "UY" }, { name: "Uzbekistan", code: "UZ" }, { name: "Vanuatu", code: "VU" }, { name: "Venezuela", code: "VE" }, { name: "Virgin Islands, British", code: "VG" }, { name: "Virgin Islands, U.S.", code: "VI" },
// { name: "Wallis and Futuna", code: "WF" },
{ name: "Western Sahara", code: "EH" }, { name: "Yemen", code: "YE" }, { name: "Zambia", code: "ZM" }, { name: "Zimbabwe", code: "ZW" }];

var Ob = {};

for (var i = 0, len = CountryList.length; i < len; i++) {
    var item = CountryList[i];

    Ob[item.code] = item.name;
}

exports.default = Ob;

/***/ }),
/* 406 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	AL: "355",
	DZ: "213",
	AF: "93",
	AR: "54",
	AE: "971",
	AW: "297",
	OM: "968",
	AZ: "994",
	IE: "353",
	EG: "20",
	ET: "251",
	EE: "372",
	AS: "1684",
	AD: "376",
	AO: "244",
	AI: "1264",
	AQ: "672",
	AG: "1268",
	AM: "374",
	AC: "247",
	AU: "61",
	AT: "43",
	BS: "1242",
	BH: "973",
	BD: "880",
	BB: "1246",
	BY: "375",
	BE: "32",
	BZ: "501",
	BJ: "229",
	BM: "1441",
	BT: "975",
	BO: "591",
	BQ: "599",
	BA: "387",
	BW: "267",
	BV: "",
	BR: "55",
	IO: "246",
	BN: "673",
	BG: "359",
	BF: "226",
	BI: "257",
	KH: "855",
	CM: "237",
	CA: "1",
	IC: "",
	CV: "238",
	KY: "1345",
	CF: "236",
	EA: "",
	TD: "235",
	CL: "56",
	CN: "86",
	CX: "61",
	CP: "",
	CC: "61",
	CO: "57",
	KM: "269",
	CK: "682",
	CR: "506",
	CI: "225",
	HR: "385",
	CU: "53",
	CW: "599",
	CY: "357",
	CZ: "420",
	CD: "243",
	DK: "45",
	DG: "",
	DJ: "253",
	DM: "1767",
	DO: "1809",
	TL: "670",
	EC: "593",

	SV: "503",
	GQ: "240",
	ER: "291",

	EU: "388",
	FK: "500",
	FO: "298",
	FJ: "679",
	FI: "358",
	FR: "33",
	FX: "241",
	// GF: "44",
	PF: "689",
	TF: "",
	GA: "44",
	GM: "220",
	GE: "594",
	DE: "49",
	GH: "233",
	GI: "350",
	GR: "30",
	GL: "299",
	GD: "995",
	// GP: "590",
	GU: "1671",
	GT: "502",
	GG: "",
	GN: "224",
	GW: "245",
	GY: "592",
	HT: "509",
	HM: "",
	HN: "504",
	HK: "852",
	HU: "36",
	IS: "354",
	IN: "91",
	ID: "62",
	IR: "98",
	IQ: "964",
	IM: "44",
	IL: "972",
	IT: "39",
	JM: "1876",
	JP: "81",
	JE: "44",
	JO: "962",
	KZ: "7",
	KE: "254",
	KI: "686",
	KP: "850",
	KR: "82",
	KW: "965",
	KG: "996",
	LA: "856",
	LV: "371",
	LB: "961",
	LS: "266",
	LR: "231",
	LY: "218",
	LI: "423",
	LT: "370",
	LU: "352",
	MO: "853",
	MK: "389",
	MG: "261",
	MW: "265",
	MY: "60",
	MV: "960",
	ML: "223",
	MT: "356",
	MH: "692",
	// MQ: "596",
	MR: "222",
	MU: "230",
	YT: "262",
	MX: "52",
	FM: "691",
	MD: "373",
	MC: "377",
	MN: "976",
	ME: "382",
	MS: "1664",
	MA: "212",
	MZ: "258",
	MM: "95",
	NA: "264",
	NR: "674",
	NP: "977",
	NL: "31",
	NC: "687",
	NZ: "64",
	NI: "505",
	NE: "227",
	NG: "234",
	NU: "683",
	// NF: "672",
	MP: "1670",
	NO: "47",

	PK: "92",
	PW: "680",
	PS: "970",
	PA: "507",
	PG: "675",
	PY: "595",
	PE: "51",
	PH: "63",
	PN: "",
	PL: "48",
	PT: "351",
	PR: "1787",
	QA: "974",
	CG: "242",
	RE: "262",
	RO: "40",
	RU: "7",
	RW: "250",
	BL: "590",
	SH: "290",
	KN: "1869",
	LC: "1758",
	MF: "590",
	PM: "508",
	VC: "1784",
	WS: "685",
	SM: "378",
	ST: "239",
	SA: "966",
	SN: "221",
	RS: "381",
	SC: "248",
	SL: "232",
	SG: "65",
	SX: "1721",
	SK: "421",
	SI: "386",
	SB: "677",
	SO: "252",
	ZA: "27",
	GS: "",
	ES: "34",
	LK: "94",
	SD: "249",
	SR: "597",
	SJ: "47",
	SZ: "268",
	SE: "46",
	CH: "41",
	SY: "963",
	TW: "886",
	TJ: "992",
	TZ: "255",
	TH: "66",
	TG: "228",
	TK: "690",
	TO: "676",
	TT: "1868",
	TA: "290",
	TN: "216",
	TR: "90",
	TM: "993",
	TC: "1649",
	TV: "688",
	SU: "",
	UG: "256",
	UA: "380",
	GB: "44",
	UK: "",
	US: "1",
	UM: "",
	UY: "598",
	UZ: "998",
	VU: "678",
	VA: "379",
	VE: "58",
	VN: "84",
	VG: "1284",
	VI: "1340",
	WF: "681",
	EH: "212",
	YE: "967",
	ZM: "260",
	ZW: "263"
};

/***/ }),
/* 407 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "UserBalanceInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "inBill",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "outDiamond",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "bill",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "diamond",
            "id": 4
        }]
    }, {
        "name": "LiveDetailInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 4
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "location",
            "id": 7
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "roomId",
            "id": 8
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "onlineTotal",
            "id": 9
        }, {
            "rule": "optional",
            "type": "string",
            "name": "roomTitle",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "liveMsg",
            "id": 11
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 12
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "qualityAuth",
            "id": 14
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 15
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 16
        }, {
            "rule": "optional",
            "type": "double",
            "name": "distance",
            "id": 17
        }, {
            "rule": "optional",
            "type": "string",
            "name": "distanceStr",
            "id": 18
        }, {
            "rule": "optional",
            "type": "string",
            "name": "bigAvatar",
            "id": 19
        }, {
            "rule": "optional",
            "type": "LiveType",
            "name": "liveType",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "enterNeedDiamond",
            "id": 21
        }, {
            "rule": "repeated",
            "type": "LiveLabel",
            "name": "liveLabels",
            "id": 22
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "voiceFlag",
            "id": 23
        }, {
            "rule": "optional",
            "type": "string",
            "name": "ab",
            "id": 24
        }, {
            "rule": "optional",
            "type": "string",
            "name": "labels",
            "id": 25
        }, {
            "rule": "optional",
            "type": "borderType",
            "name": "borderType",
            "id": 26
        }, {
            "rule": "optional",
            "type": "string",
            "name": "borderPicUrl",
            "id": 27
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "isLandscape",
            "id": 28
        }, {
            "rule": "optional",
            "type": "string",
            "name": "gameId",
            "id": 29
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "roomType",
            "id": 30
        }, {
            "rule": "optional",
            "type": "string",
            "name": "roomTypeInfo",
            "id": 31
        }]
    }, {
        "name": "LiveLabel",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "labelName",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "labelValue",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "ext",
            "id": 3
        }]
    }, {
        "name": "ProfileInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "setting",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "password",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "userToken",
            "id": 8
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "location",
            "id": 11
        }, {
            "rule": "optional",
            "type": "string",
            "name": "mobilePhone",
            "id": 12
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "fanTotal",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followTotal",
            "id": 14
        }, {
            "rule": "optional",
            "type": "UserBalanceInfo",
            "name": "balance",
            "id": 15
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "chatroomid",
            "id": 16
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followType",
            "id": 17
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "exp",
            "id": 18
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "currentExp",
            "id": 19
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "nextExp",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 21
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 22
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "qualityAuth",
            "id": 23
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 25
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "admin",
            "id": 26
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "userRealNameAuth",
            "id": 27
        }, {
            "rule": "optional",
            "type": "string",
            "name": "acceptAgreement",
            "id": 28
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "upliveCodeStatus",
            "id": 29
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "subscribe",
            "id": 30
        }, {
            "rule": "repeated",
            "type": "Source",
            "name": "sources",
            "id": 31
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "dynamicCount",
            "id": 32
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "dynamicPublishRight",
            "id": 33
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "liveType",
            "id": 34
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "enterNeedDiamond",
            "id": 35
        }, {
            "rule": "repeated",
            "type": "LiveLabel",
            "name": "liveLabels",
            "id": 36
        }, {
            "rule": "optional",
            "type": "string",
            "name": "ipForCountry",
            "id": 37
        }, {
            "rule": "optional",
            "type": "string",
            "name": "dynamicManageRights",
            "id": 38
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "newUserDueTime",
            "id": 39
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "newUser",
            "id": 40
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "hostStatus",
            "id": 41
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "guardCount",
            "id": 42
        }]
    }, {
        "name": "Source",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "bindType",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "openId",
            "id": 2
        }]
    }, {
        "name": "User",
        "fields": [],
        "messages": [{
            "name": "Login",
            "fields": [],
            "options": {
                "objc_class_prefix": "UserLogin",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "int32",
                    "name": "loginType",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "BindType",
                    "name": "bindType",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "thirdId",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "int64",
                    "name": "uid",
                    "id": 4
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "password",
                    "id": 5
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "location",
                    "id": 6
                }, {
                    "rule": "optional",
                    "type": "PushType",
                    "name": "pushType",
                    "id": 7
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "pushToken",
                    "id": 8
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "deviceId",
                    "id": 9
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "ProfileInfo",
                    "name": "profile",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "bool",
                    "name": "isFirstLogin",
                    "id": 2
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "BindType",
        "values": [{
            "name": "DEFAULT_TYPE",
            "id": 0
        }, {
            "name": "MOBILE_PHONE",
            "id": 1
        }, {
            "name": "QQ",
            "id": 2
        }, {
            "name": "WEIXIN",
            "id": 3
        }, {
            "name": "FACEBOOK",
            "id": 4
        }, {
            "name": "SINA_WEIBO",
            "id": 5
        }, {
            "name": "RR",
            "id": 6
        }, {
            "name": "TENCENT_WANBA",
            "id": 7
        }, {
            "name": "KECHENGGEZI",
            "id": 8
        }, {
            "name": "DEVICE",
            "id": 9
        }, {
            "name": "GOOGLE",
            "id": 15
        }, {
            "name": "TWITTER",
            "id": 16
        }, {
            "name": "EMAIL",
            "id": 17
        }, {
            "name": "LINE_BIND",
            "id": 19
        }, {
            "name": "KAKAO",
            "id": 20
        }, {
            "name": "WEIXIN_MINI_PROGRAM",
            "id": 21
        }, {
            "name": "TELEGRAM",
            "id": 23
        }]
    }, {
        "name": "PushType",
        "values": [{
            "name": "DEFAULT_PUSHTYPE",
            "id": 0
        }, {
            "name": "BAIDU",
            "id": 1
        }, {
            "name": "IOS",
            "id": 2
        }, {
            "name": "JPUSH",
            "id": 3
        }, {
            "name": "XIAOMI",
            "id": 4
        }, {
            "name": "GETUI",
            "id": 5
        }, {
            "name": "GOOGLE_PUSH",
            "id": 6
        }, {
            "name": "SAMSUNG",
            "id": 7
        }, {
            "name": "MEIZU",
            "id": 8
        }, {
            "name": "HUAWEI",
            "id": 9
        }, {
            "name": "GOOGLE_FCM",
            "id": 10
        }]
    }, {
        "name": "LiveType",
        "values": [{
            "name": "PUBLIC_FREE",
            "id": 0
        }, {
            "name": "PUBLIC_CHARGE",
            "id": 1
        }, {
            "name": "PRIVATE_FREE",
            "id": 2
        }, {
            "name": "PRIVATE_CHARGE",
            "id": 3
        }]
    }, {
        "name": "borderType",
        "values": [{
            "name": "PRESERVE",
            "id": 0
        }, {
            "name": "ANCHOR",
            "id": 1
        }, {
            "name": "BIRTHDAY",
            "id": 2
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 408 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * 国家电话区位码
 */
var CountryList = [{ name: "China", code: "CN" }, { name: "Taiwan", code: "TW" }, { name: "Hong Kong", code: "HK" }, { name: "United States", code: "US" }, { name: "Viet Nam", code: "VN" }, { name: "Japan", code: "JP" }, { name: "Egypt", code: "EG" }, { name: "Morocco", code: "MA" }, { name: "Saudi Arabia", code: "SA" }, { name: "Afghanistan", code: "AF" }, { name: "Åland Islands", code: "AX" }, { name: "Albania", code: "AL" }, { name: "Algeria", code: "DZ" }, { name: "American Samoa", code: "AS" }, { name: "AndorrA", code: "AD" }, { name: "Angola", code: "AO" }, { name: "Anguilla", code: "AI" }, { name: "Antarctica", code: "AQ" }, { name: "Antigua and Barbuda", code: "AG" }, { name: "Argentina", code: "AR" }, { name: "Armenia", code: "AM" }, { name: "Aruba", code: "AW" }, { name: "Australia", code: "AU" }, { name: "Austria", code: "AT" }, { name: "Azerbaijan", code: "AZ" }, { name: "Bahamas", code: "BS" }, { name: "Bahrain", code: "BH" }, { name: "Bangladesh", code: "BD" }, { name: "Barbados", code: "BB" }, { name: "Belarus", code: "BY" }, { name: "Belgium", code: "BE" }, { name: "Belize", code: "BZ" }, { name: "Benin", code: "BJ" }, { name: "Bermuda", code: "BM" }, { name: "Bhutan", code: "BT" }, { name: "Bolivia", code: "BO" }, { name: "Bosnia and Herzegovina", code: "BA" }, { name: "Botswana", code: "BW" }, { name: "Bouvet Island", code: "BV" }, { name: "Brazil", code: "BR" }, { name: "British Indian Ocean Territory", code: "IO" }, { name: "Brunei Darussalam", code: "BN" }, { name: "Bulgaria", code: "BG" }, { name: "Burkina Faso", code: "BF" }, { name: "Burundi", code: "BI" }, { name: "Cambodia", code: "KH" }, { name: "Cameroon", code: "CM" }, { name: "Canada", code: "CA" }, { name: "Cape Verde", code: "CV" }, { name: "Cayman Islands", code: "KY" }, { name: "Central African Republic", code: "CF" }, { name: "Chad", code: "TD" }, { name: "Chile", code: "CL" }, { name: "Christmas Island", code: "CX" }, { name: "Cocos (Keeling) Islands", code: "CC" }, { name: "Colombia", code: "CO" }, { name: "Comoros", code: "KM" }, { name: "Congo", code: "CG" }, { name: "Congo, The Democratic Republic of the", code: "CD" }, { name: "Cook Islands", code: "CK" }, { name: "Costa Rica", code: "CR" }, { name: "Cote D'Ivoire", code: "CI" }, { name: "Croatia", code: "HR" }, { name: "Cuba", code: "CU" }, { name: "Cyprus", code: "CY" }, { name: "Czech Republic", code: "CZ" }, { name: "Denmark", code: "DK" }, { name: "Djibouti", code: "DJ" }, { name: "Dominica", code: "DM" }, { name: "Dominican Republic", code: "DO" }, { name: "Ecuador", code: "EC" }, { name: "El Salvador", code: "SV" }, { name: "Equatorial Guinea", code: "GQ" }, { name: "Eritrea", code: "ER" }, { name: "Estonia", code: "EE" }, { name: "Ethiopia", code: "ET" }, { name: "Falkland Islands (Malvinas)", code: "FK" }, { name: "Faroe Islands", code: "FO" }, { name: "Fiji", code: "FJ" }, { name: "Finland", code: "FI" }, { name: "France", code: "FR" }, { name: "French Guiana", code: "GF" }, { name: "French Polynesia", code: "PF" }, { name: "French Southern Territories", code: "TF" }, { name: "Gabon", code: "GA" }, { name: "Gambia", code: "GM" }, { name: "Georgia", code: "GE" }, { name: "Germany", code: "DE" }, { name: "Ghana", code: "GH" }, { name: "Gibraltar", code: "GI" }, { name: "Greece", code: "GR" }, { name: "Greenland", code: "GL" }, { name: "Grenada", code: "GD" }, { name: "Guadeloupe", code: "GP" }, { name: "Guam", code: "GU" }, { name: "Guatemala", code: "GT" }, { name: "Guernsey", code: "GG" }, { name: "Guinea", code: "GN" }, { name: "Guinea-Bissau", code: "GW" }, { name: "Guyana", code: "GY" }, { name: "Haiti", code: "HT" }, { name: "Heard Island and Mcdonald Islands", code: "HM" }, { name: "Holy See (Vatican City State)", code: "VA" }, { name: "Honduras", code: "HN" }, { name: "Hungary", code: "HU" }, { name: "Iceland", code: "IS" }, { name: "India", code: "IN" }, { name: "Indonesia", code: "ID" }, { name: "Iran, Islamic Republic Of", code: "IR" }, { name: "Iraq", code: "IQ" }, { name: "Ireland", code: "IE" }, { name: "Isle of Man", code: "IM" }, { name: "Israel", code: "IL" }, { name: "Italy", code: "IT" }, { name: "Jamaica", code: "JM" }, { name: "Jersey", code: "JE" }, { name: "Jordan", code: "JO" }, { name: "Kazakhstan", code: "KZ" }, { name: "Kenya", code: "KE" }, { name: "Kiribati", code: "KI" }, { name: "Korea, Democratic People'S Republic of", code: "KP" }, { name: "Korea, Republic of", code: "KR" }, { name: "Kuwait", code: "KW" }, { name: "Kyrgyzstan", code: "KG" }, { name: "Lao People'S Democratic Republic", code: "LA" }, { name: "Latvia", code: "LV" }, { name: "Lebanon", code: "LB" }, { name: "Lesotho", code: "LS" }, { name: "Liberia", code: "LR" }, { name: "Libyan Arab Jamahiriya", code: "LY" }, { name: "Liechtenstein", code: "LI" }, { name: "Lithuania", code: "LT" }, { name: "Luxembourg", code: "LU" }, { name: "Macao", code: "MO" }, { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" }, { name: "Madagascar", code: "MG" }, { name: "Malawi", code: "MW" }, { name: "Malaysia", code: "MY" }, { name: "Maldives", code: "MV" }, { name: "Mali", code: "ML" }, { name: "Malta", code: "MT" }, { name: "Marshall Islands", code: "MH" }, { name: "Martinique", code: "MQ" }, { name: "Mauritania", code: "MR" }, { name: "Mauritius", code: "MU" }, { name: "Mayotte", code: "YT" }, { name: "Mexico", code: "MX" }, { name: "Micronesia, Federated States of", code: "FM" }, { name: "Moldova, Republic of", code: "MD" }, { name: "Monaco", code: "MC" }, { name: "Mongolia", code: "MN" }, { name: "Montserrat", code: "MS" }, { name: "Mozambique", code: "MZ" }, { name: "Myanmar", code: "MM" }, { name: "Namibia", code: "NA" }, { name: "Nauru", code: "NR" }, { name: "Nepal", code: "NP" }, { name: "Netherlands", code: "NL" }, { name: "Netherlands Antilles", code: "AN" }, { name: "New Caledonia", code: "NC" }, { name: "New Zealand", code: "NZ" }, { name: "Nicaragua", code: "NI" }, { name: "Niger", code: "NE" }, { name: "Nigeria", code: "NG" }, { name: "Niue", code: "NU" }, { name: "Norfolk Island", code: "NF" }, { name: "Northern Mariana Islands", code: "MP" }, { name: "Norway", code: "NO" }, { name: "Oman", code: "OM" }, { name: "Pakistan", code: "PK" }, { name: "Palau", code: "PW" }, { name: "Palestinian Territory, Occupied", code: "PS" }, { name: "Panama", code: "PA" }, { name: "Papua New Guinea", code: "PG" }, { name: "Paraguay", code: "PY" }, { name: "Peru", code: "PE" }, { name: "Philippines", code: "PH" }, { name: "Pitcairn", code: "PN" }, { name: "Poland", code: "PL" }, { name: "Portugal", code: "PT" }, { name: "Puerto Rico", code: "PR" }, { name: "Qatar", code: "QA" }, { name: "Reunion", code: "RE" }, { name: "Romania", code: "RO" }, { name: "Russian Federation", code: "RU" }, { name: "RWANDA", code: "RW" }, { name: "Saint Helena", code: "SH" }, { name: "Saint Kitts and Nevis", code: "KN" }, { name: "Saint Lucia", code: "LC" }, { name: "Saint Pierre and Miquelon", code: "PM" }, { name: "Saint Vincent and the Grenadines", code: "VC" }, { name: "Samoa", code: "WS" }, { name: "San Marino", code: "SM" }, { name: "Sao Tome and Principe", code: "ST" }, { name: "Senegal", code: "SN" }, { name: "Serbia and Montenegro", code: "CS" }, { name: "Seychelles", code: "SC" }, { name: "Sierra Leone", code: "SL" }, { name: "Singapore", code: "SG" }, { name: "Slovakia", code: "SK" }, { name: "Slovenia", code: "SI" }, { name: "Solomon Islands", code: "SB" }, { name: "Somalia", code: "SO" }, { name: "South Africa", code: "ZA" }, { name: "South Georgia and the South Sandwich Islands", code: "GS" }, { name: "Spain", code: "ES" }, { name: "Sri Lanka", code: "LK" }, { name: "Sudan", code: "SD" }, { name: "Suriname", code: "SR" }, { name: "Svalbard and Jan Mayen", code: "SJ" }, { name: "Swaziland", code: "SZ" }, { name: "Sweden", code: "SE" }, { name: "Switzerland", code: "CH" }, { name: "Syrian Arab Republic", code: "SY" }, { name: "Tajikistan", code: "TJ" }, { name: "Tanzania, United Republic of", code: "TZ" }, { name: "Thailand", code: "TH" }, { name: "Timor-Leste", code: "TL" }, { name: "Togo", code: "TG" }, { name: "Tokelau", code: "TK" }, { name: "Tonga", code: "TO" }, { name: "Trinidad and Tobago", code: "TT" }, { name: "Tunisia", code: "TN" }, { name: "Turkey", code: "TR" }, { name: "Turkmenistan", code: "TM" }, { name: "Turks and Caicos Islands", code: "TC" }, { name: "Tuvalu", code: "TV" }, { name: "Uganda", code: "UG" }, { name: "Ukraine", code: "UA" }, { name: "United Arab Emirates", code: "AE" }, { name: "United Kingdom", code: "GB" }, { name: "United States Minor Outlying Islands", code: "UM" }, { name: "Uruguay", code: "UY" }, { name: "Uzbekistan", code: "UZ" }, { name: "Vanuatu", code: "VU" }, { name: "Venezuela", code: "VE" }, { name: "Virgin Islands, British", code: "VG" }, { name: "Virgin Islands, U.S.", code: "VI" },
// { name: "Wallis and Futuna", code: "WF" },
{ name: "Western Sahara", code: "EH" }, { name: "Yemen", code: "YE" }, { name: "Zambia", code: "ZM" }, { name: "Zimbabwe", code: "ZW" }];

var Ob = {};

for (var i = 0, len = CountryList.length; i < len; i++) {
    var item = CountryList[i];

    Ob[item.code] = item.name;
}

exports.default = Ob;

/***/ }),
/* 409 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	AL: "355",
	DZ: "213",
	AF: "93",
	AR: "54",
	AE: "971",
	AW: "297",
	OM: "968",
	AZ: "994",
	IE: "353",
	EG: "20",
	ET: "251",
	EE: "372",
	AS: "1684",
	AD: "376",
	AO: "244",
	AI: "1264",
	AQ: "672",
	AG: "1268",
	AM: "374",
	AC: "247",
	AU: "61",
	AT: "43",
	BS: "1242",
	BH: "973",
	BD: "880",
	BB: "1246",
	BY: "375",
	BE: "32",
	BZ: "501",
	BJ: "229",
	BM: "1441",
	BT: "975",
	BO: "591",
	BQ: "599",
	BA: "387",
	BW: "267",
	BV: "",
	BR: "55",
	IO: "246",
	BN: "673",
	BG: "359",
	BF: "226",
	BI: "257",
	KH: "855",
	CM: "237",
	CA: "1",
	IC: "",
	CV: "238",
	KY: "1345",
	CF: "236",
	EA: "",
	TD: "235",
	CL: "56",
	CN: "86",
	CX: "61",
	CP: "",
	CC: "61",
	CO: "57",
	KM: "269",
	CK: "682",
	CR: "506",
	CI: "225",
	HR: "385",
	CU: "53",
	CW: "599",
	CY: "357",
	CZ: "420",
	CD: "243",
	DK: "45",
	DG: "",
	DJ: "253",
	DM: "1767",
	DO: "1809",
	TL: "670",
	EC: "593",

	SV: "503",
	GQ: "240",
	ER: "291",

	EU: "388",
	FK: "500",
	FO: "298",
	FJ: "679",
	FI: "358",
	FR: "33",
	FX: "241",
	// GF: "44",
	PF: "689",
	TF: "",
	GA: "44",
	GM: "220",
	GE: "594",
	DE: "49",
	GH: "233",
	GI: "350",
	GR: "30",
	GL: "299",
	GD: "995",
	// GP: "590",
	GU: "1671",
	GT: "502",
	GG: "",
	GN: "224",
	GW: "245",
	GY: "592",
	HT: "509",
	HM: "",
	HN: "504",
	HK: "852",
	HU: "36",
	IS: "354",
	IN: "91",
	ID: "62",
	IR: "98",
	IQ: "964",
	IM: "44",
	IL: "972",
	IT: "39",
	JM: "1876",
	JP: "81",
	JE: "44",
	JO: "962",
	KZ: "7",
	KE: "254",
	KI: "686",
	KP: "850",
	KR: "82",
	KW: "965",
	KG: "996",
	LA: "856",
	LV: "371",
	LB: "961",
	LS: "266",
	LR: "231",
	LY: "218",
	LI: "423",
	LT: "370",
	LU: "352",
	MO: "853",
	MK: "389",
	MG: "261",
	MW: "265",
	MY: "60",
	MV: "960",
	ML: "223",
	MT: "356",
	MH: "692",
	// MQ: "596",
	MR: "222",
	MU: "230",
	YT: "262",
	MX: "52",
	FM: "691",
	MD: "373",
	MC: "377",
	MN: "976",
	ME: "382",
	MS: "1664",
	MA: "212",
	MZ: "258",
	MM: "95",
	NA: "264",
	NR: "674",
	NP: "977",
	NL: "31",
	NC: "687",
	NZ: "64",
	NI: "505",
	NE: "227",
	NG: "234",
	NU: "683",
	// NF: "672",
	MP: "1670",
	NO: "47",

	PK: "92",
	PW: "680",
	PS: "970",
	PA: "507",
	PG: "675",
	PY: "595",
	PE: "51",
	PH: "63",
	PN: "",
	PL: "48",
	PT: "351",
	PR: "1787",
	QA: "974",
	CG: "242",
	RE: "262",
	RO: "40",
	RU: "7",
	RW: "250",
	BL: "590",
	SH: "290",
	KN: "1869",
	LC: "1758",
	MF: "590",
	PM: "508",
	VC: "1784",
	WS: "685",
	SM: "378",
	ST: "239",
	SA: "966",
	SN: "221",
	RS: "381",
	SC: "248",
	SL: "232",
	SG: "65",
	SX: "1721",
	SK: "421",
	SI: "386",
	SB: "677",
	SO: "252",
	ZA: "27",
	GS: "",
	ES: "34",
	LK: "94",
	SD: "249",
	SR: "597",
	SJ: "47",
	SZ: "268",
	SE: "46",
	CH: "41",
	SY: "963",
	TW: "886",
	TJ: "992",
	TZ: "255",
	TH: "66",
	TG: "228",
	TK: "690",
	TO: "676",
	TT: "1868",
	TA: "290",
	TN: "216",
	TR: "90",
	TM: "993",
	TC: "1649",
	TV: "688",
	SU: "",
	UG: "256",
	UA: "380",
	GB: "44",
	UK: "",
	US: "1",
	UM: "",
	UY: "598",
	UZ: "998",
	VU: "678",
	VA: "379",
	VE: "58",
	VN: "84",
	VG: "1284",
	VI: "1340",
	WF: "681",
	EH: "212",
	YE: "967",
	ZM: "260",
	ZW: "263"
};

/***/ }),
/* 410 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "UserBalanceInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "inBill",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "outDiamond",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "bill",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "diamond",
            "id": 4
        }]
    }, {
        "name": "ProfileInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "setting",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "password",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "userToken",
            "id": 8
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "location",
            "id": 11
        }, {
            "rule": "optional",
            "type": "string",
            "name": "mobilePhone",
            "id": 12
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "fanTotal",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followTotal",
            "id": 14
        }, {
            "rule": "optional",
            "type": "UserBalanceInfo",
            "name": "balance",
            "id": 15
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "chatroomid",
            "id": 16
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followType",
            "id": 17
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "exp",
            "id": 18
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "currentExp",
            "id": 19
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "nextExp",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 21
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 22
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "qualityAuth",
            "id": 23
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 25
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "admin",
            "id": 26
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "userRealNameAuth",
            "id": 27
        }, {
            "rule": "optional",
            "type": "string",
            "name": "acceptAgreement",
            "id": 28
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "upliveCodeStatus",
            "id": 29
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "subscribe",
            "id": 30
        }, {
            "rule": "repeated",
            "type": "Source",
            "name": "sources",
            "id": 31
        }]
    }, {
        "name": "Source",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "bindType",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "openId",
            "id": 2
        }]
    }, {
        "name": "ThirdParty",
        "fields": [],
        "messages": [{
            "name": "Check",
            "fields": [],
            "options": {
                "objc_class_prefix": "ThirdPartyCheck",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "BindType",
                    "name": "bindType",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "thirdId",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "thirdToken",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "extension",
                    "id": 4
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "ProfileInfo",
                    "name": "profile",
                    "id": 1
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "BindType",
        "values": [{
            "name": "DEFAULT_TYPE",
            "id": 0
        }, {
            "name": "MOBILE_PHONE",
            "id": 1
        }, {
            "name": "QQ",
            "id": 2
        }, {
            "name": "WEIXIN",
            "id": 3
        }, {
            "name": "FACEBOOK",
            "id": 4
        }, {
            "name": "SINA_WEIBO",
            "id": 5
        }, {
            "name": "RR",
            "id": 6
        }, {
            "name": "TENCENT_WANBA",
            "id": 7
        }, {
            "name": "KECHENGGEZI",
            "id": 8
        }, {
            "name": "DEVICE",
            "id": 9
        }, {
            "name": "GOOGLE",
            "id": 15
        }, {
            "name": "TWITTER",
            "id": 16
        }, {
            "name": "EMAIL",
            "id": 17
        }]
    }, {
        "name": "PushType",
        "values": [{
            "name": "DEFAULT_PUSHTYPE",
            "id": 0
        }, {
            "name": "BAIDU",
            "id": 1
        }, {
            "name": "IOS",
            "id": 2
        }, {
            "name": "JPUSH",
            "id": 3
        }, {
            "name": "XIAOMI",
            "id": 4
        }, {
            "name": "GETUI",
            "id": 5
        }, {
            "name": "GOOGLE_PUSH",
            "id": 6
        }, {
            "name": "SAMSUNG",
            "id": 7
        }, {
            "name": "MEIZU",
            "id": 8
        }, {
            "name": "HUAWEI",
            "id": 9
        }, {
            "name": "GOOGLE_FCM",
            "id": 10
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _smssendcode = __webpack_require__(412);

var _smssendcode2 = _interopRequireDefault(_smssendcode);

var _md = __webpack_require__(68);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pbajax = new _pbajax2.default();
var cache = new _cCache2.default({
    prefix: 'pcuplive'
});

var SmsSendCode = function () {
    function SmsSendCode() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, SmsSendCode);

        this.promise = this.sendCode(data);
    }

    _createClass(SmsSendCode, [{
        key: 'sendCode',
        value: function sendCode(data) {

            var self = this;
            var defer = $.Deferred();
            var _smsSendCodePb$Sms$Se = _smssendcode2.default.Sms.SendCode,
                Request = _smsSendCodePb$Sms$Se.Request,
                Response = _smsSendCodePb$Sms$Se.Response;


            var UserAgent = UP.Global.getDefaultUA();

            if (UserAgent.indexOf('feature/9999') > -1) {
                UserAgent += ' feature/9999';
            }

            data.deviceId = this.getCurrentUuid();
            var signature = this.getSignature(UserAgent, data.deviceId);
            data.signature = signature;
            var businessData = new Request(data);

            var requestData = {
                service: 'service',
                api: '/sms/send/code',
                header: {
                    userToken: UP.Global.getUserToken(),
                    'UserAgent': UserAgent,
                    'Accept-Language': UP.Global.siteLanguage
                }
            };

            pbajax.do(requestData, businessData, function (res) {
                var dataWrap = _public2.default.Result.decode(res);

                if (dataWrap.code == 1) {

                    defer.resolve();
                } else {
                    defer.reject();
                }
            }, function () {
                defer.reject();
            }, function () {
                defer.reject();
            });
            return defer;
        }
        /**生成签名串*/

    }, {
        key: 'getSignature',
        value: function getSignature(ua, deviceId) {
            /*
             S1 =设备号的aes加密后的md5后24位 （密钥为  jq5kmuqcWkrJD7M）
             S2 = （UserAgent的md5+设备号）的md5后8位。
             signature=S1+S2
             */
            var secret = 'jq5kmuqcWkrJD7M';
            var str = (0, _md.hex_md5)(deviceId + secret);
            var s1 = str.substr(str.length - 24);
            var str2 = (0, _md.hex_md5)((0, _md.hex_md5)(ua) + deviceId);
            var s2 = str2.substr(str2.length - 8);

            return s1 + s2;
        }

        /**
         * 模拟当前用户的身份标示
         * @param 
         * @return string
         */

    }, {
        key: 'uuid',
        value: function uuid(len, radix) {
            var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
            var uuid = [],
                i;
            radix = radix || chars.length;

            if (len) {
                // Compact form
                for (i = 0; i < len; i++) {
                    uuid[i] = chars[0 | Math.random() * radix];
                }
            } else {
                // rfc4122, version 4 form
                var r;

                // rfc4122 requires these characters
                uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
                uuid[14] = '4';

                // Fill in random data.  At i==19 set the high bits of clock sequence as
                // per rfc4122, sec. 4.1.5
                for (i = 0; i < 36; i++) {
                    if (!uuid[i]) {
                        r = 0 | Math.random() * 16;
                        uuid[i] = chars[i == 19 ? r & 0x3 | 0x8 : r];
                    }
                }
            }

            return uuid.join('');
        }

        // 获取当前有效的uuid（有效期5分钟）

    }, {
        key: 'getCurrentUuid',
        value: function getCurrentUuid() {
            // __ppuuid__ : uuid,timestamp
            var uuid = '';
            var old = cache.getCache('__pcuuid__');
            if (old) {
                var isExpire = this.checkExpire();

                // 若已失效
                if (isExpire) {
                    uuid = this.uuid(60);
                    cache.setCache('__pcuuid__', uuid);
                    cache.setCache('__pcuuid__stamp__', +new Date());
                } else {
                    uuid = old;
                    this.updateValidTime();
                }
            } else {
                uuid = this.uuid(60);
                cache.setCache('__pcuuid__', uuid);
                cache.setCache('__pcuuid__stamp__', +new Date());
            }

            return uuid;
        }

        // 判断uuid是否失效(超过1天)

    }, {
        key: 'checkExpire',
        value: function checkExpire() {
            var stamp = cache.getCache('__pcuuid__stamp__');
            var curStamp = +new Date();
            return curStamp - Number(stamp) > 24 * 60 * 60 * 1000;
        }

        // 更新当前的有效期

    }, {
        key: 'updateValidTime',
        value: function updateValidTime() {
            cache.setCache('__pcuuid__stamp__', +new Date());
        }
    }]);

    return SmsSendCode;
}();

exports.default = SmsSendCode;

/***/ }),
/* 412 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Sms.SendCode",
    "options": {
        "objc_class_prefix": "SmsSendCode",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Request",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "mobilePhone",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "deviceId",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "module",
            "id": 4
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _usersetpwd = __webpack_require__(414);

var _usersetpwd2 = _interopRequireDefault(_usersetpwd);

var _md = __webpack_require__(68);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pbajax = new _pbajax2.default();
var cache = new _cCache2.default({
    prefix: 'pcuplive'
});

var UserSetPwd = function () {
    function UserSetPwd() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, UserSetPwd);

        this.promise = this.findPwd(data);
    }

    _createClass(UserSetPwd, [{
        key: 'findPwd',
        value: function findPwd(data) {

            var self = this;
            var defer = $.Deferred();
            var _UserSetPwdPb$User$Se = _usersetpwd2.default.User.SetPassword,
                Request = _UserSetPwdPb$User$Se.Request,
                Response = _UserSetPwdPb$User$Se.Response;


            var businessData = new Request(data);

            var requestData = {
                service: 'service',
                api: '/user/set/password',
                header: {
                    userToken: UP.Global.getUserToken()

                }
            };

            pbajax.do(requestData, businessData, function (res) {
                var dataWrap = _public2.default.Result.decode(res);

                if (dataWrap.code == 1) {

                    defer.resolve(dataWrap);
                } else {
                    defer.reject(dataWrap);
                }
            }, function () {
                defer.reject();
            }, function () {
                defer.reject();
            });
            return defer;
        }
    }]);

    return UserSetPwd;
}();

exports.default = UserSetPwd;

/***/ }),
/* 414 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "User",
        "fields": [],
        "messages": [{
            "name": "SetPassword",
            "fields": [],
            "options": {
                "objc_class_prefix": "UserSetPassword",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "BindType",
                    "name": "bindType",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "thirdId",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "verifyCode",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "password",
                    "id": 4
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "BindType",
        "values": [{
            "name": "DEFAULT_TYPE",
            "id": 0
        }, {
            "name": "MOBILE_PHONE",
            "id": 1
        }, {
            "name": "QQ",
            "id": 2
        }, {
            "name": "WEIXIN",
            "id": 3
        }, {
            "name": "FACEBOOK",
            "id": 4
        }, {
            "name": "SINA_WEIBO",
            "id": 5
        }, {
            "name": "RR",
            "id": 6
        }, {
            "name": "TENCENT_WANBA",
            "id": 7
        }, {
            "name": "KECHENGGEZI",
            "id": 8
        }, {
            "name": "DEVICE",
            "id": 9
        }, {
            "name": "GOOGLE",
            "id": 15
        }, {
            "name": "TWITTER",
            "id": 16
        }, {
            "name": "EMAIL",
            "id": 17
        }, {
            "name": "LINE_BIND",
            "id": 19
        }, {
            "name": "KAKAO",
            "id": 20
        }, {
            "name": "WEIXIN_MINI_PROGRAM",
            "id": 21
        }, {
            "name": "TELEGRAM",
            "id": 23
        }]
    }, {
        "name": "PushType",
        "values": [{
            "name": "DEFAULT_PUSHTYPE",
            "id": 0
        }, {
            "name": "BAIDU",
            "id": 1
        }, {
            "name": "IOS",
            "id": 2
        }, {
            "name": "JPUSH",
            "id": 3
        }, {
            "name": "XIAOMI",
            "id": 4
        }, {
            "name": "GETUI",
            "id": 5
        }, {
            "name": "GOOGLE_PUSH",
            "id": 6
        }, {
            "name": "SAMSUNG",
            "id": 7
        }, {
            "name": "MEIZU",
            "id": 8
        }, {
            "name": "HUAWEI",
            "id": 9
        }, {
            "name": "GOOGLE_FCM",
            "id": 10
        }]
    }, {
        "name": "LiveType",
        "values": [{
            "name": "PUBLIC_FREE",
            "id": 0
        }, {
            "name": "PUBLIC_CHARGE",
            "id": 1
        }, {
            "name": "PRIVATE_FREE",
            "id": 2
        }, {
            "name": "PRIVATE_CHARGE",
            "id": 3
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cUpLoading = __webpack_require__(13);

var _cUpLoading2 = _interopRequireDefault(_cUpLoading);

var _cNotification = __webpack_require__(11);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _index = __webpack_require__(204);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 手机注册
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var PhoneRegister = function (_Component) {
	_inherits(PhoneRegister, _Component);

	function PhoneRegister(props) {
		_classCallCheck(this, PhoneRegister);

		var _this = _possibleConstructorReturn(this, (PhoneRegister.__proto__ || Object.getPrototypeOf(PhoneRegister)).call(this, props));

		_this.state = {
			progress: props.childProps.progress,
			childProps: props.childProps
		};
		return _this;
	}

	_createClass(PhoneRegister, [{
		key: 'setInitState',
		value: function setInitState(state) {
			this.refs.phoneLoginWrap.setInitState(state);
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'pop-no-tab' },
				_react2.default.createElement(_index2.default, _extends({ userProcess: 'register' }, this.state.childProps, { ref: 'phoneLoginWrap' }))
			);
		}
	}]);

	return PhoneRegister;
}(_react.Component);

module.exports = PhoneRegister;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 检测第三方账号是否已经绑定过
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _userfindpassword = __webpack_require__(417);

var _userfindpassword2 = _interopRequireDefault(_userfindpassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pbajax = new _pbajax2.default();

var FindPwd = function () {
    function FindPwd() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, FindPwd);

        this.promise = this.findPwd(data);
    }

    _createClass(FindPwd, [{
        key: 'findPwd',
        value: function findPwd(data) {
            var defer = $.Deferred();
            var _findPwdPb$User$FindP = _userfindpassword2.default.User.FindPassword,
                Request = _findPwdPb$User$FindP.Request,
                Response = _findPwdPb$User$FindP.Response;


            var businessData = new Request(data);

            var requestData = {
                service: 'service',
                api: '/user/find/password',
                header: {
                    'Accept-Language': UP.Global.siteLanguage
                }
            };

            pbajax.do(requestData, businessData, function (res) {
                var dataWrap = _public2.default.Result.decode(res);

                if (dataWrap.code == 1) {
                    // 已绑定过
                    defer.resolve(true);
                } else {
                    defer.reject(dataWrap);
                }
            }, function () {
                defer.reject();
            }, function () {
                defer.reject();
            });
            return defer.promise();
        }
    }]);

    return FindPwd;
}();

exports.default = FindPwd;

/***/ }),
/* 417 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "User",
        "fields": [],
        "messages": [{
            "name": "FindPassword",
            "fields": [],
            "options": {
                "objc_class_prefix": "UserFindPassword",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "BindType",
                    "name": "bindType",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "thirdId",
                    "id": 2
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "BindType",
        "values": [{
            "name": "DEFAULT_TYPE",
            "id": 0
        }, {
            "name": "MOBILE_PHONE",
            "id": 1
        }, {
            "name": "QQ",
            "id": 2
        }, {
            "name": "WEIXIN",
            "id": 3
        }, {
            "name": "FACEBOOK",
            "id": 4
        }, {
            "name": "SINA_WEIBO",
            "id": 5
        }, {
            "name": "RR",
            "id": 6
        }, {
            "name": "TENCENT_WANBA",
            "id": 7
        }, {
            "name": "KECHENGGEZI",
            "id": 8
        }, {
            "name": "DEVICE",
            "id": 9
        }, {
            "name": "GOOGLE",
            "id": 15
        }, {
            "name": "TWITTER",
            "id": 16
        }, {
            "name": "EMAIL",
            "id": 17
        }, {
            "name": "LINE_BIND",
            "id": 19
        }, {
            "name": "KAKAO",
            "id": 20
        }, {
            "name": "WEIXIN_MINI_PROGRAM",
            "id": 21
        }, {
            "name": "TELEGRAM",
            "id": 23
        }]
    }, {
        "name": "PushType",
        "values": [{
            "name": "DEFAULT_PUSHTYPE",
            "id": 0
        }, {
            "name": "BAIDU",
            "id": 1
        }, {
            "name": "IOS",
            "id": 2
        }, {
            "name": "JPUSH",
            "id": 3
        }, {
            "name": "XIAOMI",
            "id": 4
        }, {
            "name": "GETUI",
            "id": 5
        }, {
            "name": "GOOGLE_PUSH",
            "id": 6
        }, {
            "name": "SAMSUNG",
            "id": 7
        }, {
            "name": "MEIZU",
            "id": 8
        }, {
            "name": "HUAWEI",
            "id": 9
        }, {
            "name": "GOOGLE_FCM",
            "id": 10
        }]
    }, {
        "name": "LiveType",
        "values": [{
            "name": "PUBLIC_FREE",
            "id": 0
        }, {
            "name": "PUBLIC_CHARGE",
            "id": 1
        }, {
            "name": "PRIVATE_FREE",
            "id": 2
        }, {
            "name": "PRIVATE_CHARGE",
            "id": 3
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 检测第三方账号是否已经绑定过
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _emailregisterverifycheck = __webpack_require__(419);

var _emailregisterverifycheck2 = _interopRequireDefault(_emailregisterverifycheck);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pbajax = new _pbajax2.default();

var EmailVerifyCheck = function () {
    function EmailVerifyCheck() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, EmailVerifyCheck);

        this.promise = this.emailCheck(data);
    }

    _createClass(EmailVerifyCheck, [{
        key: 'emailCheck',
        value: function emailCheck(data) {
            var defer = $.Deferred();
            var _EmailVerifyCheckPb$E = _emailregisterverifycheck2.default.Email.RegisterVerifyCheck,
                Request = _EmailVerifyCheckPb$E.Request,
                Response = _EmailVerifyCheckPb$E.Response;


            var businessData = new Request(data); //emailCheckCode

            var requestData = {
                service: 'service',
                api: '/email/register/verify/check'
            };

            pbajax.do(requestData, businessData, function (res) {
                var dataWrap = _public2.default.Result.decode(res);

                if (dataWrap.code == 1) {
                    defer.resolve(true);
                } else {
                    defer.reject(dataWrap);
                }
            }, function () {
                defer.reject();
            }, function () {
                defer.reject();
            });
            return defer.promise();
        }
    }]);

    return EmailVerifyCheck;
}();

exports.default = EmailVerifyCheck;

/***/ }),
/* 419 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "UserBalanceInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "inBill",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "outDiamond",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "bill",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "diamond",
            "id": 4
        }]
    }, {
        "name": "LiveDetailInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 4
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "location",
            "id": 7
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "roomId",
            "id": 8
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "onlineTotal",
            "id": 9
        }, {
            "rule": "optional",
            "type": "string",
            "name": "roomTitle",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "liveMsg",
            "id": 11
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 12
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "qualityAuth",
            "id": 14
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 15
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 16
        }, {
            "rule": "optional",
            "type": "double",
            "name": "distance",
            "id": 17
        }, {
            "rule": "optional",
            "type": "string",
            "name": "distanceStr",
            "id": 18
        }, {
            "rule": "optional",
            "type": "string",
            "name": "bigAvatar",
            "id": 19
        }, {
            "rule": "optional",
            "type": "LiveType",
            "name": "liveType",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "enterNeedDiamond",
            "id": 21
        }, {
            "rule": "repeated",
            "type": "LiveLabel",
            "name": "liveLabels",
            "id": 22
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "voiceFlag",
            "id": 23
        }, {
            "rule": "optional",
            "type": "string",
            "name": "ab",
            "id": 24
        }, {
            "rule": "optional",
            "type": "string",
            "name": "labels",
            "id": 25
        }, {
            "rule": "optional",
            "type": "borderType",
            "name": "borderType",
            "id": 26
        }, {
            "rule": "optional",
            "type": "string",
            "name": "borderPicUrl",
            "id": 27
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "isLandscape",
            "id": 28
        }, {
            "rule": "optional",
            "type": "string",
            "name": "gameId",
            "id": 29
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "roomType",
            "id": 30
        }, {
            "rule": "optional",
            "type": "string",
            "name": "roomTypeInfo",
            "id": 31
        }]
    }, {
        "name": "LiveLabel",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "labelName",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "labelValue",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "ext",
            "id": 3
        }]
    }, {
        "name": "ProfileInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "setting",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "password",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "userToken",
            "id": 8
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "location",
            "id": 11
        }, {
            "rule": "optional",
            "type": "string",
            "name": "mobilePhone",
            "id": 12
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "fanTotal",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followTotal",
            "id": 14
        }, {
            "rule": "optional",
            "type": "UserBalanceInfo",
            "name": "balance",
            "id": 15
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "chatroomid",
            "id": 16
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followType",
            "id": 17
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "exp",
            "id": 18
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "currentExp",
            "id": 19
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "nextExp",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 21
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 22
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "qualityAuth",
            "id": 23
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 25
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "admin",
            "id": 26
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "userRealNameAuth",
            "id": 27
        }, {
            "rule": "optional",
            "type": "string",
            "name": "acceptAgreement",
            "id": 28
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "upliveCodeStatus",
            "id": 29
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "subscribe",
            "id": 30
        }, {
            "rule": "repeated",
            "type": "Source",
            "name": "sources",
            "id": 31
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "dynamicCount",
            "id": 32
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "dynamicPublishRight",
            "id": 33
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "liveType",
            "id": 34
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "enterNeedDiamond",
            "id": 35
        }, {
            "rule": "repeated",
            "type": "LiveLabel",
            "name": "liveLabels",
            "id": 36
        }, {
            "rule": "optional",
            "type": "string",
            "name": "ipForCountry",
            "id": 37
        }, {
            "rule": "optional",
            "type": "string",
            "name": "dynamicManageRights",
            "id": 38
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "newUserDueTime",
            "id": 39
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "newUser",
            "id": 40
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "hostStatus",
            "id": 41
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "guardCount",
            "id": 42
        }, {
            "rule": "optional",
            "type": "string",
            "name": "language",
            "id": 43
        }]
    }, {
        "name": "Source",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "bindType",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "openId",
            "id": 2
        }]
    }, {
        "name": "Email",
        "fields": [],
        "messages": [{
            "name": "RegisterVerifyCheck",
            "fields": [],
            "options": {
                "objc_class_prefix": "EmailRegisterVerifyCheck",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "string",
                    "name": "emailCheckCode",
                    "id": 1
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "ProfileInfo",
                    "name": "profile",
                    "id": 1
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "BindType",
        "values": [{
            "name": "DEFAULT_TYPE",
            "id": 0
        }, {
            "name": "MOBILE_PHONE",
            "id": 1
        }, {
            "name": "QQ",
            "id": 2
        }, {
            "name": "WEIXIN",
            "id": 3
        }, {
            "name": "FACEBOOK",
            "id": 4
        }, {
            "name": "SINA_WEIBO",
            "id": 5
        }, {
            "name": "RR",
            "id": 6
        }, {
            "name": "TENCENT_WANBA",
            "id": 7
        }, {
            "name": "KECHENGGEZI",
            "id": 8
        }, {
            "name": "DEVICE",
            "id": 9
        }, {
            "name": "GOOGLE",
            "id": 15
        }, {
            "name": "TWITTER",
            "id": 16
        }, {
            "name": "EMAIL",
            "id": 17
        }, {
            "name": "LINE_BIND",
            "id": 19
        }, {
            "name": "KAKAO",
            "id": 20
        }, {
            "name": "WEIXIN_MINI_PROGRAM",
            "id": 21
        }, {
            "name": "TELEGRAM",
            "id": 23
        }]
    }, {
        "name": "PushType",
        "values": [{
            "name": "DEFAULT_PUSHTYPE",
            "id": 0
        }, {
            "name": "BAIDU",
            "id": 1
        }, {
            "name": "IOS",
            "id": 2
        }, {
            "name": "JPUSH",
            "id": 3
        }, {
            "name": "XIAOMI",
            "id": 4
        }, {
            "name": "GETUI",
            "id": 5
        }, {
            "name": "GOOGLE_PUSH",
            "id": 6
        }, {
            "name": "SAMSUNG",
            "id": 7
        }, {
            "name": "MEIZU",
            "id": 8
        }, {
            "name": "HUAWEI",
            "id": 9
        }, {
            "name": "GOOGLE_FCM",
            "id": 10
        }]
    }, {
        "name": "LiveType",
        "values": [{
            "name": "PUBLIC_FREE",
            "id": 0
        }, {
            "name": "PUBLIC_CHARGE",
            "id": 1
        }, {
            "name": "PRIVATE_FREE",
            "id": 2
        }, {
            "name": "PRIVATE_CHARGE",
            "id": 3
        }]
    }, {
        "name": "borderType",
        "values": [{
            "name": "PRESERVE",
            "id": 0
        }, {
            "name": "ANCHOR",
            "id": 1
        }, {
            "name": "BIRTHDAY",
            "id": 2
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cUpLoading = __webpack_require__(13);

var _cUpLoading2 = _interopRequireDefault(_cUpLoading);

var _cNotification = __webpack_require__(11);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _index = __webpack_require__(206);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 邮箱注册
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var EmailRegister = function (_Component) {
	_inherits(EmailRegister, _Component);

	function EmailRegister(props) {
		_classCallCheck(this, EmailRegister);

		var _this = _possibleConstructorReturn(this, (EmailRegister.__proto__ || Object.getPrototypeOf(EmailRegister)).call(this, props));

		_this.state = {
			childProps: props.childProps
		};
		return _this;
	}

	_createClass(EmailRegister, [{
		key: 'setInitState',
		value: function setInitState(state) {
			// this.setState({childProps: state});
			this.refs.emailLoginWrap.setInitState(state);
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'pop-no-tab' },
				_react2.default.createElement(_index2.default, _extends({ userProcess: 'register' }, this.state.childProps, { ref: 'emailLoginWrap' }))
			);
		}
	}]);

	return EmailRegister;
}(_react.Component);

module.exports = EmailRegister;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _codecreate = __webpack_require__(422);

var _codecreate2 = _interopRequireDefault(_codecreate);

var _codequery = __webpack_require__(423);

var _codequery2 = _interopRequireDefault(_codequery);

var _codescan = __webpack_require__(424);

var _codescan2 = _interopRequireDefault(_codescan);

var _qrcode = __webpack_require__(90);

var _qrcode2 = _interopRequireDefault(_qrcode);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 二维码登录
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var pbajax = new _pbajax2.default();

var cache = new _cCache2.default({
	prefix: 'pcuplive'
});

var QrcodeLogin = function (_Component) {
	_inherits(QrcodeLogin, _Component);

	function QrcodeLogin(props) {
		_classCallCheck(this, QrcodeLogin);

		var _this = _possibleConstructorReturn(this, (QrcodeLogin.__proto__ || Object.getPrototypeOf(QrcodeLogin)).call(this, props));

		_this.state = {
			qrcode: ""
		};
		return _this;
	}

	_createClass(QrcodeLogin, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			var getQrcodePromise = this.getQRCode();

			getQrcodePromise.done(function (code) {
				_this2.insertQrcode(code);
				_this2.getQueryQRCodeInterval(code);
			});
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			clearTimeout(this.queryQrcodeTimer);
			this.queryQrcodeTimer = null;
		}
	}, {
		key: 'insertQrcode',
		value: function insertQrcode(code) {
			var el = $(this.refs.qrcode);

			el.qrcode({
				text: code,
				width: 160,
				height: 160,
				render: "canvas"
			});
		}
		/**
   * 检测用户是否已经扫码登录成功，若失败，2秒之后查询
   */

	}, {
		key: 'getQueryQRCodeInterval',
		value: function getQueryQRCodeInterval(code) {
			var _this3 = this;

			var queryQrcodePromise = this.getQueryQRCode(code);

			queryQrcodePromise.done(function (data) {
				if (!data) {
					_this3.queryQrcodeTimer = setTimeout(function () {
						_this3.getQueryQRCodeInterval(code);
					}, _this3.props.delay);
				} else {
					clearTimeout(_this3.queryQrcodeTimer);
					_this3.queryQrcodeTimer = null;

					// console.log('QrcodeLogin:', data);
					// 授权成功，真实用户
					cache.setCache('isRegisterRealUser', true);

					$.channel.emit("loginSuccess", data);
				}
			});
		}
	}, {
		key: 'getQRCode',
		value: function getQRCode() {
			var defer = $.Deferred();
			var Response = _codecreate2.default.TwoDimensionalCode.Create.Response;


			var requestData = {
				service: "service", // java service name
				api: "/two/dimensional/code/create" // java api
			};

			pbajax.do(requestData, {}, function (res) {
				var dataWrap = _public2.default.Result.decode(res);
				var data = Response.decode(dataWrap.data.value);

				defer.resolve(data.randomCode);
			}, function () {
				defer.reject();
			}, function () {
				defer.reject();
			});

			return defer.promise();
		}
	}, {
		key: 'getQueryQRCode',
		value: function getQueryQRCode(code) {
			var self = this;
			var defer = $.Deferred();
			var _codeQueryPb$TwoDimen = _codequery2.default.TwoDimensionalCode.Query,
			    Request = _codeQueryPb$TwoDimen.Request,
			    Response = _codeQueryPb$TwoDimen.Response;


			var businessData = new Request({ randomCode: code, deviceId: "" });

			var requestData = {
				service: "service",
				api: "/two/dimensional/code/query"
			};

			pbajax.do(requestData, businessData, function (res) {
				var dataWrap = _public2.default.Result.decode(res);

				if (dataWrap.code == 4121) {
					defer.resolve(false);
				} else {
					var data = Response.decode(dataWrap.data.value);
					var userInfo = Object.assign({}, data.profile, self.parseData(data.profile));

					defer.resolve(userInfo);
				}
			}, function () {
				defer.reject();
			}, function () {
				defer.reject();
			});

			return defer.promise();
		}

		/*
      * 解析数据
      */

	}, {
		key: 'parseData',
		value: function parseData(data) {
			var balance = data.balance || {};
			return {
				uid: this.longToString(data.uid), // 用户UID
				balance: {
					diamond: this.longToInt(balance.diamond),
					bill: this.longToInt(balance.bill),
					inBill: this.longToInt(balance.inBill),
					outDiamond: this.longToInt(balance.outDiamond)
				},
				exp: this.longToInt(data.exp), // 用户经验值
				currentExp: this.longToInt(data.currentExp), //当前级的经验值
				nextExp: this.longToInt(data.nextExp), // 距离下一级还需要多少经验值
				chatroomid: this.longToString(data.chatroomid),
				officialAuth: data.officialAuth || 0 // 大V认证标识 1是 0否
			};
		}
	}, {
		key: 'longToString',
		value: function longToString(value) {
			return window.longToString(value);
		}
	}, {
		key: 'longToInt',
		value: function longToInt(value) {
			value = this.longToString(value);

			return parseInt(value, 10) || 0;
		}
	}, {
		key: 'render',
		value: function render() {
			var tip = _lang2.default.template("打开Up直播<br/>扫一扫登录");
			tip = tip.replace('<br/>', '&nbsp;&nbsp;');
			return _react2.default.createElement(
				'div',
				{ className: 'qrcode-login' },
				_react2.default.createElement(
					'div',
					{ className: 'qrcode-wrap' },
					_react2.default.createElement('div', { className: 'qrcode', ref: 'qrcode' })
				),
				_react2.default.createElement('div', { className: 'tip', dangerouslySetInnerHTML: { __html: tip } })
			);
		}
	}]);

	return QrcodeLogin;
}(_react.Component);

QrcodeLogin.defaultProps = {
	delay: 2 * 1000
};
exports.default = QrcodeLogin;

/***/ }),
/* 422 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "TwoDimensionalCode.Create",
    "options": {
        "objc_class_prefix": "TwoDimensionalCodeCreate",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Response",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "randomCode",
            "id": 1
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 423 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "UserBalanceInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "inBill",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "outDiamond",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "bill",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "diamond",
            "id": 4
        }]
    }, {
        "name": "ProfileInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "setting",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "password",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "userToken",
            "id": 8
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "location",
            "id": 11
        }, {
            "rule": "optional",
            "type": "string",
            "name": "mobilePhone",
            "id": 12
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "fanTotal",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followTotal",
            "id": 14
        }, {
            "rule": "optional",
            "type": "UserBalanceInfo",
            "name": "balance",
            "id": 15
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "chatroomid",
            "id": 16
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followType",
            "id": 17
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "exp",
            "id": 18
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "currentExp",
            "id": 19
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "nextExp",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 21
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 22
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "qualityAuth",
            "id": 23
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 25
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "admin",
            "id": 26
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "userRealNameAuth",
            "id": 27
        }, {
            "rule": "optional",
            "type": "string",
            "name": "acceptAgreement",
            "id": 28
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "upliveCodeStatus",
            "id": 29
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "subscribe",
            "id": 30
        }, {
            "rule": "repeated",
            "type": "Source",
            "name": "sources",
            "id": 31
        }]
    }, {
        "name": "Source",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "bindType",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "openId",
            "id": 2
        }]
    }, {
        "name": "TwoDimensionalCode",
        "fields": [],
        "messages": [{
            "name": "Query",
            "fields": [],
            "options": {
                "objc_class_prefix": "TwoDimensionalCodeQuery",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "string",
                    "name": "randomCode",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "deviceId",
                    "id": 2
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "ProfileInfo",
                    "name": "profile",
                    "id": 1
                }]
            }]
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 424 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "TwoDimensionalCode.Scan",
    "options": {
        "objc_class_prefix": "TwoDimensionalCodeScan",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Request",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "randomCode",
            "id": 1
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * EVENT_NAME_MAP is used to determine which event fired when a
 * transition/animation ends, based on the style property used to
 * define that event.
 */
var EVENT_NAME_MAP = {
  transitionend: {
    'transition': 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd',
    'MozTransition': 'mozTransitionEnd',
    'OTransition': 'oTransitionEnd',
    'msTransition': 'MSTransitionEnd'
  },

  animationend: {
    'animation': 'animationend',
    'WebkitAnimation': 'webkitAnimationEnd',
    'MozAnimation': 'mozAnimationEnd',
    'OAnimation': 'oAnimationEnd',
    'msAnimation': 'MSAnimationEnd'
  }
};

var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are useable, and if not remove them
  // from the map
  if (!('AnimationEvent' in window)) {
    delete EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete EVENT_NAME_MAP.transitionend.transition;
  }

  for (var baseEventName in EVENT_NAME_MAP) {
    var baseEvents = EVENT_NAME_MAP[baseEventName];
    for (var styleName in baseEvents) {
      if (styleName in style) {
        endEvents.push(baseEvents[styleName]);
        break;
      }
    }
  }
}

if (typeof window !== 'undefined') {
  detectEvents();
}


// We use the raw {add|remove}EventListener() call because EventListener
// does not know how to remove event listeners and we really should
// clean up. Also, these events are not triggered in older browsers
// so we should be A-OK here.

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

module.exports = {
  addEndEventListener: function(node, eventListener) {
    if (endEvents.length === 0) {
      // If CSS transitions are not supported, trigger an "end animation"
      // event immediately.
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function(endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },

  removeEndEventListener: function(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function(endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var builtinStyle = __webpack_require__(427);
var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
var domVendorPrefix;

// Helper function to get the proper vendor property name. (transition => WebkitTransition)
module.exports = function(prop, isSupportTest) {

  var vendorProp;
  if (prop in builtinStyle) return prop;

  var UpperProp = prop.charAt(0).toUpperCase() + prop.substr(1);

  if (domVendorPrefix) {

    vendorProp = domVendorPrefix + UpperProp;
    if (vendorProp in builtinStyle) {
      return vendorProp;
    }
  } else {

    for (var i = 0; i < prefixes.length; ++i) {
      vendorProp = prefixes[i] + UpperProp;
      if (vendorProp in builtinStyle) {
        domVendorPrefix = prefixes[i];
        return vendorProp;
      }
    }
  }

  // if support test, not fallback to origin prop name
  if (!isSupportTest) {
    return prop;
  }

}


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = document.createElement('div').style;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var extraSheet;

module.exports = function(css) {

  if (!extraSheet) {
    // First time, create an extra stylesheet for adding rules
    extraSheet = document.createElement('style');
    document.getElementsByTagName('head')[0].appendChild(extraSheet);
    // Keep reference to actual StyleSheet object (`styleSheet` for IE < 9)
    extraSheet = extraSheet.sheet || extraSheet.styleSheet;
  }

  var index = (extraSheet.cssRules || extraSheet.rules).length;
  extraSheet.insertRule(css, index);

  return extraSheet;
}


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cssVendorPrefix;

module.exports = function() {

  if (cssVendorPrefix) return cssVendorPrefix;

  var styles = window.getComputedStyle(document.documentElement, '');
  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || (styles.OLink === '' && ['', 'o']))[1];

  return cssVendorPrefix = '-' + pre + '-';
}


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var _events = __webpack_require__(74);

var _events2 = _interopRequireDefault(_events);

var _config = __webpack_require__(57);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _cNotification = __webpack_require__(11);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _check = __webpack_require__(88);

var _check2 = _interopRequireDefault(_check);

var _register = __webpack_require__(89);

var _register2 = _interopRequireDefault(_register);

var _login = __webpack_require__(86);

var _login2 = _interopRequireDefault(_login);

var _cUpLoading = __webpack_require__(13);

var _cUpLoading2 = _interopRequireDefault(_cUpLoading);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cache = new _cCache2.default({
    prefix: 'pcuplive'
}); /**
     * google测试环境无法使用
     * @author 
     */


var bindType = 15;
var GoogleAuth = void 0;

function updateSigninStatus(isSignedIn) {
    // When signin status changes, this function is called.
    // If the signin status is changed to signedIn, we make an API call.
    // console.warn('isSignedIn', isSignedIn);
    if (isSignedIn) {
        // 登录成功
        var GoogleUser = GoogleAuth.currentUser.get();

        var _GoogleUser$getAuthRe = GoogleUser.getAuthResponse(),
            access_token = _GoogleUser$getAuthRe.access_token;

        var profileData = GoogleUser.getBasicProfile();
        // console.warn('profileData', profileData);
        $.channel.emit('fbOauthSuccess', {
            access_token: access_token,
            profileData: profileData
        });
    } else {
        var promise = GoogleAuth.signIn();
        promise.then(function () {}, function (error) {
            _cUpLoading2.default.hide();
            _cNotification2.default.simple(_lang2.default.template('授权失败'));
        });
    }
}

var google = Object.assign({
    go: function go() {
        var _this = this;

        _cUpLoading2.default.show({
            content: _lang2.default.template('正在登录')
        });
        var loadedsdk = false;
        (function (d, s, id, cb) {
            var element = d.getElementsByTagName(s)[0];
            var fjs = element;
            var js = element;
            js = d.createElement(s);
            js.id = id;
            js.src = '//apis.google.com/js/platform.js';
            fjs.parentNode.insertBefore(js, fjs);
            js.onload = cb;
        })(document, 'script', 'google-login', function () {
            var loadedsdk = true;
            _this.loadSdkTimer && clearTimeout(_this.loadSdkTimer);
            // console.warn('google sdk loaded');
            try {
                gapi.load('auth2', function () {
                    gapi.auth2.init({
                        client_id: _config.upInfoInSNS.google.clientId,
                        scope: 'profile email'
                    }).then(function () {
                        // console.warn('google sdk init');

                        GoogleAuth = gapi.auth2.getAuthInstance();

                        GoogleAuth.isSignedIn.listen(updateSigninStatus);

                        // Handle the initial sign-in state.
                        updateSigninStatus(GoogleAuth.isSignedIn.get());
                    });
                });

                $.channel.on('fbOauthSuccess', function (data) {
                    $.channel.off('fbOauthSuccess');
                    _this.getGoogleInfo(data);
                });
            } catch (error) {
                _cUpLoading2.default.hide();
                _cNotification2.default.simple(_lang2.default.template('授权失败'));
            }
        });

        this.loadSdkTimer = setTimeout(function () {
            if (!loadedsdk) {
                _cUpLoading2.default.hide();
                _cNotification2.default.simple(_lang2.default.template('授权失败'));
                new Error("gapi.load Auth2 Timeout");
            }
        }, 3 * 1000);
    },
    getGoogleInfo: function getGoogleInfo(data) {
        var _this2 = this;

        // console.warn('getGoogleInfo');
        var isRegistered = this.checkRegistered(data);

        isRegistered.done(function (registered) {
            if (registered) {
                // 三方账号已绑定Up直播
                _this2.getProfileForRegister(data);
            } else {
                // 未绑定
                _this2.getProfileForNoRegister(data);
            }
        });

        isRegistered.fail(function () {
            alert('dd');
        });
    },
    getProfileForNoRegister: function getProfileForNoRegister(data) {
        var _this3 = this;

        var registerPromise = this.register(data);

        registerPromise.done(function (data) {

            var loginPromise = _this3.login(data.uid, data.password);

            loginPromise.done(function (data) {
                // console.log('用户信息', data);

                // 授权成功，真实用户
                cache.setCache('isRegisterRealUser', true);

                _cUpLoading2.default.hide();

                UP.Global.DA.add({
                    eventName: 'loginSuccess',
                    action: 'show'
                });

                UP.Global.DA.add({
                    eventName: 'googleLoginSuccess',
                    action: 'click'
                });

                fbq('track', 'LoginSuccess', { oauthtype: 'google' });

                // location.reload();

                UP.Global.writeUserInfo(data);
                $.channel.emit('loginSuccess', data);
            });

            loginPromise.fail(function (dataWrap) {
                _cUpLoading2.default.hide();
                if (dataWrap.code == 4119) {
                    _cNotification2.default.simple('device forbidden');
                }
            });
        });

        registerPromise.fail(function (dataWrap) {
            _cUpLoading2.default.hide();
            if (dataWrap.code == 4119) {
                _cNotification2.default.simple('device forbidden');
            }
        });
    },
    getProfileForRegister: function getProfileForRegister(data) {
        var registerPromise = this.register(data);

        registerPromise.done(function (data) {
            console.log('用户信息', data);

            // 授权成功，真实用户
            cache.setCache('isRegisterRealUser', true);

            UP.Global.writeUserInfo(data);

            _cUpLoading2.default.hide();

            UP.Global.DA.add({
                eventName: 'loginSuccess',
                action: 'show'
            });

            UP.Global.DA.add({
                eventName: 'googleLoginSuccess',
                action: 'click'
            });

            fbq('track', 'LoginSuccess', { oauthtype: 'google' });

            // location.reload();

            $.channel.emit('loginSuccess', data);
        });

        registerPromise.fail(function (dataWrap) {
            _cUpLoading2.default.hide();

            if (dataWrap.code == 4119) {
                _cNotification2.default.simple('device forbidden');
            }
        });
    },


    /*
     * 第三方账号是否已经绑定过UP直播
     */
    checkRegistered: function checkRegistered(data) {
        var promise = new _check2.default({
            bindType: bindType,
            thirdId: data.profileData.getId(),
            thirdToken: data.access_token
        }).promise;

        return promise;
    },
    register: function register(data) {
        // let _lang = UP.Global.systemLanguage;
        // let countryCode = _lang.split('-')[1].toUpperCase();
        var profileData = data.profileData,
            access_token = data.access_token;

        var promise = new _register2.default({
            bindType: bindType,
            thirdId: profileData.getId(),
            thirdToken: access_token,
            avatar: profileData.getImageUrl(),
            username: profileData.getName()
            // countryCode: countryCode
        }).promise;

        return promise;
    },
    login: function login(uid, password) {
        var promise = new _login2.default({
            loginType: 1,
            bindType: bindType,
            uid: uid,
            password: password
        }).promise;

        return promise;
    }
}, _events2.default);

module.exports = google;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _config = __webpack_require__(57);

var _check = __webpack_require__(88);

var _check2 = _interopRequireDefault(_check);

var _register = __webpack_require__(89);

var _register2 = _interopRequireDefault(_register);

var _cNotification = __webpack_require__(11);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _login = __webpack_require__(86);

var _login2 = _interopRequireDefault(_login);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _cUpLoading = __webpack_require__(13);

var _cUpLoading2 = _interopRequireDefault(_cUpLoading);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 微信授权
 */
var cache = new _cCache2.default({
    prefix: 'pcuplive'
});

// 微信 3
var bindType = 3;
var wechat = {
    go: function go() {
        var _this = this;

        var urlPrefix = 'https://open.weixin.qq.com/connect/qrconnect';
        var result = {
            'appid': _config.upInfoInSNS['wechat'].appId,
            'redirect_uri': _config.cbHost + '/wechat-oauth?type=4',
            'response_type': 'code',
            'scope': 'snsapi_login',
            'state': 'STATE',
            'style': 'white'
        };

        var url = urlPrefix + '?' + $.param(result);

        UP.PrepaireForAsync({
            message: _lang2.default.template('请稍侯，正在登录中...'),
            width: 506,
            height: 530
        });

        var wechatWindow = window.open(url);

        var promise = UP.WaitForRecieveMsg(wechatWindow, 'wechatlogin');

        promise.done(function (code) {
            if (code) {
                // 成功获取code，code -> acctss_token
                _cUpLoading2.default.show({
                    content: _lang2.default.template('正在登录')
                });
                _this.fail = 0;
                _this.getWechatGetAccessToken(code);
            }
        });
    },
    getWechatGetAccessToken: function getWechatGetAccessToken(code) {
        var _this2 = this;

        var promise = $.ajax({
            url: UP.Global.getPyHost() + "/api/account/wechat/token/exchange/",
            data: {
                code: code
            },
            type: 'POST',
            dataType: 'json'
        });

        promise.done(function (data) {
            if (data.unionid) {
                var isRegistered = _this2.checkRegistered(data);

                isRegistered.done(function (registered) {
                    if (registered) {
                        // 三方账号已绑定Up直播
                        _this2.getProfileForRegister(data);
                    } else {
                        // 未绑定
                        _this2.getProfileForNoRegister(data);
                    }
                });
            } else {
                _this2.fail++;

                if (_this2.fail < 3) {
                    _this2.getWechatGetAccessToken(code);
                } else {
                    _cUpLoading2.default.hide();
                    _cNotification2.default.simple(_lang2.default.template('授权失败'));
                }
            }
        });

        return promise;
    },

    /**
     * 第三方账号是否已经绑定过UP直播
     */
    checkRegistered: function checkRegistered(data) {
        var promise = new _check2.default({
            bindType: bindType,
            thirdId: data.unionid,
            extension: data.openid,
            thirdToken: data.access_token
        }).promise;

        return promise;
    },
    getProfileForNoRegister: function getProfileForNoRegister(data) {
        var _this3 = this;

        var registerPromise = this.register(data);

        registerPromise.done(function (data) {

            var loginPromise = _this3.login(data.uid, data.password);

            loginPromise.done(function (data) {
                // console.log('用户信息', data);
                _cUpLoading2.default.hide();
                // 授权成功，真实用户
                cache.setCache('isRegisterRealUser', true);

                UP.Global.DA.add({
                    eventName: 'loginSuccess',
                    action: 'show'
                });

                UP.Global.DA.add({
                    eventName: 'wechatLoginSuccess',
                    action: 'click'
                });

                fbq('track', 'LoginSuccess', { oauthtype: 'wechat' });

                $.channel.emit('loginSuccess', data);
            });

            loginPromise.fail(function (dataWrap) {
                _cUpLoading2.default.hide();

                if (dataWrap.code == 4119) {
                    _cNotification2.default.simple('device forbidden');
                }
            });
        });

        registerPromise.fail(function (dataWrap) {
            _cUpLoading2.default.hide();

            if (dataWrap.code == 4119) {
                _cNotification2.default.simple('device forbidden');
            }
        });
    },
    getProfileForRegister: function getProfileForRegister(data) {
        var registerPromise = this.register(data);

        registerPromise.done(function (data) {
            // console.log('用户信息', data);

            _cUpLoading2.default.hide();

            // 授权成功，真实用户
            cache.setCache('isRegisterRealUser', true);

            UP.Global.DA.add({
                eventName: 'loginSuccess',
                action: 'show'
            });

            UP.Global.DA.add({
                eventName: 'wechatLoginSuccess',
                action: 'click'
            });

            fbq('track', 'LoginSuccess', { oauthtype: 'wechat' });

            $.channel.emit('loginSuccess', data);
        });

        registerPromise.fail(function (dataWrap) {
            _cUpLoading2.default.hide();

            if (dataWrap.code == 4119) {
                _cNotification2.default.simple('device forbidden');
            }
        });
    },
    register: function register(data) {
        // let _lang = UP.Global.systemLanguage;
        // let countryCode = _lang.split('-')[1].toUpperCase();
        var promise = new _register2.default({
            bindType: bindType,
            thirdId: data.unionid,
            extension: data.openid,
            thirdToken: data.access_token,
            avatar: encodeURI(data.headimgurl),
            username: data.nickname
            // countryCode: countryCode
        }).promise;

        return promise;
    },
    login: function login(uid, password) {
        var promise = new _login2.default({
            loginType: 1,
            bindType: bindType,
            uid: uid,
            password: password
        }).promise;

        return promise;
    }
};

exports.default = wechat;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _config = __webpack_require__(57);

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _cNotification = __webpack_require__(11);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cache = new _cCache2.default({
    prefix: 'pcuplive'
}); /**
     * 微博授权
     */


var Transfer = {
    go: function go(type) {
        var urlPrefix = 'https://h5.upliveapp.com/uplive-login/index.html';
        var result = {
            'multiLoginChannel': 1,
            'target_uri': this.getTransferUrl('/transfer.html?oauthback=5'),
            'oauthtype': type,
            'env': _cUrl2.default.query('env') ? _cUrl2.default.query('env') : 'pro',
            'channel': UP.Global.channel,
            'ignoreCountryCode': 1,
            'display': 'pcweb'
        };

        var url = urlPrefix + '?' + $.param(result);

        UP.PrepaireForAsync({ message: _lang2.default.template('请稍侯，正在登录中...') });

        var weiboWindow = window.open(url);

        var promise = UP.WaitForRecieveMsg(weiboWindow, 'h5login', type);

        promise.done(function (__user) {
            var user = decodeURIComponent(__user);

            var _JSON$parse = JSON.parse(user),
                userToken = _JSON$parse.userToken,
                uid = _JSON$parse.uid;

            UP.Global.DA.add({
                eventName: 'loginSuccess',
                action: 'show'
            });

            fbq('track', 'LoginSuccess', { oauthtype: type });

            UP.Global.DA.add({
                eventName: type + 'LoginSuccess',
                action: 'click'
            });

            // 授权成功，真实用户
            cache.setCache('isRegisterRealUser', true);

            $.channel.emit('authSuccess', {
                userToken: userToken,
                uid: uid
            });
        });

        promise.fail(function () {
            _cNotification2.default.simple(_lang2.default.template('授权失败'));
        });
    },


    getTransferUrl: function getTransferUrl(url) {
        var pathname = '';

        if (location.pathname.indexOf('/uplive-pc/') > -1) {
            pathname = location.pathname.substr(0, location.pathname.indexOf('/uplive-pc/') + '/uplive-pc/'.length - 1);
        }

        return location.protocol + '//' + location.hostname + pathname + url;
    }
};

exports.default = Transfer;

/***/ }),
/* 433 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "UserBalanceInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "inBill",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "outDiamond",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "bill",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "diamond",
            "id": 4
        }]
    }, {
        "name": "LiveDetailInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 4
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "location",
            "id": 7
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "roomId",
            "id": 8
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "onlineTotal",
            "id": 9
        }, {
            "rule": "optional",
            "type": "string",
            "name": "roomTitle",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "liveMsg",
            "id": 11
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 12
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "qualityAuth",
            "id": 14
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 15
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 16
        }, {
            "rule": "optional",
            "type": "double",
            "name": "distance",
            "id": 17
        }, {
            "rule": "optional",
            "type": "string",
            "name": "distanceStr",
            "id": 18
        }, {
            "rule": "optional",
            "type": "string",
            "name": "bigAvatar",
            "id": 19
        }, {
            "rule": "optional",
            "type": "LiveType",
            "name": "liveType",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "enterNeedDiamond",
            "id": 21
        }, {
            "rule": "repeated",
            "type": "LiveLabel",
            "name": "liveLabels",
            "id": 22
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "voiceFlag",
            "id": 23
        }, {
            "rule": "optional",
            "type": "string",
            "name": "ab",
            "id": 24
        }]
    }, {
        "name": "LiveLabel",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "labelName",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "labelValue",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "ext",
            "id": 3
        }]
    }, {
        "name": "ProfileInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "setting",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "password",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "userToken",
            "id": 8
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "location",
            "id": 11
        }, {
            "rule": "optional",
            "type": "string",
            "name": "mobilePhone",
            "id": 12
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "fanTotal",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followTotal",
            "id": 14
        }, {
            "rule": "optional",
            "type": "UserBalanceInfo",
            "name": "balance",
            "id": 15
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "chatroomid",
            "id": 16
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followType",
            "id": 17
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "exp",
            "id": 18
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "currentExp",
            "id": 19
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "nextExp",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 21
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 22
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "qualityAuth",
            "id": 23
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 25
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "admin",
            "id": 26
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "userRealNameAuth",
            "id": 27
        }, {
            "rule": "optional",
            "type": "string",
            "name": "acceptAgreement",
            "id": 28
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "upliveCodeStatus",
            "id": 29
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "subscribe",
            "id": 30
        }, {
            "rule": "repeated",
            "type": "Source",
            "name": "sources",
            "id": 31
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "dynamicCount",
            "id": 32
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "dynamicPublishRight",
            "id": 33
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "liveType",
            "id": 34
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "enterNeedDiamond",
            "id": 35
        }, {
            "rule": "repeated",
            "type": "LiveLabel",
            "name": "liveLabels",
            "id": 36
        }, {
            "rule": "optional",
            "type": "string",
            "name": "ipForCountry",
            "id": 37
        }, {
            "rule": "optional",
            "type": "string",
            "name": "dynamicManageRights",
            "id": 38
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "newUserDueTime",
            "id": 39
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "newUser",
            "id": 40
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "hostStatus",
            "id": 41
        }]
    }, {
        "name": "Source",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "bindType",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "openId",
            "id": 2
        }]
    }, {
        "name": "LabelInfo",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "label",
            "id": 1
        }]
    }, {
        "name": "PermissionInfo",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "permission",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "leftover",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "recoveryTime",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "keepTime",
            "id": 4
        }]
    }, {
        "name": "Mall",
        "fields": [],
        "options": {
            "objc_class_prefix": "MallMountInfo",
            "java_package": "com.asiainno.uplive.proto"
        },
        "messages": [{
            "name": "MountInfo",
            "fields": [{
                "rule": "optional",
                "type": "int32",
                "name": "mountId",
                "id": 1
            }, {
                "rule": "optional",
                "type": "string",
                "name": "name",
                "id": 2
            }, {
                "rule": "optional",
                "type": "string",
                "name": "intro",
                "id": 3
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "price",
                "id": 4
            }, {
                "rule": "optional",
                "type": "string",
                "name": "timeUnit",
                "id": 5
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "experience",
                "id": 6
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "version",
                "id": 7
            }, {
                "rule": "optional",
                "type": "bool",
                "name": "onLined",
                "id": 8
            }, {
                "rule": "optional",
                "type": "string",
                "name": "countryCode",
                "id": 9
            }, {
                "rule": "optional",
                "type": "bool",
                "name": "needLoad",
                "id": 10
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "vipGrade",
                "id": 11
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "playTimes",
                "id": 12
            }, {
                "rule": "repeated",
                "type": "MountResourceInfo",
                "name": "resources",
                "id": 13
            }, {
                "rule": "repeated",
                "type": "MountPriceConfig",
                "name": "prices",
                "id": 14
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "originalPrice",
                "id": 15
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "discountType",
                "id": 16
            }, {
                "rule": "optional",
                "type": "float",
                "name": "discountValue",
                "id": 17
            }]
        }, {
            "name": "MountResourceInfo",
            "fields": [{
                "rule": "optional",
                "type": "int32",
                "name": "type",
                "id": 1
            }, {
                "rule": "optional",
                "type": "string",
                "name": "url",
                "id": 2
            }, {
                "rule": "optional",
                "type": "string",
                "name": "md5",
                "id": 3
            }]
        }, {
            "name": "MountPriceConfig",
            "fields": [{
                "rule": "optional",
                "type": "int32",
                "name": "id",
                "id": 1
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "price",
                "id": 2
            }, {
                "rule": "optional",
                "type": "string",
                "name": "timeUnit",
                "id": 3
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "originalPrice",
                "id": 4
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "discountType",
                "id": 5
            }, {
                "rule": "optional",
                "type": "float",
                "name": "discountValue",
                "id": 6
            }]
        }]
    }, {
        "name": "Profile",
        "fields": [],
        "messages": [{
            "name": "Get",
            "fields": [],
            "options": {
                "objc_class_prefix": "ProfileGet",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "int64",
                    "name": "vuid",
                    "id": 1
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "ProfileInfo",
                    "name": "profile",
                    "id": 1
                }, {
                    "rule": "repeated",
                    "type": "LabelInfo",
                    "name": "userLabels",
                    "id": 2
                }, {
                    "rule": "repeated",
                    "type": "PermissionInfo",
                    "name": "canPermissions",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "Mall.MountInfo",
                    "name": "mountInfo",
                    "id": 4
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "BindType",
        "values": [{
            "name": "DEFAULT_TYPE",
            "id": 0
        }, {
            "name": "MOBILE_PHONE",
            "id": 1
        }, {
            "name": "QQ",
            "id": 2
        }, {
            "name": "WEIXIN",
            "id": 3
        }, {
            "name": "FACEBOOK",
            "id": 4
        }, {
            "name": "SINA_WEIBO",
            "id": 5
        }, {
            "name": "RR",
            "id": 6
        }, {
            "name": "TENCENT_WANBA",
            "id": 7
        }, {
            "name": "KECHENGGEZI",
            "id": 8
        }, {
            "name": "DEVICE",
            "id": 9
        }, {
            "name": "GOOGLE",
            "id": 15
        }, {
            "name": "TWITTER",
            "id": 16
        }, {
            "name": "EMAIL",
            "id": 17
        }, {
            "name": "LINE_BIND",
            "id": 19
        }]
    }, {
        "name": "PushType",
        "values": [{
            "name": "DEFAULT_PUSHTYPE",
            "id": 0
        }, {
            "name": "BAIDU",
            "id": 1
        }, {
            "name": "IOS",
            "id": 2
        }, {
            "name": "JPUSH",
            "id": 3
        }, {
            "name": "XIAOMI",
            "id": 4
        }, {
            "name": "GETUI",
            "id": 5
        }, {
            "name": "GOOGLE_PUSH",
            "id": 6
        }, {
            "name": "SAMSUNG",
            "id": 7
        }, {
            "name": "MEIZU",
            "id": 8
        }, {
            "name": "HUAWEI",
            "id": 9
        }, {
            "name": "GOOGLE_FCM",
            "id": 10
        }]
    }, {
        "name": "LiveType",
        "values": [{
            "name": "PUBLIC_FREE",
            "id": 0
        }, {
            "name": "PUBLIC_CHARGE",
            "id": 1
        }, {
            "name": "PRIVATE_FREE",
            "id": 2
        }, {
            "name": "PRIVATE_CHARGE",
            "id": 3
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _cNotification = __webpack_require__(11);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _visitor = __webpack_require__(435);

var _visitor2 = _interopRequireDefault(_visitor);

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * iOS/appstore version/1.9.0 build/6824
 */
var cache = new _cCache2.default({
    prefix: 'pcuplive'
});

var pbajax = new _pbajax2.default();
var visitor = {
    register: function register() {

        var self = this;
        var _lang = UP.Global.systemLanguage;
        var countryCode = ''; //_lang.split('-')[1].toUpperCase();

        var businessData = new _visitor2.default.Visitor.RegisterH5.Request({
            // countryCode // 经纬度判断，-》IP库判断
            countryCode: ''
        });

        var defer = $.Deferred();
        // console.warn('-------游客设备：Android/' + UP.Global.channel + ' version/1.9.0  smd/' + deviceId);
        UP.Global.DA.add({
            eventName: 'visitorRegisterBegin',
            action: 'click'
        });

        pbajax.do({
            service: 'safe',
            api: '/visitor/register/h5'
        }, businessData, function (res) {

            var dataWrap = _public2.default.Result.decode(res);
            var data = void 0;

            if (dataWrap.code == 1) {
                data = _visitor2.default.Visitor.RegisterH5.Response.decode(dataWrap.data.value);

                var userInfo = Object.assign({}, data.profile, self.parseData(data.profile));
                // console.warn('------游客注册结果：' , userInfo);

                UP.Global.DA.add({
                    eventName: 'visitorRegisterSuccess',
                    action: 'click'
                });

                fbq('track', 'VisitorRegisterSuccess');

                $.channel.emit('registerVisitorSuccess', userInfo);
                // console.log('registerVisitorSuccess', userInfo);
                defer.resolve(userInfo);
            } else {
                // notification.simple('游客登录失败，请使用其他方式登录');
                $.channel.emit('login');

                defer.reject();
            }
        }, function () {
            // notification.simple('游客登录失败，请使用其他方式登录');
            $.channel.emit('login');

            defer.reject();
        }, function () {
            // notification.simple('游客登录失败，请使用其他方式登录');
            $.channel.emit('login');

            defer.reject();
        });
    },

    /*
     * 解析数据
     */
    parseData: function parseData(data) {
        var balance = data.balance || {};

        return {
            uid: this.longToString(data.uid), // 用户UID
            balance: {
                diamond: this.longToInt(balance.diamond),
                bill: this.longToInt(balance.bill),
                inBill: this.longToInt(balance.inBill),
                outDiamond: this.longToInt(balance.outDiamond)
            },
            exp: this.longToInt(data.exp), // 用户经验值
            currentExp: this.longToInt(data.currentExp), //当前级的经验值
            nextExp: this.longToInt(data.nextExp), // 距离下一级还需要多少经验值
            chatroomid: this.longToString(data.chatroomid),
            officialAuth: data.officialAuth || 0, // 大V认证标识 1是 0否
            hostStatus: true
        };
    },
    longToString: function longToString(value) {
        return window.longToString(value);
    },
    longToInt: function longToInt(value) {
        value = this.longToString(value);

        return parseInt(value, 10) || 0;
    }
};

exports.default = visitor;

/***/ }),
/* 435 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "UserBalanceInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "inBill",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "outDiamond",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "bill",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "diamond",
            "id": 4
        }]
    }, {
        "name": "ProfileInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "setting",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "password",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "userToken",
            "id": 8
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "location",
            "id": 11
        }, {
            "rule": "optional",
            "type": "string",
            "name": "mobilePhone",
            "id": 12
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "fanTotal",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followTotal",
            "id": 14
        }, {
            "rule": "optional",
            "type": "UserBalanceInfo",
            "name": "balance",
            "id": 15
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "chatroomid",
            "id": 16
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followType",
            "id": 17
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "exp",
            "id": 18
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "currentExp",
            "id": 19
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "nextExp",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 21
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 22
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "qualityAuth",
            "id": 23
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 25
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "admin",
            "id": 26
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "userRealNameAuth",
            "id": 27
        }, {
            "rule": "optional",
            "type": "string",
            "name": "acceptAgreement",
            "id": 28
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "upliveCodeStatus",
            "id": 29
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "subscribe",
            "id": 30
        }, {
            "rule": "optional",
            "type": "string",
            "name": "sources",
            "id": 31
        }]
    }, {
        "name": "Visitor",
        "fields": [],
        "messages": [{
            "name": "RegisterH5",
            "fields": [],
            "options": {
                "objc_class_prefix": "VisitorRegisterH5",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "string",
                    "name": "location",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "countryCode",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "selectLanguage",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "BindType",
                    "name": "source",
                    "id": 4
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "ProfileInfo",
                    "name": "profile",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "int64",
                    "name": "watchTime",
                    "id": 2
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "BindType",
        "values": [{
            "name": "DEFAULT_TYPE",
            "id": 0
        }, {
            "name": "MOBILE_PHONE",
            "id": 1
        }, {
            "name": "QQ",
            "id": 2
        }, {
            "name": "WEIXIN",
            "id": 3
        }, {
            "name": "FACEBOOK",
            "id": 4
        }, {
            "name": "SINA_WEIBO",
            "id": 5
        }, {
            "name": "RR",
            "id": 6
        }, {
            "name": "TENCENT_WANBA",
            "id": 7
        }, {
            "name": "KECHENGGEZI",
            "id": 8
        }, {
            "name": "DEVICE",
            "id": 9
        }, {
            "name": "GOOGLE",
            "id": 15
        }, {
            "name": "TWITTER",
            "id": 16
        }, {
            "name": "EMAIL",
            "id": 17
        }]
    }, {
        "name": "PushType",
        "values": [{
            "name": "DEFAULT_PUSHTYPE",
            "id": 0
        }, {
            "name": "BAIDU",
            "id": 1
        }, {
            "name": "IOS",
            "id": 2
        }, {
            "name": "JPUSH",
            "id": 3
        }, {
            "name": "XIAOMI",
            "id": 4
        }, {
            "name": "GETUI",
            "id": 5
        }, {
            "name": "GOOGLE_PUSH",
            "id": 6
        }, {
            "name": "SAMSUNG",
            "id": 7
        }, {
            "name": "MEIZU",
            "id": 8
        }, {
            "name": "HUAWEI",
            "id": 9
        }, {
            "name": "GOOGLE_FCM",
            "id": 10
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Config = exports.FriendApply = exports.getMsgType = exports.FriendList = exports.Sessions = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * IM协议封装
                                                                                                                                                                                                                                                                               * @author zhenn
                                                                                                                                                                                                                                                                               * @createTime 2017-11-21 18:17
                                                                                                                                                                                                                                                                               * @documentaddr https://wiki.pengpengla.com/pages/viewpage.action?pageId=3678298
                                                                                                                                                                                                                                                                               */


var _into = __webpack_require__(437);

var _into2 = _interopRequireDefault(_into);

var _cPublicpb = __webpack_require__(69);

var _cPublicpb2 = _interopRequireDefault(_cPublicpb);

var _cUpPbajax = __webpack_require__(46);

var _cUpPbajax2 = _interopRequireDefault(_cUpPbajax);

var _event = __webpack_require__(438);

var _event2 = _interopRequireDefault(_event);

var _constant = __webpack_require__(439);

var _constant2 = _interopRequireDefault(_constant);

var _message = __webpack_require__(440);

var _message2 = _interopRequireDefault(_message);

var _msgActivity = __webpack_require__(441);

var _msgActivity2 = _interopRequireDefault(_msgActivity);

var _serverActivity = __webpack_require__(442);

var _serverActivity2 = _interopRequireDefault(_serverActivity);

var _msgContent = __webpack_require__(443);

var _msgContent2 = _interopRequireDefault(_msgContent);

var _msgtype = __webpack_require__(208);

var _constant3 = __webpack_require__(444);

var _constant4 = _interopRequireDefault(_constant3);

var _sessions = __webpack_require__(445);

var _sessions2 = _interopRequireDefault(_sessions);

var _friendlist = __webpack_require__(448);

var _friendlist2 = _interopRequireDefault(_friendlist);

var _friendapply = __webpack_require__(451);

var _friendapply2 = _interopRequireDefault(_friendapply);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IM = function IM() {
    this.initialize.apply(this, arguments);
};

IM.prototype = $.extend({

    initialize: function initialize(cfg) {
        this.pingTimeout = 30; // second
        this.userToken = cfg.userToken;
        this.appkey = 'uplive';
        this.termType = cfg.termType;
        this.pbajax = new _cUpPbajax2.default();
        this.upMsgList = []; // 本地上行消息列表
        this.AckTimer = {};
        this.ResendTimes = {};
        this.sid = cfg.sid;
        this.language = cfg.language || 'zh-CN';
        this.userAgent = cfg.userAgent || window.navigator.userAgent;
        this.getIntoMsg();
    },

    // 获取WS连接参数
    getIntoMsg: function getIntoMsg() {
        var _this = this;

        var self = this;

        var data = {
            appkey: this.appkey,
            termType: this.termType
        };

        // 如果是线上环境，就直接使用域名来访问
        var env = this.pbajax.env();
        var proWsHost = 'sg-im.upliveapp.com';
        var staWsHost = 'sg-im-stage.pengpengla.com';
        var isHttps = 'https:';

        this.pbajax.do({
            service: 'im',
            api: '/presence/ws/auth',
            header: {
                userToken: this.userToken,
                'Accept-Language': this.language,
                UserAgent: this.userAgent
            }
        }, new _into2.default.Garuda.AuthRequest(data), function (res) {
            var dataWrap = _cPublicpb2.default.Result.decode(res);
            var data;
            if (dataWrap.code == 1) {
                data = _into2.default.Garuda.AuthResponse.decode(dataWrap.data.value);
                var protocol = location.protocol;
                var _wsProtocol = protocol === 'http:' ? 'ws:' : 'wss:';
                var wsHost = void 0;
                if (env == 'pro') {
                    wsHost = proWsHost;
                } else {
                    wsHost = staWsHost;
                }

                if (data.ip == wsHost) {
                    data.port = 443;
                    _wsProtocol = 'wss:';
                }
                data.wsProtocol = _wsProtocol;

                _this.data = data;
                _this.initSocket(data);
                _this.emit('getIntoSuccess', data);
                console.log(data);
            } else {
                console.log('getIntoException', dataWrap.code);
                self.emit('getIntoException', dataWrap.code);
            }
        }, function () {
            self.emit('getIntoTimeout');
        }, function () {
            self.emit('getIntoFail');
        });
    },

    // 初始化websocket连接
    initSocket: function initSocket(data) {
        // var protocol = location.protocol;
        // var wsProtocol = protocol === 'http:' ? 'ws:' : 'wss:';
        wsProtocol = data.wsProtocol;

        var socketUrl = wsProtocol + '//' + data.ip + ':' + data.port + data.path + '?';

        var search = {
            sid: this.sid,
            time: longToString(data.time),
            nonce: data.nonce,
            appkey: this.appkey,
            termType: this.termType,
            sec: data.sec
        };
        socketUrl += this.pbajax.serializeURI(search);
        this.createSocket(socketUrl);
    },

    /**
     * create websocket
     */
    createSocket: function createSocket(url) {
        if (!('WebSocket' in window)) {
            return;
        }
        this.url = url;
        this.socket = new WebSocket(url);
        this.socket.binaryType = 'arraybuffer';
        this.bindEventToSocket();
    },

    // 监听socket事件
    bindEventToSocket: function bindEventToSocket() {
        var self = this;
        this.socket.onopen = function (res) {
            self.emit('open');
            console.log('socket open');
            this.closeByManual = false;

            setTimeout(function () {
                self.sendAttend();
            }, 300);

            self.createPingTimer();
        };
        this.socket.onmessage = function (resp) {

            var data;

            data = self.parseDownlinkMessage(resp.data);

            // console.log('message------', data)

            // 如果是注册的下行报文
            if (data.type == 1) {
                // 注册失败
                if (data.body) {
                    self.emit('attendFail', data.extenseBody.rResult);
                } else {
                    self.pullOfflineMsg();
                    self.emit('attendSucc');
                }
                return;
            } else if (data.type == 3) {
                // pong
                console.log('pong');
            } else if (data.type == 5) {
                // ack 信息，确定消息是否已经送达服务器
                self.emit('arrivedServer', data.msgid);
                self.updateUpMsgListStatus(data.msgid);
            } else if (data.type == 6) {
                // 收到push_version版本需求，说明有离线未读消息
                if (data.mType == 35) {
                    this.pullOfflineMsg();
                } else if (data.mType == 32) {
                    self.forcedOffline = 1;
                    self.emit('forcedOffline', data);
                }
            } else if (data.type == 12) {
                // 拉取离线消息(不含群离线/系统广播/最近消息)

                // 含系统通知(如好友申请/单聊信息)
                // console.log('离线消息=======', data);
                if (data.mType == 81) {
                    // self.emit('pullOfflineMsgSucc', data);
                    self.pullOfflineMsgSuccHandler(data);
                }
            } else {
                self.emit('message', data);
            }

            // 只要不是服务器下行ACK，均需要上报给服务器已读通知
            // 让服务器知道是否还存在未读消息
            if (data.type != 5) {
                // debugger;
                self.sendUpReadNotice(data);
            }
        };
        this.socket.onclose = function (status) {
            // 1000
            self.emit('close', status);
            self.destroyPingTimer();
        };
    },

    pullOfflineMsgSuccHandler: function pullOfflineMsgSuccHandler(data) {
        var _this2 = this;

        if (!data.body || !data.body.offlineMsg) {
            return;
        }

        var offlineMsgList = data.body.offlineMsg;
        offlineMsgList.forEach(function (item, inx) {
            item = _this2.parseDownlinkMessage(item);
            _this2.emit('message', item);
        });
    },


    // 重连
    reconnect: function reconnect() {
        console.log('socket reconnect');
        this.socket = new WebSocket(this.url);
        this.socket.binaryType = 'arraybuffer';
        this.bindEventToSocket();
    },

    reinit: function reinit() {
        this.getIntoMsg();
    },

    // 发送报文到服务器
    send: function send(msg) {
        var _this3 = this;

        if (!this.socket) {
            console.log('pls create the WebSocket first!');
            return;
        }

        if (!msg || (typeof msg === 'undefined' ? 'undefined' : _typeof(msg)) != 'object') {
            console.log('Parameter format error, pls check document again!');
            return;
        }

        var result = this.parseUplinkMessage(msg);
        var buff = result.toArrayBuffer();
        result.submiting = 1;
        // 单聊/客服消息
        if (result.type == 7 || result.type == 9) {
            this.appendUpMsgList(result);

            // 每两秒钟检测一次，一旦收到ACK，则关闭当前定时器
            this.ResendTimes[result.msgid] = 0;
            this.AckTimer[result.msgid] = setInterval(function () {
                if (!result.submiting) {
                    clearInterval(_this3.AckTimer[result.msgid]);
                } else {
                    _this3.ResendTimes[result.msgid]++;

                    if (_this3.ResendTimes[result.msgid] > 3) {
                        _this3.emit('resendMessageFail', result.msgid);
                        clearInterval(_this3.AckTimer[result.msgid]);
                        _this3.ResendTimes[result.msgid] = 0;
                    } else {
                        _this3.socket.send(buff);
                    }
                }
                console.log('dddd');
            }, 2000);
        }
        this.socket.send(result.toArrayBuffer());

        return result;
    },

    // ACK消息收到后，更新上行消息列表中的状态，标记submiting状态
    updateUpMsgListStatus: function updateUpMsgListStatus(msgid) {
        for (var i = this.upMsgList.length; i--;) {
            var item = this.upMsgList[i];
            if (item.msgid == msgid) {
                item.submiting = 0;
                break;
            }
        }
    },

    // 每次发送消息均向上行列表中追加
    // 重发消息时不能追加
    appendUpMsgList: function appendUpMsgList(msg) {
        var msgid = msg.msgid;

        for (var i = this.upMsgList.length; i--;) {
            var item = this.upMsgList[i];
            if (item.msgid == msgid) {
                return;
            }
        }
        this.upMsgList.push(msg);
    },


    // 建立连接后, 登录用户需发送出席报文, 否则无法发送消息
    sendAttend: function sendAttend() {

        var body = {
            termType: this.termType,
            userToken: this.userToken
        };

        var msg = {
            type: 1,
            body: body
        };

        this.send(msg);
    },

    // 上行报文格式化
    parseUplinkMessage: function parseUplinkMessage(msg) {
        var stamp = +new Date();
        $.extend(msg, {
            appkey: this.appkey,
            msgid: stamp.toString(),
            sendTime: stamp,
            sId: this.sid
        });

        var body = void 0;

        if (msg.body) {
            switch (msg.type) {
                case 1:
                    body = new _serverActivity2.default.Garuda.Register(msg.body);
                    break;
                // 单聊
                case 7:
                case 9:
                case 10:
                    var msgType = (0, _msgtype.getMsgType)(msg);
                    if (msgType == 'friendText') {
                        body = new _msgContent2.default.Garuda.MsgText({
                            content: msg.body.content
                        });
                    }
                    break;
                default:
                    break;

            }
            msg.body = body.toArrayBuffer();
        }

        var parsed = new _message2.default.Garuda.GMessage(msg);
        return parsed;
    },

    // 下行报文格式化
    parseDownlinkMessage: function parseDownlinkMessage(msg) {

        var format = void 0;
        try {
            format = _message2.default.Garuda.GMessage.decode(msg);
        } catch (e) {
            format = msg;
        }

        format.rId = format.rId ? Number(longToString(format.rId)) : 0;
        format.sId = format.sId ? Number(longToString(format.sId)) : 0;

        if (!format.mFormat) {
            format.mFormat = 0;
        }

        if (format.msgVersion) {
            format.msgVersion = Number(longToString(format.msgVersion));
        }

        // console.log('---------------', format);

        // format.body为空，decode报错
        if (format.body) {
            switch (format.type) {
                // 出席报文
                case 1:
                    format.body = _serverActivity2.default.Garuda.Register.decode(format.body);
                    break;
                // 单聊 / 系统通知
                case 7: // 单聊
                case 10:
                    // 系统通知（礼物助手、官方助手等）
                    // 普通消息                    
                    if (format.mType == 256) {

                        var _msgClass = _msgtype.formatMaps[format.mFormat];
                        format.body = _msgContent2.default.Garuda[_msgClass].decode(format.body);
                    }
                    break;
                // 拉取离线消息
                case 12:
                    if (format.mType == 81) {
                        format.body = _msgActivity2.default.Garuda.OfflineRes.decode(format.body);
                    }
                    break;
                default:
                    var msgClass = _msgtype.formatMaps[format.mFormat];
                    format.body = _msgContent2.default.Garuda[msgClass].decode(format.body);
                    break;
            }
        }

        return format;
    },

    // 创建ping定时器
    createPingTimer: function createPingTimer() {
        var _this4 = this;

        var self = this;
        this._pingTimer && clearInterval(this._pingTimer);
        self._pingTimer = setInterval(function () {
            console.log('ping');
            _this4.send({
                type: 2
            });
        }, this.pingTimeout * 1000);
    },

    // 手动断开
    close: function close() {
        this.closeByManual = true;
        this.socket && this.socket.close();
    },


    // 销毁ping定制器
    destroyPingTimer: function destroyPingTimer() {
        this._pingTimer && clearInterval(this._pingTimer);
    },

    // 销毁ACK检测定时器
    destroyAckCheckTimer: function destroyAckCheckTimer() {
        for (var i in this.AckTimer) {
            if (this.AckTimer[i]) {
                clearInterval(this.AckTimer[i]);
            }
        }
    }
}, _msgtype.sendTypes, _event2.default);

exports.default = IM;
exports.Sessions = _sessions2.default;
exports.FriendList = _friendlist2.default;
exports.getMsgType = _msgtype.getMsgType;
exports.FriendApply = _friendapply2.default;
exports.Config = _constant4.default;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Garuda",
    "options": {
        "objc_class_prefix": "IMPresenceWsAuth",
        "java_package": "com.asiainno.garuda.im.proto"
    },
    "messages": [{
        "name": "AuthRequest",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "appkey",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "termType",
            "id": 2
        }]
    }, {
        "name": "AuthResponse",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "aResult",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "ip",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "port",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "path",
            "id": 4
        }, {
            "rule": "optional",
            "type": "string",
            "name": "nonce",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "time",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "sec",
            "id": 7
        }, {
            "rule": "repeated",
            "type": "bytes",
            "name": "addrs",
            "id": 8
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Event center
 */
(function (global, factory) {

    // amd mode
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof require === 'function' && (typeof module === 'undefined' ? 'undefined' : _typeof(module)) === "object" && module && module["exports"]) {
        // commonjs mode
        module.exports = factory();
    } else {
        // global mode
        global.events = factory();
    }
})(window, function () {

    var Callbacks = function Callbacks(options) {
        options = $.extend({}, options);

        var memory,
            // Last fire value (for non-forgettable lists)
        _fired,
            // Flag to know if list was already fired
        firing,
            // Flag to know if list is currently firing
        firingStart,
            // First callback to fire (used internally by add and fireWith)
        firingLength,
            // End of the loop when firing
        firingIndex,
            // Index of currently firing callback (modified by remove if needed)
        list = [],
            // Actual callback list
        stack = !options.once && [],
            // Stack of fire calls for repeatable lists
        fire = function fire(data) {
            memory = options.memory && data;
            _fired = true;
            firingIndex = firingStart || 0;
            firingStart = 0;
            firingLength = list.length;
            firing = true;
            for (; list && firingIndex < firingLength; ++firingIndex) {
                if (list[firingIndex].apply(data[0], data[1]) === false && options.stopOnFalse) {
                    memory = false;
                    break;
                }
            }
            firing = false;
            if (list) {
                if (stack) stack.length && fire(stack.shift());else if (memory) list.length = 0;else Callbacks.disable();
            }
        },
            Callbacks = {
            list: list,
            add: function add() {
                if (list) {
                    var start = list.length,
                        add = function add(args) {
                        args = Array.prototype.slice.call(args);
                        args.forEach(function (arg, _) {
                            if (typeof arg === "function") {
                                if (!options.unique || !Callbacks.has(arg)) list.push(arg);
                            } else if (arg && arg.length && typeof arg !== 'string') add(arg);
                        });
                    };
                    add(arguments);
                    if (firing) firingLength = list.length;else if (memory) {
                        firingStart = start;
                        fire(memory);
                    }
                }
                return this;
            },
            remove: function remove() {
                var args = Array.prototype.slice.call(arguments);
                if (list) {
                    args.forEach(function (arg, _) {
                        var index;
                        while ((index = list.indexOf(arg, index)) > -1) {
                            list.splice(index, 1);
                            // Handle firing indexes
                            if (firing) {
                                if (index <= firingLength) --firingLength;
                                if (index <= firingIndex) --firingIndex;
                            }
                        }
                    });
                }
                return this;
            },
            has: function has(fn) {
                return !!(list && (fn ? list.indexOf(fn) > -1 : list.length));
            },
            empty: function empty() {
                firingLength = list.length = 0;
                return this;
            },
            disable: function disable() {
                list = stack = memory = undefined;
                return this;
            },
            disabled: function disabled() {
                return !list;
            },
            lock: function lock() {
                stack = undefined;
                if (!memory) Callbacks.disable();
                return this;
            },
            locked: function locked() {
                return !stack;
            },
            fireWith: function fireWith(context, args) {
                if (list && (!_fired || stack)) {
                    args = args || [];
                    args = [context, args.slice ? args.slice() : args];
                    if (firing) stack.push(args);else fire(args);
                }
                return this;
            },
            fire: function fire() {
                return Callbacks.fireWith(this, arguments);
            },
            fired: function fired() {
                return !!_fired;
            }
        };

        return Callbacks;
    };
    var channelObj = {};

    // 统一事件机制
    var Events = {
        Event: Callbacks,
        /**
         * 添加事件监听
         * @param  {string}   name - 事件名称
         * @param  {function} callback - 事件回调
         */
        on: function on(name, callback) {
            var obj,
                that = this;

            this.events = this.events || {};

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.on(item, callback);
                    }
                });
            }

            if (!this.global && name.indexOf('/') != -1) {
                // 频道监听
                if (name.split('/')[0] == 'channel') {
                    return that.channel.on(name.replace(/^channel\//gi, ''), callback);
                }

                obj = getObjectByNames(name, this);
                this.events[name] = this.events[name] || [];
                this.events[name].push(callback);
                return obj ? obj.on(getEventName(name), callback) : this;
            } else {
                obj = this.events[name] || (this.events[name] = this.Event());
            }

            // 如果设置为一起派发，则再次监听时，直接执行
            if (this._alwayEmitSource && this._alwayEmitSource[name]) {
                return callback.apply(name, this._alwayEmitSource[name]);
            }
            obj.add(callback);

            return this;
        },
        /**
         * 移除事件监听
         * @param  {string}   name     事件名称
         * @param  {function} [callback] - 事件回调，为空时，移除所有回调
         */
        off: function off(name, callback) {
            var obj,
                funs,
                that = this;

            this.events = this.events || {};

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.off(item, callback);
                    }
                });
            }

            if (!this.global && name && name.indexOf('/') != -1) {
                if (name.split('/')[0] == 'channel') {
                    return that.channel.off(name.replace(/^channel\//gi, ''), callback);
                }

                if (this.events[name]) {
                    obj = getObjectByNames(name, this);
                    if (callback) {
                        return obj ? obj.off(getEventName(name), callback) : this;
                    } else {
                        funs = this.events[name];
                        for (var i = 0; obj && funs && i < funs.length; i++) {
                            obj.off(getEventName(name), funs[i]);
                        }
                        this.events[name] = null;
                    }
                }

                return this;
            }

            if (name && callback && (obj = this.events[name])) {
                obj.remove(callback);
            } else if (name && (obj = this.events[name])) {
                obj.empty();
            } else {

                for (name in this.events) {
                    if (this.events.hasOwnProperty(name) && this.events[name]) {
                        if (!this.global && name.indexOf('/') != -1) {
                            if (name.split('/')[0] == 'channel') {
                                return this.channel.off(name.replace(/^channel\//gi, ''));
                            }
                            this.off(name);
                        } else {
                            this.events[name].empty();
                        }
                    }
                }
            }

            return this;
        },
        ///**
        // * 只监听一次事件
        // * @param name
        // * @param callback
        // */
        //once: function (name, callback) {
        //    var _callback;
        //
        //    this.on(name, _callback = function () {
        //        callback.apply(this, arguments);
        //        this.off(name, _callback);
        //    });
        //},
        /**
         * 默认派发事件
         * @return {object}
         */
        trigger: function trigger() {
            var name = arguments[0],
                obj,
                param,
                that = this;

            this.events = this.events || {};
            param = Array.prototype.slice.call(arguments, 1);

            // 逗号隔开，支持多事件
            if (name && name.indexOf(',') != -1) {
                return (name.split(',') || []).forEach(function (item) {
                    if (item) {
                        that.trigger.apply(this, [item].concat(param));
                    }
                });
            }

            if (!this.global && name && name.indexOf('/') != -1) {
                if (name.split('/')[0] == 'channel') {
                    return that.channel.trigger.apply(that.channel, [name.replace(/^channel\//gi, '')].concat(param));
                }
                obj = getObjectByNames(name, this);
                name = getEventName(name);
                return obj ? obj.trigger.apply(obj, [name].concat(param)) : this;
            }

            if (name && (obj = this.events[name])) {
                obj.fire.apply(this, [].concat(param));
            }

            return {
                event: obj,
                always: function always() {
                    that._alwayEmitSource = that._alwayEmitSource || {};
                    that._alwayEmitSource[name] = [].concat(param);
                }
            };
        },
        /**
         * 派发事件
         * @example
         *        this.emit('ready',args0,args1...);
         */
        emit: function emit() {
            return this.trigger.apply(this, arguments);
        }
    };

    /**
     * 获取context下的name属性
     * @private
     */
    function getObjectByNames(name, context) {
        var that, names, len;

        context = context || {};
        that = context;
        names = name.split('/');
        len = names.length;

        for (var i = 0; len > 1 && i < len - 1; i++) {
            if (that && that[names[i]]) {
                that = that[names[i]];
            } else {
                that = null;
            }
        }

        return that;
    }

    /**
     * 获取事件名称
     * @param  {String} name [description]
     * @return {String}
     */
    function getEventName(name) {
        var names = name.split('/');
        return names[names.length - 1];
    }

    // global single Event
    Events.channel = $.channel || ($.channel = $.extend(channelObj, Events));
    Events.channel.global = Events.channel;

    return Events;
});

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Garuda",
    "options": {
        "objc_class_prefix": "IMConstant",
        "java_package": "com.asiainno.garuda.im.proto"
    },
    "messages": [{
        "name": "UserInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uId",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "userName",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "userIcon",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "userGrade",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "userSex",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "vip",
            "id": 6
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "uType",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "lang",
            "id": 8
        }, {
            "rule": "optional",
            "type": "string",
            "name": "cc",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "status",
            "id": 10
        }]
    }],
    "enums": [{
        "name": "Type",
        "values": [{
            "name": "PRESERVE",
            "id": 0
        }, {
            "name": "REGISTER",
            "id": 1
        }, {
            "name": "PING",
            "id": 2
        }, {
            "name": "PONG",
            "id": 3
        }, {
            "name": "OUT",
            "id": 4
        }, {
            "name": "ACK",
            "id": 5
        }, {
            "name": "SERVER_NOTICE",
            "id": 6
        }, {
            "name": "USER_CHAT",
            "id": 7
        }, {
            "name": "GROUP_CHAT",
            "id": 8
        }, {
            "name": "SERVICE_CHAT",
            "id": 9
        }, {
            "name": "VIP_SERVICE_CHAT",
            "id": 14
        }, {
            "name": "SYS_NOTICE",
            "id": 10
        }, {
            "name": "SYS_BROADCAST",
            "id": 11
        }, {
            "name": "GROUP_NOTICE",
            "id": 13
        }, {
            "name": "PULL_ACT",
            "id": 12
        }]
    }, {
        "name": "MsgType",
        "values": [{
            "name": "NULL",
            "id": 0
        }, {
            "name": "MSG_ACK_2C",
            "id": 1
        }, {
            "name": "USER_MSG_ACK_2S",
            "id": 2
        }, {
            "name": "SYS_MSG_ACK_2S",
            "id": 3
        }, {
            "name": "OUT_ACK",
            "id": 4
        }, {
            "name": "INVALID_CONNECT",
            "id": 32
        }, {
            "name": "MUST_RELOGIN",
            "id": 33
        }, {
            "name": "NO_REQUEST",
            "id": 34
        }, {
            "name": "PUSH_VERSION",
            "id": 35
        }, {
            "name": "OUT_OF_SIZE",
            "id": 36
        }, {
            "name": "USER_FORBIDDEN_N",
            "id": 37
        }, {
            "name": "PULL_VERSION",
            "id": 80
        }, {
            "name": "PULL_OFFLINE_MSG",
            "id": 81
        }, {
            "name": "PULL_GROUP_MSG",
            "id": 82
        }, {
            "name": "PULL_SYS_MSG",
            "id": 83
        }, {
            "name": "PULL_RECENT_MSG",
            "id": 84
        }, {
            "name": "NORMAL_MSG",
            "id": 256
        }, {
            "name": "FRIEND_APPLY",
            "id": 257
        }, {
            "name": "FRIEND_VALID",
            "id": 258
        }, {
            "name": "FRIEND_INVALID",
            "id": 259
        }, {
            "name": "DYNAMIC_UPDATE",
            "id": 260
        }, {
            "name": "DYNAMIC_COMMENT_NOTICE",
            "id": 261
        }, {
            "name": "DYNAMIC_LIKE_NOTICE",
            "id": 262
        }, {
            "name": "DYNAMIC_UNREVIEW_NOTICE",
            "id": 263
        }, {
            "name": "DYNAMIC_CALCULATE_COMPLETE_NOTICE",
            "id": 264
        }, {
            "name": "GROUP_NOTICE_INVITE_TO_INVITEE",
            "id": 265
        }, {
            "name": "GROUP_NOTICE_INVITE_TO_OTHERS",
            "id": 266
        }, {
            "name": "GROUP_NOTICE_INVITE_TO_CONFIRM",
            "id": 267
        }, {
            "name": "GROUP_NOTICE_INVITE_TO_INVITER",
            "id": 268
        }, {
            "name": "GROUP_NOTICE_INVITE_WAIT_CONFIRM",
            "id": 290
        }, {
            "name": "GROUP_NOTICE_QUIT_TO_KICKED",
            "id": 269
        }, {
            "name": "GROUP_NOTICE_QUIT_TO_KICKER",
            "id": 270
        }, {
            "name": "GROUP_NOTICE_QUIT_TO_OTHERS",
            "id": 271
        }, {
            "name": "GROUP_NOTICE_QUIT_TO_SELF",
            "id": 289
        }, {
            "name": "GROUP_NOTICE_OWNERCHANGE_TO_NEW",
            "id": 272
        }, {
            "name": "GROUP_NOTICE_OWNERCHANGE_TO_OTHERS",
            "id": 273
        }, {
            "name": "GROUP_NOTICE_DISMISS",
            "id": 274
        }, {
            "name": "GROUP_NOTICE_AUTO_DISMISS",
            "id": 275
        }, {
            "name": "GROUP_NOTICE_MODIFY_NAME",
            "id": 276
        }, {
            "name": "GROUP_NOTICE_ADMIN_SETTING_TO_TARGET",
            "id": 277
        }, {
            "name": "GROUP_NOTICE_ADMIN_SETTING_TO_OTHERS",
            "id": 278
        }, {
            "name": "GROUP_NOTICE_ADMIN_RELIEVE_TO_TARGET",
            "id": 279
        }, {
            "name": "GROUP_NOTICE_ADMIN_RELIEVE_TO_OTHERS",
            "id": 280
        }, {
            "name": "ACTIVATE_VIP_CUSTOMER_SERVICE_TO_USER",
            "id": 281
        }, {
            "name": "CHANGE_VIP_CUSTOMER_SERVICE",
            "id": 282
        }, {
            "name": "CLOSE_VIP_CUSTOMER_SERVICE_TO_USER",
            "id": 283
        }, {
            "name": "REACTIVATE_VIP_CUSTOMER_SERVICE",
            "id": 284
        }, {
            "name": "ACTIVATE_VIP_CUSTOMER_SERVICE_TO_CS",
            "id": 285
        }, {
            "name": "CLOSE_VIP_CUSTOMER_SERVICE_TO_CS",
            "id": 287
        }, {
            "name": "GROUP_NOTICE_CREATE_SUCCESS",
            "id": 288
        }]
    }, {
        "name": "MsgFormat",
        "values": [{
            "name": "TEXT",
            "id": 0
        }, {
            "name": "GOTO_TEXT",
            "id": 1
        }, {
            "name": "PIC",
            "id": 2
        }, {
            "name": "GOTO_PIC",
            "id": 3
        }, {
            "name": "AUDIO",
            "id": 4
        }, {
            "name": "VIDEO",
            "id": 5
        }, {
            "name": "LINK",
            "id": 6
        }, {
            "name": "BUBBLE",
            "id": 7
        }, {
            "name": "GIFT",
            "id": 8
        }, {
            "name": "GIFT_REWARD_NOTICE",
            "id": 9
        }, {
            "name": "GIFT_REWARD_USER",
            "id": 10
        }, {
            "name": "FEED_VIDEO_MSG",
            "id": 11
        }, {
            "name": "FEED_TOPIC_MSG",
            "id": 12
        }, {
            "name": "UG_NOTICE",
            "id": 13
        }, {
            "name": "UG_USER",
            "id": 14
        }]
    }, {
        "name": "GotoType",
        "values": [{
            "name": "CUSTOM",
            "id": 0
        }, {
            "name": "LIVEROM",
            "id": 1
        }, {
            "name": "PROFILE",
            "id": 2
        }, {
            "name": "INNER_H5",
            "id": 3
        }, {
            "name": "OUTER_H5",
            "id": 4
        }, {
            "name": "MY_GRADE",
            "id": 5
        }, {
            "name": "MY_VIP",
            "id": 6
        }, {
            "name": "MY_PACK",
            "id": 7
        }, {
            "name": "MY_PACK_EXPIRE_GIFT",
            "id": 8
        }, {
            "name": "DYNAMIC_DETAIL",
            "id": 9
        }, {
            "name": "VIP_CS",
            "id": 10
        }, {
            "name": "GROUP_JOIN",
            "id": 11
        }, {
            "name": "FEED_VIDEO",
            "id": 12
        }, {
            "name": "MY_MOUNT",
            "id": 13
        }, {
            "name": "FEED_TOPIC",
            "id": 14
        }]
    }, {
        "name": "UserType",
        "values": [{
            "name": "NORMAL",
            "id": 0
        }, {
            "name": "ANCHOR",
            "id": 1
        }, {
            "name": "MANAGER",
            "id": 2
        }, {
            "name": "ROBOT",
            "id": 3
        }, {
            "name": "ADMIN",
            "id": 4
        }, {
            "name": "GUESS",
            "id": 5
        }]
    }, {
        "name": "TermType",
        "values": [{
            "name": "NONE",
            "id": 0
        }, {
            "name": "IPHONE",
            "id": 1
        }, {
            "name": "ANDROID",
            "id": 2
        }, {
            "name": "H5",
            "id": 3
        }, {
            "name": "WEB",
            "id": 4
        }, {
            "name": "WAP",
            "id": 5
        }, {
            "name": "OBS",
            "id": 6
        }]
    }, {
        "name": "ServerType",
        "values": [{
            "name": "CONNECTOR_TCP",
            "id": 0
        }, {
            "name": "CONNECTOR_WS",
            "id": 1
        }, {
            "name": "A3S",
            "id": 2
        }, {
            "name": "CONTAINER_NORMAL",
            "id": 3
        }, {
            "name": "CONTAINER_GROUP",
            "id": 4
        }]
    }, {
        "name": "ResultCode",
        "values": [{
            "name": "SUCCESS",
            "id": 0
        }, {
            "name": "ERROR_MSG",
            "id": 1
        }, {
            "name": "ERROR_OTHERS",
            "id": 2
        }, {
            "name": "ERROR_LOSE_PARAMETER",
            "id": 3
        }, {
            "name": "USER_TOKEN_INVALID",
            "id": 4
        }, {
            "name": "FAIL_USER_NOT_EXIST",
            "id": 5
        }, {
            "name": "AUTH_TOKEN_INVALID",
            "id": 6
        }, {
            "name": "ERROR_M1",
            "id": 7
        }, {
            "name": "USER_FORBIDDEN",
            "id": 8
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Garuda",
    "options": {
        "objc_class_prefix": "IMMessage",
        "java_package": "com.asiainno.garuda.im.proto"
    },
    "messages": [{
        "name": "GMessage",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "version",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "appkey",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "feature",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "msgid",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "sendTime",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "receiveTime",
            "id": 6
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "type",
            "id": 7
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "mType",
            "id": 8
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "mFormat",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "sId",
            "id": 10
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "rId",
            "id": 11
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "gId",
            "id": 12
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "msgVersion",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "subVersion",
            "id": 14
        }, {
            "rule": "optional",
            "type": "bytes",
            "name": "body",
            "id": 15
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "msgStatus",
            "id": 16
        }, {
            "rule": "repeated",
            "type": "int64",
            "name": "rIds",
            "id": 17
        }, {
            "rule": "optional",
            "type": "string",
            "name": "multilang",
            "id": 18
        }, {
            "rule": "optional",
            "type": "string",
            "name": "cc",
            "id": 19
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "termType",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "pushMark",
            "id": 21
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "sendMark",
            "id": 22
        }, {
            "rule": "optional",
            "type": "string",
            "name": "ext",
            "id": 23
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Garuda",
    "options": {
        "objc_class_prefix": "IMMsgActivity",
        "java_package": "com.asiainno.garuda.im.proto"
    },
    "messages": [{
        "name": "GMessage",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "version",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "appkey",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "feature",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "msgid",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "sendTime",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "receiveTime",
            "id": 6
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "type",
            "id": 7
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "mType",
            "id": 8
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "mFormat",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "sId",
            "id": 10
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "rId",
            "id": 11
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "gId",
            "id": 12
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "msgVersion",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "subVersion",
            "id": 14
        }, {
            "rule": "optional",
            "type": "bytes",
            "name": "body",
            "id": 15
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "msgStatus",
            "id": 16
        }, {
            "rule": "repeated",
            "type": "int64",
            "name": "rIds",
            "id": 17
        }, {
            "rule": "optional",
            "type": "string",
            "name": "multilang",
            "id": 18
        }, {
            "rule": "optional",
            "type": "string",
            "name": "cc",
            "id": 19
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "termType",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "pushMark",
            "id": 21
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "sendMark",
            "id": 22
        }, {
            "rule": "optional",
            "type": "string",
            "name": "ext",
            "id": 23
        }]
    }, {
        "name": "PullVersions",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "userlv",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "syslv",
            "id": 2
        }]
    }, {
        "name": "PushVersions",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "usercv",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "usize",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "syscv",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "ssize",
            "id": 4
        }]
    }, {
        "name": "OfflineReq",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "startVersion",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "endVersion",
            "id": 2
        }, {
            "rule": "repeated",
            "type": "int64",
            "name": "msgVersions",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "lang",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "gId",
            "id": 5
        }]
    }, {
        "name": "GroupOfflineReq",
        "fields": [{
            "rule": "repeated",
            "type": "OfflineReq",
            "name": "OfflineReq",
            "id": 1
        }]
    }, {
        "name": "OfflineRes",
        "fields": [{
            "rule": "repeated",
            "type": "GMessage",
            "name": "offlineMsg",
            "id": 1
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Garuda",
    "options": {
        "objc_class_prefix": "IMServerActivity",
        "java_package": "com.asiainno.garuda.im.proto"
    },
    "messages": [{
        "name": "UserInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uId",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "userName",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "userIcon",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "userGrade",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "userSex",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "vip",
            "id": 6
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "uType",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "lang",
            "id": 8
        }, {
            "rule": "optional",
            "type": "string",
            "name": "cc",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "status",
            "id": 10
        }]
    }, {
        "name": "Register",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "deviceid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "termType",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "appVersion",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "appName",
            "id": 4
        }, {
            "rule": "optional",
            "type": "string",
            "name": "channel",
            "id": 5
        }, {
            "rule": "optional",
            "type": "DeviceDetail",
            "name": "deviceDetail",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "userToken",
            "id": 7
        }, {
            "rule": "optional",
            "type": "UserInfo",
            "name": "userInfo",
            "id": 8
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "isReconn",
            "id": 9
        }, {
            "rule": "optional",
            "type": "bytes",
            "name": "authToken",
            "id": 10
        }, {
            "rule": "optional",
            "type": "bytes",
            "name": "m1",
            "id": 11
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "rResult",
            "id": 12
        }]
    }, {
        "name": "DeviceDetail",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "os",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "brand",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "model",
            "id": 3
        }]
    }, {
        "name": "Out",
        "fields": [{
            "rule": "optional",
            "type": "bool",
            "name": "isReconn",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "effectiveTime",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "deviceid",
            "id": 3
        }]
    }, {
        "name": "InternalRegister",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "sType",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "ip",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "port",
            "id": 3
        }]
    }],
    "enums": [{
        "name": "Type",
        "values": [{
            "name": "PRESERVE",
            "id": 0
        }, {
            "name": "REGISTER",
            "id": 1
        }, {
            "name": "PING",
            "id": 2
        }, {
            "name": "PONG",
            "id": 3
        }, {
            "name": "OUT",
            "id": 4
        }, {
            "name": "ACK",
            "id": 5
        }, {
            "name": "SERVER_NOTICE",
            "id": 6
        }, {
            "name": "USER_CHAT",
            "id": 7
        }, {
            "name": "GROUP_CHAT",
            "id": 8
        }, {
            "name": "SERVICE_CHAT",
            "id": 9
        }, {
            "name": "VIP_SERVICE_CHAT",
            "id": 14
        }, {
            "name": "SYS_NOTICE",
            "id": 10
        }, {
            "name": "SYS_BROADCAST",
            "id": 11
        }, {
            "name": "GROUP_NOTICE",
            "id": 13
        }, {
            "name": "PULL_ACT",
            "id": 12
        }]
    }, {
        "name": "MsgType",
        "values": [{
            "name": "NULL",
            "id": 0
        }, {
            "name": "MSG_ACK_2C",
            "id": 1
        }, {
            "name": "USER_MSG_ACK_2S",
            "id": 2
        }, {
            "name": "SYS_MSG_ACK_2S",
            "id": 3
        }, {
            "name": "OUT_ACK",
            "id": 4
        }, {
            "name": "INVALID_CONNECT",
            "id": 32
        }, {
            "name": "MUST_RELOGIN",
            "id": 33
        }, {
            "name": "NO_REQUEST",
            "id": 34
        }, {
            "name": "PUSH_VERSION",
            "id": 35
        }, {
            "name": "OUT_OF_SIZE",
            "id": 36
        }, {
            "name": "USER_FORBIDDEN_N",
            "id": 37
        }, {
            "name": "PULL_VERSION",
            "id": 80
        }, {
            "name": "PULL_OFFLINE_MSG",
            "id": 81
        }, {
            "name": "PULL_GROUP_MSG",
            "id": 82
        }, {
            "name": "PULL_SYS_MSG",
            "id": 83
        }, {
            "name": "PULL_RECENT_MSG",
            "id": 84
        }, {
            "name": "NORMAL_MSG",
            "id": 256
        }, {
            "name": "FRIEND_APPLY",
            "id": 257
        }, {
            "name": "FRIEND_VALID",
            "id": 258
        }, {
            "name": "FRIEND_INVALID",
            "id": 259
        }, {
            "name": "DYNAMIC_UPDATE",
            "id": 260
        }, {
            "name": "DYNAMIC_COMMENT_NOTICE",
            "id": 261
        }, {
            "name": "DYNAMIC_LIKE_NOTICE",
            "id": 262
        }, {
            "name": "DYNAMIC_UNREVIEW_NOTICE",
            "id": 263
        }, {
            "name": "DYNAMIC_CALCULATE_COMPLETE_NOTICE",
            "id": 264
        }, {
            "name": "GROUP_NOTICE_INVITE_TO_INVITEE",
            "id": 265
        }, {
            "name": "GROUP_NOTICE_INVITE_TO_OTHERS",
            "id": 266
        }, {
            "name": "GROUP_NOTICE_INVITE_TO_CONFIRM",
            "id": 267
        }, {
            "name": "GROUP_NOTICE_INVITE_TO_INVITER",
            "id": 268
        }, {
            "name": "GROUP_NOTICE_INVITE_WAIT_CONFIRM",
            "id": 290
        }, {
            "name": "GROUP_NOTICE_QUIT_TO_KICKED",
            "id": 269
        }, {
            "name": "GROUP_NOTICE_QUIT_TO_KICKER",
            "id": 270
        }, {
            "name": "GROUP_NOTICE_QUIT_TO_OTHERS",
            "id": 271
        }, {
            "name": "GROUP_NOTICE_QUIT_TO_SELF",
            "id": 289
        }, {
            "name": "GROUP_NOTICE_OWNERCHANGE_TO_NEW",
            "id": 272
        }, {
            "name": "GROUP_NOTICE_OWNERCHANGE_TO_OTHERS",
            "id": 273
        }, {
            "name": "GROUP_NOTICE_DISMISS",
            "id": 274
        }, {
            "name": "GROUP_NOTICE_AUTO_DISMISS",
            "id": 275
        }, {
            "name": "GROUP_NOTICE_MODIFY_NAME",
            "id": 276
        }, {
            "name": "GROUP_NOTICE_ADMIN_SETTING_TO_TARGET",
            "id": 277
        }, {
            "name": "GROUP_NOTICE_ADMIN_SETTING_TO_OTHERS",
            "id": 278
        }, {
            "name": "GROUP_NOTICE_ADMIN_RELIEVE_TO_TARGET",
            "id": 279
        }, {
            "name": "GROUP_NOTICE_ADMIN_RELIEVE_TO_OTHERS",
            "id": 280
        }, {
            "name": "ACTIVATE_VIP_CUSTOMER_SERVICE_TO_USER",
            "id": 281
        }, {
            "name": "CHANGE_VIP_CUSTOMER_SERVICE",
            "id": 282
        }, {
            "name": "CLOSE_VIP_CUSTOMER_SERVICE_TO_USER",
            "id": 283
        }, {
            "name": "REACTIVATE_VIP_CUSTOMER_SERVICE",
            "id": 284
        }, {
            "name": "ACTIVATE_VIP_CUSTOMER_SERVICE_TO_CS",
            "id": 285
        }, {
            "name": "CLOSE_VIP_CUSTOMER_SERVICE_TO_CS",
            "id": 287
        }, {
            "name": "GROUP_NOTICE_CREATE_SUCCESS",
            "id": 288
        }]
    }, {
        "name": "MsgFormat",
        "values": [{
            "name": "TEXT",
            "id": 0
        }, {
            "name": "GOTO_TEXT",
            "id": 1
        }, {
            "name": "PIC",
            "id": 2
        }, {
            "name": "GOTO_PIC",
            "id": 3
        }, {
            "name": "AUDIO",
            "id": 4
        }, {
            "name": "VIDEO",
            "id": 5
        }, {
            "name": "LINK",
            "id": 6
        }, {
            "name": "BUBBLE",
            "id": 7
        }, {
            "name": "GIFT",
            "id": 8
        }, {
            "name": "GIFT_REWARD_NOTICE",
            "id": 9
        }, {
            "name": "GIFT_REWARD_USER",
            "id": 10
        }, {
            "name": "FEED_VIDEO_MSG",
            "id": 11
        }, {
            "name": "FEED_TOPIC_MSG",
            "id": 12
        }]
    }, {
        "name": "GotoType",
        "values": [{
            "name": "CUSTOM",
            "id": 0
        }, {
            "name": "LIVEROM",
            "id": 1
        }, {
            "name": "PROFILE",
            "id": 2
        }, {
            "name": "INNER_H5",
            "id": 3
        }, {
            "name": "OUTER_H5",
            "id": 4
        }, {
            "name": "MY_GRADE",
            "id": 5
        }, {
            "name": "MY_VIP",
            "id": 6
        }, {
            "name": "MY_PACK",
            "id": 7
        }, {
            "name": "MY_PACK_EXPIRE_GIFT",
            "id": 8
        }, {
            "name": "DYNAMIC_DETAIL",
            "id": 9
        }, {
            "name": "VIP_CS",
            "id": 10
        }, {
            "name": "GROUP_JOIN",
            "id": 11
        }, {
            "name": "FEED_VIDEO",
            "id": 12
        }, {
            "name": "MY_MOUNT",
            "id": 13
        }, {
            "name": "FEED_TOPIC",
            "id": 14
        }]
    }, {
        "name": "UserType",
        "values": [{
            "name": "NORMAL",
            "id": 0
        }, {
            "name": "ANCHOR",
            "id": 1
        }, {
            "name": "MANAGER",
            "id": 2
        }, {
            "name": "ROBOT",
            "id": 3
        }, {
            "name": "ADMIN",
            "id": 4
        }, {
            "name": "GUESS",
            "id": 5
        }]
    }, {
        "name": "TermType",
        "values": [{
            "name": "NONE",
            "id": 0
        }, {
            "name": "IPHONE",
            "id": 1
        }, {
            "name": "ANDROID",
            "id": 2
        }, {
            "name": "H5",
            "id": 3
        }, {
            "name": "WEB",
            "id": 4
        }, {
            "name": "WAP",
            "id": 5
        }, {
            "name": "OBS",
            "id": 6
        }]
    }, {
        "name": "ServerType",
        "values": [{
            "name": "CONNECTOR_TCP",
            "id": 0
        }, {
            "name": "CONNECTOR_WS",
            "id": 1
        }, {
            "name": "A3S",
            "id": 2
        }, {
            "name": "CONTAINER_NORMAL",
            "id": 3
        }, {
            "name": "CONTAINER_GROUP",
            "id": 4
        }]
    }, {
        "name": "ResultCode",
        "values": [{
            "name": "SUCCESS",
            "id": 0
        }, {
            "name": "ERROR_MSG",
            "id": 1
        }, {
            "name": "ERROR_OTHERS",
            "id": 2
        }, {
            "name": "ERROR_LOSE_PARAMETER",
            "id": 3
        }, {
            "name": "USER_TOKEN_INVALID",
            "id": 4
        }, {
            "name": "FAIL_USER_NOT_EXIST",
            "id": 5
        }, {
            "name": "AUTH_TOKEN_INVALID",
            "id": 6
        }, {
            "name": "ERROR_M1",
            "id": 7
        }, {
            "name": "USER_FORBIDDEN",
            "id": 8
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Garuda",
    "options": {
        "objc_class_prefix": "IMMsgContent",
        "java_package": "com.asiainno.garuda.im.proto"
    },
    "messages": [{
        "name": "MsgText",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "content",
            "id": 1
        }]
    }, {
        "name": "MsgGotoText",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "content",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gotoType",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "bizBody",
            "id": 3
        }]
    }, {
        "name": "MsgPic",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "content",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "origUrl",
            "id": 2
        }, {
            "rule": "optional",
            "type": "bytes",
            "name": "thumbFile",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "ext",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "w",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "h",
            "id": 6
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "size",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "midUrl",
            "id": 8
        }]
    }, {
        "name": "MsgGotoPic",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "content",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gotoType",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "bizBody",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "name",
            "id": 4
        }, {
            "rule": "optional",
            "type": "string",
            "name": "url",
            "id": 5
        }, {
            "rule": "optional",
            "type": "bytes",
            "name": "pic",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "ext",
            "id": 7
        }, {
            "rule": "optional",
            "type": "double",
            "name": "w",
            "id": 8
        }, {
            "rule": "optional",
            "type": "double",
            "name": "h",
            "id": 9
        }, {
            "rule": "optional",
            "type": "double",
            "name": "size",
            "id": 10
        }]
    }, {
        "name": "MsgBubble",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "content",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "title",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "picUrl",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gotoType",
            "id": 4
        }, {
            "rule": "optional",
            "type": "string",
            "name": "bizBody",
            "id": 5
        }]
    }, {
        "name": "MsgGift",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "content",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "giftId",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "giftName",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "giftAmount",
            "id": 4
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "isContinuous",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "numContinuous",
            "id": 6
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gotoType",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "bizBody",
            "id": 8
        }]
    }, {
        "name": "GroupNotice",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "suid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "sname",
            "id": 2
        }, {
            "rule": "repeated",
            "type": "int64",
            "name": "tuid",
            "id": 3
        }, {
            "rule": "repeated",
            "type": "string",
            "name": "tname",
            "id": 4
        }, {
            "rule": "optional",
            "type": "string",
            "name": "gname",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "content",
            "id": 6
        }]
    }, {
        "name": "MsgGiftReward",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "content",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "giftId",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "giftName",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "giftAmount",
            "id": 4
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "isContinuous",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "numContinuous",
            "id": 6
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gotoType",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "bizBody",
            "id": 8
        }, {
            "rule": "optional",
            "type": "string",
            "name": "rewardResourceUrl",
            "id": 9
        }, {
            "rule": "optional",
            "type": "string",
            "name": "rewardResourceName",
            "id": 12
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "sid",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "sname",
            "id": 11
        }]
    }, {
        "name": "MsgFeedVideo",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "videoUrl",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "sid",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "sname",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "videoDesc",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gotoType",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "bizBody",
            "id": 6
        }]
    }, {
        "name": "MsgFeedTopic",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "topicName",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "topicDesc",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gotoType",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "bizBody",
            "id": 4
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 444 */
/***/ (function(module, exports) {



Object.defineProperty(exports, "__esModule", {
	value: true
});
var systemAccounts = [10001, 10004, 10005];
var UP_10001_avatar = 'http://g.cdn.upliveapps.com/oauthgame/pcimup.png';
var UP_10004_avatar = 'http://g.cdn.upliveapps.com/oauthgame/pcimgift.png';
var UP_10005_avatar = 'http://g.cdn.upliveapps.com/oauthgame/pcimservice.png';

var isSystemAccount = function isSystemAccount(uid) {
	return systemAccounts.indexOf(uid) > -1;
};

var Config = {
	UP_10001_avatar: UP_10001_avatar,
	UP_10004_avatar: UP_10004_avatar,
	UP_10005_avatar: UP_10005_avatar,
	isSystemAccount: isSystemAccount
};

exports.default = Config;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 拉取会话列表
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author zhenn
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @createTime 2017-11-30 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _cUpPbajax = __webpack_require__(46);

var _cUpPbajax2 = _interopRequireDefault(_cUpPbajax);

var _cPublicpb = __webpack_require__(69);

var _cPublicpb2 = _interopRequireDefault(_cPublicpb);

var _session = __webpack_require__(446);

var _session2 = _interopRequireDefault(_session);

var _delete = __webpack_require__(447);

var _delete2 = _interopRequireDefault(_delete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Sessions = function () {
    function Sessions(userToken) {
        _classCallCheck(this, Sessions);

        this.pbajax = new _cUpPbajax2.default();
        this.userToken = userToken;

        // 默认会话列表
        this.defaultList = [{
            type: 7, //单聊(USER_CHAT)
            oid: 10005 // 会话参与者对方标识
        }];
    }

    _createClass(Sessions, [{
        key: 'getData',
        value: function getData() {
            var _this = this;

            var promise = $.Deferred();
            this.pbajax.do({
                service: 'im',
                api: '/user/conversations',
                header: {
                    userToken: this.userToken,
                    appkey: 'uplive'
                }
            }, new _session2.default.ImUser.Conversations.Request({}), function (res) {
                var dataWrap = _cPublicpb2.default.Result.decode(res);
                var data;

                if (dataWrap.code == 1) {
                    if (dataWrap.data.value) {
                        data = _session2.default.ImUser.Conversations.Response.decode(dataWrap.data.value);
                    } else {
                        data = {
                            conversations: []
                        };
                    }

                    // 遍历会话列表。重组会话列表
                    var list = [];

                    if (data.conversations.length > 0) {
                        for (var i = data.conversations.length; i--;) {
                            var item = data.conversations[i];
                            // 将oid类型转化int
                            item.oid = Number(longToString(item.oid));

                            if (item.oid !== 10005) {
                                list[list.length] = item;
                            }
                        }
                    }

                    data.conversations = [].concat(_toConsumableArray(_this.defaultList), list);
                    _this.list = data.conversations;
                    promise.resolve(data);
                } else {
                    promise.reject();
                }
            }, function () {
                promise.reject();
            });

            return promise;
        }
    }, {
        key: 'getConversations',
        value: function getConversations() {
            return this.list;
        }
    }, {
        key: 'getConversationById',
        value: function getConversationById(oid) {
            var ret = {};
            var list = this.list;

            if (list) {
                for (var i = list.length; i--;) {
                    var item = list[i];

                    if (item.oid == oid) {
                        ret = item;
                        break;
                    }
                }
            }

            return ret;
        }
        /**
         * entrys 会话列表: [{type: '', oid: ''}, {type: '', oid: ''}]
         */

    }, {
        key: 'deleteImConversation',
        value: function deleteImConversation(entrys, callback) {
            var Request = _delete2.default.ImConversation.Delete.Request;

            var cfg = {
                service: 'im',
                api: '/conversation/delete',
                header: {
                    userToken: this.userToken
                }
            };
            var requestData = new Request({
                entrys: entrys
            });

            this.pbajax.do(cfg, requestData, function (res) {
                var dataWrap = _cPublicpb2.default.Result.decode(res);

                if (dataWrap.code == 1) {
                    callback();
                }
            });
        }
    }]);

    return Sessions;
}();

exports.default = Sessions;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// 会话列表session
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "ImUser.Conversations",
    "options": {
        "objc_class_prefix": "ImUserConversations",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Request",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "offset",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "limit",
            "id": 2
        }]
    }, {
        "name": "Response",
        "fields": [{
            "rule": "repeated",
            "type": "Conversation",
            "name": "conversations",
            "id": 1
        }]
    }, {
        "name": "Conversation",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "type",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "oid",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "name",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 4
        }, {
            "rule": "repeated",
            "type": "string",
            "name": "avatars",
            "id": 5
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "ImConversation.Delete",
    "options": {
        "objc_class_prefix": "ImConversationDelete",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Request",
        "fields": [{
            "rule": "repeated",
            "type": "ConversationEntry",
            "name": "entrys",
            "id": 1
        }]
    }, {
        "name": "ConversationEntry",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "type",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "oid",
            "id": 2
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 拉取好友列表
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author zhenn
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @createTime 2017-11-30 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _cUpPbajax = __webpack_require__(46);

var _cUpPbajax2 = _interopRequireDefault(_cUpPbajax);

var _cPublicpb = __webpack_require__(69);

var _cPublicpb2 = _interopRequireDefault(_cPublicpb);

var _profile = __webpack_require__(209);

var _profile2 = _interopRequireDefault(_profile);

var _friend = __webpack_require__(450);

var _friend2 = _interopRequireDefault(_friend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FriendList = function () {
    function FriendList(userToken) {
        _classCallCheck(this, FriendList);

        this.pbajax = new _cUpPbajax2.default();
        this.userToken = userToken;
    }

    _createClass(FriendList, [{
        key: 'getData',
        value: function getData() {
            var _this = this;

            var promise = $.Deferred();

            this.pbajax.do({
                service: 'service',
                api: '/follow/mutual/concern/list',
                header: {
                    userToken: this.userToken
                }
            }, new _friend2.default.Follow.MutualConcernList.Request({ page: 1, pageSize: 2000 }), function (res) {
                var dataWrap = _cPublicpb2.default.Result.decode(res);
                var data;
                if (dataWrap.code == 1) {
                    if (dataWrap.data.value) {
                        data = _friend2.default.Follow.MutualConcernList.Response.decode(dataWrap.data.value);
                    } else {
                        data = {
                            infos: []
                        };
                    }
                    _this.list = data.infos;
                    promise.resolve(data);
                } else {
                    promise.reject();
                }
            }, function () {
                promise.reject();
            });

            return promise;
        }
    }, {
        key: 'getFriendById',
        value: function getFriendById(uid) {
            var friend = {};
            var friends = this.list;
            if (friends) {
                for (var i = friends.length; i--;) {
                    var item = friends[i];

                    if (longToString(item.uid) == uid) {
                        friend = item;
                        break;
                    }
                }
            }

            return friend;
        }
    }, {
        key: 'getFriendList',
        value: function getFriendList() {
            return this.list;
        }
    }, {
        key: 'deleteFriendById',
        value: function deleteFriendById(uid) {
            var friends = this.list;

            if (friends) {
                for (var i = friends.length; i--;) {
                    var item = friends[i];

                    if (longToString(item.uid) == uid) {
                        friends.splice(i, 1);
                        break;
                    }
                }
            }

            this.list = friends;
        }
    }, {
        key: 'addFriendById',
        value: function addFriendById(uid) {
            var _this2 = this;

            var promise = $.Deferred();
            var list = this.list;

            for (var i = list.length; i--;) {
                var item = list[i];
                if (longToString(item.uid) == uid) {
                    list.splice(i, 1);
                    break;
                }
            }

            var profile = new _profile2.default(uid, this.userToken);

            profile.promise.done(function (_data) {

                _this2.list.push({
                    avatar: _data.avatar,
                    gender: _data.gender,
                    grade: _data.grade,
                    officialAuth: _data.officialAuth,
                    officialAuthContent: _data.officialAuthContent,
                    uid: _data.uid,
                    upliveCode: _data.upliveCode,
                    username: _data.username
                });
                promise.resolve();;
            });

            return promise;
        }
    }]);

    return FriendList;
}();

exports.default = FriendList;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "UserBalanceInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "inBill",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "outDiamond",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "bill",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "diamond",
            "id": 4
        }]
    }, {
        "name": "ProfileInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "setting",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "password",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "userToken",
            "id": 8
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "location",
            "id": 11
        }, {
            "rule": "optional",
            "type": "string",
            "name": "mobilePhone",
            "id": 12
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "fanTotal",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followTotal",
            "id": 14
        }, {
            "rule": "optional",
            "type": "UserBalanceInfo",
            "name": "balance",
            "id": 15
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "chatroomid",
            "id": 16
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followType",
            "id": 17
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "exp",
            "id": 18
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "currentExp",
            "id": 19
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "nextExp",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 21
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 22
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "qualityAuth",
            "id": 23
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 25
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "admin",
            "id": 26
        }]
    }, {
        "name": "Profile",
        "fields": [],
        "messages": [{
            "name": "Get",
            "fields": [],
            "options": {
                "objc_class_prefix": "ProfileGet",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "int64",
                    "name": "vuid",
                    "id": 1
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "ProfileInfo",
                    "name": "profile",
                    "id": 1
                }]
            }]
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// 好友列表pb
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "MutualConcern",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 6
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 8
        }]
    }, {
        "name": "Follow",
        "fields": [],
        "messages": [{
            "name": "MutualConcernList",
            "fields": [],
            "options": {
                "objc_class_prefix": "FollowMutualConcernList",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "int32",
                    "name": "page",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "pageSize",
                    "id": 2
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "int32",
                    "name": "total",
                    "id": 1
                }, {
                    "rule": "repeated",
                    "type": "MutualConcern",
                    "name": "infos",
                    "id": 2
                }]
            }]
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 好友请求列表
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author zhenn
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @createTime 2017-11-30
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _msgtype = __webpack_require__(208);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _profile = __webpack_require__(209);

var _profile2 = _interopRequireDefault(_profile);

var _follow2 = __webpack_require__(452);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FriendApply = function () {
    function FriendApply(obj) {
        _classCallCheck(this, FriendApply);

        this.im = obj.im;
        this.uid = obj.uid;
        this.userToken = obj.userToken;
        this.cache = new _cCache2.default({
            prefix: 'im/uplive/' + this.uid,
            expires: 3 * 24 * 60 * 60 * 1000
        });
        this.unhandledApplyCount = this.cache.getCache('unhandledApplyCount') || 0;
        this.list = this.cache.getCache('friendApplyList') || [];
    }

    _createClass(FriendApply, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.im.on('message', function (data) {
                var msgtype = (0, _msgtype.getMsgType)(data);

                if (msgtype == 'friendApply') {
                    _this.updateUnhandledApplyCount('add', data);
                    var promise = _this.addApplyList(data);

                    promise.done(function () {
                        $.channel.emit('onNewFriendApply', {
                            newCount: _this.getUnhandledApplyCount(),
                            applyList: _this.getApplyList()
                        });
                    });
                } else if (msgtype == 'friendValid') {
                    $.channel.emit('onFriendValid', data.sId);
                    // 成为好友通知
                    _this.updateApplyList(data.sId);
                } else if (msgtype == 'friendInvalid') {
                    // 解除好友通知
                    $.channel.emit('onFriendInvalid', data.sId);
                }
            });
        }
    }, {
        key: 'getApplyList',
        value: function getApplyList() {
            return this.list;
        }
    }, {
        key: 'getUnhandledApplyCount',
        value: function getUnhandledApplyCount() {
            return this.unhandledApplyCount;
        }
    }, {
        key: 'updateUnhandledApplyCount',
        value: function updateUnhandledApplyCount(type, data) {

            if (type == 'add') {
                var sid = data.sId;
                var list = this.list;

                for (var i = list.length; i--;) {
                    var item = list[i];

                    if (item.sid == sid && item.unhandled == true) {
                        return;
                    }
                }
            }

            type == 'add' ? this.unhandledApplyCount++ : this.unhandledApplyCount--;
            this.cache.setCache('unhandledApplyCount', this.unhandledApplyCount < 0 ? 0 : this.unhandledApplyCount);
        }
    }, {
        key: 'clearUnhandledApplyCount',
        value: function clearUnhandledApplyCount() {
            this.unhandledApplyCount = 0;
            this.cache.setCache('unhandledApplyCount', 0);
        }
    }, {
        key: 'addApplyList',
        value: function addApplyList(data) {
            var _this2 = this;

            var promise = $.Deferred();
            var sid = data.sId;
            var list = this.list;

            var profile = new _profile2.default(sid, this.userToken);

            profile.promise.done(function (_data) {
                for (var i = _this2.list.length; i--;) {
                    var item = _this2.list[i];
                    if (item.sid == sid) {
                        _this2.list.splice(i, 1);
                        break;
                    }
                }

                _this2.list.push({
                    sid: sid,
                    userInfo: _data,
                    verifyMsg: data.body.content,
                    unhandled: true
                });
                _this2.cache.setCache('friendApplyList', _this2.list);

                promise.resolve();

                // setTimeout(()=>{
                //     this.follow(sid);
                // }, 3000);
            });

            return promise;
        }
    }, {
        key: 'updateApplyList',
        value: function updateApplyList(uid) {

            var list = this.list;

            for (var i = list.length; i--;) {
                var item = list[i];
                if (item.sid == uid) {
                    item.unhandled = false;
                    break;
                }
            }

            this.cache.setCache('friendApplyList', this.list);
        }

        // 同意添加好友

    }, {
        key: 'follow',
        value: function follow(obj) {
            var _this3 = this;

            var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

            (0, _follow2.follow)(obj, this.userToken, function () {
                _this3.updateUnhandledApplyCount('delete');
                _this3.updateApplyList(obj.uid);
                callback();
            });
        }
    }]);

    return FriendApply;
}();

;

exports.default = FriendApply;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.unfollow = exports.follow = undefined;

var _index = __webpack_require__(453);

var _index2 = _interopRequireDefault(_index);

var _unfollow = __webpack_require__(454);

var _unfollow2 = _interopRequireDefault(_unfollow);

var _cPublicpb = __webpack_require__(69);

var _cPublicpb2 = _interopRequireDefault(_cPublicpb);

var _cUpPbajax = __webpack_require__(46);

var _cUpPbajax2 = _interopRequireDefault(_cUpPbajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 关注用户
var pbajax = new _cUpPbajax2.default();

var follow = function follow(obj, userToken, callback) {
    var cfg = {
        service: 'service',
        api: '/follow/user/add',
        header: {
            userToken: userToken
        }
    };
    var requestData = new _index2.default.Follow.UserAdd.Request({
        fuid: obj.uid,
        addFriend: obj.addFriend,
        content: obj.content
    });

    pbajax.do(cfg, requestData, function (res) {
        var dataWrap = _cPublicpb2.default.Result.decode(res);
        if (dataWrap.code == 1) {
            callback(obj.uid);
        }
    });
};

var unfollow = function unfollow(fuid, userToken, callback) {

    var cfg = {
        service: 'service',
        api: '/follow/user/unfollow',
        header: {
            userToken: userToken
        }
    };
    var requestData = new _unfollow2.default.Follow.UserUnfollow.Request({
        fuid: fuid
    });

    pbajax.do(cfg, requestData, function (res) {
        var dataWrap = _cPublicpb2.default.Result.decode(res);
        if (dataWrap.code == 1) {
            callback(fuid);
        }
    });
};

exports.follow = follow;
exports.unfollow = unfollow;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Follow.UserAdd",
    "options": {
        "objc_class_prefix": "FollowUserAdd",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Request",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "fuid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "addFriend",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "content",
            "id": 3
        }]
    }, {
        "name": "Response",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "followType",
            "id": 1
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Follow.UserUnfollow",
    "options": {
        "objc_class_prefix": "FollowUserUnfollow",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Request",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "fuid",
            "id": 1
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ChatMsgListView = exports.OfflineConfirm = exports.ApplyConfirm = exports.FriendApplyListView = exports.FriendListView = exports.UserChatItemView = exports.OfficeItemView = exports.ConversationListView = undefined;

var _conversationList = __webpack_require__(456);

var _conversationList2 = _interopRequireDefault(_conversationList);

var _friendList = __webpack_require__(465);

var _friendList2 = _interopRequireDefault(_friendList);

var _applyList = __webpack_require__(466);

var _applyList2 = _interopRequireDefault(_applyList);

var _applyConfirm = __webpack_require__(467);

var _applyConfirm2 = _interopRequireDefault(_applyConfirm);

var _offlineConfirm = __webpack_require__(468);

var _offlineConfirm2 = _interopRequireDefault(_offlineConfirm);

var _chatmsgList = __webpack_require__(469);

var _chatmsgList2 = _interopRequireDefault(_chatmsgList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ConversationListView = _conversationList2.default;
exports.OfficeItemView = _conversationList.OfficeItemView;
exports.UserChatItemView = _conversationList.UserChatItemView;
exports.FriendListView = _friendList2.default;
exports.FriendApplyListView = _applyList2.default;
exports.ApplyConfirm = _applyConfirm2.default;
exports.OfflineConfirm = _offlineConfirm2.default;
exports.ChatMsgListView = _chatmsgList2.default;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.UserChatItemView = exports.OfficeItemView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _userUi = __webpack_require__(22);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 会话列表
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var OfficeItemView = function OfficeItemView(_ref) {
	var item = _ref.item;

	return _react2.default.createElement(
		'div',
		null,
		_react2.default.createElement(
			'div',
			{ className: 'avatar' },
			_react2.default.createElement(
				'span',
				{ className: 'ui-img', style: { width: '30px', height: '30px' } },
				_react2.default.createElement('img', { src: '//g.cdn.pengpengla.com/oauthgame/html5/20181102/b337ac6311d5b3d03d32838f4253354f.png' })
			)
		),
		_react2.default.createElement(
			'div',
			{ className: 'info' },
			_react2.default.createElement(
				'div',
				{ className: 'name' },
				_lang2.default.template('官方客服')
			)
		)
	);
};

var UserChatItemView = function UserChatItemView(_ref2) {
	var item = _ref2.item;


	return _react2.default.createElement(
		'div',
		null,
		_react2.default.createElement(
			'div',
			{ className: 'avatar' },
			_react2.default.createElement(_userUi.ImageView, { src: item.avatar, size: 30, circle: true })
		),
		_react2.default.createElement(
			'div',
			{ className: 'info' },
			_react2.default.createElement(
				'div',
				{ className: 'name' },
				item.name
			)
		)
	);
};

var ConversationListView = function (_Component) {
	_inherits(ConversationListView, _Component);

	function ConversationListView() {
		_classCallCheck(this, ConversationListView);

		return _possibleConstructorReturn(this, (ConversationListView.__proto__ || Object.getPrototypeOf(ConversationListView)).apply(this, arguments));
	}

	_createClass(ConversationListView, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    sessionNotice = _props.sessionNotice,
			    selectedItem = _props.selectedItem;


			return _react2.default.createElement(
				'div',
				{ className: 'conversation-list' },
				_react2.default.createElement(
					'ul',
					null,
					this.props.list.map(function (item, index) {
						var actived = selectedItem.oid == item.oid ? 'actived' : '';
						var noticeNum = void 0;

						if (sessionNotice[item.oid] > 0) {
							if (sessionNotice[item.oid] > 99) {
								noticeNum = _react2.default.createElement(
									'i',
									{ className: 'notice-num' },
									'99+'
								);
							} else {
								noticeNum = _react2.default.createElement(
									'i',
									{ className: 'notice-num' },
									sessionNotice[item.oid]
								);
							}
						}

						if (item.oid == 10005) {
							return _react2.default.createElement(
								'li',
								{ className: actived, key: item.oid, 'data-uid': item.oid, onClick: _this2.props.talkTo.bind(_this2, item) },
								_react2.default.createElement(OfficeItemView, { item: item }),
								noticeNum
							);
						} else {
							return _react2.default.createElement(
								'li',
								{ className: actived, key: item.oid, 'data-uid': item.oid, onClick: _this2.props.talkTo.bind(_this2, item) },
								_react2.default.createElement(UserChatItemView, { item: item }),
								noticeNum
							);
						}
					})
				)
			);
		}
	}]);

	return ConversationListView;
}(_react.Component);

ConversationListView.defaultProps = {
	list: [],
	selectedItem: {}, // 默认选中
	sessionNotice: [],
	talkTo: function talkTo() {}
};
exports.default = ConversationListView;
exports.OfficeItemView = OfficeItemView;
exports.UserChatItemView = UserChatItemView;

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(459);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 等级配置页面
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var Gender = function (_Component) {
    _inherits(Gender, _Component);

    function Gender(props) {
        _classCallCheck(this, Gender);

        var _this = _possibleConstructorReturn(this, (Gender.__proto__ || Object.getPrototypeOf(Gender)).call(this, props));

        _this.state = {
            value: props.value
        };
        return _this;
    }

    _createClass(Gender, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                value: nextProps.value
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement('i', { className: 'ui-gender', 'data-gender': this.state.value });
        }
    }]);

    return Gender;
}(_react.Component);

Gender.defaultProps = {
    value: 0
};
exports.default = Gender;

/***/ }),
/* 459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(462);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 等级配置页面
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var VIP = function (_Component) {
    _inherits(VIP, _Component);

    function VIP(props) {
        _classCallCheck(this, VIP);

        var _this = _possibleConstructorReturn(this, (VIP.__proto__ || Object.getPrototypeOf(VIP)).call(this, props));

        _this.state = {
            value: props.value
        };
        return _this;
    }

    _createClass(VIP, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                value: nextProps.value
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement('i', { className: 'ui-vip', 'data-vip': this.state.value });
        }
    }]);

    return VIP;
}(_react.Component);

VIP.defaultProps = {
    value: 0
};
exports.default = VIP;

/***/ }),
/* 462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(464);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 官方认证配置页面
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var OfficialAuth = function (_Component) {
    _inherits(OfficialAuth, _Component);

    function OfficialAuth(props) {
        _classCallCheck(this, OfficialAuth);

        var _this = _possibleConstructorReturn(this, (OfficialAuth.__proto__ || Object.getPrototypeOf(OfficialAuth)).call(this, props));

        _this.state = {
            value: props.value
        };
        return _this;
    }

    _createClass(OfficialAuth, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                value: nextProps.value
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement('i', { className: 'ui-auth', 'data-auth': this.state.value });
        }
    }]);

    return OfficialAuth;
}(_react.Component);

OfficialAuth.defaultProps = {
    value: 0
};
exports.default = OfficialAuth;

/***/ }),
/* 464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _userUi = __webpack_require__(22);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 好友列表
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var FriendListView = function (_Component) {
	_inherits(FriendListView, _Component);

	function FriendListView() {
		_classCallCheck(this, FriendListView);

		return _possibleConstructorReturn(this, (FriendListView.__proto__ || Object.getPrototypeOf(FriendListView)).apply(this, arguments));
	}

	_createClass(FriendListView, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				'div',
				{ className: 'friend-list hostlist-lite' },
				_react2.default.createElement(
					'ul',
					null,
					this.props.list.map(function (item, index) {
						return _react2.default.createElement(
							'li',
							{ key: index },
							_react2.default.createElement(FriendItemView, { data: item, talkTo: _this2.props.talkTo })
						);
					})
				),
				this.props.list.length == 0 ? _react2.default.createElement(
					'div',
					{ className: 'mini-tip' },
					_lang2.default.template('互相关注即可成为好友哦~')
				) : null
			);
		}
	}]);

	return FriendListView;
}(_react.Component);

FriendListView.defaultProps = {
	list: [],
	talkTo: function talkTo() {}
};

var FriendItemView = function (_Component2) {
	_inherits(FriendItemView, _Component2);

	function FriendItemView() {
		_classCallCheck(this, FriendItemView);

		return _possibleConstructorReturn(this, (FriendItemView.__proto__ || Object.getPrototypeOf(FriendItemView)).apply(this, arguments));
	}

	_createClass(FriendItemView, [{
		key: 'render',
		value: function render() {
			var item = this.props.data;

			return _react2.default.createElement(
				'div',
				{ className: 'list-item', onClick: this.props.talkTo.bind(this, item) },
				_react2.default.createElement(
					'div',
					{ className: 'avatar' },
					_react2.default.createElement(_userUi.ImageView, { src: item.avatar, size: 40, circle: true }),
					item.officialAuth > 0 ? _react2.default.createElement(_userUi.OfficialAuth, { value: item.officialAuth }) : null
				),
				_react2.default.createElement(
					'div',
					{ className: 'refbox' },
					_react2.default.createElement(
						'div',
						{ className: 'user' },
						_react2.default.createElement(
							'div',
							{ className: 'username' },
							item.username
						),
						_react2.default.createElement(_userUi.Gender, { key: 'gender', value: item.gender }),
						_react2.default.createElement(_userUi.Grade, { key: 'grade', value: item.grade })
					)
				)
			);
		}
	}]);

	return FriendItemView;
}(_react.Component);

FriendItemView.defaultProps = {
	data: {},
	talkTo: function talkTo() {}
};
exports.default = FriendListView;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _userUi = __webpack_require__(22);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 好友申请列表
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var FriendApplyListView = function (_Component) {
	_inherits(FriendApplyListView, _Component);

	function FriendApplyListView() {
		_classCallCheck(this, FriendApplyListView);

		return _possibleConstructorReturn(this, (FriendApplyListView.__proto__ || Object.getPrototypeOf(FriendApplyListView)).apply(this, arguments));
	}

	_createClass(FriendApplyListView, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				'div',
				{ className: 'apply-list hostlist-lite' },
				_react2.default.createElement(
					'ul',
					null,
					this.props.list.map(function (item, index) {
						return _react2.default.createElement(
							'li',
							{ key: index },
							_react2.default.createElement(FriendApplyItemView, { data: item, onFollowFriend: _this2.props.onFollowFriend })
						);
					})
				),
				this.props.list.length == 0 ? _react2.default.createElement(
					'div',
					{ className: 'mini-tip' },
					_lang2.default.template('暂无好友申请')
				) : null
			);
		}
	}]);

	return FriendApplyListView;
}(_react.Component);

FriendApplyListView.defaultProps = {
	list: [],
	onFollowFriend: function onFollowFriend() {}
};

var FriendApplyItemView = function (_Component2) {
	_inherits(FriendApplyItemView, _Component2);

	function FriendApplyItemView() {
		_classCallCheck(this, FriendApplyItemView);

		return _possibleConstructorReturn(this, (FriendApplyItemView.__proto__ || Object.getPrototypeOf(FriendApplyItemView)).apply(this, arguments));
	}

	_createClass(FriendApplyItemView, [{
		key: 'render',
		value: function render() {
			var data = this.props.data;
			var userInfo = data.userInfo;

			return _react2.default.createElement(
				'div',
				{ className: 'list-item', 'data-uid': data.sid },
				_react2.default.createElement(
					'div',
					{ className: 'avatar' },
					_react2.default.createElement(_userUi.ImageView, { src: userInfo.avatar, size: 40, circle: true }),
					userInfo.officialAuth > 0 ? _react2.default.createElement(_userUi.OfficialAuth, { value: userInfo.officialAuth }) : null
				),
				_react2.default.createElement(
					'div',
					{ className: 'refbox' },
					_react2.default.createElement(
						'div',
						{ className: 'user' },
						_react2.default.createElement(
							'div',
							{ className: 'username' },
							userInfo.username
						),
						_react2.default.createElement(_userUi.Gender, { key: 'gender', value: userInfo.gender }),
						_react2.default.createElement(_userUi.Grade, { key: 'grade', value: userInfo.grade })
					),
					_react2.default.createElement(
						'div',
						{ className: 'info' },
						data.verifyMsg
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'extra' },
					data.unhandled ? _react2.default.createElement(
						'span',
						{ className: 'adding', onClick: this.props.onFollowFriend.bind(this, data.sid) },
						_lang2.default.template('添加')
					) : _react2.default.createElement(
						'span',
						{ className: 'added' },
						_lang2.default.template('已添加')
					)
				)
			);
		}
	}]);

	return FriendApplyItemView;
}(_react.Component);

FriendApplyItemView.defaultProps = {
	data: {},
	onFollowFriend: function onFollowFriend() {}
};
exports.default = FriendApplyListView;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

var _ScaleModal = __webpack_require__(12);

var _ScaleModal2 = _interopRequireDefault(_ScaleModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 登出弹出层
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var noop = function noop() {};

var style = {
    modalStyle: {
        position: 'absolute',
        width: '320px'
    },
    contentStyle: {
        width: '320px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        position: 'absolute',
        backgroundColor: "rgba(0,0,0, 0.5)"
    }
};

var OverlayPop = function (_Component) {
    _inherits(OverlayPop, _Component);

    function OverlayPop(props) {
        _classCallCheck(this, OverlayPop);

        var _this = _possibleConstructorReturn(this, (OverlayPop.__proto__ || Object.getPrototypeOf(OverlayPop)).call(this, props));

        _this.onChange = function (e) {
            _this.setState({
                applycontent: $(e.currentTarget).val()
            });
        };

        _this.status = 'cancel';

        _this.state = {
            placeholder: _index2.default.template('我是<%=name%>', { name: props.myusername }),
            applycontent: ''
        };
        return _this;
    }

    _createClass(OverlayPop, [{
        key: 'onConfirm',
        value: function onConfirm() {
            this.hideModal();
            this.status = 'confirm';
        }
    }, {
        key: 'onCancel',
        value: function onCancel() {
            this.hideModal();
            this.status = 'cancel';
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            if (this.status == 'confirm') {
                this.props.onConfirm(this.state.applycontent || this.state.placeholder);
            } else {
                this.props.onCancel();
            }

            this.props.onHide();
        }
    }, {
        key: 'onShow',
        value: function onShow() {
            if (this.refs.applycontent) {
                this.refs.applycontent.focus();
            }
        }
    }, {
        key: 'showModal',
        value: function showModal() {
            this.refs.modal.show();
        }
    }, {
        key: 'hideModal',
        value: function hideModal() {
            this.refs.modal.hide();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var modalStyle = style.modalStyle;
            var backdropStyle = style.backdropStyle;
            var contentStyle = style.contentStyle;

            if (this.props.modalStyle) {
                for (var _style in this.props.modalStyle) {
                    modalStyle[_style] = this.props.modalStyle[_style];
                }
            }

            if (this.props.backdropStyle) {
                for (var _style2 in this.props.backdropStyle) {
                    backdropStyle[_style2] = this.props.backdropStyle[_style2];
                }
            }

            if (this.props.contentStyle) {
                for (var _style3 in this.props.contentStyle) {
                    contentStyle[_style3] = this.props.contentStyle[_style3];
                }
            }

            return _react2.default.createElement(
                _ScaleModal2.default,
                {
                    ref: 'modal',
                    closeOnClick: this.props.closeOnClick,
                    modalStyle: modalStyle,
                    backdropStyle: backdropStyle,
                    contentStyle: contentStyle,
                    onShow: this.onShow.bind(this),
                    onHide: this.onHide.bind(this)
                },
                _react2.default.createElement(
                    'div',
                    { className: 'overlay-pop' },
                    _react2.default.createElement(
                        'div',
                        { className: 'overlay-pop-bd' },
                        _react2.default.createElement('div', { className: 'apply-confirm-hd', dangerouslySetInnerHTML: { __html: _index2.default.template('您正在向<%=name%>发送好友申请', { name: this.props.friendusername }, 1) } }),
                        _react2.default.createElement(
                            'div',
                            { className: 'apply-confirm-bd' },
                            _react2.default.createElement(
                                'div',
                                { className: 'input-wrap' },
                                _react2.default.createElement('input', {
                                    type: 'text',
                                    ref: 'applycontent',
                                    maxLength: '20',
                                    value: this.state.applycontent,
                                    placeholder: this.state.placeholder,
                                    onChange: this.onChange
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-tip' },
                                _index2.default.template('请输入20个字以内')
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'overlay-pop-ft' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn cancel', onClick: function onClick() {
                                    return _this2.onCancel();
                                } },
                            _index2.default.template('取消')
                        ),
                        _react2.default.createElement(
                            'button',
                            { className: 'btn confirm', onClick: function onClick() {
                                    return _this2.onConfirm();
                                } },
                            _index2.default.template('确认')
                        )
                    )
                )
            );
        }
    }]);

    return OverlayPop;
}(_react.Component);

OverlayPop.defaultProps = {
    onHide: noop,
    onConfirm: noop,
    onCancel: noop,
    title: '',
    content: '',
    type: 'confirm',
    closeOnClick: true
};
exports.default = OverlayPop;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

var _ScaleModal = __webpack_require__(12);

var _ScaleModal2 = _interopRequireDefault(_ScaleModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 登出弹出层
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var noop = function noop() {};

var style = {
    modalStyle: {
        position: 'absolute',
        width: '320px'
    },
    contentStyle: {
        width: '320px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        position: 'absolute',
        backgroundColor: "rgba(0,0,0, 0.5)"
    }
};

var OverlayPop = function (_Component) {
    _inherits(OverlayPop, _Component);

    function OverlayPop(props) {
        _classCallCheck(this, OverlayPop);

        var _this = _possibleConstructorReturn(this, (OverlayPop.__proto__ || Object.getPrototypeOf(OverlayPop)).call(this, props));

        _this.status = 'cancel';
        return _this;
    }

    _createClass(OverlayPop, [{
        key: 'onConfirm',
        value: function onConfirm() {
            this.hideModal();
            this.status = 'confirm';
        }
    }, {
        key: 'onCancel',
        value: function onCancel() {
            this.hideModal();
            this.status = 'cancel';
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            if (this.status == 'confirm') {
                this.props.onConfirm();
            } else {
                this.props.onCancel();
            }

            this.props.onHide();
        }
    }, {
        key: 'showModal',
        value: function showModal() {
            this.refs.modal.show();
        }
    }, {
        key: 'hideModal',
        value: function hideModal() {
            this.refs.modal.hide();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var modalStyle = style.modalStyle;
            var backdropStyle = style.backdropStyle;
            var contentStyle = style.contentStyle;

            if (this.props.modalStyle) {
                for (var _style in this.props.modalStyle) {
                    modalStyle[_style] = this.props.modalStyle[_style];
                }
            }

            if (this.props.backdropStyle) {
                for (var _style2 in this.props.backdropStyle) {
                    backdropStyle[_style2] = this.props.backdropStyle[_style2];
                }
            }

            if (this.props.contentStyle) {
                for (var _style3 in this.props.contentStyle) {
                    contentStyle[_style3] = this.props.contentStyle[_style3];
                }
            }

            return _react2.default.createElement(
                _ScaleModal2.default,
                {
                    ref: 'modal',
                    closeOnClick: this.props.closeOnClick,
                    modalStyle: modalStyle,
                    backdropStyle: backdropStyle,
                    contentStyle: contentStyle,
                    onHide: this.onHide.bind(this)
                },
                _react2.default.createElement(
                    'div',
                    { className: 'overlay-pop' },
                    _react2.default.createElement(
                        'div',
                        { className: 'overlay-pop-bd' },
                        _react2.default.createElement(
                            'div',
                            { className: 'overlay-pop-hd' },
                            _index2.default.template('提示')
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'apply-confirm-bd' },
                            _index2.default.template('您的账号在其他终端登录成功')
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'overlay-pop-ft' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn cancel', onClick: function onClick() {
                                    return _this2.onCancel();
                                } },
                            _index2.default.template('知道了')
                        ),
                        _react2.default.createElement(
                            'button',
                            { className: 'btn confirm', onClick: function onClick() {
                                    return _this2.onConfirm();
                                } },
                            _index2.default.template('重新登录')
                        )
                    )
                )
            );
        }
    }]);

    return OverlayPop;
}(_react.Component);

OverlayPop.defaultProps = {
    onHide: noop,
    onConfirm: noop,
    onCancel: noop,
    type: 'confirm',
    closeOnClick: true
};
exports.default = OverlayPop;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _previewPic = __webpack_require__(470);

var _previewPic2 = _interopRequireDefault(_previewPic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChatMsgListView = function (_Component) {
    _inherits(ChatMsgListView, _Component);

    function ChatMsgListView(props) {
        _classCallCheck(this, ChatMsgListView);

        var _this = _possibleConstructorReturn(this, (ChatMsgListView.__proto__ || Object.getPrototypeOf(ChatMsgListView)).call(this, props));

        _this.state = {
            list: props.list
        };
        _this.size = props.list.length;
        return _this;
    }

    _createClass(ChatMsgListView, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                list: nextProps.list
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.wrap = this.refs.wrap;

            this.scrollToBottom();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var newSize = this.state.list.length;
            var needToScrollToBottom = newSize !== this.size;

            needToScrollToBottom && this.scrollToBottom();

            this.size = newSize;
        }
    }, {
        key: 'scrollToBottom',
        value: function scrollToBottom() {
            var _height = this.wrap.scrollHeight - $(this.wrap).height();

            this.wrap.scrollTop = _height;
        }
    }, {
        key: 'resendMessage',
        value: function resendMessage(data) {
            this.props.resendMessage(data);
        }
    }, {
        key: 'previewPic',
        value: function previewPic(url) {
            _previewPic2.default.create({
                src: url
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'scroller', ref: 'wrap' },
                _react2.default.createElement(
                    'ul',
                    { className: 'chat-list' },
                    this.state.list.map(function (item, inx) {
                        var me = item.isSelf ? 'me' : 'friend';
                        var node = void 0;
                        var $loading = void 0;

                        if (item.isSelf) {
                            if (item.submiting == 1) {
                                $loading = _react2.default.createElement(
                                    'div',
                                    { className: 'loading' },
                                    _react2.default.createElement('i', null)
                                );
                            } else if (item.submiting == -1) {
                                $loading = _react2.default.createElement(
                                    'div',
                                    { className: 'resend', onClick: _this2.resendMessage.bind(_this2, item) },
                                    _react2.default.createElement('i', null)
                                );
                            }
                        }

                        switch (item.msgType) {
                            case 'friendText':
                                return _react2.default.createElement(
                                    'li',
                                    { className: me, key: inx, 'data-uid': item.oid },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'message' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'avatar' },
                                            _react2.default.createElement('img', { src: item.avatar })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'content' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'content-box' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'text' },
                                                    item.content
                                                ),
                                                $loading
                                            )
                                        )
                                    )
                                );
                                break;
                            case 'friendPic':
                                return _react2.default.createElement(
                                    'li',
                                    { className: me, key: inx, 'data-uid': item.oid },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'message' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'avatar' },
                                            _react2.default.createElement('img', { src: item.avatar })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'content' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'content-box' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'pic' },
                                                    _react2.default.createElement('img', { src: item.origUrl, onLoad: function onLoad() {
                                                            return _this2.scrollToBottom();
                                                        }, onClick: _this2.previewPic.bind(_this2, item.origUrl) })
                                                )
                                            )
                                        )
                                    )
                                );
                                break;
                        }
                    })
                )
            );
        }
    }]);

    return ChatMsgListView;
}(_react.Component);

ChatMsgListView.defaultProps = {
    list: [],
    resendMessage: function resendMessage() {}
};
exports.default = ChatMsgListView;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

var _ScaleModal = __webpack_require__(12);

var _ScaleModal2 = _interopRequireDefault(_ScaleModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 头像弹出层
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var noop = function noop() {};

var style = {
    modalStyle: {
        width: '350px',
        zIndex: 1080
    },
    contentStyle: {
        width: '350px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        backgroundColor: "rgba(0,0,0, 0.7)",
        zIndex: 1070
    },
    picStyle: {
        width: '100%',
        borderRadius: '6px',
        height: 'auto'
    }
};

var OverlayPop = function (_Component) {
    _inherits(OverlayPop, _Component);

    function OverlayPop(props) {
        _classCallCheck(this, OverlayPop);

        return _possibleConstructorReturn(this, (OverlayPop.__proto__ || Object.getPrototypeOf(OverlayPop)).call(this, props));
    }

    _createClass(OverlayPop, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.showModal();
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            this.props.onHide();
        }
    }, {
        key: 'showModal',
        value: function showModal() {
            this.refs.modal.show();
        }
    }, {
        key: 'hideModal',
        value: function hideModal() {
            this.refs.modal.hide();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var modalStyle = style.modalStyle;
            var backdropStyle = style.backdropStyle;
            var contentStyle = style.contentStyle;

            if (this.props.modalStyle) {
                for (var _style in this.props.modalStyle) {
                    modalStyle[_style] = this.props.modalStyle[_style];
                }
            }

            if (this.props.backdropStyle) {
                for (var _style2 in this.props.backdropStyle) {
                    backdropStyle[_style2] = this.props.backdropStyle[_style2];
                }
            }

            if (this.props.contentStyle) {
                for (var _style3 in this.props.contentStyle) {
                    contentStyle[_style3] = this.props.contentStyle[_style3];
                }
            }

            return _react2.default.createElement(
                _ScaleModal2.default,
                {
                    ref: 'modal',
                    closeOnClick: this.props.closeOnClick,
                    modalStyle: modalStyle,
                    backdropStyle: backdropStyle,
                    contentStyle: contentStyle,
                    onHide: this.onHide.bind(this),
                    className: 'J_PreviewPic'
                },
                _react2.default.createElement(
                    'div',
                    { className: 'overlay-pic-pop' },
                    _react2.default.createElement(
                        'div',
                        { className: 'close', onClick: function onClick() {
                                return _this2.hideModal();
                            } },
                        'x'
                    ),
                    _react2.default.createElement('img', { src: this.props.src, style: style.picStyle })
                )
            );
        }
    }]);

    return OverlayPop;
}(_react.Component);

OverlayPop.defaultProps = {
    onHide: noop,
    src: '',
    closeOnClick: true
};


module.exports = {
    create: function create(cfg) {
        cfg = cfg || {};

        if (this.layer) {
            this.destroy();
        }
        var mountNode = this.createMountNode();

        this.layer = _reactDom2.default.render(_react2.default.createElement(OverlayPop, _extends({}, cfg, { onHide: this.onHide.bind(this) })), mountNode);
    },
    onHide: function onHide() {
        this.destroy();
    },
    // 创建组件插入的DOM节点
    createMountNode: function createMountNode() {
        this.mountNode = document.createElement("div");
        $(document.body).append(this.mountNode);
        return this.mountNode;
    },
    destroy: function destroy() {
        _reactDom2.default.unmountComponentAtNode(this.mountNode);
        $(this.mountNode).remove();
        delete this.layer;
    }
};

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _cNotification = __webpack_require__(11);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _ScaleModal = __webpack_require__(12);

var _ScaleModal2 = _interopRequireDefault(_ScaleModal);

var _cUpLoading = __webpack_require__(13);

var _cUpLoading2 = _interopRequireDefault(_cUpLoading);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _sensitiveWords = __webpack_require__(75);

var _sensitiveWords2 = _interopRequireDefault(_sensitiveWords);

var _countryView = __webpack_require__(87);

var _countryView2 = _interopRequireDefault(_countryView);

var _set = __webpack_require__(268);

var _set2 = _interopRequireDefault(_set);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 绑定手机
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var cache = new _cCache2.default({
    prefix: 'pcuplive'
});

var noop = function noop() {};

var style = {
    modalStyle: {
        width: '400px',
        zIndex: 1070
    },
    contentStyle: {
        width: '400px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        backgroundColor: "rgba(0,0,0, 0.5)",
        zIndex: 1060
    }
};

var SelectCountry = function (_Component) {
    _inherits(SelectCountry, _Component);

    function SelectCountry(props) {
        _classCallCheck(this, SelectCountry);

        var _this = _possibleConstructorReturn(this, (SelectCountry.__proto__ || Object.getPrototypeOf(SelectCountry)).call(this, props));

        _this.handleSubmit = function (e) {
            if (_this.isFetching) {
                return;
            }

            var username = _this.refs.username.value.trim();
            var gender = parseInt(_this.refs.gender.value, 10);

            if (username == '') {
                _cNotification2.default.simple(_lang2.default.template('输入内容不能为空'));
                return;
            } else if (!_sensitiveWords2.default.check(username)) {
                _cNotification2.default.simple(_lang2.default.template('昵称不能出现敏感词'));
                return;
            }

            if (!_this.state.code) {
                _cNotification2.default.simple(_lang2.default.template('选择国家或地区'));
                _this.setState({
                    showSelect: true
                });
                return;
            }

            _this.isFetching = 1;

            _this.setProfile(_this.state.code, username, gender);
        };

        _this.handleSelectCountry = function () {
            if (_this.state.showSelect) {
                return;
            }

            _this.setState({
                showSelect: true
            });
        };

        _this.moveCaretAtEnd = function (e) {
            var temp_value = e.target.value;
            e.target.value = '';
            e.target.value = temp_value;
        };

        _this.state = {
            showSelect: false,
            username: props.username,
            gender: props.gender || 1
        };
        return _this;
    }

    _createClass(SelectCountry, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.showModal();

            this.bindEvent();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            $(document.body).off('click');
        }
    }, {
        key: 'setProfile',
        value: function setProfile(code, username, gender) {
            var _this2 = this;

            _cUpLoading2.default.show();

            var profileset = new _set2.default({
                countryCode: code,
                username: username,
                gender: gender
            });

            profileset.promise.then(function (data) {
                _cUpLoading2.default.hide();
                _this2.isFetching = 0;
                _this2.hideModal();
                _this2.status = 'complete';
                _cNotification2.default.simple(_lang2.default.template('个人信息设定成功'));

                setTimeout(function () {
                    $.channel.emit('setCountrySucc');
                }, 1000);
            }, function () {
                _cUpLoading2.default.hide();
                _this2.isFetching = 0;
                _this2.onClose();
                _cNotification2.default.simple(_lang2.default.template('个人信息设定失败'));
            });
        }
    }, {
        key: 'bindEvent',
        value: function bindEvent() {
            var _this3 = this;

            var self = this;
            var el = $(this.refs.areaCode);

            el.on({
                mouseenter: function mouseenter(e) {
                    // self.setState({
                    //  showSelect: true
                    // });
                },
                mouseleave: function mouseleave(e) {
                    self.setState({
                        showSelect: false
                    });
                },
                click: function click(e) {
                    self.setState({
                        showSelect: true
                    });
                }
            });

            $(document.body).on('click', function (e) {
                var el = $(e.target);
                var showSelect = false;

                if ($('.country-list-wrap').find(el).length > 0 || $('.country-list-wrap').find(el).length > 0) {
                    showSelect = true;
                }
                _this3.setState({
                    showSelect: showSelect
                });
            });
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            // 在隐藏动画执行完成之后再触发事件onConfirm
            if (this.status == 'complete') {
                this.props.onComplete(this.state.code);
            }
            this.props.onHide();
        }
    }, {
        key: 'onClose',
        value: function onClose() {
            this.hideModal();
            this.status = 'cancel';
        }
    }, {
        key: 'showModal',
        value: function showModal() {
            this.refs.modal.show();
        }
    }, {
        key: 'hideModal',
        value: function hideModal() {
            this.refs.modal.hide();
        }
    }, {
        key: 'onSelectOption',
        value: function onSelectOption(data) {
            // console.log(data);
            var state = {};

            if (!data.code) {
                state = Object.assign({}, { showSelect: true }, data);
            } else {
                state = Object.assign({}, { showSelect: false }, data);
            }

            this.setState(state);
        }
    }, {
        key: 'onChange',
        value: function onChange(key, e) {
            var state = this.state;

            state[key] = e.target.value;

            this.setState(state);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var userInfo = UP.Global.getUser();
            var _state = this.state,
                username = _state.username,
                gender = _state.gender;


            return _react2.default.createElement(
                _ScaleModal2.default,
                {
                    ref: 'modal',
                    closeOnClick: false,
                    onHide: this.onHide.bind(this),
                    modalStyle: style.modalStyle,
                    backdropStyle: style.backdropStyle,
                    contentStyle: style.contentStyle
                },
                _react2.default.createElement(
                    'div',
                    { className: 'select-country-pop' },
                    _react2.default.createElement(
                        'div',
                        { className: 'box' },
                        _react2.default.createElement(
                            'div',
                            { className: 'pop-hd' },
                            _lang2.default.template('个人资料'),
                            _react2.default.createElement(
                                'span',
                                { className: 'close hidden', onClick: function onClick() {
                                        return _this4.onClose();
                                    } },
                                'x'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form' },
                            _react2.default.createElement(
                                'div',
                                { className: 'form-item nickname' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'input-label' },
                                    _lang2.default.template('昵称')
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'input-wrap' },
                                    _react2.default.createElement('input', { className: 'input',
                                        type: 'text',
                                        value: username,
                                        ref: 'username',
                                        maxLength: '24',
                                        onChange: function onChange(e) {
                                            return _this4.onChange('username', e);
                                        },
                                        placeholder: _lang2.default.template('请输入昵称'),
                                        onFocus: this.moveCaretAtEnd
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'form-item gender' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'input-label' },
                                    _lang2.default.template('性别')
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'input-wrap' },
                                    _react2.default.createElement(
                                        'select',
                                        { name: 'gender', ref: 'gender', defaultValue: gender || 1 },
                                        _react2.default.createElement(
                                            'option',
                                            { value: '1' },
                                            ' ',
                                            _lang2.default.template('男'),
                                            ' '
                                        ),
                                        _react2.default.createElement(
                                            'option',
                                            { value: '2' },
                                            ' ',
                                            _lang2.default.template('女'),
                                            ' '
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'form-item choosecountry', ref: 'areaCode', onClick: this.handleSelectCountry },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'input-label' },
                                    _lang2.default.template('国家/地区')
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'input-wrap arrow' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input' },
                                        this.state.inputValue,
                                        '\u200E'
                                    )
                                ),
                                _react2.default.createElement(_countryView2.default, { visible: this.state.showSelect, selectOption: this.onSelectOption.bind(this), ref: 'countryView' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'btn', onClick: this.handleSubmit },
                                _lang2.default.template('确认')
                            )
                        )
                    )
                )
            );
        }
    }]);

    return SelectCountry;
}(_react.Component);

SelectCountry.defaultProps = {
    content: '',
    username: '',
    gender: '',
    onHide: noop,
    onComplete: noop
};


module.exports = {
    create: function create(cfg) {
        cfg = cfg || {};

        if (this.layer) {
            this.destroy();
        }
        var mountNode = this.createMountNode();

        this.layer = _reactDom2.default.render(_react2.default.createElement(SelectCountry, _extends({}, cfg, { onHide: this.onHide.bind(this) })), mountNode);
    },
    onHide: function onHide() {
        this.destroy();
    },
    // 创建组件插入的DOM节点
    createMountNode: function createMountNode() {
        this.mountNode = document.createElement("div");
        $(document.body).append(this.mountNode);
        return this.mountNode;
    },
    destroy: function destroy() {
        _reactDom2.default.unmountComponentAtNode(this.mountNode);
        $(this.mountNode).remove();
        delete this.layer;
    }
};

/***/ }),
/* 472 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Profile",
        "fields": [],
        "messages": [{
            "name": "Set",
            "fields": [],
            "options": {
                "objc_class_prefix": "ProfileSet",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "string",
                    "name": "username",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "setting",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "upliveCode",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "signature",
                    "id": 4
                }, {
                    "rule": "optional",
                    "type": "PushType",
                    "name": "pushType",
                    "id": 5
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "pushToken",
                    "id": 6
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "location",
                    "id": 7
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "gender",
                    "id": 8
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "language",
                    "id": 9
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "countryCode",
                    "id": 11
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "userRealNameAuthInfo",
                    "id": 12
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "acceptAgreement",
                    "id": 13
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "timeZone",
                    "id": 14
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "BindType",
        "values": [{
            "name": "DEFAULT_TYPE",
            "id": 0
        }, {
            "name": "MOBILE_PHONE",
            "id": 1
        }, {
            "name": "QQ",
            "id": 2
        }, {
            "name": "WEIXIN",
            "id": 3
        }, {
            "name": "FACEBOOK",
            "id": 4
        }, {
            "name": "SINA_WEIBO",
            "id": 5
        }, {
            "name": "GOOGLE",
            "id": 15
        }, {
            "name": "TWITTER",
            "id": 16
        }, {
            "name": "EMAIL",
            "id": 17
        }]
    }, {
        "name": "PushType",
        "values": [{
            "name": "DEFAULT_PUSHTYPE",
            "id": 0
        }, {
            "name": "IOS",
            "id": 2
        }, {
            "name": "XIAOMI",
            "id": 4
        }, {
            "name": "GETUI",
            "id": 5
        }, {
            "name": "GOOGLE_PUSH",
            "id": 6
        }, {
            "name": "GOOGLE_FCM",
            "id": 10
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 473 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Mall.GiftList",
    "options": {
        "objc_class_prefix": "MallGiftList",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Request",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "scene",
            "id": 1
        }]
    }, {
        "name": "Response",
        "fields": [{
            "rule": "repeated",
            "type": "GiftInfo",
            "name": "gifts",
            "id": 1
        }, {
            "rule": "repeated",
            "type": "AmountConfig",
            "name": "amountConfigs",
            "id": 2
        }]
    }, {
        "name": "GiftInfo",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "giftId",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "name",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "intro",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "type",
            "id": 4
        }, {
            "rule": "optional",
            "type": "string",
            "name": "url",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "price",
            "id": 6
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "experience",
            "id": 7
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "canCombo",
            "id": 8
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "version",
            "id": 9
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "onLined",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 11
        }, {
            "rule": "optional",
            "type": "string",
            "name": "language",
            "id": 12
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "needLoad",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "showType",
            "id": 14
        }, {
            "rule": "repeated",
            "type": "GiftResourceInfo",
            "name": "resources",
            "id": 15
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "vipGrade",
            "id": 16
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "playTimes",
            "id": 17
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "produceType",
            "id": 18
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "canSendToAllUsers",
            "id": 19
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "timeLimit",
            "id": 20
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "hostBill",
            "id": 21
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "guardLevel",
            "id": 22
        }]
    }, {
        "name": "GiftResourceInfo",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "type",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "url",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "md5",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "json",
            "id": 4
        }]
    }, {
        "name": "AmountConfig",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "amount",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "description",
            "id": 2
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 474 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Mall",
    "messages": [{
        "name": "GiftList",
        "fields": [],
        "options": {
            "objc_class_prefix": "MallGiftList",
            "java_package": "com.asiainno.uplive.proto"
        },
        "messages": [{
            "name": "Request",
            "fields": [{
                "rule": "optional",
                "type": "int32",
                "name": "scene",
                "id": 1
            }]
        }, {
            "name": "Response",
            "fields": [{
                "rule": "repeated",
                "type": "GiftInfo",
                "name": "gifts",
                "id": 1
            }, {
                "rule": "repeated",
                "type": "AmountConfig",
                "name": "amountConfigs",
                "id": 2
            }]
        }, {
            "name": "GiftInfo",
            "fields": [{
                "rule": "optional",
                "type": "int32",
                "name": "giftId",
                "id": 1
            }, {
                "rule": "optional",
                "type": "string",
                "name": "name",
                "id": 2
            }, {
                "rule": "optional",
                "type": "string",
                "name": "intro",
                "id": 3
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "type",
                "id": 4
            }, {
                "rule": "optional",
                "type": "string",
                "name": "url",
                "id": 5
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "price",
                "id": 6
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "experience",
                "id": 7
            }, {
                "rule": "optional",
                "type": "bool",
                "name": "canCombo",
                "id": 8
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "version",
                "id": 9
            }, {
                "rule": "optional",
                "type": "bool",
                "name": "onLined",
                "id": 10
            }, {
                "rule": "optional",
                "type": "string",
                "name": "countryCode",
                "id": 11
            }, {
                "rule": "optional",
                "type": "string",
                "name": "language",
                "id": 12
            }, {
                "rule": "optional",
                "type": "bool",
                "name": "needLoad",
                "id": 13
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "showType",
                "id": 14
            }, {
                "rule": "repeated",
                "type": "GiftResourceInfo",
                "name": "resources",
                "id": 15
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "vipGrade",
                "id": 16
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "playTimes",
                "id": 17
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "produceType",
                "id": 18
            }, {
                "rule": "optional",
                "type": "bool",
                "name": "canSendToAllUsers",
                "id": 19
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "timeLimit",
                "id": 20
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "hostBill",
                "id": 21
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "guardLevel",
                "id": 22
            }, {
                "rule": "repeated",
                "type": "int32",
                "name": "giftIds",
                "id": 23,
                "options": {
                    "packed": true
                }
            }, {
                "rule": "optional",
                "type": "int64",
                "name": "delayTime",
                "id": 24
            }]
        }, {
            "name": "GiftResourceInfo",
            "fields": [{
                "rule": "optional",
                "type": "int32",
                "name": "type",
                "id": 1
            }, {
                "rule": "optional",
                "type": "string",
                "name": "url",
                "id": 2
            }, {
                "rule": "optional",
                "type": "string",
                "name": "md5",
                "id": 3
            }, {
                "rule": "optional",
                "type": "string",
                "name": "json",
                "id": 4
            }]
        }, {
            "name": "AmountConfig",
            "fields": [{
                "rule": "optional",
                "type": "int32",
                "name": "amount",
                "id": 1
            }, {
                "rule": "optional",
                "type": "string",
                "name": "description",
                "id": 2
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "effectLevel",
                "id": 3
            }]
        }]
    }, {
        "name": "GiftLabelList",
        "fields": [],
        "options": {
            "objc_class_prefix": "MallGiftLabelList",
            "java_package": "com.asiainno.uplive.proto"
        },
        "messages": [{
            "name": "Request",
            "fields": [{
                "rule": "optional",
                "type": "int32",
                "name": "scene",
                "id": 1
            }]
        }, {
            "name": "Response",
            "fields": [{
                "rule": "repeated",
                "type": "GiftLabel",
                "name": "labels",
                "id": 1
            }, {
                "rule": "repeated",
                "type": "GiftList.AmountConfig",
                "name": "amountConfigs",
                "id": 2
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "giftNameSwitch",
                "id": 3
            }, {
                "rule": "repeated",
                "type": "GiftList.GiftInfo",
                "name": "offlineGifts",
                "id": 4
            }]
        }, {
            "name": "GiftLabel",
            "fields": [{
                "rule": "optional",
                "type": "int32",
                "name": "labelId",
                "id": 1
            }, {
                "rule": "optional",
                "type": "string",
                "name": "name",
                "id": 2
            }, {
                "rule": "optional",
                "type": "string",
                "name": "url",
                "id": 3
            }, {
                "rule": "repeated",
                "type": "GiftList.GiftInfo",
                "name": "gifts",
                "id": 4
            }]
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 475 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "PackGrid",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "gridId",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "giftId",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "valuable",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "lastIncreaseTime",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "expireTime",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "amount",
            "id": 6
        }]
    }, {
        "name": "PackPropGrid",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "gridId",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "propId",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "valuable",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "lastIncreaseTime",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "expireTime",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "amount",
            "id": 6
        }]
    }, {
        "name": "MallPropInfo",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "id",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "goodsId",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "type",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "giftId",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "useType",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "amount",
            "id": 6
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "timeLimit",
            "id": 7
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "propTimeLimit",
            "id": 8
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "createTime",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "updateTime",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "name",
            "id": 11
        }, {
            "rule": "optional",
            "type": "string",
            "name": "intro",
            "id": 12
        }, {
            "rule": "repeated",
            "type": "MallPropResourceUrl",
            "name": "resources",
            "id": 13
        }]
    }, {
        "name": "MallPropResourceUrl",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "type",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "url",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "md5",
            "id": 3
        }]
    }, {
        "name": "Mall",
        "fields": [],
        "messages": [{
            "name": "GiftList",
            "fields": [],
            "options": {
                "objc_class_prefix": "MallGiftList",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "int32",
                    "name": "scene",
                    "id": 1
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "repeated",
                    "type": "GiftInfo",
                    "name": "gifts",
                    "id": 1
                }, {
                    "rule": "repeated",
                    "type": "AmountConfig",
                    "name": "amountConfigs",
                    "id": 2
                }]
            }, {
                "name": "GiftInfo",
                "fields": [{
                    "rule": "optional",
                    "type": "int32",
                    "name": "giftId",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "name",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "intro",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "type",
                    "id": 4
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "url",
                    "id": 5
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "price",
                    "id": 6
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "experience",
                    "id": 7
                }, {
                    "rule": "optional",
                    "type": "bool",
                    "name": "canCombo",
                    "id": 8
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "version",
                    "id": 9
                }, {
                    "rule": "optional",
                    "type": "bool",
                    "name": "onLined",
                    "id": 10
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "countryCode",
                    "id": 11
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "language",
                    "id": 12
                }, {
                    "rule": "optional",
                    "type": "bool",
                    "name": "needLoad",
                    "id": 13
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "showType",
                    "id": 14
                }, {
                    "rule": "repeated",
                    "type": "GiftResourceInfo",
                    "name": "resources",
                    "id": 15
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "vipGrade",
                    "id": 16
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "playTimes",
                    "id": 17
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "produceType",
                    "id": 18
                }, {
                    "rule": "optional",
                    "type": "bool",
                    "name": "canSendToAllUsers",
                    "id": 19
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "timeLimit",
                    "id": 20
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "hostBill",
                    "id": 21
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "guardLevel",
                    "id": 22
                }, {
                    "rule": "repeated",
                    "type": "int32",
                    "name": "giftIds",
                    "id": 23,
                    "options": {
                        "packed": true
                    }
                }, {
                    "rule": "optional",
                    "type": "int64",
                    "name": "delayTime",
                    "id": 24
                }]
            }, {
                "name": "GiftResourceInfo",
                "fields": [{
                    "rule": "optional",
                    "type": "int32",
                    "name": "type",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "url",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "md5",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "json",
                    "id": 4
                }]
            }, {
                "name": "AmountConfig",
                "fields": [{
                    "rule": "optional",
                    "type": "int32",
                    "name": "amount",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "description",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "effectLevel",
                    "id": 3
                }]
            }]
        }]
    }, {
        "name": "Pack",
        "fields": [],
        "messages": [{
            "name": "InfoValid",
            "fields": [],
            "options": {
                "objc_class_prefix": "PackInfoValid",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "int32",
                    "name": "scene",
                    "id": 1
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "int32",
                    "name": "currentTime",
                    "id": 1
                }, {
                    "rule": "repeated",
                    "type": "PackGrid",
                    "name": "grids",
                    "id": 2
                }, {
                    "rule": "repeated",
                    "type": "Mall.GiftList.GiftInfo",
                    "name": "giftInfos",
                    "id": 3
                }, {
                    "rule": "repeated",
                    "type": "PackPropGrid",
                    "name": "propGrids",
                    "id": 4
                }, {
                    "rule": "repeated",
                    "type": "MallPropInfo",
                    "name": "propInfos",
                    "id": 5
                }]
            }]
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports = [{
    minLevel: 10,
    maxLevel: 24,
    name: '福特野马',
    pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/9a18f2d71eee393539080d3474c35f3f.png'
}, {
    minLevel: 25,
    maxLevel: 34,
    name: '宝马M3',
    pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/24272a53567e36e87ca53490b5620bd8.png'
}, {
    minLevel: 35,
    maxLevel: 49,
    name: '玛莎拉蒂GranTurismo',
    pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/c86e2e851c206c909cb8406668fe61bf.png'
}, {
    minLevel: 50,
    maxLevel: 59,
    name: '阿斯顿·马丁DB9',
    pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/ddb56fb73d0f3dcf49bbcbacd32a2e58.png'
}, {
    minLevel: 60,
    maxLevel: 69,
    name: '兰博基尼Huracan',
    pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/73d8cd4a3b06342788767c8d3ed3a581.png'
}, {
    minLevel: 70,
    maxLevel: 79,
    name: '宾利慕尚',
    pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/1bb0e4a756717315cbe495015184108e.png'
}, {
    minLevel: 80,
    maxLevel: 89,
    name: '劳斯莱斯幻影',
    pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/b0c84a5c817b8cb3cf5064fbcf9b7300.png'
}, {
    minLevel: 90,
    maxLevel: 99,
    name: '布加迪威航',
    pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/d265fc617c45186b0446388df26e29e8.png'
}, {
    minLevel: 100,
    maxLevel: 109,
    name: 'W Motors莱肯',
    pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/fa53fe57763bfa495c88f41e4aa72bb7.png'
}, {
    minLevel: 110,
    maxLevel: 119,
    name: '法拉帝960',
    pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/babfc5297e0e3cbc180d2ac1ff3951da.png'
}, {
    minLevel: 120,
    maxLevel: 129,
    name: '圣汐115 Sport Yacht',
    pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/0237f9532cb8cbfea9f380e89396a20a.png'
}, {
    minLevel: 130,
    maxLevel: 139,
    name: '圣劳伦佐SL118',
    pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/ec2e24250b8a973f0bc8e12049dc2c7b.png'
}, {
    minLevel: 140,
    maxLevel: 149,
    name: '圣劳伦佐SD126',
    pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/8b4d673a11b6df07aae447d652c76fba.png'
}, {
    minLevel: 150,
    maxLevel: 159,
    name: '圣汐131Yacht',
    pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/b929a6a2efc88ba031480e02c081a439.png'
}, {
    minLevel: 160,
    maxLevel: 169,
    name: '达索Falcon900',
    pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/53831d65a481303497109215119ce0ec.png'
}, {
    minLevel: 170,
    maxLevel: 179,
    name: '湾流G55',
    pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/6a71b0677d6d459b5897692f18e89b65.png'
}, {
    minLevel: 180,
    maxLevel: 189,
    name: '庞巴迪全球快车',
    pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/62e5afe301016ad34e437812f0a478e3.png'
}, {
    minLevel: 190,
    maxLevel: 199,
    name: '波音 787',
    pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/2bab11825adde6e58ad7cd0711a82898.png'
}, {
    minLevel: 200,
    maxLevel: 200,
    name: '空中客车 A380',
    pic: '//g.cdn.pengpengla.com/oauthgame/html5/20170217/dbe215e1947e65d36606eaa40388c37a.png'
}];

/***/ }),
/* 477 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Gifto.Mall",
    "options": {
        "objc_class_prefix": "GiftoMallCurrencyInfo",
        "java_package": "com.asiainno.uplive.proto.gift"
    },
    "messages": [{
        "name": "GiftoMallCurrencyInfo",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "giftoCurrencyCode",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "giftoCurrencyShowName",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "iconUrl",
            "id": 3
        }]
    }, {
        "name": "GiftList",
        "fields": [],
        "options": {
            "objc_class_prefix": "GiftoMallGiftList",
            "java_package": "com.asiainno.uplive.proto.gift"
        },
        "messages": [{
            "name": "Request",
            "fields": [{
                "rule": "optional",
                "type": "int32",
                "name": "scene",
                "id": 1
            }]
        }, {
            "name": "Response",
            "fields": [{
                "rule": "repeated",
                "type": "GiftInfo",
                "name": "gifts",
                "id": 1
            }, {
                "rule": "repeated",
                "type": "BatchSendConfig",
                "name": "batchSendConfigs",
                "id": 2
            }]
        }, {
            "name": "GiftInfo",
            "fields": [{
                "rule": "optional",
                "type": "int32",
                "name": "giftId",
                "id": 1
            }, {
                "rule": "optional",
                "type": "string",
                "name": "name",
                "id": 2
            }, {
                "rule": "optional",
                "type": "string",
                "name": "intro",
                "id": 3
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "type",
                "id": 4
            }, {
                "rule": "optional",
                "type": "string",
                "name": "url",
                "id": 5
            }, {
                "rule": "optional",
                "type": "string",
                "name": "price",
                "id": 6
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "experience",
                "id": 7
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "version",
                "id": 8
            }, {
                "rule": "optional",
                "type": "bool",
                "name": "onLined",
                "id": 9
            }, {
                "rule": "optional",
                "type": "string",
                "name": "countryCode",
                "id": 10
            }, {
                "rule": "optional",
                "type": "string",
                "name": "language",
                "id": 11
            }, {
                "rule": "optional",
                "type": "bool",
                "name": "needLoad",
                "id": 12
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "showType",
                "id": 13
            }, {
                "rule": "repeated",
                "type": "GiftResourceInfo",
                "name": "resources",
                "id": 14
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "vipGrade",
                "id": 15
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "playTimes",
                "id": 16
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "produceType",
                "id": 17
            }, {
                "rule": "optional",
                "type": "bool",
                "name": "canSendToAllUsers",
                "id": 18
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "timeLimit",
                "id": 19
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "hostBill",
                "id": 20
            }, {
                "rule": "optional",
                "type": "GiftoMallCurrencyInfo",
                "name": "currencyInfo",
                "id": 21
            }]
        }, {
            "name": "GiftResourceInfo",
            "fields": [{
                "rule": "optional",
                "type": "int32",
                "name": "type",
                "id": 1
            }, {
                "rule": "optional",
                "type": "string",
                "name": "url",
                "id": 2
            }, {
                "rule": "optional",
                "type": "string",
                "name": "md5",
                "id": 3
            }, {
                "rule": "optional",
                "type": "string",
                "name": "json",
                "id": 4
            }]
        }, {
            "name": "BatchSendConfig",
            "fields": [{
                "rule": "optional",
                "type": "int32",
                "name": "number",
                "id": 1
            }, {
                "rule": "optional",
                "type": "string",
                "name": "description",
                "id": 2
            }, {
                "rule": "optional",
                "type": "int32",
                "name": "effectLevel",
                "id": 3
            }]
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./": [
		1
	],
	"./areg": [
		270,
		16
	],
	"./areg.js": [
		270,
		16
	],
	"./enus": [
		107
	],
	"./enus.js": [
		107
	],
	"./eses": [
		271,
		15
	],
	"./eses.js": [
		271,
		15
	],
	"./frfr": [
		272,
		14
	],
	"./frfr.js": [
		272,
		14
	],
	"./idid": [
		273,
		13
	],
	"./idid.js": [
		273,
		13
	],
	"./index": [
		1
	],
	"./index.js": [
		1
	],
	"./jajp": [
		274,
		12
	],
	"./jajp.js": [
		274,
		12
	],
	"./keys": [
		675,
		29
	],
	"./kokr": [
		275,
		11
	],
	"./kokr.js": [
		275,
		11
	],
	"./msmy": [
		276,
		10
	],
	"./msmy.js": [
		276,
		10
	],
	"./pack": [
		277,
		9
	],
	"./pack.js": [
		277,
		9
	],
	"./ptpt": [
		278,
		8
	],
	"./ptpt.js": [
		278,
		8
	],
	"./ruru": [
		279,
		7
	],
	"./ruru.js": [
		279,
		7
	],
	"./thth": [
		280,
		6
	],
	"./thth.js": [
		280,
		6
	],
	"./trtr": [
		281,
		5
	],
	"./trtr.js": [
		281,
		5
	],
	"./vivn": [
		282,
		4
	],
	"./vivn.js": [
		282,
		4
	],
	"./zhcn": [
		283,
		3
	],
	"./zhcn.js": [
		283,
		3
	],
	"./zhhk": [
		284,
		2
	],
	"./zhhk.js": [
		284,
		2
	],
	"./zhtw": [
		285,
		1
	],
	"./zhtw.js": [
		285,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 478;
module.exports = webpackAsyncContext;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _reactRouter = __webpack_require__(23);

var _about = __webpack_require__(480);

var _about2 = _interopRequireDefault(_about);

var _news = __webpack_require__(657);

var _news2 = _interopRequireDefault(_news);

var _index = __webpack_require__(260);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cache = new _cCache2.default({
    prefix: 'pcuplive'
});
// import Home from './views/home';
// import Living from './views/living';
// import Ranking from './views/ranking';
// import Recharge  from './views/recharge';
// import Withdraw from './views/withdraw';
// import Profile from './views/profile';
// import AllHostList from './views/allhostlist';


function onEnter(nextState, replace) {
    var pathname = nextState.location.pathname;
    var paidfrom = _cUrl2.default.query('paidfrom');

    if (pathname == '/') {
        if (paidfrom) {
            return;
        } else {
            replace('/home');
        }
    }
}

function onEnterPage(nextState, replace) {
    return;

    var url = nextState.location.pathname;
    var videoInfo = UP.Global.videoInfo;

    if (url.indexOf('living') > -1) {
        _index2.default.destroy();
    } else {
        if (videoInfo && videoInfo.success == 1 && !UP.Global.isEdge) {
            // 主播正在开播
            _index2.default.create({
                data: videoInfo
            });
        }
    }
}

// 首页
var Home = function Home(location, cb) {
    __webpack_require__.e/* require.ensure */(17).then((function (require) {
        cb(null, __webpack_require__(676).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var AllHostList = function AllHostList(location, cb) {
    __webpack_require__.e/* require.ensure */(20).then((function (require) {
        cb(null, __webpack_require__(677).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Living = function Living(location, cb) {
    __webpack_require__.e/* require.ensure */(18).then((function (require) {
        cb(null, __webpack_require__(678).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Ranking = function Ranking(location, cb) {
    __webpack_require__.e/* require.ensure */(21).then((function (require) {
        cb(null, __webpack_require__(679).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Recharge = function Recharge(location, cb) {
    __webpack_require__.e/* require.ensure */(28).then((function (require) {
        cb(null, __webpack_require__(680).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Withdraw = function Withdraw(location, cb) {
    __webpack_require__.e/* require.ensure */(22).then((function (require) {
        cb(null, __webpack_require__(681).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Profile = function Profile(location, cb) {
    __webpack_require__.e/* require.ensure */(19).then((function (require) {
        cb(null, __webpack_require__(682).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Activity = function Activity(location, cb) {
    __webpack_require__.e/* require.ensure */(26).then((function (require) {
        cb(null, __webpack_require__(683).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var GameCenter = function GameCenter(location, cb) {
    __webpack_require__.e/* require.ensure */(25).then((function (require) {
        cb(null, __webpack_require__(684).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Play = function Play(location, cb) {
    __webpack_require__.e/* require.ensure */(23).then((function (require) {
        cb(null, __webpack_require__(685).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var History = function History(location, cb) {
    __webpack_require__.e/* require.ensure */(24).then((function (require) {
        cb(null, __webpack_require__(686).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Show = function Show(location, cb) {
    __webpack_require__.e/* require.ensure */(27).then((function (require) {
        cb(null, __webpack_require__(687).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var routes = _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', onEnter: onEnter },
    _react2.default.createElement(_reactRouter.Route, { path: 'home', getComponent: Home, onEnter: onEnterPage }),
    _react2.default.createElement(_reactRouter.Route, { path: 'allhostlist/(:type)(/:subtype)', getComponent: AllHostList, onEnter: onEnterPage }),
    _react2.default.createElement(_reactRouter.Route, { path: 'living/:hostid/:roomid(/:starId)', getComponent: Living, onEnter: onEnterPage }),
    _react2.default.createElement(_reactRouter.Route, { path: 'rank(/:mod)', getComponent: Ranking, onEnter: onEnterPage }),
    _react2.default.createElement(_reactRouter.Route, { path: 'recharge', getComponent: Recharge, onEnter: onEnterPage }),
    _react2.default.createElement(_reactRouter.Route, { path: 'news', component: _news2.default, onEnter: onEnterPage }),
    _react2.default.createElement(_reactRouter.Route, { path: 'about', component: _about2.default, onEnter: onEnterPage }),
    _react2.default.createElement(_reactRouter.Route, { path: 'show', getComponent: Show, onEnter: onEnterPage }),
    _react2.default.createElement(_reactRouter.Route, { path: 'activity', getComponent: Activity, onEnter: onEnterPage }),
    _react2.default.createElement(_reactRouter.Route, { path: 'gamecenter', getComponent: GameCenter, onEnter: onEnterPage }),
    _react2.default.createElement(_reactRouter.Route, { path: 'play', getComponent: Play, onEnter: onEnterPage }),
    _react2.default.createElement(_reactRouter.Route, { path: 'withdraw(/:tab)', getComponent: Withdraw, onEnter: onEnterPage }),
    _react2.default.createElement(_reactRouter.Route, { path: 'profile(/:tab)(/:uid)', getComponent: Profile, onEnter: onEnterPage }),
    _react2.default.createElement(_reactRouter.Route, { path: 'history', getComponent: History, onEnter: onEnterPage }),
    _react2.default.createElement(_reactRouter.Route, { path: '*', getComponent: Home, onEnter: onEnterPage })
);

exports.default = routes;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(154);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(155);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(1);

var _index6 = _interopRequireDefault(_index5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 首页
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var About = function (_Component) {
    _inherits(About, _Component);

    function About() {
        _classCallCheck(this, About);

        return _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).apply(this, arguments));
    }

    _createClass(About, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            document.title = _index6.default.template('页面标题');
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var node = this.refs.doc;

            $(node).css({
                minHeight: document.documentElement.clientHeight
            });
        }
    }, {
        key: 'onClick',
        value: function onClick(channel) {
            UP.Global.DA.add({
                eventName: 'Download',
                action: 'click',
                label: channel
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'about' },
                _react2.default.createElement(_index2.default, { selected: 'about' }),
                _react2.default.createElement(
                    'div',
                    { id: 'J-MainBody' },
                    _react2.default.createElement(
                        'div',
                        { className: 'doc-wrap', ref: 'doc' },
                        _react2.default.createElement(
                            'div',
                            { className: 'doc-container' },
                            _react2.default.createElement(
                                'div',
                                { className: 'doc-content', 'data-show': UP.Global.version },
                                _react2.default.createElement(
                                    'h2',
                                    { className: 'title' },
                                    _index6.default.template('Up直播-直播全世界')
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'subtitle' },
                                    _index6.default.template('让全世界看到你的美')
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'desc' },
                                    _index6.default.template('关于我们内容')
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'btns clearfix' },
                                    _react2.default.createElement(
                                        'a',
                                        { className: 'btn ios', onClick: this.onClick.bind(this, 'IOS'), href: 'https://itunes.apple.com/cn/app/up\u76F4\u64AD-\u5168\u7403love/id1235469329?mt=8', target: '_blank' },
                                        _react2.default.createElement('i', null),
                                        _react2.default.createElement(
                                            'em',
                                            null,
                                            _index6.default.template('iOS下载')
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'a',
                                        { className: 'btn android', onClick: this.onClick.bind(this, 'Android'), href: 'http://n.cdn.pengpengla.com/android/13797.apk', target: '_blank' },
                                        _react2.default.createElement('i', null),
                                        _react2.default.createElement(
                                            'em',
                                            null,
                                            _index6.default.template('Android下载')
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'a',
                                        { className: 'btn google', onClick: this.onClick.bind(this, 'Google'), href: 'https://play.google.com/store/apps/details?id=com.asiainno.uplive', target: '_blank' },
                                        _react2.default.createElement('i', null),
                                        _react2.default.createElement(
                                            'em',
                                            null,
                                            _index6.default.template('Google Play')
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return About;
}(_react.Component);

exports.default = About;

/***/ }),
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_trigger__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__placements__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Content__ = __webpack_require__(543);











var Tooltip = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _Component);

  function Tooltip() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
      var _this$props = _this.props,
          arrowContent = _this$props.arrowContent,
          overlay = _this$props.overlay,
          prefixCls = _this$props.prefixCls,
          id = _this$props.id;

      return [__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-arrow', key: 'arrow' },
        arrowContent
      ), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Content__["a" /* default */], {
        key: 'content',
        trigger: _this.trigger,
        prefixCls: prefixCls,
        id: id,
        overlay: overlay
      })];
    }, _this.saveTrigger = function (node) {
      _this.trigger = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
    return this.trigger.getPopupDomNode();
  };

  Tooltip.prototype.render = function render() {
    var _props = this.props,
        overlayClassName = _props.overlayClassName,
        trigger = _props.trigger,
        mouseEnterDelay = _props.mouseEnterDelay,
        mouseLeaveDelay = _props.mouseLeaveDelay,
        overlayStyle = _props.overlayStyle,
        prefixCls = _props.prefixCls,
        children = _props.children,
        onVisibleChange = _props.onVisibleChange,
        afterVisibleChange = _props.afterVisibleChange,
        transitionName = _props.transitionName,
        animation = _props.animation,
        placement = _props.placement,
        align = _props.align,
        destroyTooltipOnHide = _props.destroyTooltipOnHide,
        defaultVisible = _props.defaultVisible,
        getTooltipContainer = _props.getTooltipContainer,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);

    var extraProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps);
    if ('visible' in this.props) {
      extraProps.popupVisible = this.props.visible;
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_rc_trigger__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        popupClassName: overlayClassName,
        ref: this.saveTrigger,
        prefixCls: prefixCls,
        popup: this.getPopupElement,
        action: trigger,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_8__placements__["a" /* placements */],
        popupPlacement: placement,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
      }, extraProps),
      children
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Tooltip.propTypes = {
  trigger: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  defaultVisible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  placement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  onVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  afterVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  overlay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]).isRequired,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  overlayClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  getTooltipContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  destroyTooltipOnHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  align: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  arrowContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
Tooltip.defaultProps = {
  prefixCls: 'rc-tooltip',
  mouseEnterDelay: 0,
  destroyTooltipOnHide: false,
  mouseLeaveDelay: 0.1,
  align: {},
  placement: 'right',
  trigger: ['hover'],
  arrowContent: null
};


/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(484), __esModule: true };

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(485);
module.exports = __webpack_require__(37).Object.assign;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(51);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(487) });


/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(38);
var getKeys = __webpack_require__(92);
var gOPS = __webpack_require__(144);
var pIE = __webpack_require__(95);
var toObject = __webpack_require__(145);
var IObject = __webpack_require__(214);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(72)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(54);
var toLength = __webpack_require__(489);
var toAbsoluteIndex = __webpack_require__(490);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(140);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(140);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(492), __esModule: true };

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(493);
__webpack_require__(499);
module.exports = __webpack_require__(150).f('iterator');


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(494)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(217)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(140);
var defined = __webpack_require__(139);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(148);
var descriptor = __webpack_require__(91);
var setToStringTag = __webpack_require__(149);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(52)(IteratorPrototype, __webpack_require__(55)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(42);
var anObject = __webpack_require__(71);
var getKeys = __webpack_require__(92);

module.exports = __webpack_require__(38) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(36).document;
module.exports = document && document.documentElement;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(43);
var toObject = __webpack_require__(145);
var IE_PROTO = __webpack_require__(141)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(500);
var global = __webpack_require__(36);
var hide = __webpack_require__(52);
var Iterators = __webpack_require__(147);
var TO_STRING_TAG = __webpack_require__(55)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(501);
var step = __webpack_require__(502);
var Iterators = __webpack_require__(147);
var toIObject = __webpack_require__(54);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(217)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(504), __esModule: true };

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(505);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(512);
module.exports = __webpack_require__(37).Symbol;


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(36);
var has = __webpack_require__(43);
var DESCRIPTORS = __webpack_require__(38);
var $export = __webpack_require__(51);
var redefine = __webpack_require__(218);
var META = __webpack_require__(506).KEY;
var $fails = __webpack_require__(72);
var shared = __webpack_require__(142);
var setToStringTag = __webpack_require__(149);
var uid = __webpack_require__(94);
var wks = __webpack_require__(55);
var wksExt = __webpack_require__(150);
var wksDefine = __webpack_require__(151);
var enumKeys = __webpack_require__(507);
var isArray = __webpack_require__(508);
var anObject = __webpack_require__(71);
var isObject = __webpack_require__(53);
var toObject = __webpack_require__(145);
var toIObject = __webpack_require__(54);
var toPrimitive = __webpack_require__(138);
var createDesc = __webpack_require__(91);
var _create = __webpack_require__(148);
var gOPNExt = __webpack_require__(509);
var $GOPD = __webpack_require__(220);
var $GOPS = __webpack_require__(144);
var $DP = __webpack_require__(42);
var $keys = __webpack_require__(92);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(219).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(95).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(93)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(52)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(94)('meta');
var isObject = __webpack_require__(53);
var has = __webpack_require__(43);
var setDesc = __webpack_require__(42).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(72)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(92);
var gOPS = __webpack_require__(144);
var pIE = __webpack_require__(95);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(215);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(54);
var gOPN = __webpack_require__(219).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 510 */
/***/ (function(module, exports) {



/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(151)('asyncIterator');


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(151)('observable');


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(514), __esModule: true };

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(515);
module.exports = __webpack_require__(37).Object.setPrototypeOf;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(51);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(516).set });


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(53);
var anObject = __webpack_require__(71);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(210)(Function.call, __webpack_require__(220).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(518), __esModule: true };

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(519);
var $Object = __webpack_require__(37).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(51);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(148) });


/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Popup__ = __webpack_require__(527);

















function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"];

var contextTypes = {
  rcTrigger: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    onPopupMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  })
};

var Trigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Trigger, _React$Component);

  function Trigger(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Trigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.state = {
      prevPopupVisible: popupVisible,
      popupVisible: popupVisible
    };

    ALL_HANDLERS.forEach(function (h) {
      _this['fire' + h] = function (e) {
        _this.fireEvents(h, e);
      };
    });
    return _this;
  }

  Trigger.prototype.getChildContext = function getChildContext() {
    return {
      rcTrigger: {
        onPopupMouseDown: this.onPopupMouseDown
      }
    };
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
    clearTimeout(this.mouseDownTimeout);
  };

  Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var popupVisible = _ref.popupVisible;

    var newState = {};

    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
      newState.popupVisible = popupVisible;
      newState.prevPopupVisible = prevState.popupVisible;
    }

    return newState;
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return Object(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  /**
   * @param popupVisible    Show or not the popup element
   * @param event           SyntheticEvent, used for `pointAlign`
   */
  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
    var alignPoint = this.props.alignPoint;
    var prevPopupVisible = this.state.popupVisible;


    this.clearDelayTimer();

    if (prevPopupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({ popupVisible: popupVisible, prevPopupVisible: prevPopupVisible });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }

    // Always record the point position since mouseEnterDelay will delay the show
    if (alignPoint && event) {
      this.setPoint(event);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
    var _this2 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
      this.delayTimer = setTimeout(function () {
        _this2.setPopupVisible(visible, point);
        _this2.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible, event);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this3 = this;

    var popupVisible = this.state.popupVisible;
    var _props8 = this.props,
        children = _props8.children,
        forceRender = _props8.forceRender,
        alignPoint = _props8.alignPoint,
        className = _props8.className;

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
      if (alignPoint) {
        newChildProps.onMouseMove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var childrenClassName = __WEBPACK_IMPORTED_MODULE_12_classnames___default()(child && child.props && child.props.className, className);
    if (childrenClassName) {
      newChildProps.className = childrenClassName;
    }
    var trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__["a" /* default */],
        {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function (_ref2) {
          var renderComponent = _ref2.renderComponent;

          _this3.renderComponent = renderComponent;
          return trigger;
        }
      );
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || forceRender) {
      portal = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__["a" /* default */],
        { key: 'portal', getContainer: this.getContainer, didUpdate: this.handlePortalUpdate },
        this.getComponent()
      );
    }

    return [trigger, portal];
  };

  return Trigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Trigger.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  action: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  showAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  hideAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  popupStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  popupAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  focusDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  blurDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getDocument: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  forceRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  mask: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskClosable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onPopupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultPopupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  maskAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  alignPoint: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool // Maybe we can support user pass position in the future
};
Trigger.contextTypes = contextTypes;
Trigger.childContextTypes = contextTypes;
Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop,
  afterPopupVisibleChange: noop,
  onPopupAlign: noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onMouseEnter = function (e) {
    var mouseEnterDelay = _this4.props.mouseEnterDelay;

    _this4.fireEvents('onMouseEnter', e);
    _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
  };

  this.onMouseMove = function (e) {
    _this4.fireEvents('onMouseMove', e);
    _this4.setPoint(e);
  };

  this.onMouseLeave = function (e) {
    _this4.fireEvents('onMouseLeave', e);
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this4.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(_this4._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this4.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this4.clearDelayTimer();
    if (_this4.isFocusToShow()) {
      _this4.focusTime = Date.now();
      _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this4.fireEvents('onMouseDown', e);
    _this4.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this4.fireEvents('onTouchStart', e);
    _this4.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this4.fireEvents('onBlur', e);
    _this4.clearDelayTimer();
    if (_this4.isBlurToHide()) {
      _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this4.fireEvents('onContextMenu', e);
    _this4.setPopupVisible(true, e);
  };

  this.onContextMenuClose = function () {
    if (_this4.isContextMenuToShow()) {
      _this4.close();
    }
  };

  this.onClick = function (event) {
    _this4.fireEvents('onClick', event);
    // focus will trigger click
    if (_this4.focusTime) {
      var preTime = void 0;
      if (_this4.preClickTime && _this4.preTouchTime) {
        preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
      } else if (_this4.preClickTime) {
        preTime = _this4.preClickTime;
      } else if (_this4.preTouchTime) {
        preTime = _this4.preTouchTime;
      }
      if (Math.abs(preTime - _this4.focusTime) < 20) {
        return;
      }
      _this4.focusTime = 0;
    }
    _this4.preClickTime = 0;
    _this4.preTouchTime = 0;

    // Only prevent default when all the action is click.
    // https://github.com/ant-design/ant-design/issues/17043
    // https://github.com/ant-design/ant-design/issues/17291
    if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
      event.preventDefault();
    }
    var nextVisible = !_this4.state.popupVisible;
    if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
      _this4.setPopupVisible(!_this4.state.popupVisible, event);
    }
  };

  this.onPopupMouseDown = function () {
    var _context$rcTrigger = _this4.context.rcTrigger,
        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;

    _this4.hasPopupMouseDown = true;

    clearTimeout(_this4.mouseDownTimeout);
    _this4.mouseDownTimeout = setTimeout(function () {
      _this4.hasPopupMouseDown = false;
    }, 0);

    if (rcTrigger.onPopupMouseDown) {
      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this4.props.mask && !_this4.props.maskClosable) {
      return;
    }

    var target = event.target;
    var root = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
    if (!Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !_this4.hasPopupMouseDown) {
      _this4.close();
    }
  };

  this.getRootDomNode = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var _props9 = _this4.props,
        popupPlacement = _props9.popupPlacement,
        builtinPlacements = _props9.builtinPlacements,
        prefixCls = _props9.prefixCls,
        alignPoint = _props9.alignPoint,
        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;

    if (popupPlacement && builtinPlacements) {
      className.push(Object(__WEBPACK_IMPORTED_MODULE_13__utils__["b" /* getAlignPopupClassName */])(builtinPlacements, prefixCls, align, alignPoint));
    }
    if (getPopupClassNameFromAlign) {
      className.push(getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var _props10 = _this4.props,
        prefixCls = _props10.prefixCls,
        destroyPopupOnHide = _props10.destroyPopupOnHide,
        popupClassName = _props10.popupClassName,
        action = _props10.action,
        onPopupAlign = _props10.onPopupAlign,
        popupAnimation = _props10.popupAnimation,
        popupTransitionName = _props10.popupTransitionName,
        popupStyle = _props10.popupStyle,
        mask = _props10.mask,
        maskAnimation = _props10.maskAnimation,
        maskTransitionName = _props10.maskTransitionName,
        zIndex = _props10.zIndex,
        popup = _props10.popup,
        stretch = _props10.stretch,
        alignPoint = _props10.alignPoint;
    var _state = _this4.state,
        popupVisible = _state.popupVisible,
        point = _state.point;


    var align = _this4.getPopupAlign();

    var mouseProps = {};
    if (_this4.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
    }
    if (_this4.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
    }

    mouseProps.onMouseDown = _this4.onPopupMouseDown;
    mouseProps.onTouchStart = _this4.onPopupMouseDown;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_14__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: prefixCls,
        destroyPopupOnHide: destroyPopupOnHide,
        visible: popupVisible,
        point: alignPoint && point,
        className: popupClassName,
        action: action,
        align: align,
        onAlign: onPopupAlign,
        animation: popupAnimation,
        getClassNameFromAlign: _this4.getPopupClassNameFromAlign
      }, mouseProps, {
        stretch: stretch,
        getRootDomNode: _this4.getRootDomNode,
        style: popupStyle,
        mask: mask,
        zIndex: zIndex,
        transitionName: popupTransitionName,
        maskAnimation: maskAnimation,
        maskTransitionName: maskTransitionName,
        ref: _this4.savePopup
      }),
      typeof popup === 'function' ? popup() : popup
    );
  };

  this.getContainer = function () {
    var props = _this4.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.setPoint = function (point) {
    var alignPoint = _this4.props.alignPoint;

    if (!alignPoint || !point) return;

    _this4.setState({
      point: {
        pageX: point.pageX,
        pageY: point.pageY
      }
    });
  };

  this.handlePortalUpdate = function () {
    if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
      _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this4._component = node;
  };
};

Object(__WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__["a" /* polyfill */])(Trigger);

/* harmony default export */ __webpack_exports__["a"] = (Trigger);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = addEventListener;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventObject = __webpack_require__(523);

var _EventObject2 = _interopRequireDefault(_EventObject);

function addEventListener(target, eventType, callback, option) {
  function wrapCallback(e) {
    var ne = new _EventObject2['default'](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    var _ret = (function () {
      var useCapture = false;
      if (typeof option === 'object') {
        useCapture = option.capture || false;
      } else if (typeof option === 'boolean') {
        useCapture = option;
      }

      target.addEventListener(eventType, wrapCallback, option || false);

      return {
        v: {
          remove: function remove() {
            target.removeEventListener(eventType, wrapCallback, useCapture);
          }
        }
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}

module.exports = exports['default'];

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventBaseObject = __webpack_require__(524);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(127);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = undefined;
    var deltaY = undefined;
    var delta = undefined;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = undefined;
    var doc = undefined;
    var body = undefined;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2['default'].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = undefined;
  var l = undefined;
  var prop = undefined;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2['default'].prototype;

(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },

  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports['default'] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },

  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },

  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },

  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports["default"];

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContainerRender; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }





var ContainerRender =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ContainerRender, _React$Component);

  function ContainerRender() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ContainerRender);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ContainerRender)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.removeContainer = function () {
      if (_this.container) {
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(_this.container);

        _this.container.parentNode.removeChild(_this.container);

        _this.container = null;
      }
    };

    _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }

        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    };

    return _this;
  }

  _createClass(ContainerRender, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContainerRender.propTypes = {
  autoMount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  autoDestroy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  parent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  getComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};


/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Portal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }





var Portal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, _getPrototypeOf(Portal).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: "removeContainer",
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this._container) {
        return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(this.props.children, this._container);
      }

      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = {
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  didUpdate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};


/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_align__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupInner__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(223);













var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      // Used for stretch
      stretchChecked: false,
      targetWidth: undefined,
      targetHeight: undefined
    };

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
    this.setStretchSize();
  };

  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setStretchSize();
  };

  // Record size if stretch needed


  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.popupInstance);
  };

  // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align


  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var _this2 = this;

    var savePopupRef = this.savePopupRef;
    var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
    var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onMouseDown = _props.onMouseDown,
        onTouchStart = _props.onTouchStart;

    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';

    if (!visible) {
      this.currentAlignClassName = null;
    }

    var sizeStyle = {};
    if (stretch) {
      // Stretch with target
      if (stretch.indexOf('height') !== -1) {
        sizeStyle.height = targetHeight;
      } else if (stretch.indexOf('minHeight') !== -1) {
        sizeStyle.minHeight = targetHeight;
      }
      if (stretch.indexOf('width') !== -1) {
        sizeStyle.width = targetWidth;
      } else if (stretch.indexOf('minWidth') !== -1) {
        sizeStyle.minWidth = targetWidth;
      }

      // Delay force align to makes ui smooth
      if (!stretchChecked) {
        sizeStyle.visibility = 'hidden';
        setTimeout(function () {
          if (_this2.alignInstance) {
            _this2.alignInstance.forceAlign();
          }
        }, 0);
      }
    }

    var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sizeStyle, style, this.getZIndexStyle());

    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDown: onMouseDown,
      onTouchStart: onTouchStart,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        },
        visible ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
          {
            target: this.getAlignTarget(),
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              visible: true
            }, popupInnerProps),
            children
          )
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
      {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
        {
          target: this.getAlignTarget(),
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          xVisible: visible,
          childrenProps: { visible: 'xVisible' },
          disabled: !visible,
          align: align,
          onAlign: this.onAlign
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps),
          children
        )
      )
    );
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__["a" /* default */], {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
          {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          },
          maskElement
        );
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  };

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  point: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this3.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this3.currentAlignClassName !== currentAlignClassName) {
      _this3.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this3.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.setStretchSize = function () {
    var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
    var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;


    if (!stretch || !visible) {
      if (stretchChecked) {
        _this3.setState({ stretchChecked: false });
      }
      return;
    }

    var $ele = getRootDomNode();
    if (!$ele) return;

    var height = $ele.offsetHeight;
    var width = $ele.offsetWidth;

    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
      _this3.setState({
        stretchChecked: true,
        targetHeight: height,
        targetWidth: width
      });
    }
  };

  this.getTargetElement = function () {
    return _this3.props.getRootDomNode();
  };

  this.getAlignTarget = function () {
    var point = _this3.props.point;

    if (point) {
      return point;
    }
    return _this3.getTargetElement;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(529);
// export this package's api


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_align__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(533);












function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        // IE lose focus after element realign
        // We should record activeElement and restore later
        var activeElement = document.activeElement;

        if (element) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["a" /* alignElement */])(source, element, align);
        } else if (point) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["b" /* alignPoint */])(source, point, align);
        }

        Object(__WEBPACK_IMPORTED_MODULE_9__util__["e" /* restoreFocus */])(activeElement, source);

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Align, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      // if parent ref not attached .... use document.getElementById
      this.forceAlign();
      if (!props.disabled && props.monitorWindowResize) {
        this.startMonitorWindowResize();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var reAlign = false;
      var props = this.props;

      if (!props.disabled) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
        var sourceRect = source ? source.getBoundingClientRect() : null;

        if (prevProps.disabled) {
          reAlign = true;
        } else {
          var lastElement = getElement(prevProps.target);
          var currentElement = getElement(props.target);
          var lastPoint = getPoint(prevProps.target);
          var currentPoint = getPoint(props.target);

          if (Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(lastElement) && Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(currentElement)) {
            // Skip if is window
            reAlign = false;
          } else if (lastElement !== currentElement || // Element change
          lastElement && !currentElement && currentPoint || // Change from element to point
          lastPoint && currentPoint && currentElement || // Change from point to element
          currentPoint && !Object(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* isSamePoint */])(lastPoint, currentPoint)) {
            reAlign = true;
          }

          // If source element size changed
          var preRect = this.sourceRect || {};
          if (!reAlign && source && (!Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.width, sourceRect.width) || !Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.height, sourceRect.height))) {
            reAlign = true;
          }
        }

        this.sourceRect = sourceRect;
      }

      if (reAlign) {
        this.forceAlign();
      }

      if (props.monitorWindowResize && !props.disabled) {
        this.startMonitorWindowResize();
      } else {
        this.stopMonitorWindowResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: 'startMonitorWindowResize',
    value: function startMonitorWindowResize() {
      if (!this.resizeHandler) {
        this.bufferMonitor = Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
        this.resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
      }
    }
  }, {
    key: 'stopMonitorWindowResize',
    value: function stopMonitorWindowResize() {
      if (this.resizeHandler) {
        this.bufferMonitor.clear();
        this.resizeHandler.remove();
        this.resizeHandler = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          childrenProps = _props.childrenProps,
          children = _props.children;

      var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
      if (childrenProps) {
        var newProps = {};
        var propList = Object.keys(childrenProps);
        propList.forEach(function (prop) {
          newProps[prop] = _this2.props[childrenProps[prop]];
        });

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newProps);
      }
      return child;
    }
  }]);

  return Align;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    clientX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    clientY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })]),
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(531);
var $Object = __webpack_require__(37).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(51);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(38), 'Object', { defineProperty: __webpack_require__(42).f });


/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alignElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alignPoint; });
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }

  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }

  return vendorPrefix;
}

function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = getTransitionName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }

  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);

    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX; // https://stackoverflow.com/a/3485654/3040605

function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line

  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;

  if (_typeof(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }

    return undefined;
  }

  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }

    el.style[name] = value;
    return undefined;
  }

  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement; // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式

  box = elem.getBoundingClientRect(); // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top; // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.
  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.
  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');

  if (typeof ret !== 'number') {
    var d = w.document; // ie6,7,8 standard mode

    ret = d.documentElement[method];

    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }

  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */


function isWindow(obj) {
  // must use == for ie8

  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }

  if (node.nodeType === 9) {
    return node;
  }

  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null); // https://github.com/kissyteam/kissy/issues/61

  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');

var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name]; // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity

  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT]; // prevent flashing of content

    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT]; // Put in the new values to get a computed value out

    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX; // Revert the changed values

    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }

  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }

  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
} // 设置 elem 相对 elem.ownerDocument 的坐标


function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }

  var originalTransition = '';
  var originalOffset = getOffset(elem);

  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }

  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }

  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  } // force relayout


  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};

  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];

      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }

  css(elem, originalStyle); // force relayout

  forceRelayout(elem);

  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }

  var ret = {};

  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);

      var _off = offset[_key] - originalOffset[_key];

      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }

  css(elem, ret);
}

function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };

  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }

  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }

  setTransformXY(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);

    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }

  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name; // Remember the old values, and insert the new ones

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem); // Revert the old values

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;

  for (j = 0; j < props.length; j++) {
    prop = props[j];

    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;

        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }

        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }

  return value;
}

var domUtils = {
  getParent: function getParent(element) {
    var parent = element;

    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);

    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max( // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };

  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop]; // 标准模式取 documentElement
    // backcompat 取 body

    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */

function getWH(elem, name, ex) {
  var extra = ex;

  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;

  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined; // Fall back to computed then un computed css if necessary

    cssBoxValue = getComputedStyleX(elem, name);

    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    } // Normalize '', auto, and prepare for extra


    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }

  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }

  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;

  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }

    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }

    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }

  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
}; // fix #119 : https://github.com/kissyteam/kissy/issues/119

function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val;
  var elem = args[0]; // in case elem is window
  // elem.offsetWidth === undefined

  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }

  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);

  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;

    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);

        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }

        return css(elem, name, val);
      }

      return undefined;
    }

    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }

  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }

    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};

    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }

    var overflow = obj.overflow;

    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }

    return ret;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }

    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */

var getParent = utils.getParent;

function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  } // ie 这个也不是完全可行

  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法


  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }

  for (parent = getParent(element); parent && parent !== body; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');

    if (positionStyle !== 'static') {
      return parent;
    }
  }

  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;

  for (parent = getParent$1(element); parent && parent !== body; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');

    if (positionStyle === 'fixed') {
      return true;
    }
  }

  return false;
}

/**
 * 获得元素的显示部分的区域
 */

function getVisibleRectForElement(element) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement; // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.

  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el); // add border

      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }

    el = getOffsetParent(el);
  } // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601


  var originalPosition = null;

  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');

    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight; // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.

  var bodyStyle = window.getComputedStyle(body);

  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }

  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  } // Reset element position after calculate the visible area


  if (element.style) {
    element.style.position = originalPosition;
  }

  if (isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  } // Left edge inside and right edge outside viewport, try to resize it.


  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  } // Right edge outside viewport, try to move it.


  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  } // Top edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  } // Top edge inside and bottom edge outside viewport, try to resize it.


  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  } // Bottom edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;

  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }

  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */
function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n;

  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }

  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */


function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0; // 当前节点可以被放置的显示区域

  var visibleRect = getVisibleRectForElement(source); // 当前节点所占的区域, left/top/width/height

  var elRegion = getRegion(source); // 将 offset 转换成数值，支持百分比

  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion); // 当前节点将要被放置的位置

  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset); // 当前节点将要所处的区域

  var newElRegion = utils.merge(elRegion, elFuturePos); // 如果可视区域不能完全放置当前节点时允许调整

  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        }); // 偏移量也反下

        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        }); // 偏移量也反下


        var _newOffset = flipOffset(offset, 1);

        var _newTargetOffset = flipOffset(targetOffset, 1);

        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    } // 如果失败，重新计算当前节点将要被放置的位置


    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }

    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect); // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数

    if (isStillFailX || isStillFailY) {
      points = align.points;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    } // 2. 只有指定了可以调整当前方向才调整


    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY; // 确实要调整，甚至可能会调整高度宽度

    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  } // need judge to in case set fixed with in css on height auto element


  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  } // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>


  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target) {
  var visibleRect = getVisibleRectForElement(target);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}

alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);

  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }

  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }

  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight; // Provide default target point

  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, _objectSpread2({}, align, {
    points: points
  }), pointInView);
}

/* unused harmony default export */ var _unused_webpack_default_export = (alignElement);

//# sourceMappingURL=index.js.map


/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["d"] = isWindow;
/* harmony export (immutable) */ __webpack_exports__["c"] = isSimilarValue;
/* harmony export (immutable) */ __webpack_exports__["e"] = restoreFocus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__ = __webpack_require__(221);


function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

function isSimilarValue(val1, val2) {
  var int1 = Math.floor(val1);
  var int2 = Math.floor(val2);
  return Math.abs(int1 - int2) <= 1;
}

function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && Object(__WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__["a" /* default */])(container, activeElement)) {
    activeElement.focus();
  }
}

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AnimateChild__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_animate__ = __webpack_require__(226);












var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_10__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_10__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_10__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Animate);

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(224);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(226);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(225);
} catch (err) {
  var index = __webpack_require__(225);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__ = __webpack_require__(227);







var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onTouchStart: props.onTouchStart,
        style: props.style
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__["a" /* default */],
        { className: props.prefixCls + '-content', visible: props.visible },
        props.children
      )
    );
  };

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placements; });
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (placements);

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Content = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Content, _React$Component);

  function Content() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Content);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Content.prototype.componentDidUpdate = function componentDidUpdate() {
    var trigger = this.props.trigger;

    if (trigger) {
      trigger.forcePopupAlign();
    }
  };

  Content.prototype.render = function render() {
    var _props = this.props,
        overlay = _props.overlay,
        prefixCls = _props.prefixCls,
        id = _props.id;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls + '-inner', id: id, role: 'tooltip' },
      typeof overlay === 'function' ? overlay() : overlay
    );
  };

  return Content;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Content.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  overlay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]).isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  trigger: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),
/* 544 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "UserLogout",
    "options": {
        "objc_class_prefix": "UserLogout",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Request",
        "fields": []
    }]
}).build();

exports.default = _root;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _rechargePop = __webpack_require__(157);

var _rechargePop2 = _interopRequireDefault(_rechargePop);

var _rechargeResult = __webpack_require__(258);

var _rechargeResult2 = _interopRequireDefault(_rechargeResult);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _reactRouter = __webpack_require__(23);

var _rcTooltip = __webpack_require__(27);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _qrcode = __webpack_require__(90);

var _qrcode2 = _interopRequireDefault(_qrcode);

var _index = __webpack_require__(291);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(623);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(627);

var _index6 = _interopRequireDefault(_index5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Extra = function (_Component) {
    _inherits(Extra, _Component);

    function Extra(props) {
        _classCallCheck(this, Extra);

        var _this = _possibleConstructorReturn(this, (Extra.__proto__ || Object.getPrototypeOf(Extra)).call(this, props));

        _this.showRechargePop = function () {
            _this.setState({
                showRechargePop: 1
            });
        };

        _this.closeRechargePop = function () {
            _this.setState({
                showRechargePop: 0
            });
        };

        _this.state = {
            // isLoggedIn: UP.Global.isLogin(),
            showRechargePop: 0,
            currentPath: ''
        };

        _this.cache = new _cCache2.default({
            prefix: 'pcuplive'
        });
        return _this;
    }

    _createClass(Extra, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            if (this.props.selected !== 'recharge') {
                this.bindEvent();
            }
        }
    }, {
        key: "bindEvent",
        value: function bindEvent() {
            var _this2 = this;

            // 支付成功
            $.channel.on('rechargeSuccess', function (data) {
                var diamond = longToString(data.diamond);
                // 更新全局用户信息的U钻数

                UP.Global.updateDiamondBanlance(diamond);

                _this2.closeRechargePop();

                _this2.refs.result.showResultSuccess();
            });

            // 支付失败
            $.channel.on('rechargeError', function (code) {
                _this2.refs.result.showResultError(code);
            });

            $.channel.on('showRechargePop', function () {
                _this2.showRechargePop();
            });
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            $.channel.off('rechargeSuccess');
            $.channel.off('rechargeError');
        }
    }, {
        key: "render",

        /*  <Tooltip getTooltipContainer={()=>this.refs.btns} overlay={<span className="txt">{lang.template('观看记录')}</span>} placement="bottom" trigger={['hover']} overlayClassName="header-mini-popover">
                            <Link className="btn-head history" to="/history">{lang.template('观看记录')}</Link>
                        </Tooltip>
                        <Tooltip getTooltipContainer={()=>this.refs.btns} overlay={<span className="txt">{lang.template('关注')}</span>} placement="bottom" trigger={['hover']} overlayClassName="header-mini-popover">
                            <Link className="btn-head follow" to="/allhostlist/follow">{lang.template('关注')}</Link>
                        </Tooltip>*/

        value: function render() {
            return _react2.default.createElement(
                "div",
                { className: "ex-btns ex-expand-btns", ref: "btns" },
                _react2.default.createElement(_index2.default, null),
                _react2.default.createElement(
                    "div",
                    { className: "btn-head recharge", onClick: this.showRechargePop },
                    _lang2.default.template('去充值')
                ),
                _react2.default.createElement(_index4.default, null),
                _react2.default.createElement(_index6.default, null),
                UP.Global.version == 'CN' ? null : _react2.default.createElement("div", { className: "split" }),
                _react2.default.createElement(_rechargeResult2.default, { ref: "result" }),
                this.state.showRechargePop ? _react2.default.createElement(_rechargePop2.default, { onClose: this.closeRechargePop }) : null
            );
        }
    }]);

    return Extra;
}(_react.Component);

module.exports = Extra;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _config = __webpack_require__(228);

var _config2 = _interopRequireDefault(_config);

var _secondConfig = __webpack_require__(547);

var _secondConfig2 = _interopRequireDefault(_secondConfig);

var _index = __webpack_require__(548);

var _index2 = _interopRequireDefault(_index);

var _iframe = __webpack_require__(98);

var _iframe2 = _interopRequireDefault(_iframe);

var _vip = __webpack_require__(566);

var _vip2 = _interopRequireDefault(_vip);

var _index3 = __webpack_require__(207);

var _index4 = _interopRequireDefault(_index3);

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RechargeView = function (_Component) {
    _inherits(RechargeView, _Component);

    function RechargeView(props) {
        _classCallCheck(this, RechargeView);

        var _this = _possibleConstructorReturn(this, (RechargeView.__proto__ || Object.getPrototypeOf(RechargeView)).call(this, props));

        _initialiseProps.call(_this);

        var countryCode = _cUrl2.default.query('adscountry') || UP.Global.getUser().countryCode;
        var channelList = void 0;
        var subList = void 0;
        var pepaySubList = void 0;

        _this.countryCode = countryCode = countryCode != 'PK' && UP.Global.middelEastCountryCodes.indexOf(countryCode) > -1 ? 'MSL' : countryCode;

        switch (countryCode) {
            case 'CN':
                // 大陆地区
                channelList = ['vipcz', 'wxpay', 'alipay'];
                break;

            case 'MSL':
                // 中东地区
                channelList = ['vipcz', 'paypal', 'onecard'];
                break;
            case 'PK':
                // 巴基斯坦地区
                channelList = ['vipcz', 'paypal', 'onecard'];
                break;

            case 'MY':
                channelList = ['vipcz', 'dokypay', 'paypal', 'wxpay', 'alipay'];
                break;
            case 'ID':
                // 印尼
                channelList = ['vipcz', 'codapay', 'pepay'];
                subList = _secondConfig2.default.codapayId;
                pepaySubList = _secondConfig2.default.pepay;
                break;
            case 'US':
                channelList = ['vipcz', 'paypal'];
                break;
            case 'VN':
                channelList = ['vipcz', 'paypal'];
                break;
            case 'TH':
                channelList = ['pepay_entitycard_thb', 'paypal', 'vipcz', 'wxpay', 'alipay'];
                break;
            case 'KR':
                channelList = ['vipcz', 'kakaopay', 'paypal', 'wxpay', 'alipay'];
                break;
            case 'IN':
                // 印度
                // channelList = ['vipcz', 'paypal', 'codapay_390', 'codapay_391']
                channelList = ['vipcz', 'paypal', 'dokypay'];
                break;
            case 'PH':
                // 菲律宾
                channelList = ['vipcz', 'codapay'];
                subList = _secondConfig2.default.codapayPh;
                break;
            case 'TW':
                // 台湾
                channelList = ['vipcz', 'pepay_credit', 'pepay_store', 'sinopac_atm', 'bj_mycard', 'gash', 'gash_card', 'paypal'];
                pepaySubList = _secondConfig2.default.pepay_store;
                break;
            case 'HK':
                // 香港
                channelList = ['vipcz', 'paypal', 'wxpay', 'alipay'];
                break;
            case 'JP':
                // 日本
                channelList = ['vipcz', 'paypal', 'wxpay', 'alipay'];
                break;
            default:
                channelList = ['vipcz', 'paypal', 'wxpay', 'alipay'];
        }

        // IE 下去掉支付宝充值方式

        if (UP.Global.isIE && channelList.indexOf('alipay') > -1) {
            channelList.splice(channelList.indexOf('alipay'), 1);
        }

        var rendered = [];

        for (var i = channelList.length; i--;) {
            if (i == 0) {
                rendered[i] = 1;
            } else {
                rendered[i] = 0;
            }
        }

        _this.state = {
            channelList: channelList,
            rendered: rendered, // 存储支付panel渲染的状态。panel若已render，则做隐藏操作
            selectedOption: channelList[0],
            subList: subList,
            codapayChannel: subList != undefined ? subList[0] : '',
            codapayvalue: '',
            pepaySubList: pepaySubList,
            pepayChannel: pepaySubList != undefined ? pepaySubList[0] : '',
            pepayvalue: ''
        };

        _this.showExceptionPopupMap = {};
        return _this;
    }

    _createClass(RechargeView, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            var channel = sessionStorage.getItem('channel');
            var codapayoption = void 0;

            $.channel.on('getOptionListError', function () {
                _this2.showExceptionPopup();
            });

            //home页点击充值页面后选中支付方式
            if (channel != null) {
                if (this.state.subList != undefined) {
                    codapayoption = this.state.subList[0];
                } else if (this.state.pepaySubList != undefined) {
                    codapayoption = this.state.pepaySubList[0];
                } else {

                    codapayoption = '';
                }
                this.onTabClick(channel, codapayoption);
                sessionStorage.removeItem('channel');
            } else {

                if (['CN'].indexOf(this.countryCode) > -1) {
                    this.onTabClick(this.state.channelList[1]);
                }
            }
        }
    }, {
        key: "showExceptionPopup",
        value: function showExceptionPopup() {
            var self = this;

            _iframe2.default.create({
                url: 'https://m.upliveapps.com/ipay/exception.html?lang=' + UP.Global.siteLanguage,
                onHide: function onHide() {
                    if (self.state.selectedOption == 'codapay') {
                        self.showExceptionPopupMap[self.state.codapayChannel] = 1;
                    } else {
                        self.showExceptionPopupMap[self.state.selectedOption] = 1;
                    }

                    self.setState({
                        selectedOption: self.state.channelList[0] // 关闭弹出框，回到VIP充值
                    });
                }
            });
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            $.channel.off('getOptionListError');
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            var userInfo = UP.Global.getUser();
            var countryCode = this.countryCode;
            var _state = this.state,
                selectedOption = _state.selectedOption,
                channelList = _state.channelList,
                codapayChannel = _state.codapayChannel,
                subList = _state.subList,
                codapayvalue = _state.codapayvalue,
                pepayChannel = _state.pepayChannel,
                pepaySubList = _state.pepaySubList,
                pepayvalue = _state.pepayvalue;

            var $channelList = [];
            var $contentList = [];
            var $codapay_id = [];
            var $pepay_id = [];

            $.map(channelList, function (value, index) {

                var item = _config2.default[value];
                if (item.open) {
                    // 处理tab
                    var text = void 0;

                    switch (value) {
                        case 'bj_mycard':
                            text = _lang2.default.template('mycard');
                            break;
                        case 'paypal':
                            text = _lang2.default.template('paypal');
                            break;
                        case 'onecard':
                            text = _lang2.default.template('onecard');
                            break;
                        case 'alipay':
                            text = _lang2.default.template('支付宝');
                            break;
                        case 'wxpay':
                            text = _lang2.default.template('微信支付');
                            break;
                        case 'codapay':
                            text = _lang2.default.template('codapay');
                            break;
                        case 'molpay_points':
                            text = _lang2.default.template('molpay_points');
                            break;
                        case 'pepay_entitycard_thb':
                            text = 'CashCard(THB)';
                            break;
                        case 'pepay_entitycard_vnd':
                            text = _lang2.default.template('pepay_entitycard_vnd');
                            break;
                        case 'pepay_onlinebank_vnd':
                            text = _lang2.default.template('pepay_onlinebank_vnd');
                            break;
                        case 'bk_atm':
                            text = _lang2.default.template('ATM/Credit Card');
                            break;
                        case 'pepay_alfamart_idr':
                            text = 'Alfamart';
                            break;
                        case 'pepay_webatm_idr':
                            text = 'Bank Atm';
                            break;
                        case 'sinopac_atm':
                            text = 'Bank(Taiwan)';
                            break;
                        case 'kakaopay':
                            text = _lang2.default.template('kakaopay');
                            break;
                        case 'pepay_credit':
                            text = _lang2.default.template('信用卡專區');
                            break;
                        case 'pepay_store':
                            text = _lang2.default.template('便利超商代收');
                            break;
                        case 'vip':
                        case 'vipcz':
                            text = _lang2.default.template('VIP充值');
                            break;
                        case 'pepay':
                            text = _lang2.default.template('PePay');
                            break;
                        case 'codapay_390':
                            text = _lang2.default.template('Paytm Wallet');
                            break;
                        case 'codapay_391':
                            text = _lang2.default.template('Bank Transfer');
                            break;
                        default:
                            text = item.text;
                    }

                    var node = _react2.default.createElement(
                        "li",
                        { key: index },
                        _react2.default.createElement(
                            "div",
                            { className: item.option == selectedOption ? 'selected channel-item' : 'channel-item',
                                onClick: _this3.onTabClick.bind(_this3, item.option, subList != undefined ? subList[0] : '', pepaySubList != undefined ? pepaySubList[0] : '') },
                            item.option == 'sinopac_atm' || item.option == 'pepay_entitycard_thb' ? _react2.default.createElement(
                                "span",
                                null,
                                text,
                                "\u200E"
                            ) : _react2.default.createElement(
                                "span",
                                null,
                                text
                            )
                        ),
                        value == 'vipcz' && _lang2.default.template('VIP优惠描述') !== 'VIP优惠描述' && ['CN', 'TW', 'MO', 'MYC', 'HK'].indexOf(countryCode) > -1 ? _react2.default.createElement("div", { className: "floatip",
                            dangerouslySetInnerHTML: { __html: _lang2.default.template('VIP优惠描述') } }) : null,
                        item.option == 'codapay' && selectedOption == 'codapay' && subList != undefined ? _react2.default.createElement(
                            "div",
                            { className: "pay-box" },
                            _react2.default.createElement(
                                "ul",
                                { className: "channel-list channel-pay" },
                                $codapay_id
                            )
                        ) : null,
                        item.option == 'pepay' && selectedOption == 'pepay' && pepaySubList != undefined ? _react2.default.createElement(
                            "div",
                            { className: "pay-box pepay-box" },
                            _react2.default.createElement(
                                "ul",
                                { className: "channel-list channel-pay" },
                                $pepay_id
                            )
                        ) : null,
                        item.option == 'pepay_store' && selectedOption == 'pepay_store' && pepaySubList != undefined ? _react2.default.createElement(
                            "div",
                            { className: "pay-box pepaystore-box" },
                            _react2.default.createElement(
                                "ul",
                                { className: "channel-list channel-pay" },
                                $pepay_id
                            )
                        ) : null
                    );

                    $channelList[$channelList.length] = node;

                    // 处理Tab对应的内容
                    var $content = void 0;

                    if (_this3.state.rendered[index]) {
                        var $entry = void 0;

                        if (value == 'vipcz') {
                            $entry = _react2.default.createElement(_vip2.default, null);
                        } else if (value == 'codapay') {
                            $entry = _react2.default.createElement(_index2.default, { uid: userInfo.uid, channel: _this3.state.codapayChannel });
                        } else if (value == 'pepay' || value == 'pepay_store') {
                            $entry = _react2.default.createElement(_index2.default, { uid: userInfo.uid, channel: _this3.state.pepayChannel });
                        } else {
                            $entry = _react2.default.createElement(_index2.default, { uid: userInfo.uid, channel: value });
                        }

                        $content = _react2.default.createElement(
                            "div",
                            { key: value, className: value == selectedOption ? '' : 'hidden' },
                            $entry
                        );
                    } else {
                        $content = _react2.default.createElement("div", { key: value, className: "hidden" });
                    }

                    $contentList[$contentList.length] = $content;
                }
            });

            //印尼、菲律宾codapay新增支付方式
            if (subList != undefined) {
                $.map(this.state.subList, function (value, index) {

                    var item = _config2.default[value];
                    if (item.open) {

                        var codapayList = _react2.default.createElement(
                            "li",
                            { key: index },
                            _react2.default.createElement(
                                "div",
                                { className: item.option == codapayChannel ? 'channel-item selected' : 'channel-item',
                                    onClick: _this3.onTabClick.bind(_this3, codapayvalue, item.option, item.option) },
                                _react2.default.createElement(
                                    "span",
                                    null,
                                    item.text
                                )
                            )
                        );
                        $codapay_id[$codapay_id.length] = codapayList;
                    }
                });
            };
            if (pepaySubList != undefined) {

                $.map(this.state.pepaySubList, function (value, index) {

                    var item = _config2.default[value];
                    if (item.open) {

                        var pepayList = _react2.default.createElement(
                            "li",
                            { key: index, "data-type": item.option },
                            _react2.default.createElement(
                                "div",
                                { className: item.option == pepayChannel ? 'channel-item selected' : 'channel-item',
                                    onClick: _this3.onTabClick.bind(_this3, pepayvalue, item.option, item.option) },
                                _react2.default.createElement(
                                    "span",
                                    null,
                                    item.text
                                )
                            )
                        );
                        $pepay_id[$pepay_id.length] = pepayList;
                    }
                });
            }

            return _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                    "h3",
                    { className: "titles" },
                    _lang2.default.template('充值方式'),
                    "  "
                ),
                _react2.default.createElement(
                    "ul",
                    { className: "channel-list clearfix", "data-current": selectedOption },
                    $channelList
                ),
                selectedOption == 'bj_mycard' && _lang2.default.template('mycard充值提示') !== 'mycard充值提示' ? _react2.default.createElement(
                    "div",
                    { className: "mycard-tip" },
                    _lang2.default.template('mycard充值提示')
                ) : null,
                ['vip', 'vipcz', 'pepay_entitycard_thb', 'pepay_entitycard_vnd', 'icard', 'gash_card'].indexOf(selectedOption) == -1 ? _react2.default.createElement(
                    "h3",
                    { className: "titles" },
                    _lang2.default.template('充值数量')
                ) : null,
                $contentList,
                _react2.default.createElement(
                    "div",
                    { className: "kefu" },
                    _react2.default.createElement(
                        "span",
                        null,
                        _lang2.default.template('充值遇到问题,点此')
                    ),
                    _react2.default.createElement(
                        "em",
                        { className: "kefu-click", onClick: this.callService },
                        _lang2.default.template('联系客服')
                    )
                )
            );
        }
    }]);

    return RechargeView;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.onTabClick = function (option, codapayoption, pepayoption) {

        if (option == 'codapay') {
            _this4.setState({
                codapayvalue: 'codapay',
                codapayChannel: codapayoption
            });
        } else if (option == 'pepay') {
            _this4.setState({
                pepayvalue: 'pepay',
                pepayChannel: pepayoption
            });
        } else if (option == 'pepay_store') {
            _this4.setState({
                pepayvalue: 'pepay_store',
                pepayChannel: pepayoption
            });
        } else {

            if (_this4.state.selectedOption == option) {
                return;
            }
        }

        var index = _this4.state.channelList.indexOf(option);
        var rendered = _this4.state.rendered;

        rendered[index] = 1;

        _this4.setState({
            rendered: rendered,
            selectedOption: option,
            codapayChannel: codapayoption,
            pepayChannel: pepayoption
        }, function () {
            if (this.showExceptionPopupMap[option]) {
                this.showExceptionPopup();
            }
        });
    };

    this.callService = function () {
        $.channel.emit('showChat');
    };
};

exports.default = RechargeView;

/***/ }),
/* 547 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var secondChannel = {
    'codapayId': ['codapay_1', 'codapay_220', 'codapay_221', 'codapay_223'],
    'codapayPh': ['codapay_253', 'codapay_250', 'codapay_251', 'codapay_252'],
    'pepay': ['pepay_webatm_idr', 'pepay_alfamart_idr'],
    'pepay_store': ['pepay_store_ibon_twd', 'pepay_store_fami_twd', 'pepay_store_hilifeet_twd', 'pepay_store_okgo_twd']
};

exports.default = secondChannel;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _h = __webpack_require__(549);

var _h2 = _interopRequireDefault(_h);

var _optionList = __webpack_require__(558);

var _optionList2 = _interopRequireDefault(_optionList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 下单成功之后，走web支付
 */
exports.default = (0, _h2.default)(_optionList2.default);

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cUpLoading = __webpack_require__(13);

var _cUpLoading2 = _interopRequireDefault(_cUpLoading);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _cTimer = __webpack_require__(100);

var _cTimer2 = _interopRequireDefault(_cTimer);

var _cNotification = __webpack_require__(11);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _orderpb = __webpack_require__(550);

var _orderpb2 = _interopRequireDefault(_orderpb);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _config = __webpack_require__(228);

var _config2 = _interopRequireDefault(_config);

var _payresult = __webpack_require__(229);

var _payresult2 = _interopRequireDefault(_payresult);

var _bank = __webpack_require__(552);

var _bank2 = _interopRequireDefault(_bank);

var _ccnet = __webpack_require__(556);

var _ccnet2 = _interopRequireDefault(_ccnet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 充值下单模块
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var pbajax = new _pbajax2.default();

exports.default = function (ComposedComponent) {
    var Order = function (_Component) {
        _inherits(Order, _Component);

        function Order(props) {
            _classCallCheck(this, Order);

            var _this = _possibleConstructorReturn(this, (Order.__proto__ || Object.getPrototypeOf(Order)).call(this, props));

            _this.state = {
                uid: props.uid,
                channel: props.channel,
                showQrcode: 0,
                remainTime: 60
            };

            _this.cache = new _cCache2.default({
                prefix: 'pcuplive'
            });
            return _this;
        }

        _createClass(Order, [{
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                this.setState({
                    channel: nextProps.channel
                });
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.checkPayStatusTimer && clearTimeout(this.checkPayStatusTimer);
                this.singleVerifyTimer && clearTimeout(this.singleVerifyTimer);
                this.timer && this.timer.destroy();
            }
        }, {
            key: 'onSelectPay',
            value: function onSelectPay(product, ext) {

                var returnUrl = window.location.href.replace(location.hash, '');
                var channel = this.state.channel;

                returnUrl = _cUrl2.default.addParam(returnUrl, {
                    paidfrom: encodeURIComponent(UP.Global.currentPathName),
                    productId: Number(product.configId),
                    channel: channel
                });

                var clientType = _cUrl2.default.query('clientType') || 'pcuplive';
                var data = {
                    purpose: 1, // 钻石
                    productId: Number(product.configId),
                    channel: this.state.channel,
                    tradeType: _config2.default[channel].tradeType,
                    tuid: Number(this.state.uid),
                    returnUrl: returnUrl,
                    clientType: clientType
                };

                if (ext) {
                    data.ext = JSON.stringify(ext);
                }

                this.submit(data, product);
            }

            // 微信支付
            // 二维码生成后的支付状态检验
            // 在组件销毁时要销毁此定时器

        }, {
            key: 'checkPayStatus',
            value: function checkPayStatus(orderId) {
                var _this2 = this;

                this.verify(orderId);
                this.checkPayStatusTimer = setTimeout(function () {
                    _this2.setState({
                        showQrcode: 0,
                        qrcodeUrl: ''
                    });
                    $.channel.emit('rechargeError');
                    // 销毁单此校验定时器
                    clearTimeout(_this2.singleVerifyTimer);
                }, 60 * 1000);

                this.timer && this.timer.destroy();
                this.timer = new _cTimer2.default({
                    remainTime: 60
                });

                this.timer.on('tick', function (e) {
                    _this2.setState({
                        remainTime: Math.floor(e.remainTime)
                    });
                });
            }

            // 校验订单是否已成功到账

        }, {
            key: 'verify',
            value: function verify(orderId) {
                var _this3 = this;

                if (!this.verifyOrder) {
                    this.verifyOrder = new _payresult2.default(orderId);
                } else {
                    // retry时会生成新的promise
                    this.verifyOrder.retry();
                }

                this.verifyOrder.promise.done(function (resp) {

                    _this3.setState({
                        showQrcode: 0,
                        qrcodeUrl: ''
                    });

                    _this3.verifyOrder = null;
                    clearTimeout(_this3.checkPayStatusTimer);
                    $.channel.emit('rechargeSuccess', resp);
                }).fail(function () {
                    _this3.singleVerifyTimer = setTimeout(function () {
                        _this3.verify(orderId);
                    }, 2000);
                });
            }
        }, {
            key: 'submit',
            value: function submit(data, product) {
                var _this4 = this;

                _cUpLoading2.default.show({
                    content: _lang2.default.template('正在购买')
                });

                var cacheOrderKey = '_u_orderId_' + data.productId;

                pbajax.do({
                    service: 'mall',
                    api: '/mall/pay/order',
                    inchina: 1,
                    header: {
                        lang: UP.Global.siteLanguage
                    }
                }, new _orderpb2.default.Mall.PayOrder.Request(data), function (res) {

                    _cUpLoading2.default.hide();
                    var dataWrap = _public2.default.Result.decode(res);

                    if (dataWrap.code == 1) {
                        var _data = _orderpb2.default.Mall.PayOrder.Response.decode(dataWrap.data.value);
                        var channel = _this4.state.channel;
                        var orderId = _data.orderInfo.orderId;

                        _this4.cache.setCache(cacheOrderKey, orderId);

                        switch (channel) {
                            case 'pepay_entitycard_thb':
                            case 'pepay_entitycard_idr':
                            case 'pepay_onlinebank_idr':
                            case 'pepay_alfamart_idr':
                            case 'pepay_webatm_idr':
                            case 'pepay_onlinebank_vnd':
                            case 'pepay_entitycard_vnd':
                            case 'paytm':
                            case 'gash':
                            case 'gash_card':
                                var backAddr = _data.h5;

                                var _backAddr$split = backAddr.split('?'),
                                    _backAddr$split2 = _slicedToArray(_backAddr$split, 2),
                                    actions = _backAddr$split2[0],
                                    attrs = _backAddr$split2[1];

                                if (attrs) {
                                    var arr = attrs.split('&');

                                    arr = arr.map(function (item, i) {
                                        var firstEqIdx = item.indexOf('=');
                                        var key = item.substr(0, firstEqIdx);
                                        var v = item.substr(firstEqIdx + 1);
                                        return '<input type="hidden" name="' + key + '" value="' + v + '" />';
                                    });

                                    var forms = ['<form method="post" action="' + actions + '">'].concat(_toConsumableArray(arr), ['</form>']);
                                    var $form = $(forms.join(''));
                                    $(document.body).append($form);

                                    $form[0].submit();
                                }
                                break;
                            case 'alipay':
                                var form = $(_data.alipay);

                                $(document.body).append(form);

                                setTimeout(function () {
                                    document.forms[0].submit();
                                });

                                break;
                            case 'wxpay':
                                // 微信扫码支付
                                var code_url = JSON.parse(_data.wxpay).code_url;
                                var _orderId = _data.orderInfo.orderId;

                                _this4.setState({
                                    showQrcode: 1,
                                    qrcodeUrl: code_url
                                });
                                // 二维码生成后
                                // 60s内每2s请求一次验证接口
                                // 60s后用户未付款，提示充值失败并提示用户从新充值
                                // 验证通过后，调用通用的充值成功逻辑
                                _this4.checkPayStatus(_orderId);

                                break;
                            case 'sinopac_atm':
                                _bank2.default.create({
                                    orderId: _data.h5,
                                    product: product
                                });
                                break;
                            case 'pepay_credit':
                            case 'pepay_store_ibon_twd':
                            case 'pepay_store_fami_twd':
                            case 'pepay_store_hilifeet_twd':
                            case 'pepay_store_okgo_twd':
                                _ccnet2.default.create({
                                    data: _data,
                                    orderId: _data.orderInfo.orderId,
                                    product: product,
                                    orderBank: channel == 'pepay_credit' ? _lang2.default.template('CCNET-信用卡') : _lang2.default.template('CCNET-便利超商代收')
                                });
                                break;
                            case 'bk_atm':
                                var payUrl = _data.h5;

                                payUrl = payUrl.replace('zh-CN', 'vi-VN');
                                payUrl += '&web=3';

                                location.replace(payUrl);
                                break;
                            default:
                                location.replace(_data.h5);
                        }
                    } else if (dataWrap.code == 12293) {
                        _cNotification2.default.simple(_lang2.default.template('金额或次数限充'));
                    } else {
                        $.channel.emit('rechargeError', dataWrap.code);
                        // notification.simple(lang.template('下单失败'));
                    }
                }, function () {
                    _cUpLoading2.default.hide();

                    _cNotification2.default.simple(_lang2.default.template('网络连接有误, 请稍后再试'));
                });
            }
        }, {
            key: 'render',
            value: function render() {

                return _react2.default.createElement(ComposedComponent, _extends({}, this.state, { onSelectPay: this.onSelectPay.bind(this)
                }));
            }
        }]);

        return Order;
    }(_react.Component);

    Order.defaultProps = {
        uid: '', // 下单用户UID
        channel: '' // 使用的充值方式
    };


    return Order;
};

/***/ }),
/* 550 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Mall.PayOrder",
    "options": {
        "objc_class_prefix": "MallPayOrder",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Request",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "purpose",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "productId",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "channel",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "tradeType",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "tuid",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "returnUrl",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "clientType",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "platform",
            "id": 8
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "rewardType",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "rewardConfigId",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "ext",
            "id": 11
        }]
    }, {
        "name": "Response",
        "fields": [{
            "rule": "optional",
            "type": "OrderInfo",
            "name": "orderInfo",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "wxpay",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "iap",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "alipay",
            "id": 4
        }, {
            "rule": "optional",
            "type": "string",
            "name": "iab",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "h5",
            "id": 6
        }]
    }, {
        "name": "OrderInfo",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "orderId",
            "id": 1
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 551 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Mall.PayValidate",
    "options": {
        "objc_class_prefix": "MallPayValidate",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Request",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "orderId",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "receipt",
            "id": 2
        }]
    }, {
        "name": "Response",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "diamond",
            "id": 1
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _invoice = __webpack_require__(553);

var _invoice2 = _interopRequireDefault(_invoice);

var _result = __webpack_require__(554);

var _result2 = _interopRequireDefault(_result);

var _ScaleModal = __webpack_require__(12);

var _ScaleModal2 = _interopRequireDefault(_ScaleModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 充值二次确认弹出层
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var pbajax = new _pbajax2.default();

var noop = function noop() {};

var style = {
    modalStyle: {
        width: '500px'
    },
    contentStyle: {
        width: '500px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        backgroundColor: "rgba(0,0,0, 0.5)"
    }
};

var RechargePop = function (_Component) {
    _inherits(RechargePop, _Component);

    function RechargePop(props) {
        _classCallCheck(this, RechargePop);

        var _this = _possibleConstructorReturn(this, (RechargePop.__proto__ || Object.getPrototypeOf(RechargePop)).call(this, props));

        _this.state = {
            showType: 1 // 1: 确认信息；2: 发票明细；3：充值结果
        };
        return _this;
    }

    _createClass(RechargePop, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.showModal();
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            // 在隐藏动画执行完成之后再触发事件onConfirm
            if (this.status == 'confirm') {
                this.props.onConfirm();
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit() {
            this.setState({
                showType: 2
            });
        }
    }, {
        key: 'onSubmitSuccess',
        value: function onSubmitSuccess(accountId) {
            this.setState({
                showType: 3,
                accountId: accountId
            });
        }
    }, {
        key: 'onClose',
        value: function onClose() {
            this.hideModal();
            this.status = 'cancel';
        }
    }, {
        key: 'showModal',
        value: function showModal() {
            this.refs.modal.show();
        }
    }, {
        key: 'hideModal',
        value: function hideModal() {
            this.refs.modal.hide();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var userInfo = UP.Global.getUser();
            var product = this.props.product;
            var showType = this.state.showType;
            var $popcontent = void 0;

            if (showType == 1) {
                $popcontent = _react2.default.createElement(
                    'div',
                    { className: 'bank-pop bank-confirm-pop' },
                    _react2.default.createElement(
                        'div',
                        { className: 'bank-pop-hd' },
                        _react2.default.createElement(
                            'h2',
                            null,
                            _lang2.default.template('儲值訊息')
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'close', onClick: function onClick() {
                                    return _this2.hideModal();
                                } },
                            'x'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'bank-pop-bd' },
                        _react2.default.createElement(
                            'dl',
                            { className: 'detail-info' },
                            _react2.default.createElement(
                                'dd',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    _lang2.default.template('儲值訊息：')
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'txt' },
                                    userInfo.username,
                                    ' ( ',
                                    _lang2.default.template('Up帳號：<%=code%>', { code: userInfo.upliveCode }),
                                    ')'
                                )
                            ),
                            _react2.default.createElement(
                                'dd',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    _lang2.default.template('儲值額度：')
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'txt' },
                                    _react2.default.createElement(
                                        'em',
                                        null,
                                        product.amount
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'dd',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { className: 'title' },
                                    _lang2.default.template('需匯款')
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'money' },
                                    product.currencySymbol,
                                    product.money / 100
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'banklist' },
                            _react2.default.createElement(
                                'h3',
                                null,
                                _lang2.default.template('選擇銀行')
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement('input', { className: 'channel-input', type: 'radio', defaultChecked: 'checked', readyOnly: true }),
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        _lang2.default.template('永豐銀行')
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'bank-pop-ft' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn confirm', onClick: function onClick() {
                                    return _this2.handleSubmit();
                                } },
                            _lang2.default.template('確認儲值')
                        )
                    )
                );
            } else if (showType == 2) {
                $popcontent = _react2.default.createElement(_invoice2.default, { orderBank: this.props.orderBank, orderId: this.props.orderId, product: this.props.product, onClose: this.onClose.bind(this), onSubmitSuccess: this.onSubmitSuccess.bind(this) });
            } else {
                $popcontent = _react2.default.createElement(_result2.default, { orderBank: this.props.orderBank, accountId: this.state.accountId, product: this.props.product, onClose: this.onClose.bind(this) });
            }

            return _react2.default.createElement(
                _ScaleModal2.default,
                {
                    ref: 'modal',
                    closeOnClick: false,
                    onHide: this.onHide.bind(this),
                    modalStyle: style.modalStyle,
                    backdropStyle: style.backdropStyle,
                    contentStyle: style.contentStyle
                },
                $popcontent
            );
        }
    }]);

    return RechargePop;
}(_react.Component);

RechargePop.defaultProps = {
    content: '',
    product: {},
    orderBank: _lang2.default.template('永豐銀行'),
    orderId: '', // 下单的订单号
    onHide: noop
};


module.exports = {
    create: function create(cfg) {
        cfg = cfg || {};

        if (this.layer) {
            this.destroy();
        }
        var mountNode = this.createMountNode();

        this.layer = _reactDom2.default.render(_react2.default.createElement(RechargePop, _extends({}, cfg, { onHide: this.onHide.bind(this) })), mountNode);
    },
    onHide: function onHide() {
        this.destroy();
    },
    // 创建组件插入的DOM节点
    createMountNode: function createMountNode() {
        this.mountNode = document.createElement("div");
        $(document.body).append(this.mountNode);
        return this.mountNode;
    },
    destroy: function destroy() {
        _reactDom2.default.unmountComponentAtNode(this.mountNode);
        $(this.mountNode).remove();
        delete this.layer;
    }
};

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _cNotification = __webpack_require__(11);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _cUpLoading = __webpack_require__(13);

var _cUpLoading2 = _interopRequireDefault(_cUpLoading);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _ScaleModal = __webpack_require__(12);

var _ScaleModal2 = _interopRequireDefault(_ScaleModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var pbajax = new _pbajax2.default();

// 发票信息

var InvoiceInfo = function (_Component) {
    _inherits(InvoiceInfo, _Component);

    function InvoiceInfo(props) {
        _classCallCheck(this, InvoiceInfo);

        var _this = _possibleConstructorReturn(this, (InvoiceInfo.__proto__ || Object.getPrototypeOf(InvoiceInfo)).call(this, props));

        _this.handleSubmit = function () {
            var vr = _this.verifyForm();

            if (vr === true) {
                // 验证通过，提交发票信息
                _this.submit();
            } else {
                _cNotification2.default.simple(vr);
            }
        };

        _this.onInputChange = function (key, e) {
            _this.setValue(key, e.target.value.trim());
            _this.verifyForm();
        };

        _this.onSelectType = function (type) {
            if (type == _this.state.invoiceType) {
                return;
            }
            _this.setState({
                invoiceType: type
            });
        };

        _this.state = {
            btnCanSubmitType2: 0,
            btnCanSubmitType1: 0,
            invoiceType: 2,
            visible: 0, // 显示类型 0 不显示；1 显示
            email: '',
            realname: '',
            address: '',
            mobile: ''
        };
        return _this;
    }

    _createClass(InvoiceInfo, [{
        key: 'verifyForm',
        value: function verifyForm() {
            var type = this.state.invoiceType;
            var email = this.state.email;
            var realname = this.state.realname;
            var address = this.state.address;
            var mobile = this.state.mobile;

            var emailReg = /^([\.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
            var result = true;

            if (type == 1) {
                // 索取发票
                if (!emailReg.test(email)) {
                    result = _lang2.default.template("請輸入正確的信箱");
                }
                if (realname == '') {
                    result = _lang2.default.template('請輸入真實姓名');
                }

                if (address == '') {
                    result = _lang2.default.template('請輸入住宅地址');
                }

                if (mobile == '') {
                    result = _lang2.default.template('請輸入手機號碼');
                }
            } else {
                if (!emailReg.test(email)) {
                    result = _lang2.default.template("請輸入e-mail地址");
                }
            }

            var obj = this.state;

            obj['btnCanSubmitType' + this.state.invoiceType] = result === true ? 1 : 0;

            this.setState(obj);

            return result;
        }
    }, {
        key: 'setValue',
        value: function setValue(key, value) {
            var obj = this.state;

            obj[key] = value;

            this.setState(obj);
        }
    }, {
        key: 'getInvoiceAPI',
        value: function getInvoiceAPI() {
            var originMap = {
                stage: 'http://payment-test.upliveapps.com',
                pro: 'https://payment.upliveapps.com',
                dev: 'http://payment-test.upliveapps.com'
                // 当前开发环境
            };var env = _cUrl2.default.query('env');

            if (!env || env == 'null') {
                env = 'pro';
            }
            return originMap[env] || originMap['pro'];
        }
    }, {
        key: 'submit',
        value: function submit() {
            var _this2 = this;

            var userInfo = UP.Global.getUser();

            var data = {
                uid: userInfo.uid,
                platform: 'uplive', // 洋妞版本。银行汇款
                order_id: this.props.orderId,
                pay_bank: this.props.orderBank,
                invoice_type: this.state.invoiceType,
                email: this.state.email,
                t: +new Date()
            };

            if (this.state.invoiceType == 1) {
                // 索要
                Object.assign(data, {
                    real_name: this.state.realname,
                    address: this.state.address,
                    mobile: this.state.mobile
                });
            }

            var failCount = 0;

            var pushInvoice = function pushInvoice(data) {
                var promise = $.ajax({
                    url: _this2.getInvoiceAPI() + '/push/invoice',
                    data: data,
                    type: 'POST',
                    timeout: 5 * 1000,
                    dataType: 'json'
                });

                promise.done(function (res) {
                    if (res.return_code == "SUCCESS") {
                        _cUpLoading2.default.hide();
                        _this2.showBankResult(res.pay_no);
                    } else {
                        ++failCount;

                        if (failCount > 3) {
                            _cUpLoading2.default.hide();
                            _cNotification2.default.simple(res.return_code);
                        } else {
                            pushInvoice(data);
                        }
                    }
                });

                promise.fail(function () {
                    ++failCount;

                    if (failCount > 3) {
                        _cUpLoading2.default.hide();
                    } else {
                        pushInvoice(data);
                    }
                });
            };

            _cUpLoading2.default.show();

            pushInvoice(data);
        }
    }, {
        key: 'showBankResult',
        value: function showBankResult(accountId) {
            this.props.onSubmitSuccess(accountId);
        }
    }, {
        key: 'onClose',
        value: function onClose() {
            this.props.onClose();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var disabled = this.state['btnCanSubmitType' + this.state.invoiceType] ? '' : 'disabled';
            var $content = void 0;

            if (this.state.invoiceType == 2) {
                $content = _react2.default.createElement(
                    'div',
                    { className: 'input-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'input-wrap' },
                        _react2.default.createElement('input', { type: 'text', placeholder: _lang2.default.template('請輸入e-mail地址'), value: this.state.email, name: 'email', ref: 'email', onChange: this.onInputChange.bind(this, 'email') })
                    )
                );
            } else {
                $content = _react2.default.createElement(
                    'div',
                    { className: 'input-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'input-wrap' },
                        _react2.default.createElement('input', { type: 'text', placeholder: _lang2.default.template('請輸入真實姓名'), value: this.state.realname, name: 'realname', ref: 'realname', onChange: this.onInputChange.bind(this, 'realname') }),
                        _react2.default.createElement('input', { type: 'text', placeholder: _lang2.default.template('請輸入住宅地址'), value: this.state.address, name: 'address', ref: 'address', onChange: this.onInputChange.bind(this, 'address') }),
                        _react2.default.createElement('input', { type: 'text', placeholder: _lang2.default.template('請輸入手機號碼'), value: this.state.mobile, name: 'mobile', ref: 'mobile', onChange: this.onInputChange.bind(this, 'mobile') }),
                        _react2.default.createElement('input', { type: 'text', placeholder: _lang2.default.template('請輸入e-mail地址'), value: this.state.email, name: 'email', ref: 'email', onChange: this.onInputChange.bind(this, 'email') })
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'bank-pop bank-invoice-pop' },
                _react2.default.createElement(
                    'div',
                    { className: 'bank-pop-hd' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        _lang2.default.template('發票明細')
                    ),
                    _react2.default.createElement('div', { className: 'close', onClick: this.onClose.bind(this) })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'bank-pop-bd' },
                    _react2.default.createElement(
                        'div',
                        { className: 'tab-container' },
                        _react2.default.createElement(
                            'ul',
                            { className: 'tab-nav' },
                            this.props.invoiceTypeList.map(function (item, index) {
                                var selected = item.type == _this3.state.invoiceType ? 'selected' : '';

                                return _react2.default.createElement(
                                    'li',
                                    { key: index, className: 'tab ' + selected, onClick: _this3.onSelectType.bind(_this3, item.type) },
                                    item.text
                                );
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'tab-panel' },
                            $content,
                            _react2.default.createElement(
                                'ul',
                                { className: 'notice' },
                                _react2.default.createElement('li', { dangerouslySetInnerHTML: { __html: _lang2.default.template('<em>1.慈善捐贈：</em>我們會將您的愛心傳遞給社會財團法人中華民國保護動物協會，謝謝您！網址：http://apate.org/') } }),
                                _react2.default.createElement('li', { dangerouslySetInnerHTML: { __html: _lang2.default.template('<em>2.索取發票：</em>我們將於15個工作天內郵寄給您發票！') } })
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'bank-pop-ft' },
                    _react2.default.createElement(
                        'div',
                        { className: 'btn ' + disabled, onClick: this.handleSubmit },
                        _lang2.default.template('確定')
                    )
                )
            );
        }
    }]);

    return InvoiceInfo;
}(_react.Component);

InvoiceInfo.defaultProps = {
    invoiceTypeList: [{
        type: 2,
        text: _lang2.default.template('慈善捐款')
    }, {
        type: 1,
        text: _lang2.default.template('索取發票')
    }],
    product: null,
    orderBank: '',
    orderId: '',
    onClose: function onClose() {}
};
exports.default = InvoiceInfo;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _notice = __webpack_require__(555);

var _notice2 = _interopRequireDefault(_notice);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BankSuccess = function (_Component) {
    _inherits(BankSuccess, _Component);

    function BankSuccess() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, BankSuccess);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BankSuccess.__proto__ || Object.getPrototypeOf(BankSuccess)).call.apply(_ref, [this].concat(args))), _this), _this.popUpNotice = function () {
            _notice2.default.create();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(BankSuccess, [{
        key: 'onClose',
        value: function onClose() {
            this.props.onClose();
        }
    }, {
        key: 'render',
        value: function render() {
            var product = this.props.product || {};

            return _react2.default.createElement(
                'div',
                { className: 'bank-pop bank-result-pop' },
                _react2.default.createElement(
                    'div',
                    { className: 'bank-pop-hd' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        _lang2.default.template('匯款帳號訊息')
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'close', onClick: this.onClose.bind(this) },
                        'x'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'bank-pop-bd' },
                    _react2.default.createElement(
                        'div',
                        { className: 'content' },
                        _react2.default.createElement(
                            'h3',
                            null,
                            status
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'bank-info' },
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        _lang2.default.template('銀行代碼')
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'info' },
                                        '807'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        _lang2.default.template('銀行名稱')
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'info' },
                                        this.props.orderBank
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        _lang2.default.template('戶名')
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'info' },
                                        _lang2.default.template('網易收服務ATM專戶')
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        _lang2.default.template('匯款帳號')
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'info' },
                                        this.props.accountId
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        _lang2.default.template('匯款金額')
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'info' },
                                        product.currencySymbol,
                                        product.money / 100
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'notice' },
                            _lang2.default.template('請您於24小時內通過線下銀行匯款的方式轉帳至上述銀行帳戶，逾期將無法付款成功')
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'bank-pop-ft' },
                    _react2.default.createElement(
                        'div',
                        { className: 'btn', onClick: this.onClose.bind(this) },
                        _lang2.default.template('確定')
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'notice-title', onClick: this.popUpNotice },
                        _lang2.default.template('匯款注意事項')
                    )
                )
            );
        }
    }]);

    return BankSuccess;
}(_react.Component);

BankSuccess.defaultPorps = {
    product: null,
    accountId: '',
    orderBank: '',
    onClose: function onClose() {}
};
exports.default = BankSuccess;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _ScaleModal = __webpack_require__(12);

var _ScaleModal2 = _interopRequireDefault(_ScaleModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 银行发票信息
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var noop = function noop() {};

var style = {
	modalStyle: {
		width: '500px'
	},
	contentStyle: {
		width: '500px',
		borderRadius: '6px',
		backgroundColor: '#fff',
		outline: 0
	},
	backdropStyle: {
		backgroundColor: "rgba(0,0,0, 0.5)"
	}
};

var NoticePop = function (_Component) {
	_inherits(NoticePop, _Component);

	function NoticePop() {
		_classCallCheck(this, NoticePop);

		return _possibleConstructorReturn(this, (NoticePop.__proto__ || Object.getPrototypeOf(NoticePop)).apply(this, arguments));
	}

	_createClass(NoticePop, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.showModal();
		}
	}, {
		key: 'showModal',
		value: function showModal() {
			this.refs.modal.show();
		}
	}, {
		key: 'hideModal',
		value: function hideModal() {
			this.refs.modal.hide();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_ScaleModal2.default,
				{
					ref: 'modal',
					modalStyle: style.modalStyle,
					backdropStyle: style.backdropStyle,
					contentStyle: style.contentStyle
				},
				_react2.default.createElement(
					'div',
					{ className: 'bank-pop' },
					_react2.default.createElement(
						'div',
						{ className: 'bank-pop-hd' },
						_react2.default.createElement(
							'h2',
							null,
							_lang2.default.template('匯款注意事項')
						),
						_react2.default.createElement(
							'div',
							{ className: 'close', onClick: function onClick() {
									return _this2.hideModal();
								} },
							'x'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'bank-pop-bd' },
						_react2.default.createElement(
							'dl',
							{ className: 'notes' },
							_react2.default.createElement(
								'dt',
								null,
								_lang2.default.template('注意事項：')
							),
							_react2.default.createElement('dd', { dangerouslySetInnerHTML: { __html: _lang2.default.template("使用任一銀行金融卡在跨行 ATM 提款機轉帳為15元手續費。@@@@使用任一銀行金融卡在非跨行 ATM 提款機轉帳為0元手續費。@@@@虛擬帳號從生成之時起在24小時內有效，超時則無法付款成功。@@@@全年無休，24小時可用。@@@@分行別為：永豐銀行台北分行") } })
						),
						_react2.default.createElement(
							'dl',
							{ className: 'notes' },
							_react2.default.createElement(
								'dt',
								null,
								_lang2.default.template('儲值服務時間：')
							),
							_react2.default.createElement('dd', { className: 'time-info', dangerouslySetInnerHTML: { __html: _lang2.default.template("銀行APP匯款儲值轉帳時間24小時@@@@網路銀行匯款儲值轉帳時間 24小時@@@@ATM轉帳儲值時間 24小時@@@@銀行臨櫃匯款儲值轉帳時間 9:00 - 15:30@@@@郵局匯款儲值轉帳時間 8:00 - 17:00") } }),
							_react2.default.createElement('dd', { dangerouslySetInnerHTML: { __html: _lang2.default.template("銀行網路匯款儲值、ATM儲值一般15~60分鐘內到帳，其餘儲值方式的到帳時間為：周一到周四15:30 後匯款需隔天到帳，周五15 : 30 後匯款需下周一到帳。@@@@為維護自身權益，轉帳完成後請保留匯款單據。@@@@儲值過程中如果遇到任何問題，請聯繫我們客服。@@@@儲值金額將一次性轉為平台貨幣，無法分開帳號或同一帳號分多次儲值。") } })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'bank-pop-ft' },
						_react2.default.createElement(
							'button',
							{ className: 'btn confirm', onClick: function onClick() {
									return _this2.hideModal();
								} },
							_lang2.default.template('我了解')
						)
					)
				)
			);
		}
	}]);

	return NoticePop;
}(_react.Component);

module.exports = {
	create: function create(cfg) {
		cfg = cfg || {};

		if (this.layer) {
			this.destroy();
		}
		var mountNode = this.createMountNode();

		this.layer = _reactDom2.default.render(_react2.default.createElement(NoticePop, _extends({}, cfg, { onHide: this.onHide.bind(this) })), mountNode);
	},
	onHide: function onHide() {
		if (this.layer) {
			this.destroy();
		}
	},
	// 创建组件插入的DOM节点
	createMountNode: function createMountNode() {
		this.mountNode = document.createElement("div");
		$(document.body).append(this.mountNode);
		return this.mountNode;
	},
	// 销毁弹出层
	destroy: function destroy() {
		_reactDom2.default.unmountComponentAtNode(this.mountNode);
		$(this.mountNode).remove();
		delete this.layer;
	}
};

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _invoice = __webpack_require__(557);

var _invoice2 = _interopRequireDefault(_invoice);

var _ScaleModal = __webpack_require__(12);

var _ScaleModal2 = _interopRequireDefault(_ScaleModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 充值二次确认弹出层
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var pbajax = new _pbajax2.default();

var noop = function noop() {};

var style = {
    modalStyle: {
        width: '500px'
    },
    contentStyle: {
        width: '500px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        backgroundColor: "rgba(0,0,0, 0.5)"
    }
};

var RechargePop = function (_Component) {
    _inherits(RechargePop, _Component);

    function RechargePop(props) {
        _classCallCheck(this, RechargePop);

        var _this = _possibleConstructorReturn(this, (RechargePop.__proto__ || Object.getPrototypeOf(RechargePop)).call(this, props));

        _this.state = {
            showType: 1 // 1: 确认信息；2: 发票明细；3：充值结果
        };
        return _this;
    }

    _createClass(RechargePop, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.showModal();
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            // 在隐藏动画执行完成之后再触发事件onConfirm
            if (this.status == 'confirm') {
                this.props.onConfirm();
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit() {
            this.setState({
                showType: 2
            });
        }
    }, {
        key: 'onSubmitSuccess',
        value: function onSubmitSuccess() {
            var data = this.props.data;
            var backAddr = data.h5;

            var _backAddr$split = backAddr.split('?'),
                _backAddr$split2 = _slicedToArray(_backAddr$split, 2),
                actions = _backAddr$split2[0],
                attrs = _backAddr$split2[1];

            if (attrs) {
                var arr = attrs.split('&');
                // let inputs = [];

                arr = arr.map(function (item, i) {
                    // let [key, v] = item.split('=');

                    // 由于此处参数的值有可能是md5加密串，有一定概率会出现多个等于号，后端没有转义,
                    // 这会扰乱正常的参数取值，java无法修改历史渠道，要求前端处理
                    // 此处改成切割第一个等于号的方式获取key和value
                    var firstEqIdx = item.indexOf('=');
                    var key = item.substr(0, firstEqIdx);
                    var v = item.substr(firstEqIdx + 1);
                    return '<input type="hidden" name="' + key + '" value="' + v + '" />';
                });

                var forms = ['<form method="post" action="' + actions + '">'].concat(_toConsumableArray(arr), ['</form>']);
                var $form = $(forms.join(''));
                $(document.body).append($form);

                $form[0].submit();
            }
        }
    }, {
        key: 'onClose',
        value: function onClose() {
            this.hideModal();
            this.status = 'cancel';
        }
    }, {
        key: 'showModal',
        value: function showModal() {
            this.refs.modal.show();
        }
    }, {
        key: 'hideModal',
        value: function hideModal() {
            this.refs.modal.hide();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var userInfo = UP.Global.getUser();
            var product = this.props.product;
            var showType = this.state.showType;
            var $popcontent = void 0;

            if (showType == 1) {
                $popcontent = _react2.default.createElement(
                    'div',
                    { className: 'bank-pop bank-confirm-pop' },
                    _react2.default.createElement(
                        'div',
                        { className: 'bank-pop-hd' },
                        _react2.default.createElement(
                            'h2',
                            null,
                            _lang2.default.template('儲值訊息')
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'close', onClick: function onClick() {
                                    return _this2.hideModal();
                                } },
                            'x'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'bank-pop-bd' },
                        _react2.default.createElement(
                            'dl',
                            { className: 'detail-info' },
                            _react2.default.createElement(
                                'dd',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    _lang2.default.template('儲值訊息：')
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'txt' },
                                    userInfo.username,
                                    ' ( ',
                                    _lang2.default.template('Up帳號：<%=code%>', { code: userInfo.upliveCode }),
                                    ')'
                                )
                            ),
                            _react2.default.createElement(
                                'dd',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    _lang2.default.template('儲值額度：')
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'txt' },
                                    _react2.default.createElement(
                                        'em',
                                        null,
                                        product.amount
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'dd',
                                null,
                                _react2.default.createElement(
                                    'label',
                                    { className: 'title' },
                                    _lang2.default.template('需匯款')
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'money' },
                                    product.currencySymbol,
                                    product.money / 100
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'banklist' },
                            _react2.default.createElement(
                                'h3',
                                null,
                                _lang2.default.template('選擇')
                            ),
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement('input', { className: 'channel-input', type: 'radio', defaultChecked: 'checked', readyOnly: true }),
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        this.props.orderBank
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'bank-pop-ft' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn confirm', onClick: function onClick() {
                                    return _this2.handleSubmit();
                                } },
                            _lang2.default.template('確認儲值')
                        )
                    )
                );
            } else if (showType == 2) {
                $popcontent = _react2.default.createElement(_invoice2.default, { orderBank: this.props.orderBank, orderId: this.props.orderId, product: this.props.product, onClose: this.onClose.bind(this), onSubmitSuccess: this.onSubmitSuccess.bind(this) });
            }

            return _react2.default.createElement(
                _ScaleModal2.default,
                {
                    ref: 'modal',
                    closeOnClick: false,
                    onHide: this.onHide.bind(this),
                    modalStyle: style.modalStyle,
                    backdropStyle: style.backdropStyle,
                    contentStyle: style.contentStyle
                },
                $popcontent
            );
        }
    }]);

    return RechargePop;
}(_react.Component);

RechargePop.defaultProps = {
    content: '',
    product: {},
    orderBank: _lang2.default.template('永豐銀行'),
    orderId: '', // 下单的订单号
    onHide: noop
};


module.exports = {
    create: function create(cfg) {
        cfg = cfg || {};

        if (this.layer) {
            this.destroy();
        }
        var mountNode = this.createMountNode();

        this.layer = _reactDom2.default.render(_react2.default.createElement(RechargePop, _extends({}, cfg, { onHide: this.onHide.bind(this) })), mountNode);
    },
    onHide: function onHide() {
        this.destroy();
    },
    // 创建组件插入的DOM节点
    createMountNode: function createMountNode() {
        this.mountNode = document.createElement("div");
        $(document.body).append(this.mountNode);
        return this.mountNode;
    },
    destroy: function destroy() {
        _reactDom2.default.unmountComponentAtNode(this.mountNode);
        $(this.mountNode).remove();
        delete this.layer;
    }
};

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _cNotification = __webpack_require__(11);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _cUpLoading = __webpack_require__(13);

var _cUpLoading2 = _interopRequireDefault(_cUpLoading);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _ScaleModal = __webpack_require__(12);

var _ScaleModal2 = _interopRequireDefault(_ScaleModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var pbajax = new _pbajax2.default();

// 发票信息

var InvoiceInfo = function (_Component) {
    _inherits(InvoiceInfo, _Component);

    function InvoiceInfo(props) {
        _classCallCheck(this, InvoiceInfo);

        var _this = _possibleConstructorReturn(this, (InvoiceInfo.__proto__ || Object.getPrototypeOf(InvoiceInfo)).call(this, props));

        _this.handleSubmit = function () {
            var vr = _this.verifyForm();

            if (vr === true) {
                // 验证通过，提交发票信息
                _this.submit();
            } else {
                _cNotification2.default.simple(vr);
            }
        };

        _this.onInputChange = function (key, e) {
            _this.setValue(key, e.target.value.trim());
            _this.verifyForm();
        };

        _this.onSelectType = function (type) {
            if (type == _this.state.invoiceType) {
                return;
            }
            _this.setState({
                invoiceType: type
            });
        };

        _this.state = {
            btnCanSubmitType2: 0,
            btnCanSubmitType1: 0,
            invoiceType: 2,
            visible: 0, // 显示类型 0 不显示；1 显示
            email: '',
            realname: '',
            address: '',
            mobile: ''
        };
        return _this;
    }

    _createClass(InvoiceInfo, [{
        key: 'verifyForm',
        value: function verifyForm() {
            var type = this.state.invoiceType;
            var email = this.state.email;
            var realname = this.state.realname;
            var address = this.state.address;
            var mobile = this.state.mobile;

            var emailReg = /^([\.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
            var result = true;

            if (type == 1) {
                // 索取发票
                if (!emailReg.test(email)) {
                    result = _lang2.default.template("請輸入正確的信箱");
                }
                if (realname == '') {
                    result = _lang2.default.template('請輸入真實姓名');
                }

                if (address == '') {
                    result = _lang2.default.template('請輸入住宅地址');
                }

                if (mobile == '') {
                    result = _lang2.default.template('請輸入手機號碼');
                }
            } else {
                if (!emailReg.test(email)) {
                    result = _lang2.default.template("請輸入e-mail地址");
                }
            }

            var obj = this.state;

            obj['btnCanSubmitType' + this.state.invoiceType] = result === true ? 1 : 0;

            this.setState(obj);

            return result;
        }
    }, {
        key: 'setValue',
        value: function setValue(key, value) {
            var obj = this.state;

            obj[key] = value;

            this.setState(obj);
        }
    }, {
        key: 'getInvoiceAPI',
        value: function getInvoiceAPI() {
            var originMap = {
                stage: 'http://payment-test.upliveapps.com',
                pro: 'https://payment.upliveapps.com',
                dev: 'http://payment-test.upliveapps.com'
                // 当前开发环境
            };var env = _cUrl2.default.query('env');

            if (!env || env == 'null') {
                env = 'pro';
            }
            return originMap[env] || originMap['pro'];
        }
    }, {
        key: 'submit',
        value: function submit() {
            var _this2 = this;

            var userInfo = UP.Global.getUser();

            var data = {
                uid: userInfo.uid,
                platform: 'uplive', // 洋妞版本。银行汇款
                order_id: this.props.orderId,
                pay_bank: this.props.orderBank,
                invoice_type: this.state.invoiceType,
                email: this.state.email,
                t: +new Date()
            };

            if (this.state.invoiceType == 1) {
                // 索要
                Object.assign(data, {
                    real_name: this.state.realname,
                    address: this.state.address,
                    mobile: this.state.mobile
                });
            }

            var failCount = 0;

            var pushInvoice = function pushInvoice(data) {
                var promise = $.ajax({
                    url: _this2.getInvoiceAPI() + '/push/invoice',
                    data: data,
                    type: 'POST',
                    timeout: 5 * 1000,
                    dataType: 'json'
                });

                promise.done(function (res) {
                    if (res.return_code == "SUCCESS") {
                        _cUpLoading2.default.hide();
                        _this2.props.onSubmitSuccess();
                    } else {
                        ++failCount;

                        if (failCount > 3) {
                            _cUpLoading2.default.hide();
                            _cNotification2.default.simple(res.return_code);
                        } else {
                            pushInvoice(data);
                        }
                    }
                });

                promise.fail(function () {
                    ++failCount;

                    if (failCount > 3) {
                        _cUpLoading2.default.hide();
                    } else {
                        pushInvoice(data);
                    }
                });
            };

            _cUpLoading2.default.show();

            pushInvoice(data);
        }
    }, {
        key: 'onClose',
        value: function onClose() {
            this.props.onClose();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var disabled = this.state['btnCanSubmitType' + this.state.invoiceType] ? '' : 'disabled';
            var $content = void 0;

            if (this.state.invoiceType == 2) {
                $content = _react2.default.createElement(
                    'div',
                    { className: 'input-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'input-wrap' },
                        _react2.default.createElement('input', { type: 'text', placeholder: _lang2.default.template('請輸入e-mail地址'), value: this.state.email, name: 'email', ref: 'email', onChange: this.onInputChange.bind(this, 'email') })
                    )
                );
            } else {
                $content = _react2.default.createElement(
                    'div',
                    { className: 'input-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'input-wrap' },
                        _react2.default.createElement('input', { type: 'text', placeholder: _lang2.default.template('請輸入真實姓名'), value: this.state.realname, name: 'realname', ref: 'realname', onChange: this.onInputChange.bind(this, 'realname') }),
                        _react2.default.createElement('input', { type: 'text', placeholder: _lang2.default.template('請輸入住宅地址'), value: this.state.address, name: 'address', ref: 'address', onChange: this.onInputChange.bind(this, 'address') }),
                        _react2.default.createElement('input', { type: 'text', placeholder: _lang2.default.template('請輸入手機號碼'), value: this.state.mobile, name: 'mobile', ref: 'mobile', onChange: this.onInputChange.bind(this, 'mobile') }),
                        _react2.default.createElement('input', { type: 'text', placeholder: _lang2.default.template('請輸入e-mail地址'), value: this.state.email, name: 'email', ref: 'email', onChange: this.onInputChange.bind(this, 'email') })
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'bank-pop bank-invoice-pop' },
                _react2.default.createElement(
                    'div',
                    { className: 'bank-pop-hd' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        _lang2.default.template('發票明細')
                    ),
                    _react2.default.createElement('div', { className: 'close', onClick: this.onClose.bind(this) })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'bank-pop-bd' },
                    _react2.default.createElement(
                        'div',
                        { className: 'tab-container' },
                        _react2.default.createElement(
                            'ul',
                            { className: 'tab-nav' },
                            this.props.invoiceTypeList.map(function (item, index) {
                                var selected = item.type == _this3.state.invoiceType ? 'selected' : '';

                                return _react2.default.createElement(
                                    'li',
                                    { key: index, className: 'tab ' + selected, onClick: _this3.onSelectType.bind(_this3, item.type) },
                                    item.text
                                );
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'tab-panel' },
                            $content,
                            _react2.default.createElement(
                                'ul',
                                { className: 'notice' },
                                _react2.default.createElement('li', { dangerouslySetInnerHTML: { __html: _lang2.default.template('<em>1.慈善捐贈：</em>我們會將您的愛心傳遞給社會財團法人中華民國保護動物協會，謝謝您！網址：http://apate.org/') } }),
                                _react2.default.createElement('li', { dangerouslySetInnerHTML: { __html: _lang2.default.template('<em>2.索取發票：</em>我們將於15個工作天內郵寄給您發票！') } })
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'bank-pop-ft' },
                    _react2.default.createElement(
                        'div',
                        { className: 'btn ' + disabled, onClick: this.handleSubmit },
                        _lang2.default.template('確定')
                    )
                )
            );
        }
    }]);

    return InvoiceInfo;
}(_react.Component);

InvoiceInfo.defaultProps = {
    invoiceTypeList: [{
        type: 2,
        text: _lang2.default.template('慈善捐款')
    }, {
        type: 1,
        text: _lang2.default.template('索取發票')
    }],
    product: null,
    orderBank: '',
    orderId: '',
    onClose: function onClose() {}
};
exports.default = InvoiceInfo;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _optionListView = __webpack_require__(559);

var _optionListView2 = _interopRequireDefault(_optionListView);

var _optionListGenerator = __webpack_require__(564);

var _optionListGenerator2 = _interopRequireDefault(_optionListGenerator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _optionListGenerator2.default)(_optionListView2.default);

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cNotification = __webpack_require__(11);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _optionItem = __webpack_require__(560);

var _optionItem2 = _interopRequireDefault(_optionItem);

var _commonPopup = __webpack_require__(561);

var _commonPopup2 = _interopRequireDefault(_commonPopup);

var _icardConfirm = __webpack_require__(563);

var _icardConfirm2 = _interopRequireDefault(_icardConfirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 充值档列表视图
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var OptionListView = function (_Component) {
    _inherits(OptionListView, _Component);

    function OptionListView(props) {
        _classCallCheck(this, OptionListView);

        var _this = _possibleConstructorReturn(this, (OptionListView.__proto__ || Object.getPrototypeOf(OptionListView)).call(this, props));

        _this.onSelectPay = function (data) {
            if (_this.state.showQrcode == 1) {
                return;
            }
            _this.setState({
                selection: data
            });
        };

        _this.handleOrder = function (e) {

            if (!UP.Global.isRegisterRealUser()) {
                return $.channel.emit('login');
            }
            /*----  埋点 ---*/
            UP.Global.DA.add({
                eventName: 'UplivePayment',
                action: 'ClickOrderButton',
                label: _this.props.channel,
                value: _this.state.selection.amount
            });

            var nodeScroll = $('#rechargeScroller');

            if (nodeScroll) {
                var item = _this.state.selection;
                var paymentValue = {
                    channel: _this.props.channel,
                    amount: item.amount,
                    money: item.money,
                    currency: item.currency
                };
                if (nodeScroll.attr('data-type') == 'page') {
                    UP.Global.DA.add({
                        eventName: 'RechargeDesktopPayment',
                        action: 'Payment Request',
                        label: JSON.stringify(paymentValue)
                    });
                } else {
                    UP.Global.DA.add({
                        eventName: 'TopupDesktopPayment',
                        action: 'Payment Request',
                        label: JSON.stringify(paymentValue)
                    });
                }

                fbq('track', 'UplivePayment', {
                    channel: _this.props.channel,
                    amount: item.amount,
                    money: item.money,
                    currency: item.currency
                });
            }
            /*----  埋点 ---*/

            _this.props.onSelectPay(_this.state.selection);
        };

        _this.icardSubmitOrder = function (e) {
            if (!UP.Global.isRegisterRealUser()) {
                return $.channel.emit('login');
            }
            var self = _this;
            var $icardType = $(_this.refs.icardtype);
            var $icardValue = $(_this.refs.icardvalue);
            var type = $(_this.refs.icardtype).val().trim();
            var value = $(_this.refs.icardvalue).val().trim();
            var serial = $(_this.refs.icardserial).val().trim();
            var code = $(_this.refs.icardcode).val().trim();

            if (!serial) {

                _cNotification2.default.simple("Please enter serial of the card");
                return;
            }

            if (!code) {
                _cNotification2.default.simple("Please enter code of the card");
                return;
            }

            var contextProps = {
                type: _this.getSelectedText($icardType[0]),
                value: _this.getSelectedText($icardValue[0]),
                serial: serial,
                code: code
            };

            _commonPopup2.default.create(contextProps, _icardConfirm2.default, function (status) {
                if (status === 'confirm') {
                    self.props.onSelectPay(self.state.list[0], {
                        cardType: type,
                        cardValue: value,
                        serial: serial,
                        code: code
                    });
                }
            });
        };

        _this.onChangeIcardType = function (e) {
            var value = e.currentTarget.value;

            if (value == 1) {
                _this.refs.icardvalue.value = '50000';
                $(_this.refs.icard20).addClass('hidden');
            } else {
                _this.refs.icardvalue.value = '20000';
                $(_this.refs.icard20).removeClass('hidden');
            }
        };

        _this.onChangeIcardValue = function (e) {
            var value = e.currentTarget.value;
            console.log(value);
        };

        _this.state = {
            list: props.list,
            selection: props.list[0],
            showQrcode: props.showQrcode,
            qrcodeUrl: '',
            remainTime: 0
        };
        return _this;
    }

    _createClass(OptionListView, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.state.showQrcode !== nextProps.showQrcode) {
                this.setState({
                    showQrcode: nextProps.showQrcode,
                    qrcodeUrl: nextProps.qrcodeUrl
                }, function () {
                    if (this.state.showQrcode == 1) {
                        $('#wxQrPay').qrcode({
                            text: nextProps.qrcodeUrl,
                            width: 200,
                            height: 200,
                            render: 'canvas'
                        });

                        this.scrollQrcodeIntoView();
                    }
                });
            }

            this.setState({
                remainTime: nextProps.remainTime
            });
        }
    }, {
        key: 'scrollQrcodeIntoView',
        value: function scrollQrcodeIntoView() {
            var nodeScroll = $('#rechargeScroller');

            if (nodeScroll) {

                var nodeEl = $('#wxQrPay');
                var topPos = nodeEl.offset().top;

                if (nodeScroll.attr('data-type') == 'page') {
                    $(window).scrollTop(topPos);
                } else {
                    nodeScroll.scrollTop(topPos);
                }
            }
        }
    }, {
        key: 'getSelectedText',


        // icardSubmitOrder = (e)=>{
        //     let type = $(this.refs.icardtype).val().trim();
        //     let value = $(this.refs.icardvalue).val().trim();
        //     let serial = $(this.refs.icardserial).val().trim();
        //     let code = $(this.refs.icardcode).val().trim();
        //
        //
        //     if (!serial) {
        //
        //         notification.simple("Please enter serial of the card");
        //         return;
        //     }
        //
        //     if (!code) {
        //         notification.simple("Please enter code of the card");
        //         return;
        //     }
        //
        //     this.props.onSelectPay(this.state.list[0], {
        //         cardType: type,
        //         cardValue: value,
        //         serial: serial,
        //         code: code
        //     });
        // }

        // get the text content of selected option
        value: function getSelectedText(selectEl) {
            return selectEl.options[selectEl.selectedIndex].text;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                selection = _state.selection,
                list = _state.list;
            var channel = this.props.channel;

            var $list = [];
            var $extraHtml = void 0;
            var $button = void 0;
            var $tip = void 0;

            list.forEach(function (item, index) {
                var selectedCls = selection.configId == item.configId ? 'selected' : '';

                $list.push(_react2.default.createElement(
                    'li',
                    { className: selectedCls, key: index },
                    _react2.default.createElement(_optionItem2.default, { data: item, onSelectPay: _this2.onSelectPay })
                ));
            });

            if (channel == 'wxpay' && this.state.showQrcode == 1) {
                $extraHtml = _react2.default.createElement(
                    'div',
                    { className: 'qrcode-pay' },
                    _react2.default.createElement('div', { className: 'hd', dangerouslySetInnerHTML: { __html: _lang2.default.template('距离二维码过期还剩<%=count%>秒，过期后请刷新页面重新获取二维码', { count: this.state.remainTime }, 1) } }),
                    _react2.default.createElement(
                        'div',
                        { className: 'bd' },
                        _react2.default.createElement(
                            'div',
                            { className: 'qrcode' },
                            _react2.default.createElement('i', { id: 'wxQrPay' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'tip' },
                            _react2.default.createElement('i', null),
                            _react2.default.createElement('em', { dangerouslySetInnerHTML: { __html: _lang2.default.template("请使用微信扫一扫<br/>扫描二维码支付") } })
                        )
                    )
                );
            }

            // cashcard点卡充值，显示页面结构不同于其他渠道

            if (channel == 'pepay_entitycard_thb' || channel == 'pepay_entitycard_vnd' || channel == 'gash_card') {
                var real = void 0,
                    number = void 0,
                    sybol = void 0;

                if (list[0]) {
                    var _list$0$proportion$sp = list[0].proportion.split(':');

                    var _list$0$proportion$sp2 = _slicedToArray(_list$0$proportion$sp, 2);

                    real = _list$0$proportion$sp2[0];
                    number = _list$0$proportion$sp2[1];

                    sybol = list[0].currencySymbol.toUpperCase();
                }

                $list = _react2.default.createElement(
                    'div',
                    { className: 'option-list cashcard' },
                    _react2.default.createElement(
                        'h3',
                        { className: 'tips' },
                        _lang2.default.template('小贴士')
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'spectip' },
                        _react2.default.createElement(
                            'p',
                            { className: 'cash' },
                            _react2.default.createElement(
                                'em',
                                null,
                                '1.'
                            ),
                            ' ',
                            _lang2.default.template('使用CashCard充值的金额数以点卡实际支付的金额为准')
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: 'cash' },
                            _react2.default.createElement(
                                'em',
                                null,
                                '2.'
                            ),
                            ' ',
                            _lang2.default.template('使用CashCard充值所得U钻数将根据兑换比例(<%=currence%><%=real%>=<%=number%>钻)进行换算，最终所得U钻数会进行四舍五入处理', { real: real, currence: sybol, number: number })
                        )
                    )
                );

                $tip = _react2.default.createElement(
                    'div',
                    { className: 'money' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _lang2.default.template('充值比例: <%=currence%><%=real%>=<%=number%>U钻', { real: real, currence: sybol, number: number })
                    )
                );
            }

            if (channel == 'icard') {
                var _real = void 0,
                    _number = void 0,
                    _sybol = void 0;

                if (list[0]) {
                    var _list$0$proportion$sp3 = list[0].proportion.split(':');

                    var _list$0$proportion$sp4 = _slicedToArray(_list$0$proportion$sp3, 2);

                    _real = _list$0$proportion$sp4[0];
                    _number = _list$0$proportion$sp4[1];

                    _sybol = list[0].currencySymbol.toUpperCase();
                }

                $list = _react2.default.createElement(
                    'div',
                    { className: 'option-list cashcard' },
                    _react2.default.createElement(
                        'div',
                        { className: 'recharge-icard' },
                        _react2.default.createElement(
                            'div',
                            { className: 'item-wrap' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'CardType:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-wrap' },
                                _react2.default.createElement(
                                    'select',
                                    { ref: 'icardtype', onChange: this.onChangeIcardType },
                                    _react2.default.createElement(
                                        'option',
                                        { value: '2' },
                                        'Mobifone'
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        { value: '1' },
                                        'Viettel'
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        { value: '3' },
                                        'Vinaphone'
                                    )
                                ),
                                _react2.default.createElement('div', { className: 'expand-arrow' })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'item-wrap' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'CardValue:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-wrap' },
                                _react2.default.createElement(
                                    'select',
                                    { ref: 'icardvalue', onChange: this.onChangeIcardValue },
                                    _react2.default.createElement(
                                        'option',
                                        { value: '20000', ref: 'icard20' },
                                        '20.000'
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        { value: '50000' },
                                        '50.000'
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        { value: '100000' },
                                        '100.000'
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        { value: '200000' },
                                        '200.000'
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        { value: '500000' },
                                        '500.000'
                                    )
                                ),
                                _react2.default.createElement('div', { className: 'expand-arrow' })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'item-wrap' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Serial:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-wrap' },
                                _react2.default.createElement('input', { name: 'serial', ref: 'icardserial', type: 'text', placeholder: 'Please enter serial of the card', autoComplete: 'off' })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'item-wrap' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Code:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-wrap' },
                                _react2.default.createElement('input', { name: 'code', ref: 'icardcode', type: 'text', placeholder: 'Please enter code of the card', autoComplete: 'off' })
                            )
                        )
                    )
                );

                $tip = _react2.default.createElement(
                    'div',
                    { className: 'money' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _lang2.default.template('充值比例: <%=currence%><%=real%>=<%=number%>U钻', { real: _real, currence: _sybol, number: _number })
                    )
                );
            }

            if (this.state.showQrcode == 1) {
                $button = null;
            } else {
                if (channel == 'icard') {
                    $button = _react2.default.createElement(
                        'button',
                        { className: 'btn_pay', onClick: this.icardSubmitOrder },
                        _lang2.default.template('立即充值')
                    );
                } else {
                    $button = _react2.default.createElement(
                        'button',
                        { className: 'btn_pay', onClick: this.handleOrder },
                        _lang2.default.template('立即充值')
                    );
                }
            }

            return _react2.default.createElement(
                'div',
                { className: 'recharge-form' },
                _react2.default.createElement(
                    'ul',
                    { className: 'option-list clearfix' },
                    $list
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'recharge-bar clearfix' },
                    ['pepay_entitycard_thb', 'pepay_entitycard_thb', 'icard', 'gash_card'].indexOf(channel) > -1 ? $tip : _react2.default.createElement(
                        'div',
                        { className: 'money' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _lang2.default.template('应付金额'),
                            '  '
                        ),
                        _react2.default.createElement(
                            'em',
                            null,
                            selection.currencySymbol,
                            selection.money / 100
                        )
                    ),
                    $button
                ),
                $extraHtml
            );
        }
    }]);

    return OptionListView;
}(_react.Component);

OptionListView.defaultProps = {
    onSelectPay: function onSelectPay() {}
};
;

exports.default = OptionListView;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Item = function (_Component) {
    _inherits(Item, _Component);

    function Item() {
        _classCallCheck(this, Item);

        return _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
    }

    _createClass(Item, [{
        key: 'btnClick',
        value: function btnClick(data) {
            this.props.onSelectPay(data);
        }
    }, {
        key: 'render',
        value: function render() {
            var props = this.props;
            var data = props.data;
            var description = data.description;
            var count = 0;
            var newser = 0;

            if (data.type == 1) {
                description = _lang2.default.template('每人仅一次机会');
                newser = 1;
            } else if (description && description.match(/\d+/gi)) {
                count = description.match(/\d+/gi)[0];
                description = count;
            }

            var detailCls = void 0,
                btnCls = void 0;

            return _react2.default.createElement(
                'div',
                { className: 'item-wrap', 'data-fee': data.money / 100, onClick: this.btnClick.bind(this, data), 'data-newser': newser },
                _react2.default.createElement(
                    'div',
                    { className: 'detail' },
                    _react2.default.createElement(
                        'div',
                        { className: 'value' },
                        _react2.default.createElement(
                            'span',
                            { className: 'num' },
                            data.amount - count
                        ),
                        _react2.default.createElement('icon', null)
                    ),
                    description ? _react2.default.createElement(
                        'em',
                        { className: 'tip' },
                        description
                    ) : null,
                    _react2.default.createElement(
                        'div',
                        { className: 'price' },
                        data.currencySymbol,
                        data.money / 100
                    )
                )
            );
        }
    }]);

    return Item;
}(_react.Component);

Item.defaultProps = {
    data: {},
    onSelectPay: function onSelectPay() {} // option选择

};
exports.default = Item;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _dialogHoc = __webpack_require__(562);

var _dialogHoc2 = _interopRequireDefault(_dialogHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const ConfirmDialog = DialogHOC(DialogNested);

module.exports = {
	create: function create(cfg, nestedPopup, callback) {
		cfg = cfg || {};

		this._callback = callback;
		if (this.layer) {
			this.destroy();
		}

		var ConfirmDialog = (0, _dialogHoc2.default)(nestedPopup);
		var mountNode = this.createMountNode();

		this.layer = _reactDom2.default.render(_react2.default.createElement(ConfirmDialog, _extends({}, cfg, { onHide: this.onHide.bind(this), onCancel: this.onCancel.bind(this), onConfirm: this.onConfirm.bind(this) })), mountNode);
	},
	onCancel: function onCancel() {
		if ('function' == typeof this._callback) {
			this._callback('cancel');
		}
	},
	onConfirm: function onConfirm() {
		if ('function' == typeof this._callback) {
			this._callback('confirm');
		}
	},
	onHide: function onHide() {
		this.destroy();
	},
	// 创建组件插入的DOM节点
	createMountNode: function createMountNode() {
		this.mountNode = document.createElement("div");
		$(document.body).append(this.mountNode);
		return this.mountNode;
	},
	destroy: function destroy() {
		_reactDom2.default.unmountComponentAtNode(this.mountNode);
		$(this.mountNode).remove();
		delete this.layer;
	}
};

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ScaleModal = __webpack_require__(12);

var _ScaleModal2 = _interopRequireDefault(_ScaleModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 确认弹出框
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


// let ua = window.navigator.userAgent;
// let isIOS = ua.match(/iphone|ipad|itouch/i);
function DialogHOC(ComposedComponent) {
	var style = {
		modalStyle: {
			width: '320px',
			margin: '0 auto'
		},
		contentStyle: {
			width: '280px',
			margin: '0 auto',
			borderRadius: '10px',
			backgroundColor: 'rgba(228,0,147,0.8)'
		},
		backdropStyle: {
			backgroundColor: "rgba(0,0,0, 0.85)"
		}
	};

	var Dialog = function (_Component) {
		_inherits(Dialog, _Component);

		function Dialog(props) {
			_classCallCheck(this, Dialog);

			var _this = _possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call(this, props));

			_this.handleCancel = function (e) {
				_this.hideModal();

				_this.status = 'cancel';
			};

			_this.handleConfirm = function (e) {
				_this.hideModal();

				_this.status = 'confirm';
			};

			_this.onHide = _this.onHide.bind(_this);
			_this.onShow = _this.onShow.bind(_this);
			return _this;
		}

		_createClass(Dialog, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this.status = 'cancel';
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.showModal();
			}
		}, {
			key: 'onHide',
			value: function onHide() {
				if (typeof this.props.onHide == 'function') {
					this.props.onHide();
				}

				if (this.status == 'cancel') {
					if (typeof this.props.onCancel == 'function') {
						this.props.onCancel();
					}
				} else if (this.status == 'confirm') {
					if (typeof this.props.onConfirm == 'function') {
						this.props.onConfirm();
					}
				}
			}
		}, {
			key: 'onShow',
			value: function onShow() {
				if (typeof this.props.onShow == 'function') {
					this.props.onShow();
				}
			}
		}, {
			key: 'showModal',
			value: function showModal() {
				this.refs.modal.show();
			}
		}, {
			key: 'hideModal',
			value: function hideModal() {
				this.refs.modal.hide();
			}
		}, {
			key: 'render',
			value: function render() {
				var modalStyle = style.modalStyle;
				var backdropStyle = style.backdropStyle;
				var contentStyle = style.contentStyle;
				var $footer = void 0;
				// if(isIOS){
				// 	modalStyle.position = 'absolute';

				// }

				if (this.props.modalStyle) {
					for (var _style in this.props.modalStyle) {
						modalStyle[_style] = this.props.modalStyle[_style];
					}
				}

				if (this.props.backdropStyle) {
					for (var _style2 in this.props.backdropStyle) {
						backdropStyle[_style2] = this.props.backdropStyle[_style2];
					}
				}

				if (this.props.contentStyle) {
					for (var _style3 in this.props.contentStyle) {
						contentStyle[_style3] = this.props.contentStyle[_style3];
					}
				}

				return _react2.default.createElement(
					_ScaleModal2.default,
					{ ref: 'modal', closeOnClick: this.props.closeOnClick, onHide: this.onHide, onShow: this.onShow, modalStyle: modalStyle, backdropStyle: backdropStyle, contentStyle: contentStyle, className: 'popup-module' },
					_react2.default.createElement(ComposedComponent, _extends({}, this.props, this.state, { handleCancel: this.handleCancel, handleConfirm: this.handleConfirm }))
				);
			}
		}]);

		return Dialog;
	}(_react.Component);

	Dialog.defaultProps = {
		onHide: function onHide() {},
		onShow: function onShow() {}
	};


	return Dialog;
}

module.exports = DialogHOC;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IcardConfirmPopup = function (_Component) {
    _inherits(IcardConfirmPopup, _Component);

    function IcardConfirmPopup(props) {
        _classCallCheck(this, IcardConfirmPopup);

        return _possibleConstructorReturn(this, (IcardConfirmPopup.__proto__ || Object.getPrototypeOf(IcardConfirmPopup)).call(this, props));
    }

    _createClass(IcardConfirmPopup, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'popup-wrapper' },
                _react2.default.createElement(
                    'div',
                    { className: 'box-hd' },
                    _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        _index2.default.template('icard_popup_confirm_title')
                    ),
                    _react2.default.createElement('div', { className: 'close', onClick: this.props.handleCancel })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'warning-tip' },
                        'L\u01AFU \xDD:',
                        _react2.default.createElement('br', null),
                        'UPLIVE KH\xD4NG H\u1ED6 TR\u1EE2 CHO VI\u1EC6C NH\u1EACP SAI NH\xC0 M\u1EA0NG V\xC0 M\u1EC6NH GI\xC1 TH\u1EBA.',
                        _react2.default.createElement('br', null),
                        'Xin h\xE3y ch\u1ECDn th\xF4ng tin ch\xEDnh x\xE1c \u0111\u1EC3 tr\xE1nh m\u1EA5t th\u1EBB.'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'infos' },
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(
                                'span',
                                { className: 'name-span' },
                                _index2.default.template('icard_cardType'),
                                ':'
                            ),
                            ' ',
                            _react2.default.createElement(
                                'span',
                                { className: 'value-span' },
                                this.props.type
                            )
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(
                                'span',
                                { className: 'name-span' },
                                _index2.default.template('icard_cardValue'),
                                ':'
                            ),
                            ' ',
                            _react2.default.createElement(
                                'span',
                                { className: 'value-span' },
                                this.props.value
                            )
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(
                                'span',
                                { className: 'name-span' },
                                _index2.default.template('icard_Serial'),
                                ':'
                            ),
                            ' ',
                            _react2.default.createElement(
                                'span',
                                { className: 'value-span' },
                                this.props.serial
                            )
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(
                                'span',
                                { className: 'name-span' },
                                _index2.default.template('icard_Code'),
                                ':'
                            ),
                            ' ',
                            _react2.default.createElement(
                                'span',
                                { className: 'value-span' },
                                this.props.code
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'box-fd' },
                    _react2.default.createElement(
                        'div',
                        { className: 'mini-btn', onClick: this.props.handleCancel },
                        _index2.default.template('icard_popup_no')
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'mini-btn', onClick: this.props.handleConfirm },
                        _index2.default.template('icard_popup_yes')
                    )
                )
            );
        }
    }]);

    return IcardConfirmPopup;
}(_react.Component);

IcardConfirmPopup.defaultProps = {
    orderData: {}
};
exports.default = IcardConfirmPopup;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _optionlistpb = __webpack_require__(565);

var _optionlistpb2 = _interopRequireDefault(_optionlistpb);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _loading = __webpack_require__(45);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 充值档列表行为模块, 拉取获取、处理用户操作等
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var pbajax = new _pbajax2.default();

exports.default = function (ComposedComponent) {
    var _class, _temp;

    return _temp = _class = function (_Component) {
        _inherits(OptionListAct, _Component);

        function OptionListAct(props) {
            _classCallCheck(this, OptionListAct);

            var _this = _possibleConstructorReturn(this, (OptionListAct.__proto__ || Object.getPrototypeOf(OptionListAct)).call(this, props));

            _this.state = {
                channel: props.channel,
                list: [],
                loading: true
            };
            return _this;
        }

        _createClass(OptionListAct, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                this.getOptionList();
            }
        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                var _this2 = this;

                if (this.state.channel == nextProps.channel) {
                    return;
                }
                this.setState({
                    channel: nextProps.channel,
                    loading: true
                }, function () {
                    _this2.getOptionList();
                });
            }
        }, {
            key: 'getOptionList',
            value: function getOptionList() {
                var self = this;
                var uid = this.props.uid;
                var channel = this.state.channel;

                pbajax.do({
                    service: 'mall',
                    api: channel == 'bk_atm' ? '/mall/recharge/config/bkatm' : '/mall/recharge/config/h5',
                    header: {
                        'Accept-Language': UP.Global.siteLanguage
                    },
                    inchina: 1
                }, new _optionlistpb2.default.Mall.RechargeConfig.Request({
                    uid: uid,
                    channel: channel
                }), function (res) {

                    var dataWrap = _public2.default.Result.decode(res);

                    if (dataWrap.code == 1) {

                        if (dataWrap.data.value === null) {
                            // console.log('option == null');
                        } else {

                            var data = _optionlistpb2.default.Mall.RechargeConfig.Response.decode(dataWrap.data.value);

                            self.setState({
                                list: data.rechargeConfigs,
                                loading: false
                            });
                        }
                    } else if (dataWrap.code == 16777215) {
                        // 系统错误
                        $.channel.emit('getOptionListError');
                    }
                });
            }
        }, {
            key: 'render',
            value: function render() {
                if (this.state.loading) {
                    return _react2.default.createElement(_loading2.default, null);
                } else {
                    return _react2.default.createElement(ComposedComponent, _extends({}, this.state, this.props));
                }
            }
        }]);

        return OptionListAct;
    }(_react.Component), _class.defaultProps = {
        onSelectPay: function onSelectPay() {},

        uid: '',
        channel: ''
    }, _temp;
};

/***/ }),
/* 565 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Mall.RechargeConfig",
    "options": {
        "objc_class_prefix": "MallRechargeConfig",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Request",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "channel",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "rewardType",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "rewardConfigId",
            "id": 4
        }]
    }, {
        "name": "Response",
        "fields": [{
            "rule": "repeated",
            "type": "RechargeConfig",
            "name": "rechargeConfigs",
            "id": 1
        }, {
            "rule": "repeated",
            "type": "string",
            "name": "channels",
            "id": 2
        }, {
            "rule": "repeated",
            "type": "RechargeConfig",
            "name": "wxpay",
            "id": 3
        }, {
            "rule": "repeated",
            "type": "RechargeConfig",
            "name": "alipay",
            "id": 4
        }, {
            "rule": "repeated",
            "type": "RechargeConfig",
            "name": "IAP",
            "id": 5
        }, {
            "rule": "repeated",
            "type": "RechargeConfig",
            "name": "IAB",
            "id": 6
        }, {
            "rule": "repeated",
            "type": "RechargeConfig",
            "name": "others",
            "id": 7
        }, {
            "rule": "repeated",
            "type": "ChannelGroup",
            "name": "groups",
            "id": 8
        }]
    }, {
        "name": "RechargeConfig",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "configId",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "description",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "amount",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "icon",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "money",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "type",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "currency",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "currencySymbol",
            "id": 8
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "residue",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "rewardConfigId",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "rewardDesc",
            "id": 11
        }, {
            "rule": "optional",
            "type": "string",
            "name": "proportion",
            "id": 12
        }]
    }, {
        "name": "RechargeConfigList",
        "fields": [{
            "rule": "repeated",
            "type": "RechargeConfig",
            "name": "rechargeConfigList",
            "id": 1
        }]
    }, {
        "name": "ChannelGroup",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "groupCode",
            "id": 1
        }, {
            "rule": "repeated",
            "type": "string",
            "name": "channels",
            "id": 2
        }, {
            "rule": "map",
            "type": "RechargeConfigList",
            "keytype": "string",
            "name": "channelRechargeConfigMap",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "groupName",
            "id": 4
        }, {
            "rule": "map",
            "type": "string",
            "keytype": "string",
            "name": "channelNameMap",
            "id": 5
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

var _vipczConfig = __webpack_require__(567);

var _vipczConfig2 = _interopRequireDefault(_vipczConfig);

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _rcTooltip = __webpack_require__(27);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _number = __webpack_require__(44);

var _number2 = _interopRequireDefault(_number);

var _vip = __webpack_require__(615);

var _vip2 = _interopRequireDefault(_vip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import vipChargeList from './vipcz-charge-config'


var maps = {
    mobile: 'Mobile',
    line: 'Line',
    weChat: 'WeChat',
    whatsApp: 'WhatsApp',
    facebook: 'Facebook',
    email: 'Email'
};

var VipView = function (_Component) {
    _inherits(VipView, _Component);

    function VipView(props) {
        _classCallCheck(this, VipView);

        var _this = _possibleConstructorReturn(this, (VipView.__proto__ || Object.getPrototypeOf(VipView)).call(this, props));

        _this.countryCode = _cUrl2.default.query('adscountry') || UP.Global.getUser().countryCode;

        _this.state = {
            vips: [],
            vipList: []
        };
        return _this;
    }

    _createClass(VipView, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var countryCode = this.countryCode;

            // 获取充值档
            _vip2.default.fetchRechargeOptions(countryCode).then(function (data) {

                var list = data.resultResponse;
                // 降序
                list = list.sort(function (a, b) {
                    return a.rechargeAmount - b.rechargeAmount;
                });

                _this2.setState({
                    vipList: data.resultResponse
                });
            }, function (err) {
                // error
            });

            // 获取客服
            _vip2.default.fetchVipConfs(countryCode).then(function (data) {
                var hostList = data.resultResponse;

                if (hostList.length == 0) {
                    // 若无VIP客服，使用大陆的
                    _vip2.default.fetchVipConfs('CN').then(function (data) {
                        var hostList = data.resultResponse;

                        hostList = _this2.shuffle(hostList);

                        _this2.setState({
                            vips: data.resultResponse
                        });
                    });
                } else {
                    hostList = _this2.shuffle(hostList);

                    _this2.setState({
                        vips: data.resultResponse
                    });
                }
            }, function (err) {
                // error
            });
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return !UP.Global.isLoginPop;
        }
    }, {
        key: 'newHref',
        value: function newHref(value) {
            window.open(value);
        }
    }, {
        key: 'shuffle',
        value: function shuffle(arr) {
            var i = arr.length;

            while (i) {
                var j = Math.floor(Math.random() * i--);
                var _ref = [arr[i], arr[j]];
                arr[j] = _ref[0];
                arr[i] = _ref[1];
            }

            return arr;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var countryCode = this.countryCode != 'PK' && UP.Global.middelEastCountryCodes.indexOf(this.countryCode) > -1 ? 'MSL' : this.countryCode;
            var hostLists = _vipczConfig2.default[countryCode] || _vipczConfig2.default['CN'];

            var _state = this.state,
                vips = _state.vips,
                vipList = _state.vipList;


            if (vipList.length > 0) {

                $vipRechargeList = _react2.default.createElement(
                    'div',
                    { className: 'vip-chargelist hidden' },
                    _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        _index2.default.template('充值档位参考')
                    ),
                    _react2.default.createElement(
                        'ul',
                        { className: 'chargelist' },
                        vipList.map(function (item, index) {
                            return _react2.default.createElement(
                                'li',
                                { key: index },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'detail' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'value' },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'num' },
                                            _number2.default.separate(item.gearDrillNumber)
                                        ),
                                        _react2.default.createElement('icon', null)
                                    ),
                                    _react2.default.createElement(
                                        'em',
                                        { className: 'tip' },
                                        item.currencySymbol,
                                        _number2.default.separate(item.rechargeAmount)
                                    )
                                ),
                                item.addDrill > 0 ? _react2.default.createElement(
                                    'div',
                                    { className: 'price' },
                                    _number2.default.separate(item.addDrill)
                                ) : null
                            );
                        })
                    )
                );
            } else {
                $vipRechargeList = null;
            }

            return _react2.default.createElement(
                'div',
                { className: 'vip-box', ref: 'box' },
                ['CN', 'TW', 'MO', 'MYC', 'HK'].indexOf(countryCode) > -1 ? _react2.default.createElement(
                    'div',
                    { className: 'vip-title' },
                    _index2.default.template('直接联系官方客服进行充值，选择档位越高，优惠力度越大。')
                ) : null,
                $vipRechargeList,
                _react2.default.createElement(
                    'div',
                    { className: 'vipcz-head' },
                    _react2.default.createElement('div', { className: 'border' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'text' },
                        _index2.default.template("官方充值客服")
                    ),
                    _react2.default.createElement('div', { className: 'border' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'vipcz-list clearfix' },
                    vips.map(function (item, key) {
                        var ser = _extends({}, item, {
                            sns: JSON.parse(item.contactList)
                        });

                        var $wechat = void 0,
                            $wechatimg = void 0,
                            $line = void 0,
                            $lineimg = void 0,
                            $whatsapp = void 0,
                            $othertype = void 0;
                        var contact = [];

                        if (ser.sns.weChat) {
                            $wechatimg = _react2.default.createElement(
                                'div',
                                { className: 'qrcode', ref: "weiimg" + key },
                                _react2.default.createElement('i', { className: 'qrcode-bg', style: { backgroundImage: 'url(' + ser.sns.wechatqrcode + ')' } })
                            );
                            $wechat = _react2.default.createElement(
                                _rcTooltip2.default,
                                { overlay: $wechatimg, placement: 'right', trigger: ['hover'], getTooltipContainer: function getTooltipContainer() {
                                        return _this3.refs.box;
                                    }, overlayClassName: 'recharge-tooltip-vip' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'chat-item wechat' },
                                    _index2.default.template('微信'),
                                    ' : ',
                                    ser.sns.weChat
                                )
                            );
                            contact[contact.length] = $wechat;
                        }

                        if (ser.sns.line) {
                            $lineimg = _react2.default.createElement(
                                'div',
                                { className: 'qrcode', ref: "lineimg" + key },
                                _react2.default.createElement('i', { className: 'qrcode-bg', style: { backgroundImage: 'url(' + ser.sns.lineqrcode + ')' } })
                            );

                            $line = _react2.default.createElement(
                                _rcTooltip2.default,
                                { overlay: $lineimg, placement: 'right', trigger: ['hover'], getTooltipContainer: function getTooltipContainer() {
                                        return _this3.refs.box;
                                    }, overlayClassName: 'recharge-tooltip-vip' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'chat-item line' },
                                    _index2.default.template('Line'),
                                    ' : ',
                                    ser.sns.line
                                )
                            );
                            contact[contact.length] = $line;
                        }
                        if (ser.sns.messenger) {
                            $messengerimg = _react2.default.createElement(
                                'div',
                                { className: 'qrcode', ref: "messengerimg" + key },
                                _react2.default.createElement('i', { className: 'qrcode-bg', style: { backgroundImage: 'url(' + ser.sns.messengerqrcode + ')' } })
                            );

                            $messenger = _react2.default.createElement(
                                _rcTooltip2.default,
                                { overlay: $messengerimg, placement: 'right', trigger: ['hover'], getTooltipContainer: function getTooltipContainer() {
                                        return _this3.refs.box;
                                    }, overlayClassName: 'recharge-tooltip-vip' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'chat-item messager' },
                                    ' ',
                                    ser.sns.messenger
                                )
                            );
                            contact[contact.length] = $messenger;
                        }
                        if (ser.sns.zalo) {
                            $zaloimg = _react2.default.createElement(
                                'div',
                                { className: 'qrcode', ref: "zaloimg" + key },
                                _react2.default.createElement('i', { className: 'qrcode-bg', style: { backgroundImage: 'url(' + ser.sns.zaloqrcode + ')' } })
                            );

                            $zalo = _react2.default.createElement(
                                _rcTooltip2.default,
                                { overlay: $zaloimg, placement: 'right', trigger: ['hover'], getTooltipContainer: function getTooltipContainer() {
                                        return _this3.refs.box;
                                    }, overlayClassName: 'recharge-tooltip-vip' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'chat-item zalo' },
                                    _index2.default.template('Zalo'),
                                    ' : ',
                                    ser.sns.zalo
                                )
                            );
                            contact[contact.length] = $zalo;
                        }

                        if (ser.sns.whatsApp) {
                            $whatsapp = _react2.default.createElement(
                                'div',
                                { className: 'chat-item whatsapp' },
                                ser.sns.whatsApp
                            );
                            contact[contact.length] = $whatsapp;
                        }

                        if (ser.sns.mobile) {
                            contact[contact.length] = _react2.default.createElement(
                                'div',
                                { className: 'chat-item  tel' },
                                ser.sns.mobile
                            );
                        }

                        if (ser.sns.facebook) {
                            contact[contact.length] = _react2.default.createElement(
                                'div',
                                { className: 'chat-item facebook', onClick: _this3.newHref.bind(_this3, ser.sns.facebook) },
                                ser.sns.facebook
                            );
                        }

                        if (ser.sns.email) {
                            contact[contact.length] = _react2.default.createElement(
                                'a',
                                { className: 'chat-item  email', href: 'mailto: ' + ser.sns.email },
                                ser.sns.email
                            );
                        }

                        if (contact.length < 3) {
                            if (!ser.sns.line) {
                                contact[contact.length] = _react2.default.createElement(
                                    'div',
                                    { className: 'chat-item  line line-no' },
                                    _index2.default.template('Line'),
                                    ' : --'
                                );
                            }

                            if (!ser.sns.mobile) {
                                contact[contact.length] = _react2.default.createElement(
                                    'div',
                                    { className: 'chat-item  tel tel-no' },
                                    '--'
                                );
                            }
                        }

                        return _react2.default.createElement(
                            'div',
                            { className: 'vip-item', key: key },
                            _react2.default.createElement(
                                'div',
                                { className: 'avatar' },
                                _react2.default.createElement('img', { src: item.avatar })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'content' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'nickname' },
                                    item.nickName
                                ),
                                contact
                            )
                        );
                    })
                )
            );
        }
    }]);

    return VipView;
}(_react.Component);

exports.default = VipView;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
vip客服list
*/
var vipList = {
    ID: [{
        nickname: 'uplive topup',
        line: 'UP.LIVE',
        avatar: __webpack_require__(17),
        lineimg: __webpack_require__(568)
    }],
    PK: [{
        nickname: 'alee786',
        whatsapp: '+923017492611',
        wechat: 'Aleehussain786',
        avatar: __webpack_require__(569),
        weiimg: __webpack_require__(570)
    }],
    US: [{
        nickname: 'Rahul Anand',
        wechat: 'xian_uplive',
        //facebook:'xiankool@gmail.com',
        email: 'uplive.usa@gmail.com',
        avatar: __webpack_require__(571),
        weiimg: __webpack_require__(572)
    }],
    JP: [{
        nickname: 'テイテイ(奶油)',
        wechat: 'uplivevipel',
        line: 'uplivevipel',
        avatar: __webpack_require__(230),
        lineimg: __webpack_require__(231),
        weiimg: __webpack_require__(232)
    }],
    MY: [{
        nickname: 'Chuah',
        wechat: 'VIPCHUAH',
        avatar: __webpack_require__(17),
        weiimg: __webpack_require__(233)
    }, {
        nickname: 'James',
        wechat: 'weird_prince',
        line: '',
        avatar: __webpack_require__(17),
        lineimg: __webpack_require__(234),
        weiimg: __webpack_require__(235)
    }, {
        nickname: 'Jie Lun',
        wechat: 'ww233700',
        line: 'uplivejay',
        avatar: __webpack_require__(17),
        lineimg: __webpack_require__(236),
        weiimg: __webpack_require__(237)
    }, {
        nickname: 'CL',
        wechat: 'cl051296',
        avatar: __webpack_require__(17),
        weiimg: __webpack_require__(238)
    }, {
        nickname: 'Roweena',
        wechat: 'Princessroweena',
        avatar: __webpack_require__(17),
        weiimg: __webpack_require__(239)
    }],
    SG: [{
        nickname: 'Chuah',
        wechat: 'VIPCHUAH',
        avatar: __webpack_require__(17),
        weiimg: __webpack_require__(233)
    }, {
        nickname: 'James',
        wechat: 'weird_prince',
        line: '',
        avatar: __webpack_require__(17),
        lineimg: __webpack_require__(234),
        weiimg: __webpack_require__(235)
    }, {
        nickname: 'Jie Lun',
        wechat: 'ww233700',
        line: 'uplivejay',
        avatar: __webpack_require__(17),
        lineimg: __webpack_require__(236),
        weiimg: __webpack_require__(237)
    }, {
        nickname: 'CL',
        wechat: 'cl051296',
        avatar: __webpack_require__(17),
        weiimg: __webpack_require__(238)
    }, {
        nickname: 'Roweena',
        wechat: 'Princessroweena',
        avatar: __webpack_require__(17),
        weiimg: __webpack_require__(239)
    }],
    VN: [{
        nickname: 'Hoang Tam',
        facebook: 'https://m.me/hoangtam.taurus',
        avatar: __webpack_require__(17),
        faceimg: __webpack_require__(573)
    }, {
        nickname: 'Phuong Bui',
        facebook: 'https://m.me/buiphuongdl',
        avatar: __webpack_require__(17),
        faceimg: __webpack_require__(574)
    }],
    IN: [{
        nickname: 'Ruchika Tandon',
        whatsapp: '+91 9650686014',
        tel: '+91 9650686014',
        wechat: 'Ruchikatandon7',
        avatar: __webpack_require__(575),
        weiimg: __webpack_require__(576)

    }, {
        nickname: 'Vani Sharma',
        whatsapp: '＋91 8368765271',
        tel: '＋91 8368765271',
        wechat: 'Gorav19_',
        avatar: __webpack_require__(577),
        weiimg: __webpack_require__(578)

    }, {
        nickname: 'Vrinda',
        whatsapp: '91 9821446589',
        tel: '91 9821446589',
        wechat: 'bini_2018',
        avatar: __webpack_require__(579),
        weiimg: __webpack_require__(580)

    }],
    CN: [{
        nickname: 'Lily',
        // whatsapp: '96177074',
        wechat: 'uphkviplily',
        line: 'uphkviplily',
        avatar: __webpack_require__(581),
        lineimg: __webpack_require__(582),
        weiimg: __webpack_require__(583)

    }, {
        nickname: 'Anne',
        // whatsapp: '51362690',
        wechat: 'uplivehkvipanne',
        line: 'uplivehkvipanne',
        avatar: __webpack_require__(584),
        lineimg: __webpack_require__(585),
        weiimg: __webpack_require__(586)
    }, {
        nickname: '大花',
        wechat: '1260217721',
        avatar: __webpack_require__(587),
        weiimg: __webpack_require__(588)
    }, {
        nickname: '鱼鱼',
        wechat: 'uplivevipyu',
        line: 'uplivevipyu',
        avatar: __webpack_require__(589),
        lineimg: __webpack_require__(590),
        weiimg: __webpack_require__(591)
    }, {
        nickname: 'Vivi',
        wechat: 'uplivevip',
        line: 'uplivevip',
        avatar: __webpack_require__(592),
        lineimg: __webpack_require__(593),
        weiimg: __webpack_require__(594)
    }, {
        nickname: '啾比',
        wechat: 'uplivevipju',
        line: 'uplivevipju',
        avatar: __webpack_require__(595),
        lineimg: __webpack_require__(596),
        weiimg: __webpack_require__(597)
    }, {
        nickname: '艾瑪',
        wechat: 'uplivevipma',
        line: 'uplivevipma',
        avatar: __webpack_require__(598),
        lineimg: __webpack_require__(599),
        weiimg: __webpack_require__(600)
    }, {
        nickname: 'Miko',
        wechat: 'uplivevipmi',
        line: 'uplivevipmi',
        avatar: __webpack_require__(601),
        lineimg: __webpack_require__(602),
        weiimg: __webpack_require__(603)
    }, {
        nickname: 'Amy',
        wechat: '963002637',
        avatar: __webpack_require__(604),
        weiimg: __webpack_require__(605)
    }, {
        nickname: 'テイテイ(奶油)',
        wechat: 'uplivevipel',
        line: 'uplivevipel',
        avatar: __webpack_require__(230),
        lineimg: __webpack_require__(231),
        weiimg: __webpack_require__(232)
    }, {
        nickname: '晶晶',
        wechat: '1046045875',
        avatar: __webpack_require__(606),
        weiimg: __webpack_require__(607)
    }],
    BD: [{
        nickname: 'Zannatul_Mou',
        whatsapp: '+8801992029939',
        tel: '+8801992029939',
        avatar: __webpack_require__(17)

    }],
    MSL: [{
        nickname: 'Emy',
        whatsapp: '002-010-6821-5135',
        avatar: __webpack_require__(608)
    }, {
        nickname: 'Queena',
        whatsapp: '002-010-9827-8791',
        avatar: __webpack_require__(609)
    }, {
        nickname: 'DoOoOoBa',
        whatsapp: '002-0109-875-2112',
        avatar: __webpack_require__(610)
    }, {
        nickname: 'Mariam',
        whatsapp: '002-010-1948-3770',
        avatar: __webpack_require__(611)
    }, {
        nickname: 'Nour',
        whatsapp: '002-010-973752905',
        avatar: __webpack_require__(612)
    }, {
        nickname: 'Zahra',
        whatsapp: '002-010-9708-9881',
        avatar: __webpack_require__(613)
    }, {
        nickname: 'Mohamed',
        whatsapp: '002-010-9773-4093',
        avatar: __webpack_require__(614)
    }]
};

exports.default = vipList;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "150200f3ae96d6f581dac67ee877c746.png";

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "61214e33aa40f979b25e97649d6f0c2b.png";

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "43e84ef9e464baa17551dcebdf78ad9b.png";

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f5bf94895dbf0bb1e11324fe77de93b9.png";

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "959688ed076b7b56ddcb2c9fe83db4f0.png";

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7dff866ea89caab8d852a569a9390a63.png";

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2023394823c5eb32844e9c903411d14a.png";

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "83dcdec06d9d5cc9e05b48673b90f552.png";

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3722fc83486c507657222b410aa2b5ad.png";

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9261c5a728ec358a19b9a87034fc7f9c.png";

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d960c235f7a8f8d84ea944cabc364731.png";

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "905d991ff33a8e710028a87508a4efc6.png";

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "90a0ace246ce5421600f1d3161927684.png";

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d829b593f66ca91778e571b3d216956e.jpg";

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ef8691d9a1fc5ef9a9dab622c1c6bca9.png";

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "31a4371cedf52b9e36f61e1528f96ffe.png";

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "95e88fa845e9168b95db4a1d0c3cc339.jpg";

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ef8691d9a1fc5ef9a9dab622c1c6bca9.png";

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8673c7b5af638a7a9986847102bd2f8d.png";

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a6dd08e6a225d0cb3a6c68fb94983fb0.jpg";

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e325c3f2c8ce80884d95d455b9ddc24a.png";

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c0f64b2c59c5b43f2bb5188f1f87f8d0.jpg";

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "daf53489a79cb5a92cf6a86b2af7d0b7.png";

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d4567ffe8fa7af5e8f0c4f035a77aaa1.png";

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "14878d1801652f95fca78491595a8ad9.jpg";

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2fab738308034ac47d1344e76937d20c.png";

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cb8abe2a1c6293ddcaaeff035b33f872.png";

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ecbdfd55dc5246e9ea8c07d7187cc7b3.jpg";

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7f98258e83fac954d91922d168bca185.png";

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0d106450e37cb5e7646b4447bb438877.png";

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1c1218a1a46ba99447b3639da23b30b5.jpg";

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "16adcdbf07919148dde899111cf8d2e1.png";

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6897dac333c94a2ddf667434f99c42d7.png";

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c28010ec54b52cb7b2dd136f4bc4b8a6.jpg";

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b7573fca45441347cc94a6796982086b.png";

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3609f80c9d9f7622e5fa1d25c27eac69.png";

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "918b5eea7373448b1acaa56d97549e33.jpg";

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ec5f424e43d6ef1a0db311dc4fc5f6df.png";

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "817c6d5306ad44177d6e945f94a87455.png";

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "964c987d9d7aa78110b156972e939225.png";

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fc57e2042bfb18b9202d5d120a8f7cae.jpg";

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e6a093c990ac09f2856867690d03506a.jpg";

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "28bbf24261831c20324c08fe2ec8e21d.jpg";

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "66414bb60a2365984609721378d55c92.jpg";

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "34c98724b63dda5809c61633ad40469e.jpg";

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "14e75b2cae6e991861a7a51a8039c22f.jpg";

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "717e168bf92a41c219e13e3099d462ab.jpg";

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * author : RyanLiu yanfang.liu@asiainnovations.com
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * date   : 29 Nov 2018 Thu
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * desc   : Vip充值相关服务
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      **/


var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pbajax = new _pbajax2.default();

var VipSvc = function () {
    function VipSvc() {
        _classCallCheck(this, VipSvc);
    }

    _createClass(VipSvc, [{
        key: 'getMappingApiBase',
        value: function getMappingApiBase() {
            var maps = {
                pro: 'https://liveapi.upliveapps.com',
                dev: 'http://sg-liveapi.xingyunzhi.cn',
                stage: 'http://sg-liveapi.xingyunzhi.cn'
            };

            var env = void 0;

            var reg = new RegExp("(^|&)env=([^&]*)(&|$)", "i");
            env = location.search.substr(1).match(reg);

            if (env) {
                env = decodeURIComponent(env[2]);
            } else {
                env = 'pro';
            }

            return maps[env];
        }
    }, {
        key: 'fetchRechargeOptions',
        value: function fetchRechargeOptions(countryCode) {
            var defer = $.Deferred();

            // 16是充值档位信息
            $.ajax({
                url: this.getMappingApiBase() + ('/config/get?type=16&countryCode=' + countryCode),
                method: 'GET',
                success: function success(ret) {
                    try {
                        var res = JSON.parse(ret);
                        defer.resolve(res.data);
                    } catch (e) {
                        defer.reject(e);
                    }
                },
                error: function error(err) {
                    defer.reject(err);
                }
            });
            return defer.promise();
        }
    }, {
        key: 'fetchVipConfs',
        value: function fetchVipConfs(countryCode) {
            var defer = $.Deferred();

            // 21是客服
            $.ajax({
                url: this.getMappingApiBase() + ('/config/get?type=21&countryCode=' + countryCode),
                method: 'GET',
                success: function success(ret) {
                    try {
                        var res = JSON.parse(ret);
                        defer.resolve(res.data);
                    } catch (e) {
                        defer.reject(e);
                    }
                },
                error: function error(err) {
                    defer.reject(err);
                }
            });

            return defer.promise();
        }
    }]);

    return VipSvc;
}();

exports.default = new VipSvc();

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _confirm = __webpack_require__(73);

var _confirm2 = _interopRequireDefault(_confirm);

var _bindphonePop = __webpack_require__(259);

var _bindphonePop2 = _interopRequireDefault(_bindphonePop);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	show: function show() {
		UP.Global.DA.add({
			eventName: 'clickBindPhoneBtnAfterRecharge',
			action: 'click'
		});

		_confirm2.default.create({
			content: _lang2.default.template('为保证您的账户和财产安全，请绑定手机号'),
			onConfirm: function onConfirm() {
				_bindphonePop2.default.create({
					onComplete: function onComplete() {
						UP.Global.DA.add({
							eventName: 'bindPhoneSuccessAfterRecharge',
							action: 'click'
						});
					}
				});
			}
		});
	}
}; /**
    * 引导绑定手机号码
    */

/***/ }),
/* 617 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Sms.SendCode",
    "options": {
        "objc_class_prefix": "SmsSendCode",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Request",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "mobilePhone",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "deviceId",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "module",
            "id": 4
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 618 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Bind.Mobilephone",
    "options": {
        "objc_class_prefix": "BindMobilephone",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Request",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "mobilephone",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "smsCode",
            "id": 2
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _searchuser = __webpack_require__(620);

var _searchuser2 = _interopRequireDefault(_searchuser);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _hostItem = __webpack_require__(252);

var _hostItem2 = _interopRequireDefault(_hostItem);

var _follow = __webpack_require__(97);

var _follow2 = _interopRequireDefault(_follow);

var _loading = __webpack_require__(45);

var _loading2 = _interopRequireDefault(_loading);

var _preventScroll = __webpack_require__(99);

var _preventScroll2 = _interopRequireDefault(_preventScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cache = new _cCache2.default({
    prefix: 'pcuplive'
});

var List = function (_Component) {
    _inherits(List, _Component);

    function List(props) {
        _classCallCheck(this, List);

        var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

        _this.state = {
            keyword: props.keyword,
            list: [],
            isEmpty: false,
            isLoading: false,
            isEnd: false
        };

        _this.page = 1;
        _this.pageSize = 20;
        _this.pbajax = new _pbajax2.default();

        _this.fetching = false; // 加载状态加锁
        _this.first = true; // 第一页
        _this.dataOver = false; // 数据最后一页
        return _this;
    }

    _createClass(List, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.loadData();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            var _this2 = this;

            var keyword = this.state.keyword;

            if (keyword == props.keyword) {
                return;
            }

            this.fetching = false; // 加载状态加锁
            this.first = true; // 第一页
            this.dataOver = false; // 数据最后一页
            this.page = 1;

            this.setState({
                list: [],
                isLoading: false,
                isEmpty: false,
                isEnd: false,
                keyword: props.keyword
            }, function () {
                _this2.loadData();
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.pbajax.cancel();
        }
    }, {
        key: 'loadData',
        value: function loadData() {

            this.loadDataByUserName();
            // this.loadDataByUpliveCode();
        }
    }, {
        key: 'loadDataByUserName',
        value: function loadDataByUserName() {
            var _this3 = this;

            this.fetching = true;

            var userToken = UP.Global.getUserToken();

            var headerData = {
                service: 'service',
                api: '/search/user',
                header: {
                    lang: UP.Global.siteLanguage,
                    userToken: userToken
                }
            };

            var requestData = new _searchuser2.default.Search.User.Request({
                content: this.state.keyword,
                page: this.page,
                pageSize: this.pageSize
            });

            this.pbajax.do(headerData, requestData, function (resp) {
                var dataWrap = _public2.default.Result.decode(resp);

                if (dataWrap.code == 1) {
                    var dataAll = void 0,
                        data = [];

                    if (dataWrap.data.value) {
                        dataAll = _searchuser2.default.Search.User.Response.decode(dataWrap.data.value);
                        data = dataAll.infos;
                    }

                    var list = _this3.state.list;

                    var newState = {
                        list: [].concat(_toConsumableArray(list), _toConsumableArray(data))
                    };

                    if (data.length < _this3.pageSize) {
                        // 数据加载完
                        _this3.dataOver = true;
                        newState.isLoading = false;

                        if (_this3.first) {
                            if (data.length == 0) {
                                newState.isEmpty = true;
                            }
                        } else {
                            newState.isEnd = true;
                        }
                    } else {
                        newState.isLoading = true;
                    }

                    if (_this3.first) {
                        // 第一页
                        _this3.first = false;
                    }

                    _this3.setState(Object.assign({}, _this3.state, newState));
                }

                _this3.fetching = false;
            }, function () {
                _this3.fetching = false;
            });

            this.page = this.page + 1;
        }
    }, {
        key: 'scroll',
        value: function scroll(e) {
            var self = this;
            var page = this.state.page;
            var box = e.currentTarget;
            var content = this.refs.content;

            self.timer && clearTimeout(self.timer);
            self.timer = setTimeout(function () {
                if (self.dataOver) {
                    return;
                }
                if (self.fetching) {
                    return;
                }
                var scrollY = box.scrollTop,
                    boxHeight = box.clientHeight,
                    contentHeight = content.clientHeight,
                    docElement = document.documentElement;

                //console.log(scrollY, contentHeight - boxHeight - self.props.threshold);
                if (scrollY >= contentHeight - boxHeight - self.props.threshold) {

                    this.fetching = true;

                    setTimeout(function () {
                        self.loadData();
                    }, 400);
                }
            }, 300);
        }
    }, {
        key: 'onClick',
        value: function onClick() {
            $.channel.emit('hideSearchResult');
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var list = this.state.list;
            var $list = [];
            var showList = ['username', 'gender', 'grade', 'upliveCode'];

            list.forEach(function (obj, idx) {

                var $btn = void 0;
                var followType = void 0;
                var temp = {};
                var followed = [1, 3].indexOf(obj.followType) >= 0 ? 1 : 0;

                if (obj.uid != UP.Global.getUserId()) {
                    if (followed) {
                        followType = 'followed';
                    }
                    $btn = _react2.default.createElement('span', {
                        onClick: function onClick() {
                            if (!cache.getCache('isRegisterRealUser')) {
                                // 正式用户
                                $.channel.emit('login');
                                return;
                            }
                            if (followed) {
                                temp.follow.unFollow(obj.uid);
                            } else {
                                temp.follow.do(obj.uid);
                            }
                        },
                        className: 'btn',
                        'data-show': followType });
                }

                if ($btn) {
                    temp.follow = new _follow2.default();
                    temp.follow.on('followSuccess', function () {
                        obj.followType = 1;
                        _this4.setState({
                            list: list
                        });
                    });

                    temp.follow.on('unFollowSuccess', function () {
                        obj.followType = null;
                        _this4.setState({
                            list: list
                        });
                    });
                }

                $list.push(_react2.default.createElement(
                    _hostItem2.default,
                    { key: obj.uid, item: obj, onClick: _this4.onClick, showList: showList },
                    $btn
                ));
            });

            return _react2.default.createElement(
                'div',
                { ref: 'content' },
                _react2.default.createElement(_preventScroll2.default, null),
                _react2.default.createElement(
                    'ul',
                    null,
                    $list
                ),
                this.state.isLoading ? _react2.default.createElement(_loading2.default, null) : null,
                this.state.isEmpty ? _react2.default.createElement(
                    'li',
                    { className: 'list-tip' },
                    _lang2.default.template('没发现此人，重新输入试试？')
                ) : null
            );
        }
    }]);

    return List;
}(_react.Component);

List.defaultProps = {
    threshold: 100,
    keyword: ''
};
;

exports.default = List;

/***/ }),
/* 620 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "FollowInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 4
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "location",
            "id": 7
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "followType",
            "id": 8
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 11
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "qualityAuth",
            "id": 12
        }]
    }, {
        "name": "Search",
        "fields": [],
        "messages": [{
            "name": "User",
            "fields": [],
            "options": {
                "objc_class_prefix": "SearchUser",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "string",
                    "name": "content",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "page",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "pageSize",
                    "id": 3
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "repeated",
                    "type": "FollowInfo",
                    "name": "infos",
                    "id": 1
                }]
            }]
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 621 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Follow.UserAdd",
    "options": {
        "objc_class_prefix": "FollowUserAdd",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Request",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "fuid",
            "id": 1
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 622 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Follow.UserUnfollow",
    "options": {
        "objc_class_prefix": "FollowUserUnfollow",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Request",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "fuid",
            "id": 1
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _listPannel = __webpack_require__(624);

var _listPannel2 = _interopRequireDefault(_listPannel);

var _rcTooltip = __webpack_require__(27);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _reactRouter = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeadHistory = function (_Component) {
    _inherits(HeadHistory, _Component);

    function HeadHistory(props) {
        _classCallCheck(this, HeadHistory);

        var _this = _possibleConstructorReturn(this, (HeadHistory.__proto__ || Object.getPrototypeOf(HeadHistory)).call(this, props));

        _this.gitList = function () {
            var counter = _this.state.counter;

            _this.setState({
                counter: counter + 1
            });
        };

        _this.state = {
            keyword: '',
            showSearchResult: false,
            counter: 0
        };

        return _this;
    }

    _createClass(HeadHistory, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var list = this.state.data;
            var $pop = _react2.default.createElement(
                'div',
                { key: this.state.counter, className: 's-result s-result-pop' },
                _react2.default.createElement(
                    'div',
                    { className: 's-result-scroller hostlist-lite' },
                    _react2.default.createElement(_listPannel2.default, { showFollowInfo: 'true', ref: 'list' })
                )
            );

            return _react2.default.createElement(
                _rcTooltip2.default,
                { key: 1, getTooltipContainer: function getTooltipContainer() {
                        return _this2.refs.history;
                    }, overlay: $pop, placement: 'bottom', trigger: ['hover'], overlayClassName: 'header-popover header-history-popover' },
                _react2.default.createElement(
                    'div',
                    { className: 'history btn-head', ref: 'history', onMouseEnter: this.gitList },
                    _react2.default.createElement(
                        'div',
                        { className: 'result-pop-hd', ref: 'follow' },
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { to: '/history' },
                            _lang2.default.template('观看历史')
                        )
                    )
                )
            );
        }
    }]);

    return HeadHistory;
}(_react.Component);

exports.default = HeadHistory;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _hostItem = __webpack_require__(625);

var _hostItem2 = _interopRequireDefault(_hostItem);

var _follow = __webpack_require__(97);

var _follow2 = _interopRequireDefault(_follow);

var _loading = __webpack_require__(45);

var _loading2 = _interopRequireDefault(_loading);

var _preventScroll = __webpack_require__(99);

var _preventScroll2 = _interopRequireDefault(_preventScroll);

var _history = __webpack_require__(626);

var _history2 = _interopRequireDefault(_history);

var _reactRouter = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cache = new _cCache2.default({
    prefix: 'pcuplive'
});

var List = function (_Component) {
    _inherits(List, _Component);

    function List(props) {
        _classCallCheck(this, List);

        var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

        _this.state = {
            //keyword: props.keyword,
            list: [],
            isEmpty: false,
            isLoading: true,
            isEnd: false
        };

        _this.page = 0;
        _this.pageSize = 6;
        _this.pbajax = new _pbajax2.default();

        _this.fetching = false; // 加载状态加锁
        _this.first = true; // 第一页
        _this.dataOver = false; // 数据最后一页
        return _this;
    }

    _createClass(List, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.loadDataByUserName();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.pbajax.cancel();
        }
    }, {
        key: 'loadDataByUserName',
        value: function loadDataByUserName() {
            var _this2 = this;

            if (this.fetching) {
                return false;
            }
            this.fetching = true;

            var _listpb$Room$NormalIn = _history2.default.Room.NormalIntoHistory,
                Request = _listpb$Room$NormalIn.Request,
                Response = _listpb$Room$NormalIn.Response;

            var defer = $.Deferred();
            var businessData = new Request({
                page: this.page,
                pageSize: this.pageSize
            });

            this.pbajax.do({
                service: 'room',
                api: '/room/normal/into/history',
                header: {
                    userToken: UP.Global.getUserToken(),
                    'Accept-Language': UP.Global.siteLanguage
                }
            }, businessData, function (res) {

                var dataWrap = _public2.default.Result.decode(res);

                if (dataWrap.code == 1) {
                    _this2.fetching = false;
                    var dataAll = void 0,
                        data = [];

                    if (dataWrap.data.value) {
                        dataAll = Response.decode(dataWrap.data.value);
                        data = dataAll.intoHistoryInfos;
                    }

                    var list = _this2.state.list;

                    var newState = {
                        list: [].concat(_toConsumableArray(list), _toConsumableArray(data))
                    };

                    // 数据加载完
                    _this2.dataOver = true;
                    newState.isLoading = false;

                    if (_this2.first) {
                        if (data.length == 0) {
                            newState.isEmpty = true;
                        }
                    } else {
                        newState.isEnd = true;
                    }
                    if (_this2.first) {
                        // 第一页
                        _this2.first = false;
                    }

                    _this2.setState(Object.assign({}, _this2.state, newState));
                } else {
                    _this2.setState({
                        isLoading: false
                    });
                }
            }, function () {
                _this2.fetching = false;
                _this2.setState({
                    isLoading: false
                });
            });
        }
    }, {
        key: 'onClick',
        value: function onClick() {
            $.channel.emit('hideSearchResult');
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var list = this.state.list;
            var $list = [];
            var showList = ['username', 'gender', 'grade', 'signature'];

            list.slice(0, 5).forEach(function (obj, idx) {

                $list.push(_react2.default.createElement(_hostItem2.default, { key: obj.roomUid, item: obj, onClick: _this3.onClick, showList: showList }));
            });

            if (list.length > 5) {
                $list[$list.length] = _react2.default.createElement(
                    'div',
                    { className: 'more', key: $list.length + 1 },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: '/history' },
                        _lang2.default.template('查看更多')
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { ref: 'content' },
                _react2.default.createElement(_preventScroll2.default, null),
                _react2.default.createElement(
                    'ul',
                    null,
                    $list
                ),
                this.state.isLoading ? _react2.default.createElement(_loading2.default, null) : null,
                this.state.isEmpty ? _react2.default.createElement(
                    'li',
                    { className: 'list-tip' },
                    _lang2.default.template('没有浏览记录？')
                ) : null
            );
        }
    }]);

    return List;
}(_react.Component);

List.defaultProps = {
    threshold: 100,
    keyword: ''
};
;

exports.default = List;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

var _userUi = __webpack_require__(22);

var _observer = __webpack_require__(96);

var _observer2 = _interopRequireDefault(_observer);

var _number = __webpack_require__(44);

var _number2 = _interopRequireDefault(_number);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItem = function (_Component) {
    _inherits(ListItem, _Component);

    function ListItem(props) {
        _classCallCheck(this, ListItem);

        return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props));
    }

    _createClass(ListItem, [{
        key: "jumpProfile",
        value: function jumpProfile(item) {
            if (item.onlineFlag) {
                hashHistory.push("/living/" + longToString(item.roomUid) + "/" + longToString(item.roomId));
            } else {
                hashHistory.push("/profile/base/" + longToString(item.roomUid));
            }

            this.props.onClick();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var item = this.props.item;
            var linkTo = void 0;
            var diffTime = longToString(item.timeDifference);
            var timeStr = void 0;
            var notext = _index2.default.template('ta还没写签名呢，告诉ta?');
            timeStr = _number2.default.getDiffTime(diffTime);
            if (!item.signature) {
                item.signature = notext;
            }

            return _react2.default.createElement(
                "li",
                { "data-uid": item.roomUid, key: item.roomUid },
                _react2.default.createElement(
                    "div",
                    { className: "list-item", onClick: function onClick() {
                            return _this2.jumpProfile(item);
                        }, key: item.roomUid },
                    _react2.default.createElement(
                        "div",
                        { className: "avatar" },
                        _react2.default.createElement(
                            _observer2.default,
                            null,
                            function (isVisible) {
                                return _react2.default.createElement(_userUi.ImageView, { src: item.avatar, lazyload: true, size: 50, circle: true, isVisible: isVisible });
                            }
                        ),
                        item.officialAuth > 0 ? _react2.default.createElement(_userUi.OfficialAuth, { value: item.officialAuth }) : null
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "refbox" },
                        _react2.default.createElement(
                            "div",
                            { className: "user" },
                            this.props.showList.map(function (key, index) {
                                if (key == 'gender') {
                                    return item.gender ? _react2.default.createElement(_userUi.Gender, { key: "gender", value: item.gender }) : null;
                                }

                                if (key == 'grade') {
                                    return item.grade ? _react2.default.createElement(_userUi.Grade, { key: "grade", value: item.grade }) : null;
                                }
                                return _react2.default.createElement(
                                    "div",
                                    { key: index, className: key },
                                    item[key]
                                );
                            })
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "voice-box" },
                        item.onlineFlag ? _react2.default.createElement(
                            "div",
                            { className: "live" },
                            _react2.default.createElement("i", { className: "live-img" }),
                            _react2.default.createElement("em", null)
                        ) : null
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "time" },
                        timeStr
                    )
                )
            );
        }
    }]);

    return ListItem;
}(_react.Component);

ListItem.defaultProps = {
    item: {},
    onClick: function onClick() {},
    showList: ['username', 'gender', 'grade', 'signature']
};
exports.default = ListItem;

/***/ }),
/* 626 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Room.NormalIntoHistory",
    "options": {
        "java_package": "com.asiainno.uplive.proto",
        "objc_class_prefix": "RoomNormalIntoHistory"
    },
    "messages": [{
        "name": "Request",
        "fields": [{
            "rule": "optional",
            "type": "int32",
            "name": "page",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "pageSize",
            "id": 2
        }]
    }, {
        "name": "Response",
        "fields": [{
            "rule": "repeated",
            "type": "IntoHistoryInfo",
            "name": "intoHistoryInfos",
            "id": 1
        }]
    }, {
        "name": "IntoHistoryInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "roomUid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "roomId",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "timeDifference",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 5
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 7
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "onlineFlag",
            "id": 8
        }, {
            "rule": "optional",
            "type": "bool",
            "name": "privateLiveFlag",
            "id": 9
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "fee",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 11
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 12
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "vipLevel",
            "id": 13
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _listPannel = __webpack_require__(628);

var _listPannel2 = _interopRequireDefault(_listPannel);

var _rcTooltip = __webpack_require__(27);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _reactRouter = __webpack_require__(23);

var _loading = __webpack_require__(45);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeadFollow = function (_Component) {
	_inherits(HeadFollow, _Component);

	function HeadFollow(props) {
		_classCallCheck(this, HeadFollow);

		var _this = _possibleConstructorReturn(this, (HeadFollow.__proto__ || Object.getPrototypeOf(HeadFollow)).call(this, props));

		_this.gitList = function () {
			var counter = _this.state.counter;
			_this.setState({
				counter: counter + 1
			});
		};

		_this.state = {
			keyword: '',
			showSearchResult: false,
			counter: 0
		};
		return _this;
	}

	_createClass(HeadFollow, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var $pop = _react2.default.createElement(
				'div',
				{ key: this.state.counter, className: 's-result s-result-pop ' },
				_react2.default.createElement(
					'div',
					{ className: 's-result-scroller hostlist-lite' },
					_react2.default.createElement(_listPannel2.default, { showFollowInfo: 'true', ref: 'list' })
				)
			);

			return _react2.default.createElement(
				_rcTooltip2.default,
				{ getTooltipContainer: function getTooltipContainer() {
						return _this2.refs.follow;
					}, overlay: $pop, placement: 'bottom', trigger: ['hover'], overlayClassName: 'header-popover header-follow-popover' },
				_react2.default.createElement(
					'div',
					{ className: 'follow btn-head', ref: 'follow' },
					_react2.default.createElement(
						'div',
						{ className: 'result-pop-hd', ref: 'follow', onMouseEnter: this.gitList },
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: '/allhostlist/follow' },
							_lang2.default.template('关注')
						)
					)
				)
			);
		}
	}]);

	return HeadFollow;
}(_react.Component);

exports.default = HeadFollow;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pbajax = __webpack_require__(4);

var _pbajax2 = _interopRequireDefault(_pbajax);

var _cCache = __webpack_require__(3);

var _cCache2 = _interopRequireDefault(_cCache);

var _public = __webpack_require__(9);

var _public2 = _interopRequireDefault(_public);

var _followlist = __webpack_require__(629);

var _followlist2 = _interopRequireDefault(_followlist);

var _lang = __webpack_require__(1);

var _lang2 = _interopRequireDefault(_lang);

var _hostItem = __webpack_require__(630);

var _hostItem2 = _interopRequireDefault(_hostItem);

var _follow = __webpack_require__(97);

var _follow2 = _interopRequireDefault(_follow);

var _loading = __webpack_require__(45);

var _loading2 = _interopRequireDefault(_loading);

var _preventScroll = __webpack_require__(99);

var _preventScroll2 = _interopRequireDefault(_preventScroll);

var _reactRouter = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cache = new _cCache2.default({
    prefix: 'pcuplive'
});

var List = function (_Component) {
    _inherits(List, _Component);

    function List(props) {
        _classCallCheck(this, List);

        var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

        _this.state = {
            //keyword: props.keyword,
            list: [],
            isEmpty: false,
            isLoading: true,
            isEnd: false
        };

        _this.page = 1;
        _this.pageSize = 6;
        _this.pbajax = new _pbajax2.default();

        _this.fetching = false; // 加载状态加锁
        _this.first = true; // 第一页
        _this.dataOver = false; // 数据最后一页
        return _this;
    }

    _createClass(List, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.loadData();
        }

        // componentWillReceiveProps(props) {

        //     this.fetching = false; // 加载状态加锁
        //     this.first = true; // 第一页
        //     this.dataOver = false // 数据最后一页
        //     this.page = 1

        //     this.setState({
        //         list: [],
        //         isLoading: false,
        //         isEmpty: false,
        //         isEnd: false,
        //         //keyword: props.keyword
        //     }, ()=>{
        //         this.loadData();
        //     });

        // }

    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.pbajax.cancel();
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            this.loadDataByUserName();
        }
    }, {
        key: 'loadDataByUserName',
        value: function loadDataByUserName() {
            var _this2 = this;

            if (this.fetching) {
                return;
            }
            this.fetching = true;
            var self = this;
            var defer = $.Deferred();
            var _hostlistpb$Feed$Foll = _followlist2.default.Feed.FollowList,
                Request = _hostlistpb$Feed$Foll.Request,
                Response = _hostlistpb$Feed$Foll.Response;

            var businessData = new Request({
                page: this.page,
                pageSize: this.pageSize
            });

            this.pbajax.do({
                service: 'service',
                api: '/feed/follow/list',
                header: {
                    lang: UP.Global.siteLanguage,
                    userToken: UP.Global.getUserToken()
                }
            }, businessData, function (res) {

                _this2.fetching = false;
                var dataWrap = _public2.default.Result.decode(res);

                if (dataWrap.code == 1) {

                    var dataAll = void 0,
                        data = [];

                    if (dataWrap.data.value) {
                        dataAll = Response.decode(dataWrap.data.value);
                        data = dataAll.infos;
                    }

                    var list = _this2.state.list;
                    var newState = {
                        list: [].concat(_toConsumableArray(list), _toConsumableArray(data))
                    };

                    newState.isLoading = false;

                    if (data.length < _this2.pageSize) {
                        // 数据加载完
                        _this2.dataOver = true;

                        if (_this2.first) {
                            if (data.length == 0) {
                                newState.isEmpty = true;
                            }
                        } else {
                            newState.isEnd = true;
                        }
                    }

                    if (_this2.first) {
                        // 第一页
                        _this2.first = false;
                    }

                    newState = Object.assign({}, _this2.state, newState);

                    _this2.setState(_extends({}, newState));
                }
            }, function () {
                _this2.fetching = false;
            });

            this.page = this.page + 1;
        }
    }, {
        key: 'onClick',
        value: function onClick() {
            $.channel.emit('hideSearchResult');
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var list = this.state.list;
            var $list = [];
            var showList = ['username', 'gender', 'grade', 'roomTitle'];

            list.slice(0, 5).forEach(function (obj, idx) {
                $list.push(_react2.default.createElement(_hostItem2.default, { key: obj.uid, item: obj, onClick: _this3.onClick, showList: showList }));
            });

            if (list.length > 5) {
                $list[$list.length] = _react2.default.createElement(
                    'div',
                    { className: 'more', key: $list.length + 1 },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: '/allhostlist/follow' },
                        _lang2.default.template('查看更多')
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { ref: 'content' },
                _react2.default.createElement(_preventScroll2.default, null),
                _react2.default.createElement(
                    'ul',
                    null,
                    $list
                ),
                this.state.isLoading ? _react2.default.createElement(_loading2.default, null) : null,
                this.state.isEmpty ? _react2.default.createElement(
                    'li',
                    { className: 'list-tip' },
                    _lang2.default.template('你关注的人还没有直播')
                ) : null
            );
        }
    }]);

    return List;
}(_react.Component);

List.defaultProps = {
    threshold: 100,
    keyword: ''
};
;

exports.default = List;

/***/ }),
/* 629 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "LiveDetailInfo",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "uid",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "username",
            "id": 2
        }, {
            "rule": "optional",
            "type": "string",
            "name": "avatar",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "gender",
            "id": 4
        }, {
            "rule": "optional",
            "type": "string",
            "name": "signature",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "grade",
            "id": 6
        }, {
            "rule": "optional",
            "type": "string",
            "name": "location",
            "id": 7
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "roomId",
            "id": 8
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "onlineTotal",
            "id": 9
        }, {
            "rule": "optional",
            "type": "string",
            "name": "roomTitle",
            "id": 10
        }, {
            "rule": "optional",
            "type": "string",
            "name": "liveMsg",
            "id": 11
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "officialAuth",
            "id": 12
        }, {
            "rule": "optional",
            "type": "string",
            "name": "officialAuthContent",
            "id": 13
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "qualityAuth",
            "id": 14
        }, {
            "rule": "optional",
            "type": "string",
            "name": "upliveCode",
            "id": 15
        }, {
            "rule": "optional",
            "type": "string",
            "name": "countryCode",
            "id": 16
        }, {
            "rule": "optional",
            "type": "double",
            "name": "distance",
            "id": 17
        }]
    }, {
        "name": "BannerInfo",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "images",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "rank",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "endTime",
            "id": 3
        }, {
            "rule": "optional",
            "type": "string",
            "name": "jump",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "type",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "activeBeginTime",
            "id": 6
        }, {
            "rule": "optional",
            "type": "int32",
            "name": "activeEndTime",
            "id": 7
        }, {
            "rule": "optional",
            "type": "string",
            "name": "activeLabel",
            "id": 8
        }]
    }, {
        "name": "Feed",
        "fields": [],
        "messages": [{
            "name": "FollowList",
            "fields": [],
            "options": {
                "objc_class_prefix": "FeedFollowList",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "int32",
                    "name": "page",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "pageSize",
                    "id": 2
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "repeated",
                    "type": "LiveDetailInfo",
                    "name": "infos",
                    "id": 2
                }, {
                    "rule": "repeated",
                    "type": "BannerInfo",
                    "name": "banners",
                    "id": 3
                }]
            }]
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

var _userUi = __webpack_require__(22);

var _observer = __webpack_require__(96);

var _observer2 = _interopRequireDefault(_observer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItem = function (_Component) {
    _inherits(ListItem, _Component);

    function ListItem(props) {
        _classCallCheck(this, ListItem);

        return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props));
    }

    _createClass(ListItem, [{
        key: "jumpProfile",
        value: function jumpProfile(item) {
            hashHistory.push("/living/" + longToString(item.uid) + "/" + longToString(item.roomId));
            this.props.onClick();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var item = this.props.item;

            return _react2.default.createElement(
                "li",
                { "data-uid": item.uid, key: item.uid },
                _react2.default.createElement(
                    "div",
                    { className: "list-item", onClick: function onClick() {
                            return _this2.jumpProfile(item);
                        }, key: item.roomUid },
                    _react2.default.createElement(
                        "div",
                        { className: "avatar" },
                        _react2.default.createElement(
                            _observer2.default,
                            null,
                            function (isVisible) {
                                return _react2.default.createElement(_userUi.ImageView, { src: item.avatar, lazyload: true, size: 50, circle: true, isVisible: isVisible });
                            }
                        ),
                        item.officialAuth > 0 ? _react2.default.createElement(_userUi.OfficialAuth, { value: item.officialAuth }) : null
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "refbox" },
                        _react2.default.createElement(
                            "div",
                            { className: "user" },
                            this.props.showList.map(function (key, index) {
                                if (key == 'gender') {
                                    return item.gender ? _react2.default.createElement(_userUi.Gender, { key: "gender", value: item.gender }) : null;
                                }

                                if (key == 'grade') {
                                    return item.grade ? _react2.default.createElement(_userUi.Grade, { key: "grade", value: item.grade }) : null;
                                }

                                return _react2.default.createElement(
                                    "div",
                                    { key: index, className: key },
                                    item[key]
                                );
                            })
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "voice-box" },
                        _react2.default.createElement(
                            "div",
                            { className: "live" },
                            _react2.default.createElement("i", { className: "live-img" }),
                            _react2.default.createElement("em", null)
                        )
                    )
                )
            );
        }
    }]);

    return ListItem;
}(_react.Component);

ListItem.defaultProps = {
    item: {},
    onClick: function onClick() {},
    showList: ['username', 'gender', 'grade', 'roomTitle']
};
exports.default = ListItem;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8ae69ceb51e73e026745e0896792ea3d.jpg";

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "27b85e99557213d9e21ef03b7eadf093.jpg";

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9f2721974423b04a48c32494463aa9e3.jpg";

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e3755a0811da558b221ff3b585ae9b04.jpg";

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b323ca02349313c8b732252f6bcd00b9.jpg";

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a93c8dc2ebcf0c67171ca2fb55b4856a.jpg";

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d2b67e16e2fdec72aa29051bddf74e83.jpg";

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eec38171cb15f6c8ce4fa42ff0582ecf.jpg";

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0544d8c3aeafea58d61e018a3c68611c.jpg";

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e4a63de0f61f3bdfefe78758ab078f60.jpg";

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e8244270e0189d9e17bbab115fde9ac1.jpg";

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "08accb97578101bdf3e9e896422b10bb.jpg";

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "af3935de6b25d6075cd710438fc624c9.jpg";

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d2f5392cabf37fb3978a3c2bbc6c4813.jpg";

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ae3e6b06459735f9aebe12d21daa2a2d.jpg";

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "04d6ac657a1ad8c537cceb5bd1ec8b53.jpg";

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "210e8489e9d16cdd46347eaee3bb3cc9.jpg";

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0fd03c905f2016fadaefcfa2cb6c434e.jpg";

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "975745f68624336451967331292b6269.jpg";

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "008eabc78179726b714f6b813df798c9.jpg";

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _qrcode = __webpack_require__(90);

var _qrcode2 = _interopRequireDefault(_qrcode);

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(1);

var _index2 = _interopRequireDefault(_index);

var _download = __webpack_require__(245);

var _download2 = _interopRequireDefault(_download);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Download = function (_Component) {
    _inherits(Download, _Component);

    function Download(props) {
        _classCallCheck(this, Download);

        var _this = _possibleConstructorReturn(this, (Download.__proto__ || Object.getPrototypeOf(Download)).call(this, props));

        _this.renderQrcode = function () {
            var android = $(_this.refs.android);
            var ios = $(_this.refs.apple);
            var google = $(_this.refs.google);

            android.qrcode({
                text: android.data('link'),
                width: 90,
                height: 90,
                render: "canvas"
            });

            ios.qrcode({
                text: ios.data('link'),
                width: 90,
                height: 90,
                render: "canvas"
            });

            google.qrcode({
                text: google.data('link'),
                width: 90,
                height: 90,
                render: "canvas"
            });
        };

        _this.state = {
            apple: '',
            google: '',
            android: ''
        };

        _this.downloads = [{
            key: 'android',
            channel: 'Android',
            text: 'Android Apk',
            link: _download2.default.downloadUrl['android']
        }, {
            key: 'apple',
            channel: 'IOS',
            text: 'App Store',
            link: _download2.default.downloadUrl['apple']
        }, {
            key: 'google',
            channel: 'Google',
            text: 'Google Play',
            link: _download2.default.downloadUrl['google']
        }];
        return _this;
    }

    _createClass(Download, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.renderQrcode();
        }
    }, {
        key: "onClick",
        value: function onClick(channel) {
            UP.Global.DA.add({
                eventName: 'Download',
                action: 'click',
                label: channel
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                "div",
                { className: "download-pop" },
                _react2.default.createElement(
                    "div",
                    { className: "download-pop-hd" },
                    _react2.default.createElement("i", null),
                    _react2.default.createElement(
                        "h4",
                        null,
                        _index2.default.template('扫码下载Uplive客户端')
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "download-pop-bd" },
                    _react2.default.createElement(
                        "ul",
                        null,
                        this.downloads.map(function (item, index) {
                            return _react2.default.createElement(
                                "li",
                                { className: item.key, key: item.key },
                                _react2.default.createElement(
                                    "div",
                                    { className: "qrcode", ref: item.key, "data-link": item.link },
                                    _react2.default.createElement("i", null)
                                ),
                                _react2.default.createElement(
                                    "a",
                                    { onClick: _this2.onClick.bind(_this2, item.channel), href: item.link, target: "_blank" },
                                    _react2.default.createElement("i", null),
                                    _react2.default.createElement(
                                        "span",
                                        { className: "txt" },
                                        item.text
                                    )
                                )
                            );
                        })
                    )
                )
            );
        }
    }]);

    return Download;
}(_react.Component);

exports.default = Download;

/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
// let normalFacebook = require('../../images/home-new/nomal-facebook.png');
// let hoverFacebook = require('../../images/home-new/hover-facebook.png');
// let normalIns = require('../../images/home-new/nomal-ins.png');
// let hoverIns = require('../../images/home-new/hover-ins.png');
// let normalTwitter = require('../../images/home-new/nomal-twitter.png');
// let hoverTwitter = require('../../images/home-new/hover-twitter.png');
// let normalYoutube = require('../../images/home-new/nomal-youtube.png');
// let hoverYoutube = require('../../images/home-new/hover-youtube.png');
// let normalWeibo = require('../../images/home-new/nomal-weibo.png');
// let hoverWeibo = require('../../images/home-new/hover-weibo.png');
// let normalWeixin = require('../../images/home-new/nomal-weixin.png');
// let hoverWeixin = require('../../images/home-new/hover-weixin.png');
// let normalTook = require('../../images/home-new/nomal-talk.png');
// let hoverTook = require('../../images/home-new/hover-talk.png');

var imgList = {
    CN: [{
        name: 'weibo',
        path: "https://weibo.com/5893889922/profile?topnav=1&wvr=6",
        show: false
    }, {
        name: 'weixin',
        path: "https://mp.weixin.qq.com/",
        show: true
    }],
    TW: [{
        name: 'facebook',
        path: "https://www.facebook.com/uplivecam/",
        show: false
    }, {
        name: 'ins',
        path: "https://www.instagram.com/uplivetw/",
        show: false
    }, {
        name: 'youtube',
        path: "https://www.youtube.com/channel/UCzF0x8cLMXgtUlsp7zmT9cQ",
        show: false
    }],
    HK: [{
        name: 'facebook',
        path: "https://www.facebook.com/uplivehk/",
        show: false
    }, {
        name: 'ins',
        path: "https://www.instagram.com/uplive_hk/",
        show: false
    }, {
        name: 'youtube',
        path: "https://www.youtube.com/channel/UC0AUKvOH-Lpw6kEpGt3WF7g?view_as=subscriber",
        show: false
    }],
    ID: [{
        name: 'facebook',
        path: "https://www.facebook.com/upliveofficial",
        show: false
    }, {
        name: 'ins',
        path: "https://www.instagram.com/uplive.indo/",
        show: false
    }, {
        name: 'twitter',
        path: "https://twitter.com/IndonesiaUplive?lang=zh-cn",
        show: false
    }, {
        name: 'youtube',
        path: "https://www.youtube.com/channel/UCKZSBr80lZ5h-svP-9_VsEg",
        show: false
    }],
    US: [{
        name: 'facebook',
        path: "https://www.facebook.com/uplive.usa",
        show: false
    }, {
        name: 'ins',
        path: "https://www.instagram.com/uplive.usa/",
        show: false
    }, {
        name: 'twitter',
        path: "https://twitter.com/UpliveUSA",
        show: false
    }, {
        name: 'youtube',
        path: "https://www.youtube.com/channel/UCfSiViz7kKE9Yt7LYEcj8xA",
        show: false
    }],
    MSL: [{
        name: 'facebook',
        path: "https://www.facebook.com/UpliveArabApp/",
        show: false
    }, {
        name: 'ins',
        path: "https://www.instagram.com/uplivearab/",
        show: false
    }, {
        name: 'twitter',
        path: "https://twitter.com/Uplive_Arab",
        show: false
    }, {
        name: 'youtube',
        path: "https://www.youtube.com/channel/UCMrSHTXPQQT3JK1KxPgvpew/featured",
        show: false
    }],
    MY: [{
        name: 'facebook',
        path: "https://www.facebook.com/UpliveMsia/",
        show: false
    }, {
        name: 'ins',
        path: "https://www.instagram.com/uplive_msia/",
        show: false
    }],
    KR: [{
        name: 'facebook',
        path: "https://www.facebook.com/Uplive.kr/",
        show: false
    }, {
        name: 'ins',
        path: "https://www.instagram.com/uplivekr_official/",
        show: false
    }, { //需要地址
        name: 'kakao',
        path: "https://pf.kakao.com/_bnZkxl",
        show: false
    }],
    JP: [{
        name: 'facebook',
        path: "https://www.facebook.com/Asia-Innovations-Japan-%E6%A0%AA%E5%BC%8F%E4%BC%9A%E7%A4%BE-285147232081394/?modal=admin_todo_tour",
        show: false
    }, {
        name: 'ins',
        path: "https://www.instagram.com/uplive_jp/?hl=ja",
        show: false
    }, {
        name: 'twitter',
        path: "https://twitter.com/uplivejp?lang=ja",
        show: false
    }, {
        name: 'youtube',
        path: "https://www.youtube.com/channel/UC9v3b0rgFQTNJN8xb6_QmZg",
        show: false
    }],
    VN: [{
        name: 'facebook',
        path: "https://www.facebook.com/uplivevn/",
        show: false
    }, {
        name: 'ins',
        path: "https://www.instagram.com/uplive.vn/",
        show: false
    }, {
        name: 'youtube',
        path: "https://www.youtube.com/channel/UCLunRQAsZUHHGOIJ_CPt9Sg",
        show: false
    }],
    IN: [{
        name: 'facebook',
        path: "https://www.facebook.com/UpliveIndia/",
        show: false
    }, {
        name: 'ins',
        path: "https://www.instagram.com/upliveindia/",
        show: false
    }, {
        name: 'twitter',
        path: "https://twitter.com/upliveindia",
        show: false
    }]
};

exports.default = imgList;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "666824e15c078877c10f2c5306bb6abd.jpg";

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "74316b8b3af1c3fd559505ae77dcd8c2.jpg";

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "769383b65c15776a2caa3b86e6166484.jpg";

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(154);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(155);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(1);

var _index6 = _interopRequireDefault(_index5);

var _ScaleModal = __webpack_require__(12);

var _ScaleModal2 = _interopRequireDefault(_ScaleModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 首页
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var noop = function noop() {};

var style = {
    modalStyle: {
        width: '500px'
    },
    contentStyle: {
        width: '500px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        backgroundColor: "rgba(0,0,0, 0.5)"
    }
};

var News = function (_Component) {
    _inherits(News, _Component);

    function News(props) {
        _classCallCheck(this, News);

        var _this = _possibleConstructorReturn(this, (News.__proto__ || Object.getPrototypeOf(News)).call(this, props));

        _this.handleClick = function (e) {
            var userInfo = UP.Global.getUser();
            var origin = void 0;
            var params = void 0;
            var url = void 0;

            if (location.host == 'h5.upliveapp.com') {
                origin = 'http://h5.upliveapp.com';
            } else {
                origin = 'http://m.upliveapps.com';
            }

            params = {
                uid: userInfo.uid,
                country: userInfo.countryCode,
                language: UP.Global.siteLanguage,
                level: userInfo.grade
            };

            url = origin + '/upservice/custom.html?' + $.param(params);

            location.href = url;
        };

        _this.buy = function () {
            _this.refs.pop.show();
        };

        _this.state = {
            list: []
        };
        return _this;
    }

    _createClass(News, [{
        key: 'componentWillMount',
        value: function componentWillMount() {}
    }, {
        key: 'onClose',
        value: function onClose() {
            this.refs.pop.hide();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'news' },
                _react2.default.createElement(_index2.default, { selected: 'news' }),
                _react2.default.createElement(
                    'div',
                    { className: 'news-wrapper' },
                    _react2.default.createElement(
                        'h2',
                        null,
                        _index6.default.template('收费资讯')
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'news-container' },
                        _react2.default.createElement(
                            'ul',
                            null,
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'h3',
                                    null,
                                    '\u4E91\u667A\u8054\u9AD8\u7AEF\u827A\u4EBA\u5316\u5986\u6280\u5DE7'
                                ),
                                _react2.default.createElement(
                                    'em',
                                    null,
                                    '\xA550'
                                ),
                                _react2.default.createElement(
                                    'button',
                                    { onClick: this.buy },
                                    '\u4ED8\u8D39\u6D4F\u89C8'
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'h3',
                                    null,
                                    '\u4E91\u667A\u8054\u9AD8\u7AEF\u827A\u4EBA\u5531\u6B4C\u6280\u5DE7'
                                ),
                                _react2.default.createElement(
                                    'em',
                                    null,
                                    '\xA550'
                                ),
                                _react2.default.createElement(
                                    'button',
                                    { onClick: this.buy },
                                    '\u4ED8\u8D39\u6D4F\u89C8'
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'h3',
                                    null,
                                    '\u4E91\u667A\u8054\u9AD8\u7AEF\u827A\u4EBA\u8868\u6F14\u6280\u5DE7'
                                ),
                                _react2.default.createElement(
                                    'em',
                                    null,
                                    '\xA550'
                                ),
                                _react2.default.createElement(
                                    'button',
                                    { onClick: this.buy },
                                    '\u4ED8\u8D39\u6D4F\u89C8'
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'h3',
                                    null,
                                    '\u4E91\u667A\u8054\u827A\u4EBA\u7A7F\u8863\u6280\u5DE7'
                                ),
                                _react2.default.createElement(
                                    'em',
                                    null,
                                    '\xA550'
                                ),
                                _react2.default.createElement(
                                    'button',
                                    { onClick: this.buy },
                                    '\u4ED8\u8D39\u6D4F\u89C8'
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'h3',
                                    null,
                                    '\u4E91\u667A\u8054\u827A\u4EBA\u804A\u5929\u6280\u5DE7'
                                ),
                                _react2.default.createElement(
                                    'em',
                                    null,
                                    '\xA550'
                                ),
                                _react2.default.createElement(
                                    'button',
                                    { onClick: this.buy },
                                    '\u4ED8\u8D39\u6D4F\u89C8'
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'h3',
                                    null,
                                    '\u4E91\u667A\u8054\u7537\u795E\uFF0F\u5973\u795E\u5FC3\u7406\u517B\u6210\u6280\u5DE7'
                                ),
                                _react2.default.createElement(
                                    'em',
                                    null,
                                    '\xA550'
                                ),
                                _react2.default.createElement(
                                    'button',
                                    { onClick: this.buy },
                                    '\u4ED8\u8D39\u6D4F\u89C8'
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'h3',
                                    null,
                                    '\u4E91\u667A\u8054\u7537\u795E\uFF0F\u5973\u795E\u6C14\u8D28\u517B\u6210\u6280\u5DE7'
                                ),
                                _react2.default.createElement(
                                    'em',
                                    null,
                                    '\xA550'
                                ),
                                _react2.default.createElement(
                                    'button',
                                    { onClick: this.buy },
                                    '\u4ED8\u8D39\u6D4F\u89C8'
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    'h3',
                                    null,
                                    '\u4E91\u667A\u8054\u827A\u4EBA\u80A2\u4F53\u8BED\u8A00'
                                ),
                                _react2.default.createElement(
                                    'em',
                                    null,
                                    '\xA550'
                                ),
                                _react2.default.createElement(
                                    'button',
                                    { onClick: this.buy },
                                    '\u4ED8\u8D39\u6D4F\u89C8'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _ScaleModal2.default,
                        {
                            ref: 'pop',
                            closeOnClick: false,
                            modalStyle: style.modalStyle,
                            backdropStyle: style.backdropStyle,
                            contentStyle: style.contentStyle
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'bind-pop' },
                            _react2.default.createElement(
                                'div',
                                { className: 'box' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'bind-pop-hd' },
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'close', onClick: function onClick() {
                                                return _this2.onClose();
                                            } },
                                        'x'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'wechat-bind clearfix' },
                                    _react2.default.createElement('img', { src: __webpack_require__(658) }),
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'desc' },
                                        '\u9009\u62E9\u5E0C\u671B\u8D2D\u4E70\u7684\u4EA7\u54C1\uFF0C\u5E76\u5728\u4ED8\u6B3E\u540E\u901A\u8FC7app\u5185\u7684\u5B98\u65B9\u5BA2\u670D\u8FDB\u884C\u8054\u7CFB\uFF0C\u4E5F\u53EF\u901A\u8FC7',
                                        _react2.default.createElement(
                                            'em',
                                            null,
                                            'upcs@asiainnovations.com'
                                        ),
                                        '\u4EE5\u90AE\u4EF6\u7684\u65B9\u5F0F\u8FDB\u884C\u8054\u7CFB\uFF0C\u5B98\u65B9\u5DE5\u4F5C\u4EBA\u5458\u5728\u786E\u5B9A\u6536\u6B3E\u540E\uFF0C\u4F1A\u8FDB\u884C\u53D1\u8D27\u3002'
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'content-tip', onClick: this.handleClick },
                        _index6.default.template('付款遇到问题？点击联系客服')
                    )
                )
            );
        }
    }]);

    return News;
}(_react.Component);

exports.default = News;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "844749a91ba91d918baddfe1d2485460.jpg";

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cNotification = __webpack_require__(11);

var _cNotification2 = _interopRequireDefault(_cNotification);

var _index = __webpack_require__(253);

var _index2 = _interopRequireDefault(_index);

var _livend = __webpack_require__(254);

var _livend2 = _interopRequireDefault(_livend);

var _timeout = __webpack_require__(255);

var _timeout2 = _interopRequireDefault(_timeout);

var _flv = __webpack_require__(261);

var _flv2 = _interopRequireDefault(_flv);

var _index3 = __webpack_require__(1);

var _index4 = _interopRequireDefault(_index3);

var _queueanim = __webpack_require__(262);

var _queueanim2 = _interopRequireDefault(_queueanim);

var _voice = __webpack_require__(263);

var _voice2 = _interopRequireDefault(_voice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 单个视频播放
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var VideoLayer = function (_Component) {
    _inherits(VideoLayer, _Component);

    function VideoLayer(props) {
        _classCallCheck(this, VideoLayer);

        var _this = _possibleConstructorReturn(this, (VideoLayer.__proto__ || Object.getPrototypeOf(VideoLayer)).call(this, props));

        _this.play = function (e) {
            _this.setState({
                loading: true
            });

            _this.createVideo();
        };

        _this.onMouseOver = function (e) {

            if (_this.flv) {
                _this.flv.showControlBar();
            }

            _this.setState({
                showButton: true
            });

            _this.hideTimer && clearTimeout(_this.hideTimer);
        };

        _this.onMouseOut = function (e) {
            _this.hideTimer = setTimeout(function () {
                if (_this.flv) {
                    _this.flv.hideControlBar();
                }

                _this.setState({
                    showButton: false
                });
            }, 1 * 1000);
        };

        _this.goRoom = function (e) {
            hashHistory.push("living/" + _this.state.hostid + '/' + _this.state.roomid);
        };

        _this.state = {
            liveMsg: {}, // 直播流地址
            roomid: props.roomid,
            hostid: props.hostid, // 主播uid
            hostAvatar: props.avatar, // 主播头像
            enterRoomSuccess: false, // 是否成功进入直播间
            hostStopLive: null, // 主播是否停止直播
            enterRoomTimeout: null, // 进入房间是否超时
            loading: true,
            showButton: false,
            voiceFlag: false
        };
        return _this;
    }
    // componentWillReceiveProps(nextProps) {
    //     this.setState({
    //         hostid: nextProps.hostid,
    //         roomid: nextProps.roomid,
    //         avatar: nextProps.avatar                
    //     }, ()=> {
    //         this.play();
    //     });
    // }

    _createClass(VideoLayer, [{
        key: 'onEnterRoomSuccess',


        // 成功进入房间
        value: function onEnterRoomSuccess(resp) {
            var _this2 = this;

            this.setState({
                liveMsg: JSON.parse(resp.liveMsg),
                voiceFlag: resp.voiceFlag,
                enterRoomSuccess: true,
                enterRoomTimeout: false,
                hostStopLive: false
            }, function () {
                _this2.play();
                _this2.bindEvent();
            });
        }
    }, {
        key: 'bindEvent',
        value: function bindEvent() {
            var _this3 = this;

            var nodeWrap = $(this.refs.wrap);

            nodeWrap.on('mouseover', '.vcp-controls-panel', function (e) {
                _this3.hideTimer && clearTimeout(_this3.hideTimer);
            });

            nodeWrap.on('mouseover', '.vjs-controls', function (e) {
                _this3.hideTimer && clearTimeout(_this3.hideTimer);
            });

            nodeWrap.on('mouseover', '.btn-enter', function (e) {
                _this3.hideTimer && clearTimeout(_this3.hideTimer);
            });
        }
    }, {
        key: 'onEnterRoomFail',
        value: function onEnterRoomFail(code) {
            var self = this;
            var tip = void 0;

            switch (code) {
                // 主播停播
                case 20482:
                    this.setState({
                        hostStopLive: true,
                        enterRoomSuccess: false,
                        enterRoomTimeout: false
                    });
                    break;
                // 被踢出
                case 20490:
                    tip = _index4.default.template('您已被移出直播间，请稍后再试');
                    _cNotification2.default.simple(tip);
                    break;
                case 4096:
                    tip = _index4.default.template('参数错误');
                    _cNotification2.default.simple(tip);
                    break;
                case 8192:
                    $.channel.emit('login');
                    return;
                default:
                    tip = _index4.default.template('系统错误');
                    _cNotification2.default.simple(tip);
                    break;
            }
        }
    }, {
        key: 'onEnterRoomTimeout',
        value: function onEnterRoomTimeout() {
            this.setState({
                enterRoomTimeout: true,
                enterRoomSuccess: false,
                hostStopLive: false
            });
        }
    }, {
        key: 'createVideo',
        value: function createVideo() {
            var _this4 = this;

            var self = this;
            var liveMsg = this.state.liveMsg;


            if (!liveMsg.flv) {
                return;
            }

            var flv = this.flv = new _flv2.default({
                wrap: $(".J_VideoWrap", $(this.refs.wrap)),
                source: liveMsg.flv,
                id: this.props.videoid
            });

            flv.on("start", function (player) {

                _this4.setState({
                    videoPlaying: true
                });

                setTimeout(function () {
                    _this4.setState({
                        loading: false
                    }, function () {
                        $(self.refs.videomask).removeClass('hidden');
                        $(self.refs.poster).remove();
                        this.onPlayStart();
                    });
                }, 2 * 1000);
            });

            flv.on('fullscreen', function () {
                _this4.setState({
                    showButton: false
                });
            });

            flv.play();

            // 如果10s后视频没有播放，则判断为浏览器flash插件不可用
            this.__timer = setTimeout(function () {
                if (!_this4.state.videoPlaying) {
                    _this4.setState({
                        loading: false
                    }, function () {
                        $(self.refs.poster).remove();
                        $(self.refs.videomask).addClass('hidden');
                        $(self.refs.videoWrap).addClass('no-flash');
                    });
                }
            }, 10 * 1000);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.flv && this.flv.destroy();
            this.__timer && clearTimeout(this.__timer);
            this.hideTimer && clearTimeout(this.hideTimer);
        }
    }, {
        key: 'reconnectRoom',
        value: function reconnectRoom() {
            this.refs.webchat.webchat.reinit();
        }
    }, {
        key: 'onPlayStart',
        value: function onPlayStart() {
            var node = $('.J_UpVoiceWrap');

            if (node.length > 0) {
                // if (UP.Global.isSafari) {
                node.remove();
                $('#J_VideoMini .vjs-controls').before($('<div class="video-voicebg" node-id="voice"></div>'));
                _queueanim2.default.play($('#J_VideoMini [node-id="voice"]'), _voice2.default.jsons, _voice2.default.mergePics);
                // } else {
                //     $(this.refs.videoWrap).addClass('upvoice');
                //     queueanim.play(node , voiceCfg.jsons, voiceCfg.mergePics);
                // }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var _state = this.state,
                hostStopLive = _state.hostStopLive,
                enterRoomTimeout = _state.enterRoomTimeout,
                enterRoomSuccess = _state.enterRoomSuccess;

            var $liveDom = void 0;

            if (enterRoomSuccess) {
                $liveDom = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'video-wrap J_VideoWrap', id: 'J_VideoMini', ref: 'videoWrap' },
                        this.state.voiceFlag ? _react2.default.createElement('div', { className: 'video-voicebg J_UpVoiceWrap', onMouseOver: this.onMouseOver, onMouseOut: this.onMouseOut }) : null,
                        _react2.default.createElement(
                            'div',
                            { ref: 'videomask', className: 'video-mask', onMouseOver: this.onMouseOver, onMouseOut: this.onMouseOut },
                            this.state.showButton ? _react2.default.createElement(
                                'button',
                                { className: 'enter btn-enter', onClick: this.goRoom },
                                _index4.default.template('进入直播间')
                            ) : null
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'poster', ref: 'poster' },
                        _react2.default.createElement('div', {
                            className: 'posterpic',
                            ref: 'avatar',
                            style: { backgroundImage: 'url(' + this.state.hostAvatar + ')' }
                        }),
                        this.state.loading ? _react2.default.createElement(
                            'div',
                            { className: 'liveroom-three-bounce' },
                            _react2.default.createElement('div', { className: 'one' }),
                            _react2.default.createElement('div', { className: 'two' }),
                            _react2.default.createElement('div', { className: 'three' })
                        ) : null
                    )
                );
            } else if (hostStopLive) {
                $liveDom = _react2.default.createElement(_livend2.default, { roomId: this.state.roomid });
            } else if (enterRoomTimeout) {
                $liveDom = _react2.default.createElement(_timeout2.default, { reconnectRoom: this.reconnectRoom.bind(this) });
            }

            return _react2.default.createElement(
                'div',
                { className: 'videoplay', ref: 'wrap' },
                $liveDom,
                _react2.default.createElement(_index2.default, _extends({}, this.props, {
                    roomid: this.state.roomid,
                    onEnterRoomSuccess: function onEnterRoomSuccess(resp) {
                        return _this5.onEnterRoomSuccess(resp);
                    },
                    onEnterRoomFail: this.onEnterRoomFail.bind(this),
                    onEnterRoomTimeout: this.onEnterRoomTimeout.bind(this),
                    ref: 'webchat'
                }))
            );
        }
    }]);

    return VideoLayer;
}(_react.Component);

VideoLayer.defaultProps = {
    roomid: '',
    hostid: '',
    avatar: '',
    videoid: '',
    onlyView: 1
};
exports.default = VideoLayer;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global) {
    'use strict';
    // existing version for noConflict()

    var _Base64 = global.Base64;
    var version = "2.1.9";
    // if node.js, we use Buffer
    var buffer;
    if (typeof module !== 'undefined' && module.exports) {
        try {
            buffer = __webpack_require__(661).Buffer;
        } catch (err) {}
    }
    // constants
    var b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    var b64tab = function (bin) {
        var t = {};
        for (var i = 0, l = bin.length; i < l; i++) {
            t[bin.charAt(i)] = i;
        }return t;
    }(b64chars);
    var fromCharCode = String.fromCharCode;
    // encoder stuff
    var cb_utob = function cb_utob(c) {
        if (c.length < 2) {
            var cc = c.charCodeAt(0);
            return cc < 0x80 ? c : cc < 0x800 ? fromCharCode(0xc0 | cc >>> 6) + fromCharCode(0x80 | cc & 0x3f) : fromCharCode(0xe0 | cc >>> 12 & 0x0f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
        } else {
            var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
            return fromCharCode(0xf0 | cc >>> 18 & 0x07) + fromCharCode(0x80 | cc >>> 12 & 0x3f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
        }
    };
    var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
    var utob = function utob(u) {
        return u.replace(re_utob, cb_utob);
    };
    var cb_encode = function cb_encode(ccc) {
        var padlen = [0, 2, 1][ccc.length % 3],
            ord = ccc.charCodeAt(0) << 16 | (ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8 | (ccc.length > 2 ? ccc.charCodeAt(2) : 0),
            chars = [b64chars.charAt(ord >>> 18), b64chars.charAt(ord >>> 12 & 63), padlen >= 2 ? '=' : b64chars.charAt(ord >>> 6 & 63), padlen >= 1 ? '=' : b64chars.charAt(ord & 63)];
        return chars.join('');
    };
    var btoa = global.btoa ? function (b) {
        return global.btoa(b);
    } : function (b) {
        return b.replace(/[\s\S]{1,3}/g, cb_encode);
    };
    var _encode = buffer ? function (u) {
        return (u.constructor === buffer.constructor ? u : new buffer(u)).toString('base64');
    } : function (u) {
        return btoa(utob(u));
    };
    var encode = function encode(u, urisafe) {
        return !urisafe ? _encode(String(u)) : _encode(String(u)).replace(/[+\/]/g, function (m0) {
            return m0 == '+' ? '-' : '_';
        }).replace(/=/g, '');
    };
    var encodeURI = function encodeURI(u) {
        return encode(u, true);
    };
    // decoder stuff
    var re_btou = new RegExp(['[\xC0-\xDF][\x80-\xBF]', '[\xE0-\xEF][\x80-\xBF]{2}', '[\xF0-\xF7][\x80-\xBF]{3}'].join('|'), 'g');
    var cb_btou = function cb_btou(cccc) {
        switch (cccc.length) {
            case 4:
                var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3),
                    offset = cp - 0x10000;
                return fromCharCode((offset >>> 10) + 0xD800) + fromCharCode((offset & 0x3FF) + 0xDC00);
            case 3:
                return fromCharCode((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
            default:
                return fromCharCode((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
        }
    };
    var btou = function btou(b) {
        return b.replace(re_btou, cb_btou);
    };
    var cb_decode = function cb_decode(cccc) {
        var len = cccc.length,
            padlen = len % 4,
            n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0) | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0) | (len > 2 ? b64tab[cccc.charAt(2)] << 6 : 0) | (len > 3 ? b64tab[cccc.charAt(3)] : 0),
            chars = [fromCharCode(n >>> 16), fromCharCode(n >>> 8 & 0xff), fromCharCode(n & 0xff)];
        chars.length -= [0, 0, 2, 1][padlen];
        return chars.join('');
    };
    var atob = global.atob ? function (a) {
        return global.atob(a);
    } : function (a) {
        return a.replace(/[\s\S]{1,4}/g, cb_decode);
    };
    var _decode = buffer ? function (a) {
        return (a.constructor === buffer.constructor ? a : new buffer(a, 'base64')).toString();
    } : function (a) {
        return btou(atob(a));
    };
    var decode = function decode(a) {
        return _decode(String(a).replace(/[-_]/g, function (m0) {
            return m0 == '-' ? '+' : '/';
        }).replace(/[^A-Za-z0-9\+\/]/g, ''));
    };
    var noConflict = function noConflict() {
        var Base64 = global.Base64;
        global.Base64 = _Base64;
        return Base64;
    };
    // export Base64
    global.Base64 = {
        VERSION: version,
        atob: atob,
        btoa: btoa,
        fromBase64: decode,
        toBase64: encode,
        utob: utob,
        encode: encode,
        encodeURI: encodeURI,
        btou: btou,
        decode: decode,
        noConflict: noConflict
    };
    // if ES5 is available, make Base64.extendString() available
    if (typeof Object.defineProperty === 'function') {
        var noEnum = function noEnum(v) {
            return { value: v, enumerable: false, writable: true, configurable: true };
        };
        global.Base64.extendString = function () {
            Object.defineProperty(String.prototype, 'fromBase64', noEnum(function () {
                return decode(this);
            }));
            Object.defineProperty(String.prototype, 'toBase64', noEnum(function (urisafe) {
                return encode(this, urisafe);
            }));
            Object.defineProperty(String.prototype, 'toBase64URI', noEnum(function () {
                return encode(this, true);
            }));
        };
    }
    // that's it!
    if (global['Meteor']) {
        Base64 = global.Base64; // for normal export in Meteor.js
    }
    if (typeof module !== 'undefined' && module.exports) {
        module.exports.Base64 = global.Base64;
    }
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
            return global.Base64;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
})(typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : undefined);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(101)))

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(662)
var ieee754 = __webpack_require__(663)
var isArray = __webpack_require__(664)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(101)))

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 663 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 664 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 665 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [{
        "name": "Room",
        "fields": [],
        "messages": [{
            "name": "WebNormalInto",
            "fields": [],
            "options": {
                "java_package": "com.asiainno.uplive.proto",
                "objc_class_prefix": "RoomWebNormalInto"
            },
            "messages": [{
                "name": "Request",
                "fields": [{
                    "rule": "optional",
                    "type": "int64",
                    "name": "roomId",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "WebType",
                    "name": "wType",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "bool",
                    "name": "checkLifted",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "bool",
                    "name": "agreePayFlag",
                    "id": 4
                }]
            }, {
                "name": "Response",
                "fields": [{
                    "rule": "optional",
                    "type": "string",
                    "name": "liveMsg",
                    "id": 1
                }, {
                    "rule": "optional",
                    "type": "int64",
                    "name": "uid",
                    "id": 2
                }, {
                    "rule": "optional",
                    "type": "int64",
                    "name": "liveTimes",
                    "id": 3
                }, {
                    "rule": "optional",
                    "type": "int64",
                    "name": "peoples",
                    "id": 4
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "acceptLanguage",
                    "id": 5
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "wsIp",
                    "id": 6
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "wsPort",
                    "id": 7
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "wsPath",
                    "id": 8
                }, {
                    "rule": "optional",
                    "type": "int64",
                    "name": "time",
                    "id": 9
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "nonce",
                    "id": 10
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "sec",
                    "id": 11
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "userInfo",
                    "id": 12
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "termType",
                    "id": 13
                }, {
                    "rule": "optional",
                    "type": "int64",
                    "name": "sid",
                    "id": 14
                }, {
                    "rule": "optional",
                    "type": "bool",
                    "name": "checkLiftedR",
                    "id": 15
                }, {
                    "rule": "repeated",
                    "type": "string",
                    "name": "userLabels",
                    "id": 16
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "labelHighest",
                    "id": 17
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "policyMsg",
                    "id": 18
                }, {
                    "rule": "optional",
                    "type": "bool",
                    "name": "dressingFlag",
                    "id": 19
                }, {
                    "rule": "optional",
                    "type": "int64",
                    "name": "fee",
                    "id": 20
                }, {
                    "rule": "optional",
                    "type": "bool",
                    "name": "privateLiveFlag",
                    "id": 21
                }, {
                    "rule": "optional",
                    "type": "int64",
                    "name": "diamond",
                    "id": 22
                }, {
                    "rule": "optional",
                    "type": "int64",
                    "name": "keepTime",
                    "id": 23
                }, {
                    "rule": "optional",
                    "type": "bool",
                    "name": "voiceFlag",
                    "id": 24
                }, {
                    "rule": "optional",
                    "type": "bool",
                    "name": "landscapeFlag",
                    "id": 25
                }, {
                    "rule": "optional",
                    "type": "LiveModel",
                    "name": "liveModel",
                    "id": 26
                }, {
                    "rule": "optional",
                    "type": "int32",
                    "name": "multiliving",
                    "id": 27
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "gameTag",
                    "id": 28
                }, {
                    "rule": "optional",
                    "type": "string",
                    "name": "multirateUrl",
                    "id": 29
                }]
            }],
            "enums": [{
                "name": "WebType",
                "values": [{
                    "name": "WEB",
                    "id": 0
                }, {
                    "name": "WAP",
                    "id": 1
                }]
            }]
        }]
    }],
    "enums": [{
        "name": "LiveModel",
        "values": [{
            "name": "LIVE",
            "id": 0
        }, {
            "name": "MAKEFRIEND",
            "id": 1
        }, {
            "name": "GAMELIVE",
            "id": 2
        }]
    }]
}).build();
exports.default = _root;

/***/ }),
/* 666 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Room.WebNormalPurlGet",
    "options": {
        "java_package": "com.asiainno.uplive.proto",
        "objc_class_prefix": "RoomWebNormalPurlGet"
    },
    "messages": [{
        "name": "Request",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "roomId",
            "id": 1
        }]
    }, {
        "name": "Response",
        "fields": [{
            "rule": "optional",
            "type": "string",
            "name": "purl",
            "id": 1
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "keepTime",
            "id": 2
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 667 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Room.AnchorDisabledGet",
    "options": {
        "java_package": "com.asiainno.uplive.proto",
        "objc_class_prefix": "RoomAnchorDisabledGet"
    },
    "messages": [{
        "name": "Request",
        "fields": [{
            "rule": "optional",
            "type": "int64",
            "name": "roomId",
            "id": 1
        }]
    }, {
        "name": "Response",
        "fields": [{
            "rule": "optional",
            "type": "Status",
            "name": "status",
            "id": 1
        }, {
            "rule": "optional",
            "type": "string",
            "name": "disabledDesc",
            "id": 2
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "liveTimes",
            "id": 3
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "moneyTotal",
            "id": 4
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "peoples",
            "id": 5
        }, {
            "rule": "optional",
            "type": "int64",
            "name": "likeNum",
            "id": 6
        }]
    }],
    "enums": [{
        "name": "Status",
        "values": [{
            "name": "OPEN",
            "id": 0
        }, {
            "name": "DISABLED",
            "id": 1
        }, {
            "name": "FORCE_DISABLED",
            "id": 2
        }]
    }]
}).build();

exports.default = _root;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.Stats = factory();
})(undefined, function () {
    'use strict';

    var SpriteAnim = function SpriteAnim(canvasId) {
        this.canvas = document.getElementById(canvasId); // Select given canvas ID
        this.context = this.canvas.getContext("2d"); // Get 2D context
    };
    // Start method
    SpriteAnim.prototype.start = function (spriteObj) {
        this.spriteObj = spriteObj;
        this.onStart(); // onStart callback function

        // Sprite Info
        this.width = this.spriteObj.canvasWidth; // Set canvas width
        this.height = this.spriteObj.canvasHeight; // Set canvas width
        this.scale = this.spriteObj.scale;
        this.offsetX = this.spriteObj.offsetX;
        this.offsetY = this.spriteObj.offsetY;
        this.frames = this.spriteObj.frames || [];
        this.totalFrames = this.frames.length;
        this.frameIndex = 0;

        this.canvas.width = this.width; // Set canvas width
        this.canvas.height = this.height; // Set canvas width
        this.context.scale(this.scale, this.scale);
        this.actualWidth = this.width / this.scale;
        this.actualHeight = this.height / this.scale;

        // FPS stuff
        this.fps = this.spriteObj.fps || 30;
        this.timestamp_init = Date.now(); // Before execution of ticker
        this.interval = 1000 / this.fps; // Frame's interval in ms 
        this.timestamp_now, this.delta; // Vars
        this.loopSprite = this.spriteObj.loop || false; // If should loop boolean
        this.playSprite = true; // Play state boolean

        this.canvasTicker(); // Start ticker
    };
    // Stop method
    SpriteAnim.prototype.stop = function () {
        this.playSprite = false;

        this.context.clearRect(0, 0, this.actualWidth, this.actualHeight);
    };
    // New tick update
    SpriteAnim.prototype.canvasUpdate = function () {
        if (this.frameIndex < this.totalFrames - 1) {
            this.frameIndex++;
            this.draw();
        } else {
            if (this.loopSprite) {
                this.frameIndex = 0;
                this.draw();
            } else {
                this.stop();
            }
            this.onComplete();
        }
    };
    // On start callback
    SpriteAnim.prototype.onStart = function () {
        if (this.spriteObj.onStart) {
            this.spriteObj.onStart();
        }
    };
    // On complete callback
    SpriteAnim.prototype.onComplete = function () {
        if (this.spriteObj.onComplete) {
            this.spriteObj.onComplete();
        }
    };
    // Draw new frame
    SpriteAnim.prototype.draw = function () {
        this.context.clearRect(0, 0, this.actualWidth, this.actualHeight);

        var frameData = this.frames[this.frameIndex];
        if (frameData) {
            // void ctx.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
            this.context.drawImage(frameData.image, frameData.sx, frameData.sy, frameData.sWidth, frameData.sHeight, frameData.dx + this.offsetX, frameData.dy + this.offsetY, frameData.dWidth, frameData.dHeight);
        }
    };
    // Ticker
    SpriteAnim.prototype.canvasTicker = function () {
        if (this.playSprite) {
            window.requestAnimationFrame(this.canvasTicker.bind(this));
            this.timestamp_now = Date.now();
            this.delta = this.timestamp_now - this.timestamp_init;
            if (this.delta > this.interval) {
                this.timestamp_init = this.timestamp_now - this.delta % this.interval;
                this.canvasUpdate();
            }
        }
    };
    return SpriteAnim;
});

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cUrl = __webpack_require__(5);

var _cUrl2 = _interopRequireDefault(_cUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var domain = document.domain; // 数据统计
// 国内 talkingdata 国外 google统计

var analyticsType = void 0;

// 国内
if (domain == 'www.upliveapp.com') {
    // 国内版本
    analyticsType = 'TD';
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = 'https://jic.talkingdata.com/app/h5/v1?appid=5FCD37898F444EFA973266234ED771D5&vn=beta&vc=1.0.0';
    var x = document.getElementsByTagName('script')[0];
    s.onload = function () {
        $.channel.emit('analyticsSeedLoaded');
    };
    x.parentNode.insertBefore(s, x);
} else if (domain == "up.live" || domain == "www.uplive.club" || domain == 'www.up.live') {
    // 台湾版本、中东版本
    analyticsType = 'GA';
    (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r;i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments);
        }, i[r].l = 1 * new Date();a = s.createElement(o), m = s.getElementsByTagName(o)[0];a.async = 1;
        a.onload = function () {
            $.channel.emit('analyticsSeedLoaded');
        };
        a.src = g;m.parentNode.insertBefore(a, m);
    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

    ga('create', 'UA-80499728-1', 'auto');
    ga('send', 'pageview');
}

var DA = {

    // 用于存放JS尚未加载的缓存事件列表
    // js加载完成后，依次发送到对应服务
    cacheList: [],

    cacheRichList: [],

    add: function add(obj) {
        var prefix = void 0;

        if (UP.Global.marketChannel) {
            prefix = UP.Global.marketChannel;
        }
        if (_cUrl2.default.query('debug')) {
            return;
        }
        if (analyticsType == 'TD') {
            // js已加载完成
            if (typeof TDAPP != 'undefined') {
                this._add(obj, 1); // 统计所有

                if (prefix) {
                    // 统计不同渠道
                    obj.eventName = prefix + obj.eventName;
                    this._add(obj);
                }
            } else {
                this.cacheList.push(obj);
            }
        } else if (analyticsType == 'GA') {
            if (typeof ga != 'undefined') {
                this._add(obj, 1); // 统计所有

                if (prefix) {
                    // 统计不同渠道
                    obj.eventName = prefix + ' ' + obj.eventName;
                    this._add(obj);
                }
            } else {
                this.cacheList.push(obj);
            }
        }
    },
    _add: function _add(obj, isAll) {

        if (analyticsType == 'TD') {
            var event = void 0;
            if (isAll) {
                event = obj.eventName;
            } else {
                event = obj.label ? obj.eventName + ' ' + obj.label : obj.eventName;
            }

            event = event.replace(/\s/g, '');

            TDAPP.onEvent(event);
        } else if (analyticsType == 'GA') {
            var sendObj = {
                hitType: 'event',
                eventCategory: obj.eventName,
                eventAction: obj.action
            };

            if (obj.label) {
                sendObj.eventLabel = obj.label;
            }

            if (obj.value) {
                sendObj.eventValue = obj.value;
            }
            ga('send', sendObj);
        }
    },


    // 允许TD做更多的参数收集
    addVerbone: function addVerbone(obj) {

        if (analyticsType == 'TD') {

            if (typeof TDAPP != 'undefined') {
                TDAPP.onEvent(obj.eventName, obj.label, obj.param);
            } else {
                this.cacheRichList.push(obj);
            }
        } else if (analyticsType == 'GA') {
            if (typeof ga != 'undefined') {
                var sendObj = {
                    hitType: 'event',
                    eventCategory: obj.eventName,
                    eventAction: obj.action || 'show'
                };

                if (obj.label) {
                    sendObj.eventLabel = obj.label;
                }

                if (obj.value) {
                    sendObj.eventValue = obj.value;
                }

                ga('send', sendObj);
            } else {
                this.cacheRichList.push(obj);
            }
        }
    },
    addPreviousCache: function addPreviousCache() {
        var _this = this;

        this.cacheList.forEach(function (item, inx) {
            _this._add(item);
        });
    },
    clearCacheList: function clearCacheList() {
        this.cacheList = [];
    },
    addPreviousRichCache: function addPreviousRichCache() {
        var _this2 = this;

        this.cacheRichList.forEach(function (item, inx) {
            _this2.addVerbone(item);
        });
    },
    clearCacheRichList: function clearCacheRichList() {
        this.cacheRichList = [];
    }
};

$.channel.on('analyticsSeedLoaded', function () {
    DA.addPreviousCache();
    DA.clearCacheList();
    DA.addPreviousRichCache();
    DA.clearCacheRichList();
});

exports.default = DA;

/***/ }),
/* 670 */
/***/ (function(module, exports) {

/**
 * fb广告
 */
var domain = document.domain;

if (domain !== 'www.upliveapp.com') {
    !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    fbq('init', '1138480899625457');
    fbq('track', 'PageView');
} else {
    fbq = function fbq() {};
}

/***/ }),
/* 671 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var gdn = {
    init: function init() {
        // save old document.write
        var oldDocumentWrite = document.write;

        // change document.write temporary
        document.write = function (node) {
            $("body").append(node);
        };

        // get script
        $.getScript("//www.googleadservices.com/pagead/conversion.js", {
            success: function success() {
                // replace the temp document.write with the original version
                setTimeout(function () {
                    document.write = oldDocumentWrite;
                }, 100);
            }
        });
    }
};

exports.default = gdn;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.js